function $parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
function $parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
var $parcel$global = globalThis;
var $parcel$modules = {};
var $parcel$inits = {};
var parcelRequire = $parcel$global["parcelRequire94c2"];
if (parcelRequire == null) {
    parcelRequire = function(id) {
        if (id in $parcel$modules) {
            return $parcel$modules[id].exports;
        }
        if (id in $parcel$inits) {
            var init = $parcel$inits[id];
            delete $parcel$inits[id];
            var module = {
                id: id,
                exports: {}
            };
            $parcel$modules[id] = module;
            init.call(module.exports, module, module.exports);
            return module.exports;
        }
        var err = new Error("Cannot find module '" + id + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
    };
    parcelRequire.register = function register(id, init) {
        $parcel$inits[id] = init;
    };
    $parcel$global["parcelRequire94c2"] = parcelRequire;
}
var parcelRegister = parcelRequire.register;
if (!$parcel$global.lb) {
    $parcel$global.lb = new Set();
    $parcel$global.bq = [];
    $parcel$global.rlb = (bundle)=>{
        $parcel$global.lb.add(bundle);
        $parcel$global.pq();
    };
    $parcel$global.rwr = (b, r, d)=>{
        $parcel$global.bq.push({
            b,
            r,
            d
        });
        $parcel$global.pq();
    };
    $parcel$global.pq = ()=>{
        var runnableEntry = $parcel$global.bq.find((i)=>{
            return i.d.every((dep)=>{
                return $parcel$global.lb.has(dep);
            });
        });
        if (runnableEntry) {
            $parcel$global.bq = $parcel$global.bq.filter((i)=>{
                return i.b !== runnableEntry.b;
            });
            runnableEntry.r();
            $parcel$global.pq();
        }
    };
}
parcelRegister("7gWdR", function(module, exports) {
    $parcel$export(module.exports, "draggable", ()=>(parcelRequire("40DDD")).draggable);
    $parcel$export(module.exports, "dropTargetForElements", ()=>(parcelRequire("40DDD")).dropTargetForElements);
    $parcel$export(module.exports, "monitorForElements", ()=>(parcelRequire("40DDD")).monitorForElements);
    var $40DDD = parcelRequire("40DDD");
});
parcelRegister("40DDD", function(module, exports) {
    $parcel$export(module.exports, "dropTargetForElements", ()=>$0b9136830a524a8f$export$e7140b68045b5036);
    $parcel$export(module.exports, "monitorForElements", ()=>$0b9136830a524a8f$export$59a074bac4c54f54);
    $parcel$export(module.exports, "draggable", ()=>$0b9136830a524a8f$export$c746a5152d4ba26c);
    var $cBeZP;
    var $kKgsQ = parcelRequire("kKgsQ");
    var $8d5CE = parcelRequire("8d5CE");
    var $iiVLC = parcelRequire("iiVLC");
    var $3zl3q = parcelRequire("3zl3q");
    var $lzZrl = parcelRequire("lzZrl");
    var $6XFIM = parcelRequire("6XFIM");
    var $aWzmz = parcelRequire("aWzmz");
    const $0b9136830a524a8f$var$draggableRegistry = new WeakMap();
    function $0b9136830a524a8f$var$addToRegistry(args) {
        $0b9136830a524a8f$var$draggableRegistry.set(args.element, args);
        return function cleanup() {
            $0b9136830a524a8f$var$draggableRegistry.delete(args.element);
        };
    }
    const $0b9136830a524a8f$var$honeyPotFix = (0, $8d5CE.makeHoneyPotFix)();
    const $0b9136830a524a8f$var$adapter = (0, $iiVLC.makeAdapter)({
        typeKey: 'element',
        defaultDropEffect: 'move',
        mount (api) {
            return (0, $3zl3q.combine)($0b9136830a524a8f$var$honeyPotFix.bindEvents(), (0, (0, parcelRequire("cBeZP")).bind)(document, {
                type: 'dragstart',
                listener (event) {
                    if (!api.canStart(event)) return;
                    if (event.defaultPrevented) return;
                    if (!event.dataTransfer) return;
                    const target = event.target;
                    if (!(target instanceof HTMLElement)) return null;
                    const entry = $0b9136830a524a8f$var$draggableRegistry.get(target);
                    if (!entry) return null;
                    const input = (0, $aWzmz.getInput)(event);
                    const feedback = {
                        element: entry.element,
                        dragHandle: entry.dragHandle ?? null,
                        input: input
                    };
                    if (entry.canDrag && !entry.canDrag(feedback)) {
                        event.preventDefault();
                        return null;
                    }
                    if (entry.dragHandle) {
                        const over = (0, $kKgsQ.getElementFromPointWithoutHoneypot)({
                            x: input.clientX,
                            y: input.clientY
                        });
                        if (!entry.dragHandle.contains(over)) {
                            event.preventDefault();
                            return null;
                        }
                    }
                    const nativeData = entry.getInitialDataForExternal?.(feedback) ?? null;
                    if (nativeData) for (const [key, data] of Object.entries(nativeData))event.dataTransfer.setData(key, data ?? '');
                    if ((0, $6XFIM.isAndroid)() && !event.dataTransfer.types.includes((0, $511ea0f8ed5a789e$export$fd3d00026297c0ad)) && !event.dataTransfer.types.includes((0, $8b5b4a812d80efb4$export$4c44a460f123106))) event.dataTransfer.setData((0, $511ea0f8ed5a789e$export$fd3d00026297c0ad), (0, $6XFIM.androidFallbackText));
                    event.dataTransfer.setData((0, $dad94f2a683170ce$export$c9c4cc54e73b125d), '');
                    const payload = {
                        element: entry.element,
                        dragHandle: entry.dragHandle ?? null,
                        data: entry.getInitialData?.(feedback) ?? {}
                    };
                    const dragType = {
                        type: 'element',
                        payload: payload,
                        startedFrom: 'internal'
                    };
                    api.start({
                        event: event,
                        dragType: dragType
                    });
                }
            }));
        },
        dispatchEventToSource: ({ eventName: eventName, payload: payload })=>{
            $0b9136830a524a8f$var$draggableRegistry.get(payload.source.element)?.[eventName]?.(payload);
        },
        onPostDispatch: $0b9136830a524a8f$var$honeyPotFix.getOnPostDispatch()
    });
    const $0b9136830a524a8f$export$e7140b68045b5036 = $0b9136830a524a8f$var$adapter.dropTarget;
    const $0b9136830a524a8f$export$59a074bac4c54f54 = $0b9136830a524a8f$var$adapter.monitor;
    function $0b9136830a524a8f$export$c746a5152d4ba26c(args) {
        return (0, $3zl3q.combine)($0b9136830a524a8f$var$adapter.registerUsage(), $0b9136830a524a8f$var$addToRegistry(args), (0, $lzZrl.addAttribute)(args.element, {
            attribute: 'draggable',
            value: 'true'
        }));
    }
});
parcelRegister("kKgsQ", function(module, exports) {
    $parcel$export(module.exports, "getElementFromPointWithoutHoneypot", ()=>$5328a4a0c6bbab12$export$81d0353f25f5dd);
    var $dkX0L = parcelRequire("dkX0L");
    function $5328a4a0c6bbab12$export$81d0353f25f5dd(client) {
        const [top, second] = document.elementsFromPoint(client.x, client.y);
        if (!top) return null;
        if ((0, $dkX0L.isHoneyPotElement)(top)) return second ?? null;
        return top;
    }
});
parcelRegister("dkX0L", function(module, exports) {
    $parcel$export(module.exports, "isHoneyPotElement", ()=>$b72c0efc16556d78$export$821bdcd739a2706b);
    function $b72c0efc16556d78$export$821bdcd739a2706b(target) {
        return target instanceof Element && target.hasAttribute((0, $777d0e5bd42bc367$export$6eafea55f7947469));
    }
});
const $777d0e5bd42bc367$export$6eafea55f7947469 = 'data-pdnd-honey-pot';
parcelRegister("8d5CE", function(module, exports) {
    $parcel$export(module.exports, "makeHoneyPotFix", ()=>$e63f81f9f360c6d0$export$8ecad27c959e89e0);
    var $cBeZP;
    const $e63f81f9f360c6d0$var$honeyPotSize = 2;
    const $e63f81f9f360c6d0$var$halfHoneyPotSize = $e63f81f9f360c6d0$var$honeyPotSize / 2;
    function $e63f81f9f360c6d0$var$floorToClosestPixel(point) {
        return {
            x: Math.floor(point.x),
            y: Math.floor(point.y)
        };
    }
    function $e63f81f9f360c6d0$var$pullBackByHalfHoneyPotSize(point) {
        return {
            x: point.x - $e63f81f9f360c6d0$var$halfHoneyPotSize,
            y: point.y - $e63f81f9f360c6d0$var$halfHoneyPotSize
        };
    }
    function $e63f81f9f360c6d0$var$preventGoingBackwardsOffScreen(point) {
        return {
            x: Math.max(point.x, 0),
            y: Math.max(point.y, 0)
        };
    }
    function $e63f81f9f360c6d0$var$preventGoingForwardsOffScreen(point) {
        return {
            x: Math.min(point.x, window.innerWidth - $e63f81f9f360c6d0$var$honeyPotSize),
            y: Math.min(point.y, window.innerHeight - $e63f81f9f360c6d0$var$honeyPotSize)
        };
    }
    function $e63f81f9f360c6d0$var$getHoneyPotRectFor({ client: client }) {
        const point = $e63f81f9f360c6d0$var$preventGoingForwardsOffScreen($e63f81f9f360c6d0$var$preventGoingBackwardsOffScreen($e63f81f9f360c6d0$var$pullBackByHalfHoneyPotSize($e63f81f9f360c6d0$var$floorToClosestPixel(client))));
        return DOMRect.fromRect({
            x: point.x,
            y: point.y,
            width: $e63f81f9f360c6d0$var$honeyPotSize,
            height: $e63f81f9f360c6d0$var$honeyPotSize
        });
    }
    function $e63f81f9f360c6d0$var$getRectStyles({ clientRect: clientRect }) {
        return {
            left: `${clientRect.left}px`,
            top: `${clientRect.top}px`,
            width: `${clientRect.width}px`,
            height: `${clientRect.height}px`
        };
    }
    function $e63f81f9f360c6d0$var$isWithin({ client: client, clientRect: clientRect }) {
        return (client.x >= clientRect.x && client.x <= clientRect.x + clientRect.width && client.y >= clientRect.y && client.y <= clientRect.y + clientRect.height);
    }
    function $e63f81f9f360c6d0$var$mountHoneyPot({ initial: initial }) {
        const element = document.createElement('div');
        element.setAttribute((0, $777d0e5bd42bc367$export$6eafea55f7947469), 'true');
        let clientRect = $e63f81f9f360c6d0$var$getHoneyPotRectFor({
            client: initial
        });
        Object.assign(element.style, {
            backgroundColor: 'transparent',
            position: 'fixed',
            padding: 0,
            margin: 0,
            boxSizing: 'border-box',
            ...$e63f81f9f360c6d0$var$getRectStyles({
                clientRect: clientRect
            }),
            pointerEvents: 'auto',
            zIndex: (0, $ff68169bc3de57ec$export$7d0a15ee70427305)
        });
        document.body.appendChild(element);
        const unbindPointerMove = (0, (0, parcelRequire("cBeZP")).bind)(window, {
            type: 'pointermove',
            listener (event) {
                const client = {
                    x: event.clientX,
                    y: event.clientY
                };
                clientRect = $e63f81f9f360c6d0$var$getHoneyPotRectFor({
                    client: client
                });
                Object.assign(element.style, $e63f81f9f360c6d0$var$getRectStyles({
                    clientRect: clientRect
                }));
            },
            options: {
                capture: true
            }
        });
        return function finish({ current: current }) {
            unbindPointerMove();
            if ($e63f81f9f360c6d0$var$isWithin({
                client: current,
                clientRect: clientRect
            })) {
                element.remove();
                return;
            }
            function cleanup() {
                unbindPostDragEvents();
                element.remove();
            }
            const unbindPostDragEvents = (0, (0, parcelRequire("cBeZP")).bindAll)(window, [
                {
                    type: 'pointerdown',
                    listener: cleanup
                },
                {
                    type: 'pointermove',
                    listener: cleanup
                },
                {
                    type: 'focusin',
                    listener: cleanup
                },
                {
                    type: 'focusout',
                    listener: cleanup
                },
                {
                    type: 'dragstart',
                    listener: cleanup
                },
                {
                    type: 'dragenter',
                    listener: cleanup
                },
                {
                    type: 'dragover',
                    listener: cleanup
                }
            ], {
                capture: true
            });
        };
    }
    function $e63f81f9f360c6d0$export$8ecad27c959e89e0() {
        let latestPointerMove = null;
        function bindEvents() {
            latestPointerMove = null;
            return (0, (0, parcelRequire("cBeZP")).bind)(window, {
                type: 'pointermove',
                listener (event) {
                    latestPointerMove = {
                        x: event.clientX,
                        y: event.clientY
                    };
                },
                options: {
                    capture: true
                }
            });
        }
        function getOnPostDispatch() {
            let finish = null;
            return function onPostEvent({ eventName: eventName, payload: payload }) {
                if (eventName === 'onDragStart') {
                    const { input: input } = payload.location.initial;
                    const initial = latestPointerMove ?? {
                        x: input.clientX,
                        y: input.clientY
                    };
                    finish = $e63f81f9f360c6d0$var$mountHoneyPot({
                        initial: initial
                    });
                }
                if (eventName === 'onDrop') {
                    const { input: input } = payload.location.current;
                    finish?.({
                        current: {
                            x: input.clientX,
                            y: input.clientY
                        }
                    });
                    finish = null;
                    latestPointerMove = null;
                }
            };
        }
        return {
            bindEvents: bindEvents,
            getOnPostDispatch: getOnPostDispatch
        };
    }
});
const $ff68169bc3de57ec$export$7d0a15ee70427305 = 2147483647;
parcelRegister("iiVLC", function(module, exports) {
    $parcel$export(module.exports, "makeAdapter", ()=>$77e910c1e7be5898$export$2aa3a33160990d96);
    var $ik6C6 = parcelRequire("ik6C6");
    var $dSShi = parcelRequire("dSShi");
    var $c7Wsm = parcelRequire("c7Wsm");
    var $7Q7eZ = parcelRequire("7Q7eZ");
    function $77e910c1e7be5898$export$2aa3a33160990d96({ typeKey: typeKey, mount: mount, dispatchEventToSource: dispatchEventToSource, onPostDispatch: onPostDispatch, defaultDropEffect: defaultDropEffect }) {
        const monitorAPI = (0, $7Q7eZ.makeMonitor)();
        const dropTargetAPI = (0, $c7Wsm.makeDropTarget)({
            typeKey: typeKey,
            defaultDropEffect: defaultDropEffect
        });
        function dispatchEvent(args) {
            dispatchEventToSource?.(args);
            dropTargetAPI.dispatchEvent(args);
            monitorAPI.dispatchEvent(args);
            onPostDispatch?.(args);
        }
        function start({ event: event, dragType: dragType }) {
            (0, $ik6C6.lifecycle).start({
                event: event,
                dragType: dragType,
                getDropTargetsOver: dropTargetAPI.getIsOver,
                dispatchEvent: dispatchEvent
            });
        }
        function registerUsage() {
            function mountAdapter() {
                const api = {
                    canStart: (0, $ik6C6.lifecycle).canStart,
                    start: start
                };
                return mount(api);
            }
            return (0, $dSShi.register)({
                typeKey: typeKey,
                mount: mountAdapter
            });
        }
        return {
            registerUsage: registerUsage,
            dropTarget: dropTargetAPI.dropTargetForConsumers,
            monitor: monitorAPI.monitorForConsumers
        };
    }
});
parcelRegister("ik6C6", function(module, exports) {
    $parcel$export(module.exports, "lifecycle", ()=>$018f6c08d2a1465a$export$3efdceeb8ca25c51);
    var $cBeZP;
    var $kKgsQ = parcelRequire("kKgsQ");
    var $dkX0L = parcelRequire("dkX0L");
    var $9uGIN = parcelRequire("9uGIN");
    var $h5V4I = parcelRequire("h5V4I");
    var $aWzmz = parcelRequire("aWzmz");
    var $18GOV = parcelRequire("18GOV");
    const $018f6c08d2a1465a$var$globalState = {
        isActive: false
    };
    function $018f6c08d2a1465a$var$canStart() {
        return !$018f6c08d2a1465a$var$globalState.isActive;
    }
    function $018f6c08d2a1465a$var$getNativeSetDragImage(event) {
        if (event.dataTransfer) return event.dataTransfer.setDragImage.bind(event.dataTransfer);
        return null;
    }
    function $018f6c08d2a1465a$var$hasHierarchyChanged({ current: current, next: next }) {
        if (current.length !== next.length) return true;
        for(let i = 0; i < current.length; i++){
            if (current[i].element !== next[i].element) return true;
        }
        return false;
    }
    function $018f6c08d2a1465a$var$start({ event: event, dragType: dragType, getDropTargetsOver: getDropTargetsOver, dispatchEvent: dispatchEvent }) {
        if (!$018f6c08d2a1465a$var$canStart()) return;
        const initial = $018f6c08d2a1465a$var$getStartLocation({
            event: event,
            dragType: dragType,
            getDropTargetsOver: getDropTargetsOver
        });
        $018f6c08d2a1465a$var$globalState.isActive = true;
        const state = {
            current: initial
        };
        $018f6c08d2a1465a$var$setDropEffectOnEvent({
            event: event,
            current: initial.dropTargets
        });
        const dispatch = (0, $18GOV.makeDispatch)({
            source: dragType.payload,
            dispatchEvent: dispatchEvent,
            initial: initial
        });
        function updateState(next) {
            const hasChanged = $018f6c08d2a1465a$var$hasHierarchyChanged({
                current: state.current.dropTargets,
                next: next.dropTargets
            });
            state.current = next;
            if (hasChanged) dispatch.dragUpdate({
                current: state.current
            });
        }
        function onUpdateEvent(event) {
            const input = (0, $aWzmz.getInput)(event);
            const target = (0, $dkX0L.isHoneyPotElement)(event.target) ? (0, $kKgsQ.getElementFromPointWithoutHoneypot)({
                x: input.clientX,
                y: input.clientY
            }) : event.target;
            const nextDropTargets = getDropTargetsOver({
                target: target,
                input: input,
                source: dragType.payload,
                current: state.current.dropTargets
            });
            if (nextDropTargets.length) {
                event.preventDefault();
                $018f6c08d2a1465a$var$setDropEffectOnEvent({
                    event: event,
                    current: nextDropTargets
                });
            }
            updateState({
                dropTargets: nextDropTargets,
                input: input
            });
        }
        function cancel() {
            if (state.current.dropTargets.length) updateState({
                dropTargets: [],
                input: state.current.input
            });
            dispatch.drop({
                current: state.current,
                updatedSourcePayload: null
            });
            finish();
        }
        function finish() {
            $018f6c08d2a1465a$var$globalState.isActive = false;
            unbindEvents();
        }
        const unbindEvents = (0, (0, parcelRequire("cBeZP")).bindAll)(window, [
            {
                type: 'dragover',
                listener (event) {
                    onUpdateEvent(event);
                    dispatch.drag({
                        current: state.current
                    });
                }
            },
            {
                type: 'dragenter',
                listener: onUpdateEvent
            },
            {
                type: 'dragleave',
                listener (event) {
                    if (!(0, $9uGIN.isLeavingWindow)({
                        dragLeave: event
                    })) return;
                    updateState({
                        input: state.current.input,
                        dropTargets: []
                    });
                    if (dragType.startedFrom === 'external') cancel();
                }
            },
            {
                type: 'drop',
                listener (event) {
                    state.current = {
                        dropTargets: state.current.dropTargets,
                        input: (0, $aWzmz.getInput)(event)
                    };
                    if (!state.current.dropTargets.length) {
                        cancel();
                        return;
                    }
                    event.preventDefault();
                    $018f6c08d2a1465a$var$setDropEffectOnEvent({
                        event: event,
                        current: state.current.dropTargets
                    });
                    dispatch.drop({
                        current: state.current,
                        updatedSourcePayload: dragType.type === 'external' ? dragType.getDropPayload(event) : null
                    });
                    finish();
                }
            },
            {
                type: 'dragend',
                listener (event) {
                    state.current = {
                        dropTargets: state.current.dropTargets,
                        input: (0, $aWzmz.getInput)(event)
                    };
                    cancel();
                }
            },
            ...(0, $h5V4I.getBindingsForBrokenDrags)({
                onDragEnd: cancel
            })
        ], {
            capture: true
        });
        dispatch.start({
            nativeSetDragImage: $018f6c08d2a1465a$var$getNativeSetDragImage(event)
        });
    }
    function $018f6c08d2a1465a$var$setDropEffectOnEvent({ event: event, current: current }) {
        const innerMost = current[0]?.dropEffect;
        if (innerMost != null && event.dataTransfer) event.dataTransfer.dropEffect = innerMost;
    }
    function $018f6c08d2a1465a$var$getStartLocation({ event: event, dragType: dragType, getDropTargetsOver: getDropTargetsOver }) {
        const input = (0, $aWzmz.getInput)(event);
        if (dragType.startedFrom === 'external') return {
            input: input,
            dropTargets: []
        };
        const dropTargets = getDropTargetsOver({
            input: input,
            source: dragType.payload,
            target: event.target,
            current: []
        });
        return {
            input: input,
            dropTargets: dropTargets
        };
    }
    const $018f6c08d2a1465a$export$3efdceeb8ca25c51 = {
        canStart: $018f6c08d2a1465a$var$canStart,
        start: $018f6c08d2a1465a$var$start
    };
});
parcelRegister("9uGIN", function(module, exports) {
    $parcel$export(module.exports, "isLeavingWindow", ()=>$37e271cec761dcee$export$57d220c74e84a273);
    var $bYN8w = parcelRequire("bYN8w");
    var $6aABs = parcelRequire("6aABs");
    var $apnEk = parcelRequire("apnEk");
    var $9Mj6M = parcelRequire("9Mj6M");
    function $37e271cec761dcee$export$57d220c74e84a273({ dragLeave: dragLeave }) {
        const { type: type, relatedTarget: relatedTarget } = dragLeave;
        if (type !== 'dragleave') return false;
        if ((0, $6aABs.isSafari)()) return (0, $apnEk.isLeavingWindowInSafari)({
            dragLeave: dragLeave
        });
        if (relatedTarget == null) return true;
        if ((0, $bYN8w.isFirefox)()) return (0, $9Mj6M.isFromAnotherWindow)(relatedTarget);
        return relatedTarget instanceof HTMLIFrameElement;
    }
});
parcelRegister("bYN8w", function(module, exports) {
    $parcel$export(module.exports, "isFirefox", ()=>$d91d4bdc8d92ad8d$export$b7d78993b74f766d);
    var $jjNE9 = parcelRequire("jjNE9");
    const $d91d4bdc8d92ad8d$export$b7d78993b74f766d = (0, $jjNE9.once)(function isFirefox() {
        return navigator.userAgent.includes('Firefox');
    });
});
parcelRegister("jjNE9", function(module, exports) {
    $parcel$export(module.exports, "once", ()=>$b679dfdbd4fba3f1$export$d2de3aaeafa91619);
    function $b679dfdbd4fba3f1$export$d2de3aaeafa91619(fn) {
        let cache = null;
        return function wrapped(...args) {
            if (!cache) {
                const result = fn.apply(this, args);
                cache = {
                    result: result
                };
            }
            return cache.result;
        };
    }
});
parcelRegister("6aABs", function(module, exports) {
    $parcel$export(module.exports, "isSafari", ()=>$13856bb4e07cde59$export$95df08bae54cb4df);
    var $jjNE9 = parcelRequire("jjNE9");
    const $13856bb4e07cde59$export$95df08bae54cb4df = (0, $jjNE9.once)(function isSafari() {
        const { userAgent: userAgent } = navigator;
        return userAgent.includes('AppleWebKit') && !userAgent.includes('Chrome');
    });
});
parcelRegister("apnEk", function(module, exports) {
    $parcel$export(module.exports, "isEnteringWindowInSafari", ()=>$b3bca8f40bde8fa5$export$de68634bd94ed596);
    $parcel$export(module.exports, "isLeavingWindowInSafari", ()=>$b3bca8f40bde8fa5$export$f21837c338005454);
    var $cBeZP;
    var $6aABs = parcelRequire("6aABs");
    const $b3bca8f40bde8fa5$var$symbols = {
        isLeavingWindow: Symbol('leaving'),
        isEnteringWindow: Symbol('entering')
    };
    function $b3bca8f40bde8fa5$export$de68634bd94ed596({ dragEnter: dragEnter }) {
        if (!(0, $6aABs.isSafari)()) return false;
        return dragEnter.hasOwnProperty($b3bca8f40bde8fa5$var$symbols.isEnteringWindow);
    }
    function $b3bca8f40bde8fa5$export$f21837c338005454({ dragLeave: dragLeave }) {
        if (!(0, $6aABs.isSafari)()) return false;
        return dragLeave.hasOwnProperty($b3bca8f40bde8fa5$var$symbols.isLeavingWindow);
    }
    (function fixSafari() {
        if (typeof window === 'undefined') return;
        if (!(0, $6aABs.isSafari)()) return;
        function getInitialState() {
            return {
                enterCount: 0,
                isOverWindow: false
            };
        }
        let state = getInitialState();
        function resetState() {
            state = getInitialState();
        }
        (0, (0, parcelRequire("cBeZP")).bindAll)(window, [
            {
                type: 'dragstart',
                listener: ()=>{
                    state.enterCount = 0;
                    state.isOverWindow = true;
                }
            },
            {
                type: 'drop',
                listener: resetState
            },
            {
                type: 'dragend',
                listener: resetState
            },
            {
                type: 'dragenter',
                listener: (event)=>{
                    if (!state.isOverWindow && state.enterCount === 0) event[$b3bca8f40bde8fa5$var$symbols.isEnteringWindow] = true;
                    state.isOverWindow = true;
                    state.enterCount++;
                }
            },
            {
                type: 'dragleave',
                listener: (event)=>{
                    state.enterCount--;
                    if (state.isOverWindow && state.enterCount === 0) {
                        event[$b3bca8f40bde8fa5$var$symbols.isLeavingWindow] = true;
                        state.isOverWindow = false;
                    }
                }
            }
        ], {
            capture: true
        });
    })();
});
parcelRegister("9Mj6M", function(module, exports) {
    $parcel$export(module.exports, "isFromAnotherWindow", ()=>$e0983a74206d410e$export$e46810fef53b5b0e);
    function $e0983a74206d410e$var$isNodeLike(target) {
        return 'nodeName' in target;
    }
    function $e0983a74206d410e$export$e46810fef53b5b0e(eventTarget) {
        return $e0983a74206d410e$var$isNodeLike(eventTarget) && eventTarget.ownerDocument !== document;
    }
});
parcelRegister("h5V4I", function(module, exports) {
    $parcel$export(module.exports, "getBindingsForBrokenDrags", ()=>$50c75a295ab659e5$export$ac5e5b0daf997b2);
    function $50c75a295ab659e5$export$ac5e5b0daf997b2({ onDragEnd: onDragEnd }) {
        return [
            {
                type: 'pointermove',
                listener: (()=>{
                    let callCount = 0;
                    return function listener() {
                        if (callCount < 20) {
                            callCount++;
                            return;
                        }
                        onDragEnd();
                    };
                })()
            },
            {
                type: 'pointerdown',
                listener: onDragEnd
            }
        ];
    }
});
parcelRegister("aWzmz", function(module, exports) {
    $parcel$export(module.exports, "getInput", ()=>$8d49417dc8e95872$export$7c112ceec8941e67);
    function $8d49417dc8e95872$export$7c112ceec8941e67(event) {
        return {
            altKey: event.altKey,
            button: event.button,
            buttons: event.buttons,
            ctrlKey: event.ctrlKey,
            metaKey: event.metaKey,
            shiftKey: event.shiftKey,
            clientX: event.clientX,
            clientY: event.clientY,
            pageX: event.pageX,
            pageY: event.pageY
        };
    }
});
parcelRegister("18GOV", function(module, exports) {
    $parcel$export(module.exports, "makeDispatch", ()=>$9912bec6db707047$export$9f13ecc44e83d682);
    var $7nRxN;
    const $9912bec6db707047$var$scheduleOnDrag = (0, (0, parcelRequire("7nRxN")).default)((fn)=>fn());
    const $9912bec6db707047$var$dragStart = (()=>{
        let scheduled = null;
        function schedule(fn) {
            const frameId = requestAnimationFrame(()=>{
                scheduled = null;
                fn();
            });
            scheduled = {
                frameId: frameId,
                fn: fn
            };
        }
        function flush() {
            if (scheduled) {
                cancelAnimationFrame(scheduled.frameId);
                scheduled.fn();
                scheduled = null;
            }
        }
        return {
            schedule: schedule,
            flush: flush
        };
    })();
    function $9912bec6db707047$export$9f13ecc44e83d682({ source: source, initial: initial, dispatchEvent: dispatchEvent }) {
        let previous = {
            dropTargets: []
        };
        function safeDispatch(args) {
            dispatchEvent(args);
            previous = {
                dropTargets: args.payload.location.current.dropTargets
            };
        }
        const dispatch = {
            start ({ nativeSetDragImage: nativeSetDragImage }) {
                const location = {
                    current: initial,
                    previous: previous,
                    initial: initial
                };
                safeDispatch({
                    eventName: 'onGenerateDragPreview',
                    payload: {
                        source: source,
                        location: location,
                        nativeSetDragImage: nativeSetDragImage
                    }
                });
                $9912bec6db707047$var$dragStart.schedule(()=>{
                    safeDispatch({
                        eventName: 'onDragStart',
                        payload: {
                            source: source,
                            location: location
                        }
                    });
                });
            },
            dragUpdate ({ current: current }) {
                $9912bec6db707047$var$dragStart.flush();
                $9912bec6db707047$var$scheduleOnDrag.cancel();
                safeDispatch({
                    eventName: 'onDropTargetChange',
                    payload: {
                        source: source,
                        location: {
                            initial: initial,
                            previous: previous,
                            current: current
                        }
                    }
                });
            },
            drag ({ current: current }) {
                $9912bec6db707047$var$scheduleOnDrag(()=>{
                    $9912bec6db707047$var$dragStart.flush();
                    const location = {
                        initial: initial,
                        previous: previous,
                        current: current
                    };
                    safeDispatch({
                        eventName: 'onDrag',
                        payload: {
                            source: source,
                            location: location
                        }
                    });
                });
            },
            drop ({ current: current, updatedSourcePayload: updatedSourcePayload }) {
                $9912bec6db707047$var$dragStart.flush();
                $9912bec6db707047$var$scheduleOnDrag.cancel();
                safeDispatch({
                    eventName: 'onDrop',
                    payload: {
                        source: updatedSourcePayload ?? source,
                        location: {
                            current: current,
                            previous: previous,
                            initial: initial
                        }
                    }
                });
            }
        };
        return dispatch;
    }
});
parcelRegister("7nRxN", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$560437209e674614$export$2e2bcd8739ae039);
    var $560437209e674614$var$rafSchd = function rafSchd(fn) {
        var lastArgs = [];
        var frameId = null;
        var wrapperFn = function wrapperFn() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            lastArgs = args;
            if (frameId) return;
            frameId = requestAnimationFrame(function() {
                frameId = null;
                fn.apply(void 0, lastArgs);
            });
        };
        wrapperFn.cancel = function() {
            if (!frameId) return;
            cancelAnimationFrame(frameId);
            frameId = null;
        };
        return wrapperFn;
    };
    var $560437209e674614$export$2e2bcd8739ae039 = $560437209e674614$var$rafSchd;
});
parcelRegister("dSShi", function(module, exports) {
    $parcel$export(module.exports, "register", ()=>$9449928287939c74$export$6503ec6e8aabbaf);
    const $9449928287939c74$var$ledger = new Map();
    function $9449928287939c74$var$registerUsage({ typeKey: typeKey, mount: mount }) {
        const entry = $9449928287939c74$var$ledger.get(typeKey);
        if (entry) {
            entry.usageCount++;
            return entry;
        }
        const initial = {
            typeKey: typeKey,
            unmount: mount(),
            usageCount: 1
        };
        $9449928287939c74$var$ledger.set(typeKey, initial);
        return initial;
    }
    function $9449928287939c74$export$6503ec6e8aabbaf(args) {
        const entry = $9449928287939c74$var$registerUsage(args);
        return function unregister() {
            entry.usageCount--;
            if (entry.usageCount > 0) return;
            entry.unmount();
            $9449928287939c74$var$ledger.delete(args.typeKey);
        };
    }
});
parcelRegister("c7Wsm", function(module, exports) {
    $parcel$export(module.exports, "makeDropTarget", ()=>$c9c066c5732074b2$export$47d10e7bd9c81890);
    var $3zl3q = parcelRequire("3zl3q");
    var $lzZrl = parcelRequire("lzZrl");
    function $c9c066c5732074b2$var$copyReverse(array) {
        return array.slice(0).reverse();
    }
    function $c9c066c5732074b2$export$47d10e7bd9c81890({ typeKey: typeKey, defaultDropEffect: defaultDropEffect }) {
        const registry = new WeakMap();
        const dropTargetDataAtt = `data-drop-target-for-${typeKey}`;
        const dropTargetSelector = `[${dropTargetDataAtt}]`;
        function addToRegistry(args) {
            registry.set(args.element, args);
            return ()=>registry.delete(args.element);
        }
        function dropTargetForConsumers(args) {
            return (0, $3zl3q.combine)((0, $lzZrl.addAttribute)(args.element, {
                attribute: dropTargetDataAtt,
                value: 'true'
            }), addToRegistry(args));
        }
        function getActualDropTargets({ source: source, target: target, input: input, result: result = [] }) {
            if (target == null) return result;
            if (!(target instanceof Element)) {
                if (target instanceof Node) return getActualDropTargets({
                    source: source,
                    target: target.parentElement,
                    input: input,
                    result: result
                });
                return result;
            }
            const closest = target.closest(dropTargetSelector);
            if (closest == null) return result;
            const args = registry.get(closest);
            if (args == null) return result;
            const feedback = {
                input: input,
                source: source,
                element: args.element
            };
            if (args.canDrop && !args.canDrop(feedback)) return getActualDropTargets({
                source: source,
                target: args.element.parentElement,
                input: input,
                result: result
            });
            const data = args.getData?.(feedback) ?? {};
            const dropEffect = args.getDropEffect?.(feedback) ?? defaultDropEffect;
            const record = {
                data: data,
                element: args.element,
                dropEffect: dropEffect,
                isActiveDueToStickiness: false
            };
            return getActualDropTargets({
                source: source,
                target: args.element.parentElement,
                input: input,
                result: [
                    ...result,
                    record
                ]
            });
        }
        function notifyCurrent({ eventName: eventName, payload: payload }) {
            for (const record of payload.location.current.dropTargets){
                const entry = registry.get(record.element);
                const args = {
                    ...payload,
                    self: record
                };
                entry?.[eventName]?.(args);
            }
        }
        const actions = {
            onGenerateDragPreview: notifyCurrent,
            onDrag: notifyCurrent,
            onDragStart: notifyCurrent,
            onDrop: notifyCurrent,
            onDropTargetChange: ({ payload: payload })=>{
                const isCurrent = new Set(payload.location.current.dropTargets.map((record)=>record.element));
                const visited = new Set();
                for (const record of payload.location.previous.dropTargets){
                    visited.add(record.element);
                    const entry = registry.get(record.element);
                    const isOver = isCurrent.has(record.element);
                    const args = {
                        ...payload,
                        self: record
                    };
                    entry?.onDropTargetChange?.(args);
                    if (!isOver) entry?.onDragLeave?.(args);
                }
                for (const record of payload.location.current.dropTargets){
                    if (visited.has(record.element)) continue;
                    const args = {
                        ...payload,
                        self: record
                    };
                    const entry = registry.get(record.element);
                    entry?.onDropTargetChange?.(args);
                    entry?.onDragEnter?.(args);
                }
            }
        };
        function dispatchEvent(args) {
            actions[args.eventName](args);
        }
        function getIsOver({ source: source, target: target, input: input, current: current }) {
            const actual = getActualDropTargets({
                source: source,
                target: target,
                input: input
            });
            if (actual.length >= current.length) return actual;
            const lastCaptureOrdered = $c9c066c5732074b2$var$copyReverse(current);
            const actualCaptureOrdered = $c9c066c5732074b2$var$copyReverse(actual);
            const resultCaptureOrdered = [];
            for(let index = 0; index < lastCaptureOrdered.length; index++){
                const last = lastCaptureOrdered[index];
                const fresh = actualCaptureOrdered[index];
                if (fresh != null) {
                    resultCaptureOrdered.push(fresh);
                    continue;
                }
                const parent = resultCaptureOrdered[index - 1];
                const lastParent = lastCaptureOrdered[index - 1];
                if (parent?.element !== lastParent?.element) break;
                const argsForLast = registry.get(last.element);
                if (!argsForLast) break;
                const feedback = {
                    input: input,
                    source: source,
                    element: argsForLast.element
                };
                if (argsForLast.canDrop && !argsForLast.canDrop(feedback)) break;
                if (!argsForLast.getIsSticky?.(feedback)) break;
                resultCaptureOrdered.push({
                    ...last,
                    isActiveDueToStickiness: true
                });
            }
            return $c9c066c5732074b2$var$copyReverse(resultCaptureOrdered);
        }
        return {
            dropTargetForConsumers: dropTargetForConsumers,
            getIsOver: getIsOver,
            dispatchEvent: dispatchEvent
        };
    }
});
parcelRegister("3zl3q", function(module, exports) {
    $parcel$export(module.exports, "combine", ()=>$a6751ba2eb2acc9f$export$1be1fc439b849fdf);
    function $a6751ba2eb2acc9f$export$1be1fc439b849fdf(...fns) {
        return function cleanup() {
            fns.forEach((fn)=>fn());
        };
    }
});
parcelRegister("lzZrl", function(module, exports) {
    $parcel$export(module.exports, "addAttribute", ()=>$e43023517e6b167a$export$5dcb5c23b6ba980a);
    function $e43023517e6b167a$export$5dcb5c23b6ba980a(element, { attribute: attribute, value: value }) {
        element.setAttribute(attribute, value);
        return ()=>element.removeAttribute(attribute);
    }
});
parcelRegister("7Q7eZ", function(module, exports) {
    $parcel$export(module.exports, "makeMonitor", ()=>$f3636ae745ab6f9c$export$5dd4ed888d5b12ca);
    function $f3636ae745ab6f9c$export$5dd4ed888d5b12ca() {
        const registry = new Set();
        let dragging = null;
        function tryAddToActive(monitor) {
            if (!dragging) return;
            if (!monitor.canMonitor || monitor.canMonitor(dragging.canMonitorArgs)) dragging.active.add(monitor);
        }
        function monitorForConsumers(args) {
            const entry = {
                ...args
            };
            registry.add(entry);
            tryAddToActive(entry);
            return function cleanup() {
                registry.delete(entry);
                if (dragging) dragging.active.delete(entry);
            };
        }
        function dispatchEvent({ eventName: eventName, payload: payload }) {
            if (eventName === 'onGenerateDragPreview') {
                dragging = {
                    canMonitorArgs: {
                        initial: payload.location.initial,
                        source: payload.source
                    },
                    active: new Set()
                };
                for (const monitor of registry)tryAddToActive(monitor);
            }
            if (!dragging) return;
            const active = Array.from(dragging.active);
            for (const monitor of active)if (dragging.active.has(monitor)) monitor[eventName]?.(payload);
            if (eventName === 'onDrop') {
                dragging.active.clear();
                dragging = null;
            }
        }
        return {
            dispatchEvent: dispatchEvent,
            monitorForConsumers: monitorForConsumers
        };
    }
});
parcelRegister("6XFIM", function(module, exports) {
    $parcel$export(module.exports, "isAndroid", ()=>$66dca49a44fee398$export$a11b0059900ceec8);
    $parcel$export(module.exports, "androidFallbackText", ()=>$66dca49a44fee398$export$aceb3ed8b7f7bd2c);
    var $jjNE9 = parcelRequire("jjNE9");
    const $66dca49a44fee398$export$a11b0059900ceec8 = (0, $jjNE9.once)(function isAndroid() {
        return navigator.userAgent.toLocaleLowerCase().includes('android');
    });
    const $66dca49a44fee398$export$aceb3ed8b7f7bd2c = 'pdnd:android-fallback';
});
const $511ea0f8ed5a789e$export$fd3d00026297c0ad = 'text/plain';
const $8b5b4a812d80efb4$export$4c44a460f123106 = 'text/uri-list';
const $dad94f2a683170ce$export$c9c4cc54e73b125d = 'application/vnd.pdnd';
parcelRegister("4hDdm", function(module, exports) {
    $parcel$export(module.exports, "combine", ()=>(parcelRequire("3zl3q")).combine);
    var $3zl3q = parcelRequire("3zl3q");
});
parcelRegister("bwpsq", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$86366e315d74377c$export$2e2bcd8739ae039);
    const $86366e315d74377c$var$UNDERSCORE_UNICODE = 95;
    const $86366e315d74377c$var$ATOMIC_GROUP_LENGTH = 5;
    function $86366e315d74377c$export$2e2bcd8739ae039(classNames) {
        if (classNames.length <= 1 && (!classNames[0] || classNames[0].indexOf(' ') === -1)) return classNames[0] || undefined;
        const atomicGroups = {};
        for(let i = 0; i < classNames.length; i++){
            const cls = classNames[i];
            if (!cls) continue;
            const groups = cls.split(' ');
            for(let x = 0; x < groups.length; x++){
                const atomic = groups[x];
                const atomicGroupName = atomic.slice(0, atomic.charCodeAt(0) === $86366e315d74377c$var$UNDERSCORE_UNICODE ? $86366e315d74377c$var$ATOMIC_GROUP_LENGTH : undefined);
                atomicGroups[atomicGroupName] = atomic;
            }
        }
        let str = '';
        for(const key in atomicGroups){
            const value = atomicGroups[key];
            str += value + ' ';
        }
        return str.slice(0, -1);
    }
});
parcelRegister("22Gxp", function(module, exports) {
    $parcel$export(module.exports, "useUID", ()=>$17ccc3ce11c8a1a0$export$87d05f07e65211f1);
    $parcel$export(module.exports, "useUIDSeed", ()=>$17ccc3ce11c8a1a0$export$bb5ca5fba6fb4f1f);
    var $5uXOq = parcelRequire("5uXOq");
    var $7aHWJ;
    var $17ccc3ce11c8a1a0$var$generateUID = function(context) {
        var quartz = context || (0, (0, parcelRequire("7aHWJ")).counter);
        var prefix = (0, (0, parcelRequire("7aHWJ")).getPrefix)(quartz);
        var id = (0, (0, parcelRequire("7aHWJ")).getId)(quartz);
        var uid = prefix + id;
        var gen = function(item) {
            return uid + quartz.uid(item);
        };
        return {
            uid: uid,
            gen: gen
        };
    };
    var $17ccc3ce11c8a1a0$var$useUIDState = function() {
        return $5uXOq.useState($17ccc3ce11c8a1a0$var$generateUID($5uXOq.useContext((0, (0, parcelRequire("7aHWJ")).source))));
    };
    var $17ccc3ce11c8a1a0$export$87d05f07e65211f1 = function() {
        var uid = $17ccc3ce11c8a1a0$var$useUIDState()[0].uid;
        return uid;
    };
    var $17ccc3ce11c8a1a0$export$bb5ca5fba6fb4f1f = function() {
        var gen = $17ccc3ce11c8a1a0$var$useUIDState()[0].gen;
        return gen;
    };
});
parcelRegister("7aHWJ", function(module, exports) {
    $parcel$export(module.exports, "counter", ()=>$538b8e680858bf13$export$e575061ef2a070eb);
    $parcel$export(module.exports, "source", ()=>$538b8e680858bf13$export$b4d5da5f34fb77ad);
    $parcel$export(module.exports, "getId", ()=>$538b8e680858bf13$export$218c8c3169c024d2);
    $parcel$export(module.exports, "getPrefix", ()=>$538b8e680858bf13$export$36e24695f02d4503);
    var $5uXOq = parcelRequire("5uXOq");
    var $8e3lA;
    var $538b8e680858bf13$export$1921362e86c73c88 = function(prefix) {
        if (prefix === void 0) prefix = '';
        return {
            value: 1,
            prefix: prefix,
            uid: (0, (0, parcelRequire("8e3lA")).generateUID)()
        };
    };
    var $538b8e680858bf13$export$e575061ef2a070eb = $538b8e680858bf13$export$1921362e86c73c88();
    var $538b8e680858bf13$export$b4d5da5f34fb77ad = $5uXOq.createContext($538b8e680858bf13$export$1921362e86c73c88());
    var $538b8e680858bf13$export$218c8c3169c024d2 = function(source) {
        return source.value++;
    };
    var $538b8e680858bf13$export$36e24695f02d4503 = function(source) {
        return source ? source.prefix : '';
    };
});
parcelRegister("8e3lA", function(module, exports) {
    $parcel$export(module.exports, "generateUID", ()=>$5fd23a338f882896$export$bdbb4cbb3078e58d);
    $parcel$export(module.exports, "uid", ()=>$5fd23a338f882896$export$e2a22331486dcca0);
    var $5fd23a338f882896$export$bdbb4cbb3078e58d = function() {
        var counter = 1;
        var map = new WeakMap();
        var uid = function(item, index) {
            if (typeof item === 'number' || typeof item === 'string') return index ? "idx-" + index : "val-" + item;
            if (!map.has(item)) {
                map.set(item, counter++);
                return uid(item);
            }
            return 'uid' + map.get(item);
        };
        return uid;
    };
    var $5fd23a338f882896$export$e2a22331486dcca0 = $5fd23a338f882896$export$bdbb4cbb3078e58d();
});
parcelRegister("ha42n", function(module, exports) {
    $parcel$export(module.exports, "ExperienceTracker", ()=>$19380a56c83c3ed5$export$12b6b072930fd68f);
    var $82vfp;
    class $19380a56c83c3ed5$export$12b6b072930fd68f {
        constructor(options){
            this.experiences = {};
            this.subscribers = [];
            this.isNetworkOfflineError = options && options.isNetworkOfflineError || (()=>false);
        }
        start({ name: name, id: id, timeout: timeout, startTime: startTime, attributes: attributes, onSuccess: onSuccess, onFailure: onFailure, onAbort: onAbort, collect: collect }) {
            const current = this.experiences[name];
            if (current && !current.hasStopped && current.id === id) return;
            if (current) current.abort({
                reason: 'Aborted because the same experience was started with a new id'
            });
            const experience = new (0, (0, parcelRequire("82vfp")).Experience)({
                name: name,
                id: id,
                timeout: timeout,
                startTime: startTime,
                attributes: attributes,
                onSuccess: onSuccess,
                onFailure: onFailure,
                onAbort: onAbort,
                onStart: (startEvent)=>{
                    this.emit(startEvent);
                    let disposeCollectSubscription = ()=>{};
                    if (collect) {
                        const events = [];
                        disposeCollectSubscription = this.subscribe((event)=>{
                            if (event.action === 'taskStart' || events.some((previousEvent)=>previousEvent.name === event.name && previousEvent.action === 'taskStart')) {
                                events.push(event);
                                collect(events, experience);
                            }
                        });
                    }
                    return (stopEvent)=>{
                        disposeCollectSubscription();
                        this.emit(stopEvent);
                    };
                }
            });
            this.experiences[name] = experience;
        }
        succeed({ name: name, attributes: attributes }) {
            const current = this.experiences[name];
            if (!current) return;
            current.succeed(attributes);
        }
        fail({ name: name, error: error, attributes: attributes }) {
            Object.values(this.experiences).forEach((current)=>{
                if (name != null && current.name !== name) return;
                current.fail({
                    error: error,
                    attributes: attributes
                });
            });
        }
        abort({ name: name, reason: reason, attributes: attributes, checkForTimeout: checkForTimeout }) {
            function abort(experience) {
                if (name != null && experience.name !== name) return;
                experience.abort({
                    reason: reason,
                    checkForTimeout: checkForTimeout,
                    attributes: attributes
                });
            }
            const experiencesWithTimeouts = Object.values(this.experiences).filter((experience)=>experience.timeout);
            const experiencesWithoutTimeouts = Object.values(this.experiences).filter((experience)=>!experience.timeout);
            experiencesWithTimeouts.forEach(abort);
            experiencesWithoutTimeouts.forEach(abort);
        }
        subscribe(subscriber) {
            if (typeof subscriber !== 'function') throw new Error('Subscriber must be a function');
            this.subscribers.push(subscriber);
            return ()=>{
                this.subscribers = this.subscribers.filter((x)=>x !== subscriber);
            };
        }
        stopOnError({ name: name, error: error, attributes: attributes }) {
            if (this.isNetworkOfflineError(error)) {
                this.abort({
                    name: name,
                    reason: `Aborted ${name} because of network error: ${error.toString()}`,
                    checkForTimeout: false,
                    attributes: attributes
                });
                return;
            }
            return this.fail({
                name: name,
                error: error,
                attributes: attributes
            });
        }
        emit(event) {
            this.subscribers.forEach((subscriber)=>{
                try {
                    subscriber(event);
                } catch (e) {}
            });
        }
    }
});
parcelRegister("82vfp", function(module, exports) {
    $parcel$export(module.exports, "Experience", ()=>$abf5733617623630$export$c90b54e658fc4d7c);
    var $j0xjM;
    function $abf5733617623630$var$mergeAttributes(first, last) {
        if (first === undefined) return last;
        if (last === undefined) return first;
        return {
            ...first,
            ...last
        };
    }
    class $abf5733617623630$export$c90b54e658fc4d7c {
        constructor({ name: name, id: id, timeout: timeout, startTime: startTime = window.performance.now(), attributes: attributes, onStart: onStart, onSuccess: onSuccess, onFailure: onFailure, onAbort: onAbort }){
            this._hasStopped = false;
            this.name = name;
            this.id = id;
            this.timeout = timeout;
            this.startTime = startTime;
            this.attributes = attributes;
            this.onSuccess = onSuccess;
            this.onFailure = onFailure;
            this.onAbort = onAbort;
            const startEvent = {
                action: 'taskStart',
                name: name,
                id: id,
                startTime: startTime,
                timeout: timeout,
                attributes: attributes
            };
            if (onStart) this.onStop = onStart(startEvent);
        }
        get hasStopped() {
            return this._hasStopped;
        }
        succeed(attributes) {
            if (this._hasStopped) return;
            this.onSuccess && this.onSuccess();
            this.stop({
                action: 'taskSuccess',
                name: this.name,
                id: this.id,
                startTime: this.startTime,
                duration: this.getDuration(),
                attributes: $abf5733617623630$var$mergeAttributes(this.attributes, attributes)
            });
        }
        fail({ error: error, attributes: attributes }) {
            if (this._hasStopped) return;
            this.onFailure && this.onFailure();
            this.stop({
                action: 'taskFail',
                name: this.name,
                id: this.id,
                startTime: this.startTime,
                duration: this.getDuration(),
                error: error,
                attributes: $abf5733617623630$var$mergeAttributes(this.attributes, attributes)
            });
        }
        abort({ reason: reason, attributes: attributes, checkForTimeout: checkForTimeout = true }) {
            if (this._hasStopped) return;
            if (checkForTimeout && this.timeout != null && this.getDuration() >= this.timeout) {
                this.fail({
                    attributes: attributes,
                    error: new (0, (0, parcelRequire("j0xjM")).ExperienceTimeoutError)(`${this.name} failed to complete in ${this.timeout}ms`)
                });
                return;
            }
            this.onAbort && this.onAbort();
            this.stop({
                action: 'taskAbort',
                name: this.name,
                id: this.id,
                startTime: this.startTime,
                duration: this.getDuration(),
                reason: reason,
                checkForTimeout: checkForTimeout,
                attributes: $abf5733617623630$var$mergeAttributes(this.attributes, attributes)
            });
        }
        stopOn(event) {
            if (!event) return;
            if (event.action === 'taskSuccess') this.succeed();
            else if (event.action === 'taskAbort') this.abort({
                reason: event.reason,
                checkForTimeout: event.checkForTimeout
            });
            else if (event.action === 'taskFail') this.fail({
                error: event.error
            });
        }
        stop(event) {
            this._hasStopped = true;
            if (this.onStop) this.onStop(event);
        }
        getDuration() {
            return Math.round(window.performance.now() - this.startTime);
        }
    }
});
parcelRegister("j0xjM", function(module, exports) {
    $parcel$export(module.exports, "ExperienceTimeoutError", ()=>$f8ffb4638fa466dd$export$d27a2b6293f7631c);
    class $f8ffb4638fa466dd$export$d27a2b6293f7631c extends Error {
        constructor(message){
            super(message);
            this.name = 'ExperienceTimeoutError';
        }
    }
});
parcelRegister("bSOOm", function(module, exports) {
    $parcel$export(module.exports, "ExperienceTrackerContext", ()=>$0be6218364f10f40$export$a7b0697657ed8bd0);
    var $5uXOq = parcelRequire("5uXOq");
    const $0be6218364f10f40$export$a7b0697657ed8bd0 = (0, $5uXOq.createContext)({
        abort () {},
        fail () {},
        start () {},
        succeed () {},
        stopOnError () {},
        subscribe () {
            return ()=>{};
        }
    });
});
parcelRegister("kTK0a", function(module, exports) {
    $parcel$export(module.exports, "getATLContextDomain", ()=>$f7bd7ceae0ce7533$export$b5ce351acdc48c2a);
    $parcel$export(module.exports, "getATLContextUrl", ()=>$f7bd7ceae0ce7533$export$45d6512913ef41b4);
    var $fwYdj;
    var $bNZUH;
    function $f7bd7ceae0ce7533$export$8d21e34596265fa2(data) {
        if (!data || Object.keys(data).length < 1) throw new Error('Data are not available');
        globalThis.ATL_CONTEXT_DOMAIN = data;
    }
    function $f7bd7ceae0ce7533$var$isValidDomainKey(domainKey) {
        if (!(0, (0, parcelRequire("bNZUH")).AllowedDomains).includes(domainKey)) return false;
        return true;
    }
    function $f7bd7ceae0ce7533$export$b5ce351acdc48c2a(domain, environment) {
        if (!$f7bd7ceae0ce7533$var$isValidDomainKey(domain)) throw new Error(`Domain ${domain} is not supported.
      Supported domains: ${(0, (0, parcelRequire("bNZUH")).AllowedDomains).join(', ')}`);
        const data = globalThis.ATL_CONTEXT_DOMAIN;
        if (data) return data[domain];
        const [env, perimeter] = environment ?? $f7bd7ceae0ce7533$export$509d18a5fd824839();
        const override = (0, (0, parcelRequire("fwYdj")).fullDomainOverride)[domain];
        if (override) return (override[perimeter]?.[env] ?? override[0, $16271ea4123e88a6$export$f005e2e9f707cb5f][0, $16271ea4123e88a6$export$42dd0cdd351a4a9]);
        const tld = (0, (0, parcelRequire("fwYdj")).domainMap)[perimeter]?.[env] ?? (0, (0, parcelRequire("fwYdj")).domainMap)[0, $16271ea4123e88a6$export$f005e2e9f707cb5f][0, $16271ea4123e88a6$export$42dd0cdd351a4a9];
        const subdomain = (0, (0, parcelRequire("fwYdj")).subdomainOverride)[domain] ?? domain;
        return `${subdomain}.${tld}`;
    }
    function $f7bd7ceae0ce7533$export$45d6512913ef41b4(domain) {
        return `${globalThis.location.protocol}//${$f7bd7ceae0ce7533$export$b5ce351acdc48c2a(domain)}`;
    }
    function $f7bd7ceae0ce7533$export$509d18a5fd824839() {
        const hostname = globalThis.location?.hostname;
        if (!hostname) return [
            (0, $16271ea4123e88a6$export$42dd0cdd351a4a9),
            (0, $16271ea4123e88a6$export$f005e2e9f707cb5f)
        ];
        if (hostname.match(/atlassian-fex\.com/)) return [
            (0, $16271ea4123e88a6$export$a739cd5aac835909),
            (0, $16271ea4123e88a6$export$bd6b5a7802d76127)
        ];
        if (hostname.match(/stg\.atlassian-us-gov-mod\.(com|net)/)) return [
            (0, $16271ea4123e88a6$export$a739cd5aac835909),
            (0, $16271ea4123e88a6$export$ce553301d55c2fd8)
        ];
        if (hostname.match(/atlassian-stg-fedm\.net/)) return [
            (0, $16271ea4123e88a6$export$a739cd5aac835909),
            (0, $16271ea4123e88a6$export$ce553301d55c2fd8)
        ];
        if (hostname.match(/atlassian-us-gov-mod\.(com|net)/)) return [
            (0, $16271ea4123e88a6$export$42dd0cdd351a4a9),
            (0, $16271ea4123e88a6$export$ce553301d55c2fd8)
        ];
        if (hostname.match(/stg(\.internal)?\.atlassian\.com/)) return [
            (0, $16271ea4123e88a6$export$a739cd5aac835909),
            (0, $16271ea4123e88a6$export$f005e2e9f707cb5f)
        ];
        if (hostname.match(/jira-dev\.com/)) return [
            (0, $16271ea4123e88a6$export$a739cd5aac835909),
            (0, $16271ea4123e88a6$export$f005e2e9f707cb5f)
        ];
        return [
            (0, $16271ea4123e88a6$export$42dd0cdd351a4a9),
            (0, $16271ea4123e88a6$export$f005e2e9f707cb5f)
        ];
    }
});
const $16271ea4123e88a6$export$ce553301d55c2fd8 = 'fedramp-moderate';
const $16271ea4123e88a6$export$f005e2e9f707cb5f = 'commercial';
const $16271ea4123e88a6$export$bd6b5a7802d76127 = 'fedramp-fedex';
const $16271ea4123e88a6$export$a739cd5aac835909 = 'stg';
const $16271ea4123e88a6$export$42dd0cdd351a4a9 = 'prod';
const $16271ea4123e88a6$export$404582bc18fe4d9e = 'dev';
parcelRegister("fwYdj", function(module, exports) {
    $parcel$export(module.exports, "domainMap", ()=>$0e9cf2b3f287a347$export$6836b090dbaa813a);
    $parcel$export(module.exports, "subdomainOverride", ()=>$0e9cf2b3f287a347$export$c6ab20d0ac4d06b2);
    $parcel$export(module.exports, "fullDomainOverride", ()=>$0e9cf2b3f287a347$export$4723232b625f823e);
    const $0e9cf2b3f287a347$export$6836b090dbaa813a = {
        [(0, $16271ea4123e88a6$export$f005e2e9f707cb5f)]: {
            [(0, $16271ea4123e88a6$export$a739cd5aac835909)]: 'stg.atlassian.com',
            [(0, $16271ea4123e88a6$export$42dd0cdd351a4a9)]: 'atlassian.com'
        },
        [(0, $16271ea4123e88a6$export$bd6b5a7802d76127)]: {
            [(0, $16271ea4123e88a6$export$a739cd5aac835909)]: 'atlassian-fex.com'
        },
        [(0, $16271ea4123e88a6$export$ce553301d55c2fd8)]: {
            [(0, $16271ea4123e88a6$export$a739cd5aac835909)]: 'stg.atlassian-us-gov-mod.com',
            [(0, $16271ea4123e88a6$export$42dd0cdd351a4a9)]: 'atlassian-us-gov-mod.com'
        }
    };
    const $0e9cf2b3f287a347$export$c6ab20d0ac4d06b2 = {};
    const $0e9cf2b3f287a347$export$4723232b625f823e = {
        analytics: {
            [(0, $16271ea4123e88a6$export$f005e2e9f707cb5f)]: {
                [(0, $16271ea4123e88a6$export$42dd0cdd351a4a9)]: 'analytics.atlassian.com'
            }
        },
        confluence: {
            [(0, $16271ea4123e88a6$export$f005e2e9f707cb5f)]: {
                [(0, $16271ea4123e88a6$export$42dd0cdd351a4a9)]: 'confluence.atlassian.com'
            }
        },
        design: {
            [(0, $16271ea4123e88a6$export$f005e2e9f707cb5f)]: {
                [(0, $16271ea4123e88a6$export$42dd0cdd351a4a9)]: 'design.atlassian.com'
            }
        },
        extranet: {
            [(0, $16271ea4123e88a6$export$f005e2e9f707cb5f)]: {
                [(0, $16271ea4123e88a6$export$42dd0cdd351a4a9)]: 'extranet.atlassian.com'
            }
        },
        go: {
            [(0, $16271ea4123e88a6$export$f005e2e9f707cb5f)]: {
                [(0, $16271ea4123e88a6$export$42dd0cdd351a4a9)]: 'go.atlassian.com'
            }
        },
        my: {
            [(0, $16271ea4123e88a6$export$f005e2e9f707cb5f)]: {
                [(0, $16271ea4123e88a6$export$42dd0cdd351a4a9)]: 'my.atlassian.com'
            }
        },
        schema: {
            [(0, $16271ea4123e88a6$export$f005e2e9f707cb5f)]: {
                [(0, $16271ea4123e88a6$export$42dd0cdd351a4a9)]: 'schema.atlassian.com'
            }
        },
        start: {
            [(0, $16271ea4123e88a6$export$f005e2e9f707cb5f)]: {
                [(0, $16271ea4123e88a6$export$42dd0cdd351a4a9)]: 'start.atlassian.com',
                [(0, $16271ea4123e88a6$export$a739cd5aac835909)]: 'start.stg.atlassian.com'
            },
            [(0, $16271ea4123e88a6$export$ce553301d55c2fd8)]: {
                [(0, $16271ea4123e88a6$export$42dd0cdd351a4a9)]: 'start.atlassian-us-gov-mod.com',
                [(0, $16271ea4123e88a6$export$a739cd5aac835909)]: 'start.stg.atlassian-us-gov-mod.com'
            }
        },
        surveys: {
            [(0, $16271ea4123e88a6$export$f005e2e9f707cb5f)]: {
                [(0, $16271ea4123e88a6$export$42dd0cdd351a4a9)]: 'surveys.atlassian.com'
            }
        },
        'wac-cdn': {
            [(0, $16271ea4123e88a6$export$f005e2e9f707cb5f)]: {
                [(0, $16271ea4123e88a6$export$42dd0cdd351a4a9)]: 'wac-cdn.atlassian.com'
            }
        },
        integrations: {
            [(0, $16271ea4123e88a6$export$f005e2e9f707cb5f)]: {
                [(0, $16271ea4123e88a6$export$42dd0cdd351a4a9)]: 'integrations.atlassian.com'
            }
        },
        permalink: {
            [(0, $16271ea4123e88a6$export$f005e2e9f707cb5f)]: {
                [(0, $16271ea4123e88a6$export$42dd0cdd351a4a9)]: 'permalink.atlassian.com'
            }
        },
        id: {
            [(0, $16271ea4123e88a6$export$f005e2e9f707cb5f)]: {
                [(0, $16271ea4123e88a6$export$42dd0cdd351a4a9)]: 'id.atlassian.com',
                [(0, $16271ea4123e88a6$export$a739cd5aac835909)]: 'id.stg.internal.atlassian.com',
                [(0, $16271ea4123e88a6$export$404582bc18fe4d9e)]: 'id.dev.internal.atlassian.com'
            },
            [(0, $16271ea4123e88a6$export$ce553301d55c2fd8)]: {
                [(0, $16271ea4123e88a6$export$42dd0cdd351a4a9)]: 'id.atlassian-us-gov-mod.com',
                [(0, $16271ea4123e88a6$export$a739cd5aac835909)]: 'id.stg.atlassian-us-gov-mod.com'
            }
        },
        support: {
            [(0, $16271ea4123e88a6$export$f005e2e9f707cb5f)]: {
                [(0, $16271ea4123e88a6$export$42dd0cdd351a4a9)]: 'support.atlassian.com'
            }
        }
    };
});
parcelRegister("bNZUH", function(module, exports) {
    $parcel$export(module.exports, "AllowedDomains", ()=>$a96e5ce3058cda14$export$b450288891b9771b);
    const $a96e5ce3058cda14$export$b450288891b9771b = [
        'admin',
        'analytics',
        'api',
        'api.media',
        'api-private',
        'as',
        'atl-global',
        'atlaskit',
        'auth',
        'automation',
        'cassi.internal',
        'cc-import-sources.services',
        'confluence',
        'confluence-chats-integr.services',
        'confluence-cloud-bamboo.internal',
        'confluence-questions.services',
        'data-portal.internal',
        'design',
        'developer',
        'extranet',
        'go',
        'id',
        'id-mail-assets',
        'integrations',
        'ja',
        'jira',
        'jsd-widget',
        'jsd-widget-staging',
        'marketplace',
        'my',
        'my-reminders.services',
        'partners',
        'permalink',
        'permalink.stg',
        'schema',
        'start',
        'support',
        'surveys',
        'team',
        'wac-cdn',
        'xxid',
        'home'
    ];
});
parcelRegister("2I8bw", function(module, exports) {
    $parcel$export(module.exports, "getInstance", ()=>$1a9f4d6c6e9968ea$export$8bedcca5bbd73999);
    var $kTK0a;
    var $6WW6B;
    var $kBAuL;
    const $1a9f4d6c6e9968ea$var$redirect = ()=>{
        const identity = (0, (0, parcelRequire("kTK0a")).getATLContextDomain)('id');
        const redirectUrl = `https://${identity}/login?application=jira&continue=${encodeURIComponent(window.location.href)}`;
        window.location.assign(redirectUrl);
    };
    const $1a9f4d6c6e9968ea$var$DEFAULT_ENDPOINT = '/gateway/api/session/heartbeat';
    const $1a9f4d6c6e9968ea$var$DEFAULT_IDLE_TIME = 60000;
    const $1a9f4d6c6e9968ea$var$timeIsBeforeNow = (dateTime)=>{
        return !!(dateTime && dateTime.getTime() <= Date.now());
    };
    const $1a9f4d6c6e9968ea$var$HeartbeatService = ()=>{
        let timer;
        let heartBeatInterval;
        let nextCallTimestamp;
        let sessionExpiryTimestamp;
        let initialized = false;
        let authenticated = false;
        let userActive = true;
        let tabActive = true;
        const isAuthenticated = ()=>{
            return authenticated;
        };
        const isInitialized = ()=>{
            return initialized;
        };
        const init = ()=>{
            beat();
            heartBeatInterval = setupHeartbeatInterval();
            timer = setupBrowserInteractionTime();
        };
        const cleanup = ()=>{
            clearHeartbeatInterval();
            clearBrowserInteractionTime();
        };
        const beat = async ()=>{
            try {
                const response = await (0, (0, parcelRequire("kBAuL")).postHeartbeat)($1a9f4d6c6e9968ea$var$DEFAULT_ENDPOINT, $1a9f4d6c6e9968ea$var$redirect);
                if (!initialized) initialized = true;
                if (response) {
                    const { nextCallTimestamp: nextCallT, sessionExpiryTime: sessionExpiryT } = response;
                    nextCallTimestamp = new Date(nextCallT);
                    sessionExpiryTimestamp = sessionExpiryT ? new Date(sessionExpiryT) : undefined;
                    authenticated = true;
                }
            } catch (error) {
                authenticated = false;
                clearHeartbeatInterval();
            }
        };
        const setupHeartbeatInterval = ()=>setInterval(()=>{
                if ($1a9f4d6c6e9968ea$var$timeIsBeforeNow(sessionExpiryTimestamp) || userActive && tabActive && $1a9f4d6c6e9968ea$var$timeIsBeforeNow(nextCallTimestamp)) beat();
            }, 10000);
        const clearHeartbeatInterval = ()=>{
            clearInterval(heartBeatInterval);
            heartBeatInterval = undefined;
        };
        const setupBrowserInteractionTime = ()=>{
            const timer = new (0, (0, parcelRequire("6WW6B")).default)({
                idleTimeoutMs: $1a9f4d6c6e9968ea$var$DEFAULT_IDLE_TIME,
                stopTimerOnTabchange: false,
                browserTabActiveCallbacks: [
                    ()=>tabActive = true
                ],
                browserTabInactiveCallbacks: [
                    ()=>tabActive = false
                ],
                idleCallbacks: [
                    ()=>{
                        if (tabActive) beat();
                        userActive = false;
                    }
                ],
                activeCallbacks: [
                    ()=>userActive = true
                ]
            });
            timer.startTimer();
            return timer;
        };
        const clearBrowserInteractionTime = ()=>{
            timer && timer.destroy();
            timer = undefined;
        };
        return {
            isAuthenticated: isAuthenticated,
            isInitialized: isInitialized,
            init: init,
            cleanup: cleanup
        };
    };
    let $1a9f4d6c6e9968ea$var$instance = null;
    const $1a9f4d6c6e9968ea$export$8bedcca5bbd73999 = ()=>{
        if (!$1a9f4d6c6e9968ea$var$instance) {
            $1a9f4d6c6e9968ea$var$instance = $1a9f4d6c6e9968ea$var$HeartbeatService();
            $1a9f4d6c6e9968ea$var$instance.init();
        }
        return $1a9f4d6c6e9968ea$var$instance;
    };
});
parcelRegister("6WW6B", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$02c9d75fd1e73e43$export$2e2bcd8739ae039);
    var $34ck9 = parcelRequire("34ck9");
    const $02c9d75fd1e73e43$var$windowIdleEvents = [
        'scroll',
        'resize'
    ];
    const $02c9d75fd1e73e43$var$documentIdleEvents = [
        'wheel',
        'keydown',
        'keyup',
        'mousedown',
        'mousemove',
        'touchstart',
        'touchmove',
        'click',
        'contextmenu'
    ];
    class $02c9d75fd1e73e43$export$2e2bcd8739ae039 {
        constructor({ timeIntervalEllapsedCallbacks: timeIntervalEllapsedCallbacks = [], absoluteTimeEllapsedCallbacks: absoluteTimeEllapsedCallbacks = [], checkCallbacksIntervalMs: checkCallbacksIntervalMs = 100, browserTabInactiveCallbacks: browserTabInactiveCallbacks = [], idleCallbacks: idleCallbacks = [], stopTimerOnTabchange: stopTimerOnTabchange = true, activeCallbacks: activeCallbacks = [], browserTabActiveCallbacks: browserTabActiveCallbacks = [], idleTimeoutMs: idleTimeoutMs = 3000 }){
            this.onBrowserTabInactive = ()=>{
                if (this.isRunning() && this.stopTimerOnTabchange) this.stopTimer();
                this.browserTabInactiveCallbacks.forEach((fn)=>fn(this.getTimeInMilliseconds()));
            };
            this.onBrowserTabActive = ()=>{
                if (!this.isRunning()) this.startTimer();
                this.browserTabActiveCallbacks.forEach((fn)=>fn(this.getTimeInMilliseconds()));
            };
            this.onBrowserActiveChange = ()=>{
                if (document.visibilityState === 'visible') this.onBrowserTabActive();
                else this.onBrowserTabInactive();
            };
            this.onTimePassed = ()=>{
                this.absoluteTimeEllapsedCallbacks.forEach(({ callback: callback, pending: pending, timeInMilliseconds: timeInMilliseconds }, index)=>{
                    if (pending && timeInMilliseconds <= this.getTimeInMilliseconds()) {
                        callback(this.getTimeInMilliseconds());
                        this.absoluteTimeEllapsedCallbacks[index].pending = false;
                    }
                });
                this.timeIntervalEllapsedCallbacks.forEach(({ callback: callback, timeInMilliseconds: timeInMilliseconds, multiplier: multiplier }, index)=>{
                    if (timeInMilliseconds <= this.getTimeInMilliseconds()) {
                        callback(this.getTimeInMilliseconds());
                        this.timeIntervalEllapsedCallbacks[index].timeInMilliseconds = multiplier(timeInMilliseconds);
                    }
                });
                if (this.currentIdleTimeMs >= this.idleTimeoutMs && this.isRunning()) {
                    this.idle = true;
                    this.stopTimer();
                    this.idleCallbacks.forEach((fn)=>fn(this.getTimeInMilliseconds()));
                } else this.currentIdleTimeMs += this.checkCallbacksIntervalMs;
            };
            this.resetIdleTime = ()=>{
                if (this.idle) this.startTimer();
                this.activeCallbacks.forEach((fn)=>fn(this.getTimeInMilliseconds()));
                this.idle = false;
                this.currentIdleTimeMs = 0;
            };
            this.registerEventListeners = ()=>{
                const documentListenerOptions = {
                    passive: true
                };
                const windowListenerOptions = {
                    ...documentListenerOptions,
                    capture: true
                };
                document.addEventListener('visibilitychange', this.onBrowserActiveChange);
                const throttleResetIdleTime = (0, ($parcel$interopDefault($34ck9)))(this.resetIdleTime, 2000, {
                    leading: true,
                    trailing: false
                });
                $02c9d75fd1e73e43$var$windowIdleEvents.forEach((event)=>{
                    window.addEventListener(event, throttleResetIdleTime, windowListenerOptions);
                });
                $02c9d75fd1e73e43$var$documentIdleEvents.forEach((event)=>document.addEventListener(event, throttleResetIdleTime, documentListenerOptions));
            };
            this.unregisterEventListeners = ()=>{
                document.removeEventListener('visibilitychange', this.onBrowserActiveChange);
                $02c9d75fd1e73e43$var$windowIdleEvents.forEach((event)=>window.removeEventListener(event, this.resetIdleTime));
                $02c9d75fd1e73e43$var$documentIdleEvents.forEach((event)=>document.removeEventListener(event, this.resetIdleTime));
            };
            this.checkCallbacksOnInterval = ()=>{
                this.checkCallbackIntervalId = window.setInterval(()=>{
                    this.onTimePassed();
                }, this.checkCallbacksIntervalMs);
            };
            this.startTimer = ()=>{
                if (!this.checkCallbackIntervalId) this.checkCallbacksOnInterval();
                const last = this.times[this.times.length - 1];
                if (last && last.stop === null) return;
                this.times.push({
                    start: performance.now(),
                    stop: null
                });
                this.running = true;
            };
            this.stopTimer = ()=>{
                if (!this.times.length) return;
                this.times[this.times.length - 1].stop = performance.now();
                this.running = false;
            };
            this.addTimeIntervalEllapsedCallback = (timeIntervalEllapsedCallback)=>{
                this.timeIntervalEllapsedCallbacks.push(timeIntervalEllapsedCallback);
            };
            this.addAbsoluteTimeEllapsedCallback = (absoluteTimeEllapsedCallback)=>{
                this.absoluteTimeEllapsedCallbacks.push(absoluteTimeEllapsedCallback);
            };
            this.addBrowserTabInactiveCallback = (browserTabInactiveCallback)=>{
                this.browserTabInactiveCallbacks.push(browserTabInactiveCallback);
            };
            this.addBrowserTabActiveCallback = (browserTabActiveCallback)=>{
                this.browserTabActiveCallbacks.push(browserTabActiveCallback);
            };
            this.addIdleCallback = (inactiveCallback)=>{
                this.idleCallbacks.push(inactiveCallback);
            };
            this.addActiveCallback = (activeCallback)=>{
                this.activeCallbacks.push(activeCallback);
            };
            this.getTimeInMilliseconds = ()=>{
                return this.times.reduce((acc, current)=>{
                    if (current.stop) acc = acc + (current.stop - current.start);
                    else acc = acc + (performance.now() - current.start);
                    return acc;
                }, 0);
            };
            this.isRunning = ()=>{
                return this.running;
            };
            this.isIdle = ()=>{
                return this.idle;
            };
            this.reset = ()=>{
                this.times = [];
            };
            this.destroy = ()=>{
                this.unregisterEventListeners();
                if (this.checkCallbackIntervalId) window.clearInterval(this.checkCallbackIntervalId);
            };
            this.running = false;
            this.times = [];
            this.idle = false;
            this.currentIdleTimeMs = 0;
            this.marks = {};
            this.measures = {};
            this.stopTimerOnTabchange = stopTimerOnTabchange;
            this.browserTabActiveCallbacks = browserTabActiveCallbacks;
            this.browserTabInactiveCallbacks = browserTabInactiveCallbacks;
            this.checkCallbacksIntervalMs = checkCallbacksIntervalMs;
            this.idleTimeoutMs = idleTimeoutMs;
            this.timeIntervalEllapsedCallbacks = timeIntervalEllapsedCallbacks;
            this.absoluteTimeEllapsedCallbacks = absoluteTimeEllapsedCallbacks;
            this.idleCallbacks = idleCallbacks;
            this.activeCallbacks = activeCallbacks;
            this.registerEventListeners();
        }
        mark(key) {
            if (!this.marks[key]) this.marks[key] = [];
            this.marks[key].push({
                time: this.getTimeInMilliseconds()
            });
        }
        getMarks(name) {
            if (this.marks[name].length < 1) return;
            return this.marks[name];
        }
        measure(name, startMarkName, endMarkName) {
            const startMarks = this.marks[startMarkName];
            const startMark = startMarks[startMarks.length - 1];
            const endMarks = this.marks[endMarkName];
            const endMark = endMarks[endMarks.length - 1];
            if (!this.measures[name]) this.measures[name] = [];
            this.measures[name].push({
                name: name,
                startTime: startMark.time,
                duration: endMark.time - startMark.time
            });
        }
        getMeasures(name) {
            if (!this.measures[name] && this.measures[name].length < 1) return;
            return this.measures[name];
        }
    }
});
parcelRegister("34ck9", function(module, exports) {
    var $lFKmC = parcelRequire("lFKmC");
    var $k0qYG = parcelRequire("k0qYG");
    var $23bb4e171ff15bc1$var$FUNC_ERROR_TEXT = 'Expected a function';
    function $23bb4e171ff15bc1$var$throttle(func, wait, options) {
        var leading = true, trailing = true;
        if (typeof func != 'function') throw new TypeError($23bb4e171ff15bc1$var$FUNC_ERROR_TEXT);
        if ($k0qYG(options)) {
            leading = 'leading' in options ? !!options.leading : leading;
            trailing = 'trailing' in options ? !!options.trailing : trailing;
        }
        return $lFKmC(func, wait, {
            'leading': leading,
            'maxWait': wait,
            'trailing': trailing
        });
    }
    module.exports = $23bb4e171ff15bc1$var$throttle;
});
parcelRegister("kBAuL", function(module, exports) {
    $parcel$export(module.exports, "postHeartbeat", ()=>$7cff47c821db2dad$export$931f43089f67754c);
    const $7cff47c821db2dad$var$RETRY_HTTP_CODES = [
        408,
        500,
        502,
        503,
        504,
        522,
        524
    ];
    function $7cff47c821db2dad$var$timeout(ms) {
        return new Promise((resolve)=>setTimeout(resolve, ms));
    }
    async function $7cff47c821db2dad$var$fetchRetry(url, options = {}, retries = 5, backoff = 300) {
        const response = await fetch(url, options);
        if (response.ok || response.status === 401) return response;
        if (retries > 0 && $7cff47c821db2dad$var$RETRY_HTTP_CODES.includes(response.status)) {
            await $7cff47c821db2dad$var$timeout(backoff);
            return await $7cff47c821db2dad$var$fetchRetry(url, options, retries - 1, backoff * 2);
        } else return Promise.reject(response);
    }
    const $7cff47c821db2dad$export$931f43089f67754c = async (endpoint, onAuthenticationFailed, onBadRequest)=>{
        try {
            const response = await $7cff47c821db2dad$var$fetchRetry(endpoint, {
                method: 'POST',
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            if (response && response.ok) return response.json();
            if (response && response.status === 401 && onAuthenticationFailed) {
                onAuthenticationFailed();
                return;
            }
        } catch (e) {
            const errorResponse = e;
            if (errorResponse.status === 400) {
                onBadRequest?.();
                return Promise.reject(errorResponse);
            }
            if ($7cff47c821db2dad$var$RETRY_HTTP_CODES.includes(errorResponse.status)) console.warn('Heartbeat: Retried 5x, stopped to call api');
        }
    };
});
parcelRegister("eCZ6m", function(module, exports) {
    $parcel$export(module.exports, "getAggEndpoint", ()=>$3d812b79ec4c2140$export$fd126d8de571b77d);
    $parcel$export(module.exports, "getRequestBody", ()=>$3d812b79ec4c2140$export$55bce18df99af758);
    const $3d812b79ec4c2140$var$branchSlug = typeof process !== 'undefined' && process.env ? process.env.AGG_BRANCH_SLUG : undefined;
    const $3d812b79ec4c2140$var$aggPathname = `/gateway/api/graphql${$3d812b79ec4c2140$var$branchSlug ? `/${$3d812b79ec4c2140$var$branchSlug}/graphql` : ''}`;
    const $3d812b79ec4c2140$export$fd126d8de571b77d = (request, cacheConfig = {})=>{
        let endpoint = $3d812b79ec4c2140$var$aggPathname;
        if (cacheConfig.metadata?.META_SLOW_ENDPOINT) endpoint = `${endpoint}/slow`;
        if (request.id != null) endpoint = `${endpoint}/pq/${request.id}`;
        return `${endpoint}?operation=${request.name}`;
    };
    const $3d812b79ec4c2140$export$55bce18df99af758 = (request, variables)=>{
        const requestBody = {
            operationName: request.name,
            variables: variables
        };
        return JSON.stringify(requestBody);
    };
});
parcelRegister("4pgHP", function(module, exports) {
    $parcel$export(module.exports, "startCapturingExtensions", ()=>$2dde2e1ea361345d$export$8656ba3981c6f6c1);
    $parcel$export(module.exports, "stopCapturingExtensions", ()=>$2dde2e1ea361345d$export$f16fa6040161f056);
    $parcel$export(module.exports, "putExtensions", ()=>$2dde2e1ea361345d$export$17dc47fdf278de21);
    $parcel$export(module.exports, "getExtensions", ()=>$2dde2e1ea361345d$export$7c6ea4184129ef74);
    const $2dde2e1ea361345d$var$OperationExtensionsMap = {};
    const $2dde2e1ea361345d$export$8656ba3981c6f6c1 = (operationName)=>{
        $2dde2e1ea361345d$var$OperationExtensionsMap[operationName] = $2dde2e1ea361345d$var$OperationExtensionsMap[operationName] || [];
    };
    const $2dde2e1ea361345d$export$f16fa6040161f056 = (operationName)=>{
        $2dde2e1ea361345d$var$OperationExtensionsMap[operationName] = undefined;
    };
    const $2dde2e1ea361345d$export$17dc47fdf278de21 = (operationName, extension)=>{
        if (extension !== undefined) {
            const extensionsForOperation = $2dde2e1ea361345d$var$OperationExtensionsMap[operationName];
            if (extensionsForOperation !== undefined) extensionsForOperation.push(extension);
        }
    };
    const $2dde2e1ea361345d$export$7c6ea4184129ef74 = (operationName)=>$2dde2e1ea361345d$var$OperationExtensionsMap[operationName] || [];
});
parcelRegister("5Wobd", function(module, exports) {
    $parcel$export(module.exports, "startCapturingTraceIds", ()=>$4d54017c044669f2$export$a2bcb2fac360646c);
    $parcel$export(module.exports, "stopCapturingTraceIds", ()=>$4d54017c044669f2$export$559128bdc4352001);
    $parcel$export(module.exports, "addTraceId", ()=>$4d54017c044669f2$export$fcaa732775f12226);
    $parcel$export(module.exports, "getTraceIds", ()=>$4d54017c044669f2$export$5113e470f5c95670);
    const $4d54017c044669f2$var$OperationTraceIdMap = {};
    const $4d54017c044669f2$export$a2bcb2fac360646c = (operationName)=>{
        $4d54017c044669f2$var$OperationTraceIdMap[operationName] = $4d54017c044669f2$var$OperationTraceIdMap[operationName] || [];
    };
    const $4d54017c044669f2$export$559128bdc4352001 = (operationName)=>{
        $4d54017c044669f2$var$OperationTraceIdMap[operationName] = undefined;
    };
    const $4d54017c044669f2$export$fcaa732775f12226 = (operationName, traceId)=>{
        if (traceId !== undefined) {
            const traceIdsForOperation = $4d54017c044669f2$var$OperationTraceIdMap[operationName];
            if (traceIdsForOperation !== undefined) traceIdsForOperation.push(traceId);
        }
    };
    const $4d54017c044669f2$export$5113e470f5c95670 = (operationName)=>$4d54017c044669f2$var$OperationTraceIdMap[operationName] || [];
});
parcelRegister("aB8eX", function(module, exports) {
    'use strict';
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.batchActions = $7b73c06d66cb3e3d$var$batchActions;
    module.exports.enableBatching = $7b73c06d66cb3e3d$var$enableBatching;
    module.exports.batchDispatchMiddleware = $7b73c06d66cb3e3d$var$batchDispatchMiddleware;
    var $7b73c06d66cb3e3d$var$BATCH = module.exports.BATCH = 'BATCHING_REDUCER.BATCH';
    function $7b73c06d66cb3e3d$var$batchActions(actions) {
        var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $7b73c06d66cb3e3d$var$BATCH;
        return {
            type: type,
            meta: {
                batch: true
            },
            payload: actions
        };
    }
    function $7b73c06d66cb3e3d$var$enableBatching(reduce) {
        return function batchingReducer(state, action) {
            if (action && action.meta && action.meta.batch) return action.payload.reduce(batchingReducer, state);
            return reduce(state, action);
        };
    }
    function $7b73c06d66cb3e3d$var$batchDispatchMiddleware(store) {
        function dispatchChildActions(store, action) {
            if (action.meta && action.meta.batch) action.payload.forEach(function(childAction) {
                dispatchChildActions(store, childAction);
            });
            else store.dispatch(action);
        }
        return function(next) {
            return function(action) {
                if (action && action.meta && action.meta.batch) dispatchChildActions(store, action);
                return next(action);
            };
        };
    }
});
parcelRegister("korqb", function(module, exports) {
    !function(e, t) {
        t(module.exports);
    }(module.exports, function(e) {
        "use strict";
        function t(e, t) {
            e.super_ = t, e.prototype = Object.create(t.prototype, {
                constructor: {
                    value: e,
                    enumerable: !1,
                    writable: !0,
                    configurable: !0
                }
            });
        }
        function r(e, t) {
            Object.defineProperty(this, "kind", {
                value: e,
                enumerable: !0
            }), t && t.length && Object.defineProperty(this, "path", {
                value: t,
                enumerable: !0
            });
        }
        function n(e, t, r) {
            n.super_.call(this, "E", e), Object.defineProperty(this, "lhs", {
                value: t,
                enumerable: !0
            }), Object.defineProperty(this, "rhs", {
                value: r,
                enumerable: !0
            });
        }
        function o(e, t) {
            o.super_.call(this, "N", e), Object.defineProperty(this, "rhs", {
                value: t,
                enumerable: !0
            });
        }
        function i(e, t) {
            i.super_.call(this, "D", e), Object.defineProperty(this, "lhs", {
                value: t,
                enumerable: !0
            });
        }
        function a(e, t, r) {
            a.super_.call(this, "A", e), Object.defineProperty(this, "index", {
                value: t,
                enumerable: !0
            }), Object.defineProperty(this, "item", {
                value: r,
                enumerable: !0
            });
        }
        function f(e, t, r) {
            var n = e.slice((r || t) + 1 || e.length);
            return e.length = t < 0 ? e.length + t : t, e.push.apply(e, n), e;
        }
        function u(e) {
            var t = "undefined" == typeof e ? "undefined" : N(e);
            return "object" !== t ? t : e === Math ? "math" : null === e ? "null" : Array.isArray(e) ? "array" : "[object Date]" === Object.prototype.toString.call(e) ? "date" : "function" == typeof e.toString && /^\/.*\//.test(e.toString()) ? "regexp" : "object";
        }
        function l(e, t, r, c, s, d, p) {
            s = s || [], p = p || [];
            var g = s.slice(0);
            if ("undefined" != typeof d) {
                if (c) {
                    if ("function" == typeof c && c(g, d)) return;
                    if ("object" === ("undefined" == typeof c ? "undefined" : N(c))) {
                        if (c.prefilter && c.prefilter(g, d)) return;
                        if (c.normalize) {
                            var h = c.normalize(g, d, e, t);
                            h && (e = h[0], t = h[1]);
                        }
                    }
                }
                g.push(d);
            }
            "regexp" === u(e) && "regexp" === u(t) && (e = e.toString(), t = t.toString());
            var y = "undefined" == typeof e ? "undefined" : N(e), v = "undefined" == typeof t ? "undefined" : N(t), b = "undefined" !== y || p && p[p.length - 1].lhs && p[p.length - 1].lhs.hasOwnProperty(d), m = "undefined" !== v || p && p[p.length - 1].rhs && p[p.length - 1].rhs.hasOwnProperty(d);
            if (!b && m) r(new o(g, t));
            else if (!m && b) r(new i(g, e));
            else if (u(e) !== u(t)) r(new n(g, e, t));
            else if ("date" === u(e) && e - t !== 0) r(new n(g, e, t));
            else if ("object" === y && null !== e && null !== t) {
                if (p.filter(function(t) {
                    return t.lhs === e;
                }).length) e !== t && r(new n(g, e, t));
                else {
                    if (p.push({
                        lhs: e,
                        rhs: t
                    }), Array.isArray(e)) {
                        var w;
                        e.length;
                        for(w = 0; w < e.length; w++)w >= t.length ? r(new a(g, w, new i(void 0, e[w]))) : l(e[w], t[w], r, c, g, w, p);
                        for(; w < t.length;)r(new a(g, w, new o(void 0, t[w++])));
                    } else {
                        var x = Object.keys(e), S = Object.keys(t);
                        x.forEach(function(n, o) {
                            var i = S.indexOf(n);
                            i >= 0 ? (l(e[n], t[n], r, c, g, n, p), S = f(S, i)) : l(e[n], void 0, r, c, g, n, p);
                        }), S.forEach(function(e) {
                            l(void 0, t[e], r, c, g, e, p);
                        });
                    }
                    p.length = p.length - 1;
                }
            } else e !== t && ("number" === y && isNaN(e) && isNaN(t) || r(new n(g, e, t)));
        }
        function c(e, t, r, n) {
            return n = n || [], l(e, t, function(e) {
                e && n.push(e);
            }, r), n.length ? n : void 0;
        }
        function s(e, t, r) {
            if (r.path && r.path.length) {
                var n, o = e[t], i = r.path.length - 1;
                for(n = 0; n < i; n++)o = o[r.path[n]];
                switch(r.kind){
                    case "A":
                        s(o[r.path[n]], r.index, r.item);
                        break;
                    case "D":
                        delete o[r.path[n]];
                        break;
                    case "E":
                    case "N":
                        o[r.path[n]] = r.rhs;
                }
            } else switch(r.kind){
                case "A":
                    s(e[t], r.index, r.item);
                    break;
                case "D":
                    e = f(e, t);
                    break;
                case "E":
                case "N":
                    e[t] = r.rhs;
            }
            return e;
        }
        function d(e, t, r) {
            if (e && t && r && r.kind) {
                for(var n = e, o = -1, i = r.path ? r.path.length - 1 : 0; ++o < i;)"undefined" == typeof n[r.path[o]] && (n[r.path[o]] = "number" == typeof r.path[o] ? [] : {}), n = n[r.path[o]];
                switch(r.kind){
                    case "A":
                        s(r.path ? n[r.path[o]] : n, r.index, r.item);
                        break;
                    case "D":
                        delete n[r.path[o]];
                        break;
                    case "E":
                    case "N":
                        n[r.path[o]] = r.rhs;
                }
            }
        }
        function p(e, t, r) {
            if (r.path && r.path.length) {
                var n, o = e[t], i = r.path.length - 1;
                for(n = 0; n < i; n++)o = o[r.path[n]];
                switch(r.kind){
                    case "A":
                        p(o[r.path[n]], r.index, r.item);
                        break;
                    case "D":
                        o[r.path[n]] = r.lhs;
                        break;
                    case "E":
                        o[r.path[n]] = r.lhs;
                        break;
                    case "N":
                        delete o[r.path[n]];
                }
            } else switch(r.kind){
                case "A":
                    p(e[t], r.index, r.item);
                    break;
                case "D":
                    e[t] = r.lhs;
                    break;
                case "E":
                    e[t] = r.lhs;
                    break;
                case "N":
                    e = f(e, t);
            }
            return e;
        }
        function g(e, t, r) {
            if (e && t && r && r.kind) {
                var n, o, i = e;
                for(o = r.path.length - 1, n = 0; n < o; n++)"undefined" == typeof i[r.path[n]] && (i[r.path[n]] = {}), i = i[r.path[n]];
                switch(r.kind){
                    case "A":
                        p(i[r.path[n]], r.index, r.item);
                        break;
                    case "D":
                        i[r.path[n]] = r.lhs;
                        break;
                    case "E":
                        i[r.path[n]] = r.lhs;
                        break;
                    case "N":
                        delete i[r.path[n]];
                }
            }
        }
        function h(e, t, r) {
            if (e && t) {
                var n = function(n) {
                    r && !r(e, t, n) || d(e, t, n);
                };
                l(e, t, n);
            }
        }
        function y(e) {
            return "color: " + F[e].color + "; font-weight: bold";
        }
        function v(e) {
            var t = e.kind, r = e.path, n = e.lhs, o = e.rhs, i = e.index, a = e.item;
            switch(t){
                case "E":
                    return [
                        r.join("."),
                        n,
                        "\u2192",
                        o
                    ];
                case "N":
                    return [
                        r.join("."),
                        o
                    ];
                case "D":
                    return [
                        r.join(".")
                    ];
                case "A":
                    return [
                        r.join(".") + "[" + i + "]",
                        a
                    ];
                default:
                    return [];
            }
        }
        function b(e, t, r, n) {
            var o = c(e, t);
            try {
                n ? r.groupCollapsed("diff") : r.group("diff");
            } catch (e) {
                r.log("diff");
            }
            o ? o.forEach(function(e) {
                var t = e.kind, n = v(e);
                r.log.apply(r, [
                    "%c " + F[t].text,
                    y(t)
                ].concat(P(n)));
            }) : r.log("\u2014\u2014 no diff \u2014\u2014");
            try {
                r.groupEnd();
            } catch (e) {
                r.log("\u2014\u2014 diff end \u2014\u2014 ");
            }
        }
        function m(e, t, r, n) {
            switch("undefined" == typeof e ? "undefined" : N(e)){
                case "object":
                    return "function" == typeof e[n] ? e[n].apply(e, P(r)) : e[n];
                case "function":
                    return e(t);
                default:
                    return e;
            }
        }
        function w(e) {
            var t = e.timestamp, r = e.duration;
            return function(e, n, o) {
                var i = [
                    "action"
                ];
                return i.push("%c" + String(e.type)), t && i.push("%c@ " + n), r && i.push("%c(in " + o.toFixed(2) + " ms)"), i.join(" ");
            };
        }
        function x(e, t) {
            var r = t.logger, n = t.actionTransformer, o = t.titleFormatter, i = void 0 === o ? w(t) : o, a = t.collapsed, f = t.colors, u = t.level, l = t.diff, c = "undefined" == typeof t.titleFormatter;
            e.forEach(function(o, s) {
                var d = o.started, p = o.startedTime, g = o.action, h = o.prevState, y = o.error, v = o.took, w = o.nextState, x = e[s + 1];
                x && (w = x.prevState, v = x.started - d);
                var S = n(g), k = "function" == typeof a ? a(function() {
                    return w;
                }, g, o) : a, j = D(p), E = f.title ? "color: " + f.title(S) + ";" : "", A = [
                    "color: gray; font-weight: lighter;"
                ];
                A.push(E), t.timestamp && A.push("color: gray; font-weight: lighter;"), t.duration && A.push("color: gray; font-weight: lighter;");
                var O = i(S, j, v);
                try {
                    k ? f.title && c ? r.groupCollapsed.apply(r, [
                        "%c " + O
                    ].concat(A)) : r.groupCollapsed(O) : f.title && c ? r.group.apply(r, [
                        "%c " + O
                    ].concat(A)) : r.group(O);
                } catch (e) {
                    r.log(O);
                }
                var N = m(u, S, [
                    h
                ], "prevState"), P = m(u, S, [
                    S
                ], "action"), C = m(u, S, [
                    y,
                    h
                ], "error"), F = m(u, S, [
                    w
                ], "nextState");
                if (N) {
                    if (f.prevState) {
                        var L = "color: " + f.prevState(h) + "; font-weight: bold";
                        r[N]("%c prev state", L, h);
                    } else r[N]("prev state", h);
                }
                if (P) {
                    if (f.action) {
                        var T = "color: " + f.action(S) + "; font-weight: bold";
                        r[P]("%c action    ", T, S);
                    } else r[P]("action    ", S);
                }
                if (y && C) {
                    if (f.error) {
                        var M = "color: " + f.error(y, h) + "; font-weight: bold;";
                        r[C]("%c error     ", M, y);
                    } else r[C]("error     ", y);
                }
                if (F) {
                    if (f.nextState) {
                        var _ = "color: " + f.nextState(w) + "; font-weight: bold";
                        r[F]("%c next state", _, w);
                    } else r[F]("next state", w);
                }
                l && b(h, w, r, k);
                try {
                    r.groupEnd();
                } catch (e) {
                    r.log("\u2014\u2014 log end \u2014\u2014");
                }
            });
        }
        function S() {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, t = Object.assign({}, L, e), r = t.logger, n = t.stateTransformer, o = t.errorTransformer, i = t.predicate, a = t.logErrors, f = t.diffPredicate;
            if ("undefined" == typeof r) return function() {
                return function(e) {
                    return function(t) {
                        return e(t);
                    };
                };
            };
            if (e.getState && e.dispatch) return console.error("[redux-logger] redux-logger not installed. Make sure to pass logger instance as middleware:\n// Logger with default options\nimport { logger } from 'redux-logger'\nconst store = createStore(\n  reducer,\n  applyMiddleware(logger)\n)\n// Or you can create your own logger with custom options http://bit.ly/redux-logger-options\nimport createLogger from 'redux-logger'\nconst logger = createLogger({\n  // ...options\n});\nconst store = createStore(\n  reducer,\n  applyMiddleware(logger)\n)\n"), function() {
                return function(e) {
                    return function(t) {
                        return e(t);
                    };
                };
            };
            var u = [];
            return function(e) {
                var r = e.getState;
                return function(e) {
                    return function(l) {
                        if ("function" == typeof i && !i(r, l)) return e(l);
                        var c = {};
                        u.push(c), c.started = O.now(), c.startedTime = new Date, c.prevState = n(r()), c.action = l;
                        var s = void 0;
                        if (a) try {
                            s = e(l);
                        } catch (e) {
                            c.error = o(e);
                        }
                        else s = e(l);
                        c.took = O.now() - c.started, c.nextState = n(r());
                        var d = t.diff && "function" == typeof f ? f(r, l) : t.diff;
                        if (x(u, Object.assign({}, t, {
                            diff: d
                        })), u.length = 0, c.error) throw c.error;
                        return s;
                    };
                };
            };
        }
        var k, j, E = function(e, t) {
            return new Array(t + 1).join(e);
        }, A = function(e, t) {
            return E("0", t - e.toString().length) + e;
        }, D = function(e) {
            return A(e.getHours(), 2) + ":" + A(e.getMinutes(), 2) + ":" + A(e.getSeconds(), 2) + "." + A(e.getMilliseconds(), 3);
        }, O = "undefined" != typeof performance && null !== performance && "function" == typeof performance.now ? performance : Date, N = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
            return typeof e;
        } : function(e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
        }, P = function(e) {
            if (Array.isArray(e)) {
                for(var t = 0, r = Array(e.length); t < e.length; t++)r[t] = e[t];
                return r;
            }
            return Array.from(e);
        }, C = [];
        k = "object" === ("undefined" == typeof $parcel$global ? "undefined" : N($parcel$global)) && $parcel$global ? $parcel$global : "undefined" != typeof window ? window : {}, j = k.DeepDiff, j && C.push(function() {
            "undefined" != typeof j && k.DeepDiff === c && (k.DeepDiff = j, j = void 0);
        }), t(n, r), t(o, r), t(i, r), t(a, r), Object.defineProperties(c, {
            diff: {
                value: c,
                enumerable: !0
            },
            observableDiff: {
                value: l,
                enumerable: !0
            },
            applyDiff: {
                value: h,
                enumerable: !0
            },
            applyChange: {
                value: d,
                enumerable: !0
            },
            revertChange: {
                value: g,
                enumerable: !0
            },
            isConflict: {
                value: function() {
                    return "undefined" != typeof j;
                },
                enumerable: !0
            },
            noConflict: {
                value: function() {
                    return C && (C.forEach(function(e) {
                        e();
                    }), C = null), c;
                },
                enumerable: !0
            }
        });
        var F = {
            E: {
                color: "#2196F3",
                text: "CHANGED:"
            },
            N: {
                color: "#4CAF50",
                text: "ADDED:"
            },
            D: {
                color: "#F44336",
                text: "DELETED:"
            },
            A: {
                color: "#2196F3",
                text: "ARRAY:"
            }
        }, L = {
            level: "log",
            logger: console,
            logErrors: !0,
            collapsed: void 0,
            predicate: void 0,
            duration: !1,
            timestamp: !0,
            stateTransformer: function(e) {
                return e;
            },
            actionTransformer: function(e) {
                return e;
            },
            errorTransformer: function(e) {
                return e;
            },
            colors: {
                title: function() {
                    return "inherit";
                },
                prevState: function() {
                    return "#9E9E9E";
                },
                action: function() {
                    return "#03A9F4";
                },
                nextState: function() {
                    return "#4CAF50";
                },
                error: function() {
                    return "#F20404";
                }
            },
            diff: !1,
            diffPredicate: void 0,
            transformer: void 0
        }, T = function() {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, t = e.dispatch, r = e.getState;
            return "function" == typeof t || "function" == typeof r ? S()({
                dispatch: t,
                getState: r
            }) : void console.error("\n[redux-logger v3] BREAKING CHANGE\n[redux-logger v3] Since 3.0.0 redux-logger exports by default logger with default settings.\n[redux-logger v3] Change\n[redux-logger v3] import createLogger from 'redux-logger'\n[redux-logger v3] to\n[redux-logger v3] import { createLogger } from 'redux-logger'\n");
        };
        e.defaults = L, e.createLogger = S, e.logger = T, e.default = T, Object.defineProperty(e, "__esModule", {
            value: !0
        });
    });
});
parcelRegister("ifg6x", function(module, exports) {
    var $4CZTG = parcelRequire("4CZTG");
    var $d4861eb268113e50$var$partition = $4CZTG(function(result, value, key) {
        result[key ? 0 : 1].push(value);
    }, function() {
        return [
            [],
            []
        ];
    });
    module.exports = $d4861eb268113e50$var$partition;
});
parcelRegister("4CZTG", function(module, exports) {
    var $hBvrS = parcelRequire("hBvrS");
    var $fqzo0 = parcelRequire("fqzo0");
    var $bxDef = parcelRequire("bxDef");
    var $8LQ84 = parcelRequire("8LQ84");
    function $35eab98708747af8$var$createAggregator(setter, initializer) {
        return function(collection, iteratee) {
            var func = $8LQ84(collection) ? $hBvrS : $fqzo0, accumulator = initializer ? initializer() : {};
            return func(collection, setter, $bxDef(iteratee, 2), accumulator);
        };
    }
    module.exports = $35eab98708747af8$var$createAggregator;
});
parcelRegister("hBvrS", function(module, exports) {
    function $cd0e496a488f8bed$var$arrayAggregator(array, setter, iteratee, accumulator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            var value = array[index];
            setter(accumulator, value, iteratee(value), array);
        }
        return accumulator;
    }
    module.exports = $cd0e496a488f8bed$var$arrayAggregator;
});
parcelRegister("fqzo0", function(module, exports) {
    var $e7pfQ = parcelRequire("e7pfQ");
    function $b3b4bba991f8eee5$var$baseAggregator(collection, setter, iteratee, accumulator) {
        $e7pfQ(collection, function(value, key, collection) {
            setter(accumulator, value, iteratee(value), collection);
        });
        return accumulator;
    }
    module.exports = $b3b4bba991f8eee5$var$baseAggregator;
});
parcelRegister("e7pfQ", function(module, exports) {
    var $hDnyx = parcelRequire("hDnyx");
    var $bogqY = parcelRequire("bogqY");
    var $a4754f2fa2dabe99$var$baseEach = $bogqY($hDnyx);
    module.exports = $a4754f2fa2dabe99$var$baseEach;
});
parcelRegister("hDnyx", function(module, exports) {
    var $et7t4 = parcelRequire("et7t4");
    var $66FNL = parcelRequire("66FNL");
    function $cd6859e7c62c7d41$var$baseForOwn(object, iteratee) {
        return object && $et7t4(object, iteratee, $66FNL);
    }
    module.exports = $cd6859e7c62c7d41$var$baseForOwn;
});
parcelRegister("bogqY", function(module, exports) {
    var $hTJwX = parcelRequire("hTJwX");
    function $84aeaf14b55f70e4$var$createBaseEach(eachFunc, fromRight) {
        return function(collection, iteratee) {
            if (collection == null) return collection;
            if (!$hTJwX(collection)) return eachFunc(collection, iteratee);
            var length = collection.length, index = fromRight ? length : -1, iterable = Object(collection);
            while(fromRight ? index-- : ++index < length){
                if (iteratee(iterable[index], index, iterable) === false) break;
            }
            return collection;
        };
    }
    module.exports = $84aeaf14b55f70e4$var$createBaseEach;
});
parcelRegister("4U1PW", function(module, exports) {
    $parcel$export(module.exports, "createClient", ()=>$391dd11e177a8b61$export$5d730b7aed1a3eb0);
    var $l7Jgj;
    var $7Tywk;
    var $391dd11e177a8b61$var$__await = undefined && undefined.__await || function(v) {
        return this instanceof $391dd11e177a8b61$var$__await ? (this.v = v, this) : new $391dd11e177a8b61$var$__await(v);
    };
    var $391dd11e177a8b61$var$__asyncGenerator = undefined && undefined.__asyncGenerator || function(thisArg, _arguments, generator) {
        if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
        var g = generator.apply(thisArg, _arguments || []), i, q = [];
        return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
            return this;
        }, i;
        function verb(n) {
            if (g[n]) i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
        }
        function resume(n, v) {
            try {
                step(g[n](v));
            } catch (e) {
                settle(q[0][3], e);
            }
        }
        function step(r) {
            r.value instanceof $391dd11e177a8b61$var$__await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
        }
        function fulfill(value) {
            resume("next", value);
        }
        function reject(value) {
            resume("throw", value);
        }
        function settle(f, v) {
            if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
        }
    };
    function $391dd11e177a8b61$export$5d730b7aed1a3eb0(options) {
        const { url: url, connectionParams: connectionParams, lazy: lazy = true, onNonLazyError: onNonLazyError = console.error, lazyCloseTimeout: lazyCloseTimeoutMs = 0, keepAlive: keepAlive = 0, disablePong: disablePong, connectionAckWaitTimeout: connectionAckWaitTimeout = 0, retryAttempts: retryAttempts = 5, retryWait: retryWait = async function randomisedExponentialBackoff(retries) {
            let retryDelay = 1000;
            for(let i = 0; i < retries; i++)retryDelay *= 2;
            await new Promise((resolve)=>setTimeout(resolve, retryDelay + Math.floor(Math.random() * 2700 + 300)));
        }, shouldRetry: shouldRetry = $391dd11e177a8b61$var$isLikeCloseEvent, isFatalConnectionProblem: isFatalConnectionProblem, on: on, webSocketImpl: webSocketImpl, generateID: generateID = function generateUUID() {
            return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c)=>{
                const r = Math.random() * 16 | 0, v = c == 'x' ? r : r & 0x3 | 0x8;
                return v.toString(16);
            });
        }, jsonMessageReplacer: replacer, jsonMessageReviver: reviver } = options;
        let ws;
        if (webSocketImpl) {
            if (!$391dd11e177a8b61$var$isWebSocket(webSocketImpl)) throw new Error('Invalid WebSocket implementation provided');
            ws = webSocketImpl;
        } else if (typeof WebSocket !== 'undefined') ws = WebSocket;
        else if (typeof $parcel$global !== 'undefined') ws = $parcel$global.WebSocket || $parcel$global.MozWebSocket;
        else if (typeof window !== 'undefined') ws = window.WebSocket || window.MozWebSocket;
        if (!ws) throw new Error("WebSocket implementation missing; on Node you can `import WebSocket from 'ws';` and pass `webSocketImpl: WebSocket` to `createClient`");
        const WebSocketImpl = ws;
        const emitter = (()=>{
            const message = (()=>{
                const listeners = {};
                return {
                    on (id, listener) {
                        listeners[id] = listener;
                        return ()=>{
                            delete listeners[id];
                        };
                    },
                    emit (message) {
                        var _a;
                        if ('id' in message) (_a = listeners[message.id]) === null || _a === void 0 || _a.call(listeners, message);
                    }
                };
            })();
            const listeners = {
                connecting: (on === null || on === void 0 ? void 0 : on.connecting) ? [
                    on.connecting
                ] : [],
                opened: (on === null || on === void 0 ? void 0 : on.opened) ? [
                    on.opened
                ] : [],
                connected: (on === null || on === void 0 ? void 0 : on.connected) ? [
                    on.connected
                ] : [],
                ping: (on === null || on === void 0 ? void 0 : on.ping) ? [
                    on.ping
                ] : [],
                pong: (on === null || on === void 0 ? void 0 : on.pong) ? [
                    on.pong
                ] : [],
                message: (on === null || on === void 0 ? void 0 : on.message) ? [
                    message.emit,
                    on.message
                ] : [
                    message.emit
                ],
                closed: (on === null || on === void 0 ? void 0 : on.closed) ? [
                    on.closed
                ] : [],
                error: (on === null || on === void 0 ? void 0 : on.error) ? [
                    on.error
                ] : []
            };
            return {
                onMessage: message.on,
                on (event, listener) {
                    const l = listeners[event];
                    l.push(listener);
                    return ()=>{
                        l.splice(l.indexOf(listener), 1);
                    };
                },
                emit (event, ...args) {
                    for (const listener of [
                        ...listeners[event]
                    ])listener(...args);
                }
            };
        })();
        function errorOrClosed(cb) {
            const listening = [
                emitter.on('error', (err)=>{
                    listening.forEach((unlisten)=>unlisten());
                    cb(err);
                }),
                emitter.on('closed', (event)=>{
                    listening.forEach((unlisten)=>unlisten());
                    cb(event);
                })
            ];
        }
        let connecting, locks = 0, lazyCloseTimeout, retrying = false, retries = 0, disposed = false;
        async function connect() {
            clearTimeout(lazyCloseTimeout);
            const [socket, throwOnClose] = await (connecting !== null && connecting !== void 0 ? connecting : connecting = new Promise((connected, denied)=>(async ()=>{
                    if (retrying) {
                        await retryWait(retries);
                        if (!locks) {
                            connecting = undefined;
                            return denied({
                                code: 1000,
                                reason: 'All Subscriptions Gone'
                            });
                        }
                        retries++;
                    }
                    emitter.emit('connecting');
                    const socket = new WebSocketImpl(typeof url === 'function' ? await url() : url, (0, (0, parcelRequire("l7Jgj")).GRAPHQL_TRANSPORT_WS_PROTOCOL));
                    let connectionAckTimeout, queuedPing;
                    function enqueuePing() {
                        if (isFinite(keepAlive) && keepAlive > 0) {
                            clearTimeout(queuedPing);
                            queuedPing = setTimeout(()=>{
                                if (socket.readyState === WebSocketImpl.OPEN) {
                                    socket.send((0, (0, parcelRequire("l7Jgj")).stringifyMessage)({
                                        type: (0, (0, parcelRequire("l7Jgj")).MessageType).Ping
                                    }));
                                    emitter.emit('ping', false, undefined);
                                }
                            }, keepAlive);
                        }
                    }
                    errorOrClosed((errOrEvent)=>{
                        connecting = undefined;
                        clearTimeout(connectionAckTimeout);
                        clearTimeout(queuedPing);
                        denied(errOrEvent);
                        if ($391dd11e177a8b61$var$isLikeCloseEvent(errOrEvent) && errOrEvent.code === 4499) {
                            socket.close(4499, 'Terminated');
                            socket.onerror = null;
                            socket.onclose = null;
                        }
                    });
                    socket.onerror = (err)=>emitter.emit('error', err);
                    socket.onclose = (event)=>emitter.emit('closed', event);
                    socket.onopen = async ()=>{
                        try {
                            emitter.emit('opened', socket);
                            const payload = typeof connectionParams === 'function' ? await connectionParams() : connectionParams;
                            if (socket.readyState !== WebSocketImpl.OPEN) return;
                            socket.send((0, (0, parcelRequire("l7Jgj")).stringifyMessage)(payload ? {
                                type: (0, (0, parcelRequire("l7Jgj")).MessageType).ConnectionInit,
                                payload: payload
                            } : {
                                type: (0, (0, parcelRequire("l7Jgj")).MessageType).ConnectionInit
                            }, replacer));
                            if (isFinite(connectionAckWaitTimeout) && connectionAckWaitTimeout > 0) connectionAckTimeout = setTimeout(()=>{
                                socket.close((0, (0, parcelRequire("l7Jgj")).CloseCode).ConnectionAcknowledgementTimeout, 'Connection acknowledgement timeout');
                            }, connectionAckWaitTimeout);
                            enqueuePing();
                        } catch (err) {
                            emitter.emit('error', err);
                            socket.close((0, (0, parcelRequire("l7Jgj")).CloseCode).InternalClientError, (0, (0, parcelRequire("7Tywk")).limitCloseReason)(err instanceof Error ? err.message : new Error(err).message, 'Internal client error'));
                        }
                    };
                    let acknowledged = false;
                    socket.onmessage = ({ data: data })=>{
                        try {
                            const message = (0, (0, parcelRequire("l7Jgj")).parseMessage)(data, reviver);
                            emitter.emit('message', message);
                            if (message.type === 'ping' || message.type === 'pong') {
                                emitter.emit(message.type, true, message.payload);
                                if (message.type === 'pong') enqueuePing();
                                else if (!disablePong) {
                                    socket.send((0, (0, parcelRequire("l7Jgj")).stringifyMessage)(message.payload ? {
                                        type: (0, (0, parcelRequire("l7Jgj")).MessageType).Pong,
                                        payload: message.payload
                                    } : {
                                        type: (0, (0, parcelRequire("l7Jgj")).MessageType).Pong
                                    }));
                                    emitter.emit('pong', false, message.payload);
                                }
                                return;
                            }
                            if (acknowledged) return;
                            if (message.type !== (0, (0, parcelRequire("l7Jgj")).MessageType).ConnectionAck) throw new Error(`First message cannot be of type ${message.type}`);
                            clearTimeout(connectionAckTimeout);
                            acknowledged = true;
                            emitter.emit('connected', socket, message.payload);
                            retrying = false;
                            retries = 0;
                            connected([
                                socket,
                                new Promise((_, reject)=>errorOrClosed(reject))
                            ]);
                        } catch (err) {
                            socket.onmessage = null;
                            emitter.emit('error', err);
                            socket.close((0, (0, parcelRequire("l7Jgj")).CloseCode).BadResponse, (0, (0, parcelRequire("7Tywk")).limitCloseReason)(err instanceof Error ? err.message : new Error(err).message, 'Bad response'));
                        }
                    };
                })()));
            if (socket.readyState === WebSocketImpl.CLOSING) await throwOnClose;
            let release = ()=>{};
            const released = new Promise((resolve)=>release = resolve);
            return [
                socket,
                release,
                Promise.race([
                    released.then(()=>{
                        if (!locks) {
                            const complete = ()=>socket.close(1000, 'Normal Closure');
                            if (isFinite(lazyCloseTimeoutMs) && lazyCloseTimeoutMs > 0) lazyCloseTimeout = setTimeout(()=>{
                                if (socket.readyState === WebSocketImpl.OPEN) complete();
                            }, lazyCloseTimeoutMs);
                            else complete();
                        }
                    }),
                    throwOnClose
                ])
            ];
        }
        function shouldRetryConnectOrThrow(errOrCloseEvent) {
            if ($391dd11e177a8b61$var$isLikeCloseEvent(errOrCloseEvent) && ($391dd11e177a8b61$var$isFatalInternalCloseCode(errOrCloseEvent.code) || [
                (0, (0, parcelRequire("l7Jgj")).CloseCode).InternalServerError,
                (0, (0, parcelRequire("l7Jgj")).CloseCode).InternalClientError,
                (0, (0, parcelRequire("l7Jgj")).CloseCode).BadRequest,
                (0, (0, parcelRequire("l7Jgj")).CloseCode).BadResponse,
                (0, (0, parcelRequire("l7Jgj")).CloseCode).Unauthorized,
                (0, (0, parcelRequire("l7Jgj")).CloseCode).SubprotocolNotAcceptable,
                (0, (0, parcelRequire("l7Jgj")).CloseCode).SubscriberAlreadyExists,
                (0, (0, parcelRequire("l7Jgj")).CloseCode).TooManyInitialisationRequests
            ].includes(errOrCloseEvent.code))) throw errOrCloseEvent;
            if (disposed) return false;
            if ($391dd11e177a8b61$var$isLikeCloseEvent(errOrCloseEvent) && errOrCloseEvent.code === 1000) return locks > 0;
            if (!retryAttempts || retries >= retryAttempts) throw errOrCloseEvent;
            if (!shouldRetry(errOrCloseEvent)) throw errOrCloseEvent;
            if (isFatalConnectionProblem === null || isFatalConnectionProblem === void 0 ? void 0 : isFatalConnectionProblem(errOrCloseEvent)) throw errOrCloseEvent;
            return retrying = true;
        }
        if (!lazy) (async ()=>{
            locks++;
            for(;;)try {
                const [, , throwOnClose] = await connect();
                await throwOnClose;
            } catch (errOrCloseEvent) {
                try {
                    if (!shouldRetryConnectOrThrow(errOrCloseEvent)) return;
                } catch (errOrCloseEvent) {
                    return onNonLazyError === null || onNonLazyError === void 0 ? void 0 : onNonLazyError(errOrCloseEvent);
                }
            }
        })();
        return {
            on: emitter.on,
            subscribe (payload, sink) {
                const id = generateID(payload);
                let done = false, errored = false, releaser = ()=>{
                    locks--;
                    done = true;
                };
                (async ()=>{
                    locks++;
                    for(;;)try {
                        const [socket, release, waitForReleaseOrThrowOnClose] = await connect();
                        if (done) return release();
                        const unlisten = emitter.onMessage(id, (message)=>{
                            switch(message.type){
                                case (0, (0, parcelRequire("l7Jgj")).MessageType).Next:
                                    sink.next(message.payload);
                                    return;
                                case (0, (0, parcelRequire("l7Jgj")).MessageType).Error:
                                    errored = true, done = true;
                                    sink.error(message.payload);
                                    releaser();
                                    return;
                                case (0, (0, parcelRequire("l7Jgj")).MessageType).Complete:
                                    done = true;
                                    releaser();
                                    return;
                            }
                        });
                        socket.send((0, (0, parcelRequire("l7Jgj")).stringifyMessage)({
                            id: id,
                            type: (0, (0, parcelRequire("l7Jgj")).MessageType).Subscribe,
                            payload: payload
                        }, replacer));
                        releaser = ()=>{
                            if (!done && socket.readyState === WebSocketImpl.OPEN) socket.send((0, (0, parcelRequire("l7Jgj")).stringifyMessage)({
                                id: id,
                                type: (0, (0, parcelRequire("l7Jgj")).MessageType).Complete
                            }, replacer));
                            locks--;
                            done = true;
                            release();
                        };
                        await waitForReleaseOrThrowOnClose.finally(unlisten);
                        return;
                    } catch (errOrCloseEvent) {
                        if (!shouldRetryConnectOrThrow(errOrCloseEvent)) return;
                    }
                })().then(()=>{
                    if (!errored) sink.complete();
                }).catch((err)=>{
                    sink.error(err);
                });
                return ()=>{
                    if (!done) releaser();
                };
            },
            iterate (request) {
                const pending = [];
                const deferred = {
                    done: false,
                    error: null,
                    resolve: ()=>{}
                };
                const dispose = this.subscribe(request, {
                    next (val) {
                        pending.push(val);
                        deferred.resolve();
                    },
                    error (err) {
                        deferred.done = true;
                        deferred.error = err;
                        deferred.resolve();
                    },
                    complete () {
                        deferred.done = true;
                        deferred.resolve();
                    }
                });
                const iterator = function iterator() {
                    return $391dd11e177a8b61$var$__asyncGenerator(this, arguments, function* iterator_1() {
                        for(;;){
                            if (!pending.length) yield $391dd11e177a8b61$var$__await(new Promise((resolve)=>deferred.resolve = resolve));
                            while(pending.length)yield yield $391dd11e177a8b61$var$__await(pending.shift());
                            if (deferred.error) throw deferred.error;
                            if (deferred.done) return yield $391dd11e177a8b61$var$__await(void 0);
                        }
                    });
                }();
                iterator.throw = async (err)=>{
                    if (!deferred.done) {
                        deferred.done = true;
                        deferred.error = err;
                        deferred.resolve();
                    }
                    return {
                        done: true,
                        value: undefined
                    };
                };
                iterator.return = async ()=>{
                    dispose();
                    return {
                        done: true,
                        value: undefined
                    };
                };
                return iterator;
            },
            async dispose () {
                disposed = true;
                if (connecting) {
                    const [socket] = await connecting;
                    socket.close(1000, 'Normal Closure');
                }
            },
            terminate () {
                if (connecting) emitter.emit('closed', {
                    code: 4499,
                    reason: 'Terminated',
                    wasClean: false
                });
            }
        };
    }
    function $391dd11e177a8b61$var$isLikeCloseEvent(val) {
        return (0, (0, parcelRequire("7Tywk")).isObject)(val) && 'code' in val && 'reason' in val;
    }
    function $391dd11e177a8b61$var$isFatalInternalCloseCode(code) {
        if ([
            1000,
            1001,
            1006,
            1005,
            1012,
            1013,
            1014
        ].includes(code)) return false;
        return code >= 1000 && code <= 1999;
    }
    function $391dd11e177a8b61$var$isWebSocket(val) {
        return typeof val === 'function' && 'constructor' in val && 'CLOSED' in val && 'CLOSING' in val && 'CONNECTING' in val && 'OPEN' in val;
    }
});
parcelRegister("l7Jgj", function(module, exports) {
    $parcel$export(module.exports, "GRAPHQL_TRANSPORT_WS_PROTOCOL", ()=>$f60d5c8886e0651e$export$5c0a4edfedc7c457);
    $parcel$export(module.exports, "CloseCode", ()=>$f60d5c8886e0651e$export$777128f41f6616ec);
    $parcel$export(module.exports, "MessageType", ()=>$f60d5c8886e0651e$export$80edbf15fa61a4db);
    $parcel$export(module.exports, "parseMessage", ()=>$f60d5c8886e0651e$export$f2f615077a189f21);
    $parcel$export(module.exports, "stringifyMessage", ()=>$f60d5c8886e0651e$export$77896e5b47bfd50b);
    var $7Tywk;
    const $f60d5c8886e0651e$export$5c0a4edfedc7c457 = 'graphql-transport-ws';
    const $f60d5c8886e0651e$export$ec743af8bb66f3be = 'graphql-ws';
    var $f60d5c8886e0651e$export$777128f41f6616ec;
    (function(CloseCode) {
        CloseCode[CloseCode["InternalServerError"] = 4500] = "InternalServerError";
        CloseCode[CloseCode["InternalClientError"] = 4005] = "InternalClientError";
        CloseCode[CloseCode["BadRequest"] = 4400] = "BadRequest";
        CloseCode[CloseCode["BadResponse"] = 4004] = "BadResponse";
        CloseCode[CloseCode["Unauthorized"] = 4401] = "Unauthorized";
        CloseCode[CloseCode["Forbidden"] = 4403] = "Forbidden";
        CloseCode[CloseCode["SubprotocolNotAcceptable"] = 4406] = "SubprotocolNotAcceptable";
        CloseCode[CloseCode["ConnectionInitialisationTimeout"] = 4408] = "ConnectionInitialisationTimeout";
        CloseCode[CloseCode["ConnectionAcknowledgementTimeout"] = 4504] = "ConnectionAcknowledgementTimeout";
        CloseCode[CloseCode["SubscriberAlreadyExists"] = 4409] = "SubscriberAlreadyExists";
        CloseCode[CloseCode["TooManyInitialisationRequests"] = 4429] = "TooManyInitialisationRequests";
    })($f60d5c8886e0651e$export$777128f41f6616ec || ($f60d5c8886e0651e$export$777128f41f6616ec = {}));
    var $f60d5c8886e0651e$export$80edbf15fa61a4db;
    (function(MessageType) {
        MessageType["ConnectionInit"] = "connection_init";
        MessageType["ConnectionAck"] = "connection_ack";
        MessageType["Ping"] = "ping";
        MessageType["Pong"] = "pong";
        MessageType["Subscribe"] = "subscribe";
        MessageType["Next"] = "next";
        MessageType["Error"] = "error";
        MessageType["Complete"] = "complete";
    })($f60d5c8886e0651e$export$80edbf15fa61a4db || ($f60d5c8886e0651e$export$80edbf15fa61a4db = {}));
    function $f60d5c8886e0651e$export$c17861b159b1b673(val) {
        if (!(0, (0, parcelRequire("7Tywk")).isObject)(val)) throw new Error(`Message is expected to be an object, but got ${(0, (0, parcelRequire("7Tywk")).extendedTypeof)(val)}`);
        if (!val.type) throw new Error(`Message is missing the 'type' property`);
        if (typeof val.type !== 'string') throw new Error(`Message is expects the 'type' property to be a string, but got ${(0, (0, parcelRequire("7Tywk")).extendedTypeof)(val.type)}`);
        switch(val.type){
            case $f60d5c8886e0651e$export$80edbf15fa61a4db.ConnectionInit:
            case $f60d5c8886e0651e$export$80edbf15fa61a4db.ConnectionAck:
            case $f60d5c8886e0651e$export$80edbf15fa61a4db.Ping:
            case $f60d5c8886e0651e$export$80edbf15fa61a4db.Pong:
                if (val.payload != null && !(0, (0, parcelRequire("7Tywk")).isObject)(val.payload)) throw new Error(`"${val.type}" message expects the 'payload' property to be an object or nullish or missing, but got "${val.payload}"`);
                break;
            case $f60d5c8886e0651e$export$80edbf15fa61a4db.Subscribe:
                if (typeof val.id !== 'string') throw new Error(`"${val.type}" message expects the 'id' property to be a string, but got ${(0, (0, parcelRequire("7Tywk")).extendedTypeof)(val.id)}`);
                if (!val.id) throw new Error(`"${val.type}" message requires a non-empty 'id' property`);
                if (!(0, (0, parcelRequire("7Tywk")).isObject)(val.payload)) throw new Error(`"${val.type}" message expects the 'payload' property to be an object, but got ${(0, (0, parcelRequire("7Tywk")).extendedTypeof)(val.payload)}`);
                if (typeof val.payload.query !== 'string') throw new Error(`"${val.type}" message payload expects the 'query' property to be a string, but got ${(0, (0, parcelRequire("7Tywk")).extendedTypeof)(val.payload.query)}`);
                if (val.payload.variables != null && !(0, (0, parcelRequire("7Tywk")).isObject)(val.payload.variables)) throw new Error(`"${val.type}" message payload expects the 'variables' property to be a an object or nullish or missing, but got ${(0, (0, parcelRequire("7Tywk")).extendedTypeof)(val.payload.variables)}`);
                if (val.payload.operationName != null && (0, (0, parcelRequire("7Tywk")).extendedTypeof)(val.payload.operationName) !== 'string') throw new Error(`"${val.type}" message payload expects the 'operationName' property to be a string or nullish or missing, but got ${(0, (0, parcelRequire("7Tywk")).extendedTypeof)(val.payload.operationName)}`);
                if (val.payload.extensions != null && !(0, (0, parcelRequire("7Tywk")).isObject)(val.payload.extensions)) throw new Error(`"${val.type}" message payload expects the 'extensions' property to be a an object or nullish or missing, but got ${(0, (0, parcelRequire("7Tywk")).extendedTypeof)(val.payload.extensions)}`);
                break;
            case $f60d5c8886e0651e$export$80edbf15fa61a4db.Next:
                if (typeof val.id !== 'string') throw new Error(`"${val.type}" message expects the 'id' property to be a string, but got ${(0, (0, parcelRequire("7Tywk")).extendedTypeof)(val.id)}`);
                if (!val.id) throw new Error(`"${val.type}" message requires a non-empty 'id' property`);
                if (!(0, (0, parcelRequire("7Tywk")).isObject)(val.payload)) throw new Error(`"${val.type}" message expects the 'payload' property to be an object, but got ${(0, (0, parcelRequire("7Tywk")).extendedTypeof)(val.payload)}`);
                break;
            case $f60d5c8886e0651e$export$80edbf15fa61a4db.Error:
                if (typeof val.id !== 'string') throw new Error(`"${val.type}" message expects the 'id' property to be a string, but got ${(0, (0, parcelRequire("7Tywk")).extendedTypeof)(val.id)}`);
                if (!val.id) throw new Error(`"${val.type}" message requires a non-empty 'id' property`);
                if (!(0, (0, parcelRequire("7Tywk")).areGraphQLErrors)(val.payload)) throw new Error(`"${val.type}" message expects the 'payload' property to be an array of GraphQL errors, but got ${JSON.stringify(val.payload)}`);
                break;
            case $f60d5c8886e0651e$export$80edbf15fa61a4db.Complete:
                if (typeof val.id !== 'string') throw new Error(`"${val.type}" message expects the 'id' property to be a string, but got ${(0, (0, parcelRequire("7Tywk")).extendedTypeof)(val.id)}`);
                if (!val.id) throw new Error(`"${val.type}" message requires a non-empty 'id' property`);
                break;
            default:
                throw new Error(`Invalid message 'type' property "${val.type}"`);
        }
        return val;
    }
    function $f60d5c8886e0651e$export$9e0e49e75fa7d548(val) {
        try {
            $f60d5c8886e0651e$export$c17861b159b1b673(val);
            return true;
        } catch (_a) {
            return false;
        }
    }
    function $f60d5c8886e0651e$export$f2f615077a189f21(data, reviver) {
        return $f60d5c8886e0651e$export$c17861b159b1b673(typeof data === 'string' ? JSON.parse(data, reviver) : data);
    }
    function $f60d5c8886e0651e$export$77896e5b47bfd50b(msg, replacer) {
        $f60d5c8886e0651e$export$c17861b159b1b673(msg);
        return JSON.stringify(msg, replacer);
    }
});
parcelRegister("7Tywk", function(module, exports) {
    $parcel$export(module.exports, "extendedTypeof", ()=>$5bf872794d14d281$export$573326049e1b1c6b);
    $parcel$export(module.exports, "isObject", ()=>$5bf872794d14d281$export$a6cdc56e425d0d0a);
    $parcel$export(module.exports, "areGraphQLErrors", ()=>$5bf872794d14d281$export$e6262fbc2e92290);
    $parcel$export(module.exports, "limitCloseReason", ()=>$5bf872794d14d281$export$2937fa0c8dddae54);
    function $5bf872794d14d281$export$573326049e1b1c6b(val) {
        if (val === null) return 'null';
        if (Array.isArray(val)) return 'array';
        return typeof val;
    }
    function $5bf872794d14d281$export$a6cdc56e425d0d0a(val) {
        return $5bf872794d14d281$export$573326049e1b1c6b(val) === 'object';
    }
    function $5bf872794d14d281$export$edb10ab8dd75a915(val) {
        return typeof Object(val)[Symbol.asyncIterator] === 'function';
    }
    function $5bf872794d14d281$export$92bd080471bc30f1(val) {
        return $5bf872794d14d281$export$a6cdc56e425d0d0a(val) && typeof Object(val)[Symbol.asyncIterator] === 'function' && typeof val.return === 'function';
    }
    function $5bf872794d14d281$export$e6262fbc2e92290(obj) {
        return Array.isArray(obj) && obj.length > 0 && obj.every((ob)=>'message' in ob);
    }
    function $5bf872794d14d281$export$2937fa0c8dddae54(reason, whenTooLong) {
        return reason.length < 124 ? reason : whenTooLong;
    }
});
parcelRegister("6LmWt", function(module, exports) {
    $parcel$export(module.exports, "getDefaultRelayEnvironmentConfig", ()=>$61f65a0ea311dd12$export$6c790f07f4ef6a59);
    var $eiowN = parcelRequire("eiowN");
    var $65GpI = parcelRequire("65GpI");
    var $iJZ8l;
    var $dj5to;
    var $3Z1I9;
    var $iExP6;
    const $61f65a0ea311dd12$var$createStore = (source, options)=>{
        (0, $eiowN.RelayFeatureFlags).ENABLE_RELAY_RESOLVERS = true;
        return new (0, ($parcel$interopDefault($65GpI)))(source, options);
    };
    const $61f65a0ea311dd12$export$6c790f07f4ef6a59 = ({ log: log, requiredFieldLogger: requiredFieldLogger, network: network })=>({
            configName: 'Atlassian Graphql Gateway',
            network: network || (0, (0, parcelRequire("3Z1I9")).network),
            store: $61f65a0ea311dd12$var$createStore(new (0, $eiowN.RecordSource)(), {
                log: log ?? undefined,
                getDataID: (0, (0, parcelRequire("iJZ8l")).default)
            }),
            log: log,
            requiredFieldLogger: requiredFieldLogger,
            relayFieldLogger: requiredFieldLogger,
            getDataID: (0, (0, parcelRequire("iJZ8l")).default),
            scheduler: (0, (0, parcelRequire("iExP6")).default),
            missingFieldHandlers: (0, (0, parcelRequire("dj5to")).default)
        });
});
parcelRegister("65GpI", function(module, exports) {
    'use strict';
    var $7gV6J = parcelRequire("7gV6J");
    var $46f41c2f1ec2be63$var$_interopRequireDefault = $7gV6J.default;
    var $46f41c2f1ec2be63$var$_createForOfIteratorHelper2 = $46f41c2f1ec2be63$var$_interopRequireDefault((parcelRequire("8utPl")));
    var $46f41c2f1ec2be63$var$_defineProperty2 = $46f41c2f1ec2be63$var$_interopRequireDefault((parcelRequire("2KFWS")));
    var $g6Qtb = parcelRequire("g6Qtb");
    var $46f41c2f1ec2be63$var$INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE = $g6Qtb.INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE, $46f41c2f1ec2be63$var$assertInternalActorIdentifier = $g6Qtb.assertInternalActorIdentifier;
    parcelRequire("259Mc");
    var $1zFTi = parcelRequire("1zFTi");
    var $h7JIX = parcelRequire("h7JIX");
    var $4FKGD = parcelRequire("4FKGD");
    var $jeujn = parcelRequire("jeujn");
    var $ja41X = parcelRequire("ja41X");
    var $9miei = parcelRequire("9miei");
    var $5DcbW = parcelRequire("5DcbW");
    var $hWkm3 = parcelRequire("hWkm3");
    var $dfBRB = parcelRequire("dfBRB");
    var $dfBRB = parcelRequire("dfBRB");
    var $46f41c2f1ec2be63$var$ROOT_ID = $dfBRB.ROOT_ID, $46f41c2f1ec2be63$var$ROOT_TYPE = $dfBRB.ROOT_TYPE;
    var $edMta = parcelRequire("edMta");
    var $46f41c2f1ec2be63$var$LiveResolverCache = $edMta.LiveResolverCache, $46f41c2f1ec2be63$var$RELAY_RESOLVER_LIVE_STATE_SUBSCRIPTION_KEY = $edMta.RELAY_RESOLVER_LIVE_STATE_SUBSCRIPTION_KEY, $46f41c2f1ec2be63$var$getUpdatedDataIDs = $edMta.getUpdatedDataIDs;
    var $aE1Lc = parcelRequire("aE1Lc");
    var $46f41c2f1ec2be63$var$DEFAULT_RELEASE_BUFFER_SIZE = 10;
    var $46f41c2f1ec2be63$var$LiveResolverStore = function() {
        function LiveResolverStore(source, options) {
            var _this = this;
            var _options$gcReleaseBuf, _options$gcScheduler, _options$getDataID, _options$log, _options$operationLoa, _options$treatMissing, _options$shouldProces;
            (0, $46f41c2f1ec2be63$var$_defineProperty2["default"])(this, "_gcStep", function() {
                if (_this._gcRun) {
                    if (_this._gcRun.next().done) _this._gcRun = null;
                    else _this._gcScheduler(_this._gcStep);
                }
            });
            var storeIDs, ii, record;
            this._currentWriteEpoch = 0;
            this._gcHoldCounter = 0;
            this._gcReleaseBufferSize = (_options$gcReleaseBuf = options === null || options === void 0 ? void 0 : options.gcReleaseBufferSize) !== null && _options$gcReleaseBuf !== void 0 ? _options$gcReleaseBuf : $46f41c2f1ec2be63$var$DEFAULT_RELEASE_BUFFER_SIZE;
            this._gcRun = null;
            this._gcScheduler = (_options$gcScheduler = options === null || options === void 0 ? void 0 : options.gcScheduler) !== null && _options$gcScheduler !== void 0 ? _options$gcScheduler : $1zFTi;
            this._getDataID = (_options$getDataID = options === null || options === void 0 ? void 0 : options.getDataID) !== null && _options$getDataID !== void 0 ? _options$getDataID : $4FKGD;
            this._globalInvalidationEpoch = null;
            this._invalidationSubscriptions = new Set();
            this._invalidatedRecordIDs = new Set();
            this.__log = (_options$log = options === null || options === void 0 ? void 0 : options.log) !== null && _options$log !== void 0 ? _options$log : null;
            this._queryCacheExpirationTime = options === null || options === void 0 ? void 0 : options.queryCacheExpirationTime;
            this._operationLoader = (_options$operationLoa = options === null || options === void 0 ? void 0 : options.operationLoader) !== null && _options$operationLoa !== void 0 ? _options$operationLoa : null;
            this._optimisticSource = null;
            this._recordSource = source;
            this._releaseBuffer = [];
            this._roots = new Map();
            this._shouldScheduleGC = false;
            this._resolverCache = new $46f41c2f1ec2be63$var$LiveResolverCache(function() {
                return _this._getMutableRecordSource();
            }, this);
            this._storeSubscriptions = new $hWkm3(options === null || options === void 0 ? void 0 : options.log, this._resolverCache);
            this._updatedRecordIDs = new Set();
            this._treatMissingFieldsAsNull = (_options$treatMissing = options === null || options === void 0 ? void 0 : options.treatMissingFieldsAsNull) !== null && _options$treatMissing !== void 0 ? _options$treatMissing : false;
            this._actorIdentifier = options === null || options === void 0 ? void 0 : options.actorIdentifier;
            this._shouldProcessClientComponents = (_options$shouldProces = options === null || options === void 0 ? void 0 : options.shouldProcessClientComponents) !== null && _options$shouldProces !== void 0 ? _options$shouldProces : false;
            $46f41c2f1ec2be63$var$initializeRecordSource(this._recordSource);
        }
        var _proto = LiveResolverStore.prototype;
        _proto.getSource = function getSource() {
            var _this$_optimisticSour;
            return (_this$_optimisticSour = this._optimisticSource) !== null && _this$_optimisticSour !== void 0 ? _this$_optimisticSour : this._recordSource;
        };
        _proto._getMutableRecordSource = function _getMutableRecordSource() {
            var _this$_optimisticSour2;
            return (_this$_optimisticSour2 = this._optimisticSource) !== null && _this$_optimisticSour2 !== void 0 ? _this$_optimisticSour2 : this._recordSource;
        };
        _proto.getLiveResolverPromise = function getLiveResolverPromise(recordID) {
            return this._resolverCache.getLiveResolverPromise(recordID);
        };
        _proto.batchLiveStateUpdates = function batchLiveStateUpdates(callback) {
            if (this.__log != null) this.__log({
                name: 'liveresolver.batch.start'
            });
            try {
                this._resolverCache.batchLiveStateUpdates(callback);
            } finally{
                if (this.__log != null) this.__log({
                    name: 'liveresolver.batch.end'
                });
            }
        };
        _proto.check = function check(operation, options) {
            var _options$handlers, _options$getSourceFor, _options$getTargetFor, _options$defaultActor;
            var selector = operation.root;
            var source = this._getMutableRecordSource();
            var globalInvalidationEpoch = this._globalInvalidationEpoch;
            var rootEntry = this._roots.get(operation.request.identifier);
            var operationLastWrittenAt = rootEntry != null ? rootEntry.epoch : null;
            if (globalInvalidationEpoch != null) {
                if (operationLastWrittenAt == null || operationLastWrittenAt <= globalInvalidationEpoch) return {
                    status: 'stale'
                };
            }
            var handlers = (_options$handlers = options === null || options === void 0 ? void 0 : options.handlers) !== null && _options$handlers !== void 0 ? _options$handlers : [];
            var getSourceForActor = (_options$getSourceFor = options === null || options === void 0 ? void 0 : options.getSourceForActor) !== null && _options$getSourceFor !== void 0 ? _options$getSourceFor : function(actorIdentifier) {
                $46f41c2f1ec2be63$var$assertInternalActorIdentifier(actorIdentifier);
                return source;
            };
            var getTargetForActor = (_options$getTargetFor = options === null || options === void 0 ? void 0 : options.getTargetForActor) !== null && _options$getTargetFor !== void 0 ? _options$getTargetFor : function(actorIdentifier) {
                $46f41c2f1ec2be63$var$assertInternalActorIdentifier(actorIdentifier);
                return source;
            };
            var operationAvailability = $h7JIX.check(getSourceForActor, getTargetForActor, (_options$defaultActor = options === null || options === void 0 ? void 0 : options.defaultActorIdentifier) !== null && _options$defaultActor !== void 0 ? _options$defaultActor : $46f41c2f1ec2be63$var$INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE, selector, handlers, this._operationLoader, this._getDataID, this._shouldProcessClientComponents);
            return $46f41c2f1ec2be63$var$getAvailabilityStatus(operationAvailability, operationLastWrittenAt, rootEntry === null || rootEntry === void 0 ? void 0 : rootEntry.fetchTime, this._queryCacheExpirationTime);
        };
        _proto.retain = function retain(operation) {
            var _this2 = this;
            var id = operation.request.identifier;
            var disposed = false;
            var dispose = function dispose() {
                if (disposed) return;
                disposed = true;
                var rootEntry = _this2._roots.get(id);
                if (rootEntry == null) return;
                rootEntry.refCount--;
                if (rootEntry.refCount === 0) {
                    var _queryCacheExpirationTime = _this2._queryCacheExpirationTime;
                    var rootEntryIsStale = rootEntry.fetchTime != null && _queryCacheExpirationTime != null && rootEntry.fetchTime <= Date.now() - _queryCacheExpirationTime;
                    if (rootEntryIsStale) {
                        _this2._roots["delete"](id);
                        _this2.scheduleGC();
                    } else {
                        _this2._releaseBuffer.push(id);
                        if (_this2._releaseBuffer.length > _this2._gcReleaseBufferSize) {
                            var _id = _this2._releaseBuffer.shift();
                            _this2._roots["delete"](_id);
                            _this2.scheduleGC();
                        }
                    }
                }
            };
            var rootEntry = this._roots.get(id);
            if (rootEntry != null) {
                if (rootEntry.refCount === 0) this._releaseBuffer = this._releaseBuffer.filter(function(_id) {
                    return _id !== id;
                });
                rootEntry.refCount += 1;
            } else this._roots.set(id, {
                operation: operation,
                refCount: 1,
                epoch: null,
                fetchTime: null
            });
            return {
                dispose: dispose
            };
        };
        _proto.lookup = function lookup(selector) {
            var source = this.getSource();
            var snapshot = $9miei.read(source, selector, this._resolverCache);
            return snapshot;
        };
        _proto.notify = function notify(sourceOperation, invalidateStore) {
            var _this3 = this;
            var log = this.__log;
            if (log != null) log({
                name: 'store.notify.start',
                sourceOperation: sourceOperation
            });
            this._currentWriteEpoch++;
            if (invalidateStore === true) this._globalInvalidationEpoch = this._currentWriteEpoch;
            this._resolverCache.invalidateDataIDs(this._updatedRecordIDs);
            var source = this.getSource();
            var updatedOwners = [];
            this._storeSubscriptions.updateSubscriptions(source, this._updatedRecordIDs, updatedOwners, sourceOperation);
            this._invalidationSubscriptions.forEach(function(subscription) {
                _this3._updateInvalidationSubscription(subscription, invalidateStore === true);
            });
            if (log != null) log({
                name: 'store.notify.complete',
                sourceOperation: sourceOperation,
                updatedRecordIDs: this._updatedRecordIDs,
                invalidatedRecordIDs: this._invalidatedRecordIDs
            });
            this._updatedRecordIDs.clear();
            this._invalidatedRecordIDs.clear();
            if (sourceOperation != null) {
                var id = sourceOperation.request.identifier;
                var rootEntry = this._roots.get(id);
                if (rootEntry != null) {
                    rootEntry.epoch = this._currentWriteEpoch;
                    rootEntry.fetchTime = Date.now();
                } else if (sourceOperation.request.node.params.operationKind === 'query' && this._gcReleaseBufferSize > 0 && this._releaseBuffer.length < this._gcReleaseBufferSize) {
                    var temporaryRootEntry = {
                        operation: sourceOperation,
                        refCount: 0,
                        epoch: this._currentWriteEpoch,
                        fetchTime: Date.now()
                    };
                    this._releaseBuffer.push(id);
                    this._roots.set(id, temporaryRootEntry);
                }
            }
            return updatedOwners;
        };
        _proto.publish = function publish(source, idsMarkedForInvalidation) {
            var target = this._getMutableRecordSource();
            $46f41c2f1ec2be63$var$updateTargetFromSource(target, source, this._currentWriteEpoch + 1, idsMarkedForInvalidation, this._updatedRecordIDs, this._invalidatedRecordIDs);
            var log = this.__log;
            if (log != null) log({
                name: 'store.publish',
                source: source,
                optimistic: target === this._optimisticSource
            });
        };
        _proto.subscribe = function subscribe(snapshot, callback) {
            return this._storeSubscriptions.subscribe(snapshot, callback);
        };
        _proto.holdGC = function holdGC() {
            var _this4 = this;
            if (this._gcRun) {
                this._gcRun = null;
                this._shouldScheduleGC = true;
            }
            this._gcHoldCounter++;
            var dispose = function dispose() {
                if (_this4._gcHoldCounter > 0) {
                    _this4._gcHoldCounter--;
                    if (_this4._gcHoldCounter === 0 && _this4._shouldScheduleGC) {
                        _this4.scheduleGC();
                        _this4._shouldScheduleGC = false;
                    }
                }
            };
            return {
                dispose: dispose
            };
        };
        _proto.toJSON = function toJSON() {
            return 'LiveResolverStore()';
        };
        _proto.getEpoch = function getEpoch() {
            return this._currentWriteEpoch;
        };
        _proto.__getUpdatedRecordIDs = function __getUpdatedRecordIDs() {
            return this._updatedRecordIDs;
        };
        _proto.lookupInvalidationState = function lookupInvalidationState(dataIDs) {
            var _this5 = this;
            var invalidations = new Map();
            dataIDs.forEach(function(dataID) {
                var _RelayModernRecord$ge;
                var record = _this5.getSource().get(dataID);
                invalidations.set(dataID, (_RelayModernRecord$ge = $jeujn.getInvalidationEpoch(record)) !== null && _RelayModernRecord$ge !== void 0 ? _RelayModernRecord$ge : null);
            });
            invalidations.set('global', this._globalInvalidationEpoch);
            var invalidationState = {
                dataIDs: dataIDs,
                invalidations: invalidations
            };
            return invalidationState;
        };
        _proto.checkInvalidationState = function checkInvalidationState(prevInvalidationState) {
            var latestInvalidationState = this.lookupInvalidationState(prevInvalidationState.dataIDs);
            var currentInvalidations = latestInvalidationState.invalidations;
            var prevInvalidations = prevInvalidationState.invalidations;
            if (currentInvalidations.get('global') !== prevInvalidations.get('global')) return true;
            var _iterator = (0, $46f41c2f1ec2be63$var$_createForOfIteratorHelper2["default"])(prevInvalidationState.dataIDs), _step;
            try {
                for(_iterator.s(); !(_step = _iterator.n()).done;){
                    var dataID = _step.value;
                    if (currentInvalidations.get(dataID) !== prevInvalidations.get(dataID)) return true;
                }
            } catch (err) {
                _iterator.e(err);
            } finally{
                _iterator.f();
            }
            return false;
        };
        _proto.subscribeToInvalidationState = function subscribeToInvalidationState(invalidationState, callback) {
            var _this6 = this;
            var subscription = {
                callback: callback,
                invalidationState: invalidationState
            };
            var dispose = function dispose() {
                _this6._invalidationSubscriptions["delete"](subscription);
            };
            this._invalidationSubscriptions.add(subscription);
            return {
                dispose: dispose
            };
        };
        _proto._updateInvalidationSubscription = function _updateInvalidationSubscription(subscription, invalidatedStore) {
            var _this7 = this;
            var callback = subscription.callback, invalidationState = subscription.invalidationState;
            var dataIDs = invalidationState.dataIDs;
            var isSubscribedToInvalidatedIDs = invalidatedStore || dataIDs.some(function(dataID) {
                return _this7._invalidatedRecordIDs.has(dataID);
            });
            if (!isSubscribedToInvalidatedIDs) return;
            callback();
        };
        _proto.snapshot = function snapshot() {
            !(this._optimisticSource == null) && $aE1Lc(false);
            var log = this.__log;
            if (log != null) log({
                name: 'store.snapshot'
            });
            this._storeSubscriptions.snapshotSubscriptions(this.getSource());
            if (this._gcRun) {
                this._gcRun = null;
                this._shouldScheduleGC = true;
            }
            this._optimisticSource = $ja41X.create(this.getSource());
        };
        _proto.restore = function restore() {
            var optimisticSource = this._optimisticSource;
            !optimisticSource && $aE1Lc(false);
            var log = this.__log;
            if (log != null) log({
                name: 'store.restore'
            });
            var optimisticIDs = $ja41X.getOptimisticRecordIDs(optimisticSource);
            this._resolverCache.unsubscribeFromLiveResolverRecords(optimisticIDs);
            this._optimisticSource = null;
            if (this._shouldScheduleGC) this.scheduleGC();
            this._storeSubscriptions.restoreSubscriptions();
            this._resolverCache.invalidateResolverRecords(optimisticIDs);
        };
        _proto.scheduleGC = function scheduleGC() {
            if (this._gcHoldCounter > 0) {
                this._shouldScheduleGC = true;
                return;
            }
            if (this._gcRun) return;
            this._gcRun = this._collect();
            this._gcScheduler(this._gcStep);
        };
        _proto.__gc = function __gc() {
            if (this._optimisticSource != null) return;
            var gcRun = this._collect();
            while(!gcRun.next().done);
        };
        _proto._collect = function* _collect() {
            top: while(true){
                var startEpoch = this._currentWriteEpoch;
                var references = new Set();
                var _iterator2 = (0, $46f41c2f1ec2be63$var$_createForOfIteratorHelper2["default"])(this._roots.values()), _step2;
                try {
                    for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                        var operation = _step2.value.operation;
                        var selector = operation.root;
                        $5DcbW.mark(this._recordSource, selector, references, this._operationLoader, this._shouldProcessClientComponents);
                        yield;
                        if (startEpoch !== this._currentWriteEpoch) continue top;
                    }
                } catch (err) {
                    _iterator2.e(err);
                } finally{
                    _iterator2.f();
                }
                var log = this.__log;
                if (log != null) log({
                    name: 'store.gc',
                    references: references
                });
                if (references.size === 0) this._recordSource.clear();
                else {
                    var storeIDs = this._recordSource.getRecordIDs();
                    for(var ii = 0; ii < storeIDs.length; ii++){
                        var dataID = storeIDs[ii];
                        if (!references.has(dataID)) {
                            var record = this._recordSource.get(dataID);
                            if (record != null) {
                                var maybeResolverSubscription = $jeujn.getValue(record, $46f41c2f1ec2be63$var$RELAY_RESOLVER_LIVE_STATE_SUBSCRIPTION_KEY);
                                if (maybeResolverSubscription != null) maybeResolverSubscription();
                            }
                            this._recordSource.remove(dataID);
                        }
                    }
                }
                return;
            }
        };
        _proto.__getNormalizationOptions = function __getNormalizationOptions(path) {
            return {
                path: path,
                getDataID: this._getDataID,
                treatMissingFieldsAsNull: this._treatMissingFieldsAsNull,
                shouldProcessClientComponents: this._shouldProcessClientComponents,
                actorIdentifier: this._actorIdentifier
            };
        };
        _proto.__notifyUpdatedSubscribers = function __notifyUpdatedSubscribers(updatedRecords) {
            var nextUpdatedRecordIDs = $46f41c2f1ec2be63$var$getUpdatedDataIDs(updatedRecords);
            var prevUpdatedRecordIDs = this._updatedRecordIDs;
            this._updatedRecordIDs = nextUpdatedRecordIDs;
            this.notify();
            this._updatedRecordIDs = prevUpdatedRecordIDs;
        };
        return LiveResolverStore;
    }();
    function $46f41c2f1ec2be63$var$initializeRecordSource(target) {
        if (!target.has($46f41c2f1ec2be63$var$ROOT_ID)) {
            var rootRecord = $jeujn.create($46f41c2f1ec2be63$var$ROOT_ID, $46f41c2f1ec2be63$var$ROOT_TYPE);
            target.set($46f41c2f1ec2be63$var$ROOT_ID, rootRecord);
        }
    }
    function $46f41c2f1ec2be63$var$updateTargetFromSource(target, source, currentWriteEpoch, idsMarkedForInvalidation, updatedRecordIDs, invalidatedRecordIDs) {
        if (idsMarkedForInvalidation) idsMarkedForInvalidation.forEach(function(dataID) {
            var targetRecord = target.get(dataID);
            var sourceRecord = source.get(dataID);
            if (sourceRecord === null) return;
            var nextRecord;
            if (targetRecord != null) nextRecord = $jeujn.clone(targetRecord);
            else nextRecord = sourceRecord != null ? $jeujn.clone(sourceRecord) : null;
            if (!nextRecord) return;
            $jeujn.setValue(nextRecord, $dfBRB.INVALIDATED_AT_KEY, currentWriteEpoch);
            invalidatedRecordIDs.add(dataID);
            target.set(dataID, nextRecord);
        });
        var dataIDs = source.getRecordIDs();
        for(var ii = 0; ii < dataIDs.length; ii++){
            var dataID = dataIDs[ii];
            var sourceRecord = source.get(dataID);
            var targetRecord = target.get(dataID);
            if (sourceRecord && targetRecord) {
                var nextRecord = $jeujn.update(targetRecord, sourceRecord);
                if (nextRecord !== targetRecord) {
                    updatedRecordIDs.add(dataID);
                    target.set(dataID, nextRecord);
                }
            } else if (sourceRecord === null) {
                target["delete"](dataID);
                if (targetRecord !== null) updatedRecordIDs.add(dataID);
            } else if (sourceRecord) {
                target.set(dataID, sourceRecord);
                updatedRecordIDs.add(dataID);
            }
        }
    }
    function $46f41c2f1ec2be63$var$getAvailabilityStatus(operationAvailability, operationLastWrittenAt, operationFetchTime, queryCacheExpirationTime) {
        var mostRecentlyInvalidatedAt = operationAvailability.mostRecentlyInvalidatedAt, status = operationAvailability.status;
        if (typeof mostRecentlyInvalidatedAt === 'number') {
            if (operationLastWrittenAt == null || mostRecentlyInvalidatedAt > operationLastWrittenAt) return {
                status: 'stale'
            };
        }
        if (status === 'missing') return {
            status: 'missing'
        };
        if (operationFetchTime != null && queryCacheExpirationTime != null) {
            var isStale = operationFetchTime <= Date.now() - queryCacheExpirationTime;
            if (isStale) return {
                status: 'stale'
            };
        }
        return {
            status: 'available',
            fetchTime: operationFetchTime !== null && operationFetchTime !== void 0 ? operationFetchTime : null
        };
    }
    module.exports = $46f41c2f1ec2be63$var$LiveResolverStore;
});
parcelRegister("edMta", function(module, exports) {
    'use strict';
    var $7gV6J = parcelRequire("7gV6J");
    var $a5a7e09f792afd36$var$_interopRequireDefault = $7gV6J.default;
    var $a5a7e09f792afd36$var$_createForOfIteratorHelper2 = $a5a7e09f792afd36$var$_interopRequireDefault((parcelRequire("8utPl")));
    var $b2CqU = parcelRequire("b2CqU");
    var $7AO8k = parcelRequire("7AO8k");
    var $a5a7e09f792afd36$var$RELAY_LIVE_RESOLVER = $7AO8k.RELAY_LIVE_RESOLVER;
    var $brVAm = parcelRequire("brVAm");
    var $dFCzs = parcelRequire("dFCzs");
    var $dgkLD = parcelRequire("dgkLD");
    var $a5a7e09f792afd36$var$generateClientID = $dgkLD.generateClientID, $a5a7e09f792afd36$var$generateClientObjectClientID = $dgkLD.generateClientObjectClientID;
    var $jeujn = parcelRequire("jeujn");
    var $hqAuM = parcelRequire("hqAuM");
    var $a5a7e09f792afd36$var$createNormalizationSelector = $hqAuM.createNormalizationSelector;
    var $67IX0 = parcelRequire("67IX0");
    var $ggNiN = parcelRequire("ggNiN");
    var $a5a7e09f792afd36$var$normalize = $ggNiN.normalize;
    var $dfBRB = parcelRequire("dfBRB");
    var $a5a7e09f792afd36$var$RELAY_RESOLVER_ERROR_KEY = $dfBRB.RELAY_RESOLVER_ERROR_KEY, $a5a7e09f792afd36$var$RELAY_RESOLVER_INVALIDATION_KEY = $dfBRB.RELAY_RESOLVER_INVALIDATION_KEY, $a5a7e09f792afd36$var$RELAY_RESOLVER_OUTPUT_TYPE_RECORD_IDS = $dfBRB.RELAY_RESOLVER_OUTPUT_TYPE_RECORD_IDS, $a5a7e09f792afd36$var$RELAY_RESOLVER_SNAPSHOT_KEY = $dfBRB.RELAY_RESOLVER_SNAPSHOT_KEY, $a5a7e09f792afd36$var$RELAY_RESOLVER_VALUE_KEY = $dfBRB.RELAY_RESOLVER_VALUE_KEY, $a5a7e09f792afd36$var$getStorageKey = $dfBRB.getStorageKey;
    var $24A8O = parcelRequire("24A8O");
    var $1ct6Z = parcelRequire("1ct6Z");
    var $9a00R = parcelRequire("9a00R");
    var $a5a7e09f792afd36$var$isSuspenseSentinel = $9a00R.isSuspenseSentinel;
    var $aE1Lc = parcelRequire("aE1Lc");
    parcelRequire("1srSR");
    var $a5a7e09f792afd36$var$RELAY_RESOLVER_LIVE_STATE_SUBSCRIPTION_KEY = '__resolverLiveStateSubscription';
    var $a5a7e09f792afd36$var$RELAY_RESOLVER_LIVE_STATE_VALUE = '__resolverLiveStateValue';
    var $a5a7e09f792afd36$var$RELAY_RESOLVER_LIVE_STATE_DIRTY = '__resolverLiveStateDirty';
    var $a5a7e09f792afd36$var$RELAY_RESOLVER_RECORD_TYPENAME = '__RELAY_RESOLVER__';
    var $a5a7e09f792afd36$var$MODEL_PROPERTY_NAME = '__relay_model_instance';
    function $a5a7e09f792afd36$var$addDependencyEdge(edges, from, to) {
        var set = edges.get(from);
        if (!set) {
            set = new Set();
            edges.set(from, set);
        }
        set.add(to);
    }
    var $a5a7e09f792afd36$var$LiveResolverCache = function() {
        function LiveResolverCache(getRecordSource, store) {
            this._resolverIDToRecordIDs = new Map();
            this._recordIDToResolverIDs = new Map();
            this._getRecordSource = getRecordSource;
            this._store = store;
            this._handlingBatch = false;
            this._liveResolverBatchRecordSource = null;
        }
        var _proto = LiveResolverCache.prototype;
        _proto.readFromCacheOrEvaluate = function readFromCacheOrEvaluate(recordID, field, variables, evaluate, getDataForResolverFragment) {
            var recordSource = this._getRecordSource();
            var record = $a5a7e09f792afd36$var$expectRecord(recordSource, recordID);
            var storageKey = $a5a7e09f792afd36$var$getStorageKey(field, variables);
            var linkedID = $jeujn.getLinkedRecordID(record, storageKey);
            var linkedRecord = linkedID == null ? null : recordSource.get(linkedID);
            var updatedDataIDs;
            if (linkedRecord == null || this._isInvalid(linkedRecord, getDataForResolverFragment)) {
                var _linkedID;
                if (linkedRecord != null) $a5a7e09f792afd36$var$maybeUnsubscribeFromLiveState(linkedRecord);
                linkedID = (_linkedID = linkedID) !== null && _linkedID !== void 0 ? _linkedID : $a5a7e09f792afd36$var$generateClientID(recordID, storageKey);
                linkedRecord = $jeujn.create(linkedID, $a5a7e09f792afd36$var$RELAY_RESOLVER_RECORD_TYPENAME);
                var evaluationResult = evaluate();
                $jeujn.setValue(linkedRecord, $a5a7e09f792afd36$var$RELAY_RESOLVER_SNAPSHOT_KEY, evaluationResult.snapshot);
                $jeujn.setValue(linkedRecord, $a5a7e09f792afd36$var$RELAY_RESOLVER_ERROR_KEY, evaluationResult.error);
                if (field.kind === $a5a7e09f792afd36$var$RELAY_LIVE_RESOLVER) {
                    if (evaluationResult.resolverResult != null) {
                        !(evaluationResult.error == null) && $aE1Lc(false);
                        var liveState = evaluationResult.resolverResult;
                        updatedDataIDs = this._setLiveStateValue(linkedRecord, linkedID, liveState, field, variables);
                    } else var _evaluationResult$sna;
                } else updatedDataIDs = this._setResolverValue(linkedRecord, evaluationResult.resolverResult, field, variables);
                recordSource.set(linkedID, linkedRecord);
                var currentRecord = $a5a7e09f792afd36$var$expectRecord(recordSource, recordID);
                var nextRecord = $jeujn.clone(currentRecord);
                $jeujn.setLinkedRecordID(nextRecord, storageKey, linkedID);
                recordSource.set(recordID, nextRecord);
                if (field.fragment != null) {
                    var _evaluationResult$sna2;
                    var fragmentStorageKey = $a5a7e09f792afd36$var$getStorageKey(field.fragment, variables);
                    var resolverID = $a5a7e09f792afd36$var$generateClientID(recordID, fragmentStorageKey);
                    $a5a7e09f792afd36$var$addDependencyEdge(this._resolverIDToRecordIDs, resolverID, linkedID);
                    $a5a7e09f792afd36$var$addDependencyEdge(this._recordIDToResolverIDs, recordID, resolverID);
                    var seenRecordIds = (_evaluationResult$sna2 = evaluationResult.snapshot) === null || _evaluationResult$sna2 === void 0 ? void 0 : _evaluationResult$sna2.seenRecords;
                    if (seenRecordIds != null) {
                        var _iterator = (0, $a5a7e09f792afd36$var$_createForOfIteratorHelper2["default"])(seenRecordIds), _step;
                        try {
                            for(_iterator.s(); !(_step = _iterator.n()).done;){
                                var seenRecordID = _step.value;
                                $a5a7e09f792afd36$var$addDependencyEdge(this._recordIDToResolverIDs, seenRecordID, resolverID);
                            }
                        } catch (err) {
                            _iterator.e(err);
                        } finally{
                            _iterator.f();
                        }
                    }
                }
            } else if (field.kind === $a5a7e09f792afd36$var$RELAY_LIVE_RESOLVER && $jeujn.getValue(linkedRecord, $a5a7e09f792afd36$var$RELAY_RESOLVER_LIVE_STATE_DIRTY)) {
                var _linkedID2;
                linkedID = (_linkedID2 = linkedID) !== null && _linkedID2 !== void 0 ? _linkedID2 : $a5a7e09f792afd36$var$generateClientID(recordID, storageKey);
                linkedRecord = $jeujn.clone(linkedRecord);
                var _liveState = $jeujn.getValue(linkedRecord, $a5a7e09f792afd36$var$RELAY_RESOLVER_LIVE_STATE_VALUE);
                if (!$1ct6Z(_liveState)) $aE1Lc(false);
                updatedDataIDs = this._setLiveResolverValue(linkedRecord, _liveState, field, variables);
                $jeujn.setValue(linkedRecord, $a5a7e09f792afd36$var$RELAY_RESOLVER_LIVE_STATE_DIRTY, false);
                recordSource.set(linkedID, linkedRecord);
            }
            var answer = this._getResolverValue(linkedRecord);
            var snapshot = $jeujn.getValue(linkedRecord, $a5a7e09f792afd36$var$RELAY_RESOLVER_SNAPSHOT_KEY);
            var error = $jeujn.getValue(linkedRecord, $a5a7e09f792afd36$var$RELAY_RESOLVER_ERROR_KEY);
            var suspenseID = null;
            if ($a5a7e09f792afd36$var$isSuspenseSentinel(answer)) {
                var _linkedID3;
                suspenseID = (_linkedID3 = linkedID) !== null && _linkedID3 !== void 0 ? _linkedID3 : $a5a7e09f792afd36$var$generateClientID(recordID, storageKey);
            }
            return [
                answer,
                linkedID,
                error,
                snapshot,
                suspenseID,
                updatedDataIDs
            ];
        };
        _proto.getLiveResolverPromise = function getLiveResolverPromise(liveStateID) {
            var recordSource = this._getRecordSource();
            var liveStateRecord = recordSource.get(liveStateID);
            !(liveStateRecord != null) && $aE1Lc(false);
            var liveState = $jeujn.getValue(liveStateRecord, $a5a7e09f792afd36$var$RELAY_RESOLVER_LIVE_STATE_VALUE);
            return new Promise(function(resolve) {
                var unsubscribe = liveState.subscribe(function() {
                    unsubscribe();
                    resolve();
                });
            });
        };
        _proto._setLiveStateValue = function _setLiveStateValue(linkedRecord, linkedID, liveState, field, variables) {
            var handler = this._makeLiveStateHandler(linkedID);
            var unsubscribe = liveState.subscribe(handler);
            $jeujn.setValue(linkedRecord, $a5a7e09f792afd36$var$RELAY_RESOLVER_LIVE_STATE_VALUE, liveState);
            var updatedDataIDs = this._setLiveResolverValue(linkedRecord, liveState, field, variables);
            $jeujn.setValue(linkedRecord, $a5a7e09f792afd36$var$RELAY_RESOLVER_LIVE_STATE_DIRTY, false);
            $jeujn.setValue(linkedRecord, $a5a7e09f792afd36$var$RELAY_RESOLVER_LIVE_STATE_SUBSCRIPTION_KEY, unsubscribe);
            return updatedDataIDs;
        };
        _proto._makeLiveStateHandler = function _makeLiveStateHandler(linkedID) {
            var _this = this;
            return function() {
                var currentSource = _this._getRecordSource();
                var currentRecord = currentSource.get(linkedID);
                if (!currentRecord) return;
                if (!$jeujn.hasValue(currentRecord, $a5a7e09f792afd36$var$RELAY_RESOLVER_LIVE_STATE_VALUE)) return;
                var nextRecord = $jeujn.clone(currentRecord);
                $jeujn.setValue(nextRecord, $a5a7e09f792afd36$var$RELAY_RESOLVER_LIVE_STATE_DIRTY, true);
                _this._setLiveResolverUpdate(linkedID, nextRecord);
            };
        };
        _proto._setLiveResolverUpdate = function _setLiveResolverUpdate(linkedId, record) {
            if (this._handlingBatch) {
                if (this._liveResolverBatchRecordSource == null) this._liveResolverBatchRecordSource = $67IX0.create();
                this._liveResolverBatchRecordSource.set(linkedId, record);
            } else {
                var nextSource = $67IX0.create();
                nextSource.set(linkedId, record);
                this._store.publish(nextSource);
                this._store.notify();
            }
        };
        _proto.batchLiveStateUpdates = function batchLiveStateUpdates(callback) {
            !!this._handlingBatch && $aE1Lc(false);
            this._handlingBatch = true;
            try {
                callback();
            } finally{
                if (this._liveResolverBatchRecordSource != null) {
                    this._store.publish(this._liveResolverBatchRecordSource);
                    this._store.notify();
                }
                this._liveResolverBatchRecordSource = null;
                this._handlingBatch = false;
            }
        };
        _proto._setLiveResolverValue = function _setLiveResolverValue(resolverRecord, liveValue, field, variables) {
            var value = null;
            var resolverError = null;
            try {
                value = liveValue.read();
            } catch (e) {
                resolverError = e;
            }
            $jeujn.setValue(resolverRecord, $a5a7e09f792afd36$var$RELAY_RESOLVER_ERROR_KEY, resolverError);
            return this._setResolverValue(resolverRecord, value, field, variables);
        };
        _proto._setResolverValue = function _setResolverValue(resolverRecord, value, field, variables) {
            var normalizationInfo = field.normalizationInfo;
            var updatedDataIDs = null;
            if (value != null && normalizationInfo != null && !$a5a7e09f792afd36$var$isSuspenseSentinel(value)) {
                var resolverValue;
                var prevOutputTypeRecordIDs = $24A8O(resolverRecord);
                var nextOutputTypeRecordIDs = new Set();
                var currentSource = this._getRecordSource();
                if (normalizationInfo.plural) {
                    !Array.isArray(value) && $aE1Lc(false);
                    resolverValue = [];
                    var nextSource = $67IX0.create();
                    for(var ii = 0; ii < value.length; ii++){
                        var currentValue = value[ii];
                        if (currentValue == null) continue;
                        !(typeof currentValue === 'object') && $aE1Lc(false);
                        var typename = $a5a7e09f792afd36$var$getConcreteTypename(normalizationInfo, currentValue);
                        var outputTypeDataID = $a5a7e09f792afd36$var$generateClientObjectClientID(typename, $jeujn.getDataID(resolverRecord), ii);
                        var source = this._normalizeOutputTypeValue(outputTypeDataID, currentValue, variables, normalizationInfo, [
                            field.path,
                            String(ii)
                        ], typename);
                        var _iterator2 = (0, $a5a7e09f792afd36$var$_createForOfIteratorHelper2["default"])(source.getRecordIDs()), _step2;
                        try {
                            for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                                var recordID = _step2.value;
                                nextSource.set(recordID, $a5a7e09f792afd36$var$expectRecord(source, recordID));
                                nextOutputTypeRecordIDs.add(recordID);
                            }
                        } catch (err) {
                            _iterator2.e(err);
                        } finally{
                            _iterator2.f();
                        }
                        resolverValue.push(outputTypeDataID);
                    }
                    updatedDataIDs = $a5a7e09f792afd36$var$updateCurrentSource(currentSource, nextSource, prevOutputTypeRecordIDs);
                } else {
                    !(typeof value === 'object') && $aE1Lc(false);
                    var _typename = $a5a7e09f792afd36$var$getConcreteTypename(normalizationInfo, value);
                    var _outputTypeDataID = $a5a7e09f792afd36$var$generateClientObjectClientID(_typename, $jeujn.getDataID(resolverRecord));
                    var _nextSource = this._normalizeOutputTypeValue(_outputTypeDataID, value, variables, normalizationInfo, [
                        field.path
                    ], _typename);
                    var _iterator3 = (0, $a5a7e09f792afd36$var$_createForOfIteratorHelper2["default"])(_nextSource.getRecordIDs()), _step3;
                    try {
                        for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                            var _recordID = _step3.value;
                            nextOutputTypeRecordIDs.add(_recordID);
                        }
                    } catch (err) {
                        _iterator3.e(err);
                    } finally{
                        _iterator3.f();
                    }
                    resolverValue = _outputTypeDataID;
                    updatedDataIDs = $a5a7e09f792afd36$var$updateCurrentSource(currentSource, _nextSource, prevOutputTypeRecordIDs);
                }
                $jeujn.setValue(resolverRecord, $a5a7e09f792afd36$var$RELAY_RESOLVER_OUTPUT_TYPE_RECORD_IDS, nextOutputTypeRecordIDs);
                $dFCzs(resolverValue);
                $jeujn.setValue(resolverRecord, $a5a7e09f792afd36$var$RELAY_RESOLVER_VALUE_KEY, resolverValue);
            } else {
                $dFCzs(value);
                $jeujn.setValue(resolverRecord, $a5a7e09f792afd36$var$RELAY_RESOLVER_VALUE_KEY, value);
            }
            return updatedDataIDs;
        };
        _proto.notifyUpdatedSubscribers = function notifyUpdatedSubscribers(updatedDataIDs) {
            this._store.__notifyUpdatedSubscribers(updatedDataIDs);
        };
        _proto._getResolverValue = function _getResolverValue(resolverRecord) {
            return $jeujn.getValue(resolverRecord, $a5a7e09f792afd36$var$RELAY_RESOLVER_VALUE_KEY);
        };
        _proto.invalidateDataIDs = function invalidateDataIDs(updatedDataIDs) {
            var recordSource = this._getRecordSource();
            var visited = new Set();
            var recordsToVisit = Array.from(updatedDataIDs);
            while(recordsToVisit.length){
                var recordID = recordsToVisit.pop();
                updatedDataIDs.add(recordID);
                var fragmentSet = this._recordIDToResolverIDs.get(recordID);
                if (fragmentSet == null) continue;
                var _iterator4 = (0, $a5a7e09f792afd36$var$_createForOfIteratorHelper2["default"])(fragmentSet), _step4;
                try {
                    for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
                        var fragment = _step4.value;
                        if (!visited.has(fragment)) {
                            var recordSet = this._resolverIDToRecordIDs.get(fragment);
                            if (recordSet == null) continue;
                            var _iterator5 = (0, $a5a7e09f792afd36$var$_createForOfIteratorHelper2["default"])(recordSet), _step5;
                            try {
                                for(_iterator5.s(); !(_step5 = _iterator5.n()).done;){
                                    var anotherRecordID = _step5.value;
                                    $a5a7e09f792afd36$var$markInvalidatedResolverRecord(anotherRecordID, recordSource);
                                    if (!visited.has(anotherRecordID)) recordsToVisit.push(anotherRecordID);
                                }
                            } catch (err) {
                                _iterator5.e(err);
                            } finally{
                                _iterator5.f();
                            }
                        }
                    }
                } catch (err) {
                    _iterator4.e(err);
                } finally{
                    _iterator4.f();
                }
            }
        };
        _proto._isInvalid = function _isInvalid(record, getDataForResolverFragment) {
            if (!$jeujn.getValue(record, $a5a7e09f792afd36$var$RELAY_RESOLVER_INVALIDATION_KEY)) return false;
            var snapshot = $jeujn.getValue(record, $a5a7e09f792afd36$var$RELAY_RESOLVER_SNAPSHOT_KEY);
            var originalInputs = snapshot === null || snapshot === void 0 ? void 0 : snapshot.data;
            var readerSelector = snapshot === null || snapshot === void 0 ? void 0 : snapshot.selector;
            if (originalInputs == null || readerSelector == null) return true;
            var _getDataForResolverFr = getDataForResolverFragment(readerSelector), latestValues = _getDataForResolverFr.data;
            var recycled = $b2CqU(originalInputs, latestValues);
            if (recycled !== originalInputs) return true;
            if ($brVAm.MARK_RESOLVER_VALUES_AS_CLEAN_AFTER_FRAGMENT_REREAD) {
                var nextRecord = $jeujn.clone(record);
                $jeujn.setValue(nextRecord, $a5a7e09f792afd36$var$RELAY_RESOLVER_INVALIDATION_KEY, false);
                var recordSource = this._getRecordSource();
                recordSource.set($jeujn.getDataID(record), nextRecord);
            }
            return false;
        };
        _proto._normalizeOutputTypeValue = function _normalizeOutputTypeValue(outputTypeDataID, value, variables, normalizationInfo, fieldPath, typename) {
            var source = $67IX0.create();
            switch(normalizationInfo.kind){
                case 'OutputType':
                    var record = $jeujn.create(outputTypeDataID, typename);
                    source.set(outputTypeDataID, record);
                    var selector = $a5a7e09f792afd36$var$createNormalizationSelector(normalizationInfo.normalizationNode, outputTypeDataID, variables);
                    var normalizationOptions = this._store.__getNormalizationOptions(fieldPath);
                    return $a5a7e09f792afd36$var$normalize(source, selector, value, normalizationOptions).source;
                case 'WeakModel':
                    var _record = $jeujn.create(outputTypeDataID, typename);
                    $jeujn.setValue(_record, $a5a7e09f792afd36$var$MODEL_PROPERTY_NAME, value);
                    source.set(outputTypeDataID, _record);
                    return source;
                default:
                    normalizationInfo.kind;
                    $aE1Lc(false);
            }
        };
        _proto.ensureClientRecord = function ensureClientRecord(id, typeName) {
            var key = $a5a7e09f792afd36$var$generateClientObjectClientID(typeName, id);
            var recordSource = this._getRecordSource();
            if (!recordSource.has(key)) {
                var newRecord = $jeujn.create(key, typeName);
                $jeujn.setValue(newRecord, 'id', id);
                recordSource.set(key, newRecord);
            }
            return key;
        };
        _proto.unsubscribeFromLiveResolverRecords = function unsubscribeFromLiveResolverRecords(invalidatedDataIDs) {
            return $a5a7e09f792afd36$var$unsubscribeFromLiveResolverRecordsImpl(this._getRecordSource(), invalidatedDataIDs);
        };
        _proto.invalidateResolverRecords = function invalidateResolverRecords(invalidatedDataIDs) {
            if (invalidatedDataIDs.size === 0) return;
            var _iterator6 = (0, $a5a7e09f792afd36$var$_createForOfIteratorHelper2["default"])(invalidatedDataIDs), _step6;
            try {
                for(_iterator6.s(); !(_step6 = _iterator6.n()).done;){
                    var dataID = _step6.value;
                    var record = this._getRecordSource().get(dataID);
                    if (record != null && $a5a7e09f792afd36$var$isResolverRecord(record)) this._getRecordSource()["delete"](dataID);
                }
            } catch (err) {
                _iterator6.e(err);
            } finally{
                _iterator6.f();
            }
        };
        return LiveResolverCache;
    }();
    function $a5a7e09f792afd36$var$updateCurrentSource(currentSource, nextSource, prevOutputTypeRecordIDs) {
        var updatedDataIDs = new Set();
        if (prevOutputTypeRecordIDs != null) {
            var _iterator7 = (0, $a5a7e09f792afd36$var$_createForOfIteratorHelper2["default"])(prevOutputTypeRecordIDs), _step7;
            try {
                for(_iterator7.s(); !(_step7 = _iterator7.n()).done;){
                    var recordID = _step7.value;
                    if (!nextSource.has(recordID)) {
                        updatedDataIDs.add(recordID);
                        currentSource.remove(recordID);
                    }
                }
            } catch (err) {
                _iterator7.e(err);
            } finally{
                _iterator7.f();
            }
        }
        var _iterator8 = (0, $a5a7e09f792afd36$var$_createForOfIteratorHelper2["default"])(nextSource.getRecordIDs()), _step8;
        try {
            for(_iterator8.s(); !(_step8 = _iterator8.n()).done;){
                var _recordID2 = _step8.value;
                var nextRecord = $a5a7e09f792afd36$var$expectRecord(nextSource, _recordID2);
                if (currentSource.has(_recordID2)) {
                    var currentRecord = $a5a7e09f792afd36$var$expectRecord(currentSource, _recordID2);
                    var updatedRecord = $jeujn.update(currentRecord, nextRecord);
                    if (updatedRecord !== currentRecord) {
                        updatedDataIDs.add(_recordID2);
                        currentSource.set(_recordID2, updatedRecord);
                        $a5a7e09f792afd36$var$markInvalidatedLinkedResolverRecords(currentRecord, currentSource);
                    }
                } else currentSource.set(_recordID2, nextRecord);
            }
        } catch (err) {
            _iterator8.e(err);
        } finally{
            _iterator8.f();
        }
        return updatedDataIDs;
    }
    function $a5a7e09f792afd36$var$getAllLinkedRecordIds(record) {
        var linkedRecordIDs = new Set();
        $jeujn.getFields(record).forEach(function(field) {
            if ($jeujn.hasLinkedRecordID(record, field)) {
                var linkedRecordID = $jeujn.getLinkedRecordID(record, field);
                if (linkedRecordID != null) linkedRecordIDs.add(linkedRecordID);
            } else if ($jeujn.hasLinkedRecordIDs(record, field)) {
                var _RelayModernRecord$ge;
                (_RelayModernRecord$ge = $jeujn.getLinkedRecordIDs(record, field)) === null || _RelayModernRecord$ge === void 0 || _RelayModernRecord$ge.forEach(function(linkedRecordID) {
                    if (linkedRecordID != null) linkedRecordIDs.add(linkedRecordID);
                });
            }
        });
        return linkedRecordIDs;
    }
    function $a5a7e09f792afd36$var$markInvalidatedResolverRecord(dataID, recordSource) {
        var record = recordSource.get(dataID);
        if (!record) return;
        var nextRecord = $jeujn.clone(record);
        $jeujn.setValue(nextRecord, $a5a7e09f792afd36$var$RELAY_RESOLVER_INVALIDATION_KEY, true);
        recordSource.set(dataID, nextRecord);
    }
    function $a5a7e09f792afd36$var$markInvalidatedLinkedResolverRecords(record, recordSource) {
        var currentLinkedDataIDs = $a5a7e09f792afd36$var$getAllLinkedRecordIds(record);
        var _iterator9 = (0, $a5a7e09f792afd36$var$_createForOfIteratorHelper2["default"])(currentLinkedDataIDs), _step9;
        try {
            for(_iterator9.s(); !(_step9 = _iterator9.n()).done;){
                var recordID = _step9.value;
                var _record2 = recordSource.get(recordID);
                if (_record2 != null && $a5a7e09f792afd36$var$isResolverRecord(_record2)) $a5a7e09f792afd36$var$markInvalidatedResolverRecord(recordID, recordSource);
            }
        } catch (err) {
            _iterator9.e(err);
        } finally{
            _iterator9.f();
        }
    }
    function $a5a7e09f792afd36$var$unsubscribeFromLiveResolverRecordsImpl(recordSource, invalidatedDataIDs) {
        if (invalidatedDataIDs.size === 0) return;
        var _iterator10 = (0, $a5a7e09f792afd36$var$_createForOfIteratorHelper2["default"])(invalidatedDataIDs), _step10;
        try {
            for(_iterator10.s(); !(_step10 = _iterator10.n()).done;){
                var dataID = _step10.value;
                var record = recordSource.get(dataID);
                if (record != null && $a5a7e09f792afd36$var$isResolverRecord(record)) $a5a7e09f792afd36$var$maybeUnsubscribeFromLiveState(record);
            }
        } catch (err) {
            _iterator10.e(err);
        } finally{
            _iterator10.f();
        }
    }
    function $a5a7e09f792afd36$var$isResolverRecord(record) {
        return $jeujn.getType(record) === $a5a7e09f792afd36$var$RELAY_RESOLVER_RECORD_TYPENAME;
    }
    function $a5a7e09f792afd36$var$maybeUnsubscribeFromLiveState(linkedRecord) {
        var previousUnsubscribe = $jeujn.getValue(linkedRecord, $a5a7e09f792afd36$var$RELAY_RESOLVER_LIVE_STATE_SUBSCRIPTION_KEY);
        if (previousUnsubscribe != null) previousUnsubscribe();
    }
    function $a5a7e09f792afd36$var$expectRecord(source, recordID) {
        var record = source.get(recordID);
        !(record != null) && $aE1Lc(false);
        return record;
    }
    function $a5a7e09f792afd36$var$getUpdatedDataIDs(updatedRecords) {
        return updatedRecords;
    }
    function $a5a7e09f792afd36$var$getConcreteTypename(normalizationInfo, currentValue) {
        var _normalizationInfo$co;
        var typename = (_normalizationInfo$co = normalizationInfo.concreteType) !== null && _normalizationInfo$co !== void 0 ? _normalizationInfo$co : currentValue.__typename;
        !(typename != null) && $aE1Lc(false);
        return typename;
    }
    module.exports = {
        LiveResolverCache: $a5a7e09f792afd36$var$LiveResolverCache,
        getUpdatedDataIDs: $a5a7e09f792afd36$var$getUpdatedDataIDs,
        RELAY_RESOLVER_LIVE_STATE_SUBSCRIPTION_KEY: $a5a7e09f792afd36$var$RELAY_RESOLVER_LIVE_STATE_SUBSCRIPTION_KEY
    };
});
parcelRegister("1ct6Z", function(module, exports) {
    'use strict';
    function $0dfd7e67afc3bafd$var$isLiveStateValue(v) {
        return v != null && typeof v === 'object' && typeof v.read === 'function' && typeof v.subscribe === 'function';
    }
    module.exports = $0dfd7e67afc3bafd$var$isLiveStateValue;
});
parcelRegister("iJZ8l", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b125dd4fe380c966$export$2e2bcd8739ae039);
    var $VSDnB;
    var $k43Wt;
    const $b125dd4fe380c966$var$idTypeMap = new Map();
    function $b125dd4fe380c966$export$2e2bcd8739ae039(fieldValue, typeName) {
        const { id: id } = fieldValue;
        if (id == null) return undefined;
        if ((0, (0, parcelRequire("VSDnB")).fg)('platform_log_relay_duplicate_identifiers')) {
            const idString = String(id);
            if ($b125dd4fe380c966$var$idTypeMap.has(idString)) {
                const entry = $b125dd4fe380c966$var$idTypeMap.get(idString);
                if (entry) {
                    const { typeName: existingTypeName, hasLoggedConflict: hasLoggedConflict } = entry;
                    if (existingTypeName !== typeName && !hasLoggedConflict) {
                        (0, (0, parcelRequire("k43Wt")).safeWarnWithoutCustomerData)('relaydataid.generator', `RelayDataID: conflicting type names for the same ID: ${idString} with type names: ${existingTypeName} and ${typeName}.`, {
                            id: idString,
                            types: `${existingTypeName}, ${typeName}`
                        });
                        entry.hasLoggedConflict = true;
                    }
                }
            } else $b125dd4fe380c966$var$idTypeMap.set(idString, {
                typeName: typeName,
                hasLoggedConflict: false
            });
        }
        return `${String(id)}:::::${typeName}`;
    }
});
parcelRegister("k43Wt", function(module, exports) {
    $parcel$export(module.exports, "safeWarnWithoutCustomerData", ()=>$6955024b7a0709f2$export$b8c037155fd57aaf);
    const $6955024b7a0709f2$var$defaultOptions = {
        credentials: 'same-origin',
        headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json, text/javascript, */*'
        }
    };
    const $6955024b7a0709f2$var$isProduction = ()=>true;
    const $6955024b7a0709f2$var$MAX_REQUESTS_PER_INTERVAL = 5;
    const $6955024b7a0709f2$var$INTERVAL_MS = 1000;
    let $6955024b7a0709f2$var$requestQueue = [];
    let $6955024b7a0709f2$var$isProcessingQueue = false;
    const $6955024b7a0709f2$var$processQueue = ()=>{
        if ($6955024b7a0709f2$var$isProcessingQueue) return;
        $6955024b7a0709f2$var$isProcessingQueue = true;
        const processNextBatch = ()=>{
            if ($6955024b7a0709f2$var$requestQueue.length === 0) {
                $6955024b7a0709f2$var$isProcessingQueue = false;
                return;
            }
            const batch = $6955024b7a0709f2$var$requestQueue.splice(0, $6955024b7a0709f2$var$MAX_REQUESTS_PER_INTERVAL);
            batch.forEach(({ body: body, endpoint: endpoint })=>{
                fetch(endpoint, {
                    ...$6955024b7a0709f2$var$defaultOptions,
                    method: 'POST',
                    body: body
                });
            });
            setTimeout(processNextBatch, $6955024b7a0709f2$var$INTERVAL_MS);
        };
        processNextBatch();
    };
    const $6955024b7a0709f2$var$sendToServerBatched = (body, endpoint)=>{
        $6955024b7a0709f2$var$requestQueue.push({
            body: body,
            endpoint: endpoint
        });
        $6955024b7a0709f2$var$processQueue();
    };
    const $6955024b7a0709f2$var$sendToConsole = (body, endpoint, level, message, eventType, event)=>{
        console[level]('%c%s %c(POST %s)\n%cMessage\n%c%s\n\n%cEvent body\n%c%s\n\n%cException object and Stack trace (expand to jump to source)\n', 'font-size: 14px; font-weight: bold;', level.toUpperCase(), 'font-size: 10px; font-family: monospace;', endpoint, 'font-family: sans-serif; font-weight: bold; font-size: 12px', 'font-family: sans-serif; font-weight: initial;', message, 'font-family: sans-serif; font-weight: bold;', 'font-family: monospace; font-weight: initial;', body, 'font-family: sans-serif; font-size: 12px; font-weight: bold;', event);
        const currentWindow = window;
        if (!$6955024b7a0709f2$var$isProduction() && currentWindow.Cypress) {
            if (!currentWindow.cypressSafeErrorsLog) currentWindow.cypressSafeErrorsLog = [];
            currentWindow.cypressSafeErrorsLog.push({
                body: body,
                endpoint: endpoint,
                level: level,
                message: message
            });
        }
        if (eventType !== 'object') {
            const errorMessage = `Invalid log API usage: expected event of type 'object', but was ${eventType}`;
            console.error(errorMessage);
        }
        if (typeof body !== 'string') {
            const errorMessage = `Invalid log API usage: expected event of type 'string', but was ${eventType}; message will be replaced by: ${String(message)}`;
            console.error(errorMessage);
        }
        return Promise.resolve();
    };
    const $6955024b7a0709f2$var$transformData = (location, message, event)=>{
        return {
            sentFrom: location,
            message: String(message),
            event: event,
            buildKey: window?.BUILD_KEY,
            logTime: new Date().toISOString()
        };
    };
    const $6955024b7a0709f2$var$sendData = (level, location, message, event = {})=>{
        const data = $6955024b7a0709f2$var$transformData(location, message, event);
        const body = JSON.stringify(data);
        const endpoint = `/rest/internal/2/log/safe/${level}`;
        if ($6955024b7a0709f2$var$isProduction()) return $6955024b7a0709f2$var$sendToServerBatched(body, endpoint);
        return $6955024b7a0709f2$var$sendToConsole(body, endpoint, level, message, typeof event, event);
    };
    const $6955024b7a0709f2$export$b8c037155fd57aaf = (location, message, event)=>{
        $6955024b7a0709f2$var$sendData('warn', location, message, event);
    };
});
parcelRegister("dj5to", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e597542b503a321e$export$2e2bcd8739ae039);
    var $gbLWS;
    var $iJZ8l;
    const $e597542b503a321e$var$isCustomFilter = (filterId)=>/^\d+$/.test(filterId);
    const $e597542b503a321e$var$isSystemFilter = (filterId)=>/^-\d+$/.test(filterId);
    const $e597542b503a321e$export$77232ec02db7a24a = {
        handle: (field, record, argValues)=>{
            if (record != null && record.getType() === 'JiraQuery' && field.name === 'filter' && argValues.id != null) {
                const { id: id } = argValues;
                const filterId = (0, (0, parcelRequire("gbLWS")).JiraFilterAri).parse(id).filterId;
                if ($e597542b503a321e$var$isCustomFilter(filterId)) return (0, (0, parcelRequire("iJZ8l")).default)({
                    id: id
                }, 'JiraCustomFilter');
                if ($e597542b503a321e$var$isSystemFilter(filterId)) return (0, (0, parcelRequire("iJZ8l")).default)({
                    id: id
                }, 'JiraSystemFilter');
                return undefined;
            }
            return undefined;
        },
        kind: 'linked'
    };
    const $e597542b503a321e$var$MissingFieldHandlers = [
        $e597542b503a321e$export$77232ec02db7a24a
    ];
    var $e597542b503a321e$export$2e2bcd8739ae039 = $e597542b503a321e$var$MissingFieldHandlers;
});
parcelRegister("gbLWS", function(module, exports) {
    $parcel$export(module.exports, "JiraFilterAri", ()=>$bc92de03879804aa$export$3cfb6cc809e835bd);
    var $TjnT5;
    var $9KGzW;
    var $1C2Ux;
    var $bc92de03879804aa$var$jiraFilterAriStaticOpts = {
        qualifier: "ari",
        platformQualifier: "cloud",
        cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
        resourceOwner: (0, (0, parcelRequire("TjnT5")).JiraFilterAriResourceOwner),
        resourceType: (0, (0, parcelRequire("TjnT5")).JiraFilterAriResourceType),
        resourceIdSlug: "activation/{activationId}/{filterId}",
        resourceIdSegmentFormats: {
            activationId: /[a-zA-Z0-9\-]+/,
            filterId: /[!a-zA-Z0-9\-_.~@:{}=]+(\/[!a-zA-Z0-9\-_.~@:{}=]+)*/
        }
    };
    var $bc92de03879804aa$export$3cfb6cc809e835bd = class _JiraFilterAri extends (0, (0, parcelRequire("9KGzW")).RegisteredAri) {
        constructor(opts){
            super(opts);
            this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._filterId = opts.resourceIdSegmentValues.filterId;
        }
        get siteId() {
            return this._siteId;
        }
        get activationId() {
            return this._activationId;
        }
        get filterId() {
            return this._filterId;
        }
        static create(opts) {
            let derivedOpts = {
                qualifier: $bc92de03879804aa$var$jiraFilterAriStaticOpts.qualifier,
                platformQualifier: $bc92de03879804aa$var$jiraFilterAriStaticOpts.platformQualifier,
                cloudId: opts.siteId,
                resourceOwner: $bc92de03879804aa$var$jiraFilterAriStaticOpts.resourceOwner,
                resourceType: $bc92de03879804aa$var$jiraFilterAriStaticOpts.resourceType,
                resourceId: `activation/${opts.activationId}/${opts.filterId}`,
                resourceIdSegmentValues: {
                    activationId: opts.activationId,
                    filterId: opts.filterId
                }
            }, ariOpts = (0, (0, parcelRequire("1C2Ux")).AriParser).fromOpts(derivedOpts, $bc92de03879804aa$var$jiraFilterAriStaticOpts);
            return new _JiraFilterAri(ariOpts);
        }
        static parse(maybeAri) {
            let opts = (0, (0, parcelRequire("1C2Ux")).AriParser).fromString(maybeAri, $bc92de03879804aa$var$jiraFilterAriStaticOpts);
            return new _JiraFilterAri(opts);
        }
        getVariables() {
            return {
                siteId: this.siteId,
                activationId: this.activationId,
                filterId: this.filterId
            };
        }
    };
});
parcelRegister("TjnT5", function(module, exports) {
    $parcel$export(module.exports, "JiraFilterAriResourceOwner", ()=>$0a642c7bb6f094f8$export$e6199848f52f1119);
    $parcel$export(module.exports, "JiraFilterAriResourceType", ()=>$0a642c7bb6f094f8$export$3c64de4ae038e3ae);
    var $0a642c7bb6f094f8$export$e6199848f52f1119 = "jira", $0a642c7bb6f094f8$export$3c64de4ae038e3ae = "filter";
});
parcelRegister("9KGzW", function(module, exports) {
    $parcel$export(module.exports, "RegisteredAri", ()=>$71997031dd676429$export$579ee78b1dcf0a11);
    var $1Jl81;
    var $71997031dd676429$export$579ee78b1dcf0a11 = class extends (0, (0, parcelRequire("1Jl81")).Ari) {
        static check(maybeAri) {
            try {
                return this.parse(maybeAri.toString()), !0;
            } catch (err) {
                return !1;
            }
        }
        asAnyAri() {
            return (0, (0, parcelRequire("1Jl81")).AnyAri).parse(this.toString());
        }
    };
});
parcelRegister("1Jl81", function(module, exports) {
    $parcel$export(module.exports, "Ari", ()=>$142a620f899fb689$export$3a4885701291260b);
    $parcel$export(module.exports, "AnyAri", ()=>$142a620f899fb689$export$44a7af7122933d6b);
    var $1C2Ux;
    var $142a620f899fb689$export$3a4885701291260b = class {
        constructor(opts){
            this._ati = (0, (0, parcelRequire("1C2Ux")).Ati).create({
                platformQualifier: opts.platformQualifier || "cloud",
                resourceOwner: opts.resourceOwner,
                resourceType: opts.resourceType
            }), this._cloudId = opts.cloudId !== "" ? opts.cloudId : void 0, this._resourceId = opts.resourceId;
        }
        get platformQualifier() {
            return this._ati.platformQualifier;
        }
        get cloudId() {
            return this._cloudId;
        }
        get resourceOwner() {
            return this._ati.resourceOwner;
        }
        get resourceType() {
            return this._ati.resourceType;
        }
        get resourceId() {
            return this._resourceId;
        }
        get ati() {
            return this._ati;
        }
        equals(other) {
            return this.toString() === other.toString();
        }
        toString() {
            return `ari:${this.platformQualifier}:${this.resourceOwner}:${this.cloudId || ""}:${this.resourceType}/${this.resourceId}`;
        }
        toJSON() {
            return this.toString();
        }
        toOpts() {
            return {
                platformQualifier: this.platformQualifier,
                resourceOwner: this.resourceOwner,
                cloudId: this.cloudId,
                resourceType: this.resourceType,
                resourceId: this.resourceId
            };
        }
    };
    var $142a620f899fb689$export$44a7af7122933d6b = class _AnyAri extends $142a620f899fb689$export$3a4885701291260b {
        constructor(opts){
            super(opts);
        }
        static create(ariOpts, ariStaticOpts) {
            let ariOptsWithDefaults = {
                ...ariOpts,
                resourceIdSegmentValues: {}
            }, validatedOpts = (0, (0, parcelRequire("1C2Ux")).AriParser).fromOpts(ariOptsWithDefaults, ariStaticOpts);
            return new _AnyAri(validatedOpts);
        }
        static parse(maybeAri, ariStaticOpts) {
            let validatedOpts = (0, (0, parcelRequire("1C2Ux")).AriParser).fromString(maybeAri, ariStaticOpts);
            return new _AnyAri(validatedOpts);
        }
        static check(maybeAri) {
            try {
                return _AnyAri.parse(maybeAri.toString()), !0;
            } catch (err) {
                return !1;
            }
        }
        asAnyAri() {
            return this;
        }
    };
});
parcelRegister("1C2Ux", function(module, exports) {
    $parcel$export(module.exports, "AriParser", ()=>$12cb9916f0aaeeed$export$4c3a8cde7a55740b);
    $parcel$export(module.exports, "Ati", ()=>$12cb9916f0aaeeed$export$ab4b293d0121b8ee);
    var $fo7u7;
    var $ed4UU;
    function $12cb9916f0aaeeed$var$validateCloudId(cloudId, format = new RegExp("^[a-zA-Z0-9_\\-.]{0,255}$")) {
        if (!cloudId.match(format)) throw new (0, (0, parcelRequire("ed4UU")).ValidationError)(`Invalid cloud ID, expected ID of format ${format}.`);
    }
    function $12cb9916f0aaeeed$var$validateResourceId(id, format = new RegExp("[!a-zA-Z0-9\\-_.~@:{}=]+(/[!a-zA-Z0-9\\-_.~@:{}=]+)*"), key = "resourceId") {
        let formatWithCarets = new RegExp(`^${format.source}$`);
        if (!id.match(formatWithCarets)) throw new (0, (0, parcelRequire("ed4UU")).ValidationError)(`Invalid ${key} - ${id}, expected ID of format ${formatWithCarets}.`);
    }
    function $12cb9916f0aaeeed$var$validateResourceIdSegments(resourceIdSegmentValues, resourceIdSegmentFormats) {
        Object.entries(resourceIdSegmentValues).forEach(([resourceIdKey, resourceIdValue])=>{
            $12cb9916f0aaeeed$var$validateResourceId(resourceIdValue, resourceIdSegmentFormats == null ? void 0 : resourceIdSegmentFormats[resourceIdKey], resourceIdKey);
        });
    }
    function $12cb9916f0aaeeed$var$validateResourceOwner(owner, expectedResourceOwner) {
        if (expectedResourceOwner && owner !== expectedResourceOwner) throw new (0, (0, parcelRequire("ed4UU")).ValidationError)(`Invalid resource owner - ${owner}, expected ${expectedResourceOwner}.`);
    }
    function $12cb9916f0aaeeed$var$validateResourceType(type, expectedResourceType) {
        if (expectedResourceType && type !== expectedResourceType) throw new (0, (0, parcelRequire("ed4UU")).ValidationError)(`Invalid resource type - ${type}, expected ${expectedResourceType}.`);
    }
    var $12cb9916f0aaeeed$var$NUMBER_OF_ARI_SEGMENTS = 5, $12cb9916f0aaeeed$export$4c3a8cde7a55740b = class extends (0, (0, parcelRequire("fo7u7")).BaseParser) {
        static fromString(maybeAri, ariProperties) {
            let segments = this.getIdentifierSegments(maybeAri, $12cb9916f0aaeeed$var$NUMBER_OF_ARI_SEGMENTS), [qualifier, platformQualifier, resourceOwner, cloudId, resourceTypeAndId] = segments, [resourceType, ...resourceIdSegments] = resourceTypeAndId.split("/"), maybeAriDerivedProperties = {
                qualifier: qualifier,
                platformQualifier: platformQualifier,
                cloudId: cloudId,
                resourceOwner: resourceOwner,
                resourceType: resourceType,
                resourceId: resourceIdSegments.join("/"),
                resourceIdSegmentValues: ariProperties != null && ariProperties.resourceIdSlug ? this.ariSegmentValuesFromSlug(ariProperties.resourceIdSlug, resourceIdSegments.join("/"), Object.keys(ariProperties.resourceIdSegmentFormats)) : {}
            };
            return this.fromOpts(maybeAriDerivedProperties, ariProperties);
        }
        static fromOpts(maybeAriOpts, ariProperties) {
            let { qualifier: qualifier = "ari", platformQualifier: platformQualifier = "cloud", resourceOwner: resourceOwner, cloudId: cloudId, resourceId: resourceId, resourceIdSegmentValues: resourceIdSegmentValues, resourceType: resourceType } = maybeAriOpts;
            return (0, (0, parcelRequire("fo7u7")).validateAriQualifier)(qualifier), (0, (0, parcelRequire("fo7u7")).validatePlatformQualifier)(platformQualifier), $12cb9916f0aaeeed$var$validateCloudId(maybeAriOpts.cloudId || "", ariProperties == null ? void 0 : ariProperties.cloudId), $12cb9916f0aaeeed$var$validateResourceOwner(resourceOwner, ariProperties == null ? void 0 : ariProperties.resourceOwner), $12cb9916f0aaeeed$var$validateResourceType(resourceType, ariProperties == null ? void 0 : ariProperties.resourceType), $12cb9916f0aaeeed$var$validateResourceIdSegments(resourceIdSegmentValues, ariProperties == null ? void 0 : ariProperties.resourceIdSegmentFormats), {
                qualifier: qualifier,
                resourceOwner: resourceOwner,
                resourceType: resourceType,
                platformQualifier: platformQualifier,
                cloudId: cloudId,
                resourceId: resourceId,
                resourceIdSegmentValues: resourceIdSegmentValues
            };
        }
        static ariSegmentValuesFromSlug(slug, incomingSegments, expectedKeys) {
            let regexpResult = new RegExp("^" + slug.replace(/\{(.*?)\}/g, "(?<$1>.*?)") + "$").exec(incomingSegments);
            if (!regexpResult) throw new (0, (0, parcelRequire("ed4UU")).ValidationError)(`Segment '${incomingSegments}' don't match expected slug: ${slug}`);
            return expectedKeys.forEach((expectedKey)=>{
                var _a;
                if (!((_a = regexpResult.groups) != null && _a[expectedKey])) throw new (0, (0, parcelRequire("ed4UU")).ValidationError)(`No value supplied for '${expectedKey}' based on slug ${slug}`);
            }), regexpResult.groups || {};
        }
    };
    var $12cb9916f0aaeeed$var$NUMBER_OF_ATI_SEGMENTS = 4, $12cb9916f0aaeeed$var$AtiParser = class extends (0, (0, parcelRequire("fo7u7")).BaseParser) {
        static fromString(inputStr, atiOpts) {
            let segments = this.getIdentifierSegments(inputStr, $12cb9916f0aaeeed$var$NUMBER_OF_ATI_SEGMENTS), [qualifier = "ati", platformQualifier = "cloud", resourceOwner, resourceType] = segments;
            return (0, (0, parcelRequire("fo7u7")).validateAtiQualifier)(qualifier), (0, (0, parcelRequire("fo7u7")).validatePlatformQualifier)(platformQualifier), $12cb9916f0aaeeed$var$validateResourceOwner(resourceOwner, atiOpts == null ? void 0 : atiOpts.resourceOwner), $12cb9916f0aaeeed$var$validateResourceType(resourceType, atiOpts == null ? void 0 : atiOpts.resourceType), {
                platformQualifier: platformQualifier,
                resourceOwner: resourceOwner,
                resourceType: resourceType
            };
        }
        static fromOpts(maybeAtiOpts, atiOpts) {
            let { qualifier: qualifier, platformQualifier: platformQualifier, resourceOwner: resourceOwner, resourceType: resourceType } = maybeAtiOpts;
            return (0, (0, parcelRequire("fo7u7")).validateAtiQualifier)(qualifier), (0, (0, parcelRequire("fo7u7")).validatePlatformQualifier)(platformQualifier), $12cb9916f0aaeeed$var$validateResourceOwner(resourceOwner, atiOpts == null ? void 0 : atiOpts.resourceOwner), $12cb9916f0aaeeed$var$validateResourceType(resourceType, atiOpts == null ? void 0 : atiOpts.resourceType), {
                platformQualifier: platformQualifier,
                resourceOwner: resourceOwner,
                resourceType: resourceType
            };
        }
    };
    var $12cb9916f0aaeeed$export$ab4b293d0121b8ee = class _Ati {
        constructor(platformQualifier, resourceOwner, resourceType){
            this._platformQualifier = platformQualifier, this._resourceOwner = resourceOwner, this._resourceType = resourceType;
        }
        get platformQualifier() {
            return this._platformQualifier;
        }
        get resourceOwner() {
            return this._resourceOwner;
        }
        get resourceType() {
            return this._resourceType;
        }
        static create(opts) {
            return new _Ati(opts.platformQualifier || "cloud", opts.resourceOwner, opts.resourceType);
        }
        static parse(maybeAti, atiOpts) {
            let opts = $12cb9916f0aaeeed$var$AtiParser.fromString(maybeAti, atiOpts);
            return new _Ati(opts.platformQualifier, opts.resourceOwner, opts.resourceType);
        }
        toString() {
            return `ati:${this.platformQualifier}:${this.resourceOwner}:${this.resourceType}`;
        }
        toJSON() {
            return this.toString();
        }
        toOpts() {
            return {
                platformQualifier: this._platformQualifier,
                resourceOwner: this._resourceOwner,
                resourceType: this._resourceType
            };
        }
    };
});
parcelRegister("fo7u7", function(module, exports) {
    $parcel$export(module.exports, "validatePlatformQualifier", ()=>$b33ee73cfb749d69$export$4f6e8fa90a16fdc4);
    $parcel$export(module.exports, "validateAtiQualifier", ()=>$b33ee73cfb749d69$export$da331df28ad1f3d9);
    $parcel$export(module.exports, "validateAriQualifier", ()=>$b33ee73cfb749d69$export$822bcd2b6f6774a1);
    $parcel$export(module.exports, "BaseParser", ()=>$b33ee73cfb749d69$export$3d09a5c28ff3e040);
    var $ed4UU;
    function $b33ee73cfb749d69$export$4f6e8fa90a16fdc4(qualifier) {
        if (qualifier !== "cloud" && qualifier !== "third-party") throw new (0, (0, parcelRequire("ed4UU")).ValidationError)(`Identifier must have a qualifier of 'cloud' or 'third-party'. Received: ${qualifier}`);
    }
    function $b33ee73cfb749d69$export$da331df28ad1f3d9(qualifier) {
        if (qualifier !== "ati") throw new (0, (0, parcelRequire("ed4UU")).ValidationError)(`ATI must have a qualifier of 'ati'. Received: ${qualifier}`);
    }
    function $b33ee73cfb749d69$export$822bcd2b6f6774a1(qualifier) {
        if (qualifier !== "ari") throw new (0, (0, parcelRequire("ed4UU")).ValidationError)(`ARI must have a qualifier of 'ari'. Received: ${qualifier}`);
    }
    function $b33ee73cfb749d69$export$277c2bbc487e609d(qualifier) {
        if (qualifier !== "arm") throw new (0, (0, parcelRequire("ed4UU")).ValidationError)(`ARM must have a qualifier of 'arm'. Received: ${qualifier}`);
    }
    var $b33ee73cfb749d69$var$NUMBER_OF_BASE_SEGMENTS = 5, $b33ee73cfb749d69$var$SEGMENT_SEPARATOR = ":", $b33ee73cfb749d69$export$3d09a5c28ff3e040 = class {
        static getIdentifierSegments(inputStr, numberOfSegmentsRequired) {
            let allSegments = inputStr.split($b33ee73cfb749d69$var$SEGMENT_SEPARATOR);
            if (allSegments.length < numberOfSegmentsRequired) throw new (0, (0, parcelRequire("ed4UU")).ValidationError)(`Input string must have ${numberOfSegmentsRequired} segments.`);
            if (allSegments.length > numberOfSegmentsRequired) {
                let segments = allSegments.slice(0, $b33ee73cfb749d69$var$NUMBER_OF_BASE_SEGMENTS - 1), segmentsForResourceId = allSegments.slice($b33ee73cfb749d69$var$NUMBER_OF_BASE_SEGMENTS - 1, allSegments.length);
                return [
                    ...segments,
                    segmentsForResourceId.join($b33ee73cfb749d69$var$SEGMENT_SEPARATOR)
                ];
            }
            return allSegments;
        }
    };
});
parcelRegister("ed4UU", function(module, exports) {
    $parcel$export(module.exports, "ValidationError", ()=>$a58617fff8cdca9e$export$2191b9da168c6cf0);
    var $a58617fff8cdca9e$export$2191b9da168c6cf0 = class extends Error {
    };
});
parcelRegister("3Z1I9", function(module, exports) {
    $parcel$export(module.exports, "network", ()=>$d27a06de13f76964$export$21fcfd9d5c6ebbd4);
    var $eiowN = parcelRequire("eiowN");
    var $eCZ6m;
    function $d27a06de13f76964$var$fetchQuery(request, variables, cacheConfig) {
        const endpoint = (0, (0, parcelRequire("eCZ6m")).getAggEndpoint)(request, cacheConfig);
        const body = (0, (0, parcelRequire("eCZ6m")).getRequestBody)(request, variables);
        return fetch(endpoint, {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
                'content-type': 'application/json'
            },
            body: body
        }).then((response)=>{
            return response.json();
        });
    }
    const $d27a06de13f76964$export$21fcfd9d5c6ebbd4 = (0, $eiowN.Network).create($d27a06de13f76964$var$fetchQuery);
});
parcelRegister("iExP6", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$42dcb07af95a04bd$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7nsd3 = parcelRequire("7nsd3");
    var $42dcb07af95a04bd$export$2e2bcd8739ae039 = {
        cancel: ()=>{},
        schedule: (fn)=>{
            if (typeof (0, ($parcel$interopDefault($7nsd3))).unstable_batchedUpdates === 'function' && (typeof (0, $7nsd3.version) === 'undefined' || (0, $7nsd3.version).startsWith('16'))) (0, ($parcel$interopDefault($7nsd3))).unstable_batchedUpdates(()=>{
                fn();
            });
            else if (typeof (0, ($parcel$interopDefault($5uXOq))).startTransition === 'function') (0, ($parcel$interopDefault($5uXOq))).startTransition(()=>{
                fn();
            });
            else fn();
            return '';
        }
    };
});
parcelRegister("1ciso", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$438df80413aa7a79$export$2e2bcd8739ae039);
    $parcel$export(module.exports, "useUFOTransitionCompleter", ()=>$438df80413aa7a79$export$369f0ded13ce6c50);
    var $5uXOq = parcelRequire("5uXOq");
    var $7Jxgt = parcelRequire("7Jxgt");
    var $5gx4p;
    var $fe1wc;
    var $tcn7E;
    var $1u4q7;
    var $bFU4G;
    var $9AgLs;
    var $g2MbB;
    function $438df80413aa7a79$export$2e2bcd8739ae039(ufoName, routeName = ufoName) {
        const pressInteractionsList = (0, (0, parcelRequire("fe1wc")).getDoNotAbortActivePressInteractionOnTransition)();
        const interaction = (0, (0, parcelRequire("bFU4G")).getActiveInteraction)();
        if (pressInteractionsList && interaction) {
            if (pressInteractionsList.includes(interaction.ufoName)) return;
        }
        (0, (0, parcelRequire("bFU4G")).abortAll)('transition', ufoName ?? undefined);
        if (ufoName) {
            (0, (0, parcelRequire("9AgLs")).default).current = ufoName;
            const rate = (0, (0, parcelRequire("fe1wc")).getInteractionRate)(ufoName, 'transition');
            if ((0, (0, parcelRequire("5gx4p")).default)(rate)) {
                const newId = (0, $7Jxgt.v4)();
                (0, (0, parcelRequire("g2MbB")).setInteractionActiveTrace)(newId);
                (0, (0, parcelRequire("1u4q7")).DefaultInteractionID).current = newId;
                (0, (0, parcelRequire("bFU4G")).addNewInteraction)(newId, ufoName, 'transition', performance.now(), rate, null, routeName, (0, (0, parcelRequire("tcn7E")).getActiveTrace)());
            }
        }
    }
    function $438df80413aa7a79$export$369f0ded13ce6c50() {
        const interactionId = (0, $5uXOq.useContext)((0, (0, parcelRequire("1u4q7")).default));
        const capturedInteractionId = interactionId.current;
        (0, $5uXOq.useEffect)(()=>{
            if (capturedInteractionId != null) {
                let cancel = requestAnimationFrame(()=>{
                    cancel = requestAnimationFrame(()=>{
                        if (capturedInteractionId === interactionId.current) (0, (0, parcelRequire("bFU4G")).tryComplete)(capturedInteractionId);
                    });
                });
                (0, (0, parcelRequire("bFU4G")).addOnCancelCallback)(capturedInteractionId, ()=>{
                    cancelAnimationFrame(cancel);
                });
            }
        }, [
            capturedInteractionId,
            interactionId
        ]);
    }
});
parcelRegister("9AgLs", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c8d26e69bb020063$export$2e2bcd8739ae039);
    const $c8d26e69bb020063$var$UFORouteName = {
        current: null
    };
    var $c8d26e69bb020063$export$2e2bcd8739ae039 = $c8d26e69bb020063$var$UFORouteName;
});
parcelRegister("g2MbB", function(module, exports) {
    $parcel$export(module.exports, "setInteractionActiveTrace", ()=>$ccb60b9a6e8b8304$export$f2e521e495a88544);
    var $tcn7E;
    var $hIIZV;
    const $ccb60b9a6e8b8304$export$f2e521e495a88544 = (newId)=>{
        (0, (0, parcelRequire("tcn7E")).setActiveTrace)(newId.replace(/-/g, ''), (0, (0, parcelRequire("hIIZV")).generateSpanId)(), 'transition');
    };
});
parcelRegister("hIIZV", function(module, exports) {
    $parcel$export(module.exports, "generateSpanId", ()=>$633f98d7288c3c20$export$295213bc4d0c54ad);
    const $633f98d7288c3c20$export$295213bc4d0c54ad = ()=>Array.from(new Array(16), ()=>Math.floor(Math.random() * 16).toString(16)).join('');
});
parcelRegister("1AZST", function(module, exports) {
    $parcel$export(module.exports, "GlobalPageLoadExperience", ()=>$58d2d6be5127a354$export$bf7c1e56255f1467);
    var $gjd6t;
    var $4wnip;
    var $atdLB;
    var $8OuDJ;
    class $58d2d6be5127a354$var$UFOGlobalPageLoadExperience extends (0, (0, parcelRequire("4wnip")).UFOAbstractExperience) {
        startPageLoad(id, initial = false, startTime) {
            const result = super.start(initial ? 0 : (0, (0, parcelRequire("4wnip")).perfNowOrTimestamp)(startTime));
            this.setPageLoadId(id);
            this.initial = initial;
            return result;
        }
        updateConfig(config) {
            Object.assign(this.config, config);
        }
        setPageLoadId(id) {
            this.loadingPageLoadId = id;
        }
        async getId() {
            return this.loadingPageLoadId;
        }
        async exportData() {
            const data = await super.exportData();
            return {
                ...data,
                initial: this.initial
            };
        }
        constructor(...args){
            super(...args), this.loadingPageLoadId = 'UNKNOWN', this.type = (0, (0, parcelRequire("atdLB")).ExperienceTypes).Load, this.performanceType = (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).PageLoad, this.initial = true;
        }
    }
    const $58d2d6be5127a354$export$bf7c1e56255f1467 = new $58d2d6be5127a354$var$UFOGlobalPageLoadExperience('UFO_GLOBAL_PAGE_LOAD', {
        type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Load,
        performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).PageLoad,
        until: (0, (0, parcelRequire("gjd6t")).untilAll)([
            {
                category: (0, (0, parcelRequire("8OuDJ")).PageSegmentExperienceTypes).PRODUCT
            }
        ])
    });
});
parcelRegister("gjd6t", function(module, exports) {
    $parcel$export(module.exports, "untilAll", ()=>$8203c6dc9cf3beaa$export$44695628831598be);
    var $eoXiD;
    var $lc9Xi;
    const $8203c6dc9cf3beaa$var$isUntilExperience = (until)=>{
        return until.experience !== undefined;
    };
    const $8203c6dc9cf3beaa$var$isUntilCategory = (until)=>{
        return until.category !== undefined;
    };
    const $8203c6dc9cf3beaa$export$44695628831598be = (deps)=>()=>{
            const notMet = [
                ...deps
            ];
            return (data)=>{
                if (notMet.length > 0) {
                    const doneIndexes = notMet.reduce((acc, dep, i)=>{
                        if ($8203c6dc9cf3beaa$var$isUntilExperience(dep) && dep.experience.uuid === data.uuid) acc.push(i);
                        else if ($8203c6dc9cf3beaa$var$isUntilCategory(dep) && dep.category === data.category) acc.push(i);
                        return acc;
                    }, []);
                    const priorityStateFound = data.state === (0, (0, parcelRequire("lc9Xi")).UFOExperienceState).ABORTED || data.state === (0, (0, parcelRequire("lc9Xi")).UFOExperienceState).FAILED;
                    if (priorityStateFound) {
                        notMet.length = 0;
                        return {
                            done: true,
                            state: data.state
                        };
                    }
                    doneIndexes.reverse().forEach((i)=>{
                        notMet.splice(i, 1);
                    });
                    (0, (0, parcelRequire("eoXiD")).ufolog)('untilAll deps left:', notMet.length, notMet);
                    if (notMet.length === 0) return {
                        done: true,
                        state: (0, (0, parcelRequire("lc9Xi")).UFOExperienceState).SUCCEEDED
                    };
                }
                return {
                    done: false
                };
            };
        };
});
parcelRegister("lc9Xi", function(module, exports) {
    $parcel$export(module.exports, "UFOExperienceState", ()=>$afba37b3d9fab1f5$export$81b70111112841a0);
    const $afba37b3d9fab1f5$export$81b70111112841a0 = {
        NOT_STARTED: {
            id: 'NOT_STARTED',
            final: true
        },
        STARTED: {
            id: 'STARTED'
        },
        IN_PROGRESS: {
            id: 'IN_PROGRESS'
        },
        BLOCKED: {
            id: 'BLOCKED'
        },
        RECOVERED: {
            id: 'RECOVERED'
        },
        SUCCEEDED: {
            id: 'SUCCEEDED',
            final: true,
            success: true
        },
        SUCCEEDED_WAITING_FOR_DEPS: {
            id: 'SUCCEEDED_WAITING_FOR_DEPS'
        },
        FAILED: {
            id: 'FAILED',
            final: true
        },
        ABORTED: {
            id: 'ABORTED',
            final: true
        }
    };
});
parcelRegister("4wnip", function(module, exports) {
    $parcel$export(module.exports, "perfNowOrTimestamp", ()=>$feec6df92685c668$export$c753e8669d30c8ad);
    $parcel$export(module.exports, "UFOAbstractExperience", ()=>$feec6df92685c668$export$d31c89db257648c);
    var $7Jxgt = parcelRequire("7Jxgt");
    var $8Nn2p;
    var $iJHxx;
    var $eoXiD;
    var $3aRrh;
    var $fSTSz;
    var $ijH9f;
    var $lc9Xi;
    var $aqfim;
    var $atdLB;
    const $feec6df92685c668$var$getPageVisibleState = ()=>{
        return !(0, (0, parcelRequire("8Nn2p")).isWindowObjectAvailable)() || !window.document || window.document.visibilityState === 'visible' ? (0, (0, parcelRequire("fSTSz")).PageVisibleState).VISIBLE : (0, (0, parcelRequire("fSTSz")).PageVisibleState).HIDDEN;
    };
    const $feec6df92685c668$export$c753e8669d30c8ad = (timestamp)=>{
        if (timestamp !== undefined) return ~~timestamp;
        return (0, (0, parcelRequire("ijH9f")).roundPerfNow)();
    };
    class $feec6df92685c668$export$d31c89db257648c {
        constructor(id, config, instanceId = null){
            this.state = (0, (0, parcelRequire("lc9Xi")).UFOExperienceState).NOT_STARTED;
            this.instanceId = null;
            this.parent = null;
            this.category = null;
            this.metadata = {};
            this.onDoneCallbacks = [];
            this.childExperiences = [];
            this.explicitTimings = {};
            this.isSSROutputAsFMP = false;
            this.uuid = null;
            this._until = null;
            this.metrics = {
                startTime: null,
                endTime: null,
                marks: []
            };
            this.performanceConfig = {};
            this.setPageVisibleStateToMixed = ()=>{
                this.pageVisibleState = (0, (0, parcelRequire("fSTSz")).PageVisibleState).MIXED;
                (0, (0, parcelRequire("3aRrh")).visibilityChangeObserver).unsubscribe(this.setPageVisibleStateToMixed);
            };
            this.id = id;
            this.category = config?.category || null;
            this.until = config?.until || null;
            this.instanceId = instanceId;
            this.handleDoneBind = this._handleDoneExperience.bind(this);
            this.type = config.type;
            this.performanceType = config.performanceType;
            this.performanceConfig = config.performanceConfig || {};
            this.config = config;
            this.pageVisibleState = $feec6df92685c668$var$getPageVisibleState();
            this.featureFlags = config.featureFlags || [];
            this.timings = config.timings || [];
            if (config.performanceType === (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).PageLoad || config.performanceType === (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).PageSegmentLoad) this.isSSROutputAsFMP = config.isSSROutputAsFMP || false;
        }
        async transition(newState, timestamp) {
            (0, (0, parcelRequire("eoXiD")).ufolog)('async transition', this.id, this.state.id, newState.id);
            if ((0, (0, parcelRequire("aqfim")).canTransition)(this.state, newState)) {
                (0, (0, parcelRequire("eoXiD")).ufolog)(`TRANSITION: ${this.id} from ${this.state.id} to ${newState.id} successful`, this.state.final, !newState.final);
                if (newState === (0, (0, parcelRequire("lc9Xi")).UFOExperienceState).STARTED) this._reset();
                if (this.state.final && !newState.final) {
                    this.metrics.startTime = $feec6df92685c668$export$c753e8669d30c8ad(timestamp);
                    this.uuid = (0, $7Jxgt.v4)();
                }
                this.state = newState;
                if (newState.final) {
                    this.metrics.endTime = $feec6df92685c668$export$c753e8669d30c8ad(timestamp);
                    if (!this._isManualStateEnabled()) (0, (0, parcelRequire("iJHxx")).getGlobalEventStream)().push((0, (0, parcelRequire("iJHxx")).unsubscribeEvent)((0, (0, parcelRequire("fSTSz")).SUBSCRIBE_ALL), this.handleDoneBind));
                    const data = await this.exportData();
                    (0, (0, parcelRequire("eoXiD")).ufolog)('this.parent', this.parent);
                    (0, (0, parcelRequire("iJHxx")).getGlobalEventStream)().push((0, (0, parcelRequire("iJHxx")).experiencePayloadEvent)(data));
                }
                return true;
            }
            (0, (0, parcelRequire("eoXiD")).ufolog)(`TRANSITION: ${this.id} from ${this.state.id} to ${newState.id} unsuccessful`);
            (0, (0, parcelRequire("eoXiD")).ufowarn)(`transition of ${this.id} from ${this.state} to ${newState} is not possible`);
            return false;
        }
        async start(startTime) {
            const transitionSuccessful = await this.transition((0, (0, parcelRequire("lc9Xi")).UFOExperienceState).STARTED, startTime);
            if (transitionSuccessful) {
                this.pageVisibleState = $feec6df92685c668$var$getPageVisibleState();
                (0, (0, parcelRequire("3aRrh")).visibilityChangeObserver).subscribe(this.setPageVisibleStateToMixed);
                if (!this._isManualStateEnabled()) {
                    (0, (0, parcelRequire("eoXiD")).ufolog)('subscribed', this.id);
                    (0, (0, parcelRequire("iJHxx")).getGlobalEventStream)().push((0, (0, parcelRequire("iJHxx")).subscribeEvent)((0, (0, parcelRequire("fSTSz")).SUBSCRIBE_ALL), this.handleDoneBind));
                }
            }
        }
        mark(name, timestamp) {
            if (name !== (0, (0, parcelRequire("fSTSz")).FMP_MARK) && name !== (0, (0, parcelRequire("fSTSz")).INLINE_RESPONSE_MARK)) this._mark(name, timestamp);
            else (0, (0, parcelRequire("eoXiD")).ufowarn)('please use markFMP or markInlineResponse for specialised marks');
        }
        _mark(name, timestamp) {
            this.metrics.marks.push({
                name: name,
                time: $feec6df92685c668$export$c753e8669d30c8ad(timestamp)
            });
            this.transition((0, (0, parcelRequire("lc9Xi")).UFOExperienceState).IN_PROGRESS);
        }
        markFMP(timestamp) {
            this._mark((0, (0, parcelRequire("fSTSz")).FMP_MARK), timestamp);
        }
        markInlineResponse(timestamp) {
            this._mark((0, (0, parcelRequire("fSTSz")).INLINE_RESPONSE_MARK), timestamp);
        }
        _isManualStateEnabled() {
            return this.until === null;
        }
        _validateManualState() {
            if (!this._isManualStateEnabled()) {
                (0, (0, parcelRequire("eoXiD")).ufowarn)('manual change of state not allowed as "until" is defined');
                return false;
            }
            return true;
        }
        switchToEndState(state, config) {
            if (!config?.force && !this._validateManualState()) return null;
            if (config?.metadata) this.addMetadata(config.metadata);
            (0, (0, parcelRequire("3aRrh")).visibilityChangeObserver).unsubscribe(this.setPageVisibleStateToMixed);
            return this.transition(state);
        }
        async success(config) {
            return this.switchToEndState((0, (0, parcelRequire("lc9Xi")).UFOExperienceState).SUCCEEDED, config);
        }
        async failure(config) {
            return this.switchToEndState((0, (0, parcelRequire("lc9Xi")).UFOExperienceState).FAILED, config);
        }
        async abort(config) {
            return this.switchToEndState((0, (0, parcelRequire("lc9Xi")).UFOExperienceState).ABORTED, config);
        }
        addMetadata(data) {
            Object.assign(this.metadata, data);
        }
        _handleDoneExperience(data) {
            (0, (0, parcelRequire("eoXiD")).ufolog)('_handleDoneExperience in', this.id, data.state, data, this._until);
            if (data.state.final) {
                if (this._until !== null) {
                    const { done: done, state: state } = this._until(data);
                    if (done && !this.state.final) this.transition(state);
                }
            }
        }
        async getId() {
            return this.id;
        }
        async exportData() {
            return {
                id: await this.getId(),
                uuid: this.uuid,
                type: this.type,
                schemaVersion: (0, $356a3e48ee714997$export$2295b861f318254a) || 'unknown',
                performanceType: this.performanceType,
                category: this.category,
                state: this.state,
                metadata: {
                    ...this.metadata
                },
                metrics: {
                    ...this.metrics
                },
                children: [
                    ...this.childExperiences
                ],
                result: {
                    success: !!this.state.success,
                    startTime: this.metrics.startTime,
                    duration: (this.metrics.endTime || 0) - (this.metrics.startTime || 0)
                },
                platform: this.config.platform || null,
                pageVisibleState: this.pageVisibleState,
                featureFlags: this.featureFlags,
                isSSROutputAsFMP: this.isSSROutputAsFMP,
                timings: this.timings,
                explicitTimings: this.explicitTimings,
                performanceConfig: this.performanceConfig
            };
        }
        _reset() {
            this.parent = null;
            this.metadata = {};
            this.onDoneCallbacks = [];
            this.childExperiences = [];
            this.metrics = {
                startTime: null,
                endTime: null,
                marks: []
            };
            this._until = this.until ? this.until() : null;
        }
    }
});
const $356a3e48ee714997$export$2295b861f318254a = '0.1.5';
parcelRegister("ijH9f", function(module, exports) {
    $parcel$export(module.exports, "roundPerfNow", ()=>$0b1119ad19ca6f95$export$5f490af6b2b115cf);
    const $0b1119ad19ca6f95$export$5f490af6b2b115cf = ()=>~~performance.now();
});
parcelRegister("aqfim", function(module, exports) {
    $parcel$export(module.exports, "canTransition", ()=>$1ad4fd296053ba67$export$178881f329fdb81f);
    var $lc9Xi;
    const $1ad4fd296053ba67$var$UFOStateAvailableTransitions = {
        [(0, (0, parcelRequire("lc9Xi")).UFOExperienceState).NOT_STARTED.id]: [
            (0, (0, parcelRequire("lc9Xi")).UFOExperienceState).STARTED.id
        ],
        [(0, (0, parcelRequire("lc9Xi")).UFOExperienceState).STARTED.id]: [
            (0, (0, parcelRequire("lc9Xi")).UFOExperienceState).IN_PROGRESS.id,
            (0, (0, parcelRequire("lc9Xi")).UFOExperienceState).BLOCKED.id,
            (0, (0, parcelRequire("lc9Xi")).UFOExperienceState).SUCCEEDED.id,
            (0, (0, parcelRequire("lc9Xi")).UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
            (0, (0, parcelRequire("lc9Xi")).UFOExperienceState).FAILED.id,
            (0, (0, parcelRequire("lc9Xi")).UFOExperienceState).ABORTED.id
        ],
        [(0, (0, parcelRequire("lc9Xi")).UFOExperienceState).IN_PROGRESS.id]: [
            (0, (0, parcelRequire("lc9Xi")).UFOExperienceState).BLOCKED.id,
            (0, (0, parcelRequire("lc9Xi")).UFOExperienceState).SUCCEEDED.id,
            (0, (0, parcelRequire("lc9Xi")).UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
            (0, (0, parcelRequire("lc9Xi")).UFOExperienceState).FAILED.id,
            (0, (0, parcelRequire("lc9Xi")).UFOExperienceState).ABORTED.id
        ],
        [(0, (0, parcelRequire("lc9Xi")).UFOExperienceState).BLOCKED.id]: [
            (0, (0, parcelRequire("lc9Xi")).UFOExperienceState).RECOVERED.id,
            (0, (0, parcelRequire("lc9Xi")).UFOExperienceState).ABORTED.id
        ],
        [(0, (0, parcelRequire("lc9Xi")).UFOExperienceState).RECOVERED.id]: [
            (0, (0, parcelRequire("lc9Xi")).UFOExperienceState).STARTED.id,
            (0, (0, parcelRequire("lc9Xi")).UFOExperienceState).SUCCEEDED.id,
            (0, (0, parcelRequire("lc9Xi")).UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
            (0, (0, parcelRequire("lc9Xi")).UFOExperienceState).FAILED.id,
            (0, (0, parcelRequire("lc9Xi")).UFOExperienceState).ABORTED.id
        ],
        [(0, (0, parcelRequire("lc9Xi")).UFOExperienceState).SUCCEEDED.id]: [
            (0, (0, parcelRequire("lc9Xi")).UFOExperienceState).STARTED.id
        ],
        [(0, (0, parcelRequire("lc9Xi")).UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id]: [
            (0, (0, parcelRequire("lc9Xi")).UFOExperienceState).SUCCEEDED.id,
            (0, (0, parcelRequire("lc9Xi")).UFOExperienceState).FAILED.id,
            (0, (0, parcelRequire("lc9Xi")).UFOExperienceState).ABORTED.id
        ],
        [(0, (0, parcelRequire("lc9Xi")).UFOExperienceState).FAILED.id]: [
            (0, (0, parcelRequire("lc9Xi")).UFOExperienceState).STARTED.id
        ],
        [(0, (0, parcelRequire("lc9Xi")).UFOExperienceState).ABORTED.id]: [
            (0, (0, parcelRequire("lc9Xi")).UFOExperienceState).STARTED.id
        ]
    };
    const $1ad4fd296053ba67$export$178881f329fdb81f = (state1, state2)=>{
        return $1ad4fd296053ba67$var$UFOStateAvailableTransitions[state1.id] && $1ad4fd296053ba67$var$UFOStateAvailableTransitions[state1.id].includes(state2.id);
    };
});
parcelRegister("8OuDJ", function(module, exports) {
    $parcel$export(module.exports, "PageSegmentExperienceTypes", ()=>$d503287aeff5c694$export$17d97452062ccf73);
    const $d503287aeff5c694$export$17d97452062ccf73 = {
        NAVIGATION: 'NAVIGATION',
        PRODUCT: 'PRODUCT',
        COMPONENT: 'COMPONENT'
    };
});
parcelRegister("dGrdR", function(module, exports) {
    $parcel$export(module.exports, "metrics", ()=>$61d987f8a2b40232$export$b0c5c2fac8144e54);
    var $e0JCa;
    var $FEKPs;
    const $61d987f8a2b40232$export$b0c5c2fac8144e54 = {
        pageLoad: (0, parcelRequire("FEKPs")).pageLoad,
        pageSegmentLoad: (0, parcelRequire("FEKPs")).pageSegmentLoad,
        interaction: (0, parcelRequire("FEKPs")).interaction,
        custom: (0, parcelRequire("FEKPs")).custom,
        concurrent: (0, parcelRequire("e0JCa")).concurrent
    };
});
parcelRegister("e0JCa", function(module, exports) {
    $parcel$export(module.exports, "concurrent", ()=>$50ff45ae01d4cc6c$export$370df09ecc3de059);
    var $2OjhD;
    var $FEKPs;
    const $50ff45ae01d4cc6c$var$concurrentMetrics = {};
    const $50ff45ae01d4cc6c$var$getKey = (config, type)=>`${type}--${config.key}`;
    const $50ff45ae01d4cc6c$var$validateConfig = (config)=>{
        if (config.include) throw new Error('"include" is not supported in concurrent actions');
        if (config.until) throw new Error('"until" is not supported in concurrent actions');
    };
    const $50ff45ae01d4cc6c$var$ensurePath = (config, type)=>{
        const key = $50ff45ae01d4cc6c$var$getKey(config, type);
        if (!(key in $50ff45ae01d4cc6c$var$concurrentMetrics)) $50ff45ae01d4cc6c$var$concurrentMetrics[key] = {};
    };
    const $50ff45ae01d4cc6c$var$getMetricFromCache = (concurrentId, config, type)=>{
        const concurrentKey = $50ff45ae01d4cc6c$var$getKey(config, type);
        if (concurrentKey in $50ff45ae01d4cc6c$var$concurrentMetrics && $50ff45ae01d4cc6c$var$concurrentMetrics[concurrentKey][String(concurrentId)]) return $50ff45ae01d4cc6c$var$concurrentMetrics[concurrentKey][String(concurrentId)];
        if (!(concurrentKey in $50ff45ae01d4cc6c$var$concurrentMetrics)) $50ff45ae01d4cc6c$var$concurrentMetrics[concurrentKey] = {};
    };
    const $50ff45ae01d4cc6c$var$makeConcurrentMetric = (concurrentId, config, type)=>{
        $50ff45ae01d4cc6c$var$validateConfig(config);
        $50ff45ae01d4cc6c$var$ensurePath(config, type);
        const metricFromCache = $50ff45ae01d4cc6c$var$getMetricFromCache(concurrentId, config, type);
        if (metricFromCache) return metricFromCache;
        const metricFactory = type === (0, (0, parcelRequire("2OjhD")).BMEventsType).INLINE_RESULT ? (0, (0, parcelRequire("FEKPs")).interaction) : (0, (0, parcelRequire("FEKPs")).custom);
        const metric = metricFactory(config);
        $50ff45ae01d4cc6c$var$concurrentMetrics[$50ff45ae01d4cc6c$var$getKey(config, type)][String(concurrentId)] = metric;
        return metric;
    };
    const $50ff45ae01d4cc6c$export$370df09ecc3de059 = {
        pageSegmentLoad: (config)=>(concurrentId)=>$50ff45ae01d4cc6c$var$makeConcurrentMetric(concurrentId, {
                    ...config
                }, (0, (0, parcelRequire("2OjhD")).BMEventsType).PAGE_SEGMENT_LOAD),
        interaction: (config)=>(concurrentId)=>$50ff45ae01d4cc6c$var$makeConcurrentMetric(concurrentId, {
                    ...config
                }, (0, (0, parcelRequire("2OjhD")).BMEventsType).INLINE_RESULT),
        custom: (config)=>(concurrentId)=>$50ff45ae01d4cc6c$var$makeConcurrentMetric(concurrentId, {
                    ...config
                }, (0, (0, parcelRequire("2OjhD")).BMEventsType).CUSTOM)
    };
});
parcelRegister("FEKPs", function(module, exports) {
    $parcel$export(module.exports, "pageLoad", ()=>$2453836fd9363fae$export$791d520f7e8058a5);
    $parcel$export(module.exports, "pageSegmentLoad", ()=>$2453836fd9363fae$export$94114666844d5f66);
    $parcel$export(module.exports, "interaction", ()=>$2453836fd9363fae$export$92473e6020ad89b4);
    $parcel$export(module.exports, "custom", ()=>$2453836fd9363fae$export$4c00f665f0d4b443);
    var $7WP2K;
    var $5jIc1;
    var $5JtK5;
    var $2OjhD;
    const $2453836fd9363fae$export$791d520f7e8058a5 = (config)=>{
        return new (0, (0, parcelRequire("5jIc1")).PageLoadMetric)({
            ...config,
            type: (0, (0, parcelRequire("2OjhD")).BMEventsType).PAGE_LOAD
        });
    };
    const $2453836fd9363fae$export$94114666844d5f66 = (config)=>{
        return new (0, (0, parcelRequire("5JtK5")).PageSegmentLoadMetric)({
            ...config,
            type: (0, (0, parcelRequire("2OjhD")).BMEventsType).PAGE_SEGMENT_LOAD
        });
    };
    const $2453836fd9363fae$export$92473e6020ad89b4 = (config)=>{
        return new (0, (0, parcelRequire("7WP2K")).Metric)({
            ...config,
            type: (0, (0, parcelRequire("2OjhD")).BMEventsType).INLINE_RESULT
        });
    };
    const $2453836fd9363fae$export$4c00f665f0d4b443 = (config)=>{
        return new (0, (0, parcelRequire("7WP2K")).Metric)({
            ...config,
            type: (0, (0, parcelRequire("2OjhD")).BMEventsType).CUSTOM
        });
    };
});
parcelRegister("7WP2K", function(module, exports) {
    $parcel$export(module.exports, "Metric", ()=>$8418d1a2eefca193$export$efdd3e096bc27746);
    var $dNz07;
    var $9mLUv;
    var $faqZ3;
    class $8418d1a2eefca193$export$efdd3e096bc27746 extends (0, (0, parcelRequire("faqZ3")).BaseMetric) {
        start({ startTime: startTime } = {}) {
            super.start({
                startTime: startTime
            });
            this.route = (0, (0, parcelRequire("dNz07")).Route).getRoute();
        }
        stop(params = {}) {
            const stoppedSuccessfully = super.stop(params);
            if (stoppedSuccessfully && !this.config.virtual) (0, (0, parcelRequire("9mLUv")).submitter).queue(this.getData());
            return stoppedSuccessfully;
        }
    }
});
parcelRegister("5jIc1", function(module, exports) {
    $parcel$export(module.exports, "PageLoadMetric", ()=>$c2cc5063230743d5$export$3c51073271a9eac3);
    var $Y0qGc;
    var $1a316;
    var $dNz07;
    var $9mLUv;
    var $2OjhD;
    var $hjsyZ;
    var $7cRo8;
    var $3bF54;
    class $c2cc5063230743d5$export$3c51073271a9eac3 extends (0, (0, parcelRequire("hjsyZ")).BasePageLoadMetric) {
        startPageLoad(params = {
            isInitial: false
        }) {
            (0, (0, parcelRequire("7cRo8")).pageLoadMetaMetric).startPageLoad({
                ...params,
                cancelStarted: 'startTime' in params
            });
            this.watchUntil();
        }
        stop(params = {}) {
            const stopTime = params.stopTime || window.performance.now();
            const pageLoadData = (0, (0, parcelRequire("7cRo8")).pageLoadMetaMetric).getDataToMerge();
            const metaMetricStopped = (0, (0, parcelRequire("7cRo8")).pageLoadMetaMetric).stop(params);
            if (!metaMetricStopped) return false;
            if (pageLoadData.isInitial && this.config.ssr?.doneAsFmp) {
                if (!this.marks[(0, (0, parcelRequire("hjsyZ")).BasePageLoadMetric).FMP]) {
                    const mark = (0, (0, parcelRequire("Y0qGc")).SSRGetDoneMark).getDoneMark();
                    if (mark) (0, (0, parcelRequire("7cRo8")).pageLoadMetaMetric).markFMP(mark);
                } else (0, (0, parcelRequire("7cRo8")).pageLoadMetaMetric).markFMP(this.marks[(0, (0, parcelRequire("hjsyZ")).BasePageLoadMetric).FMP]);
            }
            this.route = (0, (0, parcelRequire("dNz07")).Route).getRoute();
            const metricStopped = this.stopPageLoad(pageLoadData, {
                ...params,
                stopTime: stopTime
            });
            if (!metricStopped) return false;
            const data = this.getData();
            if (!this.config.virtual) (0, (0, parcelRequire("9mLUv")).submitter).queue(data);
            (0, (0, parcelRequire("1a316")).logger).logCond(!!this.config.debug, 'page-load', 'stop', this.getData);
            this.enqueueWebVitals();
            return true;
        }
        mark(mark, timestamp = window.performance.now()) {
            (0, (0, parcelRequire("7cRo8")).pageLoadMetaMetric).mark(mark, timestamp);
        }
        markFMP(timestamp) {
            (0, (0, parcelRequire("7cRo8")).pageLoadMetaMetric).markFMP(timestamp);
        }
        getData() {
            const pageLoadMetaData = (0, (0, parcelRequire("7cRo8")).pageLoadMetaMetric).getData();
            return {
                ...super.getData(),
                marks: pageLoadMetaData.marks,
                explicitTimings: pageLoadMetaData.explicitTimings
            };
        }
        async enqueueWebVitals() {
            if (this.config.virtual || !this.isInitial) return false;
            const configChunk = await (0, (0, parcelRequire("9mLUv")).submitter).config.configChunk;
            if (!configChunk?.[(0, (0, parcelRequire("2OjhD")).BMEventsType).WEB_VITALS].webVitals?.enabled) return false;
            const webVitalMetric = new (0, (0, parcelRequire("3bF54")).WebVitalsMetric)({
                key: this.config.key,
                route: this.route,
                startTime: this.startTime,
                stopTime: this.stopTime,
                pageVisibleState: this.pageVisibleState
            });
            (0, (0, parcelRequire("9mLUv")).submitter).queue(webVitalMetric.getData());
            (0, (0, parcelRequire("1a316")).logger).logCond(!!this.config.debug, 'web-vitals', webVitalMetric.getData);
            return true;
        }
    }
});
parcelRegister("3bF54", function(module, exports) {
    $parcel$export(module.exports, "WebVitalsMetric", ()=>$e10632e38915f687$export$dc0d85d4d6503cd7);
    var $2OjhD;
    var $faqZ3;
    class $e10632e38915f687$export$dc0d85d4d6503cd7 extends (0, (0, parcelRequire("faqZ3")).BaseMetric) {
        constructor({ key: key, route: route, startTime: startTime, stopTime: stopTime, pageVisibleState: pageVisibleState }){
            super({
                type: (0, (0, parcelRequire("2OjhD")).BMEventsType).WEB_VITALS,
                key: key
            });
            this.route = route;
            this.startTime = startTime;
            this.stopTime = stopTime;
            this.state = (0, (0, parcelRequire("faqZ3")).MetricState).FINISHED;
            this.pageVisibleState = pageVisibleState;
        }
    }
});
parcelRegister("5JtK5", function(module, exports) {
    $parcel$export(module.exports, "PageSegmentLoadMetric", ()=>$868251c1eede1606$export$24c8bfcd77494cc1);
    var $Y0qGc;
    var $2OjhD;
    var $faqZ3;
    var $7WP2K;
    var $7cRo8;
    class $868251c1eede1606$export$24c8bfcd77494cc1 extends (0, (0, parcelRequire("7WP2K")).Metric) {
        static{
            this.FMP = 'fmp';
        }
        constructor(config){
            super(config), this.isInitial = true;
            this.config = config;
        }
        startFromPageLoad() {
            const pageLoadMetaData = (0, (0, parcelRequire("7cRo8")).pageLoadMetaMetric).getData();
            this.start({
                startTime: pageLoadMetaData.start ?? undefined
            });
            this.isInitial = pageLoadMetaData.isInitial;
            this.pageVisibleState = pageLoadMetaData.pageVisibleState;
        }
        mark(mark, timestamp = window.performance.now()) {
            if (mark === $868251c1eede1606$export$24c8bfcd77494cc1.FMP) return;
            super.mark(mark, timestamp);
        }
        markFMP(timestamp) {
            super.mark($868251c1eede1606$export$24c8bfcd77494cc1.FMP, timestamp);
        }
        getPageSegmentLoadData() {
            return {
                isInitial: this.isInitial
            };
        }
        getData() {
            return {
                ...super.getData(),
                ...this.getPageSegmentLoadData()
            };
        }
        getDataToMerge() {
            return {
                ...super.getDataToMerge(),
                ...this.getPageSegmentLoadData()
            };
        }
        merge(mergeData) {
            super.merge(mergeData);
            this.isInitial = mergeData.isInitial;
        }
        stop(params = {}) {
            const pageLoadData = (0, (0, parcelRequire("7cRo8")).pageLoadMetaMetric).getData();
            if (pageLoadData.isInitial && this.config.ssr?.doneAsFmp) {
                if (!this.marks[$868251c1eede1606$export$24c8bfcd77494cc1.FMP]) {
                    const mark = (0, (0, parcelRequire("Y0qGc")).SSRGetDoneMark).getDoneMark();
                    if (mark) this.markFMP(mark);
                }
            }
            if (this.config.includePageLoadTimings !== (0, (0, parcelRequire("2OjhD")).PageSegmentPageLoadMetricsOptions).WAIT_UNTIL_PRESENT || pageLoadData.state === (0, (0, parcelRequire("faqZ3")).MetricState).FINISHED) return super.stop(params);
            const now = performance.now();
            if (pageLoadData.state === (0, (0, parcelRequire("faqZ3")).MetricState).STARTED) (0, (0, parcelRequire("7cRo8")).pageLoadMetaMetric).onStop(()=>{
                super.stop({
                    ...params,
                    stopTime: params.stopTime || now
                });
            }, ()=>{
                this.cancel();
            });
            return true;
        }
    }
});
parcelRegister("dGvGJ", function(module, exports) {
    $parcel$export(module.exports, "defaultMemoize", ()=>$9f67c73d64e1d92a$export$281bff7f05488aa2, (v)=>$9f67c73d64e1d92a$export$281bff7f05488aa2 = v);
    $parcel$export(module.exports, "createSelectorCreator", ()=>$9f67c73d64e1d92a$export$5943f4447f6ef248, (v)=>$9f67c73d64e1d92a$export$5943f4447f6ef248 = v);
    $parcel$export(module.exports, "createStructuredSelector", ()=>$9f67c73d64e1d92a$export$75979cfcd91bf38f, (v)=>$9f67c73d64e1d92a$export$75979cfcd91bf38f = v);
    $parcel$export(module.exports, "createSelector", ()=>$9f67c73d64e1d92a$export$595d22ed68ca2841, (v)=>$9f67c73d64e1d92a$export$595d22ed68ca2841 = v);
    var $9f67c73d64e1d92a$export$1e511d4a378977f5;
    var $9f67c73d64e1d92a$export$281bff7f05488aa2;
    var $9f67c73d64e1d92a$export$5943f4447f6ef248;
    var $9f67c73d64e1d92a$export$75979cfcd91bf38f;
    var $9f67c73d64e1d92a$export$595d22ed68ca2841;
    'use strict';
    $9f67c73d64e1d92a$export$1e511d4a378977f5 = true;
    $9f67c73d64e1d92a$export$281bff7f05488aa2 = $9f67c73d64e1d92a$var$defaultMemoize;
    $9f67c73d64e1d92a$export$5943f4447f6ef248 = $9f67c73d64e1d92a$var$createSelectorCreator;
    $9f67c73d64e1d92a$export$75979cfcd91bf38f = $9f67c73d64e1d92a$var$createStructuredSelector;
    function $9f67c73d64e1d92a$var$defaultEqualityCheck(a, b) {
        return a === b;
    }
    function $9f67c73d64e1d92a$var$areArgumentsShallowlyEqual(equalityCheck, prev, next) {
        if (prev === null || next === null || prev.length !== next.length) return false;
        var length = prev.length;
        for(var i = 0; i < length; i++){
            if (!equalityCheck(prev[i], next[i])) return false;
        }
        return true;
    }
    function $9f67c73d64e1d92a$var$defaultMemoize(func) {
        var equalityCheck = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $9f67c73d64e1d92a$var$defaultEqualityCheck;
        var lastArgs = null;
        var lastResult = null;
        return function() {
            if (!$9f67c73d64e1d92a$var$areArgumentsShallowlyEqual(equalityCheck, lastArgs, arguments)) lastResult = func.apply(null, arguments);
            lastArgs = arguments;
            return lastResult;
        };
    }
    function $9f67c73d64e1d92a$var$getDependencies(funcs) {
        var dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;
        if (!dependencies.every(function(dep) {
            return typeof dep === 'function';
        })) {
            var dependencyTypes = dependencies.map(function(dep) {
                return typeof dep;
            }).join(', ');
            throw new Error('Selector creators expect all input-selectors to be functions, ' + ('instead received the following types: [' + dependencyTypes + ']'));
        }
        return dependencies;
    }
    function $9f67c73d64e1d92a$var$createSelectorCreator(memoize) {
        for(var _len = arguments.length, memoizeOptions = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)memoizeOptions[_key - 1] = arguments[_key];
        return function() {
            for(var _len2 = arguments.length, funcs = Array(_len2), _key2 = 0; _key2 < _len2; _key2++)funcs[_key2] = arguments[_key2];
            var recomputations = 0;
            var resultFunc = funcs.pop();
            var dependencies = $9f67c73d64e1d92a$var$getDependencies(funcs);
            var memoizedResultFunc = memoize.apply(undefined, [
                function() {
                    recomputations++;
                    return resultFunc.apply(null, arguments);
                }
            ].concat(memoizeOptions));
            var selector = $9f67c73d64e1d92a$var$defaultMemoize(function() {
                var params = [];
                var length = dependencies.length;
                for(var i = 0; i < length; i++)params.push(dependencies[i].apply(null, arguments));
                return memoizedResultFunc.apply(null, params);
            });
            selector.resultFunc = resultFunc;
            selector.recomputations = function() {
                return recomputations;
            };
            selector.resetRecomputations = function() {
                return recomputations = 0;
            };
            return selector;
        };
    }
    var $9f67c73d64e1d92a$var$createSelector = $9f67c73d64e1d92a$export$595d22ed68ca2841 = $9f67c73d64e1d92a$var$createSelectorCreator($9f67c73d64e1d92a$var$defaultMemoize);
    function $9f67c73d64e1d92a$var$createStructuredSelector(selectors) {
        var selectorCreator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $9f67c73d64e1d92a$var$createSelector;
        if (typeof selectors !== 'object') throw new Error('createStructuredSelector expects first argument to be an object ' + ('where each property is a selector, instead received a ' + typeof selectors));
        var objectKeys = Object.keys(selectors);
        return selectorCreator(objectKeys.map(function(key) {
            return selectors[key];
        }), function() {
            for(var _len3 = arguments.length, values = Array(_len3), _key3 = 0; _key3 < _len3; _key3++)values[_key3] = arguments[_key3];
            return values.reduce(function(composition, value, index) {
                composition[objectKeys[index]] = value;
                return composition;
            }, {});
        });
    }
});
parcelRegister("kvQVg", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    var $3VFsf;
    (0, parcelRequire("3VFsf")).__exportStar((parcelRequire("9bqcp")), module.exports);
});
parcelRegister("9bqcp", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.doesMeetConditions = void 0;
    var $cwXxX = parcelRequire("cwXxX");
    var $6af976c25597e9d4$var$AND_OPERATION = 'and';
    var $6af976c25597e9d4$var$OR_OPERATION = 'or';
    var $6af976c25597e9d4$var$NOT_OPERATION = 'not';
    var $6af976c25597e9d4$var$SUPPORTED_OPERATIONS = [
        $6af976c25597e9d4$var$AND_OPERATION,
        $6af976c25597e9d4$var$OR_OPERATION,
        $6af976c25597e9d4$var$NOT_OPERATION
    ];
    var $6af976c25597e9d4$var$SKIP_INSTRUCTION = 'skip';
    var $6af976c25597e9d4$var$isObject = function(x) {
        return Object.prototype.toString.call(x) === '[object Object]';
    };
    var $6af976c25597e9d4$var$unhandledOperation = function(operation) {
        throw new Error($cwXxX.errors.unhandledOperation(operation));
    };
    var $6af976c25597e9d4$var$checkOperation = function(conditionsInput, staticContextInput, operation, nesting) {
        if (nesting === void 0) nesting = 0;
        if (nesting >= 10) throw Error($cwXxX.errors.nestingOvercomplicated());
        var conditions = $6af976c25597e9d4$var$isObject(conditionsInput) ? conditionsInput : {};
        var staticContext = $6af976c25597e9d4$var$isObject(staticContextInput) ? staticContextInput : {};
        var staticKeys = Object.keys(conditions).filter(function(key) {
            return !$6af976c25597e9d4$var$SUPPORTED_OPERATIONS.includes(key);
        });
        var operationEntries = Object.entries(conditions).filter(function(_a) {
            var key = _a[0];
            return $6af976c25597e9d4$var$SUPPORTED_OPERATIONS.includes(key);
        });
        var staticKeysLength = staticKeys.length;
        var operationsLength = operationEntries.length;
        var staticEqualityComparator = function(key) {
            return (Array.isArray(conditions[key]) ? conditions[key] : [
                conditions[key]
            ]).includes(staticContext[key]);
        };
        if (staticKeysLength === 0 && operationsLength === 0) return $6af976c25597e9d4$var$SKIP_INSTRUCTION;
        if (staticKeysLength !== 0) switch(operation){
            case $6af976c25597e9d4$var$AND_OPERATION:
                if (!staticKeys.every(staticEqualityComparator)) return false;
                break;
            case $6af976c25597e9d4$var$OR_OPERATION:
                if (staticKeys.some(staticEqualityComparator)) return true;
                break;
            case $6af976c25597e9d4$var$NOT_OPERATION:
                if (staticKeys.some(function(key) {
                    return !staticEqualityComparator(key);
                })) return true;
                break;
            default:
                return $6af976c25597e9d4$var$unhandledOperation(operation);
        }
        for(var index = 0; index < operationEntries.length; index += 1){
            var _a = operationEntries[index], nextOperation = _a[0], nextConditions = _a[1];
            var nextOperationResult = $6af976c25597e9d4$var$checkOperation(nextConditions, staticContext, nextOperation, nesting + 1);
            switch(operation){
                case $6af976c25597e9d4$var$AND_OPERATION:
                    if (nextOperationResult === false) return false;
                    if (nextOperationResult === $6af976c25597e9d4$var$SKIP_INSTRUCTION && operationsLength === 1) return staticKeysLength === 0 ? $6af976c25597e9d4$var$SKIP_INSTRUCTION : true;
                    break;
                case $6af976c25597e9d4$var$OR_OPERATION:
                    if (nextOperationResult === true) return true;
                    if (nextOperationResult === $6af976c25597e9d4$var$SKIP_INSTRUCTION && operationsLength === 1) return staticKeysLength === 0 ? $6af976c25597e9d4$var$SKIP_INSTRUCTION : false;
                    break;
                case $6af976c25597e9d4$var$NOT_OPERATION:
                    if (nextOperationResult === false) return true;
                    if (nextOperationResult === $6af976c25597e9d4$var$SKIP_INSTRUCTION && operationsLength === 1) return staticKeysLength === 0 ? $6af976c25597e9d4$var$SKIP_INSTRUCTION : false;
                    break;
                default:
                    return $6af976c25597e9d4$var$unhandledOperation(operation);
            }
        }
        switch(operation){
            case $6af976c25597e9d4$var$AND_OPERATION:
                return true;
            case $6af976c25597e9d4$var$OR_OPERATION:
                return false;
            case $6af976c25597e9d4$var$NOT_OPERATION:
                return false;
            default:
                return $6af976c25597e9d4$var$unhandledOperation(operation);
        }
    };
    module.exports.doesMeetConditions = function(conditions, staticContext) {
        try {
            var result = $6af976c25597e9d4$var$checkOperation(conditions, staticContext, $6af976c25597e9d4$var$AND_OPERATION);
            return result === $6af976c25597e9d4$var$SKIP_INSTRUCTION ? true : result;
        } catch (_a) {
            return false;
        }
    };
});
parcelRegister("cwXxX", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.errors = void 0;
    module.exports.errors = {
        nestingOvercomplicated: function() {
            return 'Nesting of display conditions exceeds 10 levels';
        },
        unhandledOperation: function(operation) {
            return "Unhandled operation: " + operation;
        }
    };
});
parcelRegister("fKgem", function(module, exports) {
    module.exports = $b767bdf46d56eeb2$var$defaultsPlugin;
    function $b767bdf46d56eeb2$var$defaultsPlugin() {
        var defaultValues = {};
        return {
            defaults: defaults,
            get: get
        };
        function defaults(_, values) {
            defaultValues = values;
        }
        function get(super_fn, key) {
            var val = super_fn();
            return val !== undefined ? val : defaultValues[key];
        }
    }
});
parcelRegister("kzObv", function(module, exports) {
    var $efae012046e18468$var$namespace = 'expire_mixin';
    module.exports = $efae012046e18468$var$expirePlugin;
    function $efae012046e18468$var$expirePlugin() {
        var expirations = this.createStore(this.storage, null, this._namespacePrefix + $efae012046e18468$var$namespace);
        return {
            set: expire_set,
            get: expire_get,
            remove: expire_remove,
            getExpiration: getExpiration,
            removeExpiredKeys: removeExpiredKeys
        };
        function expire_set(super_fn, key, val, expiration) {
            if (!this.hasNamespace($efae012046e18468$var$namespace)) expirations.set(key, expiration);
            return super_fn();
        }
        function expire_get(super_fn, key) {
            if (!this.hasNamespace($efae012046e18468$var$namespace)) _checkExpiration.call(this, key);
            return super_fn();
        }
        function expire_remove(super_fn, key) {
            if (!this.hasNamespace($efae012046e18468$var$namespace)) expirations.remove(key);
            return super_fn();
        }
        function getExpiration(_, key) {
            return expirations.get(key);
        }
        function removeExpiredKeys(_) {
            var keys = [];
            this.each(function(val, key) {
                keys.push(key);
            });
            for(var i = 0; i < keys.length; i++)_checkExpiration.call(this, keys[i]);
        }
        function _checkExpiration(key) {
            var expiration = expirations.get(key, Number.MAX_VALUE);
            if (expiration <= new Date().getTime()) {
                this.raw.remove(key);
                expirations.remove(key);
            }
        }
    }
});
parcelRegister("c4CII", function(module, exports) {
    var $dgvY6 = parcelRequire("dgvY6");
    var $8ca3e4c5fdf5089f$var$slice = $dgvY6.slice;
    var $8ca3e4c5fdf5089f$var$pluck = $dgvY6.pluck;
    var $8ca3e4c5fdf5089f$var$each = $dgvY6.each;
    var $8ca3e4c5fdf5089f$var$bind = $dgvY6.bind;
    var $8ca3e4c5fdf5089f$var$create = $dgvY6.create;
    var $8ca3e4c5fdf5089f$var$isList = $dgvY6.isList;
    var $8ca3e4c5fdf5089f$var$isFunction = $dgvY6.isFunction;
    var $8ca3e4c5fdf5089f$var$isObject = $dgvY6.isObject;
    module.exports = {
        createStore: $8ca3e4c5fdf5089f$var$createStore
    };
    var $8ca3e4c5fdf5089f$var$storeAPI = {
        version: '2.0.12',
        enabled: false,
        get: function(key, optionalDefaultValue) {
            var data = this.storage.read(this._namespacePrefix + key);
            return this._deserialize(data, optionalDefaultValue);
        },
        set: function(key, value) {
            if (value === undefined) return this.remove(key);
            this.storage.write(this._namespacePrefix + key, this._serialize(value));
            return value;
        },
        remove: function(key) {
            this.storage.remove(this._namespacePrefix + key);
        },
        each: function(callback) {
            var self = this;
            this.storage.each(function(val, namespacedKey) {
                callback.call(self, self._deserialize(val), (namespacedKey || '').replace(self._namespaceRegexp, ''));
            });
        },
        clearAll: function() {
            this.storage.clearAll();
        },
        hasNamespace: function(namespace) {
            return this._namespacePrefix == '__storejs_' + namespace + '_';
        },
        createStore: function() {
            return $8ca3e4c5fdf5089f$var$createStore.apply(this, arguments);
        },
        addPlugin: function(plugin) {
            this._addPlugin(plugin);
        },
        namespace: function(namespace) {
            return $8ca3e4c5fdf5089f$var$createStore(this.storage, this.plugins, namespace);
        }
    };
    function $8ca3e4c5fdf5089f$var$_warn() {
        var _console = typeof console == 'undefined' ? null : console;
        if (!_console) return;
        var fn = _console.warn ? _console.warn : _console.log;
        fn.apply(_console, arguments);
    }
    function $8ca3e4c5fdf5089f$var$createStore(storages, plugins, namespace) {
        if (!namespace) namespace = '';
        if (storages && !$8ca3e4c5fdf5089f$var$isList(storages)) storages = [
            storages
        ];
        if (plugins && !$8ca3e4c5fdf5089f$var$isList(plugins)) plugins = [
            plugins
        ];
        var namespacePrefix = namespace ? '__storejs_' + namespace + '_' : '';
        var namespaceRegexp = namespace ? new RegExp('^' + namespacePrefix) : null;
        var legalNamespaces = /^[a-zA-Z0-9_\-]*$/;
        if (!legalNamespaces.test(namespace)) throw new Error('store.js namespaces can only have alphanumerics + underscores and dashes');
        var _privateStoreProps = {
            _namespacePrefix: namespacePrefix,
            _namespaceRegexp: namespaceRegexp,
            _testStorage: function(storage) {
                try {
                    var testStr = '__storejs__test__';
                    storage.write(testStr, testStr);
                    var ok = storage.read(testStr) === testStr;
                    storage.remove(testStr);
                    return ok;
                } catch (e) {
                    return false;
                }
            },
            _assignPluginFnProp: function(pluginFnProp, propName) {
                var oldFn = this[propName];
                this[propName] = function pluginFn() {
                    var args = $8ca3e4c5fdf5089f$var$slice(arguments, 0);
                    var self = this;
                    function super_fn() {
                        if (!oldFn) return;
                        $8ca3e4c5fdf5089f$var$each(arguments, function(arg, i) {
                            args[i] = arg;
                        });
                        return oldFn.apply(self, args);
                    }
                    var newFnArgs = [
                        super_fn
                    ].concat(args);
                    return pluginFnProp.apply(self, newFnArgs);
                };
            },
            _serialize: function(obj) {
                return JSON.stringify(obj);
            },
            _deserialize: function(strVal, defaultVal) {
                if (!strVal) return defaultVal;
                var val = '';
                try {
                    val = JSON.parse(strVal);
                } catch (e) {
                    val = strVal;
                }
                return val !== undefined ? val : defaultVal;
            },
            _addStorage: function(storage) {
                if (this.enabled) return;
                if (this._testStorage(storage)) {
                    this.storage = storage;
                    this.enabled = true;
                }
            },
            _addPlugin: function(plugin) {
                var self = this;
                if ($8ca3e4c5fdf5089f$var$isList(plugin)) {
                    $8ca3e4c5fdf5089f$var$each(plugin, function(plugin) {
                        self._addPlugin(plugin);
                    });
                    return;
                }
                var seenPlugin = $8ca3e4c5fdf5089f$var$pluck(this.plugins, function(seenPlugin) {
                    return plugin === seenPlugin;
                });
                if (seenPlugin) return;
                this.plugins.push(plugin);
                if (!$8ca3e4c5fdf5089f$var$isFunction(plugin)) throw new Error('Plugins must be function values that return objects');
                var pluginProperties = plugin.call(this);
                if (!$8ca3e4c5fdf5089f$var$isObject(pluginProperties)) throw new Error('Plugins must return an object of function properties');
                $8ca3e4c5fdf5089f$var$each(pluginProperties, function(pluginFnProp, propName) {
                    if (!$8ca3e4c5fdf5089f$var$isFunction(pluginFnProp)) throw new Error('Bad plugin property: ' + propName + ' from plugin ' + plugin.name + '. Plugins should only return functions.');
                    self._assignPluginFnProp(pluginFnProp, propName);
                });
            },
            addStorage: function(storage) {
                $8ca3e4c5fdf5089f$var$_warn('store.addStorage(storage) is deprecated. Use createStore([storages])');
                this._addStorage(storage);
            }
        };
        var store = $8ca3e4c5fdf5089f$var$create(_privateStoreProps, $8ca3e4c5fdf5089f$var$storeAPI, {
            plugins: []
        });
        store.raw = {};
        $8ca3e4c5fdf5089f$var$each(store, function(prop, propName) {
            if ($8ca3e4c5fdf5089f$var$isFunction(prop)) store.raw[propName] = $8ca3e4c5fdf5089f$var$bind(store, prop);
        });
        $8ca3e4c5fdf5089f$var$each(storages, function(storage) {
            store._addStorage(storage);
        });
        $8ca3e4c5fdf5089f$var$each(plugins, function(plugin) {
            store._addPlugin(plugin);
        });
        return store;
    }
});
parcelRegister("dgvY6", function(module, exports) {
    var $9a85913e079cf886$var$assign = $9a85913e079cf886$var$make_assign();
    var $9a85913e079cf886$var$create = $9a85913e079cf886$var$make_create();
    var $9a85913e079cf886$var$trim = $9a85913e079cf886$var$make_trim();
    var $9a85913e079cf886$var$Global = typeof window !== 'undefined' ? window : $parcel$global;
    module.exports = {
        assign: $9a85913e079cf886$var$assign,
        create: $9a85913e079cf886$var$create,
        trim: $9a85913e079cf886$var$trim,
        bind: $9a85913e079cf886$var$bind,
        slice: $9a85913e079cf886$var$slice,
        each: $9a85913e079cf886$var$each,
        map: $9a85913e079cf886$var$map,
        pluck: $9a85913e079cf886$var$pluck,
        isList: $9a85913e079cf886$var$isList,
        isFunction: $9a85913e079cf886$var$isFunction,
        isObject: $9a85913e079cf886$var$isObject,
        Global: $9a85913e079cf886$var$Global
    };
    function $9a85913e079cf886$var$make_assign() {
        if (Object.assign) return Object.assign;
        else return function shimAssign(obj, props1, props2, etc) {
            for(var i = 1; i < arguments.length; i++)$9a85913e079cf886$var$each(Object(arguments[i]), function(val, key) {
                obj[key] = val;
            });
            return obj;
        };
    }
    function $9a85913e079cf886$var$make_create() {
        if (Object.create) return function create(obj, assignProps1, assignProps2, etc) {
            var assignArgsList = $9a85913e079cf886$var$slice(arguments, 1);
            return $9a85913e079cf886$var$assign.apply(this, [
                Object.create(obj)
            ].concat(assignArgsList));
        };
        else {
            function F() {}
            return function create(obj, assignProps1, assignProps2, etc) {
                var assignArgsList = $9a85913e079cf886$var$slice(arguments, 1);
                F.prototype = obj;
                return $9a85913e079cf886$var$assign.apply(this, [
                    new F()
                ].concat(assignArgsList));
            };
        }
    }
    function $9a85913e079cf886$var$make_trim() {
        if (String.prototype.trim) return function trim(str) {
            return String.prototype.trim.call(str);
        };
        else return function trim(str) {
            return str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
        };
    }
    function $9a85913e079cf886$var$bind(obj, fn) {
        return function() {
            return fn.apply(obj, Array.prototype.slice.call(arguments, 0));
        };
    }
    function $9a85913e079cf886$var$slice(arr, index) {
        return Array.prototype.slice.call(arr, index || 0);
    }
    function $9a85913e079cf886$var$each(obj, fn) {
        $9a85913e079cf886$var$pluck(obj, function(val, key) {
            fn(val, key);
            return false;
        });
    }
    function $9a85913e079cf886$var$map(obj, fn) {
        var res = $9a85913e079cf886$var$isList(obj) ? [] : {};
        $9a85913e079cf886$var$pluck(obj, function(v, k) {
            res[k] = fn(v, k);
            return false;
        });
        return res;
    }
    function $9a85913e079cf886$var$pluck(obj, fn) {
        if ($9a85913e079cf886$var$isList(obj)) for(var i = 0; i < obj.length; i++){
            if (fn(obj[i], i)) return obj[i];
        }
        else {
            for(var key in obj)if (obj.hasOwnProperty(key)) {
                if (fn(obj[key], key)) return obj[key];
            }
        }
    }
    function $9a85913e079cf886$var$isList(val) {
        return val != null && typeof val != 'function' && typeof val.length == 'number';
    }
    function $9a85913e079cf886$var$isFunction(val) {
        return val && ({}).toString.call(val) === '[object Function]';
    }
    function $9a85913e079cf886$var$isObject(val) {
        return val && ({}).toString.call(val) === '[object Object]';
    }
});
parcelRegister("4Zgux", function(module, exports) {
    var $dgvY6 = parcelRequire("dgvY6");
    var $3a19a6cea530455f$var$Global = $dgvY6.Global;
    module.exports = {
        name: 'localStorage',
        read: $3a19a6cea530455f$var$read,
        write: $3a19a6cea530455f$var$write,
        each: $3a19a6cea530455f$var$each,
        remove: $3a19a6cea530455f$var$remove,
        clearAll: $3a19a6cea530455f$var$clearAll
    };
    function $3a19a6cea530455f$var$localStorage() {
        return $3a19a6cea530455f$var$Global.localStorage;
    }
    function $3a19a6cea530455f$var$read(key) {
        return $3a19a6cea530455f$var$localStorage().getItem(key);
    }
    function $3a19a6cea530455f$var$write(key, data) {
        return $3a19a6cea530455f$var$localStorage().setItem(key, data);
    }
    function $3a19a6cea530455f$var$each(fn) {
        for(var i = $3a19a6cea530455f$var$localStorage().length - 1; i >= 0; i--){
            var key = $3a19a6cea530455f$var$localStorage().key(i);
            fn($3a19a6cea530455f$var$read(key), key);
        }
    }
    function $3a19a6cea530455f$var$remove(key) {
        return $3a19a6cea530455f$var$localStorage().removeItem(key);
    }
    function $3a19a6cea530455f$var$clearAll() {
        return $3a19a6cea530455f$var$localStorage().clear();
    }
});
parcelRegister("2NjNT", function(module, exports) {
    module.exports = {
        name: 'memoryStorage',
        read: $208f84ff41bcb720$var$read,
        write: $208f84ff41bcb720$var$write,
        each: $208f84ff41bcb720$var$each,
        remove: $208f84ff41bcb720$var$remove,
        clearAll: $208f84ff41bcb720$var$clearAll
    };
    var $208f84ff41bcb720$var$memoryStorage = {};
    function $208f84ff41bcb720$var$read(key) {
        return $208f84ff41bcb720$var$memoryStorage[key];
    }
    function $208f84ff41bcb720$var$write(key, data) {
        $208f84ff41bcb720$var$memoryStorage[key] = data;
    }
    function $208f84ff41bcb720$var$each(callback) {
        for(var key in $208f84ff41bcb720$var$memoryStorage)if ($208f84ff41bcb720$var$memoryStorage.hasOwnProperty(key)) callback($208f84ff41bcb720$var$memoryStorage[key], key);
    }
    function $208f84ff41bcb720$var$remove(key) {
        delete $208f84ff41bcb720$var$memoryStorage[key];
    }
    function $208f84ff41bcb720$var$clearAll(key) {
        $208f84ff41bcb720$var$memoryStorage = {};
    }
});
parcelRegister("561FV", function(module, exports) {
    var $kBZUL = parcelRequire("kBZUL");
    var $abMfl = parcelRequire("abMfl");
    function $3b5ecfeebeaba989$var$has(object, path) {
        return object != null && $abMfl(object, path, $kBZUL);
    }
    module.exports = $3b5ecfeebeaba989$var$has;
});
parcelRegister("kBZUL", function(module, exports) {
    var $f0174a4434851129$var$objectProto = Object.prototype;
    var $f0174a4434851129$var$hasOwnProperty = $f0174a4434851129$var$objectProto.hasOwnProperty;
    function $f0174a4434851129$var$baseHas(object, key) {
        return object != null && $f0174a4434851129$var$hasOwnProperty.call(object, key);
    }
    module.exports = $f0174a4434851129$var$baseHas;
});
parcelRegister("9SRAA", function(module, exports) {
    var $183uB = parcelRequire("183uB");
    var $e0aIo = parcelRequire("e0aIo");
    var $8pgNR = parcelRequire("8pgNR");
    function $7322b9dc1e5079b9$var$flatRest(func) {
        return $8pgNR($e0aIo(func, undefined, $183uB), func + '');
    }
    module.exports = $7322b9dc1e5079b9$var$flatRest;
});
parcelRegister("84Tib", function(module, exports) {
    var $beQoo = parcelRequire("beQoo");
    var $fC1Kz = parcelRequire("fC1Kz");
    var $5e19965b98ae8a50$var$boolTag = '[object Boolean]';
    function $5e19965b98ae8a50$var$isBoolean(value) {
        return value === true || value === false || $fC1Kz(value) && $beQoo(value) == $5e19965b98ae8a50$var$boolTag;
    }
    module.exports = $5e19965b98ae8a50$var$isBoolean;
});
parcelRegister("duUGa", function(module, exports) {
    $parcel$export(module.exports, "UFOExperience", ()=>$785cd7675432925d$export$c00d22927c60484a);
    var $4wnip;
    class $785cd7675432925d$export$c00d22927c60484a extends (0, (0, parcelRequire("4wnip")).UFOAbstractExperience) {
    }
});
parcelRegister("dMEgP", function(module, exports) {
    var $2MIs9 = parcelRequire("2MIs9");
    var $66FNL = parcelRequire("66FNL");
    function $a08efee9347d14dc$var$values(object) {
        return object == null ? [] : $2MIs9(object, $66FNL(object));
    }
    module.exports = $a08efee9347d14dc$var$values;
});
parcelRegister("2MIs9", function(module, exports) {
    var $1nIHN = parcelRequire("1nIHN");
    function $20728bee5205c23b$var$baseValues(object, props) {
        return $1nIHN(props, function(key) {
            return object[key];
        });
    }
    module.exports = $20728bee5205c23b$var$baseValues;
});
parcelRegister("ebyGx", function(module, exports) {
    $parcel$export(module.exports, "extract", ()=>$a53cff7e93c16c2c$export$f9380c9a627682d3, (v)=>$a53cff7e93c16c2c$export$f9380c9a627682d3 = v);
    $parcel$export(module.exports, "parse", ()=>$a53cff7e93c16c2c$export$98e6a39c04603d36, (v)=>$a53cff7e93c16c2c$export$98e6a39c04603d36 = v);
    $parcel$export(module.exports, "stringify", ()=>$a53cff7e93c16c2c$export$fac44ee5b035f737, (v)=>$a53cff7e93c16c2c$export$fac44ee5b035f737 = v);
    $parcel$export(module.exports, "parseUrl", ()=>$a53cff7e93c16c2c$export$7a5253c0f62e0150, (v)=>$a53cff7e93c16c2c$export$7a5253c0f62e0150 = v);
    var $a53cff7e93c16c2c$export$f9380c9a627682d3;
    var $a53cff7e93c16c2c$export$98e6a39c04603d36;
    var $a53cff7e93c16c2c$export$fac44ee5b035f737;
    var $a53cff7e93c16c2c$export$7a5253c0f62e0150;
    'use strict';
    var $b8k6Y = parcelRequire("b8k6Y");
    var $9rcQv = parcelRequire("9rcQv");
    var $aCrRe = parcelRequire("aCrRe");
    function $a53cff7e93c16c2c$var$encoderForArrayFormat(opts) {
        switch(opts.arrayFormat){
            case 'index':
                return function(key, value, index) {
                    return value === null ? [
                        $a53cff7e93c16c2c$var$encode(key, opts),
                        '[',
                        index,
                        ']'
                    ].join('') : [
                        $a53cff7e93c16c2c$var$encode(key, opts),
                        '[',
                        $a53cff7e93c16c2c$var$encode(index, opts),
                        ']=',
                        $a53cff7e93c16c2c$var$encode(value, opts)
                    ].join('');
                };
            case 'bracket':
                return function(key, value) {
                    return value === null ? $a53cff7e93c16c2c$var$encode(key, opts) : [
                        $a53cff7e93c16c2c$var$encode(key, opts),
                        '[]=',
                        $a53cff7e93c16c2c$var$encode(value, opts)
                    ].join('');
                };
            default:
                return function(key, value) {
                    return value === null ? $a53cff7e93c16c2c$var$encode(key, opts) : [
                        $a53cff7e93c16c2c$var$encode(key, opts),
                        '=',
                        $a53cff7e93c16c2c$var$encode(value, opts)
                    ].join('');
                };
        }
    }
    function $a53cff7e93c16c2c$var$parserForArrayFormat(opts) {
        var result;
        switch(opts.arrayFormat){
            case 'index':
                return function(key, value, accumulator) {
                    result = /\[(\d*)\]$/.exec(key);
                    key = key.replace(/\[\d*\]$/, '');
                    if (!result) {
                        accumulator[key] = value;
                        return;
                    }
                    if (accumulator[key] === undefined) accumulator[key] = {};
                    accumulator[key][result[1]] = value;
                };
            case 'bracket':
                return function(key, value, accumulator) {
                    result = /(\[\])$/.exec(key);
                    key = key.replace(/\[\]$/, '');
                    if (!result) {
                        accumulator[key] = value;
                        return;
                    } else if (accumulator[key] === undefined) {
                        accumulator[key] = [
                            value
                        ];
                        return;
                    }
                    accumulator[key] = [].concat(accumulator[key], value);
                };
            default:
                return function(key, value, accumulator) {
                    if (accumulator[key] === undefined) {
                        accumulator[key] = value;
                        return;
                    }
                    accumulator[key] = [].concat(accumulator[key], value);
                };
        }
    }
    function $a53cff7e93c16c2c$var$encode(value, opts) {
        if (opts.encode) return opts.strict ? $b8k6Y(value) : encodeURIComponent(value);
        return value;
    }
    function $a53cff7e93c16c2c$var$keysSorter(input) {
        if (Array.isArray(input)) return input.sort();
        else if (typeof input === 'object') return $a53cff7e93c16c2c$var$keysSorter(Object.keys(input)).sort(function(a, b) {
            return Number(a) - Number(b);
        }).map(function(key) {
            return input[key];
        });
        return input;
    }
    function $a53cff7e93c16c2c$var$extract(str) {
        var queryStart = str.indexOf('?');
        if (queryStart === -1) return '';
        return str.slice(queryStart + 1);
    }
    function $a53cff7e93c16c2c$var$parse(str, opts) {
        opts = $9rcQv({
            arrayFormat: 'none'
        }, opts);
        var formatter = $a53cff7e93c16c2c$var$parserForArrayFormat(opts);
        var ret = Object.create(null);
        if (typeof str !== 'string') return ret;
        str = str.trim().replace(/^[?#&]/, '');
        if (!str) return ret;
        str.split('&').forEach(function(param) {
            var parts = param.replace(/\+/g, ' ').split('=');
            var key = parts.shift();
            var val = parts.length > 0 ? parts.join('=') : undefined;
            val = val === undefined ? null : $aCrRe(val);
            formatter($aCrRe(key), val, ret);
        });
        return Object.keys(ret).sort().reduce(function(result, key) {
            var val = ret[key];
            if (Boolean(val) && typeof val === 'object' && !Array.isArray(val)) result[key] = $a53cff7e93c16c2c$var$keysSorter(val);
            else result[key] = val;
            return result;
        }, Object.create(null));
    }
    $a53cff7e93c16c2c$export$f9380c9a627682d3 = $a53cff7e93c16c2c$var$extract;
    $a53cff7e93c16c2c$export$98e6a39c04603d36 = $a53cff7e93c16c2c$var$parse;
    $a53cff7e93c16c2c$export$fac44ee5b035f737 = function(obj, opts) {
        var defaults = {
            encode: true,
            strict: true,
            arrayFormat: 'none'
        };
        opts = $9rcQv(defaults, opts);
        if (opts.sort === false) opts.sort = function() {};
        var formatter = $a53cff7e93c16c2c$var$encoderForArrayFormat(opts);
        return obj ? Object.keys(obj).sort(opts.sort).map(function(key) {
            var val = obj[key];
            if (val === undefined) return '';
            if (val === null) return $a53cff7e93c16c2c$var$encode(key, opts);
            if (Array.isArray(val)) {
                var result = [];
                val.slice().forEach(function(val2) {
                    if (val2 === undefined) return;
                    result.push(formatter(key, val2, result.length));
                });
                return result.join('&');
            }
            return $a53cff7e93c16c2c$var$encode(key, opts) + '=' + $a53cff7e93c16c2c$var$encode(val, opts);
        }).filter(function(x) {
            return x.length > 0;
        }).join('&') : '';
    };
    $a53cff7e93c16c2c$export$7a5253c0f62e0150 = function(str, opts) {
        return {
            url: str.split('?')[0] || '',
            query: $a53cff7e93c16c2c$var$parse($a53cff7e93c16c2c$var$extract(str), opts)
        };
    };
});
parcelRegister("b8k6Y", function(module, exports) {
    'use strict';
    module.exports = function(str) {
        return encodeURIComponent(str).replace(/[!'()*]/g, function(c) {
            return '%' + c.charCodeAt(0).toString(16).toUpperCase();
        });
    };
});
parcelRegister("9rcQv", function(module, exports) {
    'use strict';
    var $6df099941a738cfd$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
    var $6df099941a738cfd$var$hasOwnProperty = Object.prototype.hasOwnProperty;
    var $6df099941a738cfd$var$propIsEnumerable = Object.prototype.propertyIsEnumerable;
    function $6df099941a738cfd$var$toObject(val) {
        if (val === null || val === undefined) throw new TypeError('Object.assign cannot be called with null or undefined');
        return Object(val);
    }
    function $6df099941a738cfd$var$shouldUseNative() {
        try {
            if (!Object.assign) return false;
            var test1 = new String('abc');
            test1[5] = 'de';
            if (Object.getOwnPropertyNames(test1)[0] === '5') return false;
            var test2 = {};
            for(var i = 0; i < 10; i++)test2['_' + String.fromCharCode(i)] = i;
            var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
                return test2[n];
            });
            if (order2.join('') !== '0123456789') return false;
            var test3 = {};
            'abcdefghijklmnopqrst'.split('').forEach(function(letter) {
                test3[letter] = letter;
            });
            if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') return false;
            return true;
        } catch (err) {
            return false;
        }
    }
    module.exports = $6df099941a738cfd$var$shouldUseNative() ? Object.assign : function(target, source) {
        var from;
        var to = $6df099941a738cfd$var$toObject(target);
        var symbols;
        for(var s = 1; s < arguments.length; s++){
            from = Object(arguments[s]);
            for(var key in from)if ($6df099941a738cfd$var$hasOwnProperty.call(from, key)) to[key] = from[key];
            if ($6df099941a738cfd$var$getOwnPropertySymbols) {
                symbols = $6df099941a738cfd$var$getOwnPropertySymbols(from);
                for(var i = 0; i < symbols.length; i++)if ($6df099941a738cfd$var$propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
            }
        }
        return to;
    };
});
parcelRegister("4zICj", function(module, exports) {
    $parcel$export(module.exports, "choreographerFactory", ()=>$66410bab62c95f4d$export$55d2aeb17c4cfbe);
    var $5uXOq = parcelRequire("5uXOq");
    var $TTRxY;
    var $atotX;
    var $2Mf0U;
    var $cA3S0;
    var $aUNbN;
    var $lVEk7;
    var $bNT5z;
    var $gVhsA;
    var $8ekle;
    var $kmPbm;
    var $by50B;
    function $66410bab62c95f4d$export$55d2aeb17c4cfbe(productId, env, metaMetricsData = {}, choreographerOptions = {
        enableChoreographer: true
    }) {
        const plugin = new (0, (0, parcelRequire("atotX")).ProductChoreographerPlugin)(productId, env, metaMetricsData);
        const useChoreographer = (messageId, { [(0, (0, parcelRequire("TTRxY")).MessageEventType).START]: startCallback, [(0, (0, parcelRequire("TTRxY")).MessageEventType).STOP]: stopCallback } = {})=>{
            const isMessageStarted = (0, $5uXOq.useRef)(false);
            const startRef = (0, $5uXOq.useRef)(startCallback);
            const stopRef = (0, $5uXOq.useRef)(stopCallback);
            const startMessageCallback = (0, $5uXOq.useCallback)(async (...args)=>{
                const didMessageStart = await startRef.current?.(...args) ?? true;
                isMessageStarted.current = didMessageStart;
                return didMessageStart;
            }, [
                isMessageStarted
            ]);
            const startMessage = (0, $5uXOq.useCallback)((...args)=>{
                plugin.onStart(messageId, ()=>startMessageCallback(...args));
                return plugin.startMessage(messageId);
            }, [
                messageId,
                startMessageCallback
            ]);
            const stopMessageCallback = (0, $5uXOq.useCallback)(async (...args)=>{
                const didMessageStop = await stopRef.current?.(...args) ?? true;
                isMessageStarted.current = !didMessageStop;
                return didMessageStop;
            }, [
                isMessageStarted
            ]);
            const stopMessage = (0, $5uXOq.useCallback)((...args)=>{
                if (isMessageStarted.current) {
                    plugin.onStop(messageId, ()=>stopMessageCallback(...args));
                    return plugin.stopMessage(messageId);
                }
                return Promise.resolve((0, (0, parcelRequire("TTRxY")).MessageDeliveryStatus).STOPPED);
            }, [
                isMessageStarted,
                messageId,
                stopMessageCallback
            ]);
            const toggleMessage = (0, $5uXOq.useCallback)(()=>{
                return isMessageStarted.current ? stopMessage() : startMessage();
            }, [
                isMessageStarted,
                startMessage,
                stopMessage
            ]);
            (0, $5uXOq.useLayoutEffect)(()=>{
                startRef.current = startCallback;
                stopRef.current = stopCallback;
            }, [
                startCallback,
                stopCallback
            ]);
            (0, $5uXOq.useLayoutEffect)(()=>{
                plugin.on(messageId, {
                    start: async ()=>{
                        return await startMessage() === (0, (0, parcelRequire("TTRxY")).MessageDeliveryStatus).STARTED;
                    },
                    stop: async ()=>{
                        return await stopMessage() === (0, (0, parcelRequire("TTRxY")).MessageDeliveryStatus).STOPPED;
                    }
                });
                return ()=>{
                    stopMessage(messageId);
                    plugin.off(messageId);
                };
            }, [
                messageId,
                startMessage,
                stopMessage
            ]);
            return (0, $5uXOq.useMemo)(()=>({
                    startMessage: startMessage,
                    stopMessage: stopMessage,
                    toggleMessage: toggleMessage
                }), [
                startMessage,
                stopMessage,
                toggleMessage
            ]);
        };
        const shouldBeChoreographed = (props)=>{
            return (0, (0, parcelRequire("kmPbm")).shouldBeChoreographed)(props, choreographerOptions);
        };
        const useChoreographedRender = ({ messageId: messageId, onMessageDisposition: onMessageDisposition })=>{
            const [shouldRender, setShouldRender] = (0, $5uXOq.useState)(false);
            const { startMessage: startMessage, stopMessage: stopMessage } = useChoreographer(messageId, {
                start: ()=>setShouldRender(true),
                stop: ()=>setShouldRender(false)
            });
            (0, $5uXOq.useLayoutEffect)(()=>{
                const startMessageAsync = async ()=>{
                    const disposition = await startMessage();
                    onMessageDisposition?.(disposition);
                };
                startMessageAsync();
                return ()=>void stopMessage();
            }, [
                messageId,
                onMessageDisposition,
                startMessage,
                stopMessage
            ]);
            return shouldRender;
        };
        const withChoreographedRender = (Component)=>{
            function ChoreographedComponent({ messageId: messageId, onMessageDisposition: onMessageDisposition, ...props }) {
                const shouldRender = useChoreographedRender({
                    messageId: messageId,
                    onMessageDisposition: onMessageDisposition
                });
                if (shouldRender) return (0, ($parcel$interopDefault($5uXOq))).createElement(Component, props);
                return null;
            }
            ChoreographedComponent.displayName = `Choreographed${Component.displayName ?? 'Component'}`;
            return ChoreographedComponent;
        };
        const withChoreographedToggle = (Component, toggleableProp)=>{
            function ChoreographedComponent({ messageId: messageId, onMessageDisposition: onMessageDisposition, ...rest }) {
                const props = rest;
                const toggleablePropValue = props[toggleableProp];
                const [shouldRender, setShouldRender] = (0, $5uXOq.useState)(false);
                const { startMessage: startMessage, stopMessage: stopMessage } = useChoreographer(messageId, {
                    start: ()=>setShouldRender(true),
                    stop: ()=>setShouldRender(false)
                });
                (0, $5uXOq.useLayoutEffect)(()=>{
                    if (toggleablePropValue && !shouldRender) {
                        const startMessageAsync = async ()=>{
                            const disposition = await startMessage();
                            onMessageDisposition?.(disposition);
                        };
                        startMessageAsync();
                    } else if (!toggleablePropValue && shouldRender) stopMessage();
                    return ()=>{
                        if (!toggleablePropValue && shouldRender) stopMessage();
                    };
                }, [
                    messageId,
                    onMessageDisposition,
                    shouldRender,
                    startMessage,
                    stopMessage,
                    toggleablePropValue
                ]);
                return (0, ($parcel$interopDefault($5uXOq))).createElement(Component, {
                    ...props,
                    [toggleableProp]: shouldRender
                });
            }
            return ChoreographedComponent;
        };
        function wrapWithFactoryFunctions(MaybeChoreographedComponent) {
            function Component(props) {
                return (0, ($parcel$interopDefault($5uXOq))).createElement(MaybeChoreographedComponent, {
                    ...props,
                    shouldBeChoreographed: shouldBeChoreographed,
                    withChoreographedRender: withChoreographedRender
                });
            }
            Component.displayName = MaybeChoreographedComponent.displayName = `ChoreographerFactory(${MaybeChoreographedComponent.displayName})`;
            return Component;
        }
        function wrapWithToggleFactoryFunctions(MaybeChoreographedComponent) {
            function Component(props) {
                return (0, ($parcel$interopDefault($5uXOq))).createElement(MaybeChoreographedComponent, {
                    ...props,
                    shouldBeChoreographed: shouldBeChoreographed,
                    withChoreographedToggle: withChoreographedToggle
                });
            }
            Component.displayName = MaybeChoreographedComponent.displayName = `ChoreographerFactory(${MaybeChoreographedComponent.displayName})`;
            return Component;
        }
        const AutoDismissFlag = wrapWithFactoryFunctions((0, (0, parcelRequire("2Mf0U")).AutoDismissFlag));
        const Banner = wrapWithFactoryFunctions((0, (0, parcelRequire("cA3S0")).Banner));
        const Flag = wrapWithFactoryFunctions((0, (0, parcelRequire("aUNbN")).Flag));
        const Modal = wrapWithFactoryFunctions((0, (0, parcelRequire("bNT5z")).Modal));
        const Popper = wrapWithFactoryFunctions((0, (0, parcelRequire("gVhsA")).Popper));
        const Spotlight = wrapWithFactoryFunctions((0, (0, parcelRequire("by50B")).Spotlight));
        const InlineDialog = wrapWithToggleFactoryFunctions((0, (0, parcelRequire("lVEk7")).InlineDialog));
        const Popup = function() {
            function WrappedPopup(props) {
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8ekle")).Popup), {
                    ...props,
                    shouldBeChoreographed: shouldBeChoreographed,
                    withChoreographedToggle: withChoreographedToggle
                });
            }
            WrappedPopup.displayName = `ChoreographerFactory(${(0, (0, parcelRequire("8ekle")).Popup).displayName})`;
            return WrappedPopup;
        }();
        return {
            plugin: plugin,
            useChoreographer: useChoreographer,
            shouldBeChoreographed: shouldBeChoreographed,
            useChoreographedRender: useChoreographedRender,
            withChoreographedRender: withChoreographedRender,
            withChoreographedToggle: withChoreographedToggle,
            AutoDismissFlag: AutoDismissFlag,
            Banner: Banner,
            Flag: Flag,
            InlineDialog: InlineDialog,
            Modal: Modal,
            Popper: Popper,
            Popup: Popup,
            Spotlight: Spotlight
        };
    }
});
parcelRegister("atotX", function(module, exports) {
    $parcel$export(module.exports, "ProductChoreographerPlugin", ()=>$5652f56fa664d481$export$44bee9c9373d59fb);
    var $4YUjU;
    class $5652f56fa664d481$export$44bee9c9373d59fb extends (0, (0, parcelRequire("4YUjU")).ChoreographerPlugin) {
        constructor(product, env, metaMetricsData = {}){
            super(product, env, metaMetricsData);
        }
    }
});
parcelRegister("2Mf0U", function(module, exports) {
    $parcel$export(module.exports, "AutoDismissFlag", ()=>$2d28883873c8f74f$export$9879a8e0db317538);
    var $fWXJB;
    var $kmPbm;
    const $2d28883873c8f74f$export$9879a8e0db317538 = (0, (0, parcelRequire("kmPbm")).wrapComponentForChoreographer)((0, (0, parcelRequire("fWXJB")).default));
});
parcelRegister("cA3S0", function(module, exports) {
    $parcel$export(module.exports, "Banner", ()=>$403a80a08d6d2f6a$export$3b4e64e77073e307);
    var $lkmWu;
    var $kmPbm;
    const $403a80a08d6d2f6a$export$3b4e64e77073e307 = (0, (0, parcelRequire("kmPbm")).wrapComponentForChoreographer)((0, (0, parcelRequire("lkmWu")).default));
});
parcelRegister("aUNbN", function(module, exports) {
    $parcel$export(module.exports, "Flag", ()=>$4e5c7ea548d20989$export$48ea269755562084);
    var $epfFv;
    var $kmPbm;
    const $4e5c7ea548d20989$export$48ea269755562084 = (0, (0, parcelRequire("kmPbm")).wrapComponentForChoreographer)((0, (0, parcelRequire("epfFv")).default));
});
parcelRegister("lVEk7", function(module, exports) {
    $parcel$export(module.exports, "InlineDialog", ()=>$c56e25d30c4b39ec$export$c7313f750e9cbc9d);
    var $ctg8C;
    var $kmPbm;
    const $c56e25d30c4b39ec$export$c7313f750e9cbc9d = (0, (0, parcelRequire("kmPbm")).wrapToggleableComponentForChoreographer)((0, (0, parcelRequire("ctg8C")).default), 'isOpen');
});
parcelRegister("bNT5z", function(module, exports) {
    $parcel$export(module.exports, "Modal", ()=>$0650c9f08266e4ad$export$2b77a92f1a5ad772);
    var $1R1Ge;
    var $kmPbm;
    const $0650c9f08266e4ad$export$2b77a92f1a5ad772 = (0, (0, parcelRequire("kmPbm")).wrapComponentForChoreographer)((0, (0, parcelRequire("1R1Ge")).default));
});
parcelRegister("gVhsA", function(module, exports) {
    $parcel$export(module.exports, "Popper", ()=>$bdc96b866a7df877$export$badac9ada3a0bdf9);
    var $4oNEb;
    var $kmPbm;
    const $bdc96b866a7df877$export$badac9ada3a0bdf9 = (0, (0, parcelRequire("kmPbm")).wrapComponentForChoreographer)((0, (0, parcelRequire("4oNEb")).Popper));
});
parcelRegister("8ekle", function(module, exports) {
    $parcel$export(module.exports, "Popup", ()=>$fda7f9cfac28a5c8$export$129a32eedafa97c5);
    var $1I7E8;
    var $kmPbm;
    const $fda7f9cfac28a5c8$export$129a32eedafa97c5 = (0, (0, parcelRequire("kmPbm")).wrapToggleableComponentForChoreographer)((0, (0, parcelRequire("1I7E8")).Popup), 'isOpen');
});
parcelRegister("by50B", function(module, exports) {
    $parcel$export(module.exports, "Spotlight", ()=>$13a98b6d24c00d08$export$1033c28b5e1c2deb);
    var $7gs1W;
    var $kmPbm;
    const $13a98b6d24c00d08$export$1033c28b5e1c2deb = (0, (0, parcelRequire("kmPbm")).wrapComponentForChoreographer)((0, (0, parcelRequire("7gs1W")).default));
});
parcelRegister("dI393", function(module, exports) {
    'use strict';
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    var $1o9RP = parcelRequire("1o9RP");
    Object.defineProperty(module.exports, 'default', {
        enumerable: true,
        get: function get() {
            return $9fb1d2f148532de5$var$_interopRequireDefault($1o9RP).default;
        }
    });
    function $9fb1d2f148532de5$var$_interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
});
parcelRegister("1o9RP", function(module, exports) {
    'use strict';
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    var $102fafc31c1e58cf$var$_createClass = function() {
        function defineProperties(target, props) {
            for(var i = 0; i < props.length; i++){
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor) descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
            }
        }
        return function(Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
        };
    }();
    var $5uXOq = parcelRequire("5uXOq");
    var $7nsd3 = parcelRequire("7nsd3");
    function $102fafc31c1e58cf$var$_classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
    }
    function $102fafc31c1e58cf$var$_possibleConstructorReturn(self, call) {
        if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return call && (typeof call === "object" || typeof call === "function") ? call : self;
    }
    function $102fafc31c1e58cf$var$_inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
        subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
                value: subClass,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
    }
    var $102fafc31c1e58cf$var$NodeResolver = function(_Component) {
        $102fafc31c1e58cf$var$_inherits(NodeResolver, _Component);
        function NodeResolver() {
            $102fafc31c1e58cf$var$_classCallCheck(this, NodeResolver);
            return $102fafc31c1e58cf$var$_possibleConstructorReturn(this, (NodeResolver.__proto__ || Object.getPrototypeOf(NodeResolver)).apply(this, arguments));
        }
        $102fafc31c1e58cf$var$_createClass(NodeResolver, [
            {
                key: 'componentDidMount',
                value: function componentDidMount() {
                    this.props.innerRef((0, $7nsd3.findDOMNode)(this));
                }
            },
            {
                key: 'componentWillUnmount',
                value: function componentWillUnmount() {
                    this.props.innerRef(null);
                }
            },
            {
                key: 'render',
                value: function render() {
                    return this.props.children;
                }
            }
        ]);
        return NodeResolver;
    }($5uXOq.Component);
    module.exports.default = $102fafc31c1e58cf$var$NodeResolver;
});
parcelRegister("ao4Ml", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$78ffda35a3cd2a5c$export$2e2bcd8739ae039);
    var $cIaXu;
    var $78ffda35a3cd2a5c$export$2e2bcd8739ae039 = (0, (0, parcelRequire("cIaXu")).default);
});
parcelRegister("cIaXu", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9412183d03dc0dc5$export$2e2bcd8739ae039);
    var $ddEsc = parcelRequire("ddEsc");
    var $bS32t = parcelRequire("bS32t");
    var $5uXOq = parcelRequire("5uXOq");
    var $iK0nX;
    var $1jdvF;
    var $9412183d03dc0dc5$var$FocusLockCombination = $5uXOq.forwardRef(function FocusLockUICombination(props, ref) {
        return $5uXOq.createElement((0, (0, parcelRequire("iK0nX")).default), (0, $bS32t.default)({
            sideCar: (0, (0, parcelRequire("1jdvF")).default),
            ref: ref
        }, props));
    });
    var $9412183d03dc0dc5$var$_ref = (0, (0, parcelRequire("iK0nX")).default).propTypes || {}, $9412183d03dc0dc5$var$sideCar = $9412183d03dc0dc5$var$_ref.sideCar, $9412183d03dc0dc5$var$propTypes = (0, $ddEsc.default)($9412183d03dc0dc5$var$_ref, [
        "sideCar"
    ]);
    $9412183d03dc0dc5$var$FocusLockCombination.propTypes = {};
    var $9412183d03dc0dc5$export$2e2bcd8739ae039 = $9412183d03dc0dc5$var$FocusLockCombination;
});
parcelRegister("iK0nX", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$da4cd26ce8b7c545$export$2e2bcd8739ae039);
    var $bS32t = parcelRequire("bS32t");
    var $5uXOq = parcelRequire("5uXOq");
    var $26Cgu;
    var $3Du7S;
    var $hs7HE;
    var $i2hbO;
    var $lTS5V;
    var $da4cd26ce8b7c545$var$emptyArray = [];
    var $da4cd26ce8b7c545$var$FocusLock = $5uXOq.forwardRef(function FocusLockUI(props, parentRef) {
        var _extends2;
        var _React$useState = $5uXOq.useState(), realObserved = _React$useState[0], setObserved = _React$useState[1];
        var observed = $5uXOq.useRef();
        var isActive = $5uXOq.useRef(false);
        var originalFocusedElement = $5uXOq.useRef(null);
        var _React$useState2 = $5uXOq.useState({}), update = _React$useState2[1];
        var children = props.children, _props$disabled = props.disabled, disabled = _props$disabled === void 0 ? false : _props$disabled, _props$noFocusGuards = props.noFocusGuards, noFocusGuards = _props$noFocusGuards === void 0 ? false : _props$noFocusGuards, _props$persistentFocu = props.persistentFocus, persistentFocus = _props$persistentFocu === void 0 ? false : _props$persistentFocu, _props$crossFrame = props.crossFrame, crossFrame = _props$crossFrame === void 0 ? true : _props$crossFrame, _props$autoFocus = props.autoFocus, autoFocus = _props$autoFocus === void 0 ? true : _props$autoFocus, allowTextSelection = props.allowTextSelection, group = props.group, className = props.className, whiteList = props.whiteList, hasPositiveIndices = props.hasPositiveIndices, _props$shards = props.shards, shards = _props$shards === void 0 ? $da4cd26ce8b7c545$var$emptyArray : _props$shards, _props$as = props.as, Container = _props$as === void 0 ? 'div' : _props$as, _props$lockProps = props.lockProps, containerProps = _props$lockProps === void 0 ? {} : _props$lockProps, SideCar = props.sideCar, _props$returnFocus = props.returnFocus, shouldReturnFocus = _props$returnFocus === void 0 ? false : _props$returnFocus, focusOptions = props.focusOptions, onActivationCallback = props.onActivation, onDeactivationCallback = props.onDeactivation;
        var _React$useState3 = $5uXOq.useState({}), id = _React$useState3[0];
        var onActivation = $5uXOq.useCallback(function(_ref) {
            var captureFocusRestore = _ref.captureFocusRestore;
            if (!originalFocusedElement.current) {
                var _document;
                var activeElement = (_document = document) == null ? void 0 : _document.activeElement;
                originalFocusedElement.current = activeElement;
                if (activeElement !== document.body) originalFocusedElement.current = captureFocusRestore(activeElement);
            }
            if (observed.current && onActivationCallback) onActivationCallback(observed.current);
            isActive.current = true;
            update();
        }, [
            onActivationCallback
        ]);
        var onDeactivation = $5uXOq.useCallback(function() {
            isActive.current = false;
            if (onDeactivationCallback) onDeactivationCallback(observed.current);
            update();
        }, [
            onDeactivationCallback
        ]);
        var returnFocus = $5uXOq.useCallback(function(allowDefer) {
            var focusRestore = originalFocusedElement.current;
            if (focusRestore) {
                var returnFocusTo = (typeof focusRestore === 'function' ? focusRestore() : focusRestore) || document.body;
                var howToReturnFocus = typeof shouldReturnFocus === 'function' ? shouldReturnFocus(returnFocusTo) : shouldReturnFocus;
                if (howToReturnFocus) {
                    var returnFocusOptions = typeof howToReturnFocus === 'object' ? howToReturnFocus : undefined;
                    originalFocusedElement.current = null;
                    if (allowDefer) Promise.resolve().then(function() {
                        return returnFocusTo.focus(returnFocusOptions);
                    });
                    else returnFocusTo.focus(returnFocusOptions);
                }
            }
        }, [
            shouldReturnFocus
        ]);
        var onFocus = $5uXOq.useCallback(function(event) {
            if (isActive.current) (0, (0, parcelRequire("i2hbO")).mediumFocus).useMedium(event);
        }, []);
        var onBlur = (0, (0, parcelRequire("i2hbO")).mediumBlur).useMedium;
        var setObserveNode = $5uXOq.useCallback(function(newObserved) {
            if (observed.current !== newObserved) {
                observed.current = newObserved;
                setObserved(newObserved);
            }
        }, []);
        var lockProps = (0, $bS32t.default)((_extends2 = {}, _extends2[(0, parcelRequire("26Cgu")).FOCUS_DISABLED] = disabled && 'disabled', _extends2[(0, parcelRequire("26Cgu")).FOCUS_GROUP] = group, _extends2), containerProps);
        var hasLeadingGuards = noFocusGuards !== true;
        var hasTailingGuards = hasLeadingGuards && noFocusGuards !== 'tail';
        var mergedRef = (0, (0, parcelRequire("3Du7S")).useMergeRefs)([
            parentRef,
            setObserveNode
        ]);
        var focusScopeValue = $5uXOq.useMemo(function() {
            return {
                observed: observed,
                shards: shards,
                enabled: !disabled,
                active: isActive.current
            };
        }, [
            disabled,
            isActive.current,
            shards,
            realObserved
        ]);
        return $5uXOq.createElement($5uXOq.Fragment, null, hasLeadingGuards && [
            $5uXOq.createElement("div", {
                key: "guard-first",
                "data-focus-guard": true,
                tabIndex: disabled ? -1 : 0,
                style: (0, (0, parcelRequire("hs7HE")).hiddenGuard)
            }),
            hasPositiveIndices ? $5uXOq.createElement("div", {
                key: "guard-nearest",
                "data-focus-guard": true,
                tabIndex: disabled ? -1 : 1,
                style: (0, (0, parcelRequire("hs7HE")).hiddenGuard)
            }) : null
        ], !disabled && $5uXOq.createElement(SideCar, {
            id: id,
            sideCar: (0, (0, parcelRequire("i2hbO")).mediumSidecar),
            observed: realObserved,
            disabled: disabled,
            persistentFocus: persistentFocus,
            crossFrame: crossFrame,
            autoFocus: autoFocus,
            whiteList: whiteList,
            shards: shards,
            onActivation: onActivation,
            onDeactivation: onDeactivation,
            returnFocus: returnFocus,
            focusOptions: focusOptions
        }), $5uXOq.createElement(Container, (0, $bS32t.default)({
            ref: mergedRef
        }, lockProps, {
            className: className,
            onBlur: onBlur,
            onFocus: onFocus
        }), $5uXOq.createElement((0, (0, parcelRequire("lTS5V")).focusScope).Provider, {
            value: focusScopeValue
        }, children)), hasTailingGuards && $5uXOq.createElement("div", {
            "data-focus-guard": true,
            tabIndex: disabled ? -1 : 0,
            style: (0, (0, parcelRequire("hs7HE")).hiddenGuard)
        }));
    });
    $da4cd26ce8b7c545$var$FocusLock.propTypes = {};
    var $da4cd26ce8b7c545$export$2e2bcd8739ae039 = $da4cd26ce8b7c545$var$FocusLock;
});
parcelRegister("26Cgu", function(module, exports) {
    $parcel$export(module.exports, "FOCUS_GROUP", ()=>$1889d2ef999b3988$export$4f9a06cb7441a087);
    $parcel$export(module.exports, "FOCUS_DISABLED", ()=>$1889d2ef999b3988$export$aeda8252e54b50f7);
    $parcel$export(module.exports, "FOCUS_ALLOW", ()=>$1889d2ef999b3988$export$54ecf528c58f9ef6);
    $parcel$export(module.exports, "FOCUS_AUTO", ()=>$1889d2ef999b3988$export$70e9b4a1820af101);
    $parcel$export(module.exports, "FOCUS_NO_AUTOFOCUS", ()=>$1889d2ef999b3988$export$134ebef29fd94853);
    var $1889d2ef999b3988$export$4f9a06cb7441a087 = 'data-focus-lock';
    var $1889d2ef999b3988$export$aeda8252e54b50f7 = 'data-focus-lock-disabled';
    var $1889d2ef999b3988$export$54ecf528c58f9ef6 = 'data-no-focus-lock';
    var $1889d2ef999b3988$export$70e9b4a1820af101 = 'data-autofocus-inside';
    var $1889d2ef999b3988$export$134ebef29fd94853 = 'data-no-autofocus';
});
parcelRegister("3Du7S", function(module, exports) {
    $parcel$export(module.exports, "useMergeRefs", ()=>$2a5c6201d8713c67$export$74665b213cb5c4cf);
    var $5uXOq = parcelRequire("5uXOq");
    var $dv0OY;
    var $5Gf1j;
    const $2a5c6201d8713c67$var$useIsomorphicLayoutEffect = typeof window !== 'undefined' ? $5uXOq.useLayoutEffect : $5uXOq.useEffect;
    const $2a5c6201d8713c67$var$currentValues = new WeakMap();
    function $2a5c6201d8713c67$export$74665b213cb5c4cf(refs, defaultValue) {
        const callbackRef = (0, (0, parcelRequire("5Gf1j")).useCallbackRef)(defaultValue || null, (newValue)=>refs.forEach((ref)=>(0, (0, parcelRequire("dv0OY")).assignRef)(ref, newValue)));
        $2a5c6201d8713c67$var$useIsomorphicLayoutEffect(()=>{
            const oldValue = $2a5c6201d8713c67$var$currentValues.get(callbackRef);
            if (oldValue) {
                const prevRefs = new Set(oldValue);
                const nextRefs = new Set(refs);
                const current = callbackRef.current;
                prevRefs.forEach((ref)=>{
                    if (!nextRefs.has(ref)) (0, (0, parcelRequire("dv0OY")).assignRef)(ref, null);
                });
                nextRefs.forEach((ref)=>{
                    if (!prevRefs.has(ref)) (0, (0, parcelRequire("dv0OY")).assignRef)(ref, current);
                });
            }
            $2a5c6201d8713c67$var$currentValues.set(callbackRef, refs);
        }, [
            refs
        ]);
        return callbackRef;
    }
});
parcelRegister("dv0OY", function(module, exports) {
    $parcel$export(module.exports, "assignRef", ()=>$9d3eceb3bd1bde87$export$d734136a7b018efe);
    function $9d3eceb3bd1bde87$export$d734136a7b018efe(ref, value) {
        if (typeof ref === 'function') ref(value);
        else if (ref) ref.current = value;
        return ref;
    }
});
parcelRegister("5Gf1j", function(module, exports) {
    $parcel$export(module.exports, "useCallbackRef", ()=>$422c86adb7367c4f$export$25bec8c6f54ee79a);
    var $5uXOq = parcelRequire("5uXOq");
    function $422c86adb7367c4f$export$25bec8c6f54ee79a(initialValue, callback) {
        const [ref] = (0, $5uXOq.useState)(()=>({
                value: initialValue,
                callback: callback,
                facade: {
                    get current () {
                        return ref.value;
                    },
                    set current (value){
                        const last = ref.value;
                        if (last !== value) {
                            ref.value = value;
                            ref.callback(value, last);
                        }
                    }
                }
            }));
        ref.callback = callback;
        return ref.facade;
    }
});
parcelRegister("hs7HE", function(module, exports) {
    $parcel$export(module.exports, "hiddenGuard", ()=>$cb4b06d97dec25c1$export$b8c7b07253306600);
    var $5uXOq = parcelRequire("5uXOq");
    var $cb4b06d97dec25c1$export$b8c7b07253306600 = {
        width: '1px',
        height: '0px',
        padding: 0,
        overflow: 'hidden',
        position: 'fixed',
        top: '1px',
        left: '1px'
    };
    var $cb4b06d97dec25c1$var$InFocusGuard = function InFocusGuard(_ref) {
        var _ref$children = _ref.children, children = _ref$children === void 0 ? null : _ref$children;
        return $5uXOq.createElement($5uXOq.Fragment, null, $5uXOq.createElement("div", {
            key: "guard-first",
            "data-focus-guard": true,
            "data-focus-auto-guard": true,
            style: $cb4b06d97dec25c1$export$b8c7b07253306600
        }), children, children && $5uXOq.createElement("div", {
            key: "guard-last",
            "data-focus-guard": true,
            "data-focus-auto-guard": true,
            style: $cb4b06d97dec25c1$export$b8c7b07253306600
        }));
    };
    $cb4b06d97dec25c1$var$InFocusGuard.propTypes = {};
    var $cb4b06d97dec25c1$export$2e2bcd8739ae039 = $cb4b06d97dec25c1$var$InFocusGuard;
});
parcelRegister("i2hbO", function(module, exports) {
    $parcel$export(module.exports, "mediumFocus", ()=>$d215bf5dba6c52c4$export$5733e022b1d538cb);
    $parcel$export(module.exports, "mediumBlur", ()=>$d215bf5dba6c52c4$export$b3e9a9312f73723c);
    $parcel$export(module.exports, "mediumEffect", ()=>$d215bf5dba6c52c4$export$3a1d52767cbc07b8);
    $parcel$export(module.exports, "mediumSidecar", ()=>$d215bf5dba6c52c4$export$892cbf28e5518020);
    var $bzFTo = parcelRequire("bzFTo");
    var $d215bf5dba6c52c4$export$5733e022b1d538cb = (0, $bzFTo.createMedium)({}, function(_ref) {
        var target = _ref.target, currentTarget = _ref.currentTarget;
        return {
            target: target,
            currentTarget: currentTarget
        };
    });
    var $d215bf5dba6c52c4$export$b3e9a9312f73723c = (0, $bzFTo.createMedium)();
    var $d215bf5dba6c52c4$export$3a1d52767cbc07b8 = (0, $bzFTo.createMedium)();
    var $d215bf5dba6c52c4$export$892cbf28e5518020 = (0, $bzFTo.createSidecarMedium)({
        async: true,
        ssr: typeof document !== 'undefined'
    });
});
parcelRegister("bzFTo", function(module, exports) {
    $parcel$export(module.exports, "createMedium", ()=>$86d3758a1af7e127$export$9ffbfcaf067b02c6);
    $parcel$export(module.exports, "createSidecarMedium", ()=>$86d3758a1af7e127$export$e13ec7dd7a14088d);
    function $86d3758a1af7e127$var$ItoI(a) {
        return a;
    }
    function $86d3758a1af7e127$var$innerCreateMedium(defaults, middleware = $86d3758a1af7e127$var$ItoI) {
        let buffer = [];
        let assigned = false;
        const medium = {
            read () {
                if (assigned) throw new Error('Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.');
                if (buffer.length) return buffer[buffer.length - 1];
                return defaults;
            },
            useMedium (data) {
                const item = middleware(data, assigned);
                buffer.push(item);
                return ()=>{
                    buffer = buffer.filter((x)=>x !== item);
                };
            },
            assignSyncMedium (cb) {
                assigned = true;
                while(buffer.length){
                    const cbs = buffer;
                    buffer = [];
                    cbs.forEach(cb);
                }
                buffer = {
                    push: (x)=>cb(x),
                    filter: ()=>buffer
                };
            },
            assignMedium (cb) {
                assigned = true;
                let pendingQueue = [];
                if (buffer.length) {
                    const cbs = buffer;
                    buffer = [];
                    cbs.forEach(cb);
                    pendingQueue = buffer;
                }
                const executeQueue = ()=>{
                    const cbs = pendingQueue;
                    pendingQueue = [];
                    cbs.forEach(cb);
                };
                const cycle = ()=>Promise.resolve().then(executeQueue);
                cycle();
                buffer = {
                    push: (x)=>{
                        pendingQueue.push(x);
                        cycle();
                    },
                    filter: (filter)=>{
                        pendingQueue = pendingQueue.filter(filter);
                        return buffer;
                    }
                };
            }
        };
        return medium;
    }
    function $86d3758a1af7e127$export$9ffbfcaf067b02c6(defaults, middleware = $86d3758a1af7e127$var$ItoI) {
        return $86d3758a1af7e127$var$innerCreateMedium(defaults, middleware);
    }
    function $86d3758a1af7e127$export$e13ec7dd7a14088d(options = {}) {
        const medium = $86d3758a1af7e127$var$innerCreateMedium(null);
        medium.options = {
            async: true,
            ssr: false,
            ...options
        };
        return medium;
    }
});
parcelRegister("lTS5V", function(module, exports) {
    $parcel$export(module.exports, "focusScope", ()=>$ff18b21b414ba800$export$f5272e9b1168239c);
    var $5uXOq = parcelRequire("5uXOq");
    var $ff18b21b414ba800$export$f5272e9b1168239c = (0, $5uXOq.createContext)(undefined);
});
parcelRegister("1jdvF", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0f420b8ec0f9848e$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $6mqio = parcelRequire("6mqio");
    var $j4988;
    var $2RQOj;
    var $1q0r0;
    var $5x9g9;
    var $jl7aa;
    parcelRequire("cCk2L");
    var $9wlSW;
    var $1mLS6;
    var $i2hbO;
    var $0f420b8ec0f9848e$var$focusOnBody = function focusOnBody() {
        return document && document.activeElement === document.body;
    };
    var $0f420b8ec0f9848e$var$isFreeFocus = function isFreeFocus() {
        return $0f420b8ec0f9848e$var$focusOnBody() || (0, (0, parcelRequire("jl7aa")).focusIsHidden)();
    };
    var $0f420b8ec0f9848e$var$lastActiveTrap = null;
    var $0f420b8ec0f9848e$var$lastActiveFocus = null;
    var $0f420b8ec0f9848e$var$lastPortaledElement = null;
    var $0f420b8ec0f9848e$var$focusWasOutsideWindow = false;
    var $0f420b8ec0f9848e$var$defaultWhitelist = function defaultWhitelist() {
        return true;
    };
    var $0f420b8ec0f9848e$var$focusWhitelisted = function focusWhitelisted(activeElement) {
        return ($0f420b8ec0f9848e$var$lastActiveTrap.whiteList || $0f420b8ec0f9848e$var$defaultWhitelist)(activeElement);
    };
    var $0f420b8ec0f9848e$var$recordPortal = function recordPortal(observerNode, portaledElement) {
        $0f420b8ec0f9848e$var$lastPortaledElement = {
            observerNode: observerNode,
            portaledElement: portaledElement
        };
    };
    var $0f420b8ec0f9848e$var$focusIsPortaledPair = function focusIsPortaledPair(element) {
        return $0f420b8ec0f9848e$var$lastPortaledElement && $0f420b8ec0f9848e$var$lastPortaledElement.portaledElement === element;
    };
    function $0f420b8ec0f9848e$var$autoGuard(startIndex, end, step, allNodes) {
        var lastGuard = null;
        var i = startIndex;
        do {
            var item = allNodes[i];
            if (item.guard) {
                if (item.node.dataset.focusAutoGuard) lastGuard = item;
            } else if (item.lockItem) {
                if (i !== startIndex) return;
                lastGuard = null;
            } else break;
        }while ((i += step) !== end)
        if (lastGuard) lastGuard.node.tabIndex = 0;
    }
    var $0f420b8ec0f9848e$var$focusWasOutside = function focusWasOutside(crossFrameOption) {
        if (crossFrameOption) return Boolean($0f420b8ec0f9848e$var$focusWasOutsideWindow);
        return $0f420b8ec0f9848e$var$focusWasOutsideWindow === 'meanwhile';
    };
    var $0f420b8ec0f9848e$var$checkInHost = function checkInHost(check, el, boundary) {
        return el && (el.host === check && (!el.activeElement || boundary.contains(el.activeElement)) || el.parentNode && checkInHost(check, el.parentNode, boundary));
    };
    var $0f420b8ec0f9848e$var$withinHost = function withinHost(activeElement, workingArea) {
        return workingArea.some(function(area) {
            return $0f420b8ec0f9848e$var$checkInHost(activeElement, area, area);
        });
    };
    var $0f420b8ec0f9848e$var$activateTrap = function activateTrap() {
        var result = false;
        if ($0f420b8ec0f9848e$var$lastActiveTrap) {
            var _lastActiveTrap = $0f420b8ec0f9848e$var$lastActiveTrap, observed = _lastActiveTrap.observed, persistentFocus = _lastActiveTrap.persistentFocus, autoFocus = _lastActiveTrap.autoFocus, shards = _lastActiveTrap.shards, crossFrame = _lastActiveTrap.crossFrame, focusOptions = _lastActiveTrap.focusOptions;
            var workingNode = observed || $0f420b8ec0f9848e$var$lastPortaledElement && $0f420b8ec0f9848e$var$lastPortaledElement.portaledElement;
            var activeElement = document && document.activeElement;
            if (workingNode) {
                var workingArea = [
                    workingNode
                ].concat(shards.map((0, (0, parcelRequire("1mLS6")).extractRef)).filter(Boolean));
                if (!activeElement || $0f420b8ec0f9848e$var$focusWhitelisted(activeElement)) {
                    if (persistentFocus || $0f420b8ec0f9848e$var$focusWasOutside(crossFrame) || !$0f420b8ec0f9848e$var$isFreeFocus() || !$0f420b8ec0f9848e$var$lastActiveFocus && autoFocus) {
                        if (workingNode && !((0, (0, parcelRequire("5x9g9")).focusInside)(workingArea) || activeElement && $0f420b8ec0f9848e$var$withinHost(activeElement, workingArea) || $0f420b8ec0f9848e$var$focusIsPortaledPair(activeElement, workingNode))) {
                            if (document && !$0f420b8ec0f9848e$var$lastActiveFocus && activeElement && !autoFocus) {
                                if (activeElement.blur) activeElement.blur();
                                document.body.focus();
                            } else {
                                result = (0, (0, parcelRequire("9wlSW")).moveFocusInside)(workingArea, $0f420b8ec0f9848e$var$lastActiveFocus, {
                                    focusOptions: focusOptions
                                });
                                $0f420b8ec0f9848e$var$lastPortaledElement = {};
                            }
                        }
                        $0f420b8ec0f9848e$var$focusWasOutsideWindow = false;
                        $0f420b8ec0f9848e$var$lastActiveFocus = document && document.activeElement;
                    }
                }
                if (document && activeElement !== document.activeElement && document.querySelector('[data-focus-auto-guard]')) {
                    var newActiveElement = document && document.activeElement;
                    var allNodes = (0, (0, parcelRequire("2RQOj")).expandFocusableNodes)(workingArea);
                    var focusedIndex = allNodes.map(function(_ref) {
                        var node = _ref.node;
                        return node;
                    }).indexOf(newActiveElement);
                    if (focusedIndex > -1) {
                        allNodes.filter(function(_ref2) {
                            var guard = _ref2.guard, node = _ref2.node;
                            return guard && node.dataset.focusAutoGuard;
                        }).forEach(function(_ref3) {
                            var node = _ref3.node;
                            return node.removeAttribute('tabIndex');
                        });
                        $0f420b8ec0f9848e$var$autoGuard(focusedIndex, allNodes.length, 1, allNodes);
                        $0f420b8ec0f9848e$var$autoGuard(focusedIndex, -1, -1, allNodes);
                    }
                }
            }
        }
        return result;
    };
    var $0f420b8ec0f9848e$var$onTrap = function onTrap(event) {
        if ($0f420b8ec0f9848e$var$activateTrap() && event) {
            event.stopPropagation();
            event.preventDefault();
        }
    };
    var $0f420b8ec0f9848e$var$onBlur = function onBlur() {
        return (0, (0, parcelRequire("1mLS6")).deferAction)($0f420b8ec0f9848e$var$activateTrap);
    };
    var $0f420b8ec0f9848e$var$onFocus = function onFocus(event) {
        var source = event.target;
        var currentNode = event.currentTarget;
        if (!currentNode.contains(source)) $0f420b8ec0f9848e$var$recordPortal(currentNode, source);
    };
    var $0f420b8ec0f9848e$var$FocusWatcher = function FocusWatcher() {
        return null;
    };
    var $0f420b8ec0f9848e$var$FocusTrap = function FocusTrap(_ref4) {
        var children = _ref4.children;
        return $5uXOq.createElement("div", {
            onBlur: $0f420b8ec0f9848e$var$onBlur,
            onFocus: $0f420b8ec0f9848e$var$onFocus
        }, children);
    };
    $0f420b8ec0f9848e$var$FocusTrap.propTypes = {};
    var $0f420b8ec0f9848e$var$onWindowBlur = function onWindowBlur() {
        $0f420b8ec0f9848e$var$focusWasOutsideWindow = 'just';
        (0, (0, parcelRequire("1mLS6")).deferAction)(function() {
            $0f420b8ec0f9848e$var$focusWasOutsideWindow = 'meanwhile';
        });
    };
    var $0f420b8ec0f9848e$var$attachHandler = function attachHandler() {
        document.addEventListener('focusin', $0f420b8ec0f9848e$var$onTrap);
        document.addEventListener('focusout', $0f420b8ec0f9848e$var$onBlur);
        window.addEventListener('blur', $0f420b8ec0f9848e$var$onWindowBlur);
    };
    var $0f420b8ec0f9848e$var$detachHandler = function detachHandler() {
        document.removeEventListener('focusin', $0f420b8ec0f9848e$var$onTrap);
        document.removeEventListener('focusout', $0f420b8ec0f9848e$var$onBlur);
        window.removeEventListener('blur', $0f420b8ec0f9848e$var$onWindowBlur);
    };
    function $0f420b8ec0f9848e$var$reducePropsToState(propsList) {
        return propsList.filter(function(_ref5) {
            var disabled = _ref5.disabled;
            return !disabled;
        });
    }
    var $0f420b8ec0f9848e$var$focusLockAPI = {
        moveFocusInside: (0, (0, parcelRequire("9wlSW")).moveFocusInside),
        focusInside: (0, (0, parcelRequire("5x9g9")).focusInside),
        focusNextElement: (0, (0, parcelRequire("1q0r0")).focusNextElement),
        focusPrevElement: (0, (0, parcelRequire("1q0r0")).focusPrevElement),
        focusFirstElement: (0, (0, parcelRequire("1q0r0")).focusFirstElement),
        focusLastElement: (0, (0, parcelRequire("1q0r0")).focusLastElement),
        captureFocusRestore: (0, (0, parcelRequire("j4988")).captureFocusRestore)
    };
    function $0f420b8ec0f9848e$var$handleStateChangeOnClient(traps) {
        var trap = traps.slice(-1)[0];
        if (trap && !$0f420b8ec0f9848e$var$lastActiveTrap) $0f420b8ec0f9848e$var$attachHandler();
        var lastTrap = $0f420b8ec0f9848e$var$lastActiveTrap;
        var sameTrap = lastTrap && trap && trap.id === lastTrap.id;
        $0f420b8ec0f9848e$var$lastActiveTrap = trap;
        if (lastTrap && !sameTrap) {
            lastTrap.onDeactivation();
            if (!traps.filter(function(_ref6) {
                var id = _ref6.id;
                return id === lastTrap.id;
            }).length) lastTrap.returnFocus(!trap);
        }
        if (trap) {
            $0f420b8ec0f9848e$var$lastActiveFocus = null;
            if (!sameTrap || lastTrap.observed !== trap.observed) trap.onActivation($0f420b8ec0f9848e$var$focusLockAPI);
            $0f420b8ec0f9848e$var$activateTrap(true);
            (0, (0, parcelRequire("1mLS6")).deferAction)($0f420b8ec0f9848e$var$activateTrap);
        } else {
            $0f420b8ec0f9848e$var$detachHandler();
            $0f420b8ec0f9848e$var$lastActiveFocus = null;
        }
    }
    (0, (0, parcelRequire("i2hbO")).mediumFocus).assignSyncMedium($0f420b8ec0f9848e$var$onFocus);
    (0, (0, parcelRequire("i2hbO")).mediumBlur).assignMedium($0f420b8ec0f9848e$var$onBlur);
    (0, (0, parcelRequire("i2hbO")).mediumEffect).assignMedium(function(cb) {
        return cb($0f420b8ec0f9848e$var$focusLockAPI);
    });
    var $0f420b8ec0f9848e$export$2e2bcd8739ae039 = (0, $6mqio.default)($0f420b8ec0f9848e$var$reducePropsToState, $0f420b8ec0f9848e$var$handleStateChangeOnClient)($0f420b8ec0f9848e$var$FocusWatcher);
});
parcelRegister("6mqio", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4a1931e6e98edb22$export$2e2bcd8739ae039);
    var $2jS8g = parcelRequire("2jS8g");
    var $eHiP8 = parcelRequire("eHiP8");
    var $5uXOq = parcelRequire("5uXOq");
    function $4a1931e6e98edb22$var$withSideEffect(reducePropsToState, handleStateChangeOnClient) {
        function getDisplayName(WrappedComponent) {
            return WrappedComponent.displayName || WrappedComponent.name || 'Component';
        }
        return function wrap(WrappedComponent) {
            var mountedInstances = [];
            var state;
            function emitChange() {
                state = reducePropsToState(mountedInstances.map(function(instance) {
                    return instance.props;
                }));
                handleStateChangeOnClient(state);
            }
            var SideEffect = function(_PureComponent) {
                (0, $2jS8g.default)(SideEffect, _PureComponent);
                function SideEffect() {
                    return _PureComponent.apply(this, arguments) || this;
                }
                SideEffect.peek = function peek() {
                    return state;
                };
                var _proto = SideEffect.prototype;
                _proto.componentDidMount = function componentDidMount() {
                    mountedInstances.push(this);
                    emitChange();
                };
                _proto.componentDidUpdate = function componentDidUpdate() {
                    emitChange();
                };
                _proto.componentWillUnmount = function componentWillUnmount() {
                    var index = mountedInstances.indexOf(this);
                    mountedInstances.splice(index, 1);
                    emitChange();
                };
                _proto.render = function render() {
                    return (0, ($parcel$interopDefault($5uXOq))).createElement(WrappedComponent, this.props);
                };
                return SideEffect;
            }((0, $5uXOq.PureComponent));
            (0, $eHiP8.default)(SideEffect, "displayName", "SideEffect(" + getDisplayName(WrappedComponent) + ")");
            return SideEffect;
        };
    }
    var $4a1931e6e98edb22$export$2e2bcd8739ae039 = $4a1931e6e98edb22$var$withSideEffect;
});
parcelRegister("eHiP8", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ab33aeddc06e5aed$export$2e2bcd8739ae039);
    var $586Rz = parcelRequire("586Rz");
    function $ab33aeddc06e5aed$export$2e2bcd8739ae039(e, r, t) {
        return (r = (0, $586Rz.default)(r)) in e ? Object.defineProperty(e, r, {
            value: t,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : e[r] = t, e;
    }
});
parcelRegister("586Rz", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3bc305fa7a392472$export$2e2bcd8739ae039);
    var $eKtAb = parcelRequire("eKtAb");
    var $kGKYI = parcelRequire("kGKYI");
    function $3bc305fa7a392472$export$2e2bcd8739ae039(t) {
        var i = (0, $kGKYI.default)(t, "string");
        return "symbol" == (0, $eKtAb.default)(i) ? i : i + "";
    }
});
parcelRegister("eKtAb", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$abcc4f12e9e8c580$export$2e2bcd8739ae039);
    function $abcc4f12e9e8c580$export$2e2bcd8739ae039(o) {
        "@babel/helpers - typeof";
        return $abcc4f12e9e8c580$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
            return typeof o;
        } : function(o) {
            return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
        }, $abcc4f12e9e8c580$export$2e2bcd8739ae039(o);
    }
});
parcelRegister("kGKYI", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f0fc2bce6211f5a4$export$2e2bcd8739ae039);
    var $eKtAb = parcelRequire("eKtAb");
    function $f0fc2bce6211f5a4$export$2e2bcd8739ae039(t, r) {
        if ("object" != (0, $eKtAb.default)(t) || !t) return t;
        var e = t[Symbol.toPrimitive];
        if (void 0 !== e) {
            var i = e.call(t, r || "default");
            if ("object" != (0, $eKtAb.default)(i)) return i;
            throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return ("string" === r ? String : Number)(t);
    }
});
parcelRegister("j4988", function(module, exports) {
    $parcel$export(module.exports, "captureFocusRestore", ()=>$de15791afd27bb83$export$d357db6e554ff59a);
    var $l1lpg;
    function $de15791afd27bb83$var$weakRef(value) {
        if (!value) return null;
        if (typeof WeakRef === 'undefined') return function() {
            return value || null;
        };
        var w = value ? new WeakRef(value) : null;
        return function() {
            return (w === null || w === void 0 ? void 0 : w.deref()) || null;
        };
    }
    var $de15791afd27bb83$export$5061a7725be48ff9 = function(element) {
        if (!element) return null;
        var stack = [];
        var currentElement = element;
        while(currentElement && currentElement !== document.body){
            stack.push({
                current: $de15791afd27bb83$var$weakRef(currentElement),
                parent: $de15791afd27bb83$var$weakRef(currentElement.parentElement),
                left: $de15791afd27bb83$var$weakRef(currentElement.previousElementSibling),
                right: $de15791afd27bb83$var$weakRef(currentElement.nextElementSibling)
            });
            currentElement = currentElement.parentElement;
        }
        return {
            element: $de15791afd27bb83$var$weakRef(element),
            stack: stack,
            ownerDocument: element.ownerDocument
        };
    };
    var $de15791afd27bb83$var$restoreFocusTo = function(location) {
        var _a, _b, _c, _d, _e;
        if (!location) return undefined;
        var stack = location.stack, ownerDocument = location.ownerDocument;
        var visibilityCache = new Map();
        for(var _i = 0, stack_1 = stack; _i < stack_1.length; _i++){
            var line = stack_1[_i];
            var parent_1 = (_a = line.parent) === null || _a === void 0 ? void 0 : _a.call(line);
            if (parent_1 && ownerDocument.contains(parent_1)) {
                var left = (_b = line.left) === null || _b === void 0 ? void 0 : _b.call(line);
                var savedCurrent = line.current();
                var current = parent_1.contains(savedCurrent) ? savedCurrent : undefined;
                var right = (_c = line.right) === null || _c === void 0 ? void 0 : _c.call(line);
                var focusables = (0, (0, parcelRequire("l1lpg")).getTabbableNodes)([
                    parent_1
                ], visibilityCache);
                var aim = (_e = (_d = current !== null && current !== void 0 ? current : left === null || left === void 0 ? void 0 : left.nextElementSibling) !== null && _d !== void 0 ? _d : right) !== null && _e !== void 0 ? _e : left;
                while(aim){
                    for(var _f = 0, focusables_1 = focusables; _f < focusables_1.length; _f++){
                        var focusable = focusables_1[_f];
                        if (aim === null || aim === void 0 ? void 0 : aim.contains(focusable.node)) return focusable.node;
                    }
                    aim = aim.nextElementSibling;
                }
                if (focusables.length) return focusables[0].node;
            }
        }
        return undefined;
    };
    var $de15791afd27bb83$export$d357db6e554ff59a = function(targetElement) {
        var location = $de15791afd27bb83$export$5061a7725be48ff9(targetElement);
        return function() {
            return $de15791afd27bb83$var$restoreFocusTo(location);
        };
    };
});
parcelRegister("l1lpg", function(module, exports) {
    $parcel$export(module.exports, "filterAutoFocusable", ()=>$03f3013918b31c29$export$2f70373d403a5d2b);
    $parcel$export(module.exports, "getTabbableNodes", ()=>$03f3013918b31c29$export$3738e313571e2ad2);
    $parcel$export(module.exports, "getFocusableNodes", ()=>$03f3013918b31c29$export$493d05a3a8e6532d);
    $parcel$export(module.exports, "parentAutofocusables", ()=>$03f3013918b31c29$export$dc26309a71d1ce47);
    $parcel$export(module.exports, "contains", ()=>$03f3013918b31c29$export$2344b14b097df817);
    var $649lM;
    var $jlIIa;
    var $hPwd3;
    var $detSP;
    var $03f3013918b31c29$export$6266a5cd5915dc33 = function(nodes, visibilityCache) {
        return (0, (0, parcelRequire("649lM")).toArray)(nodes).filter(function(node) {
            return (0, (0, parcelRequire("jlIIa")).isVisibleCached)(visibilityCache, node);
        }).filter(function(node) {
            return (0, (0, parcelRequire("jlIIa")).notHiddenInput)(node);
        });
    };
    var $03f3013918b31c29$export$2f70373d403a5d2b = function(nodes, cache) {
        if (cache === void 0) cache = new Map();
        return (0, (0, parcelRequire("649lM")).toArray)(nodes).filter(function(node) {
            return (0, (0, parcelRequire("jlIIa")).isAutoFocusAllowedCached)(cache, node);
        });
    };
    var $03f3013918b31c29$export$3738e313571e2ad2 = function(topNodes, visibilityCache, withGuards) {
        return (0, (0, parcelRequire("hPwd3")).orderByTabIndex)($03f3013918b31c29$export$6266a5cd5915dc33((0, (0, parcelRequire("detSP")).getFocusables)(topNodes, withGuards), visibilityCache), true, withGuards);
    };
    var $03f3013918b31c29$export$493d05a3a8e6532d = function(topNodes, visibilityCache) {
        return (0, (0, parcelRequire("hPwd3")).orderByTabIndex)($03f3013918b31c29$export$6266a5cd5915dc33((0, (0, parcelRequire("detSP")).getFocusables)(topNodes), visibilityCache), false);
    };
    var $03f3013918b31c29$export$dc26309a71d1ce47 = function(topNode, visibilityCache) {
        return $03f3013918b31c29$export$6266a5cd5915dc33((0, (0, parcelRequire("detSP")).getParentAutofocusables)(topNode), visibilityCache);
    };
    var $03f3013918b31c29$export$2344b14b097df817 = function(scope, element) {
        if (scope.shadowRoot) return $03f3013918b31c29$export$2344b14b097df817(scope.shadowRoot, element);
        else {
            if (Object.getPrototypeOf(scope).contains !== undefined && Object.getPrototypeOf(scope).contains.call(scope, element)) return true;
            return (0, (0, parcelRequire("649lM")).toArray)(scope.children).some(function(child) {
                var _a;
                if (child instanceof HTMLIFrameElement) {
                    var iframeBody = (_a = child.contentDocument) === null || _a === void 0 ? void 0 : _a.body;
                    if (iframeBody) return $03f3013918b31c29$export$2344b14b097df817(iframeBody, element);
                    return false;
                }
                return $03f3013918b31c29$export$2344b14b097df817(child, element);
            });
        }
    };
});
parcelRegister("649lM", function(module, exports) {
    $parcel$export(module.exports, "toArray", ()=>$46aa5e8f7fb698d8$export$45b10814cc054894);
    $parcel$export(module.exports, "asArray", ()=>$46aa5e8f7fb698d8$export$75093a47a9fa838d);
    $parcel$export(module.exports, "getFirst", ()=>$46aa5e8f7fb698d8$export$bcd7afcd904dce14);
    var $46aa5e8f7fb698d8$export$45b10814cc054894 = function(a) {
        var ret = Array(a.length);
        for(var i = 0; i < a.length; ++i)ret[i] = a[i];
        return ret;
    };
    var $46aa5e8f7fb698d8$export$75093a47a9fa838d = function(a) {
        return Array.isArray(a) ? a : [
            a
        ];
    };
    var $46aa5e8f7fb698d8$export$bcd7afcd904dce14 = function(a) {
        return Array.isArray(a) ? a[0] : a;
    };
});
parcelRegister("jlIIa", function(module, exports) {
    $parcel$export(module.exports, "isVisibleCached", ()=>$e162a936fc2d012a$export$3c9dc299685ad160);
    $parcel$export(module.exports, "isAutoFocusAllowedCached", ()=>$e162a936fc2d012a$export$bcaa50628f6a736e);
    $parcel$export(module.exports, "getDataset", ()=>$e162a936fc2d012a$export$698b339b0c8edae3);
    $parcel$export(module.exports, "isRadioElement", ()=>$e162a936fc2d012a$export$9d74f6fbc6f469d0);
    $parcel$export(module.exports, "notHiddenInput", ()=>$e162a936fc2d012a$export$8197b0ea56b3b055);
    $parcel$export(module.exports, "isGuard", ()=>$e162a936fc2d012a$export$d94b8b58ec2f30eb);
    $parcel$export(module.exports, "isNotAGuard", ()=>$e162a936fc2d012a$export$602e5a0d338d7750);
    $parcel$export(module.exports, "isDefined", ()=>$e162a936fc2d012a$export$4e62c701997796c1);
    var $26Cgu;
    var $e162a936fc2d012a$var$isElementHidden = function(node) {
        if (node.nodeType !== Node.ELEMENT_NODE) return false;
        var computedStyle = window.getComputedStyle(node, null);
        if (!computedStyle || !computedStyle.getPropertyValue) return false;
        return computedStyle.getPropertyValue('display') === 'none' || computedStyle.getPropertyValue('visibility') === 'hidden';
    };
    var $e162a936fc2d012a$var$getParentNode = function(node) {
        return node.parentNode && node.parentNode.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? node.parentNode.host : node.parentNode;
    };
    var $e162a936fc2d012a$var$isTopNode = function(node) {
        return node === document || node && node.nodeType === Node.DOCUMENT_NODE;
    };
    var $e162a936fc2d012a$var$isInert = function(node) {
        return node.hasAttribute('inert');
    };
    var $e162a936fc2d012a$var$isVisibleUncached = function(node, checkParent) {
        return !node || $e162a936fc2d012a$var$isTopNode(node) || !$e162a936fc2d012a$var$isElementHidden(node) && !$e162a936fc2d012a$var$isInert(node) && checkParent($e162a936fc2d012a$var$getParentNode(node));
    };
    var $e162a936fc2d012a$export$3c9dc299685ad160 = function(visibilityCache, node) {
        var cached = visibilityCache.get(node);
        if (cached !== undefined) return cached;
        var result = $e162a936fc2d012a$var$isVisibleUncached(node, $e162a936fc2d012a$export$3c9dc299685ad160.bind(undefined, visibilityCache));
        visibilityCache.set(node, result);
        return result;
    };
    var $e162a936fc2d012a$var$isAutoFocusAllowedUncached = function(node, checkParent) {
        return node && !$e162a936fc2d012a$var$isTopNode(node) ? $e162a936fc2d012a$export$b8550e27de209d85(node) ? checkParent($e162a936fc2d012a$var$getParentNode(node)) : false : true;
    };
    var $e162a936fc2d012a$export$bcaa50628f6a736e = function(cache, node) {
        var cached = cache.get(node);
        if (cached !== undefined) return cached;
        var result = $e162a936fc2d012a$var$isAutoFocusAllowedUncached(node, $e162a936fc2d012a$export$bcaa50628f6a736e.bind(undefined, cache));
        cache.set(node, result);
        return result;
    };
    var $e162a936fc2d012a$export$698b339b0c8edae3 = function(node) {
        return node.dataset;
    };
    var $e162a936fc2d012a$export$65aad1b6bc934b11 = function(node) {
        return node.tagName === 'BUTTON';
    };
    var $e162a936fc2d012a$export$88a6ceeed5737ba3 = function(node) {
        return node.tagName === 'INPUT';
    };
    var $e162a936fc2d012a$export$9d74f6fbc6f469d0 = function(node) {
        return $e162a936fc2d012a$export$88a6ceeed5737ba3(node) && node.type === 'radio';
    };
    var $e162a936fc2d012a$export$8197b0ea56b3b055 = function(node) {
        return !(($e162a936fc2d012a$export$88a6ceeed5737ba3(node) || $e162a936fc2d012a$export$65aad1b6bc934b11(node)) && (node.type === 'hidden' || node.disabled));
    };
    var $e162a936fc2d012a$export$b8550e27de209d85 = function(node) {
        var attribute = node.getAttribute((0, (0, parcelRequire("26Cgu")).FOCUS_NO_AUTOFOCUS));
        return ![
            true,
            'true',
            ''
        ].includes(attribute);
    };
    var $e162a936fc2d012a$export$d94b8b58ec2f30eb = function(node) {
        var _a;
        return Boolean(node && ((_a = $e162a936fc2d012a$export$698b339b0c8edae3(node)) === null || _a === void 0 ? void 0 : _a.focusGuard));
    };
    var $e162a936fc2d012a$export$602e5a0d338d7750 = function(node) {
        return !$e162a936fc2d012a$export$d94b8b58ec2f30eb(node);
    };
    var $e162a936fc2d012a$export$4e62c701997796c1 = function(x) {
        return Boolean(x);
    };
});
parcelRegister("hPwd3", function(module, exports) {
    $parcel$export(module.exports, "orderByTabIndex", ()=>$cfb02f3dbbab37c3$export$cb40ee071f0d5226);
    var $649lM;
    var $cfb02f3dbbab37c3$export$350ee6c095d98996 = function(a, b) {
        var aTab = Math.max(0, a.tabIndex);
        var bTab = Math.max(0, b.tabIndex);
        var tabDiff = aTab - bTab;
        var indexDiff = a.index - b.index;
        if (tabDiff) {
            if (!aTab) return 1;
            if (!bTab) return -1;
        }
        return tabDiff || indexDiff;
    };
    var $cfb02f3dbbab37c3$var$getTabIndex = function(node) {
        if (node.tabIndex < 0) {
            if (!node.hasAttribute('tabindex')) return 0;
        }
        return node.tabIndex;
    };
    var $cfb02f3dbbab37c3$export$cb40ee071f0d5226 = function(nodes, filterNegative, keepGuards) {
        return (0, (0, parcelRequire("649lM")).toArray)(nodes).map(function(node, index) {
            var tabIndex = $cfb02f3dbbab37c3$var$getTabIndex(node);
            return {
                node: node,
                index: index,
                tabIndex: keepGuards && tabIndex === -1 ? (node.dataset || {}).focusGuard ? 0 : -1 : tabIndex
            };
        }).filter(function(data) {
            return !filterNegative || data.tabIndex >= 0;
        }).sort($cfb02f3dbbab37c3$export$350ee6c095d98996);
    };
});
parcelRegister("detSP", function(module, exports) {
    $parcel$export(module.exports, "getFocusables", ()=>$9a23c35cb23add47$export$f6768025e418420e);
    $parcel$export(module.exports, "getParentAutofocusables", ()=>$9a23c35cb23add47$export$853fa94d922e78b9);
    var $26Cgu;
    var $649lM;
    var $h8JFa;
    var $9a23c35cb23add47$var$queryTabbables = (0, (0, parcelRequire("h8JFa")).tabbables).join(',');
    var $9a23c35cb23add47$var$queryGuardTabbables = "".concat($9a23c35cb23add47$var$queryTabbables, ", [data-focus-guard]");
    var $9a23c35cb23add47$var$getFocusablesWithShadowDom = function(parent, withGuards) {
        return (0, (0, parcelRequire("649lM")).toArray)((parent.shadowRoot || parent).children).reduce(function(acc, child) {
            return acc.concat(child.matches(withGuards ? $9a23c35cb23add47$var$queryGuardTabbables : $9a23c35cb23add47$var$queryTabbables) ? [
                child
            ] : [], $9a23c35cb23add47$var$getFocusablesWithShadowDom(child));
        }, []);
    };
    var $9a23c35cb23add47$var$getFocusablesWithIFrame = function(parent, withGuards) {
        var _a;
        if (parent instanceof HTMLIFrameElement && ((_a = parent.contentDocument) === null || _a === void 0 ? void 0 : _a.body)) return $9a23c35cb23add47$export$f6768025e418420e([
            parent.contentDocument.body
        ], withGuards);
        return [
            parent
        ];
    };
    var $9a23c35cb23add47$export$f6768025e418420e = function(parents, withGuards) {
        return parents.reduce(function(acc, parent) {
            var _a;
            var focusableWithShadowDom = $9a23c35cb23add47$var$getFocusablesWithShadowDom(parent, withGuards);
            var focusableWithIframes = (_a = []).concat.apply(_a, focusableWithShadowDom.map(function(node) {
                return $9a23c35cb23add47$var$getFocusablesWithIFrame(node, withGuards);
            }));
            return acc.concat(focusableWithIframes, parent.parentNode ? (0, (0, parcelRequire("649lM")).toArray)(parent.parentNode.querySelectorAll($9a23c35cb23add47$var$queryTabbables)).filter(function(node) {
                return node === parent;
            }) : []);
        }, []);
    };
    var $9a23c35cb23add47$export$853fa94d922e78b9 = function(parent) {
        var parentFocus = parent.querySelectorAll("[".concat((0, (0, parcelRequire("26Cgu")).FOCUS_AUTO), "]"));
        return (0, (0, parcelRequire("649lM")).toArray)(parentFocus).map(function(node) {
            return $9a23c35cb23add47$export$f6768025e418420e([
                node
            ]);
        }).reduce(function(acc, nodes) {
            return acc.concat(nodes);
        }, []);
    };
});
parcelRegister("h8JFa", function(module, exports) {
    $parcel$export(module.exports, "tabbables", ()=>$c7a69abaf19a3f41$export$8555f4622e95784);
    var $c7a69abaf19a3f41$export$8555f4622e95784 = [
        'button:enabled',
        'select:enabled',
        'textarea:enabled',
        'input:enabled',
        'a[href]',
        'area[href]',
        'summary',
        'iframe',
        'object',
        'embed',
        'audio[controls]',
        'video[controls]',
        '[tabindex]',
        '[contenteditable]',
        '[autofocus]'
    ];
});
parcelRegister("2RQOj", function(module, exports) {
    $parcel$export(module.exports, "expandFocusableNodes", ()=>$21697f119bba8faa$export$f89ac71e91767111);
    var $1kBVR;
    var $jlIIa;
    var $3jtrL;
    var $hPwd3;
    var $detSP;
    var $21697f119bba8faa$export$f89ac71e91767111 = function(topNode) {
        var entries = (0, (0, parcelRequire("1kBVR")).getAllAffectedNodes)(topNode).filter((0, (0, parcelRequire("jlIIa")).isNotAGuard));
        var commonParent = (0, (0, parcelRequire("3jtrL")).getTopCommonParent)(topNode, topNode, entries);
        var outerNodes = (0, (0, parcelRequire("hPwd3")).orderByTabIndex)((0, (0, parcelRequire("detSP")).getFocusables)([
            commonParent
        ], true), true, true);
        var innerElements = (0, (0, parcelRequire("detSP")).getFocusables)(entries, false);
        return outerNodes.map(function(_a) {
            var node = _a.node, index = _a.index;
            return {
                node: node,
                index: index,
                lockItem: innerElements.indexOf(node) >= 0,
                guard: (0, (0, parcelRequire("jlIIa")).isGuard)(node)
            };
        });
    };
});
parcelRegister("1kBVR", function(module, exports) {
    $parcel$export(module.exports, "getAllAffectedNodes", ()=>$0f851546d68da0ab$export$7e87c4720b9b279b);
    var $26Cgu;
    var $649lM;
    var $0f851546d68da0ab$var$filterNested = function(nodes) {
        var contained = new Set();
        var l = nodes.length;
        for(var i = 0; i < l; i += 1)for(var j = i + 1; j < l; j += 1){
            var position = nodes[i].compareDocumentPosition(nodes[j]);
            if ((position & Node.DOCUMENT_POSITION_CONTAINED_BY) > 0) contained.add(j);
            if ((position & Node.DOCUMENT_POSITION_CONTAINS) > 0) contained.add(i);
        }
        return nodes.filter(function(_, index) {
            return !contained.has(index);
        });
    };
    var $0f851546d68da0ab$var$getTopParent = function(node) {
        return node.parentNode ? $0f851546d68da0ab$var$getTopParent(node.parentNode) : node;
    };
    var $0f851546d68da0ab$export$7e87c4720b9b279b = function(node) {
        var nodes = (0, (0, parcelRequire("649lM")).asArray)(node);
        return nodes.filter(Boolean).reduce(function(acc, currentNode) {
            var group = currentNode.getAttribute((0, (0, parcelRequire("26Cgu")).FOCUS_GROUP));
            acc.push.apply(acc, group ? $0f851546d68da0ab$var$filterNested((0, (0, parcelRequire("649lM")).toArray)($0f851546d68da0ab$var$getTopParent(currentNode).querySelectorAll("[".concat((0, (0, parcelRequire("26Cgu")).FOCUS_GROUP), "=\"").concat(group, "\"]:not([").concat((0, (0, parcelRequire("26Cgu")).FOCUS_DISABLED), "=\"disabled\"])")))) : [
                currentNode
            ]);
            return acc;
        }, []);
    };
});
parcelRegister("3jtrL", function(module, exports) {
    $parcel$export(module.exports, "getTopCommonParent", ()=>$2699fcfa1a3b19bb$export$a9a7252b5f2e280e);
    $parcel$export(module.exports, "allParentAutofocusables", ()=>$2699fcfa1a3b19bb$export$8f99714c70a37db1);
    var $l1lpg;
    var $649lM;
    var $2699fcfa1a3b19bb$var$getParents = function(node, parents) {
        if (parents === void 0) parents = [];
        parents.push(node);
        if (node.parentNode) $2699fcfa1a3b19bb$var$getParents(node.parentNode.host || node.parentNode, parents);
        return parents;
    };
    var $2699fcfa1a3b19bb$export$a08e5f53769bce53 = function(nodeA, nodeB) {
        var parentsA = $2699fcfa1a3b19bb$var$getParents(nodeA);
        var parentsB = $2699fcfa1a3b19bb$var$getParents(nodeB);
        for(var i = 0; i < parentsA.length; i += 1){
            var currentParent = parentsA[i];
            if (parentsB.indexOf(currentParent) >= 0) return currentParent;
        }
        return false;
    };
    var $2699fcfa1a3b19bb$export$a9a7252b5f2e280e = function(baseActiveElement, leftEntry, rightEntries) {
        var activeElements = (0, (0, parcelRequire("649lM")).asArray)(baseActiveElement);
        var leftEntries = (0, (0, parcelRequire("649lM")).asArray)(leftEntry);
        var activeElement = activeElements[0];
        var topCommon = false;
        leftEntries.filter(Boolean).forEach(function(entry) {
            topCommon = $2699fcfa1a3b19bb$export$a08e5f53769bce53(topCommon || entry, entry) || topCommon;
            rightEntries.filter(Boolean).forEach(function(subEntry) {
                var common = $2699fcfa1a3b19bb$export$a08e5f53769bce53(activeElement, subEntry);
                if (common) {
                    if (!topCommon || (0, (0, parcelRequire("l1lpg")).contains)(common, topCommon)) topCommon = common;
                    else topCommon = $2699fcfa1a3b19bb$export$a08e5f53769bce53(common, topCommon);
                }
            });
        });
        return topCommon;
    };
    var $2699fcfa1a3b19bb$export$8f99714c70a37db1 = function(entries, visibilityCache) {
        return entries.reduce(function(acc, node) {
            return acc.concat((0, (0, parcelRequire("l1lpg")).parentAutofocusables)(node, visibilityCache));
        }, []);
    };
});
parcelRegister("1q0r0", function(module, exports) {
    $parcel$export(module.exports, "focusNextElement", ()=>$10888e6d50ae918b$export$3b0237e8566c8d65);
    $parcel$export(module.exports, "focusPrevElement", ()=>$10888e6d50ae918b$export$33b47db07a82b2fb);
    $parcel$export(module.exports, "focusFirstElement", ()=>$10888e6d50ae918b$export$2a791d8097a66406);
    $parcel$export(module.exports, "focusLastElement", ()=>$10888e6d50ae918b$export$6a79073ddabfd6c3);
    var $jfQb7;
    var $l1lpg;
    var $649lM;
    var $10888e6d50ae918b$export$1b42c72592537703 = function(element, scope, useTabbables) {
        if (!element || !scope) {
            console.error('no element or scope given');
            return {};
        }
        var shards = (0, (0, parcelRequire("649lM")).asArray)(scope);
        if (shards.every(function(shard) {
            return !(0, (0, parcelRequire("l1lpg")).contains)(shard, element);
        })) {
            console.error('Active element is not contained in the scope');
            return {};
        }
        var focusables = useTabbables ? (0, (0, parcelRequire("l1lpg")).getTabbableNodes)(shards, new Map()) : (0, (0, parcelRequire("l1lpg")).getFocusableNodes)(shards, new Map());
        var current = focusables.findIndex(function(_a) {
            var node = _a.node;
            return node === element;
        });
        if (current === -1) return undefined;
        return {
            prev: focusables[current - 1],
            next: focusables[current + 1],
            first: focusables[0],
            last: focusables[focusables.length - 1]
        };
    };
    var $10888e6d50ae918b$var$getBoundary = function(shards, useTabbables) {
        var set = useTabbables ? (0, (0, parcelRequire("l1lpg")).getTabbableNodes)((0, (0, parcelRequire("649lM")).asArray)(shards), new Map()) : (0, (0, parcelRequire("l1lpg")).getFocusableNodes)((0, (0, parcelRequire("649lM")).asArray)(shards), new Map());
        return {
            first: set[0],
            last: set[set.length - 1]
        };
    };
    var $10888e6d50ae918b$var$defaultOptions = function(options) {
        return Object.assign({
            scope: document.body,
            cycle: true,
            onlyTabbable: true
        }, options);
    };
    var $10888e6d50ae918b$var$moveFocus = function(fromElement, options, cb) {
        if (options === void 0) options = {};
        var newOptions = $10888e6d50ae918b$var$defaultOptions(options);
        var solution = $10888e6d50ae918b$export$1b42c72592537703(fromElement, newOptions.scope, newOptions.onlyTabbable);
        if (!solution) return;
        var target = cb(solution, newOptions.cycle);
        if (target) (0, (0, parcelRequire("jfQb7")).focusOn)(target.node, newOptions.focusOptions);
    };
    var $10888e6d50ae918b$export$3b0237e8566c8d65 = function(fromElement, options) {
        if (options === void 0) options = {};
        $10888e6d50ae918b$var$moveFocus(fromElement, options, function(_a, cycle) {
            var next = _a.next, first = _a.first;
            return next || cycle && first;
        });
    };
    var $10888e6d50ae918b$export$33b47db07a82b2fb = function(fromElement, options) {
        if (options === void 0) options = {};
        $10888e6d50ae918b$var$moveFocus(fromElement, options, function(_a, cycle) {
            var prev = _a.prev, last = _a.last;
            return prev || cycle && last;
        });
    };
    var $10888e6d50ae918b$var$pickBoundary = function(scope, options, what) {
        var _a;
        var boundary = $10888e6d50ae918b$var$getBoundary(scope, (_a = options.onlyTabbable) !== null && _a !== void 0 ? _a : true);
        var node = boundary[what];
        if (node) (0, (0, parcelRequire("jfQb7")).focusOn)(node.node, options.focusOptions);
    };
    var $10888e6d50ae918b$export$2a791d8097a66406 = function(scope, options) {
        if (options === void 0) options = {};
        $10888e6d50ae918b$var$pickBoundary(scope, options, 'first');
    };
    var $10888e6d50ae918b$export$6a79073ddabfd6c3 = function(scope, options) {
        if (options === void 0) options = {};
        $10888e6d50ae918b$var$pickBoundary(scope, options, 'last');
    };
});
parcelRegister("jfQb7", function(module, exports) {
    $parcel$export(module.exports, "focusOn", ()=>$e047e48fcca0b3b0$export$c12b3da842c43a8);
    var $e047e48fcca0b3b0$export$c12b3da842c43a8 = function(target, focusOptions) {
        if (!target) return;
        if ('focus' in target) target.focus(focusOptions);
        if ('contentWindow' in target && target.contentWindow) target.contentWindow.focus();
    };
});
parcelRegister("5x9g9", function(module, exports) {
    $parcel$export(module.exports, "focusInside", ()=>$4077379349d4c74a$export$20115f8da7baa6fa);
    var $l1lpg;
    var $1kBVR;
    var $649lM;
    var $33cOt;
    var $4077379349d4c74a$var$focusInFrame = function(frame, activeElement) {
        return frame === activeElement;
    };
    var $4077379349d4c74a$var$focusInsideIframe = function(topNode, activeElement) {
        return Boolean((0, (0, parcelRequire("649lM")).toArray)(topNode.querySelectorAll('iframe')).some(function(node) {
            return $4077379349d4c74a$var$focusInFrame(node, activeElement);
        }));
    };
    var $4077379349d4c74a$export$20115f8da7baa6fa = function(topNode, activeElement) {
        if (activeElement === void 0) activeElement = (0, (0, parcelRequire("33cOt")).getActiveElement)((0, (0, parcelRequire("649lM")).getFirst)(topNode).ownerDocument);
        if (!activeElement || activeElement.dataset && activeElement.dataset.focusGuard) return false;
        return (0, (0, parcelRequire("1kBVR")).getAllAffectedNodes)(topNode).some(function(node) {
            return (0, (0, parcelRequire("l1lpg")).contains)(node, activeElement) || $4077379349d4c74a$var$focusInsideIframe(node, activeElement);
        });
    };
});
parcelRegister("33cOt", function(module, exports) {
    $parcel$export(module.exports, "getActiveElement", ()=>$238b9756ed43b48b$export$cd4e5573fbe2b576);
    var $513Q1;
    var $238b9756ed43b48b$export$cd4e5573fbe2b576 = function(inDocument) {
        if (inDocument === void 0) inDocument = document;
        if (!inDocument || !inDocument.activeElement) return undefined;
        var activeElement = inDocument.activeElement;
        return activeElement.shadowRoot ? $238b9756ed43b48b$export$cd4e5573fbe2b576(activeElement.shadowRoot) : activeElement instanceof HTMLIFrameElement && (0, (0, parcelRequire("513Q1")).safeProbe)(function() {
            return activeElement.contentWindow.document;
        }) ? $238b9756ed43b48b$export$cd4e5573fbe2b576(activeElement.contentWindow.document) : activeElement;
    };
});
parcelRegister("513Q1", function(module, exports) {
    $parcel$export(module.exports, "safeProbe", ()=>$3a7005e711f25367$export$78d20aae35adef88);
    var $3a7005e711f25367$export$78d20aae35adef88 = function(cb) {
        try {
            return cb();
        } catch (e) {
            return undefined;
        }
    };
});
parcelRegister("jl7aa", function(module, exports) {
    $parcel$export(module.exports, "focusIsHidden", ()=>$e14588ebb2dd3a92$export$be6b21806d3fd485);
    var $26Cgu;
    var $l1lpg;
    var $649lM;
    var $33cOt;
    var $e14588ebb2dd3a92$export$be6b21806d3fd485 = function(inDocument) {
        if (inDocument === void 0) inDocument = document;
        var activeElement = (0, (0, parcelRequire("33cOt")).getActiveElement)(inDocument);
        if (!activeElement) return false;
        return (0, (0, parcelRequire("649lM")).toArray)(inDocument.querySelectorAll("[".concat((0, (0, parcelRequire("26Cgu")).FOCUS_ALLOW), "]"))).some(function(node) {
            return (0, (0, parcelRequire("l1lpg")).contains)(node, activeElement);
        });
    };
});
parcelRegister("cCk2L", function(module, exports) {
    $parcel$export(module.exports, "moveFocusInside", ()=>(parcelRequire("9wlSW")).moveFocusInside);
    var $26Cgu;
    var $5x9g9;
    var $jl7aa;
    var $2RQOj;
    var $9wlSW;
    var $j4988;
    var $1q0r0;
    var $l1lpg;
    var $92f894e236277f1c$export$1a988e7317c65621 = (0, parcelRequire("26Cgu"));
    var $92f894e236277f1c$var$deprecated_default_moveFocusInside = (0, (0, parcelRequire("9wlSW")).moveFocusInside);
    var $92f894e236277f1c$export$2e2bcd8739ae039 = $92f894e236277f1c$var$deprecated_default_moveFocusInside;
});
parcelRegister("9wlSW", function(module, exports) {
    $parcel$export(module.exports, "moveFocusInside", ()=>$6ee8142619db9ef1$export$cd599851e879a025);
    var $jfQb7;
    var $kKJqK;
    var $6ee8142619db9ef1$var$guardCount = 0;
    var $6ee8142619db9ef1$var$lockDisabled = false;
    var $6ee8142619db9ef1$export$cd599851e879a025 = function(topNode, lastNode, options) {
        if (options === void 0) options = {};
        var focusable = (0, (0, parcelRequire("kKJqK")).focusSolver)(topNode, lastNode);
        if ($6ee8142619db9ef1$var$lockDisabled) return;
        if (focusable) {
            if ($6ee8142619db9ef1$var$guardCount > 2) {
                console.error("FocusLock: focus-fighting detected. Only one focus management system could be active. See https://github.com/theKashey/focus-lock/#focus-fighting");
                $6ee8142619db9ef1$var$lockDisabled = true;
                setTimeout(function() {
                    $6ee8142619db9ef1$var$lockDisabled = false;
                }, 1);
                return;
            }
            $6ee8142619db9ef1$var$guardCount++;
            (0, (0, parcelRequire("jfQb7")).focusOn)(focusable.node, options.focusOptions);
            $6ee8142619db9ef1$var$guardCount--;
        }
    };
});
parcelRegister("kKJqK", function(module, exports) {
    $parcel$export(module.exports, "focusSolver", ()=>$f1bb580dea56dbbd$export$305758c744b57f6f);
    var $6e7nq;
    var $l1lpg;
    var $1kBVR;
    var $649lM;
    var $6QUqp;
    var $33cOt;
    var $jlIIa;
    var $3jtrL;
    var $f1bb580dea56dbbd$var$reorderNodes = function(srcNodes, dstNodes) {
        var remap = new Map();
        dstNodes.forEach(function(entity) {
            return remap.set(entity.node, entity);
        });
        return srcNodes.map(function(node) {
            return remap.get(node);
        }).filter((0, (0, parcelRequire("jlIIa")).isDefined));
    };
    var $f1bb580dea56dbbd$export$305758c744b57f6f = function(topNode, lastNode) {
        var activeElement = (0, (0, parcelRequire("33cOt")).getActiveElement)((0, (0, parcelRequire("649lM")).asArray)(topNode).length > 0 ? document : (0, (0, parcelRequire("649lM")).getFirst)(topNode).ownerDocument);
        var entries = (0, (0, parcelRequire("1kBVR")).getAllAffectedNodes)(topNode).filter((0, (0, parcelRequire("jlIIa")).isNotAGuard));
        var commonParent = (0, (0, parcelRequire("3jtrL")).getTopCommonParent)(activeElement || topNode, topNode, entries);
        var visibilityCache = new Map();
        var anyFocusable = (0, (0, parcelRequire("l1lpg")).getFocusableNodes)(entries, visibilityCache);
        var innerElements = anyFocusable.filter(function(_a) {
            var node = _a.node;
            return (0, (0, parcelRequire("jlIIa")).isNotAGuard)(node);
        });
        if (!innerElements[0]) return undefined;
        var outerNodes = (0, (0, parcelRequire("l1lpg")).getFocusableNodes)([
            commonParent
        ], visibilityCache).map(function(_a) {
            var node = _a.node;
            return node;
        });
        var orderedInnerElements = $f1bb580dea56dbbd$var$reorderNodes(outerNodes, innerElements);
        var innerFocusables = orderedInnerElements.map(function(_a) {
            var node = _a.node;
            return node;
        });
        var innerTabbable = orderedInnerElements.filter(function(_a) {
            var tabIndex = _a.tabIndex;
            return tabIndex >= 0;
        }).map(function(_a) {
            var node = _a.node;
            return node;
        });
        var newId = (0, (0, parcelRequire("6e7nq")).newFocus)(innerFocusables, innerTabbable, outerNodes, activeElement, lastNode);
        if (newId === (0, (0, parcelRequire("6e7nq")).NEW_FOCUS)) {
            var focusNode = (0, (0, parcelRequire("6QUqp")).pickAutofocus)(anyFocusable, innerTabbable, (0, (0, parcelRequire("3jtrL")).allParentAutofocusables)(entries, visibilityCache)) || (0, (0, parcelRequire("6QUqp")).pickAutofocus)(anyFocusable, innerFocusables, (0, (0, parcelRequire("3jtrL")).allParentAutofocusables)(entries, visibilityCache));
            if (focusNode) return {
                node: focusNode
            };
            else {
                console.warn('focus-lock: cannot find any node to move focus into');
                return undefined;
            }
        }
        if (newId === undefined) return newId;
        return orderedInnerElements[newId];
    };
});
parcelRegister("6e7nq", function(module, exports) {
    $parcel$export(module.exports, "NEW_FOCUS", ()=>$4889c5c91be25c0a$export$85710b12cf912438);
    $parcel$export(module.exports, "newFocus", ()=>$4889c5c91be25c0a$export$65842178e9bb4205);
    var $2aoIt;
    var $ee0vg;
    var $jlIIa;
    var $4889c5c91be25c0a$export$85710b12cf912438 = 'NEW_FOCUS';
    var $4889c5c91be25c0a$export$65842178e9bb4205 = function(innerNodes, innerTabbables, outerNodes, activeElement, lastNode) {
        var cnt = innerNodes.length;
        var firstFocus = innerNodes[0];
        var lastFocus = innerNodes[cnt - 1];
        var isOnGuard = (0, (0, parcelRequire("jlIIa")).isGuard)(activeElement);
        if (activeElement && innerNodes.indexOf(activeElement) >= 0) return undefined;
        var activeIndex = activeElement !== undefined ? outerNodes.indexOf(activeElement) : -1;
        var lastIndex = lastNode ? outerNodes.indexOf(lastNode) : activeIndex;
        var lastNodeInside = lastNode ? innerNodes.indexOf(lastNode) : -1;
        if (activeIndex === -1) {
            if (lastNodeInside !== -1) return lastNodeInside;
            return $4889c5c91be25c0a$export$85710b12cf912438;
        }
        if (lastNodeInside === -1) return $4889c5c91be25c0a$export$85710b12cf912438;
        var indexDiff = activeIndex - lastIndex;
        var firstNodeIndex = outerNodes.indexOf(firstFocus);
        var lastNodeIndex = outerNodes.indexOf(lastFocus);
        var correctedNodes = (0, (0, parcelRequire("2aoIt")).correctNodes)(outerNodes);
        var correctedIndex = activeElement !== undefined ? correctedNodes.indexOf(activeElement) : -1;
        var correctedIndexDiff = correctedIndex - (lastNode ? correctedNodes.indexOf(lastNode) : activeIndex);
        if (!indexDiff && lastNodeInside >= 0) return lastNodeInside;
        if (innerTabbables.length === 0) return lastNodeInside;
        var returnFirstNode = (0, (0, parcelRequire("ee0vg")).pickFocusable)(innerNodes, innerTabbables[0]);
        var returnLastNode = (0, (0, parcelRequire("ee0vg")).pickFocusable)(innerNodes, innerTabbables[innerTabbables.length - 1]);
        if (activeIndex <= firstNodeIndex && isOnGuard && Math.abs(indexDiff) > 1) return returnLastNode;
        if (activeIndex >= lastNodeIndex && isOnGuard && Math.abs(indexDiff) > 1) return returnFirstNode;
        if (indexDiff && Math.abs(correctedIndexDiff) > 1) return lastNodeInside;
        if (activeIndex <= firstNodeIndex) return returnLastNode;
        if (activeIndex > lastNodeIndex) return returnFirstNode;
        if (indexDiff) {
            if (Math.abs(indexDiff) > 1) return lastNodeInside;
            return (cnt + lastNodeInside + indexDiff) % cnt;
        }
        return undefined;
    };
});
parcelRegister("2aoIt", function(module, exports) {
    $parcel$export(module.exports, "correctNode", ()=>$193fb011be33b1b6$export$5261662167ad7ced);
    $parcel$export(module.exports, "correctNodes", ()=>$193fb011be33b1b6$export$4a5a72a7124e45f9);
    var $jlIIa;
    var $193fb011be33b1b6$var$findSelectedRadio = function(node, nodes) {
        return nodes.filter((0, (0, parcelRequire("jlIIa")).isRadioElement)).filter(function(el) {
            return el.name === node.name;
        }).filter(function(el) {
            return el.checked;
        })[0] || node;
    };
    var $193fb011be33b1b6$export$5261662167ad7ced = function(node, nodes) {
        if ((0, (0, parcelRequire("jlIIa")).isRadioElement)(node) && node.name) return $193fb011be33b1b6$var$findSelectedRadio(node, nodes);
        return node;
    };
    var $193fb011be33b1b6$export$4a5a72a7124e45f9 = function(nodes) {
        var resultSet = new Set();
        nodes.forEach(function(node) {
            return resultSet.add($193fb011be33b1b6$export$5261662167ad7ced(node, nodes));
        });
        return nodes.filter(function(node) {
            return resultSet.has(node);
        });
    };
});
parcelRegister("ee0vg", function(module, exports) {
    $parcel$export(module.exports, "pickFirstFocus", ()=>$a5b2c367f9c3daa0$export$f4e86cfa0679b9cc);
    $parcel$export(module.exports, "pickFocusable", ()=>$a5b2c367f9c3daa0$export$e06728ee87c96122);
    var $2aoIt;
    var $a5b2c367f9c3daa0$export$f4e86cfa0679b9cc = function(nodes) {
        if (nodes[0] && nodes.length > 1) return (0, (0, parcelRequire("2aoIt")).correctNode)(nodes[0], nodes);
        return nodes[0];
    };
    var $a5b2c367f9c3daa0$export$e06728ee87c96122 = function(nodes, node) {
        return nodes.indexOf((0, (0, parcelRequire("2aoIt")).correctNode)(node, nodes));
    };
});
parcelRegister("6QUqp", function(module, exports) {
    $parcel$export(module.exports, "pickAutofocus", ()=>$4fd35e3fd3ef884c$export$cfb742983e257555);
    var $l1lpg;
    var $ee0vg;
    var $jlIIa;
    var $4fd35e3fd3ef884c$var$findAutoFocused = function(autoFocusables) {
        return function(node) {
            var _a;
            var autofocus = (_a = (0, (0, parcelRequire("jlIIa")).getDataset)(node)) === null || _a === void 0 ? void 0 : _a.autofocus;
            return (node.autofocus || autofocus !== undefined && autofocus !== 'false' || autoFocusables.indexOf(node) >= 0);
        };
    };
    var $4fd35e3fd3ef884c$export$cfb742983e257555 = function(nodesIndexes, orderedNodes, groups) {
        var nodes = nodesIndexes.map(function(_a) {
            var node = _a.node;
            return node;
        });
        var autoFocusable = (0, (0, parcelRequire("l1lpg")).filterAutoFocusable)(nodes.filter($4fd35e3fd3ef884c$var$findAutoFocused(groups)));
        if (autoFocusable && autoFocusable.length) return (0, (0, parcelRequire("ee0vg")).pickFirstFocus)(autoFocusable);
        return (0, (0, parcelRequire("ee0vg")).pickFirstFocus)((0, (0, parcelRequire("l1lpg")).filterAutoFocusable)(orderedNodes));
    };
});
parcelRegister("1mLS6", function(module, exports) {
    $parcel$export(module.exports, "deferAction", ()=>$0fecfad02351d8b0$export$6523025722806278);
    $parcel$export(module.exports, "extractRef", ()=>$0fecfad02351d8b0$export$c613fed06e332533);
    function $0fecfad02351d8b0$export$6523025722806278(action) {
        setTimeout(action, 1);
    }
    var $0fecfad02351d8b0$export$db10c343af3f20fa = function inlineProp(name, value) {
        var obj = {};
        obj[name] = value;
        return obj;
    };
    var $0fecfad02351d8b0$export$c613fed06e332533 = function extractRef(ref) {
        return ref && 'current' in ref ? ref.current : ref;
    };
});
parcelRegister("cwc7f", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$91d1df2d50ef438b$export$2e2bcd8739ae039);
    var $iK0nX;
    var $91d1df2d50ef438b$export$2e2bcd8739ae039 = (0, (0, parcelRequire("iK0nX")).default);
});
parcelRegister("2alJM", function(module, exports) {
    'use strict';
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    var $dejU7 = parcelRequire("dejU7");
    Object.defineProperty(module.exports, 'default', {
        enumerable: true,
        get: function get() {
            return $193d608c8a4c8c43$var$_interopRequireDefault($dejU7).default;
        }
    });
    var $fUXdf = parcelRequire("fUXdf");
    Object.defineProperty(module.exports, 'TouchScrollable', {
        enumerable: true,
        get: function get() {
            return $fUXdf.TouchScrollable;
        }
    });
    function $193d608c8a4c8c43$var$_interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
});
parcelRegister("dejU7", function(module, exports) {
    'use strict';
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    var $9a1c05b159231ce4$var$_createClass = function() {
        function defineProperties(target, props) {
            for(var i = 0; i < props.length; i++){
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor) descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
            }
        }
        return function(Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
        };
    }();
    var $5uXOq = parcelRequire("5uXOq");
    var $9a1c05b159231ce4$var$_react2 = $9a1c05b159231ce4$var$_interopRequireDefault($5uXOq);
    var $lv4Ny = parcelRequire("lv4Ny");
    var $fUXdf = parcelRequire("fUXdf");
    var $bdRWg = parcelRequire("bdRWg");
    var $9a1c05b159231ce4$var$_withLockSheet2 = $9a1c05b159231ce4$var$_interopRequireDefault($bdRWg);
    var $fjsmD = parcelRequire("fjsmD");
    var $9a1c05b159231ce4$var$_withTouchListeners2 = $9a1c05b159231ce4$var$_interopRequireDefault($fjsmD);
    var $1sALq = parcelRequire("1sALq");
    function $9a1c05b159231ce4$var$_interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    function $9a1c05b159231ce4$var$_classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
    }
    function $9a1c05b159231ce4$var$_possibleConstructorReturn(self, call) {
        if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return call && (typeof call === "object" || typeof call === "function") ? call : self;
    }
    function $9a1c05b159231ce4$var$_inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
        subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
                value: subClass,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
    }
    var $9a1c05b159231ce4$var$ScrollLock = function(_PureComponent) {
        $9a1c05b159231ce4$var$_inherits(ScrollLock, _PureComponent);
        function ScrollLock() {
            $9a1c05b159231ce4$var$_classCallCheck(this, ScrollLock);
            return $9a1c05b159231ce4$var$_possibleConstructorReturn(this, (ScrollLock.__proto__ || Object.getPrototypeOf(ScrollLock)).apply(this, arguments));
        }
        $9a1c05b159231ce4$var$_createClass(ScrollLock, [
            {
                key: 'componentDidMount',
                value: function componentDidMount() {
                    if (!$lv4Ny.canUseDOM) return;
                    this.initialHeight = window.innerHeight;
                }
            },
            {
                key: 'componentWillUnmount',
                value: function componentWillUnmount() {
                    var offset = window.innerHeight - this.initialHeight;
                    if (offset) window.scrollTo(0, window.pageYOffset + offset);
                    this.initialHeight = window.innerHeight;
                }
            },
            {
                key: 'render',
                value: function render() {
                    var children = this.props.children;
                    return children ? $9a1c05b159231ce4$var$_react2.default.createElement($fUXdf.TouchScrollable, null, children) : null;
                }
            }
        ]);
        return ScrollLock;
    }($5uXOq.PureComponent);
    var $9a1c05b159231ce4$var$compose = (0, $1sALq.pipe)($9a1c05b159231ce4$var$_withTouchListeners2.default, $9a1c05b159231ce4$var$_withLockSheet2.default);
    var $9a1c05b159231ce4$var$SheetLock = $9a1c05b159231ce4$var$compose($9a1c05b159231ce4$var$ScrollLock);
    var $9a1c05b159231ce4$var$LockToggle = function LockToggle(props) {
        return props.isActive ? $9a1c05b159231ce4$var$_react2.default.createElement($9a1c05b159231ce4$var$SheetLock, props) : props.children;
    };
    $9a1c05b159231ce4$var$LockToggle.defaultProps = {
        accountForScrollbars: true,
        children: null,
        isActive: true
    };
    module.exports.default = $9a1c05b159231ce4$var$LockToggle;
});
parcelRegister("lv4Ny", function(module, exports) {
    (function() {
        'use strict';
        var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
        var ExecutionEnvironment = {
            canUseDOM: canUseDOM,
            canUseWorkers: typeof Worker !== 'undefined',
            canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),
            canUseViewport: canUseDOM && !!window.screen
        };
        if (typeof define === 'function' && typeof define.amd === 'object' && define.amd) define(function() {
            return ExecutionEnvironment;
        });
        else if (0, module.exports) module.exports = ExecutionEnvironment;
        else window.ExecutionEnvironment = ExecutionEnvironment;
    })();
});
parcelRegister("fUXdf", function(module, exports) {
    'use strict';
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.TouchScrollable = undefined;
    var $b96a046705879057$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    var $b96a046705879057$var$_createClass = function() {
        function defineProperties(target, props) {
            for(var i = 0; i < props.length; i++){
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor) descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
            }
        }
        return function(Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
        };
    }();
    var $5uXOq = parcelRequire("5uXOq");
    var $lv4Ny = parcelRequire("lv4Ny");
    var $1sALq = parcelRequire("1sALq");
    function $b96a046705879057$var$_objectWithoutProperties(obj, keys) {
        var target = {};
        for(var i in obj){
            if (keys.indexOf(i) >= 0) continue;
            if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
            target[i] = obj[i];
        }
        return target;
    }
    function $b96a046705879057$var$_classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
    }
    function $b96a046705879057$var$_possibleConstructorReturn(self, call) {
        if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return call && (typeof call === "object" || typeof call === "function") ? call : self;
    }
    function $b96a046705879057$var$_inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
        subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
                value: subClass,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
    }
    var $b96a046705879057$var$TouchScrollable = module.exports.TouchScrollable = function(_PureComponent) {
        $b96a046705879057$var$_inherits(TouchScrollable, _PureComponent);
        function TouchScrollable() {
            var _ref;
            var _temp, _this, _ret;
            $b96a046705879057$var$_classCallCheck(this, TouchScrollable);
            for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return _ret = (_temp = (_this = $b96a046705879057$var$_possibleConstructorReturn(this, (_ref = TouchScrollable.__proto__ || Object.getPrototypeOf(TouchScrollable)).call.apply(_ref, [
                this
            ].concat(args))), _this), _this.getScrollableArea = function(ref) {
                _this.scrollableArea = ref;
            }, _temp), $b96a046705879057$var$_possibleConstructorReturn(_this, _ret);
        }
        $b96a046705879057$var$_createClass(TouchScrollable, [
            {
                key: 'componentDidMount',
                value: function componentDidMount() {
                    if (!$lv4Ny.canUseEventListeners) return;
                    this.scrollableArea.addEventListener('touchstart', $1sALq.preventInertiaScroll, $1sALq.listenerOptions);
                    this.scrollableArea.addEventListener('touchmove', $1sALq.allowTouchMove, $1sALq.listenerOptions);
                }
            },
            {
                key: 'componentWillUnmount',
                value: function componentWillUnmount() {
                    if (!$lv4Ny.canUseEventListeners) return;
                    this.scrollableArea.removeEventListener('touchstart', $1sALq.preventInertiaScroll, $1sALq.listenerOptions);
                    this.scrollableArea.removeEventListener('touchmove', $1sALq.allowTouchMove, $1sALq.listenerOptions);
                }
            },
            {
                key: 'render',
                value: function render() {
                    var _props = this.props, children = _props.children, rest = $b96a046705879057$var$_objectWithoutProperties(_props, [
                        'children'
                    ]);
                    return typeof children === 'function' ? children(this.getScrollableArea) : (0, $5uXOq.cloneElement)(children, $b96a046705879057$var$_extends({
                        ref: this.getScrollableArea
                    }, rest));
                }
            }
        ]);
        return TouchScrollable;
    }($5uXOq.PureComponent);
});
parcelRegister("1sALq", function(module, exports) {
    'use strict';
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.pipe = module.exports.listenerOptions = undefined;
    module.exports.preventTouchMove = $1104ec85449a533c$var$preventTouchMove;
    module.exports.allowTouchMove = $1104ec85449a533c$var$allowTouchMove;
    module.exports.preventInertiaScroll = $1104ec85449a533c$var$preventInertiaScroll;
    module.exports.isTouchDevice = $1104ec85449a533c$var$isTouchDevice;
    module.exports.camelToKebab = $1104ec85449a533c$var$camelToKebab;
    module.exports.parse = $1104ec85449a533c$var$parse;
    module.exports.getPadding = $1104ec85449a533c$var$getPadding;
    module.exports.getWindowHeight = $1104ec85449a533c$var$getWindowHeight;
    module.exports.getDocumentHeight = $1104ec85449a533c$var$getDocumentHeight;
    module.exports.makeStyleTag = $1104ec85449a533c$var$makeStyleTag;
    module.exports.injectStyles = $1104ec85449a533c$var$injectStyles;
    module.exports.insertStyleTag = $1104ec85449a533c$var$insertStyleTag;
    var $lv4Ny = parcelRequire("lv4Ny");
    var $1104ec85449a533c$var$listenerOptions = module.exports.listenerOptions = {
        capture: false,
        passive: false
    };
    function $1104ec85449a533c$var$preventTouchMove(e) {
        e.preventDefault();
        return false;
    }
    function $1104ec85449a533c$var$allowTouchMove(e) {
        var target = e.currentTarget;
        if (target.scrollHeight > target.clientHeight) {
            e.stopPropagation();
            return true;
        }
        e.preventDefault();
        return false;
    }
    function $1104ec85449a533c$var$preventInertiaScroll() {
        var top = this.scrollTop;
        var totalScroll = this.scrollHeight;
        var currentScroll = top + this.offsetHeight;
        if (top === 0) this.scrollTop = 1;
        else if (currentScroll === totalScroll) this.scrollTop = top - 1;
    }
    function $1104ec85449a533c$var$isTouchDevice() {
        if (!$lv4Ny.canUseDOM) return false;
        return 'ontouchstart' in window || navigator.maxTouchPoints;
    }
    function $1104ec85449a533c$var$camelToKebab(str) {
        return str.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
    }
    function $1104ec85449a533c$var$parse(val) {
        return isNaN(val) ? val : val + 'px';
    }
    var $1104ec85449a533c$var$pipeFns = function pipeFns(a, b) {
        return function() {
            return b(a.apply(undefined, arguments));
        };
    };
    var $1104ec85449a533c$var$pipe = module.exports.pipe = function pipe() {
        for(var _len = arguments.length, fns = Array(_len), _key = 0; _key < _len; _key++)fns[_key] = arguments[_key];
        return fns.reduce($1104ec85449a533c$var$pipeFns);
    };
    function $1104ec85449a533c$var$getPadding() {
        if (!$lv4Ny.canUseDOM) return 0;
        var paddingRight = parseInt(window.getComputedStyle(document.body).paddingRight, 10);
        var scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
        return paddingRight + scrollbarWidth;
    }
    function $1104ec85449a533c$var$getWindowHeight() {
        var multiplier = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
        if ($lv4Ny.canUseDOM) return window.innerHeight * multiplier;
    }
    function $1104ec85449a533c$var$getDocumentHeight() {
        if ($lv4Ny.canUseDOM) return document.body.clientHeight;
    }
    function $1104ec85449a533c$var$makeStyleTag() {
        if (!$lv4Ny.canUseDOM) return;
        var tag = document.createElement('style');
        tag.type = 'text/css';
        tag.setAttribute('data-react-scrolllock', '');
        return tag;
    }
    function $1104ec85449a533c$var$injectStyles(tag, css) {
        if (!$lv4Ny.canUseDOM) return;
        if (tag.styleSheet) tag.styleSheet.cssText = css;
        else tag.appendChild(document.createTextNode(css));
    }
    function $1104ec85449a533c$var$insertStyleTag(tag) {
        if (!$lv4Ny.canUseDOM) return;
        var head = document.head || document.getElementsByTagName('head')[0];
        head.appendChild(tag);
    }
});
parcelRegister("bdRWg", function(module, exports) {
    'use strict';
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    var $82babfbe1d9118db$var$_createClass = function() {
        function defineProperties(target, props) {
            for(var i = 0; i < props.length; i++){
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor) descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
            }
        }
        return function(Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
        };
    }();
    module.exports.default = $82babfbe1d9118db$var$withLockSheet;
    var $5uXOq = parcelRequire("5uXOq");
    var $82babfbe1d9118db$var$_react2 = $82babfbe1d9118db$var$_interopRequireDefault($5uXOq);
    var $1sALq = parcelRequire("1sALq");
    function $82babfbe1d9118db$var$_interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    function $82babfbe1d9118db$var$_classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
    }
    function $82babfbe1d9118db$var$_possibleConstructorReturn(self, call) {
        if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return call && (typeof call === "object" || typeof call === "function") ? call : self;
    }
    function $82babfbe1d9118db$var$_inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
        subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
                value: subClass,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
    }
    function $82babfbe1d9118db$var$withLockSheet(WrappedComponent) {
        return function(_PureComponent) {
            $82babfbe1d9118db$var$_inherits(SheetProvider, _PureComponent);
            function SheetProvider() {
                var _ref;
                var _temp, _this, _ret;
                $82babfbe1d9118db$var$_classCallCheck(this, SheetProvider);
                for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                return _ret = (_temp = (_this = $82babfbe1d9118db$var$_possibleConstructorReturn(this, (_ref = SheetProvider.__proto__ || Object.getPrototypeOf(SheetProvider)).call.apply(_ref, [
                    this
                ].concat(args))), _this), _this.addSheet = function() {
                    var styles = _this.getStyles();
                    var sheet = (0, $1sALq.makeStyleTag)();
                    if (!sheet) return;
                    (0, $1sALq.injectStyles)(sheet, styles);
                    (0, $1sALq.insertStyleTag)(sheet);
                    _this.sheet = sheet;
                }, _this.getStyles = function() {
                    var accountForScrollbars = _this.props.accountForScrollbars;
                    var height = (0, $1sALq.getDocumentHeight)();
                    var paddingRight = accountForScrollbars ? (0, $1sALq.getPadding)() : null;
                    var styles = 'body {\n        box-sizing: border-box !important;\n        overflow: hidden !important;\n        position: relative !important;\n        ' + (height ? 'height: ' + height + 'px !important;' : '') + '\n        ' + (paddingRight ? 'padding-right: ' + paddingRight + 'px !important;' : '') + '\n      }';
                    return styles;
                }, _temp), $82babfbe1d9118db$var$_possibleConstructorReturn(_this, _ret);
            }
            $82babfbe1d9118db$var$_createClass(SheetProvider, [
                {
                    key: 'componentDidMount',
                    value: function componentDidMount() {
                        this.addSheet();
                    }
                },
                {
                    key: 'removeSheet',
                    value: function removeSheet() {
                        if (!this.sheet) return;
                        this.sheet.parentNode.removeChild(this.sheet);
                        this.sheet = null;
                    }
                },
                {
                    key: 'componentWillUnmount',
                    value: function componentWillUnmount() {
                        this.removeSheet();
                    }
                },
                {
                    key: 'render',
                    value: function render() {
                        return $82babfbe1d9118db$var$_react2.default.createElement(WrappedComponent, this.props);
                    }
                }
            ]);
            return SheetProvider;
        }($5uXOq.PureComponent);
    }
});
parcelRegister("fjsmD", function(module, exports) {
    'use strict';
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    var $b25ea1e2c8dc8373$var$_createClass = function() {
        function defineProperties(target, props) {
            for(var i = 0; i < props.length; i++){
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor) descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
            }
        }
        return function(Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
        };
    }();
    module.exports.default = $b25ea1e2c8dc8373$var$withTouchListeners;
    var $5uXOq = parcelRequire("5uXOq");
    var $b25ea1e2c8dc8373$var$_react2 = $b25ea1e2c8dc8373$var$_interopRequireDefault($5uXOq);
    var $lv4Ny = parcelRequire("lv4Ny");
    var $1sALq = parcelRequire("1sALq");
    function $b25ea1e2c8dc8373$var$_interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    function $b25ea1e2c8dc8373$var$_classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
    }
    function $b25ea1e2c8dc8373$var$_possibleConstructorReturn(self, call) {
        if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return call && (typeof call === "object" || typeof call === "function") ? call : self;
    }
    function $b25ea1e2c8dc8373$var$_inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
        subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
                value: subClass,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
    }
    function $b25ea1e2c8dc8373$var$withTouchListeners(WrappedComponent) {
        return function(_PureComponent) {
            $b25ea1e2c8dc8373$var$_inherits(TouchProvider, _PureComponent);
            function TouchProvider() {
                $b25ea1e2c8dc8373$var$_classCallCheck(this, TouchProvider);
                return $b25ea1e2c8dc8373$var$_possibleConstructorReturn(this, (TouchProvider.__proto__ || Object.getPrototypeOf(TouchProvider)).apply(this, arguments));
            }
            $b25ea1e2c8dc8373$var$_createClass(TouchProvider, [
                {
                    key: 'componentDidMount',
                    value: function componentDidMount() {
                        if (!$lv4Ny.canUseDOM || !(0, $1sALq.isTouchDevice)()) return;
                        document.addEventListener('touchmove', $1sALq.preventTouchMove, $1sALq.listenerOptions);
                    }
                },
                {
                    key: 'componentWillUnmount',
                    value: function componentWillUnmount() {
                        if (!$lv4Ny.canUseDOM || !(0, $1sALq.isTouchDevice)()) return;
                        document.removeEventListener('touchmove', $1sALq.preventTouchMove, $1sALq.listenerOptions);
                    }
                },
                {
                    key: 'render',
                    value: function render() {
                        return $b25ea1e2c8dc8373$var$_react2.default.createElement(WrappedComponent, this.props);
                    }
                }
            ]);
            return TouchProvider;
        }($5uXOq.PureComponent);
    }
});
parcelRegister("61IPU", function(module, exports) {
    $parcel$export(module.exports, "monitorForExternal", ()=>(parcelRequire("iPCNN")).monitorForExternal);
    var $iPCNN = parcelRequire("iPCNN");
});
parcelRegister("iPCNN", function(module, exports) {
    $parcel$export(module.exports, "monitorForExternal", ()=>$f377df4064e10188$export$bb1740f3194979c1);
    var $cBeZP;
    var $iiVLC = parcelRequire("iiVLC");
    var $6XFIM = parcelRequire("6XFIM");
    var $e2Xjq = parcelRequire("e2Xjq");
    var $h5V4I = parcelRequire("h5V4I");
    function $f377df4064e10188$export$a8e56a860d7957c7({ type: type, value: value }) {
        if (type === (0, $dad94f2a683170ce$export$c9c4cc54e73b125d)) return false;
        if (type === (0, $511ea0f8ed5a789e$export$fd3d00026297c0ad) && value === (0, $6XFIM.androidFallbackText)) return false;
        return true;
    }
    function $f377df4064e10188$export$8c257a3856120a77(transfer) {
        return Array.from(transfer.types).filter((type)=>$f377df4064e10188$export$a8e56a860d7957c7({
                type: type,
                value: transfer.getData(type)
            }));
    }
    function $f377df4064e10188$export$8d28cfecded8dcab(dataTransfer) {
        return Array.from(dataTransfer.items).filter((item)=>item.kind === 'file' || $f377df4064e10188$export$a8e56a860d7957c7({
                type: item.type,
                value: dataTransfer.getData(item.type)
            }));
    }
    let $f377df4064e10188$var$didDragStartLocally = false;
    const $f377df4064e10188$var$adapter = (0, $iiVLC.makeAdapter)({
        typeKey: 'external',
        defaultDropEffect: 'copy',
        mount (api) {
            return (0, (0, parcelRequire("cBeZP")).bind)(window, {
                type: 'dragenter',
                listener (event) {
                    if ($f377df4064e10188$var$didDragStartLocally) return;
                    if (!event.dataTransfer) return;
                    if (!api.canStart(event)) return;
                    if (!(0, $e2Xjq.isEnteringWindow)({
                        dragEnter: event
                    })) return;
                    const types = $f377df4064e10188$export$8c257a3856120a77(event.dataTransfer);
                    if (!types.length) return;
                    const locked = {
                        types: types,
                        items: [],
                        getStringData: ()=>null
                    };
                    api.start({
                        event: event,
                        dragType: {
                            type: 'external',
                            startedFrom: 'external',
                            payload: locked,
                            getDropPayload (event) {
                                if (!event.dataTransfer) return locked;
                                const items = $f377df4064e10188$export$8d28cfecded8dcab(event.dataTransfer);
                                const nativeGetData = event.dataTransfer.getData.bind(event.dataTransfer);
                                return {
                                    types: types,
                                    items: items,
                                    getStringData (mediaType) {
                                        if (!types.includes(mediaType)) return null;
                                        const value = nativeGetData(mediaType);
                                        if (!$f377df4064e10188$export$a8e56a860d7957c7({
                                            type: mediaType,
                                            value: value
                                        })) return null;
                                        return value;
                                    }
                                };
                            }
                        }
                    });
                }
            });
        }
    });
    function $f377df4064e10188$export$9edc779df9a85289(args) {
        return $f377df4064e10188$var$adapter.dropTarget(args);
    }
    function $f377df4064e10188$export$bb1740f3194979c1(args) {
        return $f377df4064e10188$var$adapter.monitor(args);
    }
    (function startup() {
        if (typeof window === 'undefined') return;
        $f377df4064e10188$var$adapter.registerUsage();
        const idle = {
            type: 'idle'
        };
        let state = idle;
        function clear() {
            if (state.type !== 'dragging') return;
            $f377df4064e10188$var$didDragStartLocally = false;
            state.cleanup();
            state = idle;
        }
        function bindEndEvents() {
            return (0, (0, parcelRequire("cBeZP")).bindAll)(window, [
                {
                    type: 'dragend',
                    listener: clear
                },
                ...(0, $h5V4I.getBindingsForBrokenDrags)({
                    onDragEnd: clear
                })
            ], {
                capture: true
            });
        }
        (0, (0, parcelRequire("cBeZP")).bind)(window, {
            type: 'dragstart',
            listener () {
                if (state.type !== 'idle') return;
                $f377df4064e10188$var$didDragStartLocally = true;
                state = {
                    type: 'dragging',
                    cleanup: bindEndEvents()
                };
            },
            options: {
                capture: true
            }
        });
    })();
});
parcelRegister("e2Xjq", function(module, exports) {
    $parcel$export(module.exports, "isEnteringWindow", ()=>$ad99df0f18a6cc64$export$d1c6f249e893cdf4);
    var $bYN8w = parcelRequire("bYN8w");
    var $6aABs = parcelRequire("6aABs");
    var $apnEk = parcelRequire("apnEk");
    var $9Mj6M = parcelRequire("9Mj6M");
    function $ad99df0f18a6cc64$export$d1c6f249e893cdf4({ dragEnter: dragEnter }) {
        const { type: type, relatedTarget: relatedTarget } = dragEnter;
        if (type !== 'dragenter') return false;
        if ((0, $6aABs.isSafari)()) return (0, $apnEk.isEnteringWindowInSafari)({
            dragEnter: dragEnter
        });
        if (relatedTarget == null) return true;
        if ((0, $bYN8w.isFirefox)()) return (0, $9Mj6M.isFromAnotherWindow)(relatedTarget);
        return relatedTarget instanceof HTMLIFrameElement;
    }
});
parcelRegister("dOXu7", function(module, exports) {
    $parcel$export(module.exports, "monitorForTextSelection", ()=>(parcelRequire("eU6JV")).monitorForTextSelection);
    var $eU6JV = parcelRequire("eU6JV");
});
parcelRegister("eU6JV", function(module, exports) {
    $parcel$export(module.exports, "monitorForTextSelection", ()=>$6ec1b195aeff981f$export$2e178e3647f5e6e9);
    var $cBeZP;
    var $8d5CE = parcelRequire("8d5CE");
    var $iiVLC = parcelRequire("iiVLC");
    var $3zl3q = parcelRequire("3zl3q");
    var $6aABs = parcelRequire("6aABs");
    function $6ec1b195aeff981f$var$findTextNode(event) {
        if (event.target instanceof Text) return event.target;
        if (!(0, $6aABs.isSafari)()) return null;
        if (!(event.target instanceof HTMLElement)) return null;
        if (event.target.draggable) return null;
        if (!event.dataTransfer?.getData((0, $511ea0f8ed5a789e$export$fd3d00026297c0ad))) return null;
        const text = Array.from(event.target.childNodes).find((node)=>node.nodeType === Node.TEXT_NODE);
        return text ?? null;
    }
    const $6ec1b195aeff981f$var$honeyPotFix = (0, $8d5CE.makeHoneyPotFix)();
    const $6ec1b195aeff981f$var$adapter = (0, $iiVLC.makeAdapter)({
        typeKey: 'text-selection',
        defaultDropEffect: 'copy',
        mount (api) {
            return (0, $3zl3q.combine)($6ec1b195aeff981f$var$honeyPotFix.bindEvents(), (0, (0, parcelRequire("cBeZP")).bind)(window, {
                type: 'dragstart',
                listener (event) {
                    if (event.defaultPrevented) return;
                    if (!event.dataTransfer) return;
                    if (event.dataTransfer.types.includes((0, $dad94f2a683170ce$export$c9c4cc54e73b125d))) return;
                    if (!api.canStart(event)) return;
                    if (!event.dataTransfer.types.includes((0, $511ea0f8ed5a789e$export$fd3d00026297c0ad))) return;
                    const target = $6ec1b195aeff981f$var$findTextNode(event);
                    if (!target) return;
                    const payload = {
                        target: target,
                        plain: event.dataTransfer.getData((0, $511ea0f8ed5a789e$export$fd3d00026297c0ad)),
                        HTML: event.dataTransfer.getData((0, $832d2a5d5849f305$export$338a9f6c7a1f02b0))
                    };
                    api.start({
                        event: event,
                        dragType: {
                            type: 'text-selection',
                            startedFrom: 'internal',
                            payload: payload
                        }
                    });
                }
            }));
        },
        onPostDispatch: $6ec1b195aeff981f$var$honeyPotFix.getOnPostDispatch()
    });
    function $6ec1b195aeff981f$export$9bfaa8eb182300d1(args) {
        return $6ec1b195aeff981f$var$adapter.dropTarget(args);
    }
    (function register() {
        if (typeof window === 'undefined') return;
        $6ec1b195aeff981f$var$adapter.registerUsage();
    })();
    function $6ec1b195aeff981f$export$2e178e3647f5e6e9(args) {
        return $6ec1b195aeff981f$var$adapter.monitor(args);
    }
});
const $832d2a5d5849f305$export$338a9f6c7a1f02b0 = 'text/html';
parcelRegister("fGOj2", function(module, exports) {
    var $ku1fk = parcelRequire("ku1fk");
    var $b6c1ccfb8fc1be45$var$listeningFocusTrap = null;
    function $b6c1ccfb8fc1be45$var$focusTrap(element, userOptions) {
        var tabbableNodes = [];
        var firstTabbableNode = null;
        var lastTabbableNode = null;
        var nodeFocusedBeforeActivation = null;
        var active = false;
        var paused = false;
        var tabEvent = null;
        var container = typeof element === 'string' ? document.querySelector(element) : element;
        var config = userOptions || {};
        config.returnFocusOnDeactivate = userOptions && userOptions.returnFocusOnDeactivate !== undefined ? userOptions.returnFocusOnDeactivate : true;
        config.escapeDeactivates = userOptions && userOptions.escapeDeactivates !== undefined ? userOptions.escapeDeactivates : true;
        var trap = {
            activate: activate,
            deactivate: deactivate,
            pause: pause,
            unpause: unpause
        };
        return trap;
        function activate(activateOptions) {
            if (active) return;
            var defaultedActivateOptions = {
                onActivate: activateOptions && activateOptions.onActivate !== undefined ? activateOptions.onActivate : config.onActivate
            };
            active = true;
            paused = false;
            nodeFocusedBeforeActivation = document.activeElement;
            if (defaultedActivateOptions.onActivate) defaultedActivateOptions.onActivate();
            addListeners();
            return trap;
        }
        function deactivate(deactivateOptions) {
            if (!active) return;
            var defaultedDeactivateOptions = {
                returnFocus: deactivateOptions && deactivateOptions.returnFocus !== undefined ? deactivateOptions.returnFocus : config.returnFocusOnDeactivate,
                onDeactivate: deactivateOptions && deactivateOptions.onDeactivate !== undefined ? deactivateOptions.onDeactivate : config.onDeactivate
            };
            removeListeners();
            if (defaultedDeactivateOptions.onDeactivate) defaultedDeactivateOptions.onDeactivate();
            if (defaultedDeactivateOptions.returnFocus) setTimeout(function() {
                $b6c1ccfb8fc1be45$var$tryFocus(nodeFocusedBeforeActivation);
            }, 0);
            active = false;
            paused = false;
            return this;
        }
        function pause() {
            if (paused || !active) return;
            paused = true;
            removeListeners();
        }
        function unpause() {
            if (!paused || !active) return;
            paused = false;
            addListeners();
        }
        function addListeners() {
            if (!active) return;
            if ($b6c1ccfb8fc1be45$var$listeningFocusTrap) $b6c1ccfb8fc1be45$var$listeningFocusTrap.pause();
            $b6c1ccfb8fc1be45$var$listeningFocusTrap = trap;
            updateTabbableNodes();
            setTimeout(function() {
                $b6c1ccfb8fc1be45$var$tryFocus(firstFocusNode());
            }, 0);
            document.addEventListener('focus', checkFocus, true);
            document.addEventListener('click', checkClick, true);
            document.addEventListener('mousedown', checkPointerDown, true);
            document.addEventListener('touchstart', checkPointerDown, true);
            document.addEventListener('keydown', checkKey, true);
            return trap;
        }
        function removeListeners() {
            if (!active || $b6c1ccfb8fc1be45$var$listeningFocusTrap !== trap) return;
            document.removeEventListener('focus', checkFocus, true);
            document.removeEventListener('click', checkClick, true);
            document.removeEventListener('mousedown', checkPointerDown, true);
            document.removeEventListener('touchstart', checkPointerDown, true);
            document.removeEventListener('keydown', checkKey, true);
            $b6c1ccfb8fc1be45$var$listeningFocusTrap = null;
            return trap;
        }
        function getNodeForOption(optionName) {
            var optionValue = config[optionName];
            var node = optionValue;
            if (!optionValue) return null;
            if (typeof optionValue === 'string') {
                node = document.querySelector(optionValue);
                if (!node) throw new Error('`' + optionName + '` refers to no known node');
            }
            if (typeof optionValue === 'function') {
                node = optionValue();
                if (!node) throw new Error('`' + optionName + '` did not return a node');
            }
            return node;
        }
        function firstFocusNode() {
            var node;
            if (getNodeForOption('initialFocus') !== null) node = getNodeForOption('initialFocus');
            else if (container.contains(document.activeElement)) node = document.activeElement;
            else node = tabbableNodes[0] || getNodeForOption('fallbackFocus');
            if (!node) throw new Error('You can\'t have a focus-trap without at least one focusable element');
            return node;
        }
        function checkPointerDown(e) {
            if (config.clickOutsideDeactivates && !container.contains(e.target)) deactivate({
                returnFocus: false
            });
        }
        function checkClick(e) {
            if (config.clickOutsideDeactivates) return;
            if (container.contains(e.target)) return;
            e.preventDefault();
            e.stopImmediatePropagation();
        }
        function checkFocus(e) {
            if (container.contains(e.target)) return;
            e.preventDefault();
            e.stopImmediatePropagation();
            if (typeof e.target.blur === 'function') e.target.blur();
            if (tabEvent) readjustFocus(tabEvent);
        }
        function checkKey(e) {
            if (e.key === 'Tab' || e.keyCode === 9) handleTab(e);
            if (config.escapeDeactivates !== false && $b6c1ccfb8fc1be45$var$isEscapeEvent(e)) deactivate();
        }
        function handleTab(e) {
            updateTabbableNodes();
            if (e.target.hasAttribute('tabindex') && Number(e.target.getAttribute('tabindex')) < 0) return tabEvent = e;
            e.preventDefault();
            var currentFocusIndex = tabbableNodes.indexOf(e.target);
            if (e.shiftKey) {
                if (e.target === firstTabbableNode || tabbableNodes.indexOf(e.target) === -1) return $b6c1ccfb8fc1be45$var$tryFocus(lastTabbableNode);
                return $b6c1ccfb8fc1be45$var$tryFocus(tabbableNodes[currentFocusIndex - 1]);
            }
            if (e.target === lastTabbableNode) return $b6c1ccfb8fc1be45$var$tryFocus(firstTabbableNode);
            $b6c1ccfb8fc1be45$var$tryFocus(tabbableNodes[currentFocusIndex + 1]);
        }
        function updateTabbableNodes() {
            tabbableNodes = $ku1fk(container);
            firstTabbableNode = tabbableNodes[0];
            lastTabbableNode = tabbableNodes[tabbableNodes.length - 1];
        }
        function readjustFocus(e) {
            if (e.shiftKey) return $b6c1ccfb8fc1be45$var$tryFocus(lastTabbableNode);
            $b6c1ccfb8fc1be45$var$tryFocus(firstTabbableNode);
        }
    }
    function $b6c1ccfb8fc1be45$var$isEscapeEvent(e) {
        return e.key === 'Escape' || e.key === 'Esc' || e.keyCode === 27;
    }
    function $b6c1ccfb8fc1be45$var$tryFocus(node) {
        if (!node || !node.focus) return;
        if (node === document.activeElement) return;
        node.focus();
        if (node.tagName.toLowerCase() === 'input') node.select();
    }
    module.exports = $b6c1ccfb8fc1be45$var$focusTrap;
});
parcelRegister("ku1fk", function(module, exports) {
    module.exports = function(el, options) {
        options = options || {};
        var elementDocument = el.ownerDocument || el;
        var basicTabbables = [];
        var orderedTabbables = [];
        var isUnavailable = $ee97937178da774c$var$createIsUnavailable(elementDocument);
        var candidateSelectors = [
            'input',
            'select',
            'a[href]',
            'textarea',
            'button',
            '[tabindex]'
        ];
        var candidates = el.querySelectorAll(candidateSelectors.join(','));
        if (options.includeContainer) {
            var matches = Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
            if (candidateSelectors.some(function(candidateSelector) {
                return matches.call(el, candidateSelector);
            })) {
                candidates = Array.prototype.slice.apply(candidates);
                candidates.unshift(el);
            }
        }
        var candidate, candidateIndexAttr, candidateIndex;
        for(var i = 0, l = candidates.length; i < l; i++){
            candidate = candidates[i];
            candidateIndexAttr = parseInt(candidate.getAttribute('tabindex'), 10);
            candidateIndex = isNaN(candidateIndexAttr) ? candidate.tabIndex : candidateIndexAttr;
            if (candidateIndex < 0 || candidate.tagName === 'INPUT' && candidate.type === 'hidden' || candidate.disabled || isUnavailable(candidate, elementDocument)) continue;
            if (candidateIndex === 0) basicTabbables.push(candidate);
            else orderedTabbables.push({
                index: i,
                tabIndex: candidateIndex,
                node: candidate
            });
        }
        var tabbableNodes = orderedTabbables.sort(function(a, b) {
            return a.tabIndex === b.tabIndex ? a.index - b.index : a.tabIndex - b.tabIndex;
        }).map(function(a) {
            return a.node;
        });
        Array.prototype.push.apply(tabbableNodes, basicTabbables);
        return tabbableNodes;
    };
    function $ee97937178da774c$var$createIsUnavailable(elementDocument) {
        var isOffCache = [];
        function isOff(node, nodeComputedStyle) {
            if (node === elementDocument.documentElement) return false;
            for(var i = 0, length = isOffCache.length; i < length; i++){
                if (isOffCache[i][0] === node) return isOffCache[i][1];
            }
            nodeComputedStyle = nodeComputedStyle || elementDocument.defaultView.getComputedStyle(node);
            var result = false;
            if (nodeComputedStyle.display === 'none') result = true;
            else if (node.parentNode) result = isOff(node.parentNode);
            isOffCache.push([
                node,
                result
            ]);
            return result;
        }
        return function isUnavailable(node) {
            if (node === elementDocument.documentElement) return false;
            var computedStyle = elementDocument.defaultView.getComputedStyle(node);
            if (isOff(node, computedStyle)) return true;
            return computedStyle.visibility === 'hidden';
        };
    }
});
parcelRegister("k9tnV", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$eabb711d482d792e$export$2e2bcd8739ae039);
    var $5pMPR;
    function $eabb711d482d792e$var$isOptionsObject(options) {
        return options === Object(options) && Object.keys(options).length !== 0;
    }
    function $eabb711d482d792e$var$defaultBehavior(actions, behavior) {
        if (behavior === void 0) behavior = 'auto';
        var canSmoothScroll = 'scrollBehavior' in document.body.style;
        actions.forEach(function(_ref) {
            var el = _ref.el, top = _ref.top, left = _ref.left;
            if (el.scroll && canSmoothScroll) el.scroll({
                top: top,
                left: left,
                behavior: behavior
            });
            else {
                el.scrollTop = top;
                el.scrollLeft = left;
            }
        });
    }
    function $eabb711d482d792e$var$getOptions(options) {
        if (options === false) return {
            block: 'end',
            inline: 'nearest'
        };
        if ($eabb711d482d792e$var$isOptionsObject(options)) return options;
        return {
            block: 'start',
            inline: 'nearest'
        };
    }
    function $eabb711d482d792e$var$scrollIntoView(target, options) {
        var targetIsDetached = !target.ownerDocument.documentElement.contains(target);
        if ($eabb711d482d792e$var$isOptionsObject(options) && typeof options.behavior === 'function') return options.behavior(targetIsDetached ? [] : (0, (0, parcelRequire("5pMPR")).default)(target, options));
        if (targetIsDetached) return;
        var computeOptions = $eabb711d482d792e$var$getOptions(options);
        return $eabb711d482d792e$var$defaultBehavior((0, (0, parcelRequire("5pMPR")).default)(target, computeOptions), computeOptions.behavior);
    }
    var $eabb711d482d792e$export$2e2bcd8739ae039 = $eabb711d482d792e$var$scrollIntoView;
});
parcelRegister("5pMPR", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3f152b3d7b173718$export$2e2bcd8739ae039);
    function $3f152b3d7b173718$var$isElement(el) {
        return el != null && typeof el === 'object' && el.nodeType === 1;
    }
    function $3f152b3d7b173718$var$canOverflow(overflow, skipOverflowHiddenElements) {
        if (skipOverflowHiddenElements && overflow === 'hidden') return false;
        return overflow !== 'visible' && overflow !== 'clip';
    }
    function $3f152b3d7b173718$var$getFrameElement(el) {
        if (!el.ownerDocument || !el.ownerDocument.defaultView) return null;
        return el.ownerDocument.defaultView.frameElement;
    }
    function $3f152b3d7b173718$var$isHiddenByFrame(el) {
        var frame = $3f152b3d7b173718$var$getFrameElement(el);
        if (!frame) return false;
        return frame.clientHeight < el.scrollHeight || frame.clientWidth < el.scrollWidth;
    }
    function $3f152b3d7b173718$var$isScrollable(el, skipOverflowHiddenElements) {
        if (el.clientHeight < el.scrollHeight || el.clientWidth < el.scrollWidth) {
            var style = getComputedStyle(el, null);
            return $3f152b3d7b173718$var$canOverflow(style.overflowY, skipOverflowHiddenElements) || $3f152b3d7b173718$var$canOverflow(style.overflowX, skipOverflowHiddenElements) || $3f152b3d7b173718$var$isHiddenByFrame(el);
        }
        return false;
    }
    function $3f152b3d7b173718$var$alignNearest(scrollingEdgeStart, scrollingEdgeEnd, scrollingSize, scrollingBorderStart, scrollingBorderEnd, elementEdgeStart, elementEdgeEnd, elementSize) {
        if (elementEdgeStart < scrollingEdgeStart && elementEdgeEnd > scrollingEdgeEnd || elementEdgeStart > scrollingEdgeStart && elementEdgeEnd < scrollingEdgeEnd) return 0;
        if (elementEdgeStart <= scrollingEdgeStart && elementSize <= scrollingSize || elementEdgeEnd >= scrollingEdgeEnd && elementSize >= scrollingSize) return elementEdgeStart - scrollingEdgeStart - scrollingBorderStart;
        if (elementEdgeEnd > scrollingEdgeEnd && elementSize < scrollingSize || elementEdgeStart < scrollingEdgeStart && elementSize > scrollingSize) return elementEdgeEnd - scrollingEdgeEnd + scrollingBorderEnd;
        return 0;
    }
    var $3f152b3d7b173718$export$2e2bcd8739ae039 = function(target, options) {
        var scrollMode = options.scrollMode, block = options.block, inline = options.inline, boundary = options.boundary, skipOverflowHiddenElements = options.skipOverflowHiddenElements;
        var checkBoundary = typeof boundary === 'function' ? boundary : function(node) {
            return node !== boundary;
        };
        if (!$3f152b3d7b173718$var$isElement(target)) throw new TypeError('Invalid target');
        var scrollingElement = document.scrollingElement || document.documentElement;
        var frames = [];
        var cursor = target;
        while($3f152b3d7b173718$var$isElement(cursor) && checkBoundary(cursor)){
            cursor = cursor.parentNode;
            if (cursor === scrollingElement) {
                frames.push(cursor);
                break;
            }
            if (cursor === document.body && $3f152b3d7b173718$var$isScrollable(cursor) && !$3f152b3d7b173718$var$isScrollable(document.documentElement)) continue;
            if ($3f152b3d7b173718$var$isScrollable(cursor, skipOverflowHiddenElements)) frames.push(cursor);
        }
        var viewportWidth = window.visualViewport ? visualViewport.width : innerWidth;
        var viewportHeight = window.visualViewport ? visualViewport.height : innerHeight;
        var viewportX = window.scrollX || pageXOffset;
        var viewportY = window.scrollY || pageYOffset;
        var _target$getBoundingCl = target.getBoundingClientRect(), targetHeight = _target$getBoundingCl.height, targetWidth = _target$getBoundingCl.width, targetTop = _target$getBoundingCl.top, targetRight = _target$getBoundingCl.right, targetBottom = _target$getBoundingCl.bottom, targetLeft = _target$getBoundingCl.left;
        var targetBlock = block === 'start' || block === 'nearest' ? targetTop : block === 'end' ? targetBottom : targetTop + targetHeight / 2;
        var targetInline = inline === 'center' ? targetLeft + targetWidth / 2 : inline === 'end' ? targetRight : targetLeft;
        var computations = [];
        for(var index = 0; index < frames.length; index++){
            var frame = frames[index];
            var _frame$getBoundingCli = frame.getBoundingClientRect(), height = _frame$getBoundingCli.height, width = _frame$getBoundingCli.width, top = _frame$getBoundingCli.top, right = _frame$getBoundingCli.right, bottom = _frame$getBoundingCli.bottom, left = _frame$getBoundingCli.left;
            if (scrollMode === 'if-needed' && targetTop >= 0 && targetLeft >= 0 && targetBottom <= viewportHeight && targetRight <= viewportWidth && targetTop >= top && targetBottom <= bottom && targetLeft >= left && targetRight <= right) return computations;
            var frameStyle = getComputedStyle(frame);
            var borderLeft = parseInt(frameStyle.borderLeftWidth, 10);
            var borderTop = parseInt(frameStyle.borderTopWidth, 10);
            var borderRight = parseInt(frameStyle.borderRightWidth, 10);
            var borderBottom = parseInt(frameStyle.borderBottomWidth, 10);
            var blockScroll = 0;
            var inlineScroll = 0;
            var scrollbarWidth = 'offsetWidth' in frame ? frame.offsetWidth - frame.clientWidth - borderLeft - borderRight : 0;
            var scrollbarHeight = 'offsetHeight' in frame ? frame.offsetHeight - frame.clientHeight - borderTop - borderBottom : 0;
            if (scrollingElement === frame) {
                if (block === 'start') blockScroll = targetBlock;
                else if (block === 'end') blockScroll = targetBlock - viewportHeight;
                else if (block === 'nearest') blockScroll = $3f152b3d7b173718$var$alignNearest(viewportY, viewportY + viewportHeight, viewportHeight, borderTop, borderBottom, viewportY + targetBlock, viewportY + targetBlock + targetHeight, targetHeight);
                else blockScroll = targetBlock - viewportHeight / 2;
                if (inline === 'start') inlineScroll = targetInline;
                else if (inline === 'center') inlineScroll = targetInline - viewportWidth / 2;
                else if (inline === 'end') inlineScroll = targetInline - viewportWidth;
                else inlineScroll = $3f152b3d7b173718$var$alignNearest(viewportX, viewportX + viewportWidth, viewportWidth, borderLeft, borderRight, viewportX + targetInline, viewportX + targetInline + targetWidth, targetWidth);
                blockScroll = Math.max(0, blockScroll + viewportY);
                inlineScroll = Math.max(0, inlineScroll + viewportX);
            } else {
                if (block === 'start') blockScroll = targetBlock - top - borderTop;
                else if (block === 'end') blockScroll = targetBlock - bottom + borderBottom + scrollbarHeight;
                else if (block === 'nearest') blockScroll = $3f152b3d7b173718$var$alignNearest(top, bottom, height, borderTop, borderBottom + scrollbarHeight, targetBlock, targetBlock + targetHeight, targetHeight);
                else blockScroll = targetBlock - (top + height / 2) + scrollbarHeight / 2;
                if (inline === 'start') inlineScroll = targetInline - left - borderLeft;
                else if (inline === 'center') inlineScroll = targetInline - (left + width / 2) + scrollbarWidth / 2;
                else if (inline === 'end') inlineScroll = targetInline - right + borderRight + scrollbarWidth;
                else inlineScroll = $3f152b3d7b173718$var$alignNearest(left, right, width, borderLeft, borderRight + scrollbarWidth, targetInline, targetInline + targetWidth, targetWidth);
                var scrollLeft = frame.scrollLeft, scrollTop = frame.scrollTop;
                blockScroll = Math.max(0, Math.min(scrollTop + blockScroll, frame.scrollHeight - height + scrollbarHeight));
                inlineScroll = Math.max(0, Math.min(scrollLeft + inlineScroll, frame.scrollWidth - width + scrollbarWidth));
                targetBlock += scrollTop - blockScroll;
                targetInline += scrollLeft - inlineScroll;
            }
            computations.push({
                el: frame,
                top: blockScroll,
                left: inlineScroll
            });
        }
        return computations;
    };
});
parcelRegister("8r6xd", function(module, exports) {
    $parcel$export(module.exports, "PendoChoreographerPlugin", ()=>$53b1d602a69e9a6f$export$3390a677f4025523);
    var $TTRxY;
    var $4YUjU;
    class $53b1d602a69e9a6f$export$3390a677f4025523 extends (0, (0, parcelRequire("4YUjU")).ChoreographerPlugin) {
        constructor(envType, metaMetricsData = {}){
            super((0, (0, parcelRequire("TTRxY")).ProductIds).PENDO, envType, metaMetricsData), this.currentMessageId = '', this.getPendoConfig = (pendoConfig)=>{
                const pendoPlugin = this;
                return {
                    ...pendoConfig,
                    guides: {
                        ...pendoConfig.guides ?? {},
                        globalScripts: [
                            ...pendoConfig.guides?.globalScripts ?? [],
                            {
                                beforeMount (evnt) {
                                    if (pendoPlugin.state.isDisabled) evnt.cancel = true;
                                    else {
                                        pendoPlugin.currentMessageId = evnt.step.id;
                                        pendoPlugin.on(pendoPlugin.currentMessageId, {});
                                        pendoPlugin.startMessage(pendoPlugin.currentMessageId);
                                    }
                                },
                                unmounted () {
                                    pendoPlugin.stopMessage(pendoPlugin.currentMessageId);
                                }
                            }
                        ]
                    }
                };
            };
        }
        isDisplayingMessage() {
            return Boolean(window.pendo?.getActiveGuide?.());
        }
    }
});
parcelRegister("lD23V", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$fbeed703bb1aba42$export$2e2bcd8739ae039);
    function $fbeed703bb1aba42$export$2e2bcd8739ae039(value, suffix, prefix) {
        if (value != undefined) {
            if (suffix) {
                if (prefix) return prefix + value + suffix;
                return value + suffix;
            }
            return value;
        }
        return 'var(--c-, )';
    }
});
parcelRegister("8Ec39", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$114f26125c89a833$export$2e2bcd8739ae039);
    var $ge1SS;
    var $114f26125c89a833$export$2e2bcd8739ae039 = (0, (0, parcelRequire("ge1SS")).default);
});
parcelRegister("ge1SS", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$72b82d0e3dab161a$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $gg6CF = parcelRequire("gg6CF");
    var $7Jxgt = parcelRequire("7Jxgt");
    var $5gx4p;
    var $fe1wc;
    var $tcn7E;
    var $1tcYS;
    var $1u4q7;
    var $bFU4G;
    var $9AgLs;
    var $kdJVm;
    let $72b82d0e3dab161a$var$tryCompleteHandle;
    const $72b82d0e3dab161a$var$AsyncSegmentHighlight = (0, $5uXOq.lazy)(()=>(parcelRequire("k124G")).then((module)=>({
                default: module.SegmentHighlight
            })));
    function $72b82d0e3dab161a$export$2e2bcd8739ae039({ name: segmentName, children: children }) {
        const parentContext = (0, $5uXOq.useContext)((0, (0, parcelRequire("1tcYS")).default));
        const segmentId = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("kdJVm")).default)(), []);
        const labelStack = (0, $5uXOq.useMemo)(()=>parentContext?.labelStack ? [
                ...parentContext.labelStack,
                {
                    name: segmentName,
                    segmentId: segmentId
                }
            ] : [
                {
                    name: segmentName,
                    segmentId: segmentId
                }
            ], [
            parentContext,
            segmentName,
            segmentId
        ]);
        const interactionId = (0, $5uXOq.useContext)((0, (0, parcelRequire("1u4q7")).default));
        const interactionContext = (0, $5uXOq.useMemo)(()=>{
            (0, (0, parcelRequire("bFU4G")).addSegment)(labelStack);
            let lastCompleteEndTime = 0;
            function complete(endTime = performance.now()) {
                if (interactionId.current) {
                    if (parentContext) parentContext.complete();
                    else {
                        const capturedInteractionId = interactionId.current;
                        if (endTime > lastCompleteEndTime) lastCompleteEndTime = endTime;
                        if ($72b82d0e3dab161a$var$tryCompleteHandle) cancelAnimationFrame?.($72b82d0e3dab161a$var$tryCompleteHandle);
                        (0, $gg6CF.unstable_scheduleCallback)((0, $gg6CF.unstable_NormalPriority), ()=>{
                            if (capturedInteractionId === interactionId.current) {
                                const isPageVisible = document?.visibilityState === 'visible';
                                const canDoRAF = typeof requestAnimationFrame !== 'undefined';
                                if (isPageVisible && canDoRAF) $72b82d0e3dab161a$var$tryCompleteHandle = requestAnimationFrame(()=>{
                                    $72b82d0e3dab161a$var$tryCompleteHandle = requestAnimationFrame(()=>{
                                        if (capturedInteractionId === interactionId.current) (0, (0, parcelRequire("bFU4G")).tryComplete)(interactionId.current, lastCompleteEndTime);
                                    });
                                });
                                else (0, (0, parcelRequire("bFU4G")).tryComplete)(interactionId.current, lastCompleteEndTime);
                            }
                        });
                    }
                }
            }
            function _internalHold(labelStack, name) {
                if (interactionId.current != null) {
                    if (parentContext) return parentContext._internalHold(labelStack, name);
                    else {
                        const capturedInteractionId = interactionId.current;
                        const disposeHold = (0, (0, parcelRequire("bFU4G")).addHold)(interactionId.current, labelStack, name);
                        return ()=>{
                            if (capturedInteractionId === interactionId.current) disposeHold();
                        };
                    }
                }
            }
            function _internalHoldByID(labelStack, id, name, remove) {
                if (interactionId.current != null) {
                    if (parentContext) {
                        parentContext._internalHoldByID(labelStack, name, id, remove);
                        return;
                    }
                    if (!remove) (0, (0, parcelRequire("bFU4G")).addHoldByID)(interactionId.current, labelStack, name, id);
                    else (0, (0, parcelRequire("bFU4G")).removeHoldByID)(interactionId.current, id);
                }
            }
            if (parentContext) return {
                ...parentContext,
                labelStack: labelStack,
                complete: complete
            };
            return {
                labelStack: labelStack,
                hold (name = 'unknown') {
                    return this._internalHold(this.labelStack, name);
                },
                addHoldByID (labelStack, id, name = 'unknown') {
                    this._internalHoldByID(labelStack, id, name, false);
                },
                removeHoldByID (labelStack, id, name = 'unknown') {
                    this._internalHoldByID(labelStack, id, name, true);
                },
                tracePress (name = 'unknown', timestamp) {
                    if (interactionId.current != null) (0, (0, parcelRequire("bFU4G")).abortByNewInteraction)(interactionId.current, name);
                    const rate = (0, (0, parcelRequire("fe1wc")).getInteractionRate)(name, 'press');
                    if ((0, (0, parcelRequire("5gx4p")).default)(rate)) {
                        const startTimestamp = timestamp ?? performance.now();
                        const newId = (0, $7Jxgt.v4)();
                        interactionId.current = newId;
                        (0, (0, parcelRequire("tcn7E")).setInteractionActiveTrace)(newId, 'press');
                        (0, (0, parcelRequire("bFU4G")).addNewInteraction)(newId, name, 'press', startTimestamp, rate, this.labelStack, (0, (0, parcelRequire("9AgLs")).default).current, (0, (0, parcelRequire("tcn7E")).getActiveTrace)());
                    }
                },
                retainQuery (info) {
                    if (interactionId.current != null) (0, (0, parcelRequire("bFU4G")).addRequestInfo)(interactionId.current, this.labelStack, info);
                },
                addPreload (moduleId, timestamp) {
                    if (interactionId.current != null) (0, (0, parcelRequire("bFU4G")).addMark)(interactionId.current, 'bundle_preload', moduleId, this.labelStack, timestamp);
                },
                addLoad (identifier, start, end) {
                    if (interactionId.current != null) {
                        const { labelStack: labelStack = [] } = this;
                        (0, (0, parcelRequire("bFU4G")).addSpan)(interactionId.current, 'bundle_load', identifier, labelStack, start, end);
                    }
                },
                addMark (name, timestamp) {
                    if (interactionId.current != null) {
                        const time = timestamp ?? performance.now();
                        (0, (0, parcelRequire("bFU4G")).addMark)(interactionId.current, 'custom', name, this.labelStack, time);
                    }
                },
                addCustomData (customData) {
                    if (interactionId.current != null) (0, (0, parcelRequire("bFU4G")).addCustomData)(interactionId.current, this.labelStack, customData);
                },
                addCustomTimings (customTimings) {
                    if (interactionId.current != null) (0, (0, parcelRequire("bFU4G")).addCustomTiming)(interactionId.current, this.labelStack, customTimings);
                },
                addApdex (apdexInfo) {
                    if (interactionId.current != null) {
                        const { key: key, stopTime: stopTime, startTime: startTime } = apdexInfo;
                        (0, (0, parcelRequire("bFU4G")).addApdex)(interactionId.current, {
                            key: key,
                            stopTime: stopTime,
                            startTime: startTime,
                            labelStack: this.labelStack
                        });
                    }
                },
                onRender (phase, actualDuration, baseDuration, startTime, commitTime) {
                    if (interactionId.current !== null) {
                        (0, (0, parcelRequire("bFU4G")).addProfilerTimings)(interactionId.current, this.labelStack, phase, actualDuration, baseDuration, startTime, commitTime);
                        this.complete(commitTime);
                    }
                },
                _internalHold: _internalHold,
                _internalHoldByID: _internalHoldByID,
                complete: complete
            };
        }, [
            parentContext,
            labelStack,
            interactionId
        ]);
        const hasMounted = (0, $5uXOq.useRef)(false);
        const onRender = (0, $5uXOq.useCallback)((_id, phase, actualDuration, baseDuration, startTime, commitTime)=>{
            if ((0, (0, parcelRequire("fe1wc")).getConfig)()?.manuallyTrackReactProfilerMounts && !hasMounted.current) {
                interactionContext.onRender('mount', actualDuration, baseDuration, startTime, commitTime);
                hasMounted.current = true;
            } else interactionContext.onRender(phase, actualDuration, baseDuration, startTime, commitTime);
        }, [
            interactionContext
        ]);
        (0, $5uXOq.useEffect)(()=>()=>{
                (0, (0, parcelRequire("bFU4G")).removeSegment)(labelStack);
            }, [
            interactionId,
            parentContext,
            interactionContext,
            labelStack
        ]);
        const reactProfilerId = (0, $5uXOq.useMemo)(()=>labelStack.map((l)=>l.name).join('/'), [
            labelStack
        ]);
        const enableSegmentHighlighting = (0, (0, parcelRequire("fe1wc")).getConfig)()?.enableSegmentHighlighting;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1tcYS")).default).Provider, {
            value: interactionContext
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Profiler), {
            id: reactProfilerId,
            onRender: onRender
        }, children, enableSegmentHighlighting && (0, ($parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Suspense), {
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($72b82d0e3dab161a$var$AsyncSegmentHighlight, {
            segmentName: segmentName
        }))));
    }
});
parcelRegister("kdJVm", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$20e4b4beffd8665a$export$2e2bcd8739ae039);
    function $20e4b4beffd8665a$export$2e2bcd8739ae039(length = 7) {
        const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        let result = '';
        for(let i = 0; i < length; i++)result += characters.charAt(Math.floor(Math.random() * characters.length));
        return result;
    }
});
parcelRegister("k124G", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("fu0KO").then(()=>parcelRequire('2AmUl'));
});
parcelRegister("6fhBS", function(module, exports) {
    "use strict";
    function $48c1cdc5229a6006$var$load(id) {
        return import((parcelRequire("dy9lH")).resolve(id));
    }
    module.exports = $48c1cdc5229a6006$var$load;
});
parcelRegister("dy9lH", function(module, exports) {
    $parcel$export(module.exports, "register", ()=>$9dd5b3e06d7b5702$export$6503ec6e8aabbaf, (v)=>$9dd5b3e06d7b5702$export$6503ec6e8aabbaf = v);
    $parcel$export(module.exports, "resolve", ()=>$9dd5b3e06d7b5702$export$f7ad0328861e2f03, (v)=>$9dd5b3e06d7b5702$export$f7ad0328861e2f03 = v);
    var $9dd5b3e06d7b5702$export$6503ec6e8aabbaf;
    var $9dd5b3e06d7b5702$export$f7ad0328861e2f03;
    "use strict";
    var $9dd5b3e06d7b5702$var$mapping = new Map();
    function $9dd5b3e06d7b5702$var$register(baseUrl, manifest) {
        for(var i = 0; i < manifest.length - 1; i += 2)$9dd5b3e06d7b5702$var$mapping.set(manifest[i], {
            baseUrl: baseUrl,
            path: manifest[i + 1]
        });
    }
    function $9dd5b3e06d7b5702$var$resolve(id) {
        var resolved = $9dd5b3e06d7b5702$var$mapping.get(id);
        if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
        return new URL(resolved.path, resolved.baseUrl).toString();
    }
    $9dd5b3e06d7b5702$export$6503ec6e8aabbaf = $9dd5b3e06d7b5702$var$register;
    $9dd5b3e06d7b5702$export$f7ad0328861e2f03 = $9dd5b3e06d7b5702$var$resolve;
});
parcelRegister("basmW", function(module, exports) {
    var $2cFTm = parcelRequire("2cFTm");
    var $8216a25e54656007$var$flow = $2cFTm();
    module.exports = $8216a25e54656007$var$flow;
});
parcelRegister("2cFTm", function(module, exports) {
    var $1WNhJ = parcelRequire("1WNhJ");
    var $9SRAA = parcelRequire("9SRAA");
    var $dzqxs = parcelRequire("dzqxs");
    var $dJhFY = parcelRequire("dJhFY");
    var $8LQ84 = parcelRequire("8LQ84");
    var $2dCKt = parcelRequire("2dCKt");
    var $19ad329dbed10597$var$FUNC_ERROR_TEXT = 'Expected a function';
    var $19ad329dbed10597$var$WRAP_CURRY_FLAG = 8, $19ad329dbed10597$var$WRAP_PARTIAL_FLAG = 32, $19ad329dbed10597$var$WRAP_ARY_FLAG = 128, $19ad329dbed10597$var$WRAP_REARG_FLAG = 256;
    function $19ad329dbed10597$var$createFlow(fromRight) {
        return $9SRAA(function(funcs) {
            var length = funcs.length, index = length, prereq = $1WNhJ.prototype.thru;
            if (fromRight) funcs.reverse();
            while(index--){
                var func = funcs[index];
                if (typeof func != 'function') throw new TypeError($19ad329dbed10597$var$FUNC_ERROR_TEXT);
                if (prereq && !wrapper && $dJhFY(func) == 'wrapper') var wrapper = new $1WNhJ([], true);
            }
            index = wrapper ? index : length;
            while(++index < length){
                func = funcs[index];
                var funcName = $dJhFY(func), data = funcName == 'wrapper' ? $dzqxs(func) : undefined;
                if (data && $2dCKt(data[0]) && data[1] == ($19ad329dbed10597$var$WRAP_ARY_FLAG | $19ad329dbed10597$var$WRAP_CURRY_FLAG | $19ad329dbed10597$var$WRAP_PARTIAL_FLAG | $19ad329dbed10597$var$WRAP_REARG_FLAG) && !data[4].length && data[9] == 1) wrapper = wrapper[$dJhFY(data[0])].apply(wrapper, data[3]);
                else wrapper = func.length == 1 && $2dCKt(func) ? wrapper[funcName]() : wrapper.thru(func);
            }
            return function() {
                var args = arguments, value = args[0];
                if (wrapper && args.length == 1 && $8LQ84(value)) return wrapper.plant(value).value();
                var index = 0, result = length ? funcs[index].apply(this, args) : value;
                while(++index < length)result = funcs[index].call(this, result);
                return result;
            };
        });
    }
    module.exports = $19ad329dbed10597$var$createFlow;
});
parcelRegister("1WNhJ", function(module, exports) {
    var $ady43 = parcelRequire("ady43");
    var $dtL2K = parcelRequire("dtL2K");
    function $16b170343299e90c$var$LodashWrapper(value, chainAll) {
        this.__wrapped__ = value;
        this.__actions__ = [];
        this.__chain__ = !!chainAll;
        this.__index__ = 0;
        this.__values__ = undefined;
    }
    $16b170343299e90c$var$LodashWrapper.prototype = $ady43($dtL2K.prototype);
    $16b170343299e90c$var$LodashWrapper.prototype.constructor = $16b170343299e90c$var$LodashWrapper;
    module.exports = $16b170343299e90c$var$LodashWrapper;
});
parcelRegister("dtL2K", function(module, exports) {
    function $9d02799e26f2befc$var$baseLodash() {}
    module.exports = $9d02799e26f2befc$var$baseLodash;
});
parcelRegister("dzqxs", function(module, exports) {
    var $hQCy5 = parcelRequire("hQCy5");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $9e13214619654b13$var$getData = !$hQCy5 ? $8Rkzz : function(func) {
        return $hQCy5.get(func);
    };
    module.exports = $9e13214619654b13$var$getData;
});
parcelRegister("hQCy5", function(module, exports) {
    var $kUWNo = parcelRequire("kUWNo");
    var $cfe531f816dee27d$var$metaMap = $kUWNo && new $kUWNo;
    module.exports = $cfe531f816dee27d$var$metaMap;
});
parcelRegister("dJhFY", function(module, exports) {
    var $b34cU = parcelRequire("b34cU");
    var $9fed306476bd143b$var$objectProto = Object.prototype;
    var $9fed306476bd143b$var$hasOwnProperty = $9fed306476bd143b$var$objectProto.hasOwnProperty;
    function $9fed306476bd143b$var$getFuncName(func) {
        var result = func.name + '', array = $b34cU[result], length = $9fed306476bd143b$var$hasOwnProperty.call($b34cU, result) ? array.length : 0;
        while(length--){
            var data = array[length], otherFunc = data.func;
            if (otherFunc == null || otherFunc == func) return data.name;
        }
        return result;
    }
    module.exports = $9fed306476bd143b$var$getFuncName;
});
parcelRegister("b34cU", function(module, exports) {
    var $80b33cfa5c78e39a$var$realNames = {};
    module.exports = $80b33cfa5c78e39a$var$realNames;
});
parcelRegister("2dCKt", function(module, exports) {
    var $gXHdK = parcelRequire("gXHdK");
    var $dzqxs = parcelRequire("dzqxs");
    var $dJhFY = parcelRequire("dJhFY");
    var $h4Vl3 = parcelRequire("h4Vl3");
    function $19dada4f3cc4c77d$var$isLaziable(func) {
        var funcName = $dJhFY(func), other = $h4Vl3[funcName];
        if (typeof other != 'function' || !(funcName in $gXHdK.prototype)) return false;
        if (func === other) return true;
        var data = $dzqxs(other);
        return !!data && func === data[0];
    }
    module.exports = $19dada4f3cc4c77d$var$isLaziable;
});
parcelRegister("gXHdK", function(module, exports) {
    var $ady43 = parcelRequire("ady43");
    var $dtL2K = parcelRequire("dtL2K");
    var $c593aec8028eae80$var$MAX_ARRAY_LENGTH = 4294967295;
    function $c593aec8028eae80$var$LazyWrapper(value) {
        this.__wrapped__ = value;
        this.__actions__ = [];
        this.__dir__ = 1;
        this.__filtered__ = false;
        this.__iteratees__ = [];
        this.__takeCount__ = $c593aec8028eae80$var$MAX_ARRAY_LENGTH;
        this.__views__ = [];
    }
    $c593aec8028eae80$var$LazyWrapper.prototype = $ady43($dtL2K.prototype);
    $c593aec8028eae80$var$LazyWrapper.prototype.constructor = $c593aec8028eae80$var$LazyWrapper;
    module.exports = $c593aec8028eae80$var$LazyWrapper;
});
parcelRegister("h4Vl3", function(module, exports) {
    var $gXHdK = parcelRequire("gXHdK");
    var $1WNhJ = parcelRequire("1WNhJ");
    var $dtL2K = parcelRequire("dtL2K");
    var $8LQ84 = parcelRequire("8LQ84");
    var $fC1Kz = parcelRequire("fC1Kz");
    var $6e2jm = parcelRequire("6e2jm");
    var $c6ef49a1bd112766$var$objectProto = Object.prototype;
    var $c6ef49a1bd112766$var$hasOwnProperty = $c6ef49a1bd112766$var$objectProto.hasOwnProperty;
    function $c6ef49a1bd112766$var$lodash(value) {
        if ($fC1Kz(value) && !$8LQ84(value) && !(value instanceof $gXHdK)) {
            if (value instanceof $1WNhJ) return value;
            if ($c6ef49a1bd112766$var$hasOwnProperty.call(value, '__wrapped__')) return $6e2jm(value);
        }
        return new $1WNhJ(value);
    }
    $c6ef49a1bd112766$var$lodash.prototype = $dtL2K.prototype;
    $c6ef49a1bd112766$var$lodash.prototype.constructor = $c6ef49a1bd112766$var$lodash;
    module.exports = $c6ef49a1bd112766$var$lodash;
});
parcelRegister("6e2jm", function(module, exports) {
    var $gXHdK = parcelRequire("gXHdK");
    var $1WNhJ = parcelRequire("1WNhJ");
    var $jHlUS = parcelRequire("jHlUS");
    function $4885d7df48eb0605$var$wrapperClone(wrapper) {
        if (wrapper instanceof $gXHdK) return wrapper.clone();
        var result = new $1WNhJ(wrapper.__wrapped__, wrapper.__chain__);
        result.__actions__ = $jHlUS(wrapper.__actions__);
        result.__index__ = wrapper.__index__;
        result.__values__ = wrapper.__values__;
        return result;
    }
    module.exports = $4885d7df48eb0605$var$wrapperClone;
});
parcelRegister("bPTaj", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c5939bd216791b87$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $cb25w;
    var $c5939bd216791b87$export$2e2bcd8739ae039 = (InnerComponent)=>{
        class EngagementEventsWrapper extends (0, $5uXOq.Component) {
            UNSAFE_componentWillMount() {
                this.fireEvent('shown');
            }
            componentWillUnmount() {
                this.fireEvent('hidden');
            }
            fireEvent(action, properties = {}) {
                const { createAnalyticsEvent: createAnalyticsEvent, messageId: messageId, variationId: variationId, componentId: componentId, componentType: componentType, isLast: isLast } = this.props;
                const analyticsEvent = createAnalyticsEvent({
                    action: action,
                    ...properties
                });
                analyticsEvent.update({
                    ekMessageId: messageId,
                    ekVariationId: variationId,
                    ekComponentId: componentId,
                    ekComponentType: componentType,
                    ekIsLast: isLast
                });
                analyticsEvent.fire('engagement');
            }
            render() {
                return (0, ($parcel$interopDefault($5uXOq))).createElement(InnerComponent, {
                    ...this.props,
                    fireClickEvent: this.fireClickEvent
                });
            }
            constructor(...args){
                super(...args), this.fireClickEvent = (clickType)=>{
                    this.fireEvent('click', {
                        clickType: clickType
                    });
                };
            }
        }
        return (0, (0, parcelRequire("cb25w")).default)()(EngagementEventsWrapper);
    };
});
parcelRegister("f9Hff", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c73ca19cb8d0c3f2$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8rCP3;
    var $c73ca19cb8d0c3f2$export$2e2bcd8739ae039 = (InnerComponent, componentType)=>{
        function isTargetComponent(message) {
            return message.componentType === componentType;
        }
        function computeNewState(state) {
            const current = state.current;
            if (current && isTargetComponent(current)) {
                let message;
                switch(current.componentType){
                    case 'contextualSurvey':
                        message = {
                            ...current,
                            aaid: state.config.aaid,
                            cloudId: state.config.cloudId,
                            stargateUrl: state.config.stargateUrl,
                            product: state.config.product,
                            orgId: state.config.orgId,
                            workspaceId: state.config.workspaceId
                        };
                        break;
                    default:
                        message = current;
                }
                return {
                    message: message
                };
            }
            return {
                message: null
            };
        }
        function getComponentType() {
            return componentType;
        }
        class StoreWrapper extends (0, $5uXOq.Component) {
            static{
                this.contextTypes = {
                    subscribeEngagementState: (0, ($parcel$interopDefault((0, parcelRequire("8rCP3"))))).func,
                    setComponentConfig: (0, ($parcel$interopDefault((0, parcelRequire("8rCP3"))))).func
                };
            }
            UNSAFE_componentWillMount() {
                if (this.canSubscribe()) this.unsubscribe = this.subscribeToStore();
                if (this.canSetConfig()) this.removeConfig = this.setChoreographerConfig();
            }
            UNSAFE_componentWillReceiveProps(nextProps) {
                if (this.props?.engagementId !== nextProps?.engagementId && this.removeConfig && this.canSetConfig()) {
                    this.removeConfig();
                    this.removeConfig = this.setChoreographerConfig(nextProps);
                } else if ((this.props?.messageType !== nextProps?.messageType || this.props?.onMessageDisposition !== nextProps?.onMessageDisposition) && this.canSetConfig()) this.setChoreographerConfig(nextProps);
            }
            componentWillUnmount() {
                if (this.unsubscribe) this.unsubscribe();
                if (this.removeConfig) this.removeConfig();
            }
            canSetConfig() {
                return this.context && this.context.setComponentConfig;
            }
            setChoreographerConfig(props = this.props) {
                return this.context.setComponentConfig(getComponentType(), {
                    messageType: props.messageType,
                    onMessageDisposition: props.onMessageDisposition
                }, props.engagementId);
            }
            canSubscribe() {
                return this.context && this.context.subscribeEngagementState;
            }
            subscribeToStore() {
                return this.context.subscribeEngagementState(this.onStoreChange);
            }
            render() {
                const { children: children, engagementId: engagementId } = this.props;
                const { message: message } = this.state;
                if (!message) {
                    if (componentType === 'inlineDialog') return children || null;
                    return null;
                }
                if (engagementId && message !== null && message.target && engagementId !== message.target) return null;
                const messageKey = `${message.messageId}.${message.variationId}.${message.componentId}`;
                return (0, ($parcel$interopDefault($5uXOq))).createElement(InnerComponent, {
                    key: messageKey,
                    ...this.props,
                    ...message
                });
            }
            constructor(...args){
                super(...args), this.state = {
                    message: null
                }, this.onStoreChange = (state)=>{
                    this.setState(computeNewState(state));
                };
            }
        }
        return StoreWrapper;
    };
});
parcelRegister("02CEF", function(module, exports) {
    $parcel$export(module.exports, "buttonActionTypes", ()=>$88face119c13f52b$export$e7d79186651244da);
    const $88face119c13f52b$export$e7d79186651244da = {
        LINK: 'link',
        DISMISS: 'dismiss'
    };
});
parcelRegister("9pLR7", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8be30f37f56f96d5$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    class $8be30f37f56f96d5$export$2e2bcd8739ae039 extends (0, $5uXOq.PureComponent) {
        render() {
            const { html: html } = this.props;
            return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                dangerouslySetInnerHTML: {
                    __html: html
                }
            });
        }
    }
});
parcelRegister("bWGt6", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8b260dd1704e65ee$export$2e2bcd8739ae039);
    var $bS32t = parcelRequire("bS32t");
    var $5uXOq = parcelRequire("5uXOq");
    var $bS0aY = parcelRequire("bS0aY");
    var $f8Sb3;
    var $l9ACI = parcelRequire("l9ACI");
    var $7PpcK = parcelRequire("7PpcK");
    var $lDKn9 = parcelRequire("lDKn9");
    var $8b260dd1704e65ee$var$testOmitPropsOnStringTag = (0, $bS0aY.default);
    var $8b260dd1704e65ee$var$testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
        return key !== 'theme';
    };
    var $8b260dd1704e65ee$var$getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag) {
        return typeof tag === 'string' && tag.charCodeAt(0) > 96 ? $8b260dd1704e65ee$var$testOmitPropsOnStringTag : $8b260dd1704e65ee$var$testOmitPropsOnComponent;
    };
    var $8b260dd1704e65ee$var$composeShouldForwardProps = function composeShouldForwardProps(tag, options, isReal) {
        var shouldForwardProp;
        if (options) {
            var optionsShouldForwardProp = options.shouldForwardProp;
            shouldForwardProp = tag.__emotion_forwardProp && optionsShouldForwardProp ? function(propName) {
                return tag.__emotion_forwardProp(propName) && optionsShouldForwardProp(propName);
            } : optionsShouldForwardProp;
        }
        if (typeof shouldForwardProp !== 'function' && isReal) shouldForwardProp = tag.__emotion_forwardProp;
        return shouldForwardProp;
    };
    var $8b260dd1704e65ee$var$ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
    var $8b260dd1704e65ee$var$Insertion = function Insertion(_ref) {
        var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
        (0, $l9ACI.registerStyles)(cache, serialized, isStringTag);
        var rules = (0, $lDKn9.useInsertionEffectAlwaysWithSyncFallback)(function() {
            return (0, $l9ACI.insertStyles)(cache, serialized, isStringTag);
        });
        return null;
    };
    var $8b260dd1704e65ee$var$createStyled = function createStyled(tag, options) {
        var isReal = tag.__emotion_real === tag;
        var baseTag = isReal && tag.__emotion_base || tag;
        var identifierName;
        var targetClassName;
        if (options !== undefined) {
            identifierName = options.label;
            targetClassName = options.target;
        }
        var shouldForwardProp = $8b260dd1704e65ee$var$composeShouldForwardProps(tag, options, isReal);
        var defaultShouldForwardProp = shouldForwardProp || $8b260dd1704e65ee$var$getDefaultShouldForwardProp(baseTag);
        var shouldUseAs = !defaultShouldForwardProp('as');
        return function() {
            var args = arguments;
            var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];
            if (identifierName !== undefined) styles.push("label:" + identifierName + ";");
            if (args[0] == null || args[0].raw === undefined) styles.push.apply(styles, args);
            else {
                styles.push(args[0][0]);
                var len = args.length;
                var i = 1;
                for(; i < len; i++)styles.push(args[i], args[0][i]);
            }
            var Styled = (0, (0, parcelRequire("f8Sb3")).withEmotionCache)(function(props, cache, ref) {
                var FinalTag = shouldUseAs && props.as || baseTag;
                var className = '';
                var classInterpolations = [];
                var mergedProps = props;
                if (props.theme == null) {
                    mergedProps = {};
                    for(var key in props)mergedProps[key] = props[key];
                    mergedProps.theme = (0, $5uXOq.useContext)((0, (0, parcelRequire("f8Sb3")).ThemeContext));
                }
                if (typeof props.className === 'string') className = (0, $l9ACI.getRegisteredStyles)(cache.registered, classInterpolations, props.className);
                else if (props.className != null) className = props.className + " ";
                var serialized = (0, $7PpcK.serializeStyles)(styles.concat(classInterpolations), cache.registered, mergedProps);
                className += cache.key + "-" + serialized.name;
                if (targetClassName !== undefined) className += " " + targetClassName;
                var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? $8b260dd1704e65ee$var$getDefaultShouldForwardProp(FinalTag) : defaultShouldForwardProp;
                var newProps = {};
                for(var _key in props){
                    if (shouldUseAs && _key === 'as') continue;
                    if (finalShouldForwardProp(_key)) newProps[_key] = props[_key];
                }
                newProps.className = className;
                newProps.ref = ref;
                return (0, $5uXOq.createElement)((0, $5uXOq.Fragment), null, (0, $5uXOq.createElement)($8b260dd1704e65ee$var$Insertion, {
                    cache: cache,
                    serialized: serialized,
                    isStringTag: typeof FinalTag === 'string'
                }), (0, $5uXOq.createElement)(FinalTag, newProps));
            });
            Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === 'string' ? baseTag : baseTag.displayName || baseTag.name || 'Component') + ")";
            Styled.defaultProps = tag.defaultProps;
            Styled.__emotion_real = Styled;
            Styled.__emotion_base = baseTag;
            Styled.__emotion_styles = styles;
            Styled.__emotion_forwardProp = shouldForwardProp;
            Object.defineProperty(Styled, 'toString', {
                value: function value() {
                    return "." + targetClassName;
                }
            });
            Styled.withComponent = function(nextTag, nextOptions) {
                return createStyled(nextTag, (0, $bS32t.default)({}, options, nextOptions, {
                    shouldForwardProp: $8b260dd1704e65ee$var$composeShouldForwardProps(Styled, nextOptions, true)
                })).apply(void 0, styles);
            };
            return Styled;
        };
    };
    var $8b260dd1704e65ee$export$2e2bcd8739ae039 = $8b260dd1704e65ee$var$createStyled;
});
parcelRegister("bS0aY", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8a44dfccbb21331d$export$2e2bcd8739ae039);
    var $73DH6 = parcelRequire("73DH6");
    var $8a44dfccbb21331d$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/;
    var $8a44dfccbb21331d$export$2e2bcd8739ae039 = (0, $73DH6.default)(function(prop) {
        return $8a44dfccbb21331d$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
    });
});
parcelRegister("73DH6", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$52379aa2a5cd30cc$export$2e2bcd8739ae039);
    function $52379aa2a5cd30cc$export$2e2bcd8739ae039(fn) {
        var cache = Object.create(null);
        return function(arg) {
            if (cache[arg] === undefined) cache[arg] = fn(arg);
            return cache[arg];
        };
    }
});
parcelRegister("l9ACI", function(module, exports) {
    $parcel$export(module.exports, "getRegisteredStyles", ()=>$f666d8e4d96dcdd3$export$95d99596f328fd52);
    $parcel$export(module.exports, "registerStyles", ()=>$f666d8e4d96dcdd3$export$580009a5da2a8b4b);
    $parcel$export(module.exports, "insertStyles", ()=>$f666d8e4d96dcdd3$export$6f077d94b33a01aa);
    var $f666d8e4d96dcdd3$var$isBrowser = true;
    function $f666d8e4d96dcdd3$export$95d99596f328fd52(registered, registeredStyles, classNames) {
        var rawClassName = '';
        classNames.split(' ').forEach(function(className) {
            if (registered[className] !== undefined) registeredStyles.push(registered[className] + ";");
            else if (className) rawClassName += className + " ";
        });
        return rawClassName;
    }
    var $f666d8e4d96dcdd3$export$580009a5da2a8b4b = function registerStyles(cache, serialized, isStringTag) {
        var className = cache.key + "-" + serialized.name;
        if ((isStringTag === false || $f666d8e4d96dcdd3$var$isBrowser === false) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
    };
    var $f666d8e4d96dcdd3$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
        $f666d8e4d96dcdd3$export$580009a5da2a8b4b(cache, serialized, isStringTag);
        var className = cache.key + "-" + serialized.name;
        if (cache.inserted[serialized.name] === undefined) {
            var current = serialized;
            do {
                cache.insert(serialized === current ? "." + className : '', current, cache.sheet, true);
                current = current.next;
            }while (current !== undefined)
        }
    };
});
parcelRegister("7Z8dX", function(module, exports) {
    $parcel$export(module.exports, "RovoPostMessagePubsubListener", ()=>$1067642daa65eae6$export$e5e1a9c59c299631);
    $parcel$export(module.exports, "useRovoPostMessageToPubsub", ()=>$1067642daa65eae6$export$5340cc94dd0ecbea);
    var $5uXOq = parcelRequire("5uXOq");
    var $cBeZP;
    var $hjiMw;
    const $1067642daa65eae6$export$cabfb6cc8c48b099 = 'rovo-post-message';
    const $1067642daa65eae6$export$25a11ea4740a334 = 'rovo-post-message-ack';
    const $1067642daa65eae6$var$allowedSubdomains = [
        '.jira-dev.com',
        '.atlassian.com',
        '.atlassian.net',
        '.atl-paas.net'
    ];
    const $1067642daa65eae6$var$allowedOrigins = [
        'bitbucket.org',
        'trello.com'
    ];
    const $1067642daa65eae6$export$c9fe6aef04e3544f = (origin)=>{
        if (!origin) return false;
        const url = new URL(origin);
        const hostname = url.hostname;
        return hostname === 'localhost' || url.protocol === 'https:' && ($1067642daa65eae6$var$allowedSubdomains.some((subdomain)=>hostname.endsWith(subdomain)) || $1067642daa65eae6$var$allowedOrigins.includes(hostname));
    };
    const $1067642daa65eae6$export$e5e1a9c59c299631 = ()=>{
        const publish = (0, (0, parcelRequire("hjiMw")).usePublish)('ai-mate');
        (0, $5uXOq.useEffect)(()=>{
            const handlerUnbind = (0, (0, parcelRequire("cBeZP")).bind)(window, {
                type: 'message',
                listener: (event)=>{
                    if (!$1067642daa65eae6$export$c9fe6aef04e3544f(event.origin)) return;
                    if (event.data.eventType === $1067642daa65eae6$export$cabfb6cc8c48b099) {
                        const eventData = event.data;
                        const ackPayload = {
                            eventType: $1067642daa65eae6$export$25a11ea4740a334,
                            payloadId: eventData.payloadId
                        };
                        event.source?.postMessage(ackPayload);
                        publish(event.data.payload);
                    }
                }
            });
            return handlerUnbind;
        }, [
            publish
        ]);
        return null;
    };
    const $1067642daa65eae6$var$TIMEOUT_WAIT_FOR_ACK = 100;
    const $1067642daa65eae6$export$5340cc94dd0ecbea = ()=>{
        const onAcknowledgeTimeoutTimeoutRef = (0, $5uXOq.useRef)(null);
        const [isWaitingForAck, setIsWaitingForAck] = (0, $5uXOq.useState)(false);
        (0, $5uXOq.useEffect)(()=>{
            const handlerUnbind = (0, (0, parcelRequire("cBeZP")).bind)(window, {
                type: 'message',
                listener: (event)=>{
                    if (!$1067642daa65eae6$export$c9fe6aef04e3544f(event.origin)) return;
                    if (event.data.eventType !== $1067642daa65eae6$export$25a11ea4740a334 || onAcknowledgeTimeoutTimeoutRef.current === null) return;
                    const eventData = event.data;
                    if (eventData.payloadId !== onAcknowledgeTimeoutTimeoutRef.current.lastPayloadId) return;
                    clearTimeout(onAcknowledgeTimeoutTimeoutRef.current.timeout);
                    onAcknowledgeTimeoutTimeoutRef.current = null;
                    setIsWaitingForAck(false);
                }
            });
            return handlerUnbind;
        }, []);
        const publishWithPostMessage = (0, $5uXOq.useCallback)(({ targetWindow: targetWindow = window.parent, payload: payload, onAcknowledgeTimeout: onAcknowledgeTimeout })=>{
            if (!targetWindow) return;
            const payloadId = Math.floor(Math.random() * 1e6).toString();
            targetWindow.postMessage({
                eventType: $1067642daa65eae6$export$cabfb6cc8c48b099,
                payload: payload,
                payloadId: payloadId
            }, '*');
            setIsWaitingForAck(true);
            const timeout = window.setTimeout(()=>{
                onAcknowledgeTimeout({
                    payload: payload
                });
                onAcknowledgeTimeoutTimeoutRef.current = null;
                setIsWaitingForAck(false);
            }, $1067642daa65eae6$var$TIMEOUT_WAIT_FOR_ACK);
            onAcknowledgeTimeoutTimeoutRef.current = {
                timeout: timeout,
                lastPayloadId: payloadId
            };
        }, []);
        return {
            publishWithPostMessage: publishWithPostMessage,
            isWaitingForAck: isWaitingForAck
        };
    };
});
parcelRegister("hjiMw", function(module, exports) {
    $parcel$export(module.exports, "useSubscribe", ()=>$775f1109619c4156$export$d3d523392640272);
    $parcel$export(module.exports, "useSubscribeAll", ()=>$775f1109619c4156$export$2570c8aa24b6d327);
    $parcel$export(module.exports, "usePublish", ()=>$775f1109619c4156$export$d55c81786220731c);
    $parcel$export(module.exports, "Subscriber", ()=>$775f1109619c4156$export$60959659b2c22881);
    var $5uXOq = parcelRequire("5uXOq");
    const $775f1109619c4156$var$ignoredTriggerLatestEvents = new Set([
        'editor-context-payload',
        'agent-changed'
    ]);
    const $775f1109619c4156$var$createPubSub = ()=>{
        let subscribedEvents = {};
        let publishQueue = {};
        let wildcardEvents = [];
        const subscribe = ({ topic: topic, triggerLatest: triggerLatest }, callback)=>{
            const events = subscribedEvents[topic] ?? [];
            const subId = events.length.toString();
            const subExists = events.some(({ id: id })=>id === subId);
            if (!subExists) {
                subscribedEvents = {
                    ...subscribedEvents,
                    [topic]: [
                        ...events,
                        {
                            callback: callback,
                            id: subId
                        }
                    ]
                };
                if (triggerLatest && !!publishQueue[topic]) {
                    const payload = publishQueue[topic];
                    callback(payload);
                    delete publishQueue[topic];
                }
            }
            return ()=>{
                subscribedEvents = {
                    ...subscribedEvents,
                    [topic]: (subscribedEvents[topic] || []).filter(({ id: id })=>id !== subId)
                };
            };
        };
        const subscribeAll = (callback)=>{
            const subId = wildcardEvents.length.toString();
            wildcardEvents = [
                ...wildcardEvents,
                {
                    callback: callback,
                    id: subId
                }
            ];
            return ()=>{
                wildcardEvents = wildcardEvents.filter(({ id: id })=>id !== subId);
            };
        };
        const publish = (topic, payload)=>{
            if (!$775f1109619c4156$var$ignoredTriggerLatestEvents.has(payload.type)) publishQueue[topic] = payload;
            wildcardEvents.forEach(({ callback: callback })=>callback(payload));
            const topicSubs = subscribedEvents[topic] || [];
            if (!topicSubs.length) return;
            topicSubs.forEach(({ callback: callback })=>callback(payload));
        };
        const flushQueue = ()=>{
            publishQueue = {};
        };
        return {
            subscribe: subscribe,
            subscribeAll: subscribeAll,
            publish: publish,
            flushQueue: flushQueue
        };
    };
    const $775f1109619c4156$var$pubSub = $775f1109619c4156$var$createPubSub();
    const $775f1109619c4156$var$usePubSub = ()=>{
        return $775f1109619c4156$var$pubSub;
    };
    const $775f1109619c4156$export$d3d523392640272 = ({ topic: topic, triggerLatest: triggerLatest }, callback)=>{
        const { subscribe: subscribe } = $775f1109619c4156$var$usePubSub();
        const callbackRef = (0, $5uXOq.useRef)(callback);
        callbackRef.current = callback;
        (0, $5uXOq.useEffect)(()=>{
            const unsubscribe = subscribe({
                topic: topic,
                triggerLatest: triggerLatest
            }, (...args)=>callbackRef.current(...args));
            return unsubscribe;
        }, [
            topic
        ]);
    };
    const $775f1109619c4156$export$2570c8aa24b6d327 = (callback)=>{
        const { subscribeAll: subscribeAll } = $775f1109619c4156$var$usePubSub();
        const callbackRef = (0, $5uXOq.useRef)(callback);
        callbackRef.current = callback;
        (0, $5uXOq.useEffect)(()=>{
            const unsubscribe = subscribeAll((...args)=>callbackRef.current(...args));
            return unsubscribe;
        }, []);
    };
    const $775f1109619c4156$var$useFlushOnUnmount = (active = false)=>{
        const { flushQueue: flushQueue } = $775f1109619c4156$var$usePubSub();
        (0, $5uXOq.useLayoutEffect)(()=>{
            return ()=>{
                if (active) flushQueue();
            };
        }, [
            active,
            flushQueue
        ]);
    };
    const $775f1109619c4156$export$d55c81786220731c = (topic)=>{
        const { publish: publish } = $775f1109619c4156$var$usePubSub();
        const publishFn = (0, $5uXOq.useCallback)((payload)=>publish(topic, payload), [
            publish,
            topic
        ]);
        return publishFn;
    };
    const $775f1109619c4156$export$60959659b2c22881 = ({ topic: topic, triggerLatest: triggerLatest, onEvent: onEvent, flushQueueOnUnmount: flushQueueOnUnmount })=>{
        $775f1109619c4156$export$d3d523392640272({
            topic: topic,
            triggerLatest: triggerLatest
        }, onEvent);
        $775f1109619c4156$var$useFlushOnUnmount(flushQueueOnUnmount);
        return null;
    };
});
parcelRegister("fn8B5", function(module, exports) {
    var $1m3dq = parcelRequire("1m3dq");
    var $4CZTG = parcelRequire("4CZTG");
    var $b30fac385487af61$var$objectProto = Object.prototype;
    var $b30fac385487af61$var$hasOwnProperty = $b30fac385487af61$var$objectProto.hasOwnProperty;
    var $b30fac385487af61$var$groupBy = $4CZTG(function(result, value, key) {
        if ($b30fac385487af61$var$hasOwnProperty.call(result, key)) result[key].push(value);
        else $1m3dq(result, key, [
            value
        ]);
    });
    module.exports = $b30fac385487af61$var$groupBy;
});
parcelRegister("cuHs1", function(module, exports) {
    var $1m3dq = parcelRequire("1m3dq");
    var $hDnyx = parcelRequire("hDnyx");
    var $bxDef = parcelRequire("bxDef");
    function $0258ef72e36fbfcb$var$mapKeys(object, iteratee) {
        var result = {};
        iteratee = $bxDef(iteratee, 3);
        $hDnyx(object, function(value, key, object) {
            $1m3dq(result, iteratee(value, key, object), value);
        });
        return result;
    }
    module.exports = $0258ef72e36fbfcb$var$mapKeys;
});
parcelRegister("lbWm4", function(module, exports) {
    var $fmP8r = parcelRequire("fmP8r");
    var $e7pfQ = parcelRequire("e7pfQ");
    var $2KOtB = parcelRequire("2KOtB");
    var $8LQ84 = parcelRequire("8LQ84");
    function $f6d7e42845d7fe59$var$forEach(collection, iteratee) {
        var func = $8LQ84(collection) ? $fmP8r : $e7pfQ;
        return func(collection, $2KOtB(iteratee));
    }
    module.exports = $f6d7e42845d7fe59$var$forEach;
});
parcelRegister("2KOtB", function(module, exports) {
    var $etyzk = parcelRequire("etyzk");
    function $20170833518d35fe$var$castFunction(value) {
        return typeof value == 'function' ? value : $etyzk;
    }
    module.exports = $20170833518d35fe$var$castFunction;
});
parcelRegister("3JOCw", function(module, exports) {
    var $bxDef = parcelRequire("bxDef");
    var $7CoLY = parcelRequire("7CoLY");
    function $2b8cd72f1d3e4fca$var$uniqBy(array, iteratee) {
        return array && array.length ? $7CoLY(array, $bxDef(iteratee, 2)) : [];
    }
    module.exports = $2b8cd72f1d3e4fca$var$uniqBy;
});
parcelRegister("j74qU", function(module, exports) {
    $parcel$export(module.exports, "eocFetch", ()=>$e038c50dbacfc9f4$export$212b9c60150b5a0a);
    var $bFU4G;
    var $aI12f;
    var $030R0;
    const $e038c50dbacfc9f4$export$212b9c60150b5a0a = (input, init)=>{
        let headers = init?.headers ?? {};
        let body = init?.body;
        if (!(window.Blob && body instanceof Blob || window.Int8Array && body instanceof Int8Array || window.Uint8Array && body instanceof Uint8Array || window.Uint8ClampedArray && body instanceof Uint8ClampedArray || window.Int16Array && body instanceof Int16Array || window.Uint16Array && body instanceof Uint16Array || window.Int32Array && body instanceof Int32Array || window.Uint32Array && body instanceof Uint32Array || window.Float32Array && body instanceof Float32Array || window.Float64Array && body instanceof Float64Array || window.ArrayBuffer && body instanceof ArrayBuffer || window.BigInt64Array && body instanceof BigInt64Array || window.BigUint64Array && body instanceof BigUint64Array || window.FormData && body instanceof FormData || window.URLSearchParams && body instanceof URLSearchParams || window.ReadableStream && body instanceof ReadableStream || window.Array && headers instanceof Array || typeof body === 'string') && headers['Content-Type'] === undefined && headers['content-type'] === undefined) {
            body = JSON.stringify(body);
            headers['Content-Type'] = 'application/json';
        }
        if (typeof input === 'string') input = (0, (0, parcelRequire("030R0")).withPrefix)(input, init);
        else input = {
            ...input,
            url: (0, (0, parcelRequire("030R0")).withPrefix)(input.url, init)
        };
        const errorTransformer = init?.errorTransformer ?? (0, (0, parcelRequire("030R0")).defaultErrorTransformer);
        const startTime = performance.now();
        return fetch(input, {
            headers: headers,
            ...init,
            body: body
        }).catch((error)=>{
            throw new (0, (0, parcelRequire("aI12f")).NetworkError)(error.name, error);
        }).then((response)=>{
            if (!response.ok) throw new (0, (0, parcelRequire("aI12f")).HTTPError)(response);
            const sanitizedUrl = (0, (0, parcelRequire("030R0")).sanitizeUrlString)((0, (0, parcelRequire("030R0")).getRequestUrl)(input));
            (0, (0, parcelRequire("bFU4G")).addSpanToAll)('fetch', sanitizedUrl, [
                {
                    name: 'network'
                }
            ], startTime, performance.now());
            switch(init?.responseType){
                case undefined:
                case 'json':
                    return response.json();
                case 'blob':
                    return response.blob();
                case 'text':
                    return response.text();
                case 'headers':
                    return response;
            }
        }).catch((error)=>{
            if ((0, (0, parcelRequire("aI12f")).isNetworkError)(error)) {
                const transformerResult = errorTransformer(error);
                if (transformerResult instanceof Promise) return transformerResult.then((finalError)=>{
                    throw finalError;
                });
                else throw transformerResult;
            }
            throw error;
        });
    };
});
parcelRegister("aI12f", function(module, exports) {
    $parcel$export(module.exports, "NetworkError", ()=>$c2cf5dfa0e96b9de$export$bae979e68e4dc802);
    $parcel$export(module.exports, "HTTPError", ()=>$c2cf5dfa0e96b9de$export$aa9d629c530f62a7);
    $parcel$export(module.exports, "StreamedHTTPError", ()=>$c2cf5dfa0e96b9de$export$c30b5b02747d791c);
    $parcel$export(module.exports, "isHTTPError", ()=>$c2cf5dfa0e96b9de$export$6b7a49ce9c98a2f);
    $parcel$export(module.exports, "isNetworkError", ()=>$c2cf5dfa0e96b9de$export$476aa014e2fd89d5);
    $parcel$export(module.exports, "isStreamedHTTPError", ()=>$c2cf5dfa0e96b9de$export$4f52fcea95c8f97d);
    var $60Rff;
    class $c2cf5dfa0e96b9de$export$bae979e68e4dc802 extends Error {
        constructor(name, cause){
            super('Network Error!'), this.name = name, this.cause = cause;
        }
    }
    class $c2cf5dfa0e96b9de$export$aa9d629c530f62a7 extends $c2cf5dfa0e96b9de$export$bae979e68e4dc802 {
        constructor(response){
            super((0, (0, parcelRequire("60Rff")).ERROR_NAMES).HTTPError);
            this.message = `HTTP Status Error: ${response.status} ${response.statusText}`;
            this.response = response;
        }
    }
    class $c2cf5dfa0e96b9de$export$c30b5b02747d791c extends $c2cf5dfa0e96b9de$export$aa9d629c530f62a7 {
        constructor(cause, data, message){
            super(cause.response), this.cause = cause, this.data = data, this.message = message;
            this.message = message;
            this.name = (0, (0, parcelRequire("60Rff")).ERROR_NAMES).StreamedHTTPError;
        }
    }
    const $c2cf5dfa0e96b9de$export$6b7a49ce9c98a2f = (candidate)=>candidate instanceof $c2cf5dfa0e96b9de$export$aa9d629c530f62a7 || [
            (0, (0, parcelRequire("60Rff")).ERROR_NAMES).HTTPError,
            (0, (0, parcelRequire("60Rff")).ERROR_NAMES).StreamedHTTPError
        ].includes(candidate.name);
    const $c2cf5dfa0e96b9de$export$476aa014e2fd89d5 = (candidate)=>candidate instanceof $c2cf5dfa0e96b9de$export$bae979e68e4dc802 || [
            (0, (0, parcelRequire("60Rff")).ERROR_NAMES).NetworkError,
            (0, (0, parcelRequire("60Rff")).ERROR_NAMES).HTTPError,
            (0, (0, parcelRequire("60Rff")).ERROR_NAMES).StreamedHTTPError
        ].includes(candidate.name);
    const $c2cf5dfa0e96b9de$export$4f52fcea95c8f97d = (candidate)=>candidate instanceof $c2cf5dfa0e96b9de$export$c30b5b02747d791c || candidate?.name === (0, (0, parcelRequire("60Rff")).ERROR_NAMES).StreamedHTTPError;
});
parcelRegister("60Rff", function(module, exports) {
    $parcel$export(module.exports, "ERROR_NAMES", ()=>$3500a6ac498ab4f6$export$daceac3b97803ce1);
    var $3500a6ac498ab4f6$export$daceac3b97803ce1;
    (function(ERROR_NAMES) {
        ERROR_NAMES["HTTPError"] = "HTTPError";
        ERROR_NAMES["StreamedHTTPError"] = "StreamedHTTPError";
        ERROR_NAMES["NetworkError"] = "NetworkError";
    })($3500a6ac498ab4f6$export$daceac3b97803ce1 || ($3500a6ac498ab4f6$export$daceac3b97803ce1 = {}));
});
parcelRegister("030R0", function(module, exports) {
    $parcel$export(module.exports, "getMeta", ()=>$bc491f1610486b68$export$c47913ca32a5c6f7);
    $parcel$export(module.exports, "withPrefix", ()=>$bc491f1610486b68$export$44188c5f179c4553);
    $parcel$export(module.exports, "defaultErrorTransformer", ()=>$bc491f1610486b68$export$270fcc0e5df09fdd);
    $parcel$export(module.exports, "jsmErrorTransformer", ()=>$bc491f1610486b68$export$994cc82144d28ded);
    $parcel$export(module.exports, "getRequestUrl", ()=>$bc491f1610486b68$export$14619c0eed01a470);
    $parcel$export(module.exports, "sanitizeUrlString", ()=>$bc491f1610486b68$export$ceb09b958e605eff);
    var $gIuON;
    var $aI12f;
    let $bc491f1610486b68$var$metaCloudId;
    let $bc491f1610486b68$var$isJSMAvailable = true;
    function $bc491f1610486b68$export$c47913ca32a5c6f7(name) {
        const globalVariable = window ?? $parcel$global;
        if ((0, (0, parcelRequire("gIuON")).isServer)() && globalVariable.ssr__metadata) return globalVariable.ssr__metadata[name];
        if ($bc491f1610486b68$var$metaCloudId) return $bc491f1610486b68$var$metaCloudId;
        if ($bc491f1610486b68$var$isJSMAvailable) {
            const element = document.querySelector(`meta[name="${name}"]`);
            $bc491f1610486b68$var$metaCloudId = element?.getAttribute('content') ?? undefined;
            $bc491f1610486b68$var$isJSMAvailable = !!$bc491f1610486b68$var$metaCloudId;
        }
        return $bc491f1610486b68$var$metaCloudId;
    }
    function $bc491f1610486b68$export$5a75f4aeb58ba80f(id) {
        $bc491f1610486b68$var$metaCloudId = id;
    }
    function $bc491f1610486b68$export$44188c5f179c4553(input, init) {
        if (init?.exactUrl) return input;
        if (window.__OG__) return '/webapi' + input;
        const cloudId = $bc491f1610486b68$export$c47913ca32a5c6f7('ajs-cloud-id');
        if (cloudId) return (0, $2021409bef50eca5$export$3414665826fa030e) + cloudId + input;
        return input;
    }
    const $bc491f1610486b68$var$mediaTypeRegex = /(^application\/json$)|(^application\/json([\s\t]?;.+?)*([\s\t]?;[\s\t]?charset=(("utf-8")|(utf-8))))/i;
    const $bc491f1610486b68$export$270fcc0e5df09fdd = (e)=>{
        if (e instanceof (0, (0, parcelRequire("aI12f")).HTTPError)) {
            const contentType = e.response.headers.get('Content-Type');
            if (contentType && $bc491f1610486b68$var$mediaTypeRegex.test(contentType)) return e.response.json().then((data)=>new (0, (0, parcelRequire("aI12f")).StreamedHTTPError)(e, data, data.errorMessage ?? data.message));
            return e.response.text().then((message)=>new (0, (0, parcelRequire("aI12f")).StreamedHTTPError)(e, message, message));
        }
        return e;
    };
    const $bc491f1610486b68$export$994cc82144d28ded = (error)=>{
        if (error instanceof (0, (0, parcelRequire("aI12f")).HTTPError)) {
            const contentType = error.response.headers.get('Content-Type');
            if (contentType && $bc491f1610486b68$var$mediaTypeRegex.test(contentType)) return error.response.json().then((data)=>new (0, (0, parcelRequire("aI12f")).StreamedHTTPError)(error, data, data.errorMessages.join(',')));
            return error.response.text().then((message)=>new (0, (0, parcelRequire("aI12f")).StreamedHTTPError)(error, message, message));
        }
        return error;
    };
    const $bc491f1610486b68$export$14619c0eed01a470 = (fetchInput)=>typeof fetchInput === 'string' ? fetchInput : fetchInput instanceof URL ? fetchInput.href : fetchInput.url;
    const $bc491f1610486b68$export$ceb09b958e605eff = (url)=>{
        const urlWithoutQueryParams = url.replace(/\?.*$/, '');
        const urlWithoutUUIDs = urlWithoutQueryParams.replace(/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}(-[0-9a-f]{13})?/gi, '<uuid>');
        return urlWithoutUUIDs;
    };
});
parcelRegister("gIuON", function(module, exports) {
    $parcel$export(module.exports, "isServer", ()=>$a110d4649f6250fb$export$6acf61af03e62db);
    const $a110d4649f6250fb$export$6acf61af03e62db = ()=>{
        try {
            return false;
        } catch (error) {
            return globalThis.false ?? false;
        }
    };
});
const $2021409bef50eca5$export$3414665826fa030e = '/gateway/api/jsm/ops/web/';
parcelRegister("dBl98", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9e6f224f96f6af0c$export$2e2bcd8739ae039);
    function $9e6f224f96f6af0c$var$fromHex(r, e, n) {
        var t = r.conversions, o = r.operations, s = r.helpers;
        n = n.replace("#", "").match(/.{2}/g);
        for(var a = 0; a < n.length; a++)n[a] = parseInt(n[a], 16);
        switch(e){
            case "rgb":
                return {
                    r: n[0],
                    g: n[1],
                    b: n[2]
                };
            default:
                return o.convert({
                    conversions: t,
                    operations: o,
                    helpers: s
                }, e, {
                    r: n[0],
                    g: n[1],
                    b: n[2]
                });
        }
    }
    function $9e6f224f96f6af0c$var$fromRgb(r, e, n) {
        var t = r.conversions, o = r.operations, s = r.helpers;
        switch(e){
            case "hex":
                return 1 == (g = Math.round(n.r).toString(16)).length && (g = "0" + g), 1 == (y = Math.round(n.g).toString(16)).length && (y = "0" + y), 1 == (_ = Math.round(n.b).toString(16)).length && (_ = "0" + _), "#" + g + y + _;
            case "cssrgb":
                return "rgb(" + Math.round(n.r) + "," + Math.round(n.g) + "," + Math.round(n.b) + ")";
            case "hsl":
                var a = [
                    g = n.r / 255,
                    y = n.g / 255,
                    _ = n.b / 255
                ].sort(), i = (a[0] + a[2]) / 2 * 100;
                return a[0] == a[2] ? (b = 0, d = 0) : (b = i >= 50 ? (a[2] - a[0]) / (2 - a[2] - a[0]) * 100 : (a[2] - a[0]) / (a[2] + a[0]) * 100, (d = a[2] == g ? (y - _) / (a[2] - a[0]) * 60 : a[2] == y ? 60 * (2 + (_ - g) / (a[2] - a[0])) : 60 * (4 + (g - y) / (a[2] - a[0]))) < 0 ? d += 360 : d > 360 && (d %= 360)), {
                    h: d,
                    s: b,
                    l: i
                };
            case "csshsl":
                var c = o.convert({
                    conversions: t,
                    helpers: s
                }, "hsl", n);
                return "hsl(" + Math.round(c.h) + "," + Math.round(c.s) + "%," + Math.round(c.l) + "%)";
            case "cmyk":
                var u = n.r / 255, l = n.g / 255, h = n.b / 255, v = 1 - Math.max(u, l, h);
                if (1 != v) var p = (1 - u - v) / (1 - v), f = (1 - l - v) / (1 - v), m = (1 - h - v) / (1 - v);
                else var p = 0, f = 0, m = 0;
                return {
                    c: p,
                    m: f,
                    y: m,
                    k: v
                };
            case "hsv":
                var d, b, g = n.r / 255, y = n.g / 255, _ = n.b / 255, M = Math.min(g, y, _), Y = Math.max(g, y, _), L = Y - M, X = Y;
                if (0 == L) d = 0, b = 0;
                else {
                    b = L / Y;
                    var Z = ((Y - g) / 6 + L / 2) / L, R = ((Y - y) / 6 + L / 2) / L, w = ((Y - _) / 6 + L / 2) / L;
                    g == Y ? d = w - R : y == Y ? d = 1 / 3 + Z - w : _ == Y && (d = 2 / 3 + R - Z), d < 0 && (d += 1), d > 1 && (d -= 1);
                }
                return {
                    h: 360 * d,
                    s: 100 * b,
                    v: 100 * X
                };
            case "yiq":
                var m = n.r / 255 * .299 + n.g / 255 * .587 + n.b / 255 * .114, C = n.r / 255 * .596 + n.g / 255 * -0.274 + n.b / 255 * -0.322, x = n.r / 255 * .211 + n.g / 255 * -0.523 + n.b / 255 * .312;
                return C = s.bounded(C, [
                    -0.5957,
                    .5957
                ]), x = s.bounded(x, [
                    -0.5226,
                    .5226
                ]), {
                    y: m,
                    i: C,
                    q: x
                };
            case "XYZ":
                var A = [
                    n.r,
                    n.g,
                    n.b
                ].map(function(r) {
                    return r / 255;
                }).map(function(r) {
                    return r <= .04045 ? r / 12.92 : Math.pow((r + .055) / 1.055, 2.4);
                }), S = s.getTransform("SRGB_XYZ").map(function(r) {
                    return A.reduce(function(e, n, t) {
                        return r[t] * n + e;
                    }, 0);
                }).map(function(r) {
                    return 100 * r;
                }), O = $9e6f224f96f6af0c$var$slicedToArray(S, 3);
                return {
                    X: O[0],
                    Y: O[1],
                    Z: O[2]
                };
            case "lms":
            case "cielab":
            case "cieluv":
            case "xyY":
                var I = o.convert({
                    conversions: t,
                    operations: o,
                    helpers: s
                }, "XYZ", n);
                return o.convert({
                    conversions: t,
                    operations: o,
                    helpers: s
                }, e, I);
            case "cielch":
                var j = o.convert({
                    conversions: t,
                    operations: o,
                    helpers: s
                }, "cieluv", n);
                return o.convert({
                    conversions: t,
                    operations: o,
                    helpers: s
                }, e, j);
            case "hsluv":
                var D = o.convert({
                    conversions: t,
                    operations: o,
                    helpers: s
                }, "cielch", n);
                return o.convert({
                    conversions: t,
                    operations: o,
                    helpers: s
                }, e, D);
        }
    }
    function $9e6f224f96f6af0c$var$fromCssRgb(r, e, n) {
        var t = r.conversions, o = r.operations, s = r.helpers;
        n = n.replace(/((rgb\(|\))|[\s]*)/g, "").split(",");
        for(var a = 0; a < n.length; a++)n[a] = parseInt(n[a]);
        switch(e){
            case "rgb":
                return {
                    r: n[0],
                    g: n[1],
                    b: n[2]
                };
            default:
                return o.convert({
                    conversions: t,
                    operations: o,
                    helpers: s
                }, e, {
                    r: n[0],
                    g: n[1],
                    b: n[2]
                });
        }
    }
    function $9e6f224f96f6af0c$var$fromHsl(r, e, n) {
        var t = r.conversions, o = r.operations, s = r.helpers;
        switch(e){
            case "rgb":
                if (0 == n.s) {
                    var a = n.l / 100 * 255;
                    return {
                        r: a,
                        g: a,
                        b: a
                    };
                }
                var i, c, u;
                i = n.l >= 50 ? n.l / 100 + n.s / 100 - n.l / 100 * (n.s / 100) : n.l / 100 * (1 + n.s / 100), c = n.l / 100 * 2 - i;
                var l, h, v, p = ((u = n.h / 360) + .333) % 1, f = u, m = s.negMod(u - .333, 1);
                return l = 6 * p < 1 ? c + 6 * (i - c) * p : 2 * p < 1 ? i : 3 * p < 2 ? c + 6 * (.666 - p) * (i - c) : c, h = 6 * f < 1 ? c + 6 * (i - c) * f : 2 * f < 1 ? i : 3 * f < 2 ? c + 6 * (.666 - f) * (i - c) : c, v = 6 * m < 1 ? c + 6 * (i - c) * m : 2 * m < 1 ? i : 3 * m < 2 ? c + 6 * (.666 - m) * (i - c) : c, l < 0 && (l = 0), h < 0 && (h = 0), v < 0 && (v = 0), {
                    r: 255 * l,
                    g: 255 * h,
                    b: 255 * v
                };
            case "csshsl":
                return "hsl(" + Math.round(n.h) + "," + Math.round(n.s) + "%," + Math.round(n.l) + "%)";
            case "hsv":
                n.s = n.s / 100, n.l = n.l / 100;
                var d = n.s * (n.l < .5 ? n.l : 1 - n.l);
                return {
                    h: n.h,
                    s: 100 * (2 * d / (n.l + d)),
                    v: 100 * (n.l + d)
                };
            default:
                var b = o.convert({
                    conversions: t,
                    operations: o,
                    helpers: s
                }, "rgb", n);
                return o.convert({
                    conversions: t,
                    operations: o,
                    helpers: s
                }, e, b);
        }
    }
    function $9e6f224f96f6af0c$var$fromCssHsl(r, e, n) {
        var t = r.conversions, o = r.operations, s = r.helpers;
        n = n.replace(/(hsl\(|\)|%|[\s]*)/g, "").split(",");
        for(var a = 0; a < n.length; a++)n[a] = parseInt(n[a]);
        switch(e){
            case "hsl":
                return {
                    h: n[0],
                    s: n[1],
                    l: n[2]
                };
            default:
                return o.convert({
                    conversions: t,
                    operations: o,
                    helpers: s
                }, e, {
                    h: n[0],
                    s: n[1],
                    l: n[2]
                });
        }
    }
    function $9e6f224f96f6af0c$var$fromHsv(r, e, n) {
        var t = r.conversions, o = r.operations, s = r.helpers;
        switch(e){
            case "rgb":
                var a, i, c;
                n.h = n.h / 360, n.s = n.s / 100, n.v = n.v / 100;
                var u = 6 * n.h;
                6 == u && (u = 0);
                var l, h, v, p = Math.round(u), f = n.v * (1 - n.s), m = n.v * (1 - n.s * (u - p)), d = n.v * (1 - n.s * (1 - (u - p)));
                return 0 == p ? (l = n.v, h = d, v = f) : 1 == p ? (l = m, h = n.v, v = f) : 2 == p ? (l = f, h = n.v, v = d) : 3 == p ? (l = f, h = m, v = n.v) : 4 == p ? (l = d, h = f, v = n.v) : (l = n.v, h = f, v = m), a = 255 * l, i = 255 * h, c = 255 * v, {
                    r: a,
                    g: i,
                    b: c
                };
            case "hsl":
                n.h = n.h / 360, n.s = n.s / 100, n.v = n.v / 100;
                return {
                    h: 360 * n.h,
                    s: 100 * ((2 - n.s) * n.v < 1 ? n.s * n.v / ((2 - n.s) * n.v) : n.s * n.v / (2 - (2 - n.s) * n.v)),
                    l: 100 * ((2 - n.s) * n.v / 2)
                };
            default:
                var b = o.convert({
                    conversions: t,
                    operations: o,
                    helpers: s
                }, "rgb", n);
                return o.convert({
                    conversions: t,
                    operations: o,
                    helpers: s
                }, e, b);
        }
    }
    function $9e6f224f96f6af0c$var$fromCmyk(r, e, n) {
        var t = r.conversions, o = r.operations, s = r.helpers;
        switch(e){
            case "rgb":
                return {
                    r: a = 255 * (1 - n.c) * (1 - n.k),
                    g: i = 255 * (1 - n.m) * (1 - n.k),
                    b: c = 255 * (1 - n.y) * (1 - n.k)
                };
            case "cssrgb":
                var a = 255 * (1 - n.c) * (1 - n.k), i = 255 * (1 - n.m) * (1 - n.k), c = 255 * (1 - n.y) * (1 - n.k);
                return "rgb(" + Math.round(a) + "," + Math.round(i) + "," + Math.round(c) + ")";
            default:
                var u = o.convert({
                    conversions: t,
                    operations: o,
                    helpers: s
                }, "rgb", n);
                return o.convert({
                    conversions: t,
                    operations: o,
                    helpers: s
                }, e, u);
        }
    }
    function $9e6f224f96f6af0c$var$fromYiq(r, e, n) {
        var t = r.conversions, o = r.operations, s = r.helpers;
        switch(n.i = s.bounded(n.i, [
            -0.5957,
            .5957
        ]), n.q = s.bounded(n.q, [
            -0.5226,
            .5226
        ]), e){
            case "rgb":
                var a = 255 * (n.y + .956 * n.i + .621 * n.q), i = 255 * (n.y + -0.272 * n.i + -0.647 * n.q), c = 255 * (n.y + -1.106 * n.i + -1.703 * n.q);
                return a = s.bounded(a, [
                    0,
                    255
                ]), i = s.bounded(i, [
                    0,
                    255
                ]), c = s.bounded(c, [
                    0,
                    255
                ]), {
                    r: a,
                    g: i,
                    b: c
                };
            default:
                var u = o.convert({
                    conversions: t,
                    operations: o,
                    helpers: s
                }, "rgb", n);
                return o.convert({
                    conversions: t,
                    operations: o,
                    helpers: s
                }, e, u);
        }
    }
    function $9e6f224f96f6af0c$var$fromXYZ(r, e, n) {
        var t = r.conversions, o = r.operations, s = r.helpers, a = s.getIlluminant("D65");
        switch(e){
            case "rgb":
                var i = [
                    n.X,
                    n.Y,
                    n.Z
                ].map(function(r) {
                    return r / 100;
                }), c = s.getTransform("INVERSE_SRGB_XYZ").map(function(r) {
                    return i.reduce(function(e, n, t) {
                        return r[t] * n + e;
                    }, 0);
                }).map(function(r) {
                    return r <= .0031308 ? 12.92 * r : 1.055 * Math.pow(r, 1 / 2.4) - .055;
                }).map(function(r) {
                    return 255 * r;
                }), u = $9e6f224f96f6af0c$var$slicedToArray(c, 3), l = u[0], h = u[1], v = u[2];
                return s.boundedRgb({
                    r: l,
                    g: h,
                    b: v
                });
            case "lms":
                var p = [
                    n.X,
                    n.Y,
                    n.Z
                ].map(function(r) {
                    return r / 100;
                }), f = s.getTransform("BRADFORD").map(function(r) {
                    return p.reduce(function(e, n, t) {
                        return r[t] * n + e;
                    }, 0);
                });
                return {
                    rho: f[0],
                    gamma: f[1],
                    beta: f[2]
                };
            case "cielab":
                var m = n.X / a.X, d = n.Y / a.Y, b = n.Z / a.Z, g = function(r) {
                    return r > .008856 ? s.cbrt(r) : (903.3 * r + 16) / 116;
                }, y = g(m), _ = g(d);
                return {
                    L: 116 * _ - 16,
                    a: 500 * (y - _),
                    b: 200 * (_ - g(b))
                };
            case "cieluv":
                var M = n.Y / a.Y, Y = M > .008856 ? 116 * s.cbrt(M) - 16 : 903.3 * M, L = function(r) {
                    return 4 * r.X / (r.X + 15 * r.Y + 3 * r.Z);
                }, X = function(r) {
                    return 9 * r.Y / (r.X + 15 * r.Y + 3 * r.Z);
                };
                return {
                    L: Y,
                    u: 13 * Y * (L(n) - L(a)),
                    v: 13 * Y * (X(n) - X(a))
                };
            case "xyY":
                return {
                    x: n.X / (n.X + n.Y + n.Z),
                    y: n.Y / (n.X + n.Y + n.Z),
                    Y: n.Y
                };
            default:
                var Z = s.boundedRgb(o.convert({
                    conversions: t,
                    operations: o,
                    helpers: s
                }, "rgb", n));
                return o.convert({
                    conversions: t,
                    operations: o,
                    helpers: s
                }, e, Z);
        }
    }
    function $9e6f224f96f6af0c$var$fromxyY(r, e, n) {
        var t = r.conversions, o = r.operations, s = r.helpers;
        switch(e){
            case "XYZ":
                var a = n.Y / n.y * n.x, i = n.Y / n.y * (1 - n.x - n.y);
                return {
                    X: a,
                    Y: n.Y,
                    Z: i
                };
            default:
                var c = o.convert({
                    conversions: t,
                    operations: o,
                    helpers: s
                }, "XYZ", n);
                return o.convert({
                    conversions: t,
                    operations: o,
                    helpers: s
                }, e, c);
        }
    }
    function $9e6f224f96f6af0c$var$fromLms(r, e, n) {
        var t = r.conversions, o = r.operations, s = r.helpers;
        switch(e){
            case "XYZ":
                var a = [
                    n.rho,
                    n.gamma,
                    n.beta
                ], i = s.getTransform("INVERSE_BRADFORD").map(function(r) {
                    return a.reduce(function(e, n, t) {
                        return r[t] * n + e;
                    }, 0);
                });
                return {
                    X: 100 * i[0],
                    Y: 100 * i[1],
                    Z: 100 * i[2]
                };
            default:
                var c = o.convert({
                    conversions: t,
                    operations: o,
                    helpers: s
                }, "XYZ", n);
                return o.convert({
                    conversions: t,
                    operations: o,
                    helpers: s
                }, e, c);
        }
    }
    function $9e6f224f96f6af0c$var$fromCieLab(r, e, n) {
        var t = r.conversions, o = r.operations, s = r.helpers;
        switch(e){
            case "XYZ":
                var a = s.getIlluminant("D65"), i = (n.L + 16) / 116, c = n.a / 500 + i, u = i - n.b / 200, l = function(r) {
                    return Math.pow(r, 3) > .008856 ? Math.pow(r, 3) : (116 * r - 16) / 903.3;
                }, h = l(c), v = l(u), p = n.L > 903.3 * .008856 ? Math.pow(i, 3) : n.L / 903.3;
                return {
                    X: h * a.X,
                    Y: p * a.Y,
                    Z: v * a.Z
                };
            default:
                var f = o.convert({
                    conversions: t,
                    operations: o,
                    helpers: s
                }, "XYZ", n);
                return o.convert({
                    conversions: t,
                    operations: o,
                    helpers: s
                }, e, f);
        }
    }
    function $9e6f224f96f6af0c$var$fromCieLuv(r, e, n) {
        var t = r.conversions, o = r.operations, s = r.helpers;
        switch(e){
            case "XYZ":
                var a = s.getIlluminant("D65"), i = function(r) {
                    return 4 * r.X / (r.X + 15 * r.Y + 3 * r.Z);
                }(a), c = function(r) {
                    return 9 * r.Y / (r.X + 15 * r.Y + 3 * r.Z);
                }(a), u = 1 / 3 * (52 * n.L / (n.u + 13 * n.L * i) - 1), l = n.L > 903.3 * .008856 ? Math.pow((n.L + 16) / 116, 3) : n.L / 903.3, h = -5 * l, v = (l * (39 * n.L / (n.v + 13 * n.L * c) - 5) - h) / (u - -1 / 3);
                return {
                    X: 100 * v,
                    Y: 100 * l,
                    Z: 100 * (v * u + h)
                };
            case "cielch":
                var p = Math.sqrt(Math.pow(n.u, 2) + Math.pow(n.v, 2)), f = Math.atan2(n.v, n.u);
                return f < 0 && (f += 2 * Math.PI), f = s.toDeg(f), {
                    L: n.L,
                    C: p,
                    h: f
                };
            default:
                var m = o.convert({
                    conversions: t,
                    operations: o,
                    helpers: s
                }, "XYZ", n);
                return o.convert({
                    conversions: t,
                    operations: o,
                    helpers: s
                }, e, m);
        }
    }
    function $9e6f224f96f6af0c$var$fromCieLch(r, e, n) {
        var t = r.conversions, o = r.operations, s = r.helpers;
        switch(e){
            case "cieluv":
                var a = s.toRad(n.h), i = n.C * Math.cos(a), c = n.C * Math.sin(a);
                return {
                    L: n.L,
                    u: i,
                    v: c
                };
            case "hsluv":
                if (n.L > 99.9999999) return {
                    hu: n.h,
                    s: 0,
                    l: 100
                };
                if (n.L < 1e-8) return {
                    hu: n.h,
                    s: 0,
                    l: 0
                };
                for(var u = (n.L + 16) / 1560896, l = u > .008856 ? u : n.L / 903.3, h = s.getTransform("INVERSE_SRGB_XYZ"), v = [], p = 0; p < 3; p++)for(var f = h[p][0], m = h[p][1], d = h[p][2], b = 0; b < 2; b++){
                    var g = (284517 * f - 94839 * d) * l, y = (838422 * d + 769860 * m + 731718 * f) * n.L * l - 769860 * b * n.L, _ = (632260 * d - 126452 * m) * l + 126452 * b;
                    v.push({
                        m: g / _,
                        b: y / _
                    });
                }
                var M = Number.MAX_VALUE, Y = s.toRad(n.h);
                v.forEach(function(r) {
                    var e = r.b / (Math.sin(Y) - r.m * Math.cos(Y));
                    e >= 0 && (M = Math.min(M, e));
                });
                var L = M;
                return {
                    hu: n.h,
                    s: n.C / L * 100,
                    l: n.L
                };
            default:
                var X = o.convert({
                    conversions: t,
                    operations: o,
                    helpers: s
                }, "cieluv", n);
                return o.convert({
                    conversions: t,
                    operations: o,
                    helpers: s
                }, e, X);
        }
    }
    function $9e6f224f96f6af0c$var$fromCieLch$1(r, e, n) {
        var t = r.conversions, o = r.operations, s = r.helpers;
        switch(e){
            case "cielch":
                if (n.L > 99.9999999) return {
                    L: 100,
                    C: 0,
                    h: n.hu
                };
                if (n.L < 1e-8) return {
                    L: 0,
                    C: 0,
                    h: n.hu
                };
                for(var a = (n.l + 16) / 1560896, i = a > .008856 ? a : n.l / 903.3, c = s.getTransform("INVERSE_SRGB_XYZ"), u = [], l = 0; l < 3; l++)for(var h = c[l][0], v = c[l][1], p = c[l][2], f = 0; f < 2; f++){
                    var m = (284517 * h - 94839 * p) * i, d = (838422 * p + 769860 * v + 731718 * h) * n.l * i - 769860 * f * n.l, b = (632260 * p - 126452 * v) * i + 126452 * f;
                    u.push({
                        m: m / b,
                        b: d / b
                    });
                }
                var g = Number.MAX_VALUE, y = s.toRad(n.hu);
                u.forEach(function(r) {
                    var e = r.b / (Math.sin(y) - r.m * Math.cos(y));
                    e >= 0 && (g = Math.min(g, e));
                });
                var _ = g;
                return {
                    L: n.l,
                    C: _ / 100 * n.s,
                    h: n.hu
                };
            default:
                var M = o.convert({
                    conversions: t,
                    operations: o,
                    helpers: s
                }, "cielch", n);
                return o.convert({
                    conversions: t,
                    operations: o,
                    helpers: s
                }, e, M);
        }
    }
    function $9e6f224f96f6af0c$var$contains(r, e) {
        return Object.keys(r).every(function(r) {
            return -1 !== e.indexOf(r);
        });
    }
    function $9e6f224f96f6af0c$var$adapt(r, e, n, t) {
        var o = r.operations.convert(r, "XYZ", e), s = r.operations.convert(r, "lms", n);
        if (t) a = r.operations.convert(r, "lms", t);
        else var a = r.operations.convert(r, "lms", r.helpers.getIlluminant("D65"));
        var i = r.helpers.getTransform("BRADFORD"), c = r.helpers.getTransform("INVERSE_BRADFORD"), u = [
            [
                s.rho / a.rho,
                0,
                0
            ],
            [
                0,
                s.gamma / a.gamma,
                0
            ],
            [
                0,
                0,
                s.beta / a.beta
            ]
        ], l = r.helpers.matrixMultiply(c, u), h = r.helpers.matrixMultiply(l, i), v = [
            [
                o.X
            ],
            [
                o.Y
            ],
            [
                o.Z
            ]
        ], p = r.helpers.matrixMultiply(h, v), f = {
            X: p[0][0],
            Y: p[1][0],
            Z: p[2][0]
        };
        return r.helpers.ready(r, f);
    }
    function $9e6f224f96f6af0c$var$adjacent(r, e, n, t) {
        for(var o = r.operations.convert(r, "hsl", t), s = [
            {
                h: o.h,
                s: o.s,
                l: o.l
            }
        ], a = 0; a < n - 1; a++)o.h = r.helpers.negMod(o.h + e, 360), s.push({
            h: o.h,
            s: o.s,
            l: o.l
        });
        return r.helpers.ready(r, s);
    }
    function $9e6f224f96f6af0c$var$brightness(r, e, n) {
        var t = r.operations.convert(r, "hsl", n);
        return t.l += e, t.l < 0 ? t.l = 0 : t.l > 100 && (t.l = 100), r.helpers.ready(r, t);
    }
    function $9e6f224f96f6af0c$var$complementary(r, e) {
        var n = r.operations.convert(r, "hsl", e);
        return n.h = (n.h + 180) % 360, r.helpers.ready(r, n);
    }
    function $9e6f224f96f6af0c$var$contrast(r, e, n) {
        var t = r.operations.convert(r, "rgb", n);
        return t.r = 255 * ((t.r / 255 - .5) * e + .5), t.r < 0 ? t.r = 0 : t.r > 255 && (t.r = 255), t.g = 255 * ((t.g / 255 - .5) * e + .5), t.g < 0 ? t.g = 0 : t.g > 255 && (t.g = 255), t.b = 255 * ((t.b / 255 - .5) * e + .5), t.b < 0 ? t.b = 0 : t.b > 255 && (t.b = 255), r.helpers.ready(r, t);
    }
    function $9e6f224f96f6af0c$var$contrastRatio(r, e) {
        var n = r.operations.convert(r, "rgb", e);
        return n = (299 * n.r + 587 * n.g + 114 * n.b) / 1e3 >= 128 ? {
            r: 0,
            g: 0,
            b: 0
        } : {
            r: 255,
            g: 255,
            b: 255
        }, r.helpers.ready(r, n);
    }
    function $9e6f224f96f6af0c$var$convert(r, e, n) {
        if (Object.keys(r.conversions).indexOf(e) > -1) {
            n.colour ? n = n.colour : n.colours && (n = n.colours);
            var t = r.helpers.determineMode(n);
            return t != e ? r.conversions[t].convert(r, e, n) : n;
        }
        return r.helpers.ready(r, e);
    }
    function $9e6f224f96f6af0c$var$difference(r, e, n, t, o) {
        t = t || 1, o = o || 1;
        var s = r.operations.convert(r, "cielab", e), a = r.operations.convert(r, "cielab", n), i = Math.sqrt(Math.pow(s.a, 2) + Math.pow(s.b, 2)), c = i - Math.sqrt(Math.pow(a.a, 2) + Math.pow(a.b, 2)), u = s.L - a.L, l = s.a - a.a, h = s.b - a.b, v = Math.sqrt(Math.pow(l, 2) + Math.pow(h, 2) - Math.pow(c, 2)), p = s.L < 16 ? .511 : .040975 * s.L / (1.01765 * s.L), f = .0638 * i / (1.0131 * i), m = Math.atan2(s.b, s.a), d = m >= 0 ? m : m + 360, b = 164 <= d && d <= 345 ? .56 + Math.abs(.2 * Math.cos(r.helpers.toRad(d + 168))) : .36 + Math.abs(.4 * Math.cos(r.helpers.toRad(d + 35))), g = Math.pow(i, 4) / (Math.pow(i, 4) + 1900), y = f * (g * b + 1 - g), _ = Math.pow(u / (t * p), 2);
        return Math.sqrt(_ + _ + _);
    }
    function $9e6f224f96f6af0c$var$fade(r, e, n, t) {
        var o = r.operations.convert(r, "rgb", n), s = r.operations.convert(r, "rgb", t), a = [
            o
        ];
        e -= 1;
        for(var i = (s.r - o.r) / e, c = (s.g - o.g) / e, u = (s.b - o.b) / e, l = {
            r: o.r,
            g: o.g,
            b: o.b
        }, h = 0; h < e - 1; h++)l.r = r.helpers.slopeMod(l.r + i, 255), l.g = r.helpers.slopeMod(l.g + c, 255), l.b = r.helpers.slopeMod(l.b + u, 255), a.push({
            r: l.r,
            g: l.g,
            b: l.b
        });
        return a.push(s), r.helpers.ready(r, a);
    }
    function $9e6f224f96f6af0c$var$greyscale(r, e) {
        var n = r.operations.convert(r, "rgb", e), t = (n.r + n.g + n.b) / 3;
        return n = {
            r: t,
            g: t,
            b: t
        }, r.helpers.ready(r, n);
    }
    function $9e6f224f96f6af0c$var$hue(r, e, n) {
        var t = r.operations.convert(r, "hsl", n);
        return t.h = r.helpers.negMod(t.h + e, 360), r.helpers.ready(r, t);
    }
    function $9e6f224f96f6af0c$var$invert(r, e) {
        var n = r.operations.convert(r, "rgb", e);
        return n.r = r.helpers.negMod(255 - n.r, 255), n.g = r.helpers.negMod(255 - n.g, 255), n.b = r.helpers.negMod(255 - n.b, 255), r.helpers.ready(r, n);
    }
    function $9e6f224f96f6af0c$var$invertLightness(r, e) {
        var n = r.operations.convert(r, "hsl", e);
        return n.l = 100 - n.l, r.helpers.ready(r, n);
    }
    function $9e6f224f96f6af0c$var$mid(r, e, n) {
        var t = r.operations.convert(r, "hsl", e), o = r.operations.convert(r, "hsl", n), s = {
            h: (t.h + o.h) / 2,
            s: (t.s + o.s) / 2,
            l: (t.l + o.l) / 2
        };
        return r.helpers.ready(r, s);
    }
    function $9e6f224f96f6af0c$var$multiply(r, e, n) {
        var t = r.operations.convert(r, "hsl", e), o = r.operations.convert(r, "hsl", n), s = {
            h: t.h,
            s: t.s,
            l: t.l / 100 * (o.l / 100) * 100
        };
        return s.l = s.l > 100 ? 100 : s.l, s.l = s.l < 0 ? 0 : s.l, r.helpers.ready(r, s);
    }
    function $9e6f224f96f6af0c$var$saturation(r, e, n) {
        var t = r.operations.convert(r, "hsl", n);
        return t.s += e, t.s < 0 ? t.s = 0 : t.s > 100 && (t.s = 100), r.helpers.ready(r, t);
    }
    function $9e6f224f96f6af0c$var$sepia(r, e) {
        var n = r.operations.convert(r, "rgb", e), t = {};
        return t.r = .393 * n.r + .769 * n.g + .189 * n.b, t.g = .349 * n.r + .686 * n.g + .168 * n.b, t.b = .272 * n.r + .534 * n.g + .131 * n.b, r.helpers.ready(r, t);
    }
    function $9e6f224f96f6af0c$var$shade(r, e, n) {
        var t = r.operations.convert(r, "hsv", n);
        return t.v += e, t.v < 0 ? t.v = 0 : t.v > 100 && (t.v = 100), r.helpers.ready(r, t);
    }
    function $9e6f224f96f6af0c$var$temperature(r, e) {
        var n = r.operations.convert(r, "xyY", e), t = (n.x - .332) / (n.y - .1858);
        return -449 * Math.pow(t, 3) + 3525 * Math.pow(t, 2) - 6823.3 * t + 5520.33;
    }
    function $9e6f224f96f6af0c$var$tetrad(r, e) {
        for(var n = r.operations.convert(r, "hsl", e), t = [
            {
                h: n.h,
                s: n.s,
                l: n.l
            }
        ], o = 0; o < 3; o++)n.h = (n.h + 90) % 360, t.push({
            h: n.h,
            s: n.s,
            l: n.l
        });
        return r.helpers.ready(r, t);
    }
    function $9e6f224f96f6af0c$var$triad(r, e) {
        for(var n = r.operations.convert(r, "hsl", e), t = [
            {
                h: n.h,
                s: n.s,
                l: n.l
            }
        ], o = 0; o < 2; o++)n.h = (n.h + 120) % 360, t.push({
            h: n.h,
            s: n.s,
            l: n.l
        });
        return r.helpers.ready(r, t);
    }
    var $9e6f224f96f6af0c$var$fromHex_1 = $9e6f224f96f6af0c$var$fromHex, $9e6f224f96f6af0c$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(r) {
        return typeof r;
    } : function(r) {
        return r && "function" == typeof Symbol && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
    }, $9e6f224f96f6af0c$var$slicedToArray = function() {
        function r(r, e) {
            var n = [], t = !0, o = !1, s = void 0;
            try {
                for(var a, i = r[Symbol.iterator](); !(t = (a = i.next()).done) && (n.push(a.value), !e || n.length !== e); t = !0);
            } catch (r) {
                o = !0, s = r;
            } finally{
                try {
                    !t && i.return && i.return();
                } finally{
                    if (o) throw s;
                }
            }
            return n;
        }
        return function(e, n) {
            if (Array.isArray(e)) return e;
            if (Symbol.iterator in Object(e)) return r(e, n);
            throw new TypeError("Invalid attempt to destructure non-iterable instance");
        };
    }(), $9e6f224f96f6af0c$var$toConsumableArray = function(r) {
        if (Array.isArray(r)) {
            for(var e = 0, n = Array(r.length); e < r.length; e++)n[e] = r[e];
            return n;
        }
        return Array.from(r);
    }, $9e6f224f96f6af0c$var$fromRgb_1 = $9e6f224f96f6af0c$var$fromRgb, $9e6f224f96f6af0c$var$fromCssRgb_1 = $9e6f224f96f6af0c$var$fromCssRgb, $9e6f224f96f6af0c$var$fromHsl_1 = $9e6f224f96f6af0c$var$fromHsl, $9e6f224f96f6af0c$var$fromCssHsl_1 = $9e6f224f96f6af0c$var$fromCssHsl, $9e6f224f96f6af0c$var$fromHsv_1 = $9e6f224f96f6af0c$var$fromHsv, $9e6f224f96f6af0c$var$fromCmyk_1 = $9e6f224f96f6af0c$var$fromCmyk, $9e6f224f96f6af0c$var$fromYiq_1 = $9e6f224f96f6af0c$var$fromYiq, $9e6f224f96f6af0c$var$fromXYZ_1 = $9e6f224f96f6af0c$var$fromXYZ, $9e6f224f96f6af0c$var$fromxyY_1 = $9e6f224f96f6af0c$var$fromxyY, $9e6f224f96f6af0c$var$fromLms_1 = $9e6f224f96f6af0c$var$fromLms, $9e6f224f96f6af0c$var$fromCieLab_1 = $9e6f224f96f6af0c$var$fromCieLab, $9e6f224f96f6af0c$var$fromCieLuv_1 = $9e6f224f96f6af0c$var$fromCieLuv, $9e6f224f96f6af0c$var$fromCieLch_1 = $9e6f224f96f6af0c$var$fromCieLch, $9e6f224f96f6af0c$var$fromHsluv = $9e6f224f96f6af0c$var$fromCieLch$1, $9e6f224f96f6af0c$var$index = {
        hex: {
            test: function(r) {
                return "string" == typeof r && "#" === r.slice(0, 1);
            },
            convert: $9e6f224f96f6af0c$var$fromHex_1
        },
        rgb: {
            test: function(r) {
                return $9e6f224f96f6af0c$var$contains(r, [
                    "r",
                    "g",
                    "b"
                ]);
            },
            convert: $9e6f224f96f6af0c$var$fromRgb_1
        },
        cssrgb: {
            test: function(r) {
                return "string" == typeof r && "rgb(" === r.slice(0, 4);
            },
            convert: $9e6f224f96f6af0c$var$fromCssRgb_1
        },
        hsl: {
            test: function(r) {
                return $9e6f224f96f6af0c$var$contains(r, [
                    "h",
                    "s",
                    "l"
                ]);
            },
            convert: $9e6f224f96f6af0c$var$fromHsl_1
        },
        csshsl: {
            test: function(r) {
                return "string" == typeof r && "hsl(" === r.slice(0, 4);
            },
            convert: $9e6f224f96f6af0c$var$fromCssHsl_1
        },
        hsv: {
            test: function(r) {
                return $9e6f224f96f6af0c$var$contains(r, [
                    "h",
                    "s",
                    "v"
                ]);
            },
            convert: $9e6f224f96f6af0c$var$fromHsv_1
        },
        cmyk: {
            test: function(r) {
                return $9e6f224f96f6af0c$var$contains(r, [
                    "c",
                    "m",
                    "y",
                    "k"
                ]);
            },
            convert: $9e6f224f96f6af0c$var$fromCmyk_1
        },
        yiq: {
            test: function(r) {
                return $9e6f224f96f6af0c$var$contains(r, [
                    "y",
                    "i",
                    "q"
                ]);
            },
            convert: $9e6f224f96f6af0c$var$fromYiq_1
        },
        XYZ: {
            test: function(r) {
                return $9e6f224f96f6af0c$var$contains(r, [
                    "X",
                    "Y",
                    "Z"
                ]);
            },
            convert: $9e6f224f96f6af0c$var$fromXYZ_1
        },
        xyY: {
            test: function(r) {
                return $9e6f224f96f6af0c$var$contains(r, [
                    "x",
                    "y",
                    "Y"
                ]);
            },
            convert: $9e6f224f96f6af0c$var$fromxyY_1
        },
        lms: {
            test: function(r) {
                return $9e6f224f96f6af0c$var$contains(r, [
                    "rho",
                    "gamma",
                    "beta"
                ]);
            },
            convert: $9e6f224f96f6af0c$var$fromLms_1
        },
        cielab: {
            test: function(r) {
                return $9e6f224f96f6af0c$var$contains(r, [
                    "L",
                    "a",
                    "b"
                ]);
            },
            convert: $9e6f224f96f6af0c$var$fromCieLab_1
        },
        cieluv: {
            test: function(r) {
                return $9e6f224f96f6af0c$var$contains(r, [
                    "L",
                    "u",
                    "v"
                ]);
            },
            convert: $9e6f224f96f6af0c$var$fromCieLuv_1
        },
        cielch: {
            test: function(r) {
                return $9e6f224f96f6af0c$var$contains(r, [
                    "L",
                    "C",
                    "h"
                ]);
            },
            convert: $9e6f224f96f6af0c$var$fromCieLch_1
        },
        hsluv: {
            test: function(r) {
                return $9e6f224f96f6af0c$var$contains(r, [
                    "hu",
                    "s",
                    "l"
                ]);
            },
            convert: $9e6f224f96f6af0c$var$fromHsluv
        }
    }, $9e6f224f96f6af0c$var$adapt_1 = $9e6f224f96f6af0c$var$adapt, $9e6f224f96f6af0c$var$adjacent_1 = $9e6f224f96f6af0c$var$adjacent, $9e6f224f96f6af0c$var$brightness_1 = $9e6f224f96f6af0c$var$brightness, $9e6f224f96f6af0c$var$complementary_1 = $9e6f224f96f6af0c$var$complementary, $9e6f224f96f6af0c$var$contrast_1 = $9e6f224f96f6af0c$var$contrast, $9e6f224f96f6af0c$var$contrastRatio_1 = $9e6f224f96f6af0c$var$contrastRatio, $9e6f224f96f6af0c$var$convert_1 = $9e6f224f96f6af0c$var$convert, $9e6f224f96f6af0c$var$difference_1 = $9e6f224f96f6af0c$var$difference, $9e6f224f96f6af0c$var$fade_1 = $9e6f224f96f6af0c$var$fade, $9e6f224f96f6af0c$var$greyscale_1 = $9e6f224f96f6af0c$var$greyscale, $9e6f224f96f6af0c$var$hue_1 = $9e6f224f96f6af0c$var$hue, $9e6f224f96f6af0c$var$invert_1 = $9e6f224f96f6af0c$var$invert, $9e6f224f96f6af0c$var$invertLightness_1 = $9e6f224f96f6af0c$var$invertLightness, $9e6f224f96f6af0c$var$mid_1 = $9e6f224f96f6af0c$var$mid, $9e6f224f96f6af0c$var$multiply_1 = $9e6f224f96f6af0c$var$multiply, $9e6f224f96f6af0c$var$saturation_1 = $9e6f224f96f6af0c$var$saturation, $9e6f224f96f6af0c$var$sepia_1 = $9e6f224f96f6af0c$var$sepia, $9e6f224f96f6af0c$var$shade_1 = $9e6f224f96f6af0c$var$shade, $9e6f224f96f6af0c$var$temperature_1 = $9e6f224f96f6af0c$var$temperature, $9e6f224f96f6af0c$var$tetrad_1 = $9e6f224f96f6af0c$var$tetrad, $9e6f224f96f6af0c$var$triad_1 = $9e6f224f96f6af0c$var$triad, $9e6f224f96f6af0c$var$index$2 = {
        adapt: $9e6f224f96f6af0c$var$adapt_1,
        adjacent: $9e6f224f96f6af0c$var$adjacent_1,
        brightness: $9e6f224f96f6af0c$var$brightness_1,
        complementary: $9e6f224f96f6af0c$var$complementary_1,
        contrast: $9e6f224f96f6af0c$var$contrast_1,
        contrastRatio: $9e6f224f96f6af0c$var$contrastRatio_1,
        convert: $9e6f224f96f6af0c$var$convert_1,
        difference: $9e6f224f96f6af0c$var$difference_1,
        fade: $9e6f224f96f6af0c$var$fade_1,
        greyscale: $9e6f224f96f6af0c$var$greyscale_1,
        hue: $9e6f224f96f6af0c$var$hue_1,
        invert: $9e6f224f96f6af0c$var$invert_1,
        invertLightness: $9e6f224f96f6af0c$var$invertLightness_1,
        mid: $9e6f224f96f6af0c$var$mid_1,
        multiply: $9e6f224f96f6af0c$var$multiply_1,
        saturation: $9e6f224f96f6af0c$var$saturation_1,
        sepia: $9e6f224f96f6af0c$var$sepia_1,
        shade: $9e6f224f96f6af0c$var$shade_1,
        temperature: $9e6f224f96f6af0c$var$temperature_1,
        tetrad: $9e6f224f96f6af0c$var$tetrad_1,
        triad: $9e6f224f96f6af0c$var$triad_1
    }, $9e6f224f96f6af0c$var$constants = {
        ILLUMINANTS: {
            A: {
                X: 1.0985 * 100,
                Y: 100,
                Z: 35.585
            },
            B: {
                X: 99.072,
                Y: 100,
                Z: 85.223
            },
            C: {
                X: 98.074,
                Y: 100,
                Z: 118.232
            },
            D50: {
                X: 96.422,
                Y: 100,
                Z: 82.521
            },
            D55: {
                X: 95.682,
                Y: 100,
                Z: 92.149
            },
            D65: {
                X: 95.047,
                Y: 100,
                Z: 108.883
            },
            D75: {
                X: 94.972,
                Y: 100,
                Z: 122.638
            },
            E: {
                X: 100,
                Y: 100,
                Z: 100
            },
            F2: {
                X: .99186 * 100,
                Y: 100,
                Z: 67.393
            },
            F7: {
                X: 95.041,
                Y: 100,
                Z: 108.747
            },
            F11: {
                X: 1.00962 * 100,
                Y: 100,
                Z: 64.35
            }
        },
        TRANSFORMS: {
            BRADFORD: [
                [
                    .8951,
                    .2664,
                    -0.1614
                ],
                [
                    -0.7502,
                    1.7135,
                    .0367
                ],
                [
                    .0389,
                    -0.0685,
                    1.0296
                ]
            ],
            INVERSE_BRADFORD: [
                [
                    .9869929,
                    -0.1470543,
                    .1599627
                ],
                [
                    .4323053,
                    .5183603,
                    .0492912
                ],
                [
                    -0.0085287,
                    .0400428,
                    .9684867
                ]
            ],
            SRGB_XYZ: [
                [
                    .4124,
                    .3576,
                    .1805
                ],
                [
                    .2126,
                    .7152,
                    .0722
                ],
                [
                    .0193,
                    .1192,
                    .9505
                ]
            ],
            INVERSE_SRGB_XYZ: [
                [
                    3.2406,
                    -1.5372,
                    -0.4986
                ],
                [
                    -0.9689,
                    1.8758,
                    .0415
                ],
                [
                    .0557,
                    -0.204,
                    1.057
                ]
            ]
        }
    }, $9e6f224f96f6af0c$var$api = function(r, e, n) {
        var t = Object.keys(r.operations).reduce(function(e, t) {
            var o = r.operations[t];
            return e[t] = function() {
                for(var e = arguments.length, t = Array(e), s = 0; s < e; s++)t[s] = arguments[s];
                var a = t.slice(0).map(function(r) {
                    return "object" === (void 0 === r ? "undefined" : $9e6f224f96f6af0c$var$_typeof(r)) ? Object.assign({}, r) : r;
                });
                if (n && n.colours) return function e(n) {
                    var t = n.map(function(n) {
                        if (Array.isArray(n)) {
                            var t = e(n);
                            return t.colours || t.colour;
                        }
                        var s = o.apply(void 0, [
                            r
                        ].concat($9e6f224f96f6af0c$var$toConsumableArray(a), [
                            n
                        ]));
                        return "object" === (void 0 === s ? "undefined" : $9e6f224f96f6af0c$var$_typeof(s)) ? s.colours || s.colour : s;
                    });
                    return "number" != typeof t[0] ? r.helpers.ready(r, t) : t;
                }(n.colours);
                return o.apply(void 0, [
                    r
                ].concat($9e6f224f96f6af0c$var$toConsumableArray(a), [
                    n ? n.colour : void 0
                ]));
            }, e;
        }, {});
        return n || (t = Object.assign(t, e)), t;
    }, $9e6f224f96f6af0c$var$api_1 = $9e6f224f96f6af0c$var$api, $9e6f224f96f6af0c$var$helpers = {
        getIlluminant: function(r) {
            return $9e6f224f96f6af0c$var$constants.ILLUMINANTS[r];
        },
        getTransform: function(r) {
            return $9e6f224f96f6af0c$var$constants.TRANSFORMS[r];
        },
        matrixMultiply: function(r, e) {
            for(var n = [], t = 0; t < r.length; t++){
                n[t] = [];
                for(var o = 0; o < e[0].length; o++){
                    for(var s = 0, a = 0; a < r[0].length; a++)s += r[t][a] * e[a][o];
                    n[t][o] = s;
                }
            }
            return n;
        },
        cbrt: function(r) {
            if (Math.cbrt) return Math.cbrt(r);
            var e = Math.pow(Math.abs(r), 1 / 3);
            return r < 0 ? -e : e;
        },
        toRad: function(r) {
            return r * (Math.PI / 180);
        },
        toDeg: function(r) {
            return r * (180 / Math.PI);
        },
        negMod: function(r, e) {
            return (r % e + e) % e;
        },
        slopeMod: function(r) {
            function e(e, n) {
                return r.apply(this, arguments);
            }
            return e.toString = function() {
                return r.toString();
            }, e;
        }(function(r, e) {
            return r > 2 * e ? slopeMod(r - 2 * e, e) : r > e ? 2 * e - r : r < 0 ? slopeMod(r + 2 * e, e) : r;
        }),
        bounded: function(r, e) {
            return r < e[0] ? r = e[0] : r > e[1] && (r = e[1]), r;
        },
        boundedRgb: function(r) {
            var e = this, n = function(r) {
                return e.bounded(r, [
                    0,
                    255
                ]);
            };
            return {
                r: n(r.r),
                g: n(r.g),
                b: n(r.b)
            };
        },
        determineMode: function(r) {
            for(var e in $9e6f224f96f6af0c$var$index)if ($9e6f224f96f6af0c$var$index.hasOwnProperty(e) && $9e6f224f96f6af0c$var$index[e].test(r)) return e;
            return null;
        },
        ready: function(r, e) {
            var n = r.conversions, t = r.operations, o = r.helpers, s = {};
            switch(Object.prototype.toString.call(e)){
                case "[object Object]":
                case "[object String]":
                    s.colour = e;
                    for(var a in n)n.hasOwnProperty(a) && function(r) {
                        Object.defineProperty(s, r, {
                            get: function() {
                                o.determineMode(e);
                                return t.convert({
                                    conversions: n,
                                    operations: t,
                                    helpers: o
                                }, r, e);
                            },
                            enumerable: !0
                        });
                    }(a);
                    return s = Object.assign(s, $9e6f224f96f6af0c$var$api_1({
                        conversions: n,
                        operations: t,
                        helpers: o
                    }, $9e6f224f96f6af0c$var$constants, s));
                case "[object Array]":
                    s.colours = e;
                    for(var i in n)n.hasOwnProperty(i) && function(r) {
                        Object.defineProperty(s, r, {
                            get: function() {
                                return function e(s) {
                                    return s.map(function(s) {
                                        return Array.isArray(s) ? e(s) : t.convert({
                                            conversions: n,
                                            operations: t,
                                            helpers: o
                                        }, r, s);
                                    });
                                }(e);
                            },
                            enumerable: !0
                        });
                    }(i);
                    return s = Object.assign(s, $9e6f224f96f6af0c$var$api_1({
                        conversions: n,
                        operations: t,
                        helpers: o
                    }, $9e6f224f96f6af0c$var$constants, s));
                default:
                    return null;
            }
        }
    }, $9e6f224f96f6af0c$var$helpers_1 = $9e6f224f96f6af0c$var$helpers, $9e6f224f96f6af0c$var$dependencies = {
        conversions: $9e6f224f96f6af0c$var$index,
        operations: $9e6f224f96f6af0c$var$index$2,
        helpers: $9e6f224f96f6af0c$var$helpers_1
    }, $9e6f224f96f6af0c$var$entry = $9e6f224f96f6af0c$var$api_1($9e6f224f96f6af0c$var$dependencies, $9e6f224f96f6af0c$var$constants);
    var $9e6f224f96f6af0c$export$2e2bcd8739ae039 = $9e6f224f96f6af0c$var$entry;
});
parcelRegister("1bGms", function(module, exports) {
    $parcel$export(module.exports, "AccountMenu", ()=>$eb480c5bace8303e$export$ff20d75d5eda4388);
    var $5uXOq = parcelRequire("5uXOq");
    var $1PVpv = parcelRequire("1PVpv");
    var $kHCo7;
    var $6EBh3;
    var $8NZjk;
    var $cvjqp;
    var $fnXLr;
    const $eb480c5bace8303e$export$ff20d75d5eda4388 = ({ testId: testId, name: name, picture: picture, email: email, managedBy: managedBy, manageProfileLink: manageProfileLink, viewProfileLink: viewProfileLink, onViewProfileClick: onViewProfileClick, switchAccountLink: switchAccountLink, logOutLink: logOutLink, logInLink: logInLink, onThemeChange: onThemeChange, currentTheme: currentTheme, extraMenuItems: extraMenuItems })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, $1PVpv.NavigationAnalyticsContext), {
            data: (0, (0, parcelRequire("kHCo7")).ANALYTICS_CONTEXT)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8NZjk")).AccountMenuIntlProvider), null, logInLink ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cvjqp")).AccountMenuLoggedOutState), {
            testId: testId && `${testId}--logged-out-state`,
            logInLink: logInLink
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fnXLr")).AccountMenuPopup), {
            testId: testId,
            picture: picture,
            email: email,
            content: ({ onClose: closePopup })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6EBh3")).AccountMenuContent), {
                    testId: testId && `${testId}--content`,
                    closePopup: closePopup,
                    name: name,
                    picture: picture,
                    email: email,
                    managedBy: managedBy,
                    manageProfileLink: manageProfileLink,
                    viewProfileLink: viewProfileLink,
                    onViewProfileClick: onViewProfileClick,
                    switchAccountLink: switchAccountLink,
                    logOutLink: logOutLink,
                    onThemeChange: onThemeChange,
                    currentTheme: currentTheme,
                    extraMenuItems: extraMenuItems
                })
        })));
});
parcelRegister("kHCo7", function(module, exports) {
    $parcel$export(module.exports, "NAVIGATION_CHANNEL", ()=>$898ad1755d1c196d$export$515664faa1398f37);
    $parcel$export(module.exports, "ANALYTICS_CONTEXT", ()=>$898ad1755d1c196d$export$3cbe56a0cabcff38);
    const $898ad1755d1c196d$export$515664faa1398f37 = 'navigation';
    const $898ad1755d1c196d$export$3cbe56a0cabcff38 = {
        source: 'atlassianAccountMenu',
        componentName: 'atlassianAccountMenu',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    };
});
parcelRegister("6EBh3", function(module, exports) {
    $parcel$export(module.exports, "AccountMenuContent", ()=>$174fca08ce98c8fc$export$49c2771125e1e9f1);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $ousew;
    var $2NMNM;
    var $6q3np;
    var $k2tiP;
    var $fptva;
    var $1bKdn;
    var $bxqXD;
    var $dNE6G;
    var $d9wnW;
    var $3Z96c;
    var $eZUJu;
    var $9UCCQ;
    var $k5uoT;
    var $kHCo7;
    var $1j5Ak;
    var $chqbk;
    var $bWGt6 = parcelRequire("bWGt6");
    const $174fca08ce98c8fc$export$49c2771125e1e9f1 = ({ testId: testId, closePopup: closePopup, name: name, picture: picture, email: email, managedBy: managedBy, manageProfileLink: manageProfileLink, viewProfileLink: viewProfileLink, onViewProfileClick: onViewProfileClick, switchAccountLink: switchAccountLink, logOutLink: logOutLink, onThemeChange: onThemeChange, currentTheme: currentTheme, extraMenuItems: extraMenuItems = null })=>{
        const themeSwitcherProps = onThemeChange && currentTheme;
        const shouldRenderProfileThemeSwitcherSection = Boolean(viewProfileLink || manageProfileLink || themeSwitcherProps);
        return (0, (0, parcelRequire("f8Sb3")).jsx)($174fca08ce98c8fc$var$Container, {
            "data-testid": testId
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("eZUJu")).default), null, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("9UCCQ")).default), null, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("1j5Ak")).AccountDetails), {
            testId: testId && `${testId}--details`,
            name: name,
            picture: picture,
            email: email,
            managedBy: managedBy
        })), shouldRenderProfileThemeSwitcherSection && (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("9UCCQ")).default), null, viewProfileLink && (0, (0, parcelRequire("f8Sb3")).jsx)($174fca08ce98c8fc$var$ViewProfileLink, {
            onClick: onViewProfileClick,
            testId: testId && `${testId}--view-profile`,
            href: viewProfileLink,
            closePopup: closePopup
        }), manageProfileLink && (0, (0, parcelRequire("f8Sb3")).jsx)($174fca08ce98c8fc$var$ManageProfileLink, {
            testId: testId && `${testId}--manage-profile`,
            href: manageProfileLink,
            closePopup: closePopup
        }), themeSwitcherProps && (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("chqbk")).ThemeSwitcher), {
            testId: testId && `${testId}--theme-switcher`,
            onThemeChange: onThemeChange,
            currentTheme: currentTheme
        })), extraMenuItems, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("9UCCQ")).default), {
            hasSeparator: shouldRenderProfileThemeSwitcherSection
        }, switchAccountLink && (0, (0, parcelRequire("f8Sb3")).jsx)($174fca08ce98c8fc$var$SwitchAccountLink, {
            testId: testId && `${testId}--switch-account`,
            href: switchAccountLink,
            closePopup: closePopup
        }), (0, (0, parcelRequire("f8Sb3")).jsx)($174fca08ce98c8fc$var$LogOutLink, {
            testId: testId && `${testId}--log-out`,
            href: logOutLink,
            closePopup: closePopup
        }))));
    };
    const $174fca08ce98c8fc$var$Container = (0, $bWGt6.default)("div", {
        target: "evherry0"
    })({
        boxSizing: 'border-box',
        minWidth: (0, (0, parcelRequire("k5uoT")).gridSize)() * 38
    });
    const $174fca08ce98c8fc$var$ViewProfileLink = ({ testId: testId, href: href, onClick: onClick, closePopup: closePopup })=>(0, (0, parcelRequire("f8Sb3")).jsx)($174fca08ce98c8fc$var$Link, {
            testId: testId,
            href: href,
            onClick: onClick,
            icon: (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("1bKdn"))))), {
                color: "currentColor",
                label: "",
                LEGACY_size: "medium",
                LEGACY_fallbackIcon: (0, (0, parcelRequire("dNE6G")).default)
            }),
            closePopup: closePopup,
            actionSubjectId: "viewProfileLink"
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("ousew")).default), {
            id: "identity.account-menu.account-details.view-profile-tooltip",
            defaultMessage: "Profile",
            description: "Text shown when hovering over profile information"
        }));
    const $174fca08ce98c8fc$var$ManageProfileLink = ({ testId: testId, href: href, closePopup: closePopup })=>(0, (0, parcelRequire("f8Sb3")).jsx)($174fca08ce98c8fc$var$Link, {
            testId: testId,
            href: href,
            icon: (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("k2tiP"))))), {
                color: "currentColor",
                label: "",
                LEGACY_size: "medium"
            }),
            closePopup: closePopup,
            actionSubjectId: "manageProfileLink",
            target: "_blank",
            rel: "noopener"
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("ousew")).default), {
            id: "identity.account-menu.account-details.manage-profile-link",
            defaultMessage: "Account settings",
            description: "Text for link to account management page"
        }));
    const $174fca08ce98c8fc$var$SwitchAccountLink = ({ testId: testId, href: href, closePopup: closePopup })=>(0, (0, parcelRequire("f8Sb3")).jsx)($174fca08ce98c8fc$var$Link, {
            testId: testId,
            icon: (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("fptva"))))), {
                color: "currentColor",
                label: "",
                LEGACY_size: "medium",
                LEGACY_fallbackIcon: (0, (0, parcelRequire("bxqXD")).default)
            }),
            href: href,
            closePopup: closePopup,
            actionSubjectId: "switchAccountLink"
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("ousew")).default), {
            id: "identity.account-menu.account-menu-content.switch-account-button",
            defaultMessage: "Switch account",
            description: "Label for button in account menu to switch to another another account"
        }));
    const $174fca08ce98c8fc$var$LogOutLink = ({ testId: testId, href: href, closePopup: closePopup })=>(0, (0, parcelRequire("f8Sb3")).jsx)($174fca08ce98c8fc$var$Link, {
            testId: testId,
            icon: (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("6q3np"))))), {
                color: "currentColor",
                label: "",
                LEGACY_size: "medium",
                LEGACY_fallbackIcon: (0, (0, parcelRequire("d9wnW")).default)
            }),
            href: href,
            closePopup: closePopup,
            actionSubjectId: "logOutLink"
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("ousew")).default), {
            id: "identity.account-menu.account-menu-content.log-out-button",
            defaultMessage: "Log out",
            description: "Label for button in account menu to log out"
        }));
    const $174fca08ce98c8fc$var$Link = ({ testId: testId, closePopup: closePopup, icon: icon, href: href, onClick: onClick, actionSubjectId: actionSubjectId, children: children, ...props })=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const handleClick = (0, $5uXOq.useCallback)((event)=>{
            const analyticsEvent = createAnalyticsEvent({
                eventType: (0, $676c5e519aa5ba55$export$a1562d08625f5d7e),
                action: 'clicked',
                actionSubject: 'menuLinkItem',
                actionSubjectId: actionSubjectId
            });
            const clone = analyticsEvent.clone();
            if (clone) clone.fire((0, (0, parcelRequire("kHCo7")).NAVIGATION_CHANNEL));
            onClick?.(event, analyticsEvent);
            closePopup?.(event);
        }, [
            createAnalyticsEvent,
            onClick,
            closePopup,
            actionSubjectId
        ]);
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("3Z96c")).default), {
            testId: testId,
            iconBefore: icon,
            href: href,
            onClick: handleClick,
            ...props
        }, children);
    };
});
const $676c5e519aa5ba55$export$a1562d08625f5d7e = 'ui';
const $676c5e519aa5ba55$export$947dac6c72b26f81 = 'track';
const $676c5e519aa5ba55$export$f1d537d508d2945a = 'screen';
const $676c5e519aa5ba55$export$12346a674644c156 = 'operational';
const $676c5e519aa5ba55$export$b055de0e665cb20c = 'unknown';
parcelRegister("1j5Ak", function(module, exports) {
    $parcel$export(module.exports, "AccountDetails", ()=>$44d42378b5c841d1$export$66e04d0aacdb3b2);
    var $f8Sb3;
    var $ousew;
    var $1bKdn;
    var $dNE6G;
    var $cgL5K;
    var $k5uoT;
    var $aOl2M;
    var $9FNiA;
    var $bWGt6 = parcelRequire("bWGt6");
    function $44d42378b5c841d1$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $44d42378b5c841d1$export$66e04d0aacdb3b2 = ({ testId: testId, name: name, picture: picture, email: email, managedBy: managedBy })=>(0, (0, parcelRequire("f8Sb3")).jsx)($44d42378b5c841d1$var$Container, {
            "data-testid": testId
        }, managedBy && (0, (0, parcelRequire("f8Sb3")).jsx)($44d42378b5c841d1$var$ManagedBy, null, (0, (0, parcelRequire("f8Sb3")).jsx)($44d42378b5c841d1$var$PersonIconWrapper, null, (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("1bKdn"))))), {
            color: "currentColor",
            label: "",
            LEGACY_size: "small",
            LEGACY_fallbackIcon: (0, (0, parcelRequire("dNE6G")).default)
        })), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("ousew")).default), {
            id: "identity.account-menu.account-menu-details.managed-account",
            defaultMessage: "This account is managed by <b>{managedBy}</b>",
            description: "Label showing the user which organisation manages their Atlassian account",
            values: {
                b: (text)=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("cgL5K")).default), {
                        as: "strong",
                        size: "small",
                        color: "inherit"
                    }, text),
                managedBy: managedBy
            }
        })), (0, (0, parcelRequire("f8Sb3")).jsx)($44d42378b5c841d1$var$Content, {
            hasHeader: !!managedBy
        }, (0, (0, parcelRequire("f8Sb3")).jsx)($44d42378b5c841d1$var$Profile, {
            testId: testId,
            name: name,
            picture: picture,
            email: email
        })));
    const $44d42378b5c841d1$var$Container = (0, $bWGt6.default)("section", {
        target: "e3lis067"
    })({
        display: 'flex',
        flexDirection: 'column',
        margin: `0 ${"var(--ds-space-100, 8px)"}`
    });
    const $44d42378b5c841d1$var$ManagedBy = (0, $bWGt6.default)("small", {
        target: "e3lis066"
    })({
        display: 'box',
        margin: '0px',
        padding: `${"var(--ds-space-025, 2px)"} ${"var(--ds-space-100, 8px)"}`,
        textAlign: 'center',
        borderRadius: `${(0, (0, parcelRequire("k5uoT")).borderRadius)()}px ${(0, (0, parcelRequire("k5uoT")).borderRadius)()}px 0 0`,
        background: `var(--ds-background-information, ${(0, $829f609a65d26a98$export$226de0355ed012f8)})`,
        color: "var(--ds-text-subtle, #44546F)"
    });
    const $44d42378b5c841d1$var$PersonIconWrapper = (0, $bWGt6.default)("span", {
        target: "e3lis065"
    })({
        name: "1d1sf9j",
        styles: "margin-right:var(--ds-space-050, 4px);& > span{width:12px;height:12px;}"
    });
    const $44d42378b5c841d1$var$Content = (0, $bWGt6.default)("div", {
        target: "e3lis064"
    })({
        display: 'flex',
        flexDirection: 'column',
        background: `var(--ds-surface-sunken, ${(0, $829f609a65d26a98$export$8d43898f60b96a82)})`
    }, ({ hasHeader: hasHeader })=>({
            borderRadius: hasHeader ? `0 0 ${(0, (0, parcelRequire("k5uoT")).borderRadius)()}px ${(0, (0, parcelRequire("k5uoT")).borderRadius)()}px` : `${(0, (0, parcelRequire("k5uoT")).borderRadius)()}px`
        }));
    const $44d42378b5c841d1$var$Profile = ({ name: name, email: email, picture: picture, testId: testId })=>(0, (0, parcelRequire("f8Sb3")).jsx)($44d42378b5c841d1$var$ProfileWrapper, null, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("aOl2M")).ProfilePicture), {
            src: picture,
            size: (0, (0, parcelRequire("k5uoT")).gridSize)() * 8,
            testId: testId && `${testId}--picture`
        }), (0, (0, parcelRequire("f8Sb3")).jsx)($44d42378b5c841d1$var$NameAndEmail, null, (0, (0, parcelRequire("f8Sb3")).jsx)($44d42378b5c841d1$var$DisplayName, {
            "data-testid": testId && `${testId}--name`
        }, name || (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("9FNiA")).SkeletonText), {
            length: "6em"
        })), (0, (0, parcelRequire("f8Sb3")).jsx)($44d42378b5c841d1$var$EmailAddress, {
            "data-testid": testId && `${testId}--email`
        }, email || (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("9FNiA")).SkeletonText), {
            length: "10em"
        }))));
    const $44d42378b5c841d1$var$ProfileWrapper = (0, $bWGt6.default)("div", {
        target: "e3lis063"
    })({
        display: 'flex',
        flexDirection: 'row',
        margin: `${"var(--ds-space-200, 16px)"} ${"var(--ds-space-200, 16px)"}`
    });
    const $44d42378b5c841d1$var$NameAndEmail = (0, $bWGt6.default)("div", {
        target: "e3lis062"
    })({
        display: 'flex',
        flexDirection: 'column',
        margin: `auto 0 auto ${"var(--ds-space-200, 16px)"}`
    });
    const $44d42378b5c841d1$var$DisplayName = (0, $bWGt6.default)("h3", {
        target: "e3lis061"
    })({
        color: `var(--ds-text, ${(0, $829f609a65d26a98$export$7d61b15e0da132af)})`,
        margin: 0
    });
    const $44d42378b5c841d1$var$EmailAddress = (0, $bWGt6.default)("p", {
        target: "e3lis060"
    })({
        name: "ngg0zx",
        styles: "margin-top:var(--ds-space-025, 2px);color:var(--ds-text-subtlest, #626F86);font-weight:400"
    });
});
var $829f609a65d26a98$exports = {};
$parcel$export($829f609a65d26a98$exports, "R50", ()=>$829f609a65d26a98$export$4b84fd0e2c617bd);
$parcel$export($829f609a65d26a98$exports, "R75", ()=>$829f609a65d26a98$export$b34b069eff244586);
$parcel$export($829f609a65d26a98$exports, "R100", ()=>$829f609a65d26a98$export$be802dd0d8b57f35);
$parcel$export($829f609a65d26a98$exports, "R200", ()=>$829f609a65d26a98$export$60847d42f9da92a6);
$parcel$export($829f609a65d26a98$exports, "R300", ()=>$829f609a65d26a98$export$4a7404f376229999);
$parcel$export($829f609a65d26a98$exports, "R400", ()=>$829f609a65d26a98$export$2010d0fb4295b346);
$parcel$export($829f609a65d26a98$exports, "R500", ()=>$829f609a65d26a98$export$2837b5a1a71d5c02);
$parcel$export($829f609a65d26a98$exports, "Y50", ()=>$829f609a65d26a98$export$8d9596b529bbb9cf);
$parcel$export($829f609a65d26a98$exports, "Y75", ()=>$829f609a65d26a98$export$41060a744ab0b7ae);
$parcel$export($829f609a65d26a98$exports, "Y100", ()=>$829f609a65d26a98$export$1cc05bbbf340e559);
$parcel$export($829f609a65d26a98$exports, "Y200", ()=>$829f609a65d26a98$export$5aae31392d72caaa);
$parcel$export($829f609a65d26a98$exports, "Y300", ()=>$829f609a65d26a98$export$c6930421db9fa514);
$parcel$export($829f609a65d26a98$exports, "Y400", ()=>$829f609a65d26a98$export$59619663aa6500fb);
$parcel$export($829f609a65d26a98$exports, "Y500", ()=>$829f609a65d26a98$export$874739ea9e379ab6);
$parcel$export($829f609a65d26a98$exports, "G50", ()=>$829f609a65d26a98$export$8a6341c32b6a3ee6);
$parcel$export($829f609a65d26a98$exports, "G75", ()=>$829f609a65d26a98$export$69a3bf21b9686c2b);
$parcel$export($829f609a65d26a98$exports, "G100", ()=>$829f609a65d26a98$export$afbce1382ec95f73);
$parcel$export($829f609a65d26a98$exports, "G200", ()=>$829f609a65d26a98$export$747d86715d4175de);
$parcel$export($829f609a65d26a98$exports, "G300", ()=>$829f609a65d26a98$export$940e1f69e873f202);
$parcel$export($829f609a65d26a98$exports, "G400", ()=>$829f609a65d26a98$export$a49394138f7b8e85);
$parcel$export($829f609a65d26a98$exports, "G500", ()=>$829f609a65d26a98$export$6fa04827ac68a4fb);
$parcel$export($829f609a65d26a98$exports, "B50", ()=>$829f609a65d26a98$export$226de0355ed012f8);
$parcel$export($829f609a65d26a98$exports, "B75", ()=>$829f609a65d26a98$export$8c13c2ee36917869);
$parcel$export($829f609a65d26a98$exports, "B100", ()=>$829f609a65d26a98$export$ecfc1dff386a3e7a);
$parcel$export($829f609a65d26a98$exports, "B200", ()=>$829f609a65d26a98$export$215b7063051591f1);
$parcel$export($829f609a65d26a98$exports, "B300", ()=>$829f609a65d26a98$export$e62e8919cca44969);
$parcel$export($829f609a65d26a98$exports, "B400", ()=>$829f609a65d26a98$export$b3de0ae08da2ce64);
$parcel$export($829f609a65d26a98$exports, "B500", ()=>$829f609a65d26a98$export$a6ee3d71bc067634);
$parcel$export($829f609a65d26a98$exports, "B600", ()=>$829f609a65d26a98$export$67f15409e87642a1);
$parcel$export($829f609a65d26a98$exports, "B700", ()=>$829f609a65d26a98$export$f0539dbc42dbb067);
$parcel$export($829f609a65d26a98$exports, "P50", ()=>$829f609a65d26a98$export$363e4475840015bb);
$parcel$export($829f609a65d26a98$exports, "P75", ()=>$829f609a65d26a98$export$4b0a4417ed59760f);
$parcel$export($829f609a65d26a98$exports, "P100", ()=>$829f609a65d26a98$export$6011520a64d9a187);
$parcel$export($829f609a65d26a98$exports, "P200", ()=>$829f609a65d26a98$export$a7175d4e9206bc80);
$parcel$export($829f609a65d26a98$exports, "P300", ()=>$829f609a65d26a98$export$b48405b95304b5a1);
$parcel$export($829f609a65d26a98$exports, "P400", ()=>$829f609a65d26a98$export$c71e4279dd54a18d);
$parcel$export($829f609a65d26a98$exports, "P500", ()=>$829f609a65d26a98$export$147899de772240ec);
$parcel$export($829f609a65d26a98$exports, "T50", ()=>$829f609a65d26a98$export$2cf711fe14c66f06);
$parcel$export($829f609a65d26a98$exports, "T75", ()=>$829f609a65d26a98$export$7a8f4d33f6f9772c);
$parcel$export($829f609a65d26a98$exports, "T100", ()=>$829f609a65d26a98$export$776c9c497ef08533);
$parcel$export($829f609a65d26a98$exports, "T200", ()=>$829f609a65d26a98$export$69cb3ca10c1e330e);
$parcel$export($829f609a65d26a98$exports, "T300", ()=>$829f609a65d26a98$export$9dc1ef0f3f48059b);
$parcel$export($829f609a65d26a98$exports, "T400", ()=>$829f609a65d26a98$export$7c835c78b6fcdef8);
$parcel$export($829f609a65d26a98$exports, "T500", ()=>$829f609a65d26a98$export$6036577f95c3877e);
$parcel$export($829f609a65d26a98$exports, "N0", ()=>$829f609a65d26a98$export$29a4f05edc054374);
$parcel$export($829f609a65d26a98$exports, "N10", ()=>$829f609a65d26a98$export$e655ef011c4aa1a2);
$parcel$export($829f609a65d26a98$exports, "N20", ()=>$829f609a65d26a98$export$9fdfb749e33cdf97);
$parcel$export($829f609a65d26a98$exports, "N30", ()=>$829f609a65d26a98$export$3e51e8f1440314ba);
$parcel$export($829f609a65d26a98$exports, "N40", ()=>$829f609a65d26a98$export$1ce2d1575d444ceb);
$parcel$export($829f609a65d26a98$exports, "N50", ()=>$829f609a65d26a98$export$8754fc7e6d8b3000);
$parcel$export($829f609a65d26a98$exports, "N60", ()=>$829f609a65d26a98$export$c2e91cbeada39b8b);
$parcel$export($829f609a65d26a98$exports, "N70", ()=>$829f609a65d26a98$export$5f71e19f3a7ad9de);
$parcel$export($829f609a65d26a98$exports, "N80", ()=>$829f609a65d26a98$export$eaa8c8a70ac22806);
$parcel$export($829f609a65d26a98$exports, "N90", ()=>$829f609a65d26a98$export$7c87d337fb91a97d);
$parcel$export($829f609a65d26a98$exports, "N100", ()=>$829f609a65d26a98$export$d6447c357493214f);
$parcel$export($829f609a65d26a98$exports, "N200", ()=>$829f609a65d26a98$export$f563ee71e9ee74cd);
$parcel$export($829f609a65d26a98$exports, "N300", ()=>$829f609a65d26a98$export$e2ef2124cf4024b1);
$parcel$export($829f609a65d26a98$exports, "N400", ()=>$829f609a65d26a98$export$eece5f492e429f08);
$parcel$export($829f609a65d26a98$exports, "N500", ()=>$829f609a65d26a98$export$c39c0fe0f26207ae);
$parcel$export($829f609a65d26a98$exports, "N600", ()=>$829f609a65d26a98$export$7090862dc3038a9f);
$parcel$export($829f609a65d26a98$exports, "N700", ()=>$829f609a65d26a98$export$ad0bacf983b7ddaa);
$parcel$export($829f609a65d26a98$exports, "N800", ()=>$829f609a65d26a98$export$7d61b15e0da132af);
$parcel$export($829f609a65d26a98$exports, "N900", ()=>$829f609a65d26a98$export$fbda843f0a27fe96);
$parcel$export($829f609a65d26a98$exports, "N10A", ()=>$829f609a65d26a98$export$791e57b27ca738ef);
$parcel$export($829f609a65d26a98$exports, "N20A", ()=>$829f609a65d26a98$export$8d43898f60b96a82);
$parcel$export($829f609a65d26a98$exports, "N30A", ()=>$829f609a65d26a98$export$920c0d5c49070351);
$parcel$export($829f609a65d26a98$exports, "N40A", ()=>$829f609a65d26a98$export$46987b49aab6d1a8);
$parcel$export($829f609a65d26a98$exports, "N50A", ()=>$829f609a65d26a98$export$7d3359664e8bb0e5);
$parcel$export($829f609a65d26a98$exports, "N60A", ()=>$829f609a65d26a98$export$d2d3bedfb276cac0);
$parcel$export($829f609a65d26a98$exports, "N70A", ()=>$829f609a65d26a98$export$6e5e7499ff054f6d);
$parcel$export($829f609a65d26a98$exports, "N80A", ()=>$829f609a65d26a98$export$59264b346c877fa7);
$parcel$export($829f609a65d26a98$exports, "N90A", ()=>$829f609a65d26a98$export$d092757d7c64925c);
$parcel$export($829f609a65d26a98$exports, "N100A", ()=>$829f609a65d26a98$export$486ab785e4bac3c6);
$parcel$export($829f609a65d26a98$exports, "N200A", ()=>$829f609a65d26a98$export$fba592bbc6419fea);
$parcel$export($829f609a65d26a98$exports, "N300A", ()=>$829f609a65d26a98$export$13609db0e6812ab8);
$parcel$export($829f609a65d26a98$exports, "N400A", ()=>$829f609a65d26a98$export$fbae4efaa892d883);
$parcel$export($829f609a65d26a98$exports, "N500A", ()=>$829f609a65d26a98$export$f13946d26f440ce6);
$parcel$export($829f609a65d26a98$exports, "N600A", ()=>$829f609a65d26a98$export$19f58225ac52a306);
$parcel$export($829f609a65d26a98$exports, "N700A", ()=>$829f609a65d26a98$export$6384f09da70e7b62);
$parcel$export($829f609a65d26a98$exports, "N800A", ()=>$829f609a65d26a98$export$d0dccc730683edc2);
$parcel$export($829f609a65d26a98$exports, "DN900", ()=>$829f609a65d26a98$export$2f6319cf7d736c2a);
$parcel$export($829f609a65d26a98$exports, "DN800", ()=>$829f609a65d26a98$export$95126bc8884d6634);
$parcel$export($829f609a65d26a98$exports, "DN700", ()=>$829f609a65d26a98$export$8338d8c35d44ff1);
$parcel$export($829f609a65d26a98$exports, "DN600", ()=>$829f609a65d26a98$export$5368d76ae4fbbda7);
$parcel$export($829f609a65d26a98$exports, "DN500", ()=>$829f609a65d26a98$export$9f0a771d16ec8d36);
$parcel$export($829f609a65d26a98$exports, "DN400", ()=>$829f609a65d26a98$export$abcf8c38338b4aa5);
$parcel$export($829f609a65d26a98$exports, "DN300", ()=>$829f609a65d26a98$export$97e81faa16a182c7);
$parcel$export($829f609a65d26a98$exports, "DN200", ()=>$829f609a65d26a98$export$bfe21c59123ecf33);
$parcel$export($829f609a65d26a98$exports, "DN100", ()=>$829f609a65d26a98$export$ee82aa2ea6a1558);
$parcel$export($829f609a65d26a98$exports, "DN90", ()=>$829f609a65d26a98$export$682927c6ed76be02);
$parcel$export($829f609a65d26a98$exports, "DN80", ()=>$829f609a65d26a98$export$91fd9994c5be9757);
$parcel$export($829f609a65d26a98$exports, "DN70", ()=>$829f609a65d26a98$export$d281fbfe3cff2df6);
$parcel$export($829f609a65d26a98$exports, "DN60", ()=>$829f609a65d26a98$export$3902c91d8b98a753);
$parcel$export($829f609a65d26a98$exports, "DN50", ()=>$829f609a65d26a98$export$8e8133c1ba5845b5);
$parcel$export($829f609a65d26a98$exports, "DN40", ()=>$829f609a65d26a98$export$33ff357f6620b39);
$parcel$export($829f609a65d26a98$exports, "DN30", ()=>$829f609a65d26a98$export$633847cf062b69e0);
$parcel$export($829f609a65d26a98$exports, "DN20", ()=>$829f609a65d26a98$export$9776a6e503bdbf76);
$parcel$export($829f609a65d26a98$exports, "DN10", ()=>$829f609a65d26a98$export$6c813d5160dff5db);
$parcel$export($829f609a65d26a98$exports, "DN0", ()=>$829f609a65d26a98$export$3d4f271a500072a);
$parcel$export($829f609a65d26a98$exports, "DN800A", ()=>$829f609a65d26a98$export$fe151285c22759ec);
$parcel$export($829f609a65d26a98$exports, "DN700A", ()=>$829f609a65d26a98$export$a101c6190d0da34);
$parcel$export($829f609a65d26a98$exports, "DN600A", ()=>$829f609a65d26a98$export$4b16f52932fda51);
$parcel$export($829f609a65d26a98$exports, "DN500A", ()=>$829f609a65d26a98$export$a74bcd7b9845b0d8);
$parcel$export($829f609a65d26a98$exports, "DN400A", ()=>$829f609a65d26a98$export$9209c179316d1751);
$parcel$export($829f609a65d26a98$exports, "DN300A", ()=>$829f609a65d26a98$export$88f55133f636c8dd);
$parcel$export($829f609a65d26a98$exports, "DN200A", ()=>$829f609a65d26a98$export$51126f85d1009512);
$parcel$export($829f609a65d26a98$exports, "DN100A", ()=>$829f609a65d26a98$export$a069b547bd23af78);
$parcel$export($829f609a65d26a98$exports, "DN90A", ()=>$829f609a65d26a98$export$40cce05af3b2600a);
$parcel$export($829f609a65d26a98$exports, "DN80A", ()=>$829f609a65d26a98$export$b78942185925a0d);
$parcel$export($829f609a65d26a98$exports, "DN70A", ()=>$829f609a65d26a98$export$e058fb44b8eaafca);
$parcel$export($829f609a65d26a98$exports, "DN60A", ()=>$829f609a65d26a98$export$92b0b8de26920c18);
$parcel$export($829f609a65d26a98$exports, "DN50A", ()=>$829f609a65d26a98$export$67564f7459d3fc9e);
$parcel$export($829f609a65d26a98$exports, "DN40A", ()=>$829f609a65d26a98$export$77868e1ca884ffa3);
$parcel$export($829f609a65d26a98$exports, "DN30A", ()=>$829f609a65d26a98$export$2afd71d7d3ea2cd5);
$parcel$export($829f609a65d26a98$exports, "DN20A", ()=>$829f609a65d26a98$export$f2a0acaab9972c70);
$parcel$export($829f609a65d26a98$exports, "DN10A", ()=>$829f609a65d26a98$export$9ab70e67d6475361);
$parcel$export($829f609a65d26a98$exports, "T30", ()=>$829f609a65d26a98$export$d2adc5dedf09fced);
$parcel$export($829f609a65d26a98$exports, "L50", ()=>$829f609a65d26a98$export$f51762073d2bb381);
$parcel$export($829f609a65d26a98$exports, "L75", ()=>$829f609a65d26a98$export$95e26d54def96891);
const $829f609a65d26a98$export$4b84fd0e2c617bd = '#FFEBE6';
const $829f609a65d26a98$export$b34b069eff244586 = '#FFBDAD';
const $829f609a65d26a98$export$be802dd0d8b57f35 = '#FF8F73';
const $829f609a65d26a98$export$60847d42f9da92a6 = '#FF7452';
const $829f609a65d26a98$export$4a7404f376229999 = '#FF5630';
const $829f609a65d26a98$export$2010d0fb4295b346 = '#DE350B';
const $829f609a65d26a98$export$2837b5a1a71d5c02 = '#BF2600';
const $829f609a65d26a98$export$8d9596b529bbb9cf = '#FFFAE6';
const $829f609a65d26a98$export$41060a744ab0b7ae = '#FFF0B3';
const $829f609a65d26a98$export$1cc05bbbf340e559 = '#FFE380';
const $829f609a65d26a98$export$5aae31392d72caaa = '#FFC400';
const $829f609a65d26a98$export$c6930421db9fa514 = '#FFAB00';
const $829f609a65d26a98$export$59619663aa6500fb = '#FF991F';
const $829f609a65d26a98$export$874739ea9e379ab6 = '#FF8B00';
const $829f609a65d26a98$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $829f609a65d26a98$export$69a3bf21b9686c2b = '#ABF5D1';
const $829f609a65d26a98$export$afbce1382ec95f73 = '#79F2C0';
const $829f609a65d26a98$export$747d86715d4175de = '#57D9A3';
const $829f609a65d26a98$export$940e1f69e873f202 = '#36B37E';
const $829f609a65d26a98$export$a49394138f7b8e85 = '#00875A';
const $829f609a65d26a98$export$6fa04827ac68a4fb = '#006644';
const $829f609a65d26a98$export$226de0355ed012f8 = '#DEEBFF';
const $829f609a65d26a98$export$8c13c2ee36917869 = '#B3D4FF';
const $829f609a65d26a98$export$ecfc1dff386a3e7a = '#4C9AFF';
const $829f609a65d26a98$export$215b7063051591f1 = '#2684FF';
const $829f609a65d26a98$export$e62e8919cca44969 = '#0065FF';
const $829f609a65d26a98$export$b3de0ae08da2ce64 = '#0052CC';
const $829f609a65d26a98$export$a6ee3d71bc067634 = '#0747A6';
const $829f609a65d26a98$export$67f15409e87642a1 = '#669DF1';
const $829f609a65d26a98$export$f0539dbc42dbb067 = '#8FB8F6';
const $829f609a65d26a98$export$363e4475840015bb = '#EAE6FF';
const $829f609a65d26a98$export$4b0a4417ed59760f = '#C0B6F2';
const $829f609a65d26a98$export$6011520a64d9a187 = '#998DD9';
const $829f609a65d26a98$export$a7175d4e9206bc80 = '#8777D9';
const $829f609a65d26a98$export$b48405b95304b5a1 = '#6554C0';
const $829f609a65d26a98$export$c71e4279dd54a18d = '#5243AA';
const $829f609a65d26a98$export$147899de772240ec = '#403294';
const $829f609a65d26a98$export$2cf711fe14c66f06 = '#E6FCFF';
const $829f609a65d26a98$export$7a8f4d33f6f9772c = '#B3F5FF';
const $829f609a65d26a98$export$776c9c497ef08533 = '#79E2F2';
const $829f609a65d26a98$export$69cb3ca10c1e330e = '#00C7E6';
const $829f609a65d26a98$export$9dc1ef0f3f48059b = '#00B8D9';
const $829f609a65d26a98$export$7c835c78b6fcdef8 = '#00A3BF';
const $829f609a65d26a98$export$6036577f95c3877e = '#008DA6';
const $829f609a65d26a98$export$29a4f05edc054374 = '#FFFFFF';
const $829f609a65d26a98$export$e655ef011c4aa1a2 = '#FAFBFC';
const $829f609a65d26a98$export$9fdfb749e33cdf97 = '#F4F5F7';
const $829f609a65d26a98$export$3e51e8f1440314ba = '#EBECF0';
const $829f609a65d26a98$export$1ce2d1575d444ceb = '#DFE1E6';
const $829f609a65d26a98$export$8754fc7e6d8b3000 = '#C1C7D0';
const $829f609a65d26a98$export$c2e91cbeada39b8b = '#B3BAC5';
const $829f609a65d26a98$export$5f71e19f3a7ad9de = '#A5ADBA';
const $829f609a65d26a98$export$eaa8c8a70ac22806 = '#97A0AF';
const $829f609a65d26a98$export$7c87d337fb91a97d = '#8993A4';
const $829f609a65d26a98$export$d6447c357493214f = '#7A869A';
const $829f609a65d26a98$export$f563ee71e9ee74cd = '#6B778C';
const $829f609a65d26a98$export$e2ef2124cf4024b1 = '#5E6C84';
const $829f609a65d26a98$export$eece5f492e429f08 = '#505F79';
const $829f609a65d26a98$export$c39c0fe0f26207ae = '#42526E';
const $829f609a65d26a98$export$7090862dc3038a9f = '#344563';
const $829f609a65d26a98$export$ad0bacf983b7ddaa = '#253858';
const $829f609a65d26a98$export$7d61b15e0da132af = '#172B4D';
const $829f609a65d26a98$export$fbda843f0a27fe96 = '#091E42';
const $829f609a65d26a98$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $829f609a65d26a98$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $829f609a65d26a98$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $829f609a65d26a98$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $829f609a65d26a98$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $829f609a65d26a98$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $829f609a65d26a98$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $829f609a65d26a98$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $829f609a65d26a98$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $829f609a65d26a98$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $829f609a65d26a98$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $829f609a65d26a98$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $829f609a65d26a98$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $829f609a65d26a98$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $829f609a65d26a98$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $829f609a65d26a98$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $829f609a65d26a98$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $829f609a65d26a98$export$2f6319cf7d736c2a = '#E6EDFA';
const $829f609a65d26a98$export$95126bc8884d6634 = '#DCE5F5';
const $829f609a65d26a98$export$8338d8c35d44ff1 = '#CED9EB';
const $829f609a65d26a98$export$5368d76ae4fbbda7 = '#B8C7E0';
const $829f609a65d26a98$export$9f0a771d16ec8d36 = '#ABBBD6';
const $829f609a65d26a98$export$abcf8c38338b4aa5 = '#9FB0CC';
const $829f609a65d26a98$export$97e81faa16a182c7 = '#8C9CB8';
const $829f609a65d26a98$export$bfe21c59123ecf33 = '#7988A3';
const $829f609a65d26a98$export$ee82aa2ea6a1558 = '#67758F';
const $829f609a65d26a98$export$682927c6ed76be02 = '#56637A';
const $829f609a65d26a98$export$91fd9994c5be9757 = '#455166';
const $829f609a65d26a98$export$d281fbfe3cff2df6 = '#3B475C';
const $829f609a65d26a98$export$3902c91d8b98a753 = '#313D52';
const $829f609a65d26a98$export$8e8133c1ba5845b5 = '#283447';
const $829f609a65d26a98$export$33ff357f6620b39 = '#202B3D';
const $829f609a65d26a98$export$633847cf062b69e0 = '#1B2638';
const $829f609a65d26a98$export$9776a6e503bdbf76 = '#121A29';
const $829f609a65d26a98$export$6c813d5160dff5db = '#0E1624';
const $829f609a65d26a98$export$3d4f271a500072a = '#0D1424';
const $829f609a65d26a98$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $829f609a65d26a98$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $829f609a65d26a98$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $829f609a65d26a98$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $829f609a65d26a98$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $829f609a65d26a98$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $829f609a65d26a98$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $829f609a65d26a98$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $829f609a65d26a98$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $829f609a65d26a98$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $829f609a65d26a98$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $829f609a65d26a98$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $829f609a65d26a98$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $829f609a65d26a98$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $829f609a65d26a98$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $829f609a65d26a98$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $829f609a65d26a98$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
const $829f609a65d26a98$export$d2adc5dedf09fced = '#292A2E';
const $829f609a65d26a98$export$f51762073d2bb381 = '#94C748';
const $829f609a65d26a98$export$95e26d54def96891 = '#B3DF72';
parcelRegister("aOl2M", function(module, exports) {
    $parcel$export(module.exports, "ProfilePicture", ()=>$7e3ebb52190c5aa0$export$2d75367b6e042d67);
    var $f8Sb3;
    var $7FST0;
    var $ezSxh;
    function $7e3ebb52190c5aa0$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $7e3ebb52190c5aa0$var$imgStyles = {
        name: "1b6qxg",
        styles: "display:block;border-radius:50%"
    };
    const $7e3ebb52190c5aa0$export$2d75367b6e042d67 = ({ testId: testId, src: src, size: size, className: className })=>{
        const state = (0, (0, parcelRequire("ezSxh")).useImageState)(src || '');
        const displayImage = src && state === 'loaded';
        const displayFallback = src && state === 'error';
        const displaySkeleton = !displayImage && !displayFallback;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            "data-testid": testId,
            className: className,
            css: (0, (0, parcelRequire("f8Sb3")).css)({
                width: size,
                height: size,
                ...displaySkeleton && {
                    borderRadius: '50%',
                    backgroundColor: `var(--ds-background-neutral, ${0, $829f609a65d26a98$export$8d43898f60b96a82})`
                },
                '& svg, & img': {
                    width: size,
                    height: size
                }
            })
        }, displayImage && (0, (0, parcelRequire("f8Sb3")).jsx)("img", {
            "data-testid": testId && `${testId}--img`,
            src: src,
            css: $7e3ebb52190c5aa0$var$imgStyles
        }), displayFallback && (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("7FST0"))))), {
            spacing: "spacious",
            testId: testId && `${testId}--fallback`,
            label: "",
            color: `var(--ds-text-subtlest, ${(0, $829f609a65d26a98$export$7c87d337fb91a97d)})`,
            LEGACY_secondaryColor: `var(--ds-text-inverse, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`
        }));
    };
});
parcelRegister("ezSxh", function(module, exports) {
    $parcel$export(module.exports, "useImageState", ()=>$18b3dc2a6224905c$export$2c1df3428fc3264c);
    var $5uXOq = parcelRequire("5uXOq");
    const $18b3dc2a6224905c$export$2c1df3428fc3264c = (src)=>{
        const [state, setState] = (0, $5uXOq.useState)('pending');
        const imgRef = (0, $5uXOq.useRef)();
        (0, $5uXOq.useEffect)(()=>{
            if (!imgRef.current) {
                imgRef.current = new Image();
                imgRef.current.onload = ()=>setState('loaded');
                imgRef.current.onerror = ()=>setState('error');
            }
            setState('pending');
            imgRef.current.src = src;
        }, [
            src
        ]);
        return state;
    };
});
parcelRegister("9FNiA", function(module, exports) {
    $parcel$export(module.exports, "SkeletonText", ()=>$bc870af4b63b46f6$export$cb6ddd830302c2a8);
    var $bWGt6 = parcelRequire("bWGt6");
    const $bc870af4b63b46f6$export$cb6ddd830302c2a8 = (0, $bWGt6.default)("span", {
        target: "ej73sxo0"
    })({
        display: 'inline-block',
        height: '1em',
        borderRadius: '0.5em',
        backgroundColor: `var(--ds-background-neutral, ${(0, $829f609a65d26a98$export$8d43898f60b96a82)})`
    }, ({ length: length })=>({
            width: length
        }));
});
parcelRegister("chqbk", function(module, exports) {
    $parcel$export(module.exports, "ThemeSwitcher", ()=>$c95b2c70e6cea885$export$9d63163ee2173b37);
    var $5uXOq = parcelRequire("5uXOq");
    var $7VHMR;
    var $ousew;
    var $BLPHT;
    var $a5n5E;
    var $826f6;
    var $hWZau;
    var $ex8Nz;
    var $kJpBP;
    var $6Aw1W = parcelRequire("6Aw1W");
    var $aPrir = parcelRequire("aPrir");
    var $hk5bz = parcelRequire("hk5bz");
    var $bWGt6 = parcelRequire("bWGt6");
    function $c95b2c70e6cea885$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $c95b2c70e6cea885$export$9d63163ee2173b37 = ({ testId: testId, onThemeChange: onThemeChange, currentTheme: currentTheme })=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("BLPHT")).default), {
            testId: testId,
            placement: "auto-start",
            trigger: ({ triggerRef: triggerRef, ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kJpBP")).default), {
                    ref: triggerRef,
                    onClick: (event)=>event.stopPropagation(),
                    iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("826f6"))))), {
                        color: "currentColor",
                        label: "",
                        LEGACY_fallbackIcon: (0, (0, parcelRequire("ex8Nz")).default)
                    }),
                    iconAfter: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("hWZau"))))), {
                        color: "currentColor",
                        label: ""
                    }),
                    ...props
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), {
                    id: "identity.account-menu.theme-switcher.theme-button",
                    defaultMessage: "Theme",
                    description: "Label for button in the account menu to switch to a different theme"
                }))
        }, $c95b2c70e6cea885$var$themeOptions.map(({ label: label, value: value, thumbnail: thumbnail })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("a5n5E")).default), {
                testId: `${testId}--radio-${value}`,
                id: value,
                key: value,
                onClick: ()=>onThemeChange(value),
                isSelected: currentTheme === value
            }, (0, ($parcel$interopDefault($5uXOq))).createElement($c95b2c70e6cea885$var$RadioLabelContainer, null, (0, ($parcel$interopDefault($5uXOq))).createElement("img", {
                src: thumbnail,
                width: 64,
                height: 48,
                alt: ""
            }), label))));
    };
    const $c95b2c70e6cea885$var$RadioLabelContainer = (0, $bWGt6.default)("div", {
        target: "e1q43w0o0"
    })({
        name: "ql53ha",
        styles: "display:flex;align-items:center;gap:var(--ds-space-150, 12px)"
    });
    const $c95b2c70e6cea885$var$messages = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        light: {
            id: 'identity.account-menu.theme-switcher.light.option',
            defaultMessage: 'Light',
            description: 'Label for the theme switcher light option'
        },
        dark: {
            id: 'identity.account-menu.theme-switcher.dark.option',
            defaultMessage: 'Dark',
            description: 'Label for the theme switcher dark option'
        },
        matchBrowser: {
            id: 'identity.account-menu.theme-switcher.match-browser.option',
            defaultMessage: 'Match browser',
            description: 'Label for the theme switcher match browser option'
        }
    });
    const $c95b2c70e6cea885$var$themeOptions = [
        {
            label: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), $c95b2c70e6cea885$var$messages.light),
            value: 'light',
            thumbnail: (0, ($parcel$interopDefault($aPrir)))
        },
        {
            label: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), $c95b2c70e6cea885$var$messages.dark),
            value: 'dark',
            thumbnail: (0, ($parcel$interopDefault($6Aw1W)))
        },
        {
            label: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), $c95b2c70e6cea885$var$messages.matchBrowser),
            value: 'auto',
            thumbnail: (0, ($parcel$interopDefault($hk5bz)))
        }
    ];
});
parcelRegister("6Aw1W", function(module, exports) {
    module.exports = new URL("dark-mode.fd95cecc.svg", import.meta.url).toString();
});
parcelRegister("aPrir", function(module, exports) {
    module.exports = new URL("light-mode.9ae6186d.svg", import.meta.url).toString();
});
parcelRegister("hk5bz", function(module, exports) {
    module.exports = new URL("match-browser.defc82cb.svg", import.meta.url).toString();
});
parcelRegister("8NZjk", function(module, exports) {
    $parcel$export(module.exports, "AccountMenuIntlProvider", ()=>$ba982ee9af94b9bc$export$6c1f1571e3dd1b34);
    var $5uXOq = parcelRequire("5uXOq");
    var $i5FdW;
    var $koVbs;
    var $5ZCUE;
    const $ba982ee9af94b9bc$export$6c1f1571e3dd1b34 = ({ children: children })=>{
        const { locale: locale } = (0, (0, parcelRequire("koVbs")).default)();
        const messages = $ba982ee9af94b9bc$var$useMessages(locale);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("i5FdW")).default), {
            locale: locale,
            messages: messages
        }, children);
    };
    const $ba982ee9af94b9bc$var$useMessages = (locale)=>{
        const [messages, setMessages] = (0, $5uXOq.useState)();
        (0, $5uXOq.useEffect)(()=>{
            if (/^en(-US)?$/i.exec(locale)) setMessages(undefined);
            else {
                let cancelled = false;
                $ba982ee9af94b9bc$var$loadMessages(locale).catch((_error)=>undefined).then((messages)=>{
                    if (!cancelled) setMessages(messages);
                });
                return ()=>{
                    cancelled = true;
                };
            }
        }, [
            locale,
            setMessages
        ]);
        return messages;
    };
    const $ba982ee9af94b9bc$var$loadMessages = async (locale)=>{
        let [language, region = ''] = locale.split('-', 2);
        language = language.toLowerCase();
        region = region.toUpperCase();
        return (await ((0, (0, parcelRequire("5ZCUE")).default)[`${language}_${region}`] || (0, (0, parcelRequire("5ZCUE")).default)[language])?.())?.default;
    };
});
parcelRegister("5ZCUE", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7372768e0fc82eee$export$2e2bcd8739ae039);
    const $7372768e0fc82eee$var$lazyMessages = {
        cs: ()=>(parcelRequire("bxtQ1")),
        cs_CZ: ()=>(parcelRequire("3bKWf")),
        da: ()=>(parcelRequire("9Pmln")),
        da_DK: ()=>(parcelRequire("aEEaA")),
        de: ()=>(parcelRequire("hhLZu")),
        de_DE: ()=>(parcelRequire("9jZSH")),
        en_GB: ()=>(parcelRequire("f65rg")),
        en_ZZ: ()=>(parcelRequire("nyvP4")),
        es: ()=>(parcelRequire("k08Ug")),
        fi: ()=>(parcelRequire("1ZS5U")),
        fi_FI: ()=>(parcelRequire("4Kl9f")),
        fr: ()=>(parcelRequire("6Rvd6")),
        fr_FR: ()=>(parcelRequire("c1lxU")),
        hu: ()=>(parcelRequire("dLcCM")),
        hu_HU: ()=>(parcelRequire("6Ldnp")),
        it: ()=>(parcelRequire("5FmwZ")),
        it_IT: ()=>(parcelRequire("7aVGc")),
        ja: ()=>(parcelRequire("ksotD")),
        ja_JP: ()=>(parcelRequire("clrss")),
        ko: ()=>(parcelRequire("1DCRj")),
        ko_KR: ()=>(parcelRequire("cVp1h")),
        nb: ()=>(parcelRequire("9jfCG")),
        nb_NO: ()=>(parcelRequire("9t1Ya")),
        nl: ()=>(parcelRequire("Wp3MP")),
        nl_NL: ()=>(parcelRequire("av84K")),
        pl: ()=>(parcelRequire("auIal")),
        pl_PL: ()=>(parcelRequire("1Vy9d")),
        pt_BR: ()=>(parcelRequire("6yK6a")),
        ru: ()=>(parcelRequire("bgQW6")),
        ru_RU: ()=>(parcelRequire("cHxzG")),
        sv: ()=>(parcelRequire("gFUUu")),
        sv_SE: ()=>(parcelRequire("gtGaL")),
        th: ()=>(parcelRequire("j9guh")),
        th_TH: ()=>(parcelRequire("cJ0iL")),
        tr: ()=>(parcelRequire("8oADi")),
        tr_TR: ()=>(parcelRequire("d3wt1")),
        uk: ()=>(parcelRequire("708EE")),
        uk_UA: ()=>(parcelRequire("atYk5")),
        vi: ()=>(parcelRequire("7M7uE")),
        vi_VN: ()=>(parcelRequire("juYsG")),
        zh: ()=>(parcelRequire("TjGzl")),
        zh_CN: ()=>(parcelRequire("iBL22")),
        zh_TW: ()=>(parcelRequire("hYR8x"))
    };
    var $7372768e0fc82eee$export$2e2bcd8739ae039 = $7372768e0fc82eee$var$lazyMessages;
});
parcelRegister("bxtQ1", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("8T7VK").then(()=>parcelRequire('be02C'));
});
parcelRegister("3bKWf", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("7b5qs").then(()=>parcelRequire('fEJZa'));
});
parcelRegister("9Pmln", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("abDck").then(()=>parcelRequire('aOZ9H'));
});
parcelRegister("aEEaA", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("eUKfO").then(()=>parcelRequire('45iy5'));
});
parcelRegister("hhLZu", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("13VLx").then(()=>parcelRequire('bkd7P'));
});
parcelRegister("9jZSH", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("a8qvQ").then(()=>parcelRequire('9uLfO'));
});
parcelRegister("f65rg", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("jwEps").then(()=>parcelRequire('4deUn'));
});
parcelRegister("nyvP4", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("3yAcv").then(()=>parcelRequire('5hPMC'));
});
parcelRegister("k08Ug", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("lseqR").then(()=>parcelRequire('3Nhdd'));
});
parcelRegister("1ZS5U", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("5zEOA").then(()=>parcelRequire('dQ2b1'));
});
parcelRegister("4Kl9f", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("dTt25").then(()=>parcelRequire('8KVwU'));
});
parcelRegister("6Rvd6", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("8Qyrj").then(()=>parcelRequire('cJg6M'));
});
parcelRegister("c1lxU", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("1QYxo").then(()=>parcelRequire('7Cp6N'));
});
parcelRegister("dLcCM", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("8yW2Y").then(()=>parcelRequire('S4yUH'));
});
parcelRegister("6Ldnp", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("jaThx").then(()=>parcelRequire('7zGoD'));
});
parcelRegister("5FmwZ", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("8RnnA").then(()=>parcelRequire('5i7M2'));
});
parcelRegister("7aVGc", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("aWnGM").then(()=>parcelRequire('43bOU'));
});
parcelRegister("ksotD", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("j53ag").then(()=>parcelRequire('6xXDZ'));
});
parcelRegister("clrss", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("6YVJy").then(()=>parcelRequire('4k0qc'));
});
parcelRegister("1DCRj", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("1pLz5").then(()=>parcelRequire('hiq6X'));
});
parcelRegister("cVp1h", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("1748d").then(()=>parcelRequire('9iT7G'));
});
parcelRegister("9jfCG", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("fSO2i").then(()=>parcelRequire('ay7Tg'));
});
parcelRegister("9t1Ya", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("7BEEZ").then(()=>parcelRequire('emQME'));
});
parcelRegister("Wp3MP", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("19jzm").then(()=>parcelRequire('og1G8'));
});
parcelRegister("av84K", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("jn60K").then(()=>parcelRequire('blySf'));
});
parcelRegister("auIal", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("14Shs").then(()=>parcelRequire('az1yO'));
});
parcelRegister("1Vy9d", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("7BiYh").then(()=>parcelRequire('dH96e'));
});
parcelRegister("6yK6a", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("iJevj").then(()=>parcelRequire('ivYay'));
});
parcelRegister("bgQW6", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("k7wxq").then(()=>parcelRequire('82gce'));
});
parcelRegister("cHxzG", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("ii8Ar").then(()=>parcelRequire('jwhuy'));
});
parcelRegister("gFUUu", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("buOJ5").then(()=>parcelRequire('29C6m'));
});
parcelRegister("gtGaL", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("fH82G").then(()=>parcelRequire('9c5wb'));
});
parcelRegister("j9guh", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("aAqLX").then(()=>parcelRequire('coREq'));
});
parcelRegister("cJ0iL", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("hm3Yv").then(()=>parcelRequire('9ajce'));
});
parcelRegister("8oADi", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("9W2lm").then(()=>parcelRequire('4bIqg'));
});
parcelRegister("d3wt1", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("5fvIi").then(()=>parcelRequire('ggsS6'));
});
parcelRegister("708EE", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("driqQ").then(()=>parcelRequire('cupFd'));
});
parcelRegister("atYk5", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("luwXg").then(()=>parcelRequire('eMuwP'));
});
parcelRegister("7M7uE", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("8osZB").then(()=>parcelRequire('ij9vB'));
});
parcelRegister("juYsG", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("PkqaZ").then(()=>parcelRequire('huT3J'));
});
parcelRegister("TjGzl", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("flXjk").then(()=>parcelRequire('bcwNS'));
});
parcelRegister("iBL22", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("gp2vZ").then(()=>parcelRequire('aUjDR'));
});
parcelRegister("hYR8x", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("lA7Ru").then(()=>parcelRequire('ecDM5'));
});
parcelRegister("cvjqp", function(module, exports) {
    $parcel$export(module.exports, "AccountMenuLoggedOutState", ()=>$eaae2451158aa9d2$export$904b79312c8d6122);
    var $5uXOq = parcelRequire("5uXOq");
    var $ousew;
    var $8Pko5;
    var $pkYLA;
    var $71IBF;
    var $kHCo7;
    const $eaae2451158aa9d2$export$904b79312c8d6122 = ({ testId: testId, logInLink: logInLink })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8Pko5")).Profile), {
            testId: testId,
            href: logInLink,
            onClick: (event, analytics)=>{
                analytics.update({
                    actionSubjectId: 'logInLink'
                }).fire((0, (0, parcelRequire("kHCo7")).NAVIGATION_CHANNEL));
            },
            tooltip: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), {
                id: "identity.account-menu.account-menu-logged-out-state.log-in",
                defaultMessage: "Log in",
                description: "Tooltip for log in button when user is logged out"
            }),
            icon: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("pkYLA"))))), {
                color: "currentColor",
                label: "",
                LEGACY_size: "medium",
                LEGACY_fallbackIcon: (0, ($parcel$interopDefault((0, parcelRequire("71IBF")))))
            })
        });
});
parcelRegister("fnXLr", function(module, exports) {
    $parcel$export(module.exports, "AccountMenuPopup", ()=>$8d206fa9e8c3fd62$export$473cb05bf335b0e1);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $7VHMR;
    var $koVbs;
    var $c543i;
    var $8Pko5;
    var $7FST0;
    var $1I7E8;
    var $kHCo7;
    var $ezSxh;
    function $8d206fa9e8c3fd62$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $8d206fa9e8c3fd62$export$473cb05bf335b0e1 = ({ testId: testId, picture: picture, email: email, content: content })=>{
        const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
        const close = (0, (0, parcelRequire("c543i")).useCallbackWithAnalytics)(()=>setIsOpen(false), {
            eventType: (0, $676c5e519aa5ba55$export$a1562d08625f5d7e),
            action: 'closed',
            actionSubject: 'popup',
            actionSubjectId: 'accountMenu'
        }, (0, (0, parcelRequire("kHCo7")).NAVIGATION_CHANNEL));
        const open = (0, (0, parcelRequire("c543i")).useCallbackWithAnalytics)(()=>setIsOpen(true), {
            eventType: (0, $676c5e519aa5ba55$export$a1562d08625f5d7e),
            action: 'opened',
            actionSubject: 'popup',
            actionSubjectId: 'accountMenu'
        }, (0, (0, parcelRequire("kHCo7")).NAVIGATION_CHANNEL));
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("1I7E8")).default), {
            isOpen: isOpen,
            onClose: close,
            testId: testId,
            placement: "bottom",
            trigger: (triggerProps)=>(0, (0, parcelRequire("f8Sb3")).jsx)($8d206fa9e8c3fd62$var$AccountMenuTrigger, {
                    onClick: isOpen ? close : open,
                    testId: testId && `${testId}--trigger`,
                    picture: picture,
                    email: email,
                    ...triggerProps
                }),
            content: content
        });
    };
    const $8d206fa9e8c3fd62$var$imgStyles = {
        name: "qlds6h",
        styles: "border-radius:50%;width:var(--ds-space-300, 24px);height:var(--ds-space-300, 24px)"
    };
    const $8d206fa9e8c3fd62$var$AccountMenuTrigger = (0, ($parcel$interopDefault($5uXOq))).forwardRef(({ picture: picture, email: email, ...props }, ref)=>{
        const intl = (0, (0, parcelRequire("koVbs")).default)();
        const state = (0, (0, parcelRequire("ezSxh")).useImageState)(picture || '');
        const tooltip = intl.formatMessage($8d206fa9e8c3fd62$var$messages.triggerTooltip);
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("8Pko5")).Profile), {
            ...props,
            ref: ref,
            tooltip: email || tooltip,
            icon: picture && state === 'loaded' ? (0, (0, parcelRequire("f8Sb3")).jsx)("img", {
                css: $8d206fa9e8c3fd62$var$imgStyles,
                src: picture,
                alt: tooltip
            }) : (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("7FST0"))))), {
                color: "currentColor",
                label: tooltip,
                LEGACY_size: "medium",
                spacing: "spacious"
            })
        });
    });
    const $8d206fa9e8c3fd62$var$messages = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        triggerTooltip: {
            id: 'identity.account-menu.account-menu-popup.skeleton.tooltip',
            defaultMessage: 'Account',
            description: 'Tooltip and alt-text for the account menu item'
        }
    });
});
parcelRegister("DEWI6", function(module, exports) {
    $parcel$export(module.exports, "cx", ()=>$077367a4d5677cd3$export$a274e22fb40f762e);
    var $bwpsq;
    const $077367a4d5677cd3$export$a274e22fb40f762e = (...styles)=>{
        const actualStyles = styles;
        return (0, (0, parcelRequire("bwpsq")).default)(actualStyles);
    };
});
parcelRegister("6Csk1", function(module, exports) {
    var $hsOo6 = parcelRequire("hsOo6");
    var $4NkAS = parcelRequire("4NkAS");
    var $9MM2g = parcelRequire("9MM2g");
    var $hTJwX = parcelRequire("hTJwX");
    var $evszO = parcelRequire("evszO");
    var $66FNL = parcelRequire("66FNL");
    var $4d1c42d4f14298ee$var$objectProto = Object.prototype;
    var $4d1c42d4f14298ee$var$hasOwnProperty = $4d1c42d4f14298ee$var$objectProto.hasOwnProperty;
    var $4d1c42d4f14298ee$var$assign = $9MM2g(function(object, source) {
        if ($evszO(source) || $hTJwX(source)) {
            $4NkAS(source, $66FNL(source), object);
            return;
        }
        for(var key in source)if ($4d1c42d4f14298ee$var$hasOwnProperty.call(source, key)) $hsOo6(object, key, source[key]);
    });
    module.exports = $4d1c42d4f14298ee$var$assign;
});
parcelRegister("jFnH8", function(module, exports) {
    $parcel$export(module.exports, "Behaviours", ()=>(parcelRequire("cJg0i")).Behaviours);
    $parcel$export(module.exports, "TargetTabs", ()=>(parcelRequire("cJg0i")).TargetTabs);
    $parcel$export(module.exports, "Prompts", ()=>(parcelRequire("cJg0i")).Prompts);
    $parcel$export(module.exports, "createProvisioningPageExtensions", ()=>(parcelRequire("gP7sO")).createProvisioningPageExtensions);
    $parcel$export(module.exports, "createProvisioningApiExtensions", ()=>(parcelRequire("jiQLJ")).createProvisioningApiExtensions);
    $parcel$export(module.exports, "createRecommendationContextExtensions", ()=>(parcelRequire("bG1bs")).createRecommendationContextExtensions);
    var $cJg0i = parcelRequire("cJg0i");
    var $b1Kvi = parcelRequire("b1Kvi");
    var $fh3Yg = parcelRequire("fh3Yg");
    var $jaORC = parcelRequire("jaORC");
    var $gP7sO = parcelRequire("gP7sO");
    var $jiQLJ = parcelRequire("jiQLJ");
    var $bG1bs = parcelRequire("bG1bs");
    var $9xYqG = parcelRequire("9xYqG");
});
parcelRegister("cJg0i", function(module, exports) {
    $parcel$export(module.exports, "Behaviours", ()=>$5fe0e6234d117982$export$993d0f36af4bf76f);
    $parcel$export(module.exports, "TargetTabs", ()=>$5fe0e6234d117982$export$c57f0d43fd595f43);
    $parcel$export(module.exports, "Prompts", ()=>$5fe0e6234d117982$export$d1609d6291f3d60d);
    const $5fe0e6234d117982$export$696c71818ae3f184 = {
        FREE: 'free',
        STANDARD: 'standard',
        PREMIUM: 'premium',
        ESSENTIALS: 'essentials',
        ENTERPRISE: 'enterprise'
    };
    const $5fe0e6234d117982$export$993d0f36af4bf76f = {
        LAND: 'land',
        CLOSE: 'close'
    };
    const $5fe0e6234d117982$export$c57f0d43fd595f43 = {
        SAME: 'same',
        NEW: 'new'
    };
    const $5fe0e6234d117982$export$d1609d6291f3d60d = {
        NEXT: 'next',
        CLOSE: 'close',
        GO_TO_PRODUCT: 'go-to-product',
        RETURN_TO_PRODUCT: 'return-to-product'
    };
});
parcelRegister("b1Kvi", function(module, exports) {
    var $9xYqG = parcelRequire("9xYqG");
    var $cJg0i = parcelRequire("cJg0i");
    const $ad4411e35d2d8c65$export$196a138f6d49c2bb = [
        'edition'
    ];
    const $ad4411e35d2d8c65$export$28c762e8047316d8 = (0, $9xYqG.createProductExtensions)($ad4411e35d2d8c65$export$196a138f6d49c2bb);
});
parcelRegister("9xYqG", function(module, exports) {
    $parcel$export(module.exports, "createProductExtensions", ()=>$7b705e4156365c5d$export$42e62ee12e8ced48);
    parcelRequire("jWY5k");
    var $a0mnO = parcelRequire("a0mnO");
    const $7b705e4156365c5d$export$9143c254bff9f7b7 = (object, propertyNames)=>propertyNames.reduce((accumulator, property)=>{
            const value = object[property];
            if (value !== undefined) accumulator[property] = value;
            return accumulator;
        }, {});
    const $7b705e4156365c5d$export$42e62ee12e8ced48 = (extensionsWhitelist)=>(options)=>{
            const filteredOptions = $7b705e4156365c5d$export$9143c254bff9f7b7(options, extensionsWhitelist);
            return new (0, $a0mnO.CrossFlowExtensions)(filteredOptions);
        };
    const $7b705e4156365c5d$export$86a865d89ef3c690 = (...extensions)=>{
        const combinedOptions = Object.assign({}, ...extensions);
        return new (0, $a0mnO.CrossFlowExtensions)(combinedOptions);
    };
});
parcelRegister("jWY5k", function(module, exports) {
    $parcel$export(module.exports, "CrossFlowExtensions", ()=>(parcelRequire("a0mnO")).CrossFlowExtensions);
    $parcel$export(module.exports, "Targets", ()=>(parcelRequire("eGnH0")).Targets);
    var $a0mnO = parcelRequire("a0mnO");
    var $eGnH0 = parcelRequire("eGnH0");
});
parcelRegister("a0mnO", function(module, exports) {
    $parcel$export(module.exports, "CrossFlowExtensions", ()=>$4d8edd1cb612639e$export$a5e53d1dcbd6eb61);
    class $4d8edd1cb612639e$export$a5e53d1dcbd6eb61 {
        constructor(options){
            Object.assign(this, options);
            Object.freeze(this);
        }
    }
});
parcelRegister("eGnH0", function(module, exports) {
    $parcel$export(module.exports, "Targets", ()=>$f1c0dfa9569fbb1b$export$59a8eb9cff113544);
    const $f1c0dfa9569fbb1b$export$59a8eb9cff113544 = {
        CONFLUENCE: 'confluence.ondemand',
        JIRA_CORE: 'jira-core.ondemand',
        JIRA_SERVICE_DESK: 'jira-servicedesk.ondemand',
        JIRA_SOFTWARE: 'jira-software.ondemand',
        JIRA_PRODUCT_DISCOVERY: 'jira-product-discovery',
        BITBUCKET: 'bitbucket.ondemand',
        TRELLO: 'trello',
        OPSGENIE: 'opsgenie',
        STATUSPAGE: 'statuspage',
        TEAM_CENTRAL: 'townsquare',
        ATLAS: 'townsquare',
        AVOCADO: 'avocado',
        ANALYTICS: 'atlassian-analytics-free',
        COMPASS: 'compass',
        LOOM: 'loom',
        ROVO: 'rovo.ondemand'
    };
});
parcelRegister("fh3Yg", function(module, exports) {
    var $9xYqG = parcelRequire("9xYqG");
    var $cJg0i = parcelRequire("cJg0i");
    const $353da589146b832d$export$390f3b1f433f2095 = [
        'edition',
        'migrationSourceUuid',
        'grantAccessTo'
    ];
    const $353da589146b832d$export$386012fe624cad4 = (0, $9xYqG.createProductExtensions)($353da589146b832d$export$390f3b1f433f2095);
});
parcelRegister("jaORC", function(module, exports) {
    var $9xYqG = parcelRequire("9xYqG");
    var $cJg0i = parcelRequire("cJg0i");
    const $638bae63202e03ae$export$c41268b4369999ed = [
        'edition',
        'migrationSourceUuid'
    ];
    const $638bae63202e03ae$export$a60e4abab2cc3b2b = (0, $9xYqG.createProductExtensions)($638bae63202e03ae$export$c41268b4369999ed);
});
parcelRegister("gP7sO", function(module, exports) {
    $parcel$export(module.exports, "createProvisioningPageExtensions", ()=>$57002cfa239290dc$export$f05508383d0ca130);
    var $9xYqG = parcelRequire("9xYqG");
    const $57002cfa239290dc$export$99f81e179e225ceb = [
        'provisioningPageOptions'
    ];
    const $57002cfa239290dc$export$f05508383d0ca130 = (options)=>(0, $9xYqG.createProductExtensions)($57002cfa239290dc$export$99f81e179e225ceb)({
            provisioningPageOptions: options
        });
});
parcelRegister("jiQLJ", function(module, exports) {
    $parcel$export(module.exports, "createProvisioningApiExtensions", ()=>$8f278686bdd56b47$export$530ae557c94159b9);
    var $9xYqG = parcelRequire("9xYqG");
    const $8f278686bdd56b47$export$bba48927994d7f26 = [
        'provisioningApiParams'
    ];
    const $8f278686bdd56b47$export$530ae557c94159b9 = (options)=>(0, $9xYqG.createProductExtensions)($8f278686bdd56b47$export$bba48927994d7f26)({
            provisioningApiParams: options
        });
});
parcelRegister("bG1bs", function(module, exports) {
    $parcel$export(module.exports, "createRecommendationContextExtensions", ()=>$e4df05e4385e1ca7$export$d1baeed0bd0517aa);
    var $9xYqG = parcelRequire("9xYqG");
    const $e4df05e4385e1ca7$export$4227e3a27cbd377 = [
        'recommendationContext'
    ];
    const $e4df05e4385e1ca7$export$d1baeed0bd0517aa = (options)=>(0, $9xYqG.createProductExtensions)($e4df05e4385e1ca7$export$4227e3a27cbd377)({
            recommendationContext: options
        });
});
parcelRegister("941eD", function(module, exports) {
    $parcel$export(module.exports, "useCrossFlow", ()=>(parcelRequire("7wLxr")).useCrossFlow);
    $parcel$export(module.exports, "withCrossFlow", ()=>(parcelRequire("7wLxr")).withCrossFlow);
    $parcel$export(module.exports, "Journeys", ()=>(parcelRequire("lEtNM")).Journeys);
    $parcel$export(module.exports, "Targets", ()=>(parcelRequire("eGnH0")).Targets);
    parcelRequire("bHpB9");
    var $lEtNM = parcelRequire("lEtNM");
    var $7wLxr = parcelRequire("7wLxr");
    parcelRequire("jWY5k");
    var $eGnH0 = parcelRequire("eGnH0");
    var $4iwBY = parcelRequire("4iwBY");
});
parcelRegister("bHpB9", function(module, exports) {
    $parcel$export(module.exports, "BaseCrossFlowApiProvider", ()=>(parcelRequire("7wLxr")).BaseCrossFlowApiProvider);
    $parcel$export(module.exports, "useCrossFlow", ()=>(parcelRequire("7wLxr")).useCrossFlow);
    $parcel$export(module.exports, "withCrossFlow", ()=>(parcelRequire("7wLxr")).withCrossFlow);
    $parcel$export(module.exports, "Journeys", ()=>(parcelRequire("lEtNM")).Journeys);
    $parcel$export(module.exports, "Reasons", ()=>(parcelRequire("lEtNM")).Reasons);
    var $7wLxr = parcelRequire("7wLxr");
    var $lEtNM = parcelRequire("lEtNM");
});
parcelRegister("7wLxr", function(module, exports) {
    $parcel$export(module.exports, "BaseCrossFlowApiProvider", ()=>$df7415e1fd91aa6d$export$c0ddec072762f62a);
    $parcel$export(module.exports, "useCrossFlow", ()=>$df7415e1fd91aa6d$export$6e7a10fe635a0dfc);
    $parcel$export(module.exports, "withCrossFlow", ()=>$df7415e1fd91aa6d$export$655b6c19a0daddb8);
    var $5uXOq = parcelRequire("5uXOq");
    var $aMvxT = parcelRequire("aMvxT");
    var $lEtNM = parcelRequire("lEtNM");
    const $df7415e1fd91aa6d$var$LATEST_VERSION = (0, $aMvxT.VERSION);
    const $df7415e1fd91aa6d$var$CrossFlowContext = (0, $5uXOq.createContext)(()=>({
            isEnabled: false,
            reason: (0, $lEtNM.Reasons).NO_PROVIDER
        }));
    const $df7415e1fd91aa6d$export$59ce2d27e6cd8c9 = (onOpen)=>(version)=>{
            switch(version){
                case 0, $aMvxT.VERSION:
                    return {
                        isEnabled: true,
                        api: (0, $aMvxT.createAPIv0)(onOpen)
                    };
                default:
                    return {
                        isEnabled: false,
                        reason: (0, $lEtNM.Reasons).NO_API_SUPPORT
                    };
            }
        };
    const $df7415e1fd91aa6d$export$c0ddec072762f62a = ({ onOpen: onOpen, children: children })=>{
        const negotiateApi = (0, $5uXOq.useMemo)(()=>$df7415e1fd91aa6d$export$59ce2d27e6cd8c9(onOpen), [
            onOpen
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($df7415e1fd91aa6d$var$CrossFlowContext.Provider, {
            value: negotiateApi
        }, children);
    };
    const $df7415e1fd91aa6d$export$6e7a10fe635a0dfc = ()=>{
        const negotiateApi = (0, $5uXOq.useContext)($df7415e1fd91aa6d$var$CrossFlowContext);
        return (0, $5uXOq.useMemo)(()=>negotiateApi($df7415e1fd91aa6d$var$LATEST_VERSION), [
            negotiateApi
        ]);
    };
    function $df7415e1fd91aa6d$export$655b6c19a0daddb8(WrappedComponent) {
        const ComponentWithCrossFlow = (props)=>{
            const crossFlow = $df7415e1fd91aa6d$export$6e7a10fe635a0dfc();
            return (0, ($parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
                ...props,
                crossFlow: crossFlow
            });
        };
        ComponentWithCrossFlow.displayName = `withCrossFlow(${WrappedComponent.displayName || WrappedComponent.name || 'Component'})`;
        return ComponentWithCrossFlow;
    }
});
parcelRegister("aMvxT", function(module, exports) {
    $parcel$export(module.exports, "VERSION", ()=>$626f88795be3264e$export$a4ad2735b021c132);
    $parcel$export(module.exports, "createAPIv0", ()=>$626f88795be3264e$export$9ff7368ac93fcf2d);
    const $626f88795be3264e$export$a4ad2735b021c132 = 0;
    const $626f88795be3264e$export$9ff7368ac93fcf2d = (onOpen)=>({
            open (options) {
                return onOpen(options);
            }
        });
});
parcelRegister("lEtNM", function(module, exports) {
    $parcel$export(module.exports, "Journeys", ()=>$19f792998fd3f757$export$3411873bfd520bb6);
    $parcel$export(module.exports, "Reasons", ()=>$19f792998fd3f757$export$da2d4f2f250d6f84);
    const $19f792998fd3f757$export$3411873bfd520bb6 = {
        GET_STARTED: 'get-started',
        DECIDE: 'decide',
        DISCOVER: 'discover'
    };
    const $19f792998fd3f757$export$da2d4f2f250d6f84 = {
        NO_API_SUPPORT: 'Could not provide requested API version',
        NO_PROVIDER: 'Provider not found'
    };
});
parcelRegister("4iwBY", function(module, exports) {
    var $5uXOq = parcelRequire("5uXOq");
    parcelRequire("bHpB9");
    var $7wLxr = parcelRequire("7wLxr");
    const $748a6f8c19f20150$export$bb23a1e8e036feea = (props)=>{
        const propsRef = (0, $5uXOq.useRef)(props);
        const crossFlowRef = (0, $5uXOq.useRef)((0, $7wLxr.useCrossFlow)());
        (0, $5uXOq.useEffect)(()=>{
            const crossFlow = crossFlowRef.current;
            (async ()=>{
                const { onComplete: onComplete, onError: onError, ...options } = propsRef.current;
                if (crossFlow.isEnabled) try {
                    const status = await crossFlow.api.open(options);
                    onComplete?.(status);
                } catch (err) {
                    onError?.(err);
                }
            })();
        }, []);
        return null;
    };
});
parcelRegister("cmVQ7", function(module, exports) {
    $parcel$export(module.exports, "useFireCrossFlowAnalyticsEvents", ()=>$b1a1530bf65c0c61$export$c2095165ae2bdcda);
    var $5uXOq = parcelRequire("5uXOq");
    var $2NMNM;
    var $iDfVE;
    var $jAXLO;
    function $b1a1530bf65c0c61$export$c2095165ae2bdcda() {
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const firedViewedScreenEventName = (0, $5uXOq.useRef)();
        const firedViewedUIEventId = (0, $5uXOq.useRef)();
        const mapToCcpProductKeys = (0, $5uXOq.useCallback)((recommendedProductIds, targetProductId)=>{
            const ccpProductIds = recommendedProductIds.reduce((acc, curr)=>{
                acc.push((0, (0, parcelRequire("iDfVE")).SURFACE_ANALYTICS_PRODUCT_MAP).products[curr] ?? curr);
                return acc;
            }, []);
            const ccpTargetProductId = targetProductId && (0, (0, parcelRequire("iDfVE")).SURFACE_ANALYTICS_PRODUCT_MAP).products[targetProductId];
            return {
                recommendedProductIds: ccpProductIds,
                targetProductId: ccpTargetProductId ?? targetProductId
            };
        }, []);
        const fireViewedScreenEvent = (0, $5uXOq.useCallback)((name, commonAttributes, attributes)=>{
            if (firedViewedScreenEventName.current === name) return;
            const { recommendedProductIds: recommendedProductIds, ...rest } = commonAttributes;
            const { recommendedProductIds: ccpProductIds } = mapToCcpProductKeys(recommendedProductIds);
            createAnalyticsEvent({
                eventType: (0, (0, parcelRequire("jAXLO")).eventTypes).SCREEN,
                name: name,
                attributes: {
                    recommendedProductIds: ccpProductIds,
                    ...rest,
                    ...attributes
                }
            }).fire((0, (0, parcelRequire("jAXLO")).CROSS_FLOW_CHANNEL));
            firedViewedScreenEventName.current = name;
        }, [
            createAnalyticsEvent,
            mapToCcpProductKeys
        ]);
        const fireViewedUIEvent = (0, $5uXOq.useCallback)((event, commonAttributes, attributes)=>{
            if (firedViewedUIEventId.current === event.actionSubjectId) return;
            const { source: source, recommendedProductIds: recommendedProductIds, ...rest } = commonAttributes;
            const { recommendedProductIds: ccpProductIds } = mapToCcpProductKeys(recommendedProductIds);
            createAnalyticsEvent({
                eventType: (0, (0, parcelRequire("jAXLO")).eventTypes).UI,
                ...event,
                source: source,
                attributes: {
                    recommendedProductIds: ccpProductIds,
                    ...rest,
                    ...attributes
                }
            }).fire((0, (0, parcelRequire("jAXLO")).CROSS_FLOW_CHANNEL));
            firedViewedUIEventId.current = event.actionSubjectId;
        }, [
            createAnalyticsEvent,
            mapToCcpProductKeys
        ]);
        const fireInteractedUIEvent = (0, $5uXOq.useCallback)((event, commonAttributes, attributes)=>{
            const { source: source, recommendedProductIds: recommendedProductIds, targetProductId: targetProductId, ...rest } = commonAttributes;
            const { recommendedProductIds: ccpProductIds, targetProductId: ccpTargetProductId } = mapToCcpProductKeys(recommendedProductIds ?? [], targetProductId);
            createAnalyticsEvent({
                eventType: (0, (0, parcelRequire("jAXLO")).eventTypes).UI,
                ...event,
                source: source,
                attributes: {
                    recommendedProductIds: ccpProductIds,
                    targetProductId: ccpTargetProductId,
                    ...rest,
                    ...attributes
                }
            }).fire((0, (0, parcelRequire("jAXLO")).CROSS_FLOW_CHANNEL));
        }, [
            createAnalyticsEvent,
            mapToCcpProductKeys
        ]);
        return {
            fireViewedScreenEvent: fireViewedScreenEvent,
            fireViewedUIEvent: fireViewedUIEvent,
            fireInteractedUIEvent: fireInteractedUIEvent
        };
    }
});
parcelRegister("iDfVE", function(module, exports) {
    $parcel$export(module.exports, "FIRST_PARTY_CCP_PRODUCT_IDS", ()=>$b9514a810cbf7271$export$6c053e1694ef181c);
    $parcel$export(module.exports, "SURFACE_ANALYTICS_PRODUCT_MAP", ()=>$b9514a810cbf7271$export$54e3fc09a2a3347a);
    const $b9514a810cbf7271$export$31048cb2a0753b12 = {
        jira_software_cloud: 'd8a847a4-cde4-4c50-8ea1-dc3d4193214f',
        jira_work_management_cloud: '46ccaa9e-cdb0-4995-8886-5827a5ff162b',
        jira_service_management_cloud: 'de63a248-1f93-46ed-b6ea-ab8e38af1c88',
        jira_product_discovery: 'a6f908c8-709c-45f4-9e2d-eca25b93b94a',
        confluence_cloud: '6aab3f4e-cc71-474d-8d28-abef8b057808',
        opsgenie: 'fdb4649d-ca4d-49f8-a8bf-ffa558a65551'
    };
    const $b9514a810cbf7271$export$9d8f18312db80469 = {
        jira_software_cloud: 'd8a847a4-cde4-4c50-8ea1-dc3d4193214f',
        jira_work_management_cloud: '46ccaa9e-cdb0-4995-8886-5827a5ff162b',
        jira_service_management_cloud: 'de63a248-1f93-46ed-b6ea-ab8e38af1c88',
        jira_product_discovery: 'a6f908c8-709c-45f4-9e2d-eca25b93b94a',
        confluence_cloud: '6aab3f4e-cc71-474d-8d28-abef8b057808',
        opsgenie: 'fdb4649d-ca4d-49f8-a8bf-ffa558a65551'
    };
    const $b9514a810cbf7271$export$6c053e1694ef181c = {
        prod: $b9514a810cbf7271$export$31048cb2a0753b12,
        staging: $b9514a810cbf7271$export$9d8f18312db80469
    };
    const $b9514a810cbf7271$export$54e3fc09a2a3347a = {
        products: {
            'confluence.ondemand': '6aab3f4e-cc71-474d-8d28-abef8b057808',
            'jira-software.ondemand': 'd8a847a4-cde4-4c50-8ea1-dc3d4193214f',
            'jira-servicedesk.ondemand': 'de63a248-1f93-46ed-b6ea-ab8e38af1c88',
            'jira-core.ondemand': '46ccaa9e-cdb0-4995-8886-5827a5ff162b',
            opsgenie: 'fdb4649d-ca4d-49f8-a8bf-ffa558a65551',
            statuspage: '0b8ea1e2-52df-11ea-8d77-2e728ce88125',
            townsquare: '7c917705-866d-4b6b-b266-0fc7633e8342',
            compass: '6bce2ccb-4f57-46f5-812a-9dbf02dc28f2',
            'jira-product-discovery': 'a6f908c8-709c-45f4-9e2d-eca25b93b94a',
            beacon: '0a0a31b0-3f5f-4693-b231-9a753bee012e',
            'atlassian-analytics-free': 'f44da23e-5907-4d81-8a78-33bedee10969',
            mercury: 'd16a2ba8-445f-4e83-9c7b-9bcf349ff905'
        }
    };
});
parcelRegister("jAXLO", function(module, exports) {
    $parcel$export(module.exports, "CROSS_FLOW_CHANNEL", ()=>$dc2b00b588a8d355$export$c536a7e29a0739b8);
    $parcel$export(module.exports, "eventTypes", ()=>$dc2b00b588a8d355$export$285f3d0989f9023f);
    const $dc2b00b588a8d355$export$c536a7e29a0739b8 = 'crossFlow';
    var $dc2b00b588a8d355$export$285f3d0989f9023f;
    (function(eventTypes) {
        eventTypes["UI"] = "ui";
        eventTypes["SCREEN"] = "screen";
    })($dc2b00b588a8d355$export$285f3d0989f9023f || ($dc2b00b588a8d355$export$285f3d0989f9023f = {}));
});
parcelRegister("s7Ri8", function(module, exports) {
    var $ck5fJ = parcelRequire("ck5fJ");
    var $a1YLW = parcelRequire("a1YLW");
    var $8LQ84 = parcelRequire("8LQ84");
    function $0548b62ea127d690$var$shuffle(collection) {
        var func = $8LQ84(collection) ? $ck5fJ : $a1YLW;
        return func(collection);
    }
    module.exports = $0548b62ea127d690$var$shuffle;
});
parcelRegister("ck5fJ", function(module, exports) {
    var $jHlUS = parcelRequire("jHlUS");
    var $ifvdh = parcelRequire("ifvdh");
    function $8f8b6d61b1553b58$var$arrayShuffle(array) {
        return $ifvdh($jHlUS(array));
    }
    module.exports = $8f8b6d61b1553b58$var$arrayShuffle;
});
parcelRegister("ifvdh", function(module, exports) {
    var $diicZ = parcelRequire("diicZ");
    function $d491d6fac47da618$var$shuffleSelf(array, size) {
        var index = -1, length = array.length, lastIndex = length - 1;
        size = size === undefined ? length : size;
        while(++index < size){
            var rand = $diicZ(index, lastIndex), value = array[rand];
            array[rand] = array[index];
            array[index] = value;
        }
        array.length = size;
        return array;
    }
    module.exports = $d491d6fac47da618$var$shuffleSelf;
});
parcelRegister("diicZ", function(module, exports) {
    var $9adb14a65c3f9737$var$nativeFloor = Math.floor, $9adb14a65c3f9737$var$nativeRandom = Math.random;
    function $9adb14a65c3f9737$var$baseRandom(lower, upper) {
        return lower + $9adb14a65c3f9737$var$nativeFloor($9adb14a65c3f9737$var$nativeRandom() * (upper - lower + 1));
    }
    module.exports = $9adb14a65c3f9737$var$baseRandom;
});
parcelRegister("a1YLW", function(module, exports) {
    var $ifvdh = parcelRequire("ifvdh");
    var $dMEgP = parcelRequire("dMEgP");
    function $74d923783422b512$var$baseShuffle(collection) {
        return $ifvdh($dMEgP(collection));
    }
    module.exports = $74d923783422b512$var$baseShuffle;
});
parcelRegister("bHDKL", function(module, exports) {
    $parcel$export(module.exports, "ARTICLE_TYPE", ()=>$d93cba26535df61b$export$a72bfd9b1e5592c8);
    var $d93cba26535df61b$export$a72bfd9b1e5592c8;
    (function(ARTICLE_TYPE) {
        ARTICLE_TYPE["HELP_ARTICLE"] = "HELP_ARTICLE";
        ARTICLE_TYPE["WHATS_NEW"] = "WHATS_NEW";
    })($d93cba26535df61b$export$a72bfd9b1e5592c8 || ($d93cba26535df61b$export$a72bfd9b1e5592c8 = {}));
});
parcelRegister("c74za", function(module, exports) {
    var $dgvY6 = parcelRequire("dgvY6");
    var $8d19ae39f7480d44$var$Global = $dgvY6.Global;
    module.exports = {
        name: 'sessionStorage',
        read: $8d19ae39f7480d44$var$read,
        write: $8d19ae39f7480d44$var$write,
        each: $8d19ae39f7480d44$var$each,
        remove: $8d19ae39f7480d44$var$remove,
        clearAll: $8d19ae39f7480d44$var$clearAll
    };
    function $8d19ae39f7480d44$var$sessionStorage() {
        return $8d19ae39f7480d44$var$Global.sessionStorage;
    }
    function $8d19ae39f7480d44$var$read(key) {
        return $8d19ae39f7480d44$var$sessionStorage().getItem(key);
    }
    function $8d19ae39f7480d44$var$write(key, data) {
        return $8d19ae39f7480d44$var$sessionStorage().setItem(key, data);
    }
    function $8d19ae39f7480d44$var$each(fn) {
        for(var i = $8d19ae39f7480d44$var$sessionStorage().length - 1; i >= 0; i--){
            var key = $8d19ae39f7480d44$var$sessionStorage().key(i);
            fn($8d19ae39f7480d44$var$read(key), key);
        }
    }
    function $8d19ae39f7480d44$var$remove(key) {
        return $8d19ae39f7480d44$var$sessionStorage().removeItem(key);
    }
    function $8d19ae39f7480d44$var$clearAll() {
        return $8d19ae39f7480d44$var$sessionStorage().clear();
    }
});
parcelRegister("6eBRn", function(module, exports) {
    function $48a16b14c2519b21$var$fromPairs(pairs) {
        var index = -1, length = pairs == null ? 0 : pairs.length, result = {};
        while(++index < length){
            var pair = pairs[index];
            result[pair[0]] = pair[1];
        }
        return result;
    }
    module.exports = $48a16b14c2519b21$var$fromPairs;
});
parcelRegister("1vIa3", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e074ad31022f2fed$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $iKEpC;
    const $e074ad31022f2fed$var$CommerceExperience = ({ url: url, onComplete: onComplete, onError: onError, configuration: configuration })=>{
        const containerRef = (0, $5uXOq.useRef)(null);
        const commerceExperienceIframe = (0, $5uXOq.useRef)(null);
        const stringifiedConfiguration = JSON.stringify(configuration || {});
        (0, $5uXOq.useEffect)(()=>{
            if (containerRef.current) {
                commerceExperienceIframe.current = new (0, (0, parcelRequire("iKEpC")).CommerceExperience)(url, {
                    container: containerRef.current,
                    onComplete: onComplete,
                    onError: onError,
                    configuration: JSON.parse(stringifiedConfiguration)
                });
                commerceExperienceIframe.current?.init();
            }
            return ()=>{
                commerceExperienceIframe.current?.cleanup();
            };
        }, [
            url,
            onComplete,
            onError,
            stringifiedConfiguration
        ]);
        return ((0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            ref: containerRef,
            style: {
                height: '100%',
                width: '100%',
                overflow: 'hidden'
            }
        }));
    };
    var $e074ad31022f2fed$export$2e2bcd8739ae039 = $e074ad31022f2fed$var$CommerceExperience;
});
parcelRegister("iKEpC", function(module, exports) {
    $parcel$export(module.exports, "CommerceExperience", ()=>$ef63dc43daf1f828$export$65c1176b77c6ad31);
    var $ilQ8p;
    class $ef63dc43daf1f828$export$65c1176b77c6ad31 {
        constructor(url, options){
            this.options = options;
            this.iframeManager = new (0, (0, parcelRequire("ilQ8p")).IFrameManager)(url, options.configuration);
        }
        init() {
            const iframe = this.iframeManager.create(this.options.container);
            if (iframe.contentWindow) iframe.contentWindow.cexp_sdk = {
                onComplete: this.options.onComplete,
                onError: this.options.onError
            };
        }
        cleanup() {
            this.iframeManager.remove();
        }
    }
});
parcelRegister("ilQ8p", function(module, exports) {
    $parcel$export(module.exports, "IFrameManager", ()=>$3c770d2f1ef33833$export$5cdd44db74d265ce);
    var $1ttXZ;
    var $6CLWu;
    class $3c770d2f1ef33833$export$5cdd44db74d265ce {
        constructor(url, configurationOptions){
            this.iframe = null;
            this.iframeURL = (0, (0, parcelRequire("1ttXZ")).appendQueryParams)((0, (0, parcelRequire("6CLWu")).convertToSameOrigin)(url), configurationOptions);
        }
        get origin() {
            return this.iframeURL.origin;
        }
        create(container) {
            this.iframe = document.createElement('iframe');
            this.iframe.src = this.iframeURL.href;
            this.iframe.style.border = '0px';
            this.iframe.style.minWidth = '100%';
            this.iframe.style.height = '100%';
            container.appendChild(this.iframe);
            return this.iframe;
        }
        remove() {
            if (this.iframe && this.iframe.parentElement) {
                this.iframe.parentElement.removeChild(this.iframe);
                this.iframe = null;
            }
        }
    }
});
parcelRegister("1ttXZ", function(module, exports) {
    $parcel$export(module.exports, "appendQueryParams", ()=>$1f083fd5e29111ec$export$a0b32aef6b0d7373);
    function $1f083fd5e29111ec$export$a0b32aef6b0d7373(url, configurationOptions) {
        if (configurationOptions) {
            const sanitizedConfigurationOptions = $1f083fd5e29111ec$export$f69e046d5386ed61(configurationOptions);
            const existingParams = new URLSearchParams(url.search);
            Object.entries(sanitizedConfigurationOptions).forEach(([key, value])=>{
                if (Array.isArray(value)) existingParams.set(key, value.join(','));
                else if (value) existingParams.set(key, value);
            });
            url.search = existingParams.toString();
        }
        return url;
    }
    function $1f083fd5e29111ec$export$f69e046d5386ed61(options) {
        const sanitizedOptions = {};
        Object.entries(options).forEach(([key, value])=>{
            if (Array.isArray(value)) sanitizedOptions[key] = value.filter((item)=>typeof item === 'string' && item != null);
            else if (typeof value === 'string') sanitizedOptions[key] = value;
        });
        return sanitizedOptions;
    }
});
parcelRegister("6CLWu", function(module, exports) {
    $parcel$export(module.exports, "convertToSameOrigin", ()=>$62a031d8287e3993$export$b3eeb1359be95e5);
    const $62a031d8287e3993$var$replaceBillingEmbedPath = (path)=>path.replace('/billing', (0, $c9850feaece45083$export$62b1d6bac3360b4e));
    function $62a031d8287e3993$export$b3eeb1359be95e5(originalUrl) {
        const urlWithAdminhubOrigin = new URL(originalUrl);
        const url = new URL(window.location.origin + $62a031d8287e3993$var$replaceBillingEmbedPath(urlWithAdminhubOrigin.pathname));
        return url;
    }
});
const $c9850feaece45083$export$62b1d6bac3360b4e = '/admin-embed/billing';
parcelRegister("dvyoy", function(module, exports) {
    $parcel$export(module.exports, "EditionAwarenessButton", ()=>$f2185ccb98b6d6d2$export$57ddd9301662f8e4);
    $parcel$export(module.exports, "EditionAwarenessLinkButton", ()=>$f2185ccb98b6d6d2$export$57c5e4c8900420b5);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $bOVbW;
    var $i7S2n;
    var $bZC6Q;
    var $jhmo0;
    var $dC5iT;
    var $5ILhZ;
    var $8CUq3;
    var $j4doy;
    const $f2185ccb98b6d6d2$var$buttonStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        borderWidth: 'border.width',
        font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        borderStyle: 'solid',
        backgroundColor: 'elevation.surface',
        borderRadius: 'border.radius.100',
        paddingInline: 'space.150',
        paddingBlock: 'space.050',
        minHeight: '32px',
        color: 'color.text',
        transitionProperty: 'color, background-color',
        transitionDuration: '200ms',
        display: 'flex',
        gap: 'space.100',
        alignItems: 'center',
        fontWeight: "var(--ds-font-weight-medium, 500)",
        textDecoration: 'none',
        ':hover': {
            backgroundColor: 'color.background.neutral.subtle.hovered',
            textDecoration: 'none',
            color: 'color.text'
        },
        ':active': {
            backgroundColor: 'color.background.neutral.subtle.pressed',
            textDecoration: 'none'
        }
    });
    const $f2185ccb98b6d6d2$var$brandStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        color: 'color.text.brand',
        borderColor: 'color.border.brand',
        ':hover': {
            color: 'color.text.brand'
        }
    });
    const $f2185ccb98b6d6d2$var$warningStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        borderColor: 'color.border.warning'
    });
    const $f2185ccb98b6d6d2$var$dangerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        borderColor: 'color.border.danger'
    });
    const $f2185ccb98b6d6d2$var$iconStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        display: 'flex',
        flexGrow: 0,
        flexShrink: 0,
        alignSelf: 'center',
        fontSize: 0,
        lineHeight: 0,
        userSelect: 'none'
    });
    const $f2185ccb98b6d6d2$var$sparkleAnimation = null;
    const $f2185ccb98b6d6d2$var$sparkleStyles = null;
    const $f2185ccb98b6d6d2$var$ButtonIcon = (props)=>{
        const { status: status, upgradeIconType: upgradeIconType, icon: icon } = props;
        const UpgradeIcon = upgradeIconType === 'gem' ? (0, ($parcel$interopDefault((0, parcelRequire("bOVbW"))))) : (0, (0, parcelRequire("j4doy")).SparkleIcon);
        if (icon === 'upgrade') return $5uXOq.createElement(UpgradeIcon, {
            label: "",
            primaryColor: "var(--ds-icon-discovery)",
            color: "var(--ds-icon-discovery)",
            testId: `${upgradeIconType}-icon`
        });
        if (icon === 'warning') return $5uXOq.createElement((0, ($parcel$interopDefault((0, parcelRequire("bZC6Q"))))), {
            label: "",
            color: "var(--ds-icon-warning)",
            testId: "warning-icon"
        });
        if (icon === 'danger') return $5uXOq.createElement((0, ($parcel$interopDefault((0, parcelRequire("bZC6Q"))))), {
            label: "",
            color: "var(--ds-icon-danger)",
            testId: "warning-icon"
        });
        if (icon === 'missing-payment-details') return $5uXOq.createElement((0, ($parcel$interopDefault((0, parcelRequire("i7S2n"))))), {
            label: "",
            color: "var(--ds-icon-discovery)",
            LEGACY_size: "small",
            testId: "credit-card-icon"
        });
        if (status === 'warning') return $5uXOq.createElement((0, ($parcel$interopDefault((0, parcelRequire("bZC6Q"))))), {
            label: "",
            color: "var(--ds-icon-warning)",
            testId: "warning-icon"
        });
        if (status === 'danger') return $5uXOq.createElement((0, ($parcel$interopDefault((0, parcelRequire("bZC6Q"))))), {
            label: "",
            color: "var(--ds-icon-danger)",
            testId: "warning-icon"
        });
        return $5uXOq.createElement(UpgradeIcon, {
            label: "",
            primaryColor: "var(--ds-icon-discovery)",
            color: "var(--ds-icon-discovery)",
            testId: `${upgradeIconType}-icon`
        });
    };
    const $f2185ccb98b6d6d2$export$57ddd9301662f8e4 = (0, $5uXOq.forwardRef)(({ children: children, status: status, upgradeIconType: upgradeIconType, icon: icon, ...rest }, ref)=>{
        return $5uXOq.createElement("div", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1o9zidpf _kqwl1woi _nrflymdr _1yzo1ytf _1g1e12c5 _e03k1h6o _tjnb1spj _bd4y1woi _1t38ymdr _117t1ytf _wasv12c5 _158u1h6o _mgxm1spj _ddpz1bs3 _13wwidpf"
            ])
        }, $5uXOq.createElement((0, (0, parcelRequire("5ILhZ")).default), {
            ...rest,
            ref: ref,
            xcss: [
                $f2185ccb98b6d6d2$var$buttonStyles,
                status === 'default' && $f2185ccb98b6d6d2$var$brandStyles,
                status === 'warning' && $f2185ccb98b6d6d2$var$warningStyles,
                status === 'danger' && $f2185ccb98b6d6d2$var$dangerStyles
            ]
        }, $5uXOq.createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $f2185ccb98b6d6d2$var$iconStyles
        }, $5uXOq.createElement($f2185ccb98b6d6d2$var$ButtonIcon, {
            status: status,
            upgradeIconType: upgradeIconType,
            icon: icon
        })), children));
    });
    const $f2185ccb98b6d6d2$export$57c5e4c8900420b5 = (0, $5uXOq.forwardRef)(({ children: children, status: status, upgradeIconType: upgradeIconType, href: href, icon: icon, ...rest }, ref)=>{
        return $5uXOq.createElement("div", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1o9zidpf _kqwl1woi _nrflymdr _1yzo1ytf _1g1e12c5 _e03k1h6o _tjnb1spj _bd4y1woi _1t38ymdr _117t1ytf _wasv12c5 _158u1h6o _mgxm1spj _ddpz1bs3 _13wwidpf"
            ])
        }, $5uXOq.createElement((0, (0, parcelRequire("jhmo0")).default), {
            ...rest,
            ref: ref,
            href: href,
            xcss: [
                $f2185ccb98b6d6d2$var$buttonStyles,
                status === 'default' && $f2185ccb98b6d6d2$var$brandStyles,
                status === 'warning' && $f2185ccb98b6d6d2$var$warningStyles,
                status === 'danger' && $f2185ccb98b6d6d2$var$dangerStyles
            ]
        }, $5uXOq.createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $f2185ccb98b6d6d2$var$iconStyles
        }, $5uXOq.createElement($f2185ccb98b6d6d2$var$ButtonIcon, {
            status: status,
            upgradeIconType: upgradeIconType,
            icon: icon
        })), children));
    });
});
parcelRegister("j4doy", function(module, exports) {
    $parcel$export(module.exports, "SparkleIcon", ()=>$191bbdf081e30be9$export$1019ff5537a7252e);
    var $5uXOq = parcelRequire("5uXOq");
    var $5LWLA;
    const $191bbdf081e30be9$var$SparkleGlyph = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
            ...props,
            xmlns: "http://www.w3.org/2000/svg",
            width: "14",
            height: "14",
            fill: "none"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            id: "starMain",
            fillRule: "evenodd",
            d: "m5.184 1.921-1.28 3.244L.664 6.443a.52.52 0 0 0 0 .966l3.242 1.279 1.279 3.242a.52.52 0 0 0 .967 0l1.278-3.242 3.242-1.28a.52.52 0 0 0 0-.966L7.43 5.165 6.15 1.92a.517.517 0 0 0-.69-.285.519.519 0 0 0-.276.285Z",
            clipRule: "evenodd",
            fill: "currentColor"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            id: "starBottomRight",
            fillRule: "evenodd",
            d: "m10.246 9.237-.496 1.255-1.255.496a.37.37 0 0 0-.205.494c.04.09.113.162.205.198l1.255.495.496 1.256a.373.373 0 0 0 .692 0l.496-1.256 1.255-.495a.371.371 0 0 0 0-.692l-1.255-.496-.496-1.255a.369.369 0 0 0-.494-.205.373.373 0 0 0-.198.205Z",
            clipRule: "evenodd",
            fill: "currentColor"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            id: "starTopRight",
            fillRule: "evenodd",
            d: "m10.715.568-.495 1.257-1.256.496a.373.373 0 0 0 0 .692l1.256.495.495 1.257a.372.372 0 0 0 .692 0l.497-1.257 1.255-.495a.371.371 0 0 0 0-.692l-1.255-.496L11.407.57a.367.367 0 0 0-.209-.21.375.375 0 0 0-.483.209Z",
            clipRule: "evenodd",
            fill: "currentColor"
        }));
    const $191bbdf081e30be9$export$1019ff5537a7252e = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5LWLA")).default), {
            glyph: $191bbdf081e30be9$var$SparkleGlyph,
            ...props
        });
});
parcelRegister("kMSay", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$143a91bbcd4a2e96$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $6wxJn;
    function $143a91bbcd4a2e96$export$2e2bcd8739ae039(name) {
        const context = (0, $5uXOq.useContext)((0, (0, parcelRequire("6wxJn")).default));
        const handleClick = (0, $5uXOq.useCallback)((timeStamp)=>{
            if (context) {
                const time = timeStamp || performance.now();
                context.tracePress(name, time);
            }
        }, [
            context,
            name
        ]);
        return handleClick;
    }
});
parcelRegister("FISJv", function(module, exports) {
    var $g7i7g = parcelRequire("g7i7g");
    var $5wIsF = parcelRequire("5wIsF");
    var $07d6a509d0c9362c$var$pull = $g7i7g($5wIsF);
    module.exports = $07d6a509d0c9362c$var$pull;
});
parcelRegister("5wIsF", function(module, exports) {
    var $anVYT = parcelRequire("anVYT");
    function $40626e026fe1545a$var$pullAll(array, values) {
        return array && array.length && values && values.length ? $anVYT(array, values) : array;
    }
    module.exports = $40626e026fe1545a$var$pullAll;
});
parcelRegister("anVYT", function(module, exports) {
    var $1nIHN = parcelRequire("1nIHN");
    var $2wwA6 = parcelRequire("2wwA6");
    var $jA03V = parcelRequire("jA03V");
    var $cW28x = parcelRequire("cW28x");
    var $jHlUS = parcelRequire("jHlUS");
    var $78f90735d44c9d27$var$arrayProto = Array.prototype;
    var $78f90735d44c9d27$var$splice = $78f90735d44c9d27$var$arrayProto.splice;
    function $78f90735d44c9d27$var$basePullAll(array, values, iteratee, comparator) {
        var indexOf = comparator ? $jA03V : $2wwA6, index = -1, length = values.length, seen = array;
        if (array === values) values = $jHlUS(values);
        if (iteratee) seen = $1nIHN(array, $cW28x(iteratee));
        while(++index < length){
            var fromIndex = 0, value = values[index], computed = iteratee ? iteratee(value) : value;
            while((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1){
                if (seen !== array) $78f90735d44c9d27$var$splice.call(seen, fromIndex, 1);
                $78f90735d44c9d27$var$splice.call(array, fromIndex, 1);
            }
        }
        return array;
    }
    module.exports = $78f90735d44c9d27$var$basePullAll;
});
parcelRegister("jA03V", function(module, exports) {
    function $e4116d7d57d0dfb7$var$baseIndexOfWith(array, value, fromIndex, comparator) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (comparator(array[index], value)) return index;
        }
        return -1;
    }
    module.exports = $e4116d7d57d0dfb7$var$baseIndexOfWith;
});
parcelRegister("eufEc", function(module, exports) {
    $parcel$export(module.exports, "JSResourceForInteraction", ()=>$2236bb2e85f415e3$export$e83743682263315a);
    var $eIMrK;
    var $ce6VA;
    var $iyWSs;
    const $2236bb2e85f415e3$var$cache = (0, (0, parcelRequire("eIMrK")).createCache)(new Map());
    function $2236bb2e85f415e3$export$e83743682263315a(loader, opts) {
        return $2236bb2e85f415e3$var$cache.get(opts.moduleId, ()=>(0, (0, parcelRequire("ce6VA")).PreloadableJSResource)(()=>(0, (0, parcelRequire("iyWSs")).postTask)(loader, {
                    priority: 'user-visible'
                }), opts));
    }
});
parcelRegister("eIMrK", function(module, exports) {
    $parcel$export(module.exports, "createCache", ()=>$26949c89be85980a$export$cf6fa0bbcc94b912);
    function $26949c89be85980a$export$cf6fa0bbcc94b912(store) {
        return {
            get (key, supplier) {
                const value = store.get(key);
                if (value != null) return value;
                const v = supplier();
                store.set(key, v);
                return v;
            }
        };
    }
});
parcelRegister("ce6VA", function(module, exports) {
    $parcel$export(module.exports, "PreloadableJSResource", ()=>$0aceca9655b1ea8e$export$4fe5fba5bb1d3c09);
    var $eYVtd;
    function $0aceca9655b1ea8e$export$4fe5fba5bb1d3c09(loader, opts) {
        const resource = (0, (0, parcelRequire("eYVtd")).JSResource)(loader, opts);
        return Object.assign(resource, {
            preload () {
                const jsModule = resource.getModuleIfRequired();
                if (jsModule != null) return;
                resource.load().catch(()=>{});
            }
        });
    }
});
parcelRegister("eYVtd", function(module, exports) {
    $parcel$export(module.exports, "JSResource", ()=>$0077c3a5c33c2d5c$export$148e45a6d4b4d65);
    var $s9uRx;
    var $kqVcd;
    var $c8s79;
    function $0077c3a5c33c2d5c$export$148e45a6d4b4d65(loader, opts) {
        const { moduleId: moduleId, moduleName: moduleName } = opts;
        const listeners = new Set();
        let promise;
        let state = {
            type: 'init'
        };
        function createOnLoad(event) {
            return (module)=>{
                (0, (0, parcelRequire("kqVcd")).eventEmitter).emit('jsresource.load.complete', event);
                state = {
                    type: 'module',
                    module: module
                };
                for (const listener of listeners)listener.onLoad(module);
            };
        }
        function createOnError(event) {
            return (error)=>{
                (0, (0, parcelRequire("kqVcd")).eventEmitter).emit('jsresource.load.error', {
                    ...event,
                    error: error
                });
                state = {
                    type: 'error',
                    error: error
                };
                for (const listener of listeners)listener.onError?.(error);
            };
        }
        return {
            getModuleId () {
                return moduleId;
            },
            getModuleName () {
                return moduleName;
            },
            getModuleIfRequired () {
                if (state.type === 'error') throw state.error;
                return state.type === 'module' ? state.module : null;
            },
            load () {
                if (!promise) {
                    const event = {
                        moduleId: moduleId,
                        transactionId: (0, (0, parcelRequire("s9uRx")).generateId)()
                    };
                    const onError = createOnError(event);
                    const onLoad = createOnLoad(event);
                    (0, (0, parcelRequire("kqVcd")).eventEmitter).emit('jsresource.load.start', event);
                    try {
                        promise = loader().then((result)=>{
                            const module = (0, (0, parcelRequire("c8s79")).isJSModuleWithDefaultExport)(result) ? result.default : result;
                            onLoad(module);
                            return module;
                        }).catch((error)=>{
                            onError(error);
                            throw error;
                        });
                    } catch (error) {
                        if (error instanceof Error) onError(error);
                        promise = Promise.reject(error);
                    }
                }
                return promise;
            },
            onComplete (onLoad, onError) {
                if (state.type === 'module') {
                    onLoad(state.module);
                    return ()=>{};
                }
                if (state.type === 'error') {
                    onError?.(state.error);
                    return ()=>{};
                }
                const listener = {
                    onError: onError,
                    onLoad: onLoad
                };
                listeners.add(listener);
                return ()=>{
                    listeners.delete(listener);
                };
            }
        };
    }
});
parcelRegister("s9uRx", function(module, exports) {
    $parcel$export(module.exports, "generateId", ()=>$7b3c882236d08e62$export$567fc7097e064344);
    let $7b3c882236d08e62$var$id = 100000;
    function $7b3c882236d08e62$export$567fc7097e064344() {
        $7b3c882236d08e62$var$id += 1;
        return $7b3c882236d08e62$var$id.toString();
    }
});
parcelRegister("kqVcd", function(module, exports) {
    $parcel$export(module.exports, "eventEmitter", ()=>$c1231136395d7ade$export$10dc3edfc20c8ff);
    function $c1231136395d7ade$var$createEventEmitter() {
        const eventSubscribers = new Map();
        return {
            emit (eventName, event) {
                const subscribers = eventSubscribers.get(eventName);
                for (const subscriber of subscribers ?? [])subscriber(event);
            },
            on (eventName, subscriber) {
                if (!eventSubscribers.has(eventName)) eventSubscribers.set(eventName, new Set([
                    subscriber
                ]));
                else eventSubscribers.get(eventName).add(subscriber);
                return ()=>{
                    const set = eventSubscribers.get(eventName);
                    set.delete(subscriber);
                    if (set.size === 0) eventSubscribers.delete(eventName);
                };
            }
        };
    }
    const $c1231136395d7ade$export$10dc3edfc20c8ff = $c1231136395d7ade$var$createEventEmitter();
});
parcelRegister("c8s79", function(module, exports) {
    $parcel$export(module.exports, "isJSModuleWithDefaultExport", ()=>$e831db33fb49cb12$export$3b514faac3ba993c);
    function $e831db33fb49cb12$export$3b514faac3ba993c(module) {
        try {
            return Object.prototype.hasOwnProperty.call(module, 'default');
        } catch (_) {
            return false;
        }
    }
});
parcelRegister("iyWSs", function(module, exports) {
    $parcel$export(module.exports, "postTask", ()=>$4dcc2a181ab1528f$export$13c9d02ca54955a3);
    async function $4dcc2a181ab1528f$var$toPromise(callback) {
        return callback();
    }
    function $4dcc2a181ab1528f$var$getScheduler(obj) {
        if ('scheduler' in obj && obj.scheduler !== 'undefined') return obj.scheduler;
    }
    function $4dcc2a181ab1528f$export$13c9d02ca54955a3(callback, options) {
        const scheduler = $4dcc2a181ab1528f$var$getScheduler(globalThis);
        if (!scheduler) {
            if (options.priority === 'background') return (parcelRequire("2XhkG")).then(()=>$4dcc2a181ab1528f$var$getScheduler(globalThis).postTask(callback, options));
            return $4dcc2a181ab1528f$var$toPromise(callback);
        }
        return scheduler.postTask(callback, options);
    }
});
parcelRegister("2XhkG", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("7EQgJ").then(()=>parcelRequire('9wHM1'));
});
parcelRegister("fEDBv", function(module, exports) {
    $parcel$export(module.exports, "createEntryPoint", ()=>$9a10ed1d48ab8caa$export$fa00dd5c1a75592f);
    function $9a10ed1d48ab8caa$export$fa00dd5c1a75592f(params) {
        return params;
    }
});
parcelRegister("fNobW", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$545cc6aa0f2abe1d$export$2e2bcd8739ae039);
    var $eUQkk;
    var $545cc6aa0f2abe1d$export$2e2bcd8739ae039 = (0, (0, parcelRequire("eUQkk")).default);
});
parcelRegister("eUQkk", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$934d1a8b664b9601$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $1tcYS;
    const $934d1a8b664b9601$var$useLayoutEffectSAFE = typeof window === 'undefined' ? (0, $5uXOq.useEffect) : (0, $5uXOq.useLayoutEffect);
    function $934d1a8b664b9601$export$2e2bcd8739ae039({ children: children, name: name, hold: hold = true }) {
        const context = (0, $5uXOq.useContext)((0, (0, parcelRequire("1tcYS")).default));
        $934d1a8b664b9601$var$useLayoutEffectSAFE(()=>{
            if (hold && context != null) return context.hold(name);
        }, [
            hold,
            context,
            name
        ]);
        return children != null ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, children) : null;
    }
});
parcelRegister("3T6Xo", function(module, exports) {
    var $gDRiW = parcelRequire("gDRiW");
    var $2d4be7a7064f22f9$var$kebabCase = $gDRiW(function(result, word, index) {
        return result + (index ? '-' : '') + word.toLowerCase();
    });
    module.exports = $2d4be7a7064f22f9$var$kebabCase;
});
parcelRegister("fElvF", function(module, exports) {
    $parcel$export(module.exports, "InvitePeopleModalContext", ()=>$075d48b841fc8ac5$export$be58429061ae5194);
    $parcel$export(module.exports, "InvitePeopleModalContextProvider", ()=>$075d48b841fc8ac5$export$496e4f58036bb94d);
    var $5uXOq = parcelRequire("5uXOq");
    const $075d48b841fc8ac5$var$AKInvitePeopleModal = (0, $5uXOq.lazy)(()=>(parcelRequire("1BaVz")));
    const $075d48b841fc8ac5$var$AKModalTransition = (0, $5uXOq.lazy)(()=>(parcelRequire("dXyDo")).then((module)=>({
                default: module.ModalTransition
            })));
    const $075d48b841fc8ac5$export$be58429061ae5194 = (0, $5uXOq.createContext)({
        isOpen: false,
        openModal: ()=>undefined,
        closeModal: ()=>undefined
    });
    const $075d48b841fc8ac5$export$496e4f58036bb94d = (invitePeopleModalContextProviderProps)=>{
        const { children: children } = invitePeopleModalContextProviderProps;
        const [invitePeopleState, setInvitePeopleState] = (0, $5uXOq.useState)({
            isOpen: false
        });
        const openModal = (invitePeopleProps, onClose)=>{
            setInvitePeopleState({
                isOpen: true,
                props: invitePeopleProps,
                onClose: onClose
            });
        };
        const closeModal = (0, $5uXOq.useCallback)((trigger)=>{
            if (!invitePeopleState.isOpen) return;
            invitePeopleState.onClose?.(trigger);
            setInvitePeopleState({
                previousProps: invitePeopleState.props,
                isOpen: false
            });
        }, [
            invitePeopleState
        ]);
        const reopenModal = (0, $5uXOq.useCallback)(()=>{
            setInvitePeopleState((prevState)=>!prevState.isOpen && prevState.previousProps ? {
                    props: prevState.previousProps,
                    isOpen: true
                } : prevState);
        }, []);
        const context = (0, $5uXOq.useMemo)(()=>({
                openModal: openModal,
                closeModal: closeModal,
                isOpen: invitePeopleState.isOpen
            }), [
            closeModal,
            invitePeopleState.isOpen
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($075d48b841fc8ac5$export$be58429061ae5194.Provider, {
            value: context
        }, children, invitePeopleState.isOpen && (0, ($parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Suspense), {
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($075d48b841fc8ac5$var$AKModalTransition, null, (0, ($parcel$interopDefault($5uXOq))).createElement($075d48b841fc8ac5$var$AKInvitePeopleModal, {
            onCloseHandler: closeModal,
            experimental_onReopenHandler: reopenModal,
            ...invitePeopleState.props
        }))));
    };
});
parcelRegister("1BaVz", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("2X3xv")
    ]).then(()=>parcelRequire('h8XS8'));
});
parcelRegister("dXyDo", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("c6u3S")
    ]).then(()=>parcelRequire('3YJEd'));
});
parcelRegister("ce4pa", function(module, exports) {
    $parcel$export(module.exports, "ExperienceSuccess", ()=>$a91ff3a48261deb0$export$4962f3898bd5c829);
    var $5uXOq = parcelRequire("5uXOq");
    const $a91ff3a48261deb0$export$4962f3898bd5c829 = ({ experience: experience })=>{
        (0, $5uXOq.useLayoutEffect)(()=>{
            experience.success();
        }, [
            experience
        ]);
        return null;
    };
});
parcelRegister("lLItl", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b7435f92b90f1f57$export$2e2bcd8739ae039);
    const $b7435f92b90f1f57$var$convertToError = (e)=>{
        let error;
        if (e instanceof Error) error = e;
        else if (typeof e === 'string') error = new Error(e);
        else if (typeof e === 'object') try {
            error = new Error('Object error instance thrown for operation: ' + JSON.stringify(e));
        } catch (jsonError) {
            error = new Error('Object serialisation error thrown during operation: ' + String(e));
        }
        else error = new Error('No error instance thrown for operation: ' + String(e));
        return error;
    };
    var $b7435f92b90f1f57$export$2e2bcd8739ae039 = $b7435f92b90f1f57$var$convertToError;
});
parcelRegister("6DRRy", function(module, exports) {
    $parcel$export(module.exports, "fetchItemsWithCursor", ()=>$4d5f7e3c666571fb$export$1d3435507f486e79);
    $parcel$export(module.exports, "retryFetch", ()=>$4d5f7e3c666571fb$export$635968db05579875);
    $parcel$export(module.exports, "httpRetryPolicy", ()=>$4d5f7e3c666571fb$export$bd28f8bf945907aa);
    $parcel$export(module.exports, "FetchError", ()=>$4d5f7e3c666571fb$export$26e841bcf1aeb894);
    $parcel$export(module.exports, "fetchJson", ()=>$4d5f7e3c666571fb$export$6d71b655afe1638d);
    $parcel$export(module.exports, "buildQueryString", ()=>$4d5f7e3c666571fb$export$6b17a39e52c8ee53);
    $parcel$export(module.exports, "sortByName", ()=>$4d5f7e3c666571fb$export$7932064324870761);
    var $7qDUb = parcelRequire("7qDUb");
    var $1qaNp;
    function $4d5f7e3c666571fb$var$defaultErrorMapper(response) {
        return Promise.resolve({
            code: response.status.toString(),
            message: response.statusText
        });
    }
    function $4d5f7e3c666571fb$var$defaultResultMapper(response) {
        return response.json();
    }
    async function $4d5f7e3c666571fb$export$1d3435507f486e79({ url: url, queryParams: queryParams = {}, signal: signal, getItems: getItems, getCursor: getCursor, canRetryCheck: canRetryCheck, mapError: mapError = $4d5f7e3c666571fb$var$defaultErrorMapper }) {
        const items = [];
        let response;
        let page = 0;
        do {
            if (signal?.aborted) return {
                ok: false,
                aborted: true
            };
            const cursor = response?.ok ? getCursor(response.result) : undefined;
            const queryParamsWithCursor = cursor ? {
                ...queryParams,
                cursor: cursor
            } : queryParams;
            const search = Object.entries(queryParamsWithCursor ?? {}).map(([key, value])=>`${encodeURIComponent(key)}=${encodeURIComponent(value)}`).join('&');
            const urlWithParams = [
                url,
                search
            ].filter(Boolean).join('?');
            response = await $4d5f7e3c666571fb$export$635968db05579875({
                request: ()=>fetch(urlWithParams, {
                        signal: signal
                    }),
                mapError: mapError,
                signal: signal,
                canRetryCheck: canRetryCheck
            });
            if (!response.ok) return response.aborted ? response : {
                ...response,
                page: page
            };
            items.push.apply(items, getItems(response.result));
            ++page;
        }while (response?.ok && getCursor(response.result))
        return {
            ok: true,
            items: items,
            pages: page
        };
    }
    async function $4d5f7e3c666571fb$export$9369b12211e1fce4({ request: request, canRetryCheck: canRetryCheck, attempt: attempt = 0, signal: signal }) {
        const result = await request(signal);
        if (result.ok || result.aborted || signal?.aborted) return result;
        else {
            const [canRetry, timeToWait] = canRetryCheck(result.status, ++attempt, signal);
            if (canRetry) {
                if (timeToWait) await (0, (0, parcelRequire("1qaNp")).wait)(timeToWait);
                return $4d5f7e3c666571fb$export$9369b12211e1fce4({
                    request: request,
                    canRetryCheck: canRetryCheck,
                    attempt: attempt,
                    signal: signal
                });
            }
        }
        return result;
    }
    const $4d5f7e3c666571fb$var$DEFAULT_MAX_ATTEMPTS = 3;
    const $4d5f7e3c666571fb$var$DEFAULT_BACKOFF_TIME_MS = 200;
    const $4d5f7e3c666571fb$var$DEFAULT_BACKOFF_TIME_429_MS = 1000;
    function $4d5f7e3c666571fb$export$bd28f8bf945907aa({ maxAttempts: maxAttempts = $4d5f7e3c666571fb$var$DEFAULT_MAX_ATTEMPTS, backoffTimeMs: backoffTimeMs = $4d5f7e3c666571fb$var$DEFAULT_BACKOFF_TIME_MS, rateLimitBackoffTimeMs: rateLimitBackoffTimeMs = $4d5f7e3c666571fb$var$DEFAULT_BACKOFF_TIME_429_MS } = {}) {
        return (status, attempts)=>{
            if (attempts >= maxAttempts) return [
                false,
                0
            ];
            switch(status){
                case 401:
                case 403:
                case 404:
                    return [
                        false,
                        0
                    ];
                case 429:
                    return [
                        true,
                        rateLimitBackoffTimeMs
                    ];
                default:
                    return [
                        true,
                        backoffTimeMs
                    ];
            }
        };
    }
    function $4d5f7e3c666571fb$export$635968db05579875({ request: request, mapResult: mapResult = $4d5f7e3c666571fb$var$defaultResultMapper, mapError: mapError = $4d5f7e3c666571fb$var$defaultErrorMapper, canRetryCheck: canRetryCheck = $4d5f7e3c666571fb$export$bd28f8bf945907aa(), signal: signal }) {
        return $4d5f7e3c666571fb$export$9369b12211e1fce4({
            request: async ()=>{
                let response;
                try {
                    response = await request();
                    if (response.ok) return {
                        ok: true,
                        result: await mapResult(response)
                    };
                    const { code: code, message: message } = await mapError(response);
                    return {
                        ok: false,
                        aborted: false,
                        status: response.status,
                        code: code,
                        message: message
                    };
                } catch (error) {
                    if (error instanceof Error) {
                        if (error.name === 'AbortError') return {
                            ok: false,
                            aborted: true
                        };
                        return {
                            ok: false,
                            aborted: false,
                            status: (0, $b21f23f22e452d68$export$2c32b0fe4533d89e),
                            code: error.name,
                            message: error.message
                        };
                    }
                    return {
                        ok: false,
                        aborted: false,
                        status: (0, $b21f23f22e452d68$export$2c32b0fe4533d89e),
                        code: (0, $b21f23f22e452d68$export$9267d266a5449137),
                        message: (0, $b21f23f22e452d68$export$33789febc109c023)
                    };
                }
            },
            canRetryCheck: canRetryCheck,
            signal: signal
        });
    }
    class $4d5f7e3c666571fb$export$26e841bcf1aeb894 extends Error {
        constructor(message, statusCode, errorType){
            super(message);
            this.name = 'FetchError';
            this.statusCode = statusCode;
            this.errorType = errorType;
        }
    }
    const $4d5f7e3c666571fb$export$6d71b655afe1638d = (url, action, init)=>fetch(url, {
            credentials: 'include',
            ...init
        }).then((response)=>{
            if (response.ok) return response.json();
            throw new $4d5f7e3c666571fb$export$26e841bcf1aeb894(`Unable to fetch ${action} ${response.statusText}`, response.status);
        });
    const $4d5f7e3c666571fb$var$isNil = (value)=>value === undefined || value === null;
    function $4d5f7e3c666571fb$export$6b17a39e52c8ee53(obj) {
        const query = Object.keys(obj).filter((key)=>!$4d5f7e3c666571fb$var$isNil(obj[key])).map((key)=>`${encodeURIComponent(key)}=${encodeURIComponent(obj[key])}`).join('&');
        return query ? '?' + query : query;
    }
    function $4d5f7e3c666571fb$export$7932064324870761(values) {
        return (0, ($parcel$interopDefault($7qDUb)))(values, ({ name: name })=>name.toLowerCase());
    }
});
parcelRegister("7qDUb", function(module, exports) {
    var $ekcP3 = parcelRequire("ekcP3");
    var $kE90z = parcelRequire("kE90z");
    var $g7i7g = parcelRequire("g7i7g");
    var $4rDUz = parcelRequire("4rDUz");
    var $5689ea6dce44e1ca$var$sortBy = $g7i7g(function(collection, iteratees) {
        if (collection == null) return [];
        var length = iteratees.length;
        if (length > 1 && $4rDUz(collection, iteratees[0], iteratees[1])) iteratees = [];
        else if (length > 2 && $4rDUz(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
            iteratees[0]
        ];
        return $kE90z(collection, $ekcP3(iteratees, 1), []);
    });
    module.exports = $5689ea6dce44e1ca$var$sortBy;
});
parcelRegister("kE90z", function(module, exports) {
    var $1nIHN = parcelRequire("1nIHN");
    var $fTwLR = parcelRequire("fTwLR");
    var $bxDef = parcelRequire("bxDef");
    var $jXnVG = parcelRequire("jXnVG");
    var $iWpGN = parcelRequire("iWpGN");
    var $cW28x = parcelRequire("cW28x");
    var $4pePQ = parcelRequire("4pePQ");
    var $etyzk = parcelRequire("etyzk");
    var $8LQ84 = parcelRequire("8LQ84");
    function $f07e87ec0cad1451$var$baseOrderBy(collection, iteratees, orders) {
        if (iteratees.length) iteratees = $1nIHN(iteratees, function(iteratee) {
            if ($8LQ84(iteratee)) return function(value) {
                return $fTwLR(value, iteratee.length === 1 ? iteratee[0] : iteratee);
            };
            return iteratee;
        });
        else iteratees = [
            $etyzk
        ];
        var index = -1;
        iteratees = $1nIHN(iteratees, $cW28x($bxDef));
        var result = $jXnVG(collection, function(value, key, collection) {
            var criteria = $1nIHN(iteratees, function(iteratee) {
                return iteratee(value);
            });
            return {
                'criteria': criteria,
                'index': ++index,
                'value': value
            };
        });
        return $iWpGN(result, function(object, other) {
            return $4pePQ(object, other, orders);
        });
    }
    module.exports = $f07e87ec0cad1451$var$baseOrderBy;
});
parcelRegister("jXnVG", function(module, exports) {
    var $e7pfQ = parcelRequire("e7pfQ");
    var $hTJwX = parcelRequire("hTJwX");
    function $e87616de80329acf$var$baseMap(collection, iteratee) {
        var index = -1, result = $hTJwX(collection) ? Array(collection.length) : [];
        $e7pfQ(collection, function(value, key, collection) {
            result[++index] = iteratee(value, key, collection);
        });
        return result;
    }
    module.exports = $e87616de80329acf$var$baseMap;
});
parcelRegister("iWpGN", function(module, exports) {
    function $dca1921d42c9de26$var$baseSortBy(array, comparer) {
        var length = array.length;
        array.sort(comparer);
        while(length--)array[length] = array[length].value;
        return array;
    }
    module.exports = $dca1921d42c9de26$var$baseSortBy;
});
parcelRegister("4pePQ", function(module, exports) {
    var $7JssJ = parcelRequire("7JssJ");
    function $3355012d40661daa$var$compareMultiple(object, other, orders) {
        var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
        while(++index < length){
            var result = $7JssJ(objCriteria[index], othCriteria[index]);
            if (result) {
                if (index >= ordersLength) return result;
                var order = orders[index];
                return result * (order == 'desc' ? -1 : 1);
            }
        }
        return object.index - other.index;
    }
    module.exports = $3355012d40661daa$var$compareMultiple;
});
parcelRegister("7JssJ", function(module, exports) {
    var $4faK3 = parcelRequire("4faK3");
    function $5a12d0703028d451$var$compareAscending(value, other) {
        if (value !== other) {
            var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = $4faK3(value);
            var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = $4faK3(other);
            if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
            if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
        }
        return 0;
    }
    module.exports = $5a12d0703028d451$var$compareAscending;
});
const $b21f23f22e452d68$export$68362b925a39303e = '/gateway/api/slack';
const $b21f23f22e452d68$export$83c8d7110915321e = 'invite-people';
const $b21f23f22e452d68$export$2c32b0fe4533d89e = 0;
const $b21f23f22e452d68$export$9267d266a5449137 = 'NETWORK_ERROR';
const $b21f23f22e452d68$export$33789febc109c023 = 'Network error';
const $b21f23f22e452d68$export$4804b650706e0b62 = 'CONFLUENCE_METADATA_ERROR';
const $b21f23f22e452d68$export$85183a312807388d = 'peopleTeams';
const $b21f23f22e452d68$export$d67bd32411617d53 = 480;
const $b21f23f22e452d68$export$cce5ee914c2ec5d9 = 924;
const $b21f23f22e452d68$export$ab2f49a861856bab = '/gateway/api';
const $b21f23f22e452d68$export$127769e597bc5ee5 = '/external-users/third-party';
const $b21f23f22e452d68$export$8bad17bb0225d989 = '/external-users/orgs';
const $b21f23f22e452d68$export$e468596ea25b5295 = 'integrations';
const $b21f23f22e452d68$export$458ba67f45a7f353 = 'Third Party Search';
const $b21f23f22e452d68$export$bc2c06c4779f47f2 = 'Organisation Settings';
const $b21f23f22e452d68$export$20875166a8676880 = '/growth/invite-3rd-party-teams';
const $b21f23f22e452d68$export$3f9855fcc7fa383e = '/slack-channels';
const $b21f23f22e452d68$export$2d4bcc939d0de9de = 'google-invites';
const $b21f23f22e452d68$export$baca96d2908c1d98 = 'microsoft-invites';
const $b21f23f22e452d68$export$89aa938ff9a6aec2 = 3;
parcelRegister("1qaNp", function(module, exports) {
    $parcel$export(module.exports, "wait", ()=>$b92636ad2a3204c5$export$5c069c93d2b7493f);
    async function $b92636ad2a3204c5$export$5c069c93d2b7493f(delayMs) {
        return new Promise((resolve)=>{
            setTimeout(()=>{
                resolve();
            }, delayMs);
        });
    }
});
parcelRegister("dvXKO", function(module, exports) {
    $parcel$export(module.exports, "slackServiceFactory", ()=>$76f19881c4248625$export$b2ac8baa522556a7);
    var $9u4JR;
    var $1IQ8k;
    var $6pj04;
    function $76f19881c4248625$export$b2ac8baa522556a7(cloudId, product, createAnalyticsEvent) {
        switch(product){
            case 'platform':
                return new (0, (0, parcelRequire("6pj04")).default)(cloudId, createAnalyticsEvent);
            case 'confluence':
                return new (0, (0, parcelRequire("9u4JR")).default)(cloudId, createAnalyticsEvent);
            default:
                return new (0, (0, parcelRequire("1IQ8k")).default)(cloudId, createAnalyticsEvent);
        }
    }
});
parcelRegister("9u4JR", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$809e2019f42963d6$export$2e2bcd8739ae039);
    var $ak6EA;
    var $cByYp;
    var $iBUTl;
    class $809e2019f42963d6$export$2e2bcd8739ae039 extends (0, (0, parcelRequire("ak6EA")).default) {
        constructor(cloudId, createUIAnalyticsEvent){
            const analytics = (0, (0, parcelRequire("cByYp")).getSlackServiceAnalytics)(createUIAnalyticsEvent);
            super(cloudId, 'confluence', analytics);
            this.confluenceAnalytics = (0, (0, parcelRequire("cByYp")).getConfluenceSlackServiceAnalytics)(createUIAnalyticsEvent);
        }
        async primeConsentUrl() {
            if (this.consentUrl) return;
            const location = typeof window === 'undefined' ? undefined : window.location;
            if (location) {
                const urlResult = await (0, (0, parcelRequire("iBUTl")).default)(location, this.confluenceAnalytics, this.abortController?.signal);
                if (urlResult.ok) this.consentUrl = urlResult.result;
                else throw new Error('Failed priming consent URL');
            }
        }
    }
});
parcelRegister("ak6EA", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ebe600a4dc9b1c9a$export$2e2bcd8739ae039);
    var $2gQ83;
    var $7qDUb = parcelRequire("7qDUb");
    var $7Jxgt = parcelRequire("7Jxgt");
    var $l9cFs;
    var $g1YUU;
    var $98FOM;
    var $6DRRy;
    const $ebe600a4dc9b1c9a$var$POPUP_WIDTH = 500;
    const $ebe600a4dc9b1c9a$var$POPUP_HEIGHT = 900;
    const $ebe600a4dc9b1c9a$var$USER_FETCH_LIMIT = 1000;
    const $ebe600a4dc9b1c9a$var$retryOptions = {
        maxAttempts: 3,
        backoffTimeMs: 200,
        rateLimitBackoffTimeMs: 1000
    };
    class $ebe600a4dc9b1c9a$export$2e2bcd8739ae039 {
        constructor(cloudId, product, analytics){
            this.cloudId = cloudId;
            this.product = product;
            this.analytics = analytics;
            this.windowName = (0, $7Jxgt.v4)();
            this.abortController = typeof AbortController !== 'undefined' ? new AbortController() : null;
            this.userStream = {
                count: 0,
                pages: 0,
                finishedLoading: false
            };
            this.channelStream = {
                count: 0,
                pages: 0,
                finishedLoading: false
            };
            this.onMessage = ({ data: data, target: target, source: source })=>{
                if (!source || target !== window || data !== 'success') return;
                window.removeEventListener('message', this.onMessage);
                const popupWindow = source;
                if (!this.popupWindow) return;
                popupWindow.close();
                this.popupWindow = undefined;
                this.onSuccess?.();
            };
            this.baseUrl = `${0, $b21f23f22e452d68$export$68362b925a39303e}/${product}`;
        }
        abort() {
            if (this.abortController) {
                this.abortController.abort();
                this.abortController = typeof AbortController !== 'undefined' ? new AbortController() : null;
            }
        }
        async getConsent(onSuccess) {
            await this.primeConsentUrl();
            this.onSuccess = onSuccess;
            window.addEventListener('message', this.onMessage);
            const popupWindow = window.open(this.consentUrl, this.windowName, (0, (0, parcelRequire("l9cFs")).default)($ebe600a4dc9b1c9a$var$POPUP_WIDTH, $ebe600a4dc9b1c9a$var$POPUP_HEIGHT));
            if (popupWindow) this.popupWindow = popupWindow;
        }
        async isSlackEnabled() {
            const result = await (0, (0, parcelRequire("6DRRy")).retryFetch)({
                request: ()=>fetch(`${this.baseUrl}/enabled?cloudId=${this.cloudId}`, {
                        signal: this.abortController?.signal
                    }),
                mapResult: (response)=>response.json().then(({ enabled: enabled })=>enabled),
                mapError: (response)=>response.json().then((obj)=>{
                        const { code: code, message: message } = obj;
                        return {
                            code: code ?? '',
                            message: message ?? ''
                        };
                    })
            });
            if (result.ok) this.analytics.onGetEnabledSucceeded();
            else if (!result.aborted && !(0, (0, parcelRequire("g1YUU")).isAcceptableFailure)(result.status)) this.analytics.onGetEnabledFailed({
                status: result.status,
                errorMessage: result.message
            });
            return result;
        }
        async getTeams() {
            const response = await (0, (0, parcelRequire("6DRRy")).fetchItemsWithCursor)({
                url: `${this.baseUrl}/teams`,
                queryParams: {
                    cloudId: this.cloudId
                },
                signal: this.abortController?.signal,
                getItems: (response)=>response.teams,
                getCursor: (response)=>response.nextCursor,
                canRetryCheck: (0, (0, parcelRequire("6DRRy")).httpRetryPolicy)($ebe600a4dc9b1c9a$var$retryOptions)
            });
            if (response.ok) {
                this.analytics.onFetchTeamsSucceeded({
                    teams: response.items.length,
                    pages: response.pages
                });
                return {
                    ok: true,
                    result: (0, ($parcel$interopDefault($7qDUb)))(response.items, [
                        ({ name: name })=>name.toLowerCase()
                    ])
                };
            } else if (response.aborted) return response;
            else {
                this.analytics.onFetchTeamsFailed({
                    page: response.page,
                    status: response.status,
                    errorMessage: response.message
                });
                return response;
            }
        }
        streamUsers(teamId, onResponse, cursor) {
            if (!cursor) this.userStream = {
                count: 0,
                pages: 0,
                finishedLoading: false
            };
            (0, (0, parcelRequire("6DRRy")).retryFetch)({
                request: ()=>fetch(`${this.baseUrl}/recipients${(0, (0, parcelRequire("6DRRy")).buildQueryString)({
                        cloudId: this.cloudId,
                        teamId: teamId,
                        cursor: cursor,
                        limit: $ebe600a4dc9b1c9a$var$USER_FETCH_LIMIT
                    })}`, {
                        signal: this.abortController?.signal
                    }),
                canRetryCheck: (0, (0, parcelRequire("6DRRy")).httpRetryPolicy)($ebe600a4dc9b1c9a$var$retryOptions)
            }).then((resp)=>{
                if (!resp.ok) {
                    if (!resp.aborted) this.analytics.onFetchUsersFailed({
                        teamId: teamId,
                        page: this.userStream.pages,
                        status: resp.status,
                        errorMessage: resp.message
                    });
                    onResponse(resp);
                    return;
                }
                this.userStream.pages++;
                this.userStream.count += resp.result.recipients.length;
                this.userStream.finishedLoading = !!resp.result.nextCursor;
                onResponse({
                    ok: true,
                    result: resp.result.recipients,
                    nextCursor: resp.result.nextCursor
                });
                if (resp.result.nextCursor) this.streamUsers(teamId, onResponse, resp.result.nextCursor);
                else this.analytics.onFetchUsersSucceeded({
                    teamId: teamId,
                    users: this.userStream.count,
                    pages: this.userStream.pages
                });
            });
        }
        streamChannels(teamId, onResponse, cursor) {
            if (!cursor) this.channelStream = {
                count: 0,
                pages: 0,
                finishedLoading: false
            };
            (0, (0, parcelRequire("6DRRy")).retryFetch)({
                request: ()=>fetch(`${this.baseUrl}/channels${(0, (0, parcelRequire("6DRRy")).buildQueryString)({
                        cloudId: this.cloudId,
                        teamId: teamId,
                        cursor: cursor
                    })}`, {
                        signal: this.abortController?.signal
                    }),
                canRetryCheck: (0, (0, parcelRequire("6DRRy")).httpRetryPolicy)($ebe600a4dc9b1c9a$var$retryOptions)
            }).then((resp)=>{
                if (!resp.ok) {
                    if (!resp.aborted) this.analytics.onFetchChannelsFailed({
                        teamId: teamId,
                        page: this.channelStream.pages,
                        status: resp.status,
                        errorMessage: resp.message
                    });
                    onResponse(resp);
                    return;
                }
                this.channelStream.pages++;
                this.channelStream.count += resp.result.channels.length;
                this.channelStream.finishedLoading = !!resp.result.nextCursor;
                onResponse({
                    ok: true,
                    result: resp.result.channels,
                    nextCursor: resp.result.nextCursor
                });
                if (resp.result.nextCursor) this.streamChannels(teamId, onResponse, resp.result.nextCursor);
                else this.analytics.onFetchChannelsSucceeded({
                    teamId: teamId,
                    channels: this.channelStream.count,
                    pages: this.channelStream.pages
                });
            });
        }
        async fetchSlackUsers(teamId) {
            const response = await (0, (0, parcelRequire("6DRRy")).fetchItemsWithCursor)({
                url: `${this.baseUrl}/recipients`,
                queryParams: {
                    cloudId: this.cloudId,
                    teamId: teamId
                },
                signal: this.abortController?.signal,
                getItems: (response)=>response.recipients,
                getCursor: (response)=>response.nextCursor,
                canRetryCheck: (0, (0, parcelRequire("6DRRy")).httpRetryPolicy)($ebe600a4dc9b1c9a$var$retryOptions)
            });
            if (response.ok) {
                const users = (0, ($parcel$interopDefault($7qDUb)))(response.items, [
                    ({ name: name })=>name.toLowerCase()
                ]);
                this.analytics.onFetchUsersSucceeded({
                    teamId: teamId,
                    users: response.items.length,
                    pages: response.pages
                });
                return {
                    ok: true,
                    result: users
                };
            } else if (response.aborted) return response;
            else {
                this.analytics.onFetchUsersFailed({
                    teamId: teamId,
                    page: response.page,
                    status: response.status,
                    errorMessage: response.message
                });
                return response;
            }
        }
        async share({ teamId: teamId, conversationId: conversationId, conversationType: conversationType, link: link, message: message }) {
            (0, (0, parcelRequire("98FOM")).startUfoExperience)((0, (0, parcelRequire("98FOM")).UfoExperiences).SLACK_REQUEST_SENT);
            const origin = new (0, (0, parcelRequire("2gQ83")).default)({
                product: this.product
            });
            const response = await (0, (0, parcelRequire("6DRRy")).retryFetch)({
                request: ()=>fetch(`${this.baseUrl}/share`, {
                        method: 'post',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify({
                            cloudId: this.cloudId,
                            teamId: teamId,
                            conversation: {
                                id: conversationId,
                                type: conversationType
                            },
                            link: origin.addToUrl(link),
                            message: message
                        }),
                        signal: this.abortController?.signal
                    }),
                mapResult: ()=>Promise.resolve(),
                mapError: (response)=>response.json().then((obj)=>{
                        const { code: code, message: message } = obj;
                        return {
                            code: code ?? '',
                            message: message ?? ''
                        };
                    }),
                signal: this.abortController?.signal
            });
            if (response.ok) {
                const successAttributes = {
                    product: this.product,
                    teamId: teamId,
                    conversationType: conversationType,
                    conversationId: conversationId,
                    messageLength: message.length || 0,
                    userCount: this.userStream.count
                };
                this.analytics.onShareSucceeded(successAttributes);
                (0, (0, parcelRequire("98FOM")).succeedUfoExperience)((0, (0, parcelRequire("98FOM")).UfoExperiences).SLACK_REQUEST_SENT, successAttributes);
            } else if (!response.aborted && !(0, (0, parcelRequire("g1YUU")).isAcceptableFailure)(response.status)) {
                const failedAttributes = {
                    product: this.product,
                    teamId: teamId,
                    conversationType: conversationType,
                    conversationId: conversationId,
                    status: response.status,
                    errorMessage: response.message
                };
                this.analytics.onShareFailed(failedAttributes);
                (0, (0, parcelRequire("98FOM")).failUfoExperience)((0, (0, parcelRequire("98FOM")).UfoExperiences).SLACK_REQUEST_SENT, failedAttributes);
            }
            return response.ok ? {
                ok: true,
                result: origin
            } : response;
        }
    }
});
parcelRegister("l9cFs", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f57f9c409938ee94$export$2e2bcd8739ae039);
    function $f57f9c409938ee94$export$2e2bcd8739ae039(preferredWidth, preferredHeight) {
        const width = Math.min(preferredWidth, window.screen.availWidth);
        const height = Math.min(preferredHeight, window.screen.availHeight);
        return Object.entries({
            toolbar: 0,
            menubar: 0,
            location: 0,
            status: 0,
            scrollbars: 1,
            resizable: 0,
            chrome: 'yes',
            width: width,
            height: height,
            left: Math.round((window.innerWidth - width) / 2 + window.screenX),
            top: Math.round((window.innerHeight - height) / 3 + window.screenY)
        }).map(([key, value])=>`${key}=${value}`).join(',');
    }
});
parcelRegister("g1YUU", function(module, exports) {
    $parcel$export(module.exports, "isAcceptableFailure", ()=>$543b49fcc280bf32$export$678d91a98f79a24d);
    const $543b49fcc280bf32$export$678d91a98f79a24d = (statusCode)=>!statusCode || statusCode === 400 || statusCode === 401 || statusCode === 403;
});
parcelRegister("98FOM", function(module, exports) {
    $parcel$export(module.exports, "UfoExperiences", ()=>$a70375286e62f1f6$export$72df3c76208340b5);
    $parcel$export(module.exports, "ufoExperiences", ()=>$a70375286e62f1f6$export$615f888019c45765);
    $parcel$export(module.exports, "startUfoExperience", ()=>$a70375286e62f1f6$export$5e9287b6a10f8075);
    $parcel$export(module.exports, "succeedUfoExperience", ()=>$a70375286e62f1f6$export$c5a5cf072c836c0e);
    $parcel$export(module.exports, "failUfoExperience", ()=>$a70375286e62f1f6$export$8dda83bafca11b77);
    $parcel$export(module.exports, "abortUfoExperience", ()=>$a70375286e62f1f6$export$b1021040eb94cdca);
    var $atdLB;
    var $duUGa;
    var $a70375286e62f1f6$export$72df3c76208340b5;
    (function(UfoExperiences) {
        UfoExperiences["SLACK_SEGMENT_RENDERED"] = "slack-segment-rendered";
        UfoExperiences["SLACK_REQUEST_SENT"] = "slack-request-sent";
        UfoExperiences["SLACK_FORM_ENABLED"] = "share-form-enabled";
        UfoExperiences["PLATFORM_SLACK_USERS_PAGE_FETCHED"] = "platform-slack-users-page-fetched";
    })($a70375286e62f1f6$export$72df3c76208340b5 || ($a70375286e62f1f6$export$72df3c76208340b5 = {}));
    var $a70375286e62f1f6$var$PlatformComponent;
    (function(PlatformComponent) {
        PlatformComponent["ShareToSlack"] = "share-to-slack";
        PlatformComponent["CoreInvites"] = "core-invites";
    })($a70375286e62f1f6$var$PlatformComponent || ($a70375286e62f1f6$var$PlatformComponent = {}));
    const $a70375286e62f1f6$export$615f888019c45765 = {
        ["slack-request-sent"]: new (0, (0, parcelRequire("duUGa")).UFOExperience)("slack-request-sent", {
            type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Experience,
            performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).Custom,
            platform: {
                component: "share-to-slack"
            }
        }),
        ["slack-segment-rendered"]: new (0, (0, parcelRequire("duUGa")).UFOExperience)("slack-segment-rendered", {
            type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Load,
            performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).PageSegmentLoad,
            platform: {
                component: "share-to-slack"
            }
        }),
        ["share-form-enabled"]: new (0, (0, parcelRequire("duUGa")).UFOExperience)("share-form-enabled", {
            type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Load,
            performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).Custom,
            platform: {
                component: "share-to-slack"
            }
        }),
        ["platform-slack-users-page-fetched"]: new (0, (0, parcelRequire("duUGa")).UFOExperience)("platform-slack-users-page-fetched", {
            type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Load,
            performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).Custom,
            platform: {
                component: "core-invites"
            }
        })
    };
    const $a70375286e62f1f6$export$5e9287b6a10f8075 = (experienceName, properties)=>{
        const experience = $a70375286e62f1f6$export$615f888019c45765[experienceName];
        experience.start();
        if (properties) experience.addMetadata(properties);
    };
    const $a70375286e62f1f6$export$c5a5cf072c836c0e = (experienceName, properties)=>{
        const experience = $a70375286e62f1f6$export$615f888019c45765[experienceName];
        experience.success({
            metadata: properties
        });
    };
    const $a70375286e62f1f6$export$8dda83bafca11b77 = (experienceName, properties)=>{
        const experience = $a70375286e62f1f6$export$615f888019c45765[experienceName];
        experience.failure({
            metadata: properties
        });
    };
    const $a70375286e62f1f6$export$b1021040eb94cdca = (experienceName, properties)=>{
        const experience = $a70375286e62f1f6$export$615f888019c45765[experienceName];
        experience.abort({
            metadata: properties
        });
    };
});
parcelRegister("cByYp", function(module, exports) {
    $parcel$export(module.exports, "getSlackServiceAnalytics", ()=>$c102fdd7a86ad41c$export$2b9ff26dd710d5d7);
    $parcel$export(module.exports, "getConfluenceSlackServiceAnalytics", ()=>$c102fdd7a86ad41c$export$2cc68fa43a97a8c);
    var $gB4mS;
    const $c102fdd7a86ad41c$var$createAndFireEventOnPeopleTeams = (0, (0, parcelRequire("gB4mS")).default)((0, $b21f23f22e452d68$export$85183a312807388d));
    var $c102fdd7a86ad41c$var$AnalyticsActionSubject;
    (function(AnalyticsActionSubject) {
        AnalyticsActionSubject["INTEGRATION_SUCCEEDED"] = "integrationEnabled";
        AnalyticsActionSubject["INTEGRATION_TEAMS"] = "integrationTeams";
        AnalyticsActionSubject["INTEGRATION_CONVERSATIONS"] = "integrationConversations";
        AnalyticsActionSubject["INTEGRATION_METADATA"] = "integrationMetadata";
        AnalyticsActionSubject["INTEGRATION_TOKEN"] = "integrationCsrfToken";
        AnalyticsActionSubject["SHARE"] = "share";
    })($c102fdd7a86ad41c$var$AnalyticsActionSubject || ($c102fdd7a86ad41c$var$AnalyticsActionSubject = {}));
    var $c102fdd7a86ad41c$var$AnalyticsAction;
    (function(AnalyticsAction) {
        AnalyticsAction["FAILED"] = "failed";
        AnalyticsAction["SUCCEEDED"] = "succeeded";
    })($c102fdd7a86ad41c$var$AnalyticsAction || ($c102fdd7a86ad41c$var$AnalyticsAction = {}));
    const $c102fdd7a86ad41c$export$e0925453bd625a62 = (createAnalyticsEvent)=>{
        const fireEventWithPayload = $c102fdd7a86ad41c$var$createAndFireEventOnPeopleTeams({
            eventType: (0, $676c5e519aa5ba55$export$12346a674644c156),
            actionSubject: "integrationEnabled",
            action: "succeeded"
        });
        fireEventWithPayload(createAnalyticsEvent);
    };
    const $c102fdd7a86ad41c$export$d533ef9287e29338 = (createAnalyticsEvent, { status: status, errorMessage: errorMessage })=>{
        const fireEventWithPayload = $c102fdd7a86ad41c$var$createAndFireEventOnPeopleTeams({
            eventType: (0, $676c5e519aa5ba55$export$12346a674644c156),
            actionSubject: "integrationEnabled",
            action: "failed",
            attributes: {
                status: status,
                errorMessage: errorMessage
            }
        });
        fireEventWithPayload(createAnalyticsEvent);
    };
    const $c102fdd7a86ad41c$export$10723e48240e4b6a = (createAnalyticsEvent, { teams: teams, pages: pages })=>{
        const fireEventWithPayload = $c102fdd7a86ad41c$var$createAndFireEventOnPeopleTeams({
            eventType: (0, $676c5e519aa5ba55$export$12346a674644c156),
            actionSubject: "integrationTeams",
            action: "succeeded",
            attributes: {
                teams: teams,
                pages: pages
            }
        });
        fireEventWithPayload(createAnalyticsEvent);
    };
    const $c102fdd7a86ad41c$export$77d7c2557ef0cb5b = (createAnalyticsEvent, { page: page, status: status, errorMessage: errorMessage })=>{
        const fireEventWithPayload = $c102fdd7a86ad41c$var$createAndFireEventOnPeopleTeams({
            eventType: (0, $676c5e519aa5ba55$export$12346a674644c156),
            actionSubject: "integrationTeams",
            action: "failed",
            attributes: {
                page: page,
                status: status,
                errorMessage: errorMessage
            }
        });
        fireEventWithPayload(createAnalyticsEvent);
    };
    const $c102fdd7a86ad41c$export$1fb50f4a006f5510 = (createAnalyticsEvent, { slackTeamId: slackTeamId, conversationTypes: conversationTypes, conversations: conversations, pages: pages })=>{
        const fireEventWithPayload = $c102fdd7a86ad41c$var$createAndFireEventOnPeopleTeams({
            eventType: (0, $676c5e519aa5ba55$export$12346a674644c156),
            actionSubject: "integrationConversations",
            action: "succeeded",
            attributes: {
                integrationTeamId: slackTeamId,
                conversationTypes: conversationTypes,
                conversations: conversations,
                pages: pages
            }
        });
        fireEventWithPayload(createAnalyticsEvent);
    };
    const $c102fdd7a86ad41c$export$121a5feec5d3a18f = (createAnalyticsEvent, { slackTeamId: slackTeamId, conversationTypes: conversationTypes, page: page, status: status, errorMessage: errorMessage })=>{
        const fireEventWithPayload = $c102fdd7a86ad41c$var$createAndFireEventOnPeopleTeams({
            eventType: (0, $676c5e519aa5ba55$export$12346a674644c156),
            actionSubject: "integrationConversations",
            action: "failed",
            attributes: {
                integrationTeamId: slackTeamId,
                conversationTypes: conversationTypes,
                page: page,
                status: status,
                errorMessage: errorMessage
            }
        });
        fireEventWithPayload(createAnalyticsEvent);
    };
    const $c102fdd7a86ad41c$export$503ff4642f649174 = (createAnalyticsEvent)=>{
        const fireEventWithPayload = $c102fdd7a86ad41c$var$createAndFireEventOnPeopleTeams({
            eventType: (0, $676c5e519aa5ba55$export$12346a674644c156),
            actionSubject: "integrationMetadata",
            action: "succeeded"
        });
        fireEventWithPayload(createAnalyticsEvent);
    };
    const $c102fdd7a86ad41c$export$68485a36cbb1a06f = (createAnalyticsEvent, params)=>{
        const fireEventWithPayload = $c102fdd7a86ad41c$var$createAndFireEventOnPeopleTeams({
            eventType: (0, $676c5e519aa5ba55$export$12346a674644c156),
            actionSubject: "integrationMetadata",
            action: "failed",
            attributes: {
                ...params
            }
        });
        fireEventWithPayload(createAnalyticsEvent);
    };
    const $c102fdd7a86ad41c$export$5cc3ad7b898341e7 = (createAnalyticsEvent)=>{
        const fireEventWithPayload = $c102fdd7a86ad41c$var$createAndFireEventOnPeopleTeams({
            eventType: (0, $676c5e519aa5ba55$export$12346a674644c156),
            actionSubject: "integrationMetadata",
            action: "succeeded"
        });
        fireEventWithPayload(createAnalyticsEvent);
    };
    const $c102fdd7a86ad41c$export$757b1ed45dd16a84 = (createAnalyticsEvent)=>{
        const fireEventWithPayload = $c102fdd7a86ad41c$var$createAndFireEventOnPeopleTeams({
            eventType: (0, $676c5e519aa5ba55$export$12346a674644c156),
            actionSubject: "integrationCsrfToken",
            action: "failed"
        });
        fireEventWithPayload(createAnalyticsEvent);
    };
    const $c102fdd7a86ad41c$var$productActionSubjectId = {
        jira: 'issue',
        confluence: 'page',
        platform: 'issue'
    };
    const $c102fdd7a86ad41c$export$24b0574fd3374a47 = ({ product: product, slackTeamId: slackTeamId, conversationType: conversationType, conversationId: conversationId, messageLength: messageLength, userCount: userCount }, createAnalyticsEvent)=>{
        const fireEventWithPayload = $c102fdd7a86ad41c$var$createAndFireEventOnPeopleTeams({
            eventType: (0, $676c5e519aa5ba55$export$12346a674644c156),
            actionSubject: "share",
            action: "succeeded",
            actionSubjectId: $c102fdd7a86ad41c$var$productActionSubjectId[product],
            attributes: {
                integrationTeamId: slackTeamId,
                integrationConversationType: conversationType,
                integrationConversationId: conversationId,
                messageLength: messageLength,
                workspaceSize: userCount
            },
            source: 'integrationShareDialog'
        });
        fireEventWithPayload(createAnalyticsEvent);
    };
    const $c102fdd7a86ad41c$export$867fe86603399772 = ({ product: product, slackTeamId: slackTeamId, conversationType: conversationType, conversationId: conversationId, status: status, errorMessage: errorMessage }, createAnalyticsEvent)=>{
        const fireEventWithPayload = $c102fdd7a86ad41c$var$createAndFireEventOnPeopleTeams({
            eventType: (0, $676c5e519aa5ba55$export$12346a674644c156),
            actionSubject: "share",
            action: "failed",
            actionSubjectId: $c102fdd7a86ad41c$var$productActionSubjectId[product],
            attributes: {
                integrationTeamId: slackTeamId,
                integrationConversationType: conversationType,
                integrationConversationId: conversationId,
                status: status,
                errorMessage: errorMessage
            },
            source: 'integrationShareDialog'
        });
        fireEventWithPayload(createAnalyticsEvent);
    };
    const $c102fdd7a86ad41c$export$5a5d58e4161f41aa = ({ slackTeamId: slackTeamId, conversationTypes: conversationTypes, conversations: conversations, pages: pages, actionSubjectId: actionSubjectId }, createAnalyticsEvent)=>{
        const fireEventWithPayload = $c102fdd7a86ad41c$var$createAndFireEventOnPeopleTeams({
            eventType: (0, $676c5e519aa5ba55$export$12346a674644c156),
            actionSubject: 'integrationConversations',
            action: "succeeded",
            actionSubjectId: actionSubjectId,
            attributes: {
                integrationTeamId: slackTeamId,
                conversationTypes: conversationTypes,
                conversations: conversations,
                pages: pages
            },
            source: 'integrationShareDialog'
        });
        fireEventWithPayload(createAnalyticsEvent);
    };
    const $c102fdd7a86ad41c$export$1286eed6ab074bde = ({ slackTeamId: slackTeamId, conversationTypes: conversationTypes, page: page, status: status, errorMessage: errorMessage, actionSubjectId: actionSubjectId }, createAnalyticsEvent)=>{
        const fireEventWithPayload = $c102fdd7a86ad41c$var$createAndFireEventOnPeopleTeams({
            eventType: (0, $676c5e519aa5ba55$export$12346a674644c156),
            actionSubject: 'integrationConversations',
            action: "failed",
            actionSubjectId: actionSubjectId,
            attributes: {
                integrationTeamId: slackTeamId,
                conversationTypes: conversationTypes,
                page: page,
                status: status,
                errorMessage: errorMessage
            },
            source: 'integrationShareDialog'
        });
        fireEventWithPayload(createAnalyticsEvent);
    };
    const $c102fdd7a86ad41c$export$2b9ff26dd710d5d7 = (createAnalyticsEvent)=>({
            onGetEnabledSucceeded: ()=>$c102fdd7a86ad41c$export$e0925453bd625a62(createAnalyticsEvent),
            onGetEnabledFailed: (params)=>$c102fdd7a86ad41c$export$d533ef9287e29338(createAnalyticsEvent, params),
            onFetchTeamsSucceeded: (params)=>$c102fdd7a86ad41c$export$10723e48240e4b6a(createAnalyticsEvent, params),
            onFetchTeamsFailed: (params)=>$c102fdd7a86ad41c$export$77d7c2557ef0cb5b(createAnalyticsEvent, params),
            onFetchUsersSucceeded: ({ teamId: teamId, users: users, pages: pages })=>$c102fdd7a86ad41c$export$1fb50f4a006f5510(createAnalyticsEvent, {
                    slackTeamId: teamId || '',
                    conversationTypes: [
                        'directMessage'
                    ],
                    conversations: users || 0,
                    pages: pages
                }),
            onFetchUsersFailed: ({ teamId: teamId, page: page, status: status, errorMessage: errorMessage })=>$c102fdd7a86ad41c$export$121a5feec5d3a18f(createAnalyticsEvent, {
                    slackTeamId: teamId,
                    conversationTypes: [
                        'directMessage'
                    ],
                    page: page,
                    status: status,
                    errorMessage: errorMessage
                }),
            onShareSucceeded: ({ product: product, teamId: teamId, conversationType: conversationType, conversationId: conversationId, messageLength: messageLength, userCount: userCount })=>{
                $c102fdd7a86ad41c$export$24b0574fd3374a47({
                    product: product,
                    slackTeamId: teamId,
                    conversationType: conversationType,
                    conversationId: conversationId,
                    messageLength: messageLength,
                    userCount: userCount
                }, createAnalyticsEvent);
            },
            onShareFailed: ({ product: product, teamId: teamId, conversationType: conversationType, conversationId: conversationId, status: status, errorMessage: errorMessage })=>{
                $c102fdd7a86ad41c$export$867fe86603399772({
                    product: product,
                    slackTeamId: teamId,
                    conversationType: conversationType,
                    conversationId: conversationId,
                    status: status,
                    errorMessage: errorMessage
                }, createAnalyticsEvent);
            },
            onFetchChannelsSucceeded: ({ teamId: teamId, channels: channels, pages: pages })=>{
                $c102fdd7a86ad41c$export$5a5d58e4161f41aa({
                    slackTeamId: teamId,
                    conversationTypes: [
                        'public',
                        'private'
                    ],
                    conversations: channels,
                    pages: pages,
                    actionSubjectId: 'channels'
                }, createAnalyticsEvent);
            },
            onFetchChannelsFailed: ({ teamId: teamId, page: page, status: status, errorMessage: errorMessage })=>{
                $c102fdd7a86ad41c$export$1286eed6ab074bde({
                    slackTeamId: teamId,
                    conversationTypes: [
                        'public',
                        'private'
                    ],
                    page: page,
                    status: status,
                    errorMessage: errorMessage,
                    actionSubjectId: 'channels'
                }, createAnalyticsEvent);
            }
        });
    const $c102fdd7a86ad41c$export$2cc68fa43a97a8c = (createAnalyticsEvent)=>({
            onFetchConnectMetadataSucceeded: ()=>$c102fdd7a86ad41c$export$503ff4642f649174(createAnalyticsEvent),
            onFetchConnectMetadataFailed: (params)=>$c102fdd7a86ad41c$export$68485a36cbb1a06f(createAnalyticsEvent, params),
            onRefreshIntegrationCsrfTokenSucceeded: ()=>$c102fdd7a86ad41c$export$5cc3ad7b898341e7(createAnalyticsEvent),
            onRefreshIntegrationCsrfTokenFailed: ()=>$c102fdd7a86ad41c$export$757b1ed45dd16a84(createAnalyticsEvent)
        });
});
parcelRegister("iBUTl", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f9e6baa0295986a5$export$2e2bcd8739ae039);
    var $3UwlP;
    var $4Kuie;
    const $f9e6baa0295986a5$var$consentUrl = {
        prod: `https://confluence-chats-integr.services.atlassian.com/api/slack/teams/login?source=${(0, $b21f23f22e452d68$export$83c8d7110915321e)}`,
        staging: `https://confluence-chats-integr.stg.services.atlassian.com/api/slack/teams/login?source=${(0, $b21f23f22e452d68$export$83c8d7110915321e)}`
    };
    const $f9e6baa0295986a5$var$connectKey = {
        prod: 'confluence-chats-integration',
        staging: 'confluence-chats-integration-stg-east'
    };
    const $f9e6baa0295986a5$var$ACQUIRE_CSRF_TIMEOUT_MS = 2000;
    async function $f9e6baa0295986a5$export$2e2bcd8739ae039(location, analytics, signal) {
        const environment = (0, (0, parcelRequire("3UwlP")).default)(location.hostname);
        const response = await $f9e6baa0295986a5$var$getConfluenceSlackIntegrationDialogParams(location, signal);
        if (!response.ok) {
            if (!response.aborted) analytics.onFetchConnectMetadataFailed({
                status: response.status,
                errorMessage: response.message
            });
            return response;
        }
        analytics.onFetchConnectMetadataSucceeded();
        const { contextJwt: contextJwt, url: url } = response.result;
        try {
            await (0, (0, parcelRequire("4Kuie")).default)(url, $f9e6baa0295986a5$var$ACQUIRE_CSRF_TIMEOUT_MS);
            analytics.onRefreshIntegrationCsrfTokenSucceeded();
        } catch (error) {
            analytics.onRefreshIntegrationCsrfTokenFailed();
        }
        return {
            ok: true,
            result: `${$f9e6baa0295986a5$var$consentUrl[environment]}&jwt=${encodeURIComponent(contextJwt)}`
        };
    }
    async function $f9e6baa0295986a5$var$getConfluenceSlackIntegrationDialogParams(location, signal) {
        const connectPath = $f9e6baa0295986a5$var$getConnectPath(location);
        try {
            const response = await fetch(connectPath, {
                method: 'POST',
                headers: {
                    'content-type': 'application/x-www-form-urlencoded; charset=UTF-8'
                },
                signal: signal,
                body: Object.entries({
                    'plugin-key': 'confluence-chats-integration',
                    key: 'dialog',
                    productContext: '{}',
                    classifier: 'json'
                }).map((kvp)=>kvp.map(encodeURIComponent).join('=')).join('&')
            });
            if (response.ok) return {
                ok: true,
                result: await response.json()
            };
            return {
                ok: false,
                aborted: false,
                status: response.status,
                code: `${response.status}`,
                message: await response.text()
            };
        } catch (error) {
            if (error instanceof Error) {
                if (error.name === 'AbortError') return {
                    ok: false,
                    aborted: true
                };
                return {
                    ok: false,
                    aborted: false,
                    status: (0, $b21f23f22e452d68$export$2c32b0fe4533d89e),
                    code: (0, $b21f23f22e452d68$export$9267d266a5449137),
                    message: error.message || (0, $b21f23f22e452d68$export$33789febc109c023)
                };
            }
            return {
                ok: false,
                aborted: false,
                status: (0, $b21f23f22e452d68$export$2c32b0fe4533d89e),
                code: (0, $b21f23f22e452d68$export$9267d266a5449137),
                message: (0, $b21f23f22e452d68$export$33789febc109c023)
            };
        }
    }
    function $f9e6baa0295986a5$var$getConnectPath(location) {
        const environment = (0, (0, parcelRequire("3UwlP")).default)(location.hostname);
        return `/wiki/plugins/servlet/ac/${$f9e6baa0295986a5$var$connectKey[environment]}/dialog`;
    }
});
parcelRegister("3UwlP", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$35346a90866bf1cc$export$2e2bcd8739ae039);
    function $35346a90866bf1cc$export$2e2bcd8739ae039(hostname) {
        return hostname.endsWith('jira-dev.com') || hostname.endsWith('localhost') ? 'staging' : 'prod';
    }
});
parcelRegister("4Kuie", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9cd1ccdabc754196$export$2e2bcd8739ae039);
    function $9cd1ccdabc754196$export$2e2bcd8739ae039(url, timeoutMs) {
        const iframe = document.createElement('iframe');
        iframe.src = url;
        iframe.width = '0';
        iframe.height = '0';
        iframe.style.position = 'absolute';
        iframe.style.visibility = 'hidden';
        iframe.style.borderWidth = '0';
        document.body.appendChild(iframe);
        return new Promise((resolve, reject)=>{
            let completed = false;
            const timeout = setTimeout(()=>{
                completed = true;
                document.body.removeChild(iframe);
                reject();
            }, timeoutMs);
            iframe.onload = ()=>{
                if (!completed) {
                    clearTimeout(timeout);
                    completed = true;
                    document.body.removeChild(iframe);
                    resolve();
                }
            };
        });
    }
});
parcelRegister("1IQ8k", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$10f0f4dca2163b51$export$2e2bcd8739ae039);
    var $ak6EA;
    var $cByYp;
    var $bsm0s;
    class $10f0f4dca2163b51$export$2e2bcd8739ae039 extends (0, (0, parcelRequire("ak6EA")).default) {
        constructor(cloudId, createUIAnalyticsEvent){
            const analytics = (0, (0, parcelRequire("cByYp")).getSlackServiceAnalytics)(createUIAnalyticsEvent);
            super(cloudId, 'jira', analytics);
        }
        async primeConsentUrl() {
            if (!this.consentUrl) this.consentUrl = (0, (0, parcelRequire("bsm0s")).default)(location);
        }
    }
});
parcelRegister("bsm0s", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7b92fc389a33ea19$export$2e2bcd8739ae039);
    var $3UwlP;
    const $7b92fc389a33ea19$var$consentUrl = {
        prod: `https://atlassian-slack-integration.services.atlassian.com/api/slack/login?source=${(0, $b21f23f22e452d68$export$83c8d7110915321e)}`,
        staging: `https://atlassian-slack-integration.stg.services.atlassian.com/api/slack/login?source=${(0, $b21f23f22e452d68$export$83c8d7110915321e)}`
    };
    function $7b92fc389a33ea19$export$2e2bcd8739ae039(location) {
        const environment = (0, (0, parcelRequire("3UwlP")).default)(location.hostname);
        return $7b92fc389a33ea19$var$consentUrl[environment];
    }
});
parcelRegister("6pj04", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$621a1e491e72207e$export$2e2bcd8739ae039);
    var $ak6EA;
    var $cByYp;
    var $98FOM;
    var $6DRRy;
    const $621a1e491e72207e$var$USER_FETCH_LIMIT = 500;
    const $621a1e491e72207e$var$RETRY_OPTIONS = {
        maxAttempts: 3,
        backoffTimeMs: 200,
        rateLimitBackoffTimeMs: 1000
    };
    class $621a1e491e72207e$export$2e2bcd8739ae039 extends (0, (0, parcelRequire("ak6EA")).default) {
        constructor(cloudId, createUIAnalyticsEvent){
            const analytics = (0, (0, parcelRequire("cByYp")).getSlackServiceAnalytics)(createUIAnalyticsEvent);
            super(cloudId, 'platform', analytics);
        }
        streamUsers(teamId, onResponse, cursor) {
            (0, (0, parcelRequire("98FOM")).startUfoExperience)((0, (0, parcelRequire("98FOM")).UfoExperiences).PLATFORM_SLACK_USERS_PAGE_FETCHED, {
                limit: $621a1e491e72207e$var$USER_FETCH_LIMIT
            });
            if (!cursor) this.userStream = {
                count: 0,
                pages: 0,
                finishedLoading: false
            };
            const queryString = new URLSearchParams({
                teamId: teamId,
                cloudId: this.cloudId,
                limit: $621a1e491e72207e$var$USER_FETCH_LIMIT.toString(),
                ...cursor ? {
                    cursor: cursor
                } : {}
            });
            (0, (0, parcelRequire("6DRRy")).retryFetch)({
                request: ()=>fetch(`${(0, $b21f23f22e452d68$export$ab2f49a861856bab)}${(0, $b21f23f22e452d68$export$127769e597bc5ee5)}/slack/users?${queryString}`, {
                        signal: this.abortController?.signal
                    }),
                canRetryCheck: (0, (0, parcelRequire("6DRRy")).httpRetryPolicy)($621a1e491e72207e$var$RETRY_OPTIONS)
            }).then((resp)=>{
                if (!resp.ok) {
                    if (!resp.aborted) {
                        this.analytics.onFetchUsersFailed({
                            teamId: teamId,
                            page: this.userStream.pages,
                            status: resp.status,
                            errorMessage: resp.message
                        });
                        (0, (0, parcelRequire("98FOM")).failUfoExperience)((0, (0, parcelRequire("98FOM")).UfoExperiences).PLATFORM_SLACK_USERS_PAGE_FETCHED);
                    } else (0, (0, parcelRequire("98FOM")).abortUfoExperience)((0, (0, parcelRequire("98FOM")).UfoExperiences).PLATFORM_SLACK_USERS_PAGE_FETCHED);
                    onResponse(resp);
                    return;
                }
                this.userStream.pages++;
                this.userStream.count += resp.result.users.length;
                this.userStream.finishedLoading = !!resp.result.nextCursor;
                onResponse({
                    ok: true,
                    result: resp.result.users.map(({ id: id, email: email, displayName: displayName, realName: name, avatar: avatarUrl })=>({
                            id: id,
                            name: name,
                            displayName: displayName,
                            avatarUrl: avatarUrl,
                            email: email,
                            type: 'directMessage'
                        })),
                    nextCursor: resp.result.nextCursor
                });
                (0, (0, parcelRequire("98FOM")).succeedUfoExperience)((0, (0, parcelRequire("98FOM")).UfoExperiences).PLATFORM_SLACK_USERS_PAGE_FETCHED, {
                    numResults: resp.result.users.length
                });
                if (resp.result.nextCursor) this.streamUsers(teamId, onResponse, resp.result.nextCursor);
                else this.analytics.onFetchUsersSucceeded({
                    teamId: teamId,
                    users: this.userStream.count,
                    pages: this.userStream.pages
                });
            });
        }
        streamChannelsExperiment(workspaceId, onResponse, onError, cursor) {
            if (!cursor) this.channelStream = {
                count: 0,
                pages: 0,
                finishedLoading: false
            };
            const queryString = new URLSearchParams({
                workspaceId: workspaceId,
                ...cursor ? {
                    cursor: cursor
                } : {}
            });
            (0, (0, parcelRequire("6DRRy")).retryFetch)({
                request: ()=>fetch(`${(0, $b21f23f22e452d68$export$ab2f49a861856bab)}${(0, $b21f23f22e452d68$export$20875166a8676880)}${(0, $b21f23f22e452d68$export$3f9855fcc7fa383e)}?${queryString}`, {
                        signal: this.abortController?.signal
                    }),
                canRetryCheck: (0, (0, parcelRequire("6DRRy")).httpRetryPolicy)($621a1e491e72207e$var$RETRY_OPTIONS)
            }).then((resp)=>{
                if (!resp.ok) {
                    onResponse(resp);
                    return;
                }
                this.channelStream.pages++;
                this.channelStream.count += resp.result.channels.length;
                this.channelStream.finishedLoading = !!resp.result.nextCursor;
                onResponse({
                    ok: true,
                    result: resp.result.channels,
                    nextCursor: resp.result.nextCursor
                });
                if (resp.result.nextCursor) this.streamChannelsExperiment(workspaceId, onResponse, onError, resp.result.nextCursor);
            }).catch((error)=>{
                onError(error);
            });
        }
        async primeConsentUrl() {}
    }
});
parcelRegister("2JsdQ", function(module, exports) {
    $parcel$export(module.exports, "useInvitePeopleModal", ()=>$e68e6d998c14d38d$export$b9ec44715ae5ad99);
    var $5uXOq = parcelRequire("5uXOq");
    var $fElvF;
    const $e68e6d998c14d38d$export$b9ec44715ae5ad99 = (useInvitePeopleModalProps)=>{
        const { onClose: onClose, ...invitePeopleProps } = useInvitePeopleModalProps;
        const { openModal: openModal, closeModal: closeModal, isOpen: isOpen } = (0, $5uXOq.useContext)((0, (0, parcelRequire("fElvF")).InvitePeopleModalContext));
        return {
            experimental_openModal: (propsOverride)=>openModal({
                    ...invitePeopleProps,
                    ...propsOverride
                }, onClose),
            openModal: ()=>openModal(invitePeopleProps, onClose),
            closeModal: closeModal,
            isOpen: isOpen
        };
    };
});
parcelRegister("fqbGj", function(module, exports) {
    $parcel$export(module.exports, "NudgeSpotlight", ()=>$8ea39cee960047f1$export$eebbda33f5d4d735);
    var $5uXOq = parcelRequire("5uXOq");
    var $jC4R5;
    var $k8nZq;
    var $4oNEb;
    var $cBeZP;
    var $4AhK0;
    var $4aeUu;
    var $ao4Ml = parcelRequire("ao4Ml");
    const $8ea39cee960047f1$var$blinkNudge = (nudgeBlinkId, eventTarget, setAnimateIn)=>{
        const nudgeBlinkTriggers = Array.from(document.querySelectorAll(`[data-nudge-blink='${nudgeBlinkId}']`));
        const clickIsInsideTrigger = nudgeBlinkTriggers?.some((triggerElement)=>{
            return triggerElement && triggerElement.contains(eventTarget);
        });
        if (clickIsInsideTrigger) {
            setAnimateIn(true);
            return true;
        }
        return false;
    };
    const $8ea39cee960047f1$export$eebbda33f5d4d735 = (0, $5uXOq.forwardRef)(({ hidden: externalHidden, setHidden: setHidden, hideNudgeOnClick: hideNudgeOnClick = true, hideSpotlightCardOnOutsideClick: hideSpotlightCardOnOutsideClick = true, concealSpotlightOnReferenceHidden: concealSpotlightOnReferenceHidden = false, showSpotlightCardOnFirstRender: showSpotlightCardOnFirstRender = true, children: children, spotlightCard: Spotlight = (0, (0, parcelRequire("4AhK0")).default), nudge: Nudge = (0, (0, parcelRequire("jC4R5")).DefaultNudge), position: position = 'bottom', offset: offset, zIndex: zIndex = 800, onRender: onRender, onShow: onShow, onHide: onHide, onClick: onClick, onOutsideClick: onOutsideClick, pulseColor: pulseColor, pulseShadowColor: pulseShadowColor, pulseBorderRadius: pulseBorderRadius, nudgeBlinkId: nudgeBlinkId, nudgeTestId: nudgeTestId, nudgeTag: nudgeTag, headingId: headingId, ...spotlightCardProps }, nudgeSpotlightRef)=>{
        const handlers = (0, $5uXOq.useRef)();
        handlers.current = {
            onRender: onRender,
            onHide: onHide,
            onShow: onShow,
            onClick: onClick,
            onOutsideClick: onOutsideClick
        };
        const nudgeRef = (0, $5uXOq.useRef)(null);
        const spotlightCardRef = (0, $5uXOq.useRef)(null);
        const showNudge = !externalHidden;
        const [canShowSpotlight, setCanShowSpotlight] = (0, $5uXOq.useState)(showSpotlightCardOnFirstRender);
        const [showSpotlight, setShowSpotlight] = (0, $5uXOq.useState)(false);
        const [shouldBlink, setShouldBlink] = (0, $5uXOq.useState)(false);
        const stopBlink = (0, $5uXOq.useCallback)(()=>setShouldBlink(false), []);
        const forceUpdateFnRef = (0, $5uXOq.useRef)({
            fn: ()=>{}
        });
        (0, $5uXOq.useImperativeHandle)(nudgeSpotlightRef, ()=>({
                toggleCardVisibility: setCanShowSpotlight,
                forceUpdateCardPosition: ()=>forceUpdateFnRef.current.fn()
            }), [
            setCanShowSpotlight
        ]);
        const markReadyToShow = (0, $5uXOq.useCallback)(()=>showNudge && setCanShowSpotlight(true), [
            showNudge
        ]);
        const onTargetClick = (0, $5uXOq.useCallback)((event)=>{
            if (!externalHidden) {
                if (hideNudgeOnClick) setHidden(event);
                handlers.current?.onClick?.();
            }
        }, [
            externalHidden,
            hideNudgeOnClick,
            setHidden,
            handlers
        ]);
        (0, $5uXOq.useEffect)(()=>{
            setShowSpotlight(showNudge && canShowSpotlight);
        }, [
            showNudge,
            canShowSpotlight
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (!externalHidden) {
                handlers.current?.onRender?.();
                return ()=>handlers.current?.onHide?.();
            }
        }, [
            externalHidden,
            handlers
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (showSpotlight) handlers.current?.onShow?.();
        }, [
            showSpotlight,
            handlers
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (externalHidden) setCanShowSpotlight(showSpotlightCardOnFirstRender);
        }, [
            externalHidden,
            showSpotlightCardOnFirstRender
        ]);
        (0, $5uXOq.useEffect)(()=>{
            let unbind;
            let timeout;
            if (showSpotlight && hideSpotlightCardOnOutsideClick) timeout = window.setTimeout(()=>{
                unbind = (0, (0, parcelRequire("cBeZP")).bind)(window, {
                    type: 'click',
                    listener: (event)=>{
                        const eventTarget = event.target;
                        if (nudgeRef.current && spotlightCardRef.current && eventTarget instanceof Node && !nudgeRef.current.contains(eventTarget) && !spotlightCardRef.current.contains(eventTarget)) {
                            if (nudgeBlinkId) {
                                const didBlink = $8ea39cee960047f1$var$blinkNudge(nudgeBlinkId, eventTarget, setShouldBlink);
                                if (didBlink) return;
                            }
                            setCanShowSpotlight(false);
                            handlers.current?.onOutsideClick?.();
                            unbind?.();
                        }
                    },
                    options: {
                        capture: true,
                        passive: true
                    }
                });
            });
            return ()=>{
                unbind?.();
                window.clearTimeout(timeout);
            };
        }, [
            showSpotlight,
            hideSpotlightCardOnOutsideClick,
            setHidden,
            handlers,
            nudgeBlinkId
        ]);
        const concealSpotlightOnScrollStyles = (isReferenceHidden)=>concealSpotlightOnReferenceHidden && isReferenceHidden ? {
                display: 'none'
            } : {};
        const cardConfig = (0, $5uXOq.useMemo)(()=>Spotlight === (0, (0, parcelRequire("4AhK0")).default) ? {
                ...spotlightCardProps,
                id: nudgeBlinkId
            } : {
                cardTestId: spotlightCardProps.cardTestId
            }, [
            Spotlight,
            spotlightCardProps,
            nudgeBlinkId
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Fragment), null, (0, ($parcel$interopDefault($5uXOq))).createElement(Nudge, {
            ref: nudgeRef,
            hasPulse: showNudge,
            onClickCapture: onTargetClick,
            onMouseEnter: markReadyToShow,
            pulseColor: pulseColor,
            pulseShadowColor: pulseShadowColor,
            pulseBorderRadius: pulseBorderRadius,
            nudgeTestId: nudgeTestId,
            tag: nudgeTag
        }, children), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k8nZq")).default), {
            zIndex: zIndex
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4oNEb")).Popper), {
            placement: position,
            referenceElement: nudgeRef.current || undefined,
            offset: offset
        }, ({ ref: ref, style: popperStyles, forceUpdate: forceUpdate, isReferenceHidden: isReferenceHidden })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4aeUu")).SpotlightContainer), {
                showSpotlight: showSpotlight,
                shouldBlink: shouldBlink,
                stopBlink: stopBlink,
                zIndex: zIndex,
                ref: ref,
                containerStyles: {
                    ...popperStyles,
                    ...concealSpotlightOnScrollStyles(isReferenceHidden)
                },
                role: "dialog",
                ariaLabelledBy: headingId || 'nudge-spot-light-card-heading'
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $ao4Ml.default), null, (forceUpdateFnRef.current.fn = forceUpdate) && null, (0, ($parcel$interopDefault($5uXOq))).createElement(Spotlight, {
                ...cardConfig,
                ref: spotlightCardRef
            }))))));
    });
    var $8ea39cee960047f1$export$2e2bcd8739ae039 = $8ea39cee960047f1$export$eebbda33f5d4d735;
});
parcelRegister("jC4R5", function(module, exports) {
    $parcel$export(module.exports, "DefaultNudge", ()=>$d88355bc6c5eb74c$export$b7d614104f4a4a7c);
    var $5uXOq = parcelRequire("5uXOq");
    var $5XLZB;
    const $d88355bc6c5eb74c$export$b7d614104f4a4a7c = (0, $5uXOq.forwardRef)(({ children: children, nudgeTestId: nudgeTestId, ...rest }, ref)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5XLZB")).NudgeTooltipPulse), {
            ...rest,
            ref: ref,
            "data-testid": nudgeTestId
        }, children));
});
parcelRegister("5XLZB", function(module, exports) {
    $parcel$export(module.exports, "NudgeTooltipPulse", ()=>$589071e97cffed79$export$2d11151259bb3b10);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $k5uoT;
    function $589071e97cffed79$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $589071e97cffed79$var$baseShadow = '0 0 0 3px';
    const $589071e97cffed79$var$basePulseColor = `var(--ds-border-accent-purple, ${(0, $829f609a65d26a98$exports).P75})`;
    const $589071e97cffed79$var$basePulseShadowColor = "var(--ds-border-accent-purple, rgba(101, 84, 192, 1))";
    const $589071e97cffed79$var$easing = 'cubic-bezier(0.55, 0.055, 0.675, 0.19)';
    const $589071e97cffed79$var$pulseAnimation = (0, (0, parcelRequire("f8Sb3")).css)({
        '@keyframes pulseKeyframes': {
            '0%': {
                opacity: 0
            },
            '50%': {
                opacity: 1
            },
            '100%': {
                opacity: 0
            }
        },
        animation: `pulseKeyframes 3000ms ${$589071e97cffed79$var$easing} infinite`
    });
    const $589071e97cffed79$var$pseudoStyle = {
        name: "24nntw",
        styles: "content:'';position:absolute;top:0;left:0;width:100%;height:100%"
    };
    const $589071e97cffed79$export$814d9bf8c56ac913 = ({ hasPulse: hasPulse, pulseBorderRadius: pulseBorderRadius, pulseColor: pulseColor, pulseShadowColor: pulseShadowColor })=>(0, (0, parcelRequire("f8Sb3")).css)({
            display: 'block',
            '> *': {
                position: 'relative',
                '&::before': [
                    $589071e97cffed79$var$pseudoStyle,
                    {
                        borderRadius: `${pulseBorderRadius}px`,
                        boxShadow: `${$589071e97cffed79$var$baseShadow} ${pulseColor}`,
                        opacity: hasPulse ? 1 : 0,
                        transition: 'opacity 0.1s ease-in-out',
                        pointerEvents: 'none'
                    }
                ],
                '&::after': [
                    $589071e97cffed79$var$pseudoStyle,
                    {
                        borderRadius: `${pulseBorderRadius}px`,
                        boxShadow: `${$589071e97cffed79$var$baseShadow} ${pulseColor}, 0 0 11px ${pulseShadowColor}`,
                        opacity: 0,
                        pointerEvents: 'none'
                    },
                    hasPulse && $589071e97cffed79$var$pulseAnimation
                ]
            }
        });
    const $589071e97cffed79$export$2d11151259bb3b10 = (0, $5uXOq.forwardRef)(({ hasPulse: hasPulse, pulseBorderRadius: pulseBorderRadius = (0, (0, parcelRequire("k5uoT")).borderRadius)(), pulseColor: pulseColor = $589071e97cffed79$var$basePulseColor, pulseShadowColor: pulseShadowColor = $589071e97cffed79$var$basePulseShadowColor, tag: TargetContainer = 'span', ...rest }, ref)=>{
        const CastTargetContainer = TargetContainer;
        return (0, (0, parcelRequire("f8Sb3")).jsx)(CastTargetContainer, {
            css: $589071e97cffed79$export$814d9bf8c56ac913({
                hasPulse: hasPulse,
                pulseBorderRadius: pulseBorderRadius,
                pulseColor: pulseColor,
                pulseShadowColor: pulseShadowColor
            }),
            ref: ref,
            ...rest
        });
    });
});
parcelRegister("4AhK0", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b690ab706aa80c88$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    function $b690ab706aa80c88$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $b690ab706aa80c88$var$borderRadius = 3;
    const $b690ab706aa80c88$var$containerStyles = {
        color: `var(--ds-text-inverse, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
        boxShadow: `var(--ds-shadow-overlay, ${`0 4px 8px -2px ${(0, $829f609a65d26a98$export$7d3359664e8bb0e5)}, 0 0 1px ${(0, $829f609a65d26a98$export$d2d3bedfb276cac0)}`})`,
        backgroundColor: `var(--ds-background-discovery-bold, ${(0, $829f609a65d26a98$export$b48405b95304b5a1)})`,
        borderRadius: `${$b690ab706aa80c88$var$borderRadius}px`,
        overflow: 'auto'
    };
    const $b690ab706aa80c88$var$bodyStyles = {
        display: 'flex',
        flexDirection: 'column',
        padding: `${"var(--ds-space-200, 16px)"} ${"var(--ds-space-250, 20px)"}`
    };
    const $b690ab706aa80c88$var$headingStyles = {
        name: "1j2r6qm",
        styles: "font-size:1.42857em;font-style:inherit;line-height:1.2;font-weight:500;letter-spacing:-0.008em;margin-top:28px;color:inherit;&:first-child{margin-top:0;}"
    };
    const $b690ab706aa80c88$var$headerStyles = {
        display: 'flex',
        paddingBottom: "var(--ds-space-100, 8px)",
        alignItems: `baseline`,
        justifyContent: `space-between`
    };
    const $b690ab706aa80c88$var$footerStyles = {
        display: 'flex',
        paddingTop: "var(--ds-space-100, 8px)",
        alignItems: 'center',
        justifyContent: 'space-between'
    };
    const $b690ab706aa80c88$var$actionItemStyles = (index)=>(0, (0, parcelRequire("f8Sb3")).css)({
            margin: `0 ${"var(--ds-space-050, 4px)"}`,
            cursor: 'pointer',
            alignItems: 'baseline',
            borderWidth: '0px',
            borderRadius: '3px',
            boxSizing: 'border-box',
            display: 'inline-flex',
            fontSize: 'inherit',
            fontStyle: 'normal',
            fontFamily: 'inherit',
            fontWeight: 500,
            maxWidth: '100%',
            position: 'relative',
            textAlign: 'center',
            textDecoration: 'none',
            transition: 'background 0.1s ease-out 0s, box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38) 0s',
            whiteSpace: 'nowrap',
            background: index ? `var(--ds-background-discovery-bold, ${0, $829f609a65d26a98$export$b48405b95304b5a1})` : `var(--ds-background-inverse-subtle, ${0, $829f609a65d26a98$export$c71e4279dd54a18d})`,
            height: '2.28571em',
            lineHeight: '2.28571em',
            padding: '0px 10px',
            verticalAlign: 'middle',
            width: 'auto',
            justifyContent: 'center',
            color: `var(--ds-text-inverse, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
            '&:hover': {
                backgroundColor: `var(--ds-interaction-hovered, ${(0, $829f609a65d26a98$export$a7175d4e9206bc80)})`
            },
            '&:active': {
                backgroundColor: `var(--ds-interaction-pressed, ${(0, $829f609a65d26a98$export$a7175d4e9206bc80)})`
            }
        });
    const $b690ab706aa80c88$var$ActionItem = ({ index: index, ...rest })=>(0, (0, parcelRequire("f8Sb3")).jsx)("button", {
            css: $b690ab706aa80c88$var$actionItemStyles(index),
            ...rest
        });
    const $b690ab706aa80c88$var$actionItemContainerStyles = {
        display: 'flex',
        margin: `${"var(--ds-space-negative-050, -4px)"}`,
        flexDirection: 'row-reverse'
    };
    const $b690ab706aa80c88$export$b3ae98194e057550 = (0, $5uXOq.forwardRef)(({ image: image, heading: heading, actions: actions, actionsBeforeElement: actionsBeforeElement, width: width = 300, cardTestId: cardTestId, content: content, id: id }, ref)=>{
        const renderedActions = (0, $5uXOq.useMemo)(()=>actions?.map(({ text: text, onClick: onClick }, index)=>(0, (0, parcelRequire("f8Sb3")).jsx)($b690ab706aa80c88$var$ActionItem, {
                    index: index,
                    onClick: onClick,
                    key: `${text}-${index}`
                }, text)), [
            actions
        ]);
        const renderHeader = !!heading;
        const renderFooter = !!actionsBeforeElement || !!actions;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ref: ref,
            style: {
                ...$b690ab706aa80c88$var$containerStyles,
                width: `${width}px`
            },
            "data-testid": cardTestId
        }, typeof image === 'string' ? (0, (0, parcelRequire("f8Sb3")).jsx)("img", {
            src: image,
            alt: ""
        }) : image, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            style: $b690ab706aa80c88$var$bodyStyles,
            id: id
        }, renderHeader && (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            style: $b690ab706aa80c88$var$headerStyles
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            id: "nudge-spot-light-card-heading",
            css: $b690ab706aa80c88$var$headingStyles
        }, heading)), content, renderFooter && (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            style: $b690ab706aa80c88$var$footerStyles
        }, actionsBeforeElement || (0, (0, parcelRequire("f8Sb3")).jsx)("span", null), (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            style: $b690ab706aa80c88$var$actionItemContainerStyles
        }, renderedActions))));
    });
    var $b690ab706aa80c88$export$2e2bcd8739ae039 = $b690ab706aa80c88$export$b3ae98194e057550;
});
parcelRegister("4aeUu", function(module, exports) {
    $parcel$export(module.exports, "SpotlightContainer", ()=>$99a240fc01f7ca0b$export$d0f55839b708c0a0);
    var $5uXOq = parcelRequire("5uXOq");
    var $ahdj0;
    var $k8nZq;
    const $99a240fc01f7ca0b$export$474e8ee88cc7cd8f = 200;
    const $99a240fc01f7ca0b$export$3d6f334bf7dc4597 = 120;
    const $99a240fc01f7ca0b$var$defaultTransitionStyles = {
        opacity: 0,
        transitionProperty: 'opacity',
        transitionTimingFunction: 'ease-in-out',
        transitionDuration: `${$99a240fc01f7ca0b$export$474e8ee88cc7cd8f}ms`
    };
    const $99a240fc01f7ca0b$var$statefulTransitionStyles = {
        entering: {},
        entered: {
            opacity: 1
        },
        exiting: {
            transitionDuration: `${$99a240fc01f7ca0b$export$3d6f334bf7dc4597}ms`,
            opacity: 0
        },
        exited: {},
        unmounted: {}
    };
    const $99a240fc01f7ca0b$var$timeoutDurations = {
        enter: 0,
        exit: $99a240fc01f7ca0b$export$3d6f334bf7dc4597
    };
    const $99a240fc01f7ca0b$export$d0f55839b708c0a0 = (0, $5uXOq.forwardRef)(({ containerStyles: containerStyles, showSpotlight: showSpotlight, shouldBlink: shouldBlink, zIndex: zIndex, stopBlink: stopBlink, ariaLabelledBy: ariaLabelledBy, ...rest }, ref)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ahdj0")).default), {
            appear: true,
            in: showSpotlight && !shouldBlink,
            timeout: $99a240fc01f7ca0b$var$timeoutDurations,
            onExited: stopBlink,
            unmountOnExit: !shouldBlink
        }, (state)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k8nZq")).default), {
                zIndex: zIndex
            }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                style: {
                    ...containerStyles,
                    ...$99a240fc01f7ca0b$var$defaultTransitionStyles,
                    ...$99a240fc01f7ca0b$var$statefulTransitionStyles[state]
                },
                ref: ref,
                "aria-labelledby": ariaLabelledBy,
                ...rest
            }))));
});
parcelRegister("bdDiz", function(module, exports) {
    (function webpackUniversalModuleDefinition(root, factory) {
        module.exports = factory();
    })(typeof self !== 'undefined' ? self : module.exports, function() {
        return function(modules) {
            var installedModules = {};
            function __webpack_require__(moduleId) {
                if (installedModules[moduleId]) return installedModules[moduleId].exports;
                var module1 = installedModules[moduleId] = {
                    i: moduleId,
                    l: false,
                    exports: {}
                };
                modules[moduleId].call(module1.exports, module1, module1.exports, __webpack_require__);
                module1.l = true;
                return module1.exports;
            }
            __webpack_require__.m = modules;
            __webpack_require__.c = installedModules;
            __webpack_require__.d = function(exports, name, getter) {
                if (!__webpack_require__.o(exports, name)) Object.defineProperty(exports, name, {
                    configurable: false,
                    enumerable: true,
                    get: getter
                });
            };
            __webpack_require__.n = function(module1) {
                var getter = module1 && module1.__esModule ? function getDefault() {
                    return module1['default'];
                } : function getModuleExports() {
                    return module1;
                };
                __webpack_require__.d(getter, 'a', getter);
                return getter;
            };
            __webpack_require__.o = function(object, property) {
                return Object.prototype.hasOwnProperty.call(object, property);
            };
            __webpack_require__.p = "";
            return __webpack_require__(__webpack_require__.s = 3);
        }([
            function(module1, exports, __webpack_require__) {
                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
                }
                var RushaCore = __webpack_require__(5);
                var _require = __webpack_require__(1), toHex = _require.toHex, ceilHeapSize = _require.ceilHeapSize;
                var conv = __webpack_require__(6);
                var padlen = function(len) {
                    for(len += 9; len % 64 > 0; len += 1);
                    return len;
                };
                var padZeroes = function(bin, len) {
                    var h8 = new Uint8Array(bin.buffer);
                    var om = len % 4, align = len - om;
                    switch(om){
                        case 0:
                            h8[align + 3] = 0;
                        case 1:
                            h8[align + 2] = 0;
                        case 2:
                            h8[align + 1] = 0;
                        case 3:
                            h8[align + 0] = 0;
                    }
                    for(var i = (len >> 2) + 1; i < bin.length; i++)bin[i] = 0;
                };
                var padData = function(bin, chunkLen, msgLen) {
                    bin[chunkLen >> 2] |= 0x80 << 24 - (chunkLen % 4 << 3);
                    bin[((chunkLen >> 2) + 2 & -16) + 14] = msgLen / 536870912 | 0;
                    bin[((chunkLen >> 2) + 2 & -16) + 15] = msgLen << 3;
                };
                var getRawDigest = function(heap, padMaxChunkLen) {
                    var io = new Int32Array(heap, padMaxChunkLen + 320, 5);
                    var out = new Int32Array(5);
                    var arr = new DataView(out.buffer);
                    arr.setInt32(0, io[0], false);
                    arr.setInt32(4, io[1], false);
                    arr.setInt32(8, io[2], false);
                    arr.setInt32(12, io[3], false);
                    arr.setInt32(16, io[4], false);
                    return out;
                };
                var Rusha = function() {
                    function Rusha(chunkSize) {
                        _classCallCheck(this, Rusha);
                        chunkSize = chunkSize || 65536;
                        if (chunkSize % 64 > 0) throw new Error('Chunk size must be a multiple of 128 bit');
                        this._offset = 0;
                        this._maxChunkLen = chunkSize;
                        this._padMaxChunkLen = padlen(chunkSize);
                        this._heap = new ArrayBuffer(ceilHeapSize(this._padMaxChunkLen + 320 + 20));
                        this._h32 = new Int32Array(this._heap);
                        this._h8 = new Int8Array(this._heap);
                        this._core = new RushaCore({
                            Int32Array: Int32Array
                        }, {}, this._heap);
                    }
                    Rusha.prototype._initState = function _initState(heap, padMsgLen) {
                        this._offset = 0;
                        var io = new Int32Array(heap, padMsgLen + 320, 5);
                        io[0] = 1732584193;
                        io[1] = -271733879;
                        io[2] = -1732584194;
                        io[3] = 271733878;
                        io[4] = -1009589776;
                    };
                    Rusha.prototype._padChunk = function _padChunk(chunkLen, msgLen) {
                        var padChunkLen = padlen(chunkLen);
                        var view = new Int32Array(this._heap, 0, padChunkLen >> 2);
                        padZeroes(view, chunkLen);
                        padData(view, chunkLen, msgLen);
                        return padChunkLen;
                    };
                    Rusha.prototype._write = function _write(data, chunkOffset, chunkLen, off) {
                        conv(data, this._h8, this._h32, chunkOffset, chunkLen, off || 0);
                    };
                    Rusha.prototype._coreCall = function _coreCall(data, chunkOffset, chunkLen, msgLen, finalize) {
                        var padChunkLen = chunkLen;
                        this._write(data, chunkOffset, chunkLen);
                        if (finalize) padChunkLen = this._padChunk(chunkLen, msgLen);
                        this._core.hash(padChunkLen, this._padMaxChunkLen);
                    };
                    Rusha.prototype.rawDigest = function rawDigest(str) {
                        var msgLen = str.byteLength || str.length || str.size || 0;
                        this._initState(this._heap, this._padMaxChunkLen);
                        var chunkOffset = 0, chunkLen = this._maxChunkLen;
                        for(chunkOffset = 0; msgLen > chunkOffset + chunkLen; chunkOffset += chunkLen)this._coreCall(str, chunkOffset, chunkLen, msgLen, false);
                        this._coreCall(str, chunkOffset, msgLen - chunkOffset, msgLen, true);
                        return getRawDigest(this._heap, this._padMaxChunkLen);
                    };
                    Rusha.prototype.digest = function digest(str) {
                        return toHex(this.rawDigest(str).buffer);
                    };
                    Rusha.prototype.digestFromString = function digestFromString(str) {
                        return this.digest(str);
                    };
                    Rusha.prototype.digestFromBuffer = function digestFromBuffer(str) {
                        return this.digest(str);
                    };
                    Rusha.prototype.digestFromArrayBuffer = function digestFromArrayBuffer(str) {
                        return this.digest(str);
                    };
                    Rusha.prototype.resetState = function resetState() {
                        this._initState(this._heap, this._padMaxChunkLen);
                        return this;
                    };
                    Rusha.prototype.append = function append(chunk) {
                        var chunkOffset = 0;
                        var chunkLen = chunk.byteLength || chunk.length || chunk.size || 0;
                        var turnOffset = this._offset % this._maxChunkLen;
                        var inputLen = void 0;
                        this._offset += chunkLen;
                        while(chunkOffset < chunkLen){
                            inputLen = Math.min(chunkLen - chunkOffset, this._maxChunkLen - turnOffset);
                            this._write(chunk, chunkOffset, inputLen, turnOffset);
                            turnOffset += inputLen;
                            chunkOffset += inputLen;
                            if (turnOffset === this._maxChunkLen) {
                                this._core.hash(this._maxChunkLen, this._padMaxChunkLen);
                                turnOffset = 0;
                            }
                        }
                        return this;
                    };
                    Rusha.prototype.getState = function getState() {
                        var turnOffset = this._offset % this._maxChunkLen;
                        var heap = void 0;
                        if (!turnOffset) {
                            var io = new Int32Array(this._heap, this._padMaxChunkLen + 320, 5);
                            heap = io.buffer.slice(io.byteOffset, io.byteOffset + io.byteLength);
                        } else heap = this._heap.slice(0);
                        return {
                            offset: this._offset,
                            heap: heap
                        };
                    };
                    Rusha.prototype.setState = function setState(state) {
                        this._offset = state.offset;
                        if (state.heap.byteLength === 20) {
                            var io = new Int32Array(this._heap, this._padMaxChunkLen + 320, 5);
                            io.set(new Int32Array(state.heap));
                        } else this._h32.set(new Int32Array(state.heap));
                        return this;
                    };
                    Rusha.prototype.rawEnd = function rawEnd() {
                        var msgLen = this._offset;
                        var chunkLen = msgLen % this._maxChunkLen;
                        var padChunkLen = this._padChunk(chunkLen, msgLen);
                        this._core.hash(padChunkLen, this._padMaxChunkLen);
                        var result = getRawDigest(this._heap, this._padMaxChunkLen);
                        this._initState(this._heap, this._padMaxChunkLen);
                        return result;
                    };
                    Rusha.prototype.end = function end() {
                        return toHex(this.rawEnd().buffer);
                    };
                    return Rusha;
                }();
                module1.exports = Rusha;
                module1.exports._core = RushaCore;
            },
            function(module1, exports) {
                var precomputedHex = new Array(256);
                for(var i = 0; i < 256; i++)precomputedHex[i] = (i < 0x10 ? '0' : '') + i.toString(16);
                module1.exports.toHex = function(arrayBuffer) {
                    var binarray = new Uint8Array(arrayBuffer);
                    var res = new Array(arrayBuffer.byteLength);
                    for(var _i = 0; _i < res.length; _i++)res[_i] = precomputedHex[binarray[_i]];
                    return res.join('');
                };
                module1.exports.ceilHeapSize = function(v) {
                    var p = 0;
                    if (v <= 65536) return 65536;
                    if (v < 16777216) {
                        for(p = 1; p < v; p = p << 1);
                    } else {
                        for(p = 16777216; p < v; p += 16777216);
                    }
                    return p;
                };
                module1.exports.isDedicatedWorkerScope = function(self1) {
                    var isRunningInWorker = 'WorkerGlobalScope' in self1 && self1 instanceof self1.WorkerGlobalScope;
                    var isRunningInSharedWorker = 'SharedWorkerGlobalScope' in self1 && self1 instanceof self1.SharedWorkerGlobalScope;
                    var isRunningInServiceWorker = 'ServiceWorkerGlobalScope' in self1 && self1 instanceof self1.ServiceWorkerGlobalScope;
                    return isRunningInWorker && !isRunningInSharedWorker && !isRunningInServiceWorker;
                };
            },
            function(module1, exports, __webpack_require__) {
                module1.exports = function() {
                    var Rusha = __webpack_require__(0);
                    var hashData = function(hasher, data, cb) {
                        try {
                            return cb(null, hasher.digest(data));
                        } catch (e) {
                            return cb(e);
                        }
                    };
                    var hashFile = function(hasher, readTotal, blockSize, file, cb) {
                        var reader = new self.FileReader();
                        reader.onloadend = function onloadend() {
                            if (reader.error) return cb(reader.error);
                            var buffer = reader.result;
                            readTotal += reader.result.byteLength;
                            try {
                                hasher.append(buffer);
                            } catch (e) {
                                cb(e);
                                return;
                            }
                            if (readTotal < file.size) hashFile(hasher, readTotal, blockSize, file, cb);
                            else cb(null, hasher.end());
                        };
                        reader.readAsArrayBuffer(file.slice(readTotal, readTotal + blockSize));
                    };
                    var workerBehaviourEnabled = true;
                    self.onmessage = function(event) {
                        if (!workerBehaviourEnabled) return;
                        var data = event.data.data, file = event.data.file, id = event.data.id;
                        if (typeof id === 'undefined') return;
                        if (!file && !data) return;
                        var blockSize = event.data.blockSize || 4194304;
                        var hasher = new Rusha(blockSize);
                        hasher.resetState();
                        var done = function(err, hash) {
                            if (!err) self.postMessage({
                                id: id,
                                hash: hash
                            });
                            else self.postMessage({
                                id: id,
                                error: err.name
                            });
                        };
                        if (data) hashData(hasher, data, done);
                        if (file) hashFile(hasher, 0, blockSize, file, done);
                    };
                    return function() {
                        workerBehaviourEnabled = false;
                    };
                };
            },
            function(module1, exports, __webpack_require__) {
                var work = __webpack_require__(4);
                var Rusha = __webpack_require__(0);
                var createHash = __webpack_require__(7);
                var runWorker = __webpack_require__(2);
                var _require = __webpack_require__(1), isDedicatedWorkerScope = _require.isDedicatedWorkerScope;
                var isRunningInDedicatedWorker = typeof self !== 'undefined' && isDedicatedWorkerScope(self);
                Rusha.disableWorkerBehaviour = isRunningInDedicatedWorker ? runWorker() : function() {};
                Rusha.createWorker = function() {
                    var worker = work(2);
                    var terminate = worker.terminate;
                    worker.terminate = function() {
                        URL.revokeObjectURL(worker.objectURL);
                        terminate.call(worker);
                    };
                    return worker;
                };
                Rusha.createHash = createHash;
                module1.exports = Rusha;
            },
            function(module1, exports, __webpack_require__) {
                function webpackBootstrapFunc(modules) {
                    var installedModules = {};
                    function __webpack_require__(moduleId) {
                        if (installedModules[moduleId]) return installedModules[moduleId].exports;
                        var module1 = installedModules[moduleId] = {
                            i: moduleId,
                            l: false,
                            exports: {}
                        };
                        modules[moduleId].call(module1.exports, module1, module1.exports, __webpack_require__);
                        module1.l = true;
                        return module1.exports;
                    }
                    __webpack_require__.m = modules;
                    __webpack_require__.c = installedModules;
                    __webpack_require__.i = function(value) {
                        return value;
                    };
                    __webpack_require__.d = function(exports, name, getter) {
                        if (!__webpack_require__.o(exports, name)) Object.defineProperty(exports, name, {
                            configurable: false,
                            enumerable: true,
                            get: getter
                        });
                    };
                    __webpack_require__.r = function(exports) {
                        Object.defineProperty(exports, '__esModule', {
                            value: true
                        });
                    };
                    __webpack_require__.n = function(module1) {
                        var getter = module1 && module1.__esModule ? function getDefault() {
                            return module1['default'];
                        } : function getModuleExports() {
                            return module1;
                        };
                        __webpack_require__.d(getter, 'a', getter);
                        return getter;
                    };
                    __webpack_require__.o = function(object, property) {
                        return Object.prototype.hasOwnProperty.call(object, property);
                    };
                    __webpack_require__.p = "/";
                    __webpack_require__.oe = function(err) {
                        console.error(err);
                        throw err;
                    };
                    var f = __webpack_require__(__webpack_require__.s = ENTRY_MODULE);
                    return f.default || f;
                }
                var moduleNameReqExp = '[\\.|\\-|\\+|\\w|\/|@]+';
                var dependencyRegExp = '\\((\/\\*.*?\\*\/)?\s?.*?(' + moduleNameReqExp + ').*?\\)';
                function quoteRegExp(str) {
                    return (str + '').replace(/[.?*+^$[\]\\(){}|-]/g, '\\$&');
                }
                function getModuleDependencies(sources, module1, queueName) {
                    var retval = {};
                    retval[queueName] = [];
                    var fnString = module1.toString();
                    var wrapperSignature = fnString.match(/^function\s?\(\w+,\s*\w+,\s*(\w+)\)/);
                    if (!wrapperSignature) return retval;
                    var webpackRequireName = wrapperSignature[1];
                    var re = new RegExp('(\\\\n|\\W)' + quoteRegExp(webpackRequireName) + dependencyRegExp, 'g');
                    var match;
                    while(match = re.exec(fnString)){
                        if (match[3] === 'dll-reference') continue;
                        retval[queueName].push(match[3]);
                    }
                    re = new RegExp('\\(' + quoteRegExp(webpackRequireName) + '\\("(dll-reference\\s(' + moduleNameReqExp + '))"\\)\\)' + dependencyRegExp, 'g');
                    while(match = re.exec(fnString)){
                        if (!sources[match[2]]) {
                            retval[queueName].push(match[1]);
                            sources[match[2]] = __webpack_require__(match[1]).m;
                        }
                        retval[match[2]] = retval[match[2]] || [];
                        retval[match[2]].push(match[4]);
                    }
                    return retval;
                }
                function hasValuesInQueues(queues) {
                    var keys = Object.keys(queues);
                    return keys.reduce(function(hasValues, key) {
                        return hasValues || queues[key].length > 0;
                    }, false);
                }
                function getRequiredModules(sources, moduleId) {
                    var modulesQueue = {
                        main: [
                            moduleId
                        ]
                    };
                    var requiredModules = {
                        main: []
                    };
                    var seenModules = {
                        main: {}
                    };
                    while(hasValuesInQueues(modulesQueue)){
                        var queues = Object.keys(modulesQueue);
                        for(var i = 0; i < queues.length; i++){
                            var queueName = queues[i];
                            var queue = modulesQueue[queueName];
                            var moduleToCheck = queue.pop();
                            seenModules[queueName] = seenModules[queueName] || {};
                            if (seenModules[queueName][moduleToCheck] || !sources[queueName][moduleToCheck]) continue;
                            seenModules[queueName][moduleToCheck] = true;
                            requiredModules[queueName] = requiredModules[queueName] || [];
                            requiredModules[queueName].push(moduleToCheck);
                            var newModules = getModuleDependencies(sources, sources[queueName][moduleToCheck], queueName);
                            var newModulesKeys = Object.keys(newModules);
                            for(var j = 0; j < newModulesKeys.length; j++){
                                modulesQueue[newModulesKeys[j]] = modulesQueue[newModulesKeys[j]] || [];
                                modulesQueue[newModulesKeys[j]] = modulesQueue[newModulesKeys[j]].concat(newModules[newModulesKeys[j]]);
                            }
                        }
                    }
                    return requiredModules;
                }
                module1.exports = function(moduleId, options) {
                    options = options || {};
                    var sources = {
                        main: __webpack_require__.m
                    };
                    var requiredModules = options.all ? {
                        main: Object.keys(sources)
                    } : getRequiredModules(sources, moduleId);
                    var src = '';
                    Object.keys(requiredModules).filter(function(m) {
                        return m !== 'main';
                    }).forEach(function(module1) {
                        var entryModule = 0;
                        while(requiredModules[module1][entryModule])entryModule++;
                        requiredModules[module1].push(entryModule);
                        sources[module1][entryModule] = '(function(module, exports, __webpack_require__) { module.exports = __webpack_require__; })';
                        src = src + 'var ' + module1 + ' = (' + webpackBootstrapFunc.toString().replace('ENTRY_MODULE', JSON.stringify(entryModule)) + ')({' + requiredModules[module1].map(function(id) {
                            return '' + JSON.stringify(id) + ': ' + sources[module1][id].toString();
                        }).join(',') + '});\n';
                    });
                    src = src + '(' + webpackBootstrapFunc.toString().replace('ENTRY_MODULE', JSON.stringify(moduleId)) + ')({' + requiredModules.main.map(function(id) {
                        return '' + JSON.stringify(id) + ': ' + sources.main[id].toString();
                    }).join(',') + '})(self);';
                    var blob = new window.Blob([
                        src
                    ], {
                        type: 'text/javascript'
                    });
                    if (options.bare) return blob;
                    var URL1 = window.URL || window.webkitURL || window.mozURL || window.msURL;
                    var workerUrl = URL1.createObjectURL(blob);
                    var worker = new window.Worker(workerUrl);
                    worker.objectURL = workerUrl;
                    return worker;
                };
            },
            function(module1, exports) {
                module1.exports = function RushaCore(stdlib$846, foreign$847, heap$848) {
                    'use asm';
                    var H$849 = new stdlib$846.Int32Array(heap$848);
                    function hash$850(k$851, x$852) {
                        k$851 = k$851 | 0;
                        x$852 = x$852 | 0;
                        var i$853 = 0, j$854 = 0, y0$855 = 0, z0$856 = 0, y1$857 = 0, z1$858 = 0, y2$859 = 0, z2$860 = 0, y3$861 = 0, z3$862 = 0, y4$863 = 0, z4$864 = 0, t0$865 = 0, t1$866 = 0;
                        y0$855 = H$849[x$852 + 320 >> 2] | 0;
                        y1$857 = H$849[x$852 + 324 >> 2] | 0;
                        y2$859 = H$849[x$852 + 328 >> 2] | 0;
                        y3$861 = H$849[x$852 + 332 >> 2] | 0;
                        y4$863 = H$849[x$852 + 336 >> 2] | 0;
                        for(i$853 = 0; (i$853 | 0) < (k$851 | 0); i$853 = i$853 + 64 | 0){
                            z0$856 = y0$855;
                            z1$858 = y1$857;
                            z2$860 = y2$859;
                            z3$862 = y3$861;
                            z4$864 = y4$863;
                            for(j$854 = 0; (j$854 | 0) < 64; j$854 = j$854 + 4 | 0){
                                t1$866 = H$849[i$853 + j$854 >> 2] | 0;
                                t0$865 = ((y0$855 << 5 | y0$855 >>> 27) + (y1$857 & y2$859 | ~y1$857 & y3$861) | 0) + ((t1$866 + y4$863 | 0) + 1518500249 | 0) | 0;
                                y4$863 = y3$861;
                                y3$861 = y2$859;
                                y2$859 = y1$857 << 30 | y1$857 >>> 2;
                                y1$857 = y0$855;
                                y0$855 = t0$865;
                                H$849[k$851 + j$854 >> 2] = t1$866;
                            }
                            for(j$854 = k$851 + 64 | 0; (j$854 | 0) < (k$851 + 80 | 0); j$854 = j$854 + 4 | 0){
                                t1$866 = (H$849[j$854 - 12 >> 2] ^ H$849[j$854 - 32 >> 2] ^ H$849[j$854 - 56 >> 2] ^ H$849[j$854 - 64 >> 2]) << 1 | (H$849[j$854 - 12 >> 2] ^ H$849[j$854 - 32 >> 2] ^ H$849[j$854 - 56 >> 2] ^ H$849[j$854 - 64 >> 2]) >>> 31;
                                t0$865 = ((y0$855 << 5 | y0$855 >>> 27) + (y1$857 & y2$859 | ~y1$857 & y3$861) | 0) + ((t1$866 + y4$863 | 0) + 1518500249 | 0) | 0;
                                y4$863 = y3$861;
                                y3$861 = y2$859;
                                y2$859 = y1$857 << 30 | y1$857 >>> 2;
                                y1$857 = y0$855;
                                y0$855 = t0$865;
                                H$849[j$854 >> 2] = t1$866;
                            }
                            for(j$854 = k$851 + 80 | 0; (j$854 | 0) < (k$851 + 160 | 0); j$854 = j$854 + 4 | 0){
                                t1$866 = (H$849[j$854 - 12 >> 2] ^ H$849[j$854 - 32 >> 2] ^ H$849[j$854 - 56 >> 2] ^ H$849[j$854 - 64 >> 2]) << 1 | (H$849[j$854 - 12 >> 2] ^ H$849[j$854 - 32 >> 2] ^ H$849[j$854 - 56 >> 2] ^ H$849[j$854 - 64 >> 2]) >>> 31;
                                t0$865 = ((y0$855 << 5 | y0$855 >>> 27) + (y1$857 ^ y2$859 ^ y3$861) | 0) + ((t1$866 + y4$863 | 0) + 1859775393 | 0) | 0;
                                y4$863 = y3$861;
                                y3$861 = y2$859;
                                y2$859 = y1$857 << 30 | y1$857 >>> 2;
                                y1$857 = y0$855;
                                y0$855 = t0$865;
                                H$849[j$854 >> 2] = t1$866;
                            }
                            for(j$854 = k$851 + 160 | 0; (j$854 | 0) < (k$851 + 240 | 0); j$854 = j$854 + 4 | 0){
                                t1$866 = (H$849[j$854 - 12 >> 2] ^ H$849[j$854 - 32 >> 2] ^ H$849[j$854 - 56 >> 2] ^ H$849[j$854 - 64 >> 2]) << 1 | (H$849[j$854 - 12 >> 2] ^ H$849[j$854 - 32 >> 2] ^ H$849[j$854 - 56 >> 2] ^ H$849[j$854 - 64 >> 2]) >>> 31;
                                t0$865 = ((y0$855 << 5 | y0$855 >>> 27) + (y1$857 & y2$859 | y1$857 & y3$861 | y2$859 & y3$861) | 0) + ((t1$866 + y4$863 | 0) - 1894007588 | 0) | 0;
                                y4$863 = y3$861;
                                y3$861 = y2$859;
                                y2$859 = y1$857 << 30 | y1$857 >>> 2;
                                y1$857 = y0$855;
                                y0$855 = t0$865;
                                H$849[j$854 >> 2] = t1$866;
                            }
                            for(j$854 = k$851 + 240 | 0; (j$854 | 0) < (k$851 + 320 | 0); j$854 = j$854 + 4 | 0){
                                t1$866 = (H$849[j$854 - 12 >> 2] ^ H$849[j$854 - 32 >> 2] ^ H$849[j$854 - 56 >> 2] ^ H$849[j$854 - 64 >> 2]) << 1 | (H$849[j$854 - 12 >> 2] ^ H$849[j$854 - 32 >> 2] ^ H$849[j$854 - 56 >> 2] ^ H$849[j$854 - 64 >> 2]) >>> 31;
                                t0$865 = ((y0$855 << 5 | y0$855 >>> 27) + (y1$857 ^ y2$859 ^ y3$861) | 0) + ((t1$866 + y4$863 | 0) - 899497514 | 0) | 0;
                                y4$863 = y3$861;
                                y3$861 = y2$859;
                                y2$859 = y1$857 << 30 | y1$857 >>> 2;
                                y1$857 = y0$855;
                                y0$855 = t0$865;
                                H$849[j$854 >> 2] = t1$866;
                            }
                            y0$855 = y0$855 + z0$856 | 0;
                            y1$857 = y1$857 + z1$858 | 0;
                            y2$859 = y2$859 + z2$860 | 0;
                            y3$861 = y3$861 + z3$862 | 0;
                            y4$863 = y4$863 + z4$864 | 0;
                        }
                        H$849[x$852 + 320 >> 2] = y0$855;
                        H$849[x$852 + 324 >> 2] = y1$857;
                        H$849[x$852 + 328 >> 2] = y2$859;
                        H$849[x$852 + 332 >> 2] = y3$861;
                        H$849[x$852 + 336 >> 2] = y4$863;
                    }
                    return {
                        hash: hash$850
                    };
                };
            },
            function(module1, exports) {
                var _this = this;
                var reader = void 0;
                if (typeof self !== 'undefined' && typeof self.FileReaderSync !== 'undefined') reader = new self.FileReaderSync();
                var convStr = function(str, H8, H32, start, len, off) {
                    var i = void 0, om = off % 4, lm = (len + om) % 4, j = len - lm;
                    switch(om){
                        case 0:
                            H8[off] = str.charCodeAt(start + 3);
                        case 1:
                            H8[off + 1 - (om << 1) | 0] = str.charCodeAt(start + 2);
                        case 2:
                            H8[off + 2 - (om << 1) | 0] = str.charCodeAt(start + 1);
                        case 3:
                            H8[off + 3 - (om << 1) | 0] = str.charCodeAt(start);
                    }
                    if (len < lm + (4 - om)) return;
                    for(i = 4 - om; i < j; i = i + 4 | 0)H32[off + i >> 2] = str.charCodeAt(start + i) << 24 | str.charCodeAt(start + i + 1) << 16 | str.charCodeAt(start + i + 2) << 8 | str.charCodeAt(start + i + 3);
                    switch(lm){
                        case 3:
                            H8[off + j + 1 | 0] = str.charCodeAt(start + j + 2);
                        case 2:
                            H8[off + j + 2 | 0] = str.charCodeAt(start + j + 1);
                        case 1:
                            H8[off + j + 3 | 0] = str.charCodeAt(start + j);
                    }
                };
                var convBuf = function(buf, H8, H32, start, len, off) {
                    var i = void 0, om = off % 4, lm = (len + om) % 4, j = len - lm;
                    switch(om){
                        case 0:
                            H8[off] = buf[start + 3];
                        case 1:
                            H8[off + 1 - (om << 1) | 0] = buf[start + 2];
                        case 2:
                            H8[off + 2 - (om << 1) | 0] = buf[start + 1];
                        case 3:
                            H8[off + 3 - (om << 1) | 0] = buf[start];
                    }
                    if (len < lm + (4 - om)) return;
                    for(i = 4 - om; i < j; i = i + 4 | 0)H32[off + i >> 2 | 0] = buf[start + i] << 24 | buf[start + i + 1] << 16 | buf[start + i + 2] << 8 | buf[start + i + 3];
                    switch(lm){
                        case 3:
                            H8[off + j + 1 | 0] = buf[start + j + 2];
                        case 2:
                            H8[off + j + 2 | 0] = buf[start + j + 1];
                        case 1:
                            H8[off + j + 3 | 0] = buf[start + j];
                    }
                };
                var convBlob = function(blob, H8, H32, start, len, off) {
                    var i = void 0, om = off % 4, lm = (len + om) % 4, j = len - lm;
                    var buf = new Uint8Array(reader.readAsArrayBuffer(blob.slice(start, start + len)));
                    switch(om){
                        case 0:
                            H8[off] = buf[3];
                        case 1:
                            H8[off + 1 - (om << 1) | 0] = buf[2];
                        case 2:
                            H8[off + 2 - (om << 1) | 0] = buf[1];
                        case 3:
                            H8[off + 3 - (om << 1) | 0] = buf[0];
                    }
                    if (len < lm + (4 - om)) return;
                    for(i = 4 - om; i < j; i = i + 4 | 0)H32[off + i >> 2 | 0] = buf[i] << 24 | buf[i + 1] << 16 | buf[i + 2] << 8 | buf[i + 3];
                    switch(lm){
                        case 3:
                            H8[off + j + 1 | 0] = buf[j + 2];
                        case 2:
                            H8[off + j + 2 | 0] = buf[j + 1];
                        case 1:
                            H8[off + j + 3 | 0] = buf[j];
                    }
                };
                module1.exports = function(data, H8, H32, start, len, off) {
                    if (typeof data === 'string') return convStr(data, H8, H32, start, len, off);
                    if (data instanceof Array) return convBuf(data, H8, H32, start, len, off);
                    if (_this && _this.Buffer && _this.Buffer.isBuffer(data)) return convBuf(data, H8, H32, start, len, off);
                    if (data instanceof ArrayBuffer) return convBuf(new Uint8Array(data), H8, H32, start, len, off);
                    if (data.buffer instanceof ArrayBuffer) return convBuf(new Uint8Array(data.buffer, data.byteOffset, data.byteLength), H8, H32, start, len, off);
                    if (data instanceof Blob) return convBlob(data, H8, H32, start, len, off);
                    throw new Error('Unsupported data type.');
                };
            },
            function(module1, exports, __webpack_require__) {
                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
                }
                var Rusha = __webpack_require__(0);
                var _require = __webpack_require__(1), toHex = _require.toHex;
                var Hash = function() {
                    function Hash() {
                        _classCallCheck(this, Hash);
                        this._rusha = new Rusha();
                        this._rusha.resetState();
                    }
                    Hash.prototype.update = function update(data) {
                        this._rusha.append(data);
                        return this;
                    };
                    Hash.prototype.digest = function digest(encoding) {
                        var digest = this._rusha.rawEnd().buffer;
                        if (!encoding) return digest;
                        if (encoding === 'hex') return toHex(digest);
                        throw new Error('unsupported digest encoding');
                    };
                    return Hash;
                }();
                module1.exports = function() {
                    return new Hash();
                };
            }
        ]);
    });
});
parcelRegister("e7WVN", function(module, exports) {
    $parcel$export(module.exports, "setInteractionError", ()=>$e56ceeea538fc730$export$5b689ca7b019e89f);
    var $bFU4G;
    function $e56ceeea538fc730$export$5b689ca7b019e89f(interactionName, error) {
        const interaction = (0, (0, parcelRequire("bFU4G")).getActiveInteraction)();
        if (!interaction) return;
        if (interaction.ufoName !== interactionName) return;
        (0, (0, parcelRequire("bFU4G")).addError)(interaction.id, error.name, null, 'Manual interaction error', error.errorMessage, undefined, true);
    }
});
parcelRegister("eTXmK", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$21211904d99073e5$export$2e2bcd8739ae039);
    var $7Jxgt = parcelRequire("7Jxgt");
    var $5gx4p;
    var $fe1wc;
    var $tcn7E;
    var $1u4q7;
    var $bFU4G;
    var $9AgLs;
    function $21211904d99073e5$export$2e2bcd8739ae039(name, timestamp) {
        const rate = (0, (0, parcelRequire("fe1wc")).getInteractionRate)(name, 'press');
        const pressInteractionsList = (0, (0, parcelRequire("fe1wc")).getDoNotAbortActivePressInteraction)();
        if (pressInteractionsList?.includes(name)) {
            const interaction = (0, (0, parcelRequire("bFU4G")).getActiveInteraction)();
            if (interaction?.ufoName !== 'unknown' && interaction?.type === 'press') return;
        }
        if ((0, (0, parcelRequire("5gx4p")).default)(rate)) {
            (0, (0, parcelRequire("bFU4G")).abortAll)('new_interaction', name);
            const startTimestamp = timestamp ?? performance.now();
            const newId = (0, $7Jxgt.v4)();
            (0, (0, parcelRequire("tcn7E")).setInteractionActiveTrace)(newId, 'press');
            (0, (0, parcelRequire("1u4q7")).DefaultInteractionID).current = newId;
            (0, (0, parcelRequire("bFU4G")).addNewInteraction)(newId, name, 'press', startTimestamp, rate, [], (0, (0, parcelRequire("9AgLs")).default).current, (0, (0, parcelRequire("tcn7E")).getActiveTrace)());
        }
    }
});
parcelRegister("3j5Ay", function(module, exports) {
    $parcel$export(module.exports, "SwitchToTooltipText", ()=>$b102069bd48b9b82$export$c5ef4d14b7e18cbd);
    var $5uXOq = parcelRequire("5uXOq");
    var $ousew;
    var $99tqu;
    var $5WNqJ;
    const $b102069bd48b9b82$export$c5ef4d14b7e18cbd = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("99tqu")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("5WNqJ")).default).yourAppsTooltip));
});
parcelRegister("99tqu", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$adb5f42f21ad260c$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $i5FdW;
    var $koVbs;
    var $7Fgjd;
    var $jMc3y;
    var $2NMNM;
    function $adb5f42f21ad260c$var$fetchLanguageFile(locale) {
        switch(locale){
            case 'cs-CZ':
            case 'cs':
                return (parcelRequire("5xQkc"));
            case 'da-DK':
            case 'da':
                return (parcelRequire("dDgyP"));
            case 'de-DE':
            case 'de':
                return (parcelRequire("4DmXo"));
            case 'en-GB':
                return (parcelRequire("aZpkq"));
            case 'en-ZZ':
                return (parcelRequire("eAU0Z"));
            case 'en-US':
            case 'en':
                return (parcelRequire("3THXg"));
            case 'es-ES':
            case 'es':
                return (parcelRequire("4MkE7"));
            case 'et':
                return (parcelRequire("l7EvD"));
            case 'fi-FI':
            case 'fi':
                return (parcelRequire("fkxvI"));
            case 'fr-FR':
            case 'fr':
                return (parcelRequire("97vD6"));
            case 'hu-HU':
            case 'hu':
                return (parcelRequire("eUeYp"));
            case 'is':
                return (parcelRequire("7EPVP"));
            case 'it-IT':
            case 'it':
                return (parcelRequire("dewXY"));
            case 'ja-JP':
            case 'ja':
                return (parcelRequire("6vQ0f"));
            case 'ko-KR':
            case 'ko':
                return (parcelRequire("7NHQ6"));
            case 'nb-NB':
            case 'nb':
                return (parcelRequire("dnmdG"));
            case 'nl-NL':
            case 'nl':
                return (parcelRequire("6MX5c"));
            case 'pl-PL':
            case 'pl':
                return (parcelRequire("gp3bp"));
            case 'pt-BR':
            case 'pt':
                return (parcelRequire("f7OMn"));
            case 'pt-PT':
                return (parcelRequire("bR1YP"));
            case 'ro':
                return (parcelRequire("4a6W0"));
            case 'ru-RU':
            case 'ru':
                return (parcelRequire("gONld"));
            case 'sk':
                return (parcelRequire("6lV0p"));
            case 'sv-SE':
            case 'sv':
                return (parcelRequire("fbptw"));
            case 'th-TH':
            case 'th':
                return (parcelRequire("bg7cu"));
            case 'tr-TR':
            case 'tr':
                return (parcelRequire("keX3y"));
            case 'uk-UK':
            case 'uk':
                return (parcelRequire("kxrQ7"));
            case 'vi-VI':
            case 'vi':
                return (parcelRequire("1AThx"));
            case 'zh-TW':
            case 'zh-HK':
                return (parcelRequire("6ZkOb"));
            case 'zh-ZH':
            case 'zh-CN':
            case 'zh':
                return (parcelRequire("6xsm4"));
        }
        throw Error(`Unable to find translation for locale ${locale}`);
    }
    const $adb5f42f21ad260c$var$SwitcherIntlProvider = ({ children: children })=>{
        const { locale: locale } = (0, (0, parcelRequire("koVbs")).default)();
        const [isLocaleLoaded, setIsLocaleLoaded] = (0, $5uXOq.useState)(false);
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const [messages, setMessages] = (0, $5uXOq.useState)({});
        (0, $5uXOq.useEffect)(()=>{
            async function startToFetchMessagesByLocale() {
                const intlLocale = new Intl.Locale(locale.replace('_', '-'));
                try {
                    const module = await $adb5f42f21ad260c$var$fetchLanguageFile(intlLocale.toString());
                    const newMessages = module.default || module;
                    setMessages(newMessages);
                    setIsLocaleLoaded(true);
                } catch (e) {
                    setIsLocaleLoaded(true);
                    createAnalyticsEvent({
                        eventType: (0, $676c5e519aa5ba55$export$12346a674644c156),
                        action: 'not_loaded',
                        actionSubject: 'i18n',
                        attributes: {
                            country: intlLocale.region,
                            language: intlLocale.language
                        }
                    }).fire((0, (0, parcelRequire("jMc3y")).NAVIGATION_CHANNEL));
                }
            }
            startToFetchMessagesByLocale();
        }, [
            locale,
            createAnalyticsEvent
        ]);
        if (!isLocaleLoaded) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7Fgjd")).default), null);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("i5FdW")).default), {
            locale: locale,
            key: locale,
            messages: messages
        }, children);
    };
    var $adb5f42f21ad260c$export$2e2bcd8739ae039 = $adb5f42f21ad260c$var$SwitcherIntlProvider;
});
parcelRegister("7Fgjd", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6d3d00b3a0083460$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $4CjFb;
    var $47RdN;
    var $22RxY;
    var $hWyMn;
    var $koVbs;
    var $11Xk0;
    const $6d3d00b3a0083460$var$iconSkeletonStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        display: 'inline-block',
        width: 32,
        height: 32,
        backgroundColor: `var(--ds-skeleton, ${$829f609a65d26a98$export$9fdfb749e33cdf97})`,
        borderRadius: "var(--ds-border-radius-200, 8px)"
    });
    const $6d3d00b3a0083460$var$lineSkeletonStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        display: 'inline-block',
        width: 98,
        height: 10,
        backgroundColor: `var(--ds-skeleton, ${$829f609a65d26a98$export$9fdfb749e33cdf97})`,
        borderRadius: "var(--ds-border-radius, 3px)"
    });
    const $6d3d00b3a0083460$var$iconSkeleton = (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
        css: $6d3d00b3a0083460$var$iconSkeletonStyles
    });
    const $6d3d00b3a0083460$var$lineSkeleton = (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
        css: $6d3d00b3a0083460$var$lineSkeletonStyles
    });
    var $6d3d00b3a0083460$export$2e2bcd8739ae039 = ()=>{
        (0, (0, parcelRequire("hWyMn")).useExperienceRenderAndMountMark)((0, (0, parcelRequire("22RxY")).ExperienceMark).SWITCHER_SKELETON_MOUNT);
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("4CjFb")).SectionContainer), {
            sectionId: "skeleton",
            title: $6d3d00b3a0083460$var$lineSkeleton,
            sectionRole: "alert",
            "aria-label": formatMessage((0, (0, parcelRequire("11Xk0")).default).skeletonLoaderAriaLabel)
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("47RdN")).default), {
            tag: "li",
            icon: $6d3d00b3a0083460$var$iconSkeleton,
            isDisabled: true,
            "aria-hidden": "true"
        }, $6d3d00b3a0083460$var$lineSkeleton), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("47RdN")).default), {
            tag: "li",
            icon: $6d3d00b3a0083460$var$iconSkeleton,
            isDisabled: true,
            "aria-hidden": "true"
        }, $6d3d00b3a0083460$var$lineSkeleton), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("47RdN")).default), {
            tag: "li",
            icon: $6d3d00b3a0083460$var$iconSkeleton,
            isDisabled: true,
            "aria-hidden": "true"
        }, $6d3d00b3a0083460$var$lineSkeleton));
    };
});
parcelRegister("4CjFb", function(module, exports) {
    $parcel$export(module.exports, "SectionContainerTitle", ()=>$c7c93e2870532b5e$export$7bb82566a1f2a4f5);
    $parcel$export(module.exports, "SectionContainer", ()=>$c7c93e2870532b5e$export$be4c8679ebfd988);
    var $5uXOq = parcelRequire("5uXOq");
    var $3RZIb;
    var $7paD5;
    var $f8Sb3;
    var $jMc3y;
    var $1PVpv = parcelRequire("1PVpv");
    var $fABEI;
    var $l1lhL;
    var $7Ghqv;
    function $c7c93e2870532b5e$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $c7c93e2870532b5e$var$sectionContainerStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        padding: `${"var(--ds-space-075, 6px)"} 0`
    });
    const $c7c93e2870532b5e$var$secondarySectionTitleBaseStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        '&&': {
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            textTransform: 'uppercase',
            whiteSpace: 'nowrap',
            marginTop: `${"var(--ds-space-200, 16px)"}`,
            marginLeft: `${"var(--ds-space-100, 8px)"}`
        }
    });
    const $c7c93e2870532b5e$var$secondarySectionTitleStandaloneStyles = {
        name: "tnphew",
        styles: "margin-bottom:var(--ds-space-050, 4px)"
    };
    const $c7c93e2870532b5e$var$secondarySectionTitleDrawerStyles = {
        name: "803obq",
        styles: "margin-bottom:var(--ds-space-100, 8px)"
    };
    const $c7c93e2870532b5e$var$sectionTitleStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        color: "var(--ds-text-subtle, #44546F)",
        font: `var(--ds-font-body-small, ${(0, (0, parcelRequire("3RZIb")).fontFallback).body.small})`,
        fontWeight: "var(--ds-font-weight-bold, 700)"
    });
    const $c7c93e2870532b5e$var$sectionChildrenWrapperStyles = {
        name: "1kz5jpr",
        styles: "list-style-type:none;padding:0;margin:0"
    };
    const $c7c93e2870532b5e$export$7bb82566a1f2a4f5 = ({ appearance: appearance, title: title })=>(0, (0, parcelRequire("f8Sb3")).jsx)("h3", {
            css: [
                $c7c93e2870532b5e$var$secondarySectionTitleBaseStyles,
                appearance === 'standalone' ? $c7c93e2870532b5e$var$secondarySectionTitleStandaloneStyles : $c7c93e2870532b5e$var$secondarySectionTitleDrawerStyles,
                $c7c93e2870532b5e$var$sectionTitleStyles
            ]
        }, title);
    const $c7c93e2870532b5e$var$SectionContainerComponent = ({ title: title, titleLink: titleLink, children: children, appearance: appearance, actionSubject: actionSubject, sectionId: sectionId, sectionRole: sectionRole, ariaLabel: ariaLabel })=>{
        return (0, ($parcel$interopDefault($5uXOq))).Children.toArray(children).some(Boolean) ? (0, (0, parcelRequire("f8Sb3")).jsx)("section", {
            css: $c7c93e2870532b5e$var$sectionContainerStyles,
            "data-testid": `${sectionId}__section`,
            role: sectionRole,
            "aria-label": ariaLabel
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("fABEI")).FadeIn), null, title && (0, (0, parcelRequire("f8Sb3")).jsx)($c7c93e2870532b5e$export$7bb82566a1f2a4f5, {
            appearance: appearance,
            title: title
        }), titleLink && (0, (0, parcelRequire("f8Sb3")).jsx)($c7c93e2870532b5e$var$TitleLink, {
            titleLink: titleLink,
            actionSubject: actionSubject
        })), (0, (0, parcelRequire("f8Sb3")).jsx)("ul", {
            css: $c7c93e2870532b5e$var$sectionChildrenWrapperStyles
        }, children)) : null;
    };
    const $c7c93e2870532b5e$var$TitleLink = ({ titleLink: titleLink, actionSubject: actionSubject })=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, $1PVpv.NavigationAnalyticsContext), {
            key: titleLink.key,
            data: (0, (0, parcelRequire("jMc3y")).getItemAnalyticsContext)(0, titleLink.key, (0, (0, parcelRequire("7Ghqv")).AnalyticsItemType).PRODUCT, titleLink.productType)
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("l1lhL")).default), {
            href: titleLink.href,
            iconAfter: (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("7paD5"))))), {
                LEGACY_size: "small",
                color: "currentColor",
                label: ""
            }),
            label: titleLink.label,
            testId: "section-title__link",
            actionSubject: actionSubject,
            ariaLabel: titleLink.ariaLabel
        }));
    const $c7c93e2870532b5e$export$be4c8679ebfd988 = (0, (0, parcelRequire("jMc3y")).withAnalyticsContextData)((props)=>(0, (0, parcelRequire("jMc3y")).analyticsAttributes)({
            group: props.sectionId,
            groupItemsCount: (0, ($parcel$interopDefault($5uXOq))).Children.count(props.children)
        }))($c7c93e2870532b5e$var$SectionContainerComponent);
});
parcelRegister("jMc3y", function(module, exports) {
    $parcel$export(module.exports, "NAVIGATION_CHANNEL", ()=>$9e71ae1a8a0d4641$export$515664faa1398f37);
    $parcel$export(module.exports, "SWITCHER_SUBJECT", ()=>$9e71ae1a8a0d4641$export$17ff9c46e41eb585);
    $parcel$export(module.exports, "SWITCHER_ITEM_SUBJECT", ()=>$9e71ae1a8a0d4641$export$7598b001981cfda5);
    $parcel$export(module.exports, "SWITCHER_ITEM_LOZENGES_SUBJECT", ()=>$9e71ae1a8a0d4641$export$c3c93e13b09d3ad9);
    $parcel$export(module.exports, "SWITCHER_CHILD_ITEM_SUBJECT", ()=>$9e71ae1a8a0d4641$export$7d4d527df0e3789c);
    $parcel$export(module.exports, "SWITCHER_ITEM_EXPAND_SUBJECT", ()=>$9e71ae1a8a0d4641$export$16cf10618135eb24);
    $parcel$export(module.exports, "SWITCHER_COMPONENT", ()=>$9e71ae1a8a0d4641$export$2b570fc112cbca);
    $parcel$export(module.exports, "SWITCHER_SOURCE", ()=>$9e71ae1a8a0d4641$export$5ed36c4d23de5568);
    $parcel$export(module.exports, "TRIGGER_COMPONENT", ()=>$9e71ae1a8a0d4641$export$8d2f933bbd9e4f09);
    $parcel$export(module.exports, "TRIGGER_SUBJECT", ()=>$9e71ae1a8a0d4641$export$d7029a5dc66b0736);
    $parcel$export(module.exports, "SWITCHER_PARTIAL_RESULTS", ()=>$9e71ae1a8a0d4641$export$4649adbfda1b6a66);
    $parcel$export(module.exports, "SWITCHER_ORG_ITEM", ()=>$9e71ae1a8a0d4641$export$6dd696c9ad636a67);
    $parcel$export(module.exports, "SWITCHER_ORG_NAME_EXPAND_PANEL", ()=>$9e71ae1a8a0d4641$export$53f2256589c0fa08);
    $parcel$export(module.exports, "SWITCHER_CURRENT_ORG", ()=>$9e71ae1a8a0d4641$export$44c7ac3fdc1d62b8);
    $parcel$export(module.exports, "SWITCHER_ORG_LIST", ()=>$9e71ae1a8a0d4641$export$d9d2f872f3b91169);
    $parcel$export(module.exports, "SWITCHER_JOINABLE_SITES", ()=>$9e71ae1a8a0d4641$export$5724539c9b1a3a5d);
    $parcel$export(module.exports, "SWITCHER_AVAILABLE_PRODUCTS", ()=>$9e71ae1a8a0d4641$export$22f5f827d9934254);
    $parcel$export(module.exports, "createAndFireNavigationEvent", ()=>$9e71ae1a8a0d4641$export$884b1a4c7ac9dd14);
    $parcel$export(module.exports, "analyticsAttributes", ()=>$9e71ae1a8a0d4641$export$a305f130b289b818);
    $parcel$export(module.exports, "withAnalyticsContextData", ()=>$9e71ae1a8a0d4641$export$97ebdd8e7274f18a);
    $parcel$export(module.exports, "RenderTracker", ()=>$9e71ae1a8a0d4641$export$e09ad93c2b74b853);
    $parcel$export(module.exports, "NotRenderedTracker", ()=>$9e71ae1a8a0d4641$export$95b1f1a72cad0dcb);
    $parcel$export(module.exports, "ViewedTracker", ()=>$9e71ae1a8a0d4641$export$b3fd6624b6a6d057);
    $parcel$export(module.exports, "ImageLoadedTracker", ()=>$9e71ae1a8a0d4641$export$7609fab79cf145a0);
    $parcel$export(module.exports, "getJoinableSitesRenderTracker", ()=>$9e71ae1a8a0d4641$export$e823e937102b322b);
    $parcel$export(module.exports, "getDiscoverSectionRenderTracker", ()=>$9e71ae1a8a0d4641$export$eff0211e47c4d541);
    $parcel$export(module.exports, "getRecentContainersRenderTracker", ()=>$9e71ae1a8a0d4641$export$92f66a8a67c9c3ce);
    $parcel$export(module.exports, "getCustomLinksRenderTracker", ()=>$9e71ae1a8a0d4641$export$d75a4f56d85f67ea);
    $parcel$export(module.exports, "getItemAnalyticsContext", ()=>$9e71ae1a8a0d4641$export$6489efba2ca85102);
    $parcel$export(module.exports, "withAnalyticsEvents", ()=>(parcelRequire("cb25w")).default);
    $parcel$export(module.exports, "NavigationAnalyticsContext", ()=>(parcelRequire("1PVpv")).NavigationAnalyticsContext);
    $parcel$export(module.exports, "OPERATIONAL_EVENT_TYPE", ()=>$676c5e519aa5ba55$export$12346a674644c156);
    $parcel$export(module.exports, "UI_EVENT_TYPE", ()=>$676c5e519aa5ba55$export$a1562d08625f5d7e);
    var $5uXOq = parcelRequire("5uXOq");
    var $1PVpv = parcelRequire("1PVpv");
    var $gB4mS;
    var $2NMNM;
    var $cb25w;
    var $4JKO4;
    var $crCnP;
    var $6WztE;
    var $1m1Hd;
    const $9e71ae1a8a0d4641$export$515664faa1398f37 = 'navigation';
    const $9e71ae1a8a0d4641$export$17ff9c46e41eb585 = 'atlassianSwitcher';
    const $9e71ae1a8a0d4641$export$7598b001981cfda5 = 'atlassianSwitcherItem';
    const $9e71ae1a8a0d4641$export$c3c93e13b09d3ad9 = 'atlassianSwitcherItemLozenges';
    const $9e71ae1a8a0d4641$export$7d4d527df0e3789c = 'atlassianSwitcherChildItem';
    const $9e71ae1a8a0d4641$export$16cf10618135eb24 = 'atlassianSwitcherItemExpand';
    const $9e71ae1a8a0d4641$export$2b570fc112cbca = 'atlassianSwitcher';
    const $9e71ae1a8a0d4641$export$5ed36c4d23de5568 = 'atlassianSwitcher';
    const $9e71ae1a8a0d4641$export$8d2f933bbd9e4f09 = 'atlassianSwitcherPrefetch';
    const $9e71ae1a8a0d4641$export$d7029a5dc66b0736 = 'atlassianSwitcherPrefetch';
    const $9e71ae1a8a0d4641$export$4649adbfda1b6a66 = 'atlassianSwitcherPartialResultError';
    const $9e71ae1a8a0d4641$export$6dd696c9ad636a67 = 'atlassianSwitcherOrgItem';
    const $9e71ae1a8a0d4641$export$af0b3e734498c53c = 'atlassianSwitcherFooterLeaveFeedback';
    const $9e71ae1a8a0d4641$export$53f2256589c0fa08 = 'atlassianSwitcherOrgNameExpandPanel';
    const $9e71ae1a8a0d4641$export$44c7ac3fdc1d62b8 = 'atlassianSwitcherCurrentOrg';
    const $9e71ae1a8a0d4641$export$d9d2f872f3b91169 = 'atlassianSwitcherOrganisationsList';
    const $9e71ae1a8a0d4641$export$5724539c9b1a3a5d = 'atlassianSwitcherJoinableSites';
    const $9e71ae1a8a0d4641$export$22f5f827d9934254 = 'atlassianSwitcherAvailableProducts';
    const $9e71ae1a8a0d4641$var$SWITCHER_DISCOVER_SECTION = 'atlassianSwitcherDiscoverMore';
    const $9e71ae1a8a0d4641$var$SWITCHER_RECENT_CONTAINERS = 'atlassianSwitcherRecentContainers';
    const $9e71ae1a8a0d4641$var$SWITCHER_CUSTOM_LINKS = 'atlassianSwitcherCustomLinks';
    const $9e71ae1a8a0d4641$var$SWITCHER_REMOTE_ICON = 'atlassianSwitcherRemoteIcon';
    const $9e71ae1a8a0d4641$var$RENDERED_ACTION = 'rendered';
    const $9e71ae1a8a0d4641$var$NOT_RENDERED_ACTION = 'not_rendered';
    const $9e71ae1a8a0d4641$var$VIEWED_ACTION = 'viewed';
    const $9e71ae1a8a0d4641$var$LOADED_ACTION = 'loaded';
    const $9e71ae1a8a0d4641$var$NOT_LOADED_ACTION = 'not_loaded';
    const $9e71ae1a8a0d4641$export$884b1a4c7ac9dd14 = (0, (0, parcelRequire("gB4mS")).default)($9e71ae1a8a0d4641$export$515664faa1398f37);
    const $9e71ae1a8a0d4641$export$a305f130b289b818 = (attributes)=>({
            attributes: attributes
        });
    const $9e71ae1a8a0d4641$export$97ebdd8e7274f18a = function(mapPropsToContext) {
        return function(WrappedComponent) {
            return (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, $1PVpv.NavigationAnalyticsContext), {
                    data: mapPropsToContext(props)
                }, (0, ($parcel$interopDefault($5uXOq))).createElement(WrappedComponent, props));
        };
    };
    const $9e71ae1a8a0d4641$var$isValidDuration = (duration)=>{
        return duration !== null && duration !== undefined && duration >= 0;
    };
    const $9e71ae1a8a0d4641$export$e09ad93c2b74b853 = (0, (0, parcelRequire("cb25w")).default)({
        onRender: (createAnalyticsEvent, props)=>{
            const duration = props.data?.duration;
            return createAnalyticsEvent({
                eventType: (0, $676c5e519aa5ba55$export$12346a674644c156),
                action: $9e71ae1a8a0d4641$var$RENDERED_ACTION,
                actionSubject: props.subject,
                attributes: {
                    ...props.data,
                    ...$9e71ae1a8a0d4641$var$isValidDuration(duration) && {
                        bucket: (0, (0, parcelRequire("6WztE")).getMetricBucket)(duration, (0, (0, parcelRequire("6WztE")).RenderTrackerBuckets))
                    }
                }
            }).fire($9e71ae1a8a0d4641$export$515664faa1398f37);
        }
    })(class extends (0, ($parcel$interopDefault($5uXOq))).Component {
        componentDidMount() {
            this.props.onRender();
        }
        render() {
            return null;
        }
    });
    const $9e71ae1a8a0d4641$export$95b1f1a72cad0dcb = (0, (0, parcelRequire("cb25w")).default)({
        onRender: (createAnalyticsEvent, props)=>{
            return createAnalyticsEvent({
                eventType: (0, $676c5e519aa5ba55$export$12346a674644c156),
                action: $9e71ae1a8a0d4641$var$NOT_RENDERED_ACTION,
                actionSubject: props.subject,
                attributes: props.data
            }).fire($9e71ae1a8a0d4641$export$515664faa1398f37);
        }
    })(class extends (0, ($parcel$interopDefault($5uXOq))).Component {
        componentDidMount() {
            this.props.onRender();
        }
        render() {
            return null;
        }
    });
    const $9e71ae1a8a0d4641$export$b3fd6624b6a6d057 = (0, (0, parcelRequire("cb25w")).default)({
        onRender: (createAnalyticsEvent, props)=>{
            return createAnalyticsEvent({
                eventType: (0, $676c5e519aa5ba55$export$a1562d08625f5d7e),
                action: $9e71ae1a8a0d4641$var$VIEWED_ACTION,
                actionSubject: props.subject,
                attributes: props.data
            }).fire($9e71ae1a8a0d4641$export$515664faa1398f37);
        }
    })(class extends (0, ($parcel$interopDefault($5uXOq))).Component {
        componentDidMount() {
            this.props.onRender();
        }
        render() {
            return null;
        }
    });
    const $9e71ae1a8a0d4641$export$7609fab79cf145a0 = (props)=>{
        const { onLoad: onLoad, onError: onError, ...imgProps } = props;
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const imageMountedAt = (0, ($parcel$interopDefault($5uXOq))).useRef((0, (0, parcelRequire("1m1Hd")).performanceNow)());
        const analyticsHandler = (0, ($parcel$interopDefault($5uXOq))).useCallback((actionType, event, action)=>{
            const duration = (0, (0, parcelRequire("1m1Hd")).performanceNow)() - imageMountedAt.current;
            createAnalyticsEvent({
                action: actionType,
                actionSubject: $9e71ae1a8a0d4641$var$SWITCHER_REMOTE_ICON,
                attributes: {
                    ...$9e71ae1a8a0d4641$var$isValidDuration(duration) && {
                        bucket: (0, (0, parcelRequire("6WztE")).getMetricBucket)(duration, (0, (0, parcelRequire("6WztE")).ImageLoadTrackerBuckets)),
                        duration: duration
                    },
                    src: imgProps.src
                },
                eventType: (0, $676c5e519aa5ba55$export$12346a674644c156)
            }).fire($9e71ae1a8a0d4641$export$515664faa1398f37);
            if (action) action(event);
        }, [
            createAnalyticsEvent,
            imageMountedAt,
            imgProps.src
        ]);
        const onErrorAnalyticsHandler = (0, ($parcel$interopDefault($5uXOq))).useCallback((errorEvent)=>{
            analyticsHandler($9e71ae1a8a0d4641$var$NOT_LOADED_ACTION, errorEvent, onError);
        }, [
            analyticsHandler,
            onError
        ]);
        const onLoadAnalyticsHandler = (0, ($parcel$interopDefault($5uXOq))).useCallback((loadEvent)=>{
            analyticsHandler($9e71ae1a8a0d4641$var$LOADED_ACTION, loadEvent, onLoad);
        }, [
            analyticsHandler,
            onLoad
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement("img", {
            ...imgProps,
            onError: onErrorAnalyticsHandler,
            onLoad: onLoadAnalyticsHandler
        });
    };
    const $9e71ae1a8a0d4641$var$renderTrackerWithReason = ({ subject: subject, notRenderedReason: notRenderedReason, emptyRenderExpected: emptyRenderExpected, data: data })=>{
        if (notRenderedReason) return (0, ($parcel$interopDefault($5uXOq))).createElement($9e71ae1a8a0d4641$export$95b1f1a72cad0dcb, {
            subject: subject,
            data: {
                ...data,
                notRenderedReason: notRenderedReason
            }
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement($9e71ae1a8a0d4641$export$e09ad93c2b74b853, {
            subject: subject,
            data: {
                ...data,
                emptyRender: emptyRenderExpected
            }
        });
    };
    const $9e71ae1a8a0d4641$var$renderTracker = ({ subject: subject, providerFailed: providerFailed, emptyRenderExpected: emptyRenderExpected, linksRendered: linksRendered, data: data })=>{
        if (providerFailed || linksRendered.length === 0 && !emptyRenderExpected) return (0, ($parcel$interopDefault($5uXOq))).createElement($9e71ae1a8a0d4641$export$95b1f1a72cad0dcb, {
            subject: subject,
            data: {
                ...data,
                providerFailed: providerFailed
            }
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement($9e71ae1a8a0d4641$export$e09ad93c2b74b853, {
            subject: subject,
            data: {
                ...data,
                emptyRender: emptyRenderExpected
            }
        });
    };
    const $9e71ae1a8a0d4641$export$e823e937102b322b = (providerResult, joinableSiteLinks, data)=>{
        if (!(0, (0, parcelRequire("4JKO4")).hasLoaded)(providerResult)) return null;
        if (providerResult.data && !providerResult.data.sites) return null;
        const emptyRenderExpected = Boolean(providerResult.data && providerResult.data.sites && providerResult.data.sites.length === 0);
        return $9e71ae1a8a0d4641$var$renderTracker({
            subject: $9e71ae1a8a0d4641$export$5724539c9b1a3a5d,
            providerFailed: providerResult.data === null,
            emptyRenderExpected: emptyRenderExpected,
            linksRendered: joinableSiteLinks,
            data: data
        });
    };
    const $9e71ae1a8a0d4641$export$eff0211e47c4d541 = (xflowProviderResult, provisionedProductsProviderResult, joinableSitesProviderResult, productRecommendationsProviderResult, suggestedProductLinks, data)=>{
        const hasProviderNotReturnedExpectedData = (provider)=>provider.data === null || provider.status === (0, (0, parcelRequire("4JKO4")).Status).ERROR;
        const collectResults = (provider)=>({
                failed: hasProviderNotReturnedExpectedData(provider),
                loaded: (0, (0, parcelRequire("4JKO4")).hasLoaded)(provider)
            });
        const emptyRenderExpected = suggestedProductLinks.length === 0;
        const results = {
            xflow: collectResults(xflowProviderResult),
            provisionedProducts: collectResults(provisionedProductsProviderResult),
            joinableSites: collectResults(joinableSitesProviderResult),
            productRecommendations: collectResults(productRecommendationsProviderResult)
        };
        const providersLoaded = results.joinableSites.loaded && results.provisionedProducts.loaded && results.xflow.loaded && results.productRecommendations.loaded;
        if (!providersLoaded) return null;
        const didProviderFail = results.joinableSites.failed || results.provisionedProducts.failed || results.xflow.failed || results.productRecommendations.failed;
        if (didProviderFail) return $9e71ae1a8a0d4641$var$renderTracker({
            subject: $9e71ae1a8a0d4641$var$SWITCHER_DISCOVER_SECTION,
            providerFailed: true,
            emptyRenderExpected: emptyRenderExpected,
            linksRendered: suggestedProductLinks,
            data: {
                ...data,
                providerResults: {
                    joinableSites: joinableSitesProviderResult.status,
                    joinableSitesFailed: results.joinableSites.failed,
                    provisionedProducts: provisionedProductsProviderResult.status,
                    provisionedProductsFailed: results.provisionedProducts.failed,
                    xflow: xflowProviderResult.status,
                    xflowFailed: results.xflow.failed,
                    productRecommendations: productRecommendationsProviderResult.status,
                    productRecommendationsFailed: results.productRecommendations.failed
                }
            }
        });
        return $9e71ae1a8a0d4641$var$renderTracker({
            subject: $9e71ae1a8a0d4641$var$SWITCHER_DISCOVER_SECTION,
            providerFailed: false,
            emptyRenderExpected: emptyRenderExpected,
            linksRendered: suggestedProductLinks,
            data: data
        });
    };
    const $9e71ae1a8a0d4641$export$92f66a8a67c9c3ce = (isEnabled, cgRecentContainersProviderResult, userSiteDataProviderResult, recentLinks, data)=>{
        if (!isEnabled) return null;
        const providerFailed = cgRecentContainersProviderResult.data === null || userSiteDataProviderResult.data === null;
        const emptyRenderExpected = Boolean(cgRecentContainersProviderResult.data && cgRecentContainersProviderResult.data.collaborationGraphEntities && cgRecentContainersProviderResult.data.collaborationGraphEntities.length === 0);
        return $9e71ae1a8a0d4641$var$renderTracker({
            subject: $9e71ae1a8a0d4641$var$SWITCHER_RECENT_CONTAINERS,
            providerFailed: providerFailed,
            emptyRenderExpected: emptyRenderExpected,
            linksRendered: recentLinks,
            data: data
        });
    };
    const $9e71ae1a8a0d4641$export$d75a4f56d85f67ea = (customLinksProviderResult, userSiteDataProviderResult, customLinks, data)=>{
        if (!customLinksProviderResult) return;
        const emptyRenderExpected = customLinks.length === 0;
        function getNotRenderedReason() {
            if (customLinksProviderResult?.status === (0, (0, parcelRequire("4JKO4")).Status).ERROR) return 'custom_links_api_error';
            const error = userSiteDataProviderResult.error;
            if (!error) return null;
            if (error instanceof (0, (0, parcelRequire("crCnP")).UserSiteDataError)) return error.reason;
            else return 'usd_unknown';
        }
        const notRenderedReason = getNotRenderedReason();
        return $9e71ae1a8a0d4641$var$renderTrackerWithReason({
            subject: $9e71ae1a8a0d4641$var$SWITCHER_CUSTOM_LINKS,
            notRenderedReason: notRenderedReason,
            emptyRenderExpected: emptyRenderExpected,
            data: data
        });
    };
    const $9e71ae1a8a0d4641$export$6489efba2ca85102 = (groupIndex, id, type, productType, extraAttributes)=>({
            ...$9e71ae1a8a0d4641$export$a305f130b289b818({
                groupIndex: groupIndex,
                itemId: id,
                itemType: type,
                productType: productType,
                ...extraAttributes
            })
        });
});
parcelRegister("4JKO4", function(module, exports) {
    $parcel$export(module.exports, "Status", ()=>$82e51cfa01cc5ffa$export$96e9906d6d93a972);
    $parcel$export(module.exports, "createResultComplete", ()=>$82e51cfa01cc5ffa$export$947ceca65da0e7a6);
    $parcel$export(module.exports, "isComplete", ()=>$82e51cfa01cc5ffa$export$9569565a7ac14e8e);
    $parcel$export(module.exports, "isError", ()=>$82e51cfa01cc5ffa$export$e6127cc7fe7395c3);
    $parcel$export(module.exports, "hasLoaded", ()=>$82e51cfa01cc5ffa$export$5fce62f50756dbf);
    $parcel$export(module.exports, "default", ()=>$82e51cfa01cc5ffa$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $jMc3y;
    var $cb25w;
    var $3JMPn;
    var $ceimD;
    var $9dCRm;
    const $82e51cfa01cc5ffa$var$DATA_PROVIDER_SUBJECT = 'atlassianSwitcherDataProvider';
    var $82e51cfa01cc5ffa$export$96e9906d6d93a972;
    (function(Status) {
        Status["LOADING"] = "loading";
        Status["COMPLETE"] = "complete";
        Status["ERROR"] = "error";
    })($82e51cfa01cc5ffa$export$96e9906d6d93a972 || ($82e51cfa01cc5ffa$export$96e9906d6d93a972 = {}));
    const $82e51cfa01cc5ffa$export$947ceca65da0e7a6 = (data)=>({
            status: "complete",
            data: data
        });
    const $82e51cfa01cc5ffa$export$9569565a7ac14e8e = (result)=>result.status === "complete";
    const $82e51cfa01cc5ffa$export$e6127cc7fe7395c3 = (result)=>result.status === "error";
    const $82e51cfa01cc5ffa$export$20bb0d907fbbe433 = (result)=>result.status === "loading";
    const $82e51cfa01cc5ffa$export$5fce62f50756dbf = (result)=>result.status !== "loading";
    function $82e51cfa01cc5ffa$export$2e2bcd8739ae039(name, experienceMark, mapPropsToPromise, mapPropsToInitialValue, retryConfig, shouldUpdate) {
        const getInitialState = (props)=>{
            if (mapPropsToInitialValue) {
                const initialValue = mapPropsToInitialValue(props);
                if (initialValue !== undefined) return {
                    status: "complete",
                    data: initialValue
                };
            }
            return {
                status: "loading",
                data: null
            };
        };
        class DataProvider extends (0, ($parcel$interopDefault($5uXOq))).Component {
            static{
                this.displayName = `DataProvider(${name})`;
            }
            componentWillUnmount() {
                this.acceptResults = false;
            }
            componentDidMount() {
                this.props.experienceTracker.markStart(experienceMark);
                this.fetchData();
            }
            componentDidUpdate(prevProps) {
                if (shouldUpdate?.(prevProps.params, this.props.params)) this.fetchData();
            }
            fetchData() {
                (0, (0, parcelRequire("ceimD")).retryOnException)(()=>mapPropsToPromise(this.props.params), {
                    intervalsMS: retryConfig?.intervalsMS || [],
                    shouldRetryOnException: retryConfig?.shouldRetryOnException,
                    onRetry: (previousException, retryCount)=>{
                        this.onRetry(previousException, retryCount);
                    }
                }).then((result)=>{
                    this.onResult(result);
                }).catch((error)=>{
                    this.onError(error);
                });
            }
            onResult(value) {
                if (this.acceptResults) this.setState({
                    data: value,
                    status: "complete"
                });
                this.props.experienceTracker.markEnd(experienceMark);
                this.fireOperationalEvent({
                    action: 'receivedResult',
                    actionSubjectId: name,
                    attributes: {
                        provider: name
                    }
                });
            }
            onRetry(error, retryCount) {
                this.fireOperationalEvent({
                    action: 'retried',
                    actionSubjectId: name,
                    attributes: {
                        provider: name,
                        reason: retryConfig?.customErrorToReason ? retryConfig.customErrorToReason(error) : (0, (0, parcelRequire("3JMPn")).errorToReason)(error),
                        retryCount: retryCount
                    }
                });
            }
            onError(error) {
                if (this.acceptResults && !$82e51cfa01cc5ffa$export$9569565a7ac14e8e(this.state)) this.setState({
                    error: error,
                    status: "error",
                    data: null
                });
                this.fireOperationalEvent({
                    action: 'failed',
                    actionSubjectId: name,
                    attributes: {
                        provider: name,
                        reason: (0, (0, parcelRequire("3JMPn")).errorToReason)(error)
                    }
                });
            }
            render() {
                return this.props.children(this.state);
            }
            constructor(...args){
                super(...args), this.acceptResults = true, this.state = getInitialState(this.props.params), this.fireOperationalEvent = (payload)=>{
                    if (this.props.createAnalyticsEvent) this.props.createAnalyticsEvent({
                        eventType: (0, $676c5e519aa5ba55$export$12346a674644c156),
                        actionSubject: $82e51cfa01cc5ffa$var$DATA_PROVIDER_SUBJECT,
                        ...payload,
                        attributes: {
                            ...payload.attributes,
                            outdated: !this.acceptResults
                        }
                    }).fire((0, (0, parcelRequire("jMc3y")).NAVIGATION_CHANNEL));
                };
            }
        }
        const InnerComponent = (0, (0, parcelRequire("cb25w")).default)()((0, (0, parcelRequire("9dCRm")).withExperienceTracker)(DataProvider));
        const OuterComponent = ({ children: children, ...params })=>{
            return (0, ($parcel$interopDefault($5uXOq))).createElement(InnerComponent, {
                params: params
            }, children);
        };
        return OuterComponent;
    }
});
parcelRegister("3JMPn", function(module, exports) {
    $parcel$export(module.exports, "errorToReason", ()=>$dc29284f7f5c6994$export$a3e288208721751b);
    function $dc29284f7f5c6994$export$a3e288208721751b(error) {
        const { name: name = 'Unknown', status: status } = error || {};
        return {
            name: name,
            status: status
        };
    }
});
parcelRegister("ceimD", function(module, exports) {
    $parcel$export(module.exports, "retryOnException", ()=>$9ef2d0ae385447e7$export$1d94629c94e7a17f);
    const $9ef2d0ae385447e7$export$5c069c93d2b7493f = (ms)=>new Promise((resolve)=>{
            setTimeout(resolve, ms);
        });
    const $9ef2d0ae385447e7$export$1d94629c94e7a17f = async (invokeOperation, config)=>{
        let nextMSInterval = 0;
        let error = new Error('No calls made');
        const retries = config.intervalsMS.length;
        while(nextMSInterval !== undefined)try {
            if (nextMSInterval > 0) {
                await $9ef2d0ae385447e7$export$5c069c93d2b7493f(nextMSInterval);
                if (config.onRetry) config.onRetry(error, retries - config.intervalsMS.length);
            }
            return await invokeOperation();
        } catch (e) {
            error = e;
            if (config.shouldRetryOnException && !config.shouldRetryOnException(error)) throw error;
            nextMSInterval = config.intervalsMS.shift();
        }
        throw error;
    };
});
parcelRegister("9dCRm", function(module, exports) {
    $parcel$export(module.exports, "SwitcherExperienceTrackerContext", ()=>$fd97f7583b9f4485$export$3f3eebb4b8116461);
    $parcel$export(module.exports, "useExperienceTracker", ()=>$fd97f7583b9f4485$export$cdefb2a8b53f879f);
    $parcel$export(module.exports, "withExperienceTracker", ()=>$fd97f7583b9f4485$export$f88dde183f4d31cb);
    var $5uXOq = parcelRequire("5uXOq");
    const $fd97f7583b9f4485$var$noop = ()=>{};
    const $fd97f7583b9f4485$export$3f3eebb4b8116461 = (0, $5uXOq.createContext)({
        start: $fd97f7583b9f4485$var$noop,
        success: $fd97f7583b9f4485$var$noop,
        failure: $fd97f7583b9f4485$var$noop,
        failureAll: $fd97f7583b9f4485$var$noop,
        abort: $fd97f7583b9f4485$var$noop,
        abortAll: $fd97f7583b9f4485$var$noop,
        markStart: $fd97f7583b9f4485$var$noop,
        markEnd: $fd97f7583b9f4485$var$noop
    });
    const $fd97f7583b9f4485$export$cdefb2a8b53f879f = ()=>(0, $5uXOq.useContext)($fd97f7583b9f4485$export$3f3eebb4b8116461);
    const $fd97f7583b9f4485$export$f88dde183f4d31cb = (Component)=>{
        const WithExperienceTracker = (props)=>{
            const experienceTracker = $fd97f7583b9f4485$export$cdefb2a8b53f879f();
            return (0, ($parcel$interopDefault($5uXOq))).createElement(Component, {
                ...props,
                experienceTracker: experienceTracker
            });
        };
        WithExperienceTracker.displayName = `WithExperienceTracker(${Component.displayName})`;
        return WithExperienceTracker;
    };
});
parcelRegister("crCnP", function(module, exports) {
    $parcel$export(module.exports, "UserSiteDataErrorReason", ()=>$f5aa30bcad5cbe4c$export$b08600051ba52198);
    $parcel$export(module.exports, "UserSiteDataError", ()=>$f5aa30bcad5cbe4c$export$c460344055e97b1);
    var $f5aa30bcad5cbe4c$export$b08600051ba52198;
    (function(UserSiteDataErrorReason) {
        UserSiteDataErrorReason["APS_NO_SITE_MATCH"] = "aps_no_site_match";
        UserSiteDataErrorReason["APS_EMPTY_RESULT"] = "aps_empty_result";
        UserSiteDataErrorReason["APS_PARTIAL_EMPTY_RESULT"] = "aps_partial_response_empty_result";
    })($f5aa30bcad5cbe4c$export$b08600051ba52198 || ($f5aa30bcad5cbe4c$export$b08600051ba52198 = {}));
    class $f5aa30bcad5cbe4c$export$c460344055e97b1 extends Error {
        constructor(reason, message){
            super(message);
            this.name = 'UserSiteDataError';
            this.reason = reason;
        }
    }
});
parcelRegister("6WztE", function(module, exports) {
    $parcel$export(module.exports, "ImageLoadTrackerBuckets", ()=>$511e8ab45352d11f$export$5fbf68affeca91cd);
    $parcel$export(module.exports, "RenderTrackerBuckets", ()=>$511e8ab45352d11f$export$e59c24bc0768d568);
    $parcel$export(module.exports, "getMetricBucket", ()=>$511e8ab45352d11f$export$b59492d26971ae92);
    const $511e8ab45352d11f$var$INFINITY = '+Inf';
    const $511e8ab45352d11f$export$5fbf68affeca91cd = [
        4000,
        2000,
        1000,
        500,
        100,
        50
    ];
    const $511e8ab45352d11f$export$e59c24bc0768d568 = [
        1000,
        900,
        800,
        700,
        600,
        500
    ];
    const $511e8ab45352d11f$export$b59492d26971ae92 = (metricValue, buckets)=>{
        return metricValue >= 0 ? buckets.reduce((lowestBucket, currentBucket)=>{
            return metricValue <= currentBucket ? currentBucket.toString() : lowestBucket.toString();
        }, $511e8ab45352d11f$var$INFINITY) : null;
    };
});
parcelRegister("1m1Hd", function(module, exports) {
    $parcel$export(module.exports, "performanceNow", ()=>$e36b466c5a947fe6$export$fb4230f160368c88);
    const $e36b466c5a947fe6$export$fb4230f160368c88 = typeof window !== 'undefined' && window.performance && window.performance.now.bind(performance) || Date.now;
});
parcelRegister("fABEI", function(module, exports) {
    $parcel$export(module.exports, "FadeIn", ()=>$0474dc0fa8056512$export$bd7370ffb2917ab7);
    parcelRequire("5uXOq");
    var $f8Sb3;
    const $0474dc0fa8056512$var$fadeIn = (0, (0, parcelRequire("f8Sb3")).keyframes)({
        to: {
            opacity: 1
        }
    });
    const $0474dc0fa8056512$var$fadeInStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        animation: `${$0474dc0fa8056512$var$fadeIn} 500ms ease forwards`,
        opacity: 0,
        margin: 0,
        padding: 0,
        color: `var(--ds-text, ${$829f609a65d26a98$export$7d61b15e0da132af})`
    });
    const $0474dc0fa8056512$export$bd7370ffb2917ab7 = ({ children: children, className: className, tag: Tag = 'div' })=>(0, (0, parcelRequire("f8Sb3")).jsx)(Tag, {
            css: $0474dc0fa8056512$var$fadeInStyles,
            className: className
        }, children);
});
parcelRegister("l1lhL", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6e2ad39095fe6079$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $fVnbM;
    var $7paD5;
    var $cb25w;
    var $jMc3y;
    var $ousew;
    const $6e2ad39095fe6079$var$ItemLink = ({ label: label, href: href, testId: testId, onClick: onClick, ariaLabel: ariaLabel })=>{
        const buttonProps = {
            appearance: 'link',
            href: href,
            className: 'section-link',
            target: '_blank',
            rel: 'noopener noreferrer',
            iconAfter: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("7paD5"))))), {
                LEGACY_size: "small",
                color: "currentColor",
                label: ""
            }),
            onClick: onClick ? (e, a)=>onClick(e, a) : undefined,
            testId: testId
        };
        if (ariaLabel) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), ariaLabel, (placeholder)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
                ...buttonProps,
                "aria-label": String(placeholder)
            }, label));
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), buttonProps, label);
    };
    var $6e2ad39095fe6079$export$2e2bcd8739ae039 = (0, (0, parcelRequire("cb25w")).default)({
        onClick: (0, (0, parcelRequire("jMc3y")).createAndFireNavigationEvent)({
            eventType: (0, $676c5e519aa5ba55$export$a1562d08625f5d7e),
            action: 'clicked',
            actionSubject: (0, (0, parcelRequire("jMc3y")).SWITCHER_ITEM_SUBJECT)
        })
    })($6e2ad39095fe6079$var$ItemLink);
});
parcelRegister("7Ghqv", function(module, exports) {
    $parcel$export(module.exports, "CollaborationGraphRecentContainerType", ()=>$5da9cf836c48eef4$export$405e7bccf91c0dd6);
    $parcel$export(module.exports, "Permissions", ()=>$5da9cf836c48eef4$export$2d41982586bbb6be);
    $parcel$export(module.exports, "Product", ()=>$5da9cf836c48eef4$export$264ad599d7cef668);
    $parcel$export(module.exports, "Feature", ()=>$5da9cf836c48eef4$export$6e91cf7616333d5);
    $parcel$export(module.exports, "AnalyticsItemType", ()=>$5da9cf836c48eef4$export$77f267162e8983fb);
    $parcel$export(module.exports, "ProductKey", ()=>$5da9cf836c48eef4$export$f3a53bd43617a593);
    $parcel$export(module.exports, "DiscoverLinkItemKeys", ()=>$5da9cf836c48eef4$export$b5f05566ea758e86);
    var $5da9cf836c48eef4$export$32bb98a9a0fbbcb0;
    (function(RecentContainerType) {
        RecentContainerType["JIRA_PROJECT"] = "jira-project";
        RecentContainerType["CONFLUENCE_SPACE"] = "confluence-space";
    })($5da9cf836c48eef4$export$32bb98a9a0fbbcb0 || ($5da9cf836c48eef4$export$32bb98a9a0fbbcb0 = {}));
    var $5da9cf836c48eef4$export$405e7bccf91c0dd6;
    (function(CollaborationGraphRecentContainerType) {
        CollaborationGraphRecentContainerType["JIRA_PROJECT"] = "jiraProject";
        CollaborationGraphRecentContainerType["CONFLUENCE_SPACE"] = "confluenceSpace";
    })($5da9cf836c48eef4$export$405e7bccf91c0dd6 || ($5da9cf836c48eef4$export$405e7bccf91c0dd6 = {}));
    var $5da9cf836c48eef4$export$2d41982586bbb6be;
    (function(Permissions) {
        Permissions["MANAGE"] = "manage";
        Permissions["CAN_INVITE_USERS"] = "invite-users";
    })($5da9cf836c48eef4$export$2d41982586bbb6be || ($5da9cf836c48eef4$export$2d41982586bbb6be = {}));
    var $5da9cf836c48eef4$export$264ad599d7cef668;
    (function(Product) {
        Product["BITBUCKET"] = "bitbucket";
        Product["CONFLUENCE"] = "confluence";
        Product["HOME"] = "home";
        Product["JIRA"] = "jira";
        Product["SITE_ADMIN"] = "site-admin";
        Product["TRELLO"] = "trello";
        Product["START"] = "start";
    })($5da9cf836c48eef4$export$264ad599d7cef668 || ($5da9cf836c48eef4$export$264ad599d7cef668 = {}));
    var $5da9cf836c48eef4$export$6e91cf7616333d5;
    (function(Feature) {
        Feature["enableRecentContainers"] = "enableRecentContainers";
        Feature["xflow"] = "xflow";
        Feature["isProductStoreInTrelloJSWFirstEnabled"] = "isProductStoreInTrelloJSWFirstEnabled";
        Feature["isProductStoreInTrelloConfluenceFirstEnabled"] = "isProductStoreInTrelloConfluenceFirstEnabled";
        Feature["isSlackDiscoveryEnabled"] = "isSlackDiscoveryEnabled";
        Feature["isUFOEnabled"] = "isUFOEnabled";
        Feature["isHighlightJwmInSwitcherExtendedAudienceEnabled"] = "isHighlightJwmInSwitcherExtendedAudienceEnabled";
    })($5da9cf836c48eef4$export$6e91cf7616333d5 || ($5da9cf836c48eef4$export$6e91cf7616333d5 = {}));
    var $5da9cf836c48eef4$export$77f267162e8983fb;
    (function(AnalyticsItemType) {
        AnalyticsItemType["PRODUCT"] = "product";
        AnalyticsItemType["ADMIN"] = "admin";
        AnalyticsItemType["TRY"] = "try";
        AnalyticsItemType["JOIN"] = "join";
        AnalyticsItemType["CUSTOM_LINK"] = "customLink";
        AnalyticsItemType["DISCOVER_FIXED_LINKS"] = "discover-fixed-links";
        AnalyticsItemType["RECENT"] = "recent";
        AnalyticsItemType["EMPTY_STATE_EXPLORE_PRODUCTS"] = "empty-state-explore-products";
    })($5da9cf836c48eef4$export$77f267162e8983fb || ($5da9cf836c48eef4$export$77f267162e8983fb = {}));
    var $5da9cf836c48eef4$export$f3a53bd43617a593;
    (function(ProductKey) {
        ProductKey["CONFLUENCE"] = "confluence.ondemand";
        ProductKey["JIRA_CORE"] = "jira-core.ondemand";
        ProductKey["JIRA_SOFTWARE"] = "jira-software.ondemand";
        ProductKey["JIRA_SERVICE_DESK"] = "jira-servicedesk.ondemand";
        ProductKey["BITBUCKET"] = "bitbucket";
        ProductKey["OPSGENIE"] = "opsgenie";
        ProductKey["STATUSPAGE"] = "statuspage";
        ProductKey["TRELLO"] = "trello";
        ProductKey["COMPASS"] = "compass";
        ProductKey["TEAM_CENTRAL"] = "townsquare";
        ProductKey["JIRA_PRODUCT_DISCOVERY"] = "jira-product-discovery";
    })($5da9cf836c48eef4$export$f3a53bd43617a593 || ($5da9cf836c48eef4$export$f3a53bd43617a593 = {}));
    var $5da9cf836c48eef4$export$b5f05566ea758e86;
    (function(DiscoverLinkItemKeys) {
        DiscoverLinkItemKeys["DISCOVER_MORE"] = "discover-more";
        DiscoverLinkItemKeys["SLACK_INTEGRATION"] = "slack-integration";
    })($5da9cf836c48eef4$export$b5f05566ea758e86 || ($5da9cf836c48eef4$export$b5f05566ea758e86 = {}));
});
parcelRegister("47RdN", function(module, exports) {
    $parcel$export(module.exports, "LozengeType", ()=>$a9efd1840e3e9616$export$b95b532653e2b7f6);
    $parcel$export(module.exports, "default", ()=>$a9efd1840e3e9616$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $3Z96c;
    var $jMc3y;
    var $fABEI;
    var $f8Sb3;
    var $lj8SI;
    var $ousew;
    var $11Xk0;
    var $5bUrR;
    function $a9efd1840e3e9616$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    var $a9efd1840e3e9616$export$b95b532653e2b7f6;
    (function(LozengeType) {
        LozengeType["New"] = "new";
        LozengeType["Try"] = "try";
    })($a9efd1840e3e9616$export$b95b532653e2b7f6 || ($a9efd1840e3e9616$export$b95b532653e2b7f6 = {}));
    const $a9efd1840e3e9616$var$lozengeData = {
        ["new"]: {
            label: (0, (0, parcelRequire("11Xk0")).default).newLozenge,
            componentProps: {
                appearance: 'new'
            }
        },
        ["try"]: {
            label: (0, (0, parcelRequire("11Xk0")).default).tryLozenge,
            componentProps: {
                appearance: 'new'
            }
        }
    };
    const $a9efd1840e3e9616$var$fadeInStyles = {
        name: "1d3w5wq",
        styles: "width:100%"
    };
    const $a9efd1840e3e9616$var$childrenStyles = {
        name: "1ixuzqj",
        styles: "line-height:14px;min-height:16px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap"
    };
    const $a9efd1840e3e9616$var$itemDescriptionStyles = {
        name: "ess88o",
        styles: "color:var(--ds-text-subtlest, #626F86);overflow:hidden;text-overflow:ellipsis;white-space:nowrap;line-height:var(--ds-space-150, 12px);font-weight:var(--ds-font-weight-regular, 400)"
    };
    const $a9efd1840e3e9616$var$SwitcherItem = ({ icon: icon, description: description, elemAfter: elemAfter, shouldAllowMultiline: shouldAllowMultiline, onClick: onClick, children: children, lozenges: lozenges, product: product, createAnalyticsEvent: createAnalyticsEvent, tag: tag, href: href, ...rest })=>{
        const itemDescription = (0, ($parcel$interopDefault($5uXOq))).useMemo(()=>{
            if ((0, ($parcel$interopDefault($5uXOq))).isValidElement(description) || typeof description === 'string') return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                css: $a9efd1840e3e9616$var$itemDescriptionStyles
            }, description);
            return undefined;
        }, [
            description
        ]);
        const renderLozenges = (0, ($parcel$interopDefault($5uXOq))).useMemo(()=>{
            if (!lozenges?.length) return null;
            return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("5bUrR")).default), {
                product: product,
                triggerSubject: "switcherItemLozengeErrorBoundary",
                hideFallbackUI: true
            }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault($5uXOq))).Fragment, null, lozenges.map((lozenge, index)=>{
                const { componentProps: componentProps, label: label } = $a9efd1840e3e9616$var$lozengeData[lozenge];
                return (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
                    key: index,
                    style: {
                        marginLeft: "var(--ds-space-100, 8px)"
                    }
                }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("lj8SI")).default), {
                    ...componentProps,
                    testId: "switcher-item-lozenge"
                }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("ousew")).default), label)));
            }), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("jMc3y")).RenderTracker), {
                subject: (0, (0, parcelRequire("jMc3y")).SWITCHER_ITEM_LOZENGES_SUBJECT),
                data: {
                    product: product,
                    lozenges: lozenges,
                    children: children,
                    description: description
                }
            })));
        }, [
            lozenges,
            product,
            children,
            description
        ]);
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("fABEI")).FadeIn), {
            css: $a9efd1840e3e9616$var$fadeInStyles,
            tag: tag
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("3Z96c")).default), {
            testId: "switcher-base-item",
            description: itemDescription,
            iconBefore: icon,
            iconAfter: elemAfter,
            target: "_blank",
            href: href ?? '#',
            onClick: (event)=>{
                if (!href) event.preventDefault();
                if (onClick) onClick(event);
            },
            ...rest
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: $a9efd1840e3e9616$var$childrenStyles
        }, children, renderLozenges)));
    };
    var $a9efd1840e3e9616$export$2e2bcd8739ae039 = $a9efd1840e3e9616$var$SwitcherItem;
});
parcelRegister("11Xk0", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$089b654fda7941bd$export$2e2bcd8739ae039);
    var $7VHMR;
    const $089b654fda7941bd$var$messages = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        newLozenge: {
            id: 'fabric.atlassianSwitcher.newLozenge',
            defaultMessage: 'New',
            description: 'The lozenge text for a lozenge indicating a new switcher item'
        },
        tryLozenge: {
            id: 'fabric.atlassianSwitcher.tryLozenge',
            defaultMessage: 'Try',
            description: 'Alternative lozenge text for a lozenge indicating a new switcher item'
        },
        sites: {
            id: 'fabric.atlassianSwitcher.sites',
            defaultMessage: '{productName} {numSites, plural, one {site} other {sites}}',
            description: 'The text of a toggle showing or hiding more site options'
        },
        skeletonLoaderAriaLabel: {
            id: 'fabric.atlassianSwitcher.skeletonLoaderAriaLabel',
            defaultMessage: 'The App Switcher is loading',
            description: 'The aria-label for the app switcher skeleton loader primative'
        }
    });
    var $089b654fda7941bd$export$2e2bcd8739ae039 = $089b654fda7941bd$var$messages;
});
parcelRegister("5bUrR", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$205dd79fcd22fb9a$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $ousew;
    var $8RXs9;
    var $f8Sb3;
    var $kuB9l;
    var $8ksBL;
    var $jMc3y;
    var $cb25w;
    var $lUEIX;
    var $3JMPn;
    var $2hJAu;
    var $7Ghqv;
    var $2cj0e;
    var $86sdh;
    var $cmYVy;
    function $205dd79fcd22fb9a$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $205dd79fcd22fb9a$var$TRIGGER_SUBJECT = 'errorBoundary';
    const $205dd79fcd22fb9a$var$ACTION_SUBJECT = 'rendered';
    const $205dd79fcd22fb9a$var$robotsImgStyles = {
        name: "1nv5fft",
        styles: "height:200px"
    };
    const $205dd79fcd22fb9a$var$trelloErrorImgStyles = {
        name: "8svur3",
        styles: "width:140px;height:88px"
    };
    const $205dd79fcd22fb9a$var$unverifiedUserImageStyles = {
        name: "1vavuhq",
        styles: "height:150px"
    };
    const $205dd79fcd22fb9a$var$errorContentStyles = {
        name: "1m9g2qv",
        styles: "display:flex;align-items:center;justify-content:center;flex-direction:column"
    };
    const $205dd79fcd22fb9a$var$errorHeadingStyles = {
        name: "zfzx1k",
        styles: "max-width:240px;margin-top:var(--ds-space-400, 32px)"
    };
    const $205dd79fcd22fb9a$var$errorMessageStyles = {
        name: "8c8jo5",
        styles: "max-width:240px;margin-top:var(--ds-space-300, 24px)"
    };
    const $205dd79fcd22fb9a$var$loginButtonStyles = {
        name: "1d79juz",
        styles: "margin-top:var(--ds-space-300, 24px)"
    };
    const $205dd79fcd22fb9a$var$errorBoundaryBoxStyles = {
        name: "1ourv3z",
        styles: "display:flex;justify-content:center;flex-direction:column;text-align:center"
    };
    const $205dd79fcd22fb9a$var$errorBoundaryBoxDrawerStyles = {
        name: "ys7599",
        styles: "padding-top:128px;padding-right:var(--ds-space-800, 64px)"
    };
    const $205dd79fcd22fb9a$var$errorBoundaryBoxNonDrawerStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        margin: `${"var(--ds-space-600, 48px)"} 0`
    });
    const $205dd79fcd22fb9a$var$loginButtonNonDrawerStyles = {
        name: "1gfc3a0",
        styles: "justify-content:center;align-self:stretch"
    };
    const $205dd79fcd22fb9a$var$ErrorMessage = (props)=>(0, (0, parcelRequire("f8Sb3")).jsx)("p", {
            css: $205dd79fcd22fb9a$var$errorMessageStyles
        }, props.children);
    class $205dd79fcd22fb9a$var$ErrorBoundary extends (0, ($parcel$interopDefault($5uXOq))).Component {
        componentDidCatch(error) {
            const reason = error instanceof (0, (0, parcelRequire("86sdh")).SwitcherLoadError) ? error.reason() : (0, (0, parcelRequire("3JMPn")).errorToReason)(error);
            this.setState({
                hasError: true,
                reason: reason
            }, ()=>{
                this.fireOperationalEvent({
                    action: $205dd79fcd22fb9a$var$ACTION_SUBJECT,
                    attributes: {
                        ...reason,
                        ...this.props.extraAnalyticProps
                    }
                });
            });
            this.props.onErrorCallback?.(error);
        }
        renderErrorBody(appearance) {
            const { reason: reason } = this.state;
            if (!reason) return;
            if (reason.name === (0, (0, parcelRequire("cmYVy")).FETCH_ERROR_NAME)) {
                const isTrello = this.props.product === (0, (0, parcelRequire("7Ghqv")).Product).TRELLO;
                if (reason.status === 401) return (0, (0, parcelRequire("f8Sb3")).jsx)((0, $5uXOq.Fragment), null, (0, (0, parcelRequire("f8Sb3")).jsx)($205dd79fcd22fb9a$var$ErrorMessage, null, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("2hJAu")).default).errorTextLoggedOut)), isTrello ? (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("2cj0e")).default), {
                    css: [
                        $205dd79fcd22fb9a$var$loginButtonStyles,
                        appearance !== 'drawer' && $205dd79fcd22fb9a$var$loginButtonNonDrawerStyles
                    ],
                    appearance: "link",
                    href: (0, (0, parcelRequire("lUEIX")).getLoginUrl)((0, (0, parcelRequire("7Ghqv")).Product).TRELLO),
                    onClick: this.handleLogin
                }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("2hJAu")).default).login)) : (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("2cj0e")).default), {
                    css: [
                        $205dd79fcd22fb9a$var$loginButtonStyles,
                        appearance !== 'drawer' && $205dd79fcd22fb9a$var$loginButtonNonDrawerStyles
                    ],
                    onClick: this.handleLogin
                }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("2hJAu")).default).login)));
                if (reason.status === 403) return (0, (0, parcelRequire("f8Sb3")).jsx)($205dd79fcd22fb9a$var$ErrorMessage, null, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("2hJAu")).default).errorTextUnverified));
                return (0, (0, parcelRequire("f8Sb3")).jsx)($205dd79fcd22fb9a$var$ErrorMessage, null, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("2hJAu")).default).errorTextNetwork));
            }
            return (0, (0, parcelRequire("f8Sb3")).jsx)($205dd79fcd22fb9a$var$ErrorMessage, null, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("2hJAu")).default).errorText));
        }
        renderErrorHeading() {
            const { reason: reason } = this.state;
            if (!reason) return;
            if (reason.name === (0, (0, parcelRequire("cmYVy")).FETCH_ERROR_NAME) && reason.status === 401) return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("2hJAu")).default).errorHeadingLoggedOut);
            if (reason.name === (0, (0, parcelRequire("cmYVy")).FETCH_ERROR_NAME) && reason.status === 403) return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("2hJAu")).default).errorHeadingUnverified);
            return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("2hJAu")).default).errorHeading);
        }
        renderErrorImage() {
            const { intl: intl, product: product } = this.props;
            const { reason: reason } = this.state;
            if (product === (0, (0, parcelRequire("7Ghqv")).Product).TRELLO) return (0, (0, parcelRequire("f8Sb3")).jsx)("img", {
                css: $205dd79fcd22fb9a$var$trelloErrorImgStyles,
                src: (0, (0, parcelRequire("kuB9l")).default),
                alt: intl.formatMessage((0, (0, parcelRequire("2hJAu")).default).errorImageAltText)
            });
            if (reason.status === 403) return (0, (0, parcelRequire("f8Sb3")).jsx)("img", {
                css: $205dd79fcd22fb9a$var$unverifiedUserImageStyles,
                src: (0, (0, parcelRequire("8ksBL")).default),
                alt: intl.formatMessage((0, (0, parcelRequire("2hJAu")).default).errorImageAltText)
            });
            return (0, (0, parcelRequire("f8Sb3")).jsx)($205dd79fcd22fb9a$var$RobotImage, {
                css: $205dd79fcd22fb9a$var$robotsImgStyles,
                alt: intl.formatMessage((0, (0, parcelRequire("2hJAu")).default).errorImageAltText)
            });
        }
        render() {
            const { appearance: appearance, hideFallbackUI: hideFallbackUI } = this.props;
            const { hasError: hasError } = this.state;
            if (hasError && hideFallbackUI) return (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault($5uXOq))).Fragment, null);
            if (hasError) return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                css: [
                    $205dd79fcd22fb9a$var$errorBoundaryBoxStyles,
                    appearance === 'drawer' ? $205dd79fcd22fb9a$var$errorBoundaryBoxDrawerStyles : $205dd79fcd22fb9a$var$errorBoundaryBoxNonDrawerStyles
                ],
                "data-testid": "error-boundary"
            }, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                css: $205dd79fcd22fb9a$var$errorContentStyles
            }, this.renderErrorImage(), (0, (0, parcelRequire("f8Sb3")).jsx)("h3", {
                css: $205dd79fcd22fb9a$var$errorHeadingStyles
            }, this.renderErrorHeading()), this.renderErrorBody(appearance)));
            return this.props.children;
        }
        constructor(...args){
            super(...args), this.state = {
                hasError: false
            }, this.fireOperationalEvent = (payload)=>{
                if (this.props.createAnalyticsEvent) this.props.createAnalyticsEvent({
                    eventType: (0, $676c5e519aa5ba55$export$12346a674644c156),
                    actionSubject: this.props.triggerSubject || $205dd79fcd22fb9a$var$TRIGGER_SUBJECT,
                    ...payload
                }).fire((0, (0, parcelRequire("jMc3y")).NAVIGATION_CHANNEL));
            }, this.handleLogin = (_, analyticsEvent)=>{
                analyticsEvent.update({
                    eventType: (0, $676c5e519aa5ba55$export$a1562d08625f5d7e),
                    actionSubjectId: 'login'
                }).fire((0, (0, parcelRequire("jMc3y")).NAVIGATION_CHANNEL));
                if (this.props.product !== (0, (0, parcelRequire("7Ghqv")).Product).TRELLO) window.location.reload();
            };
        }
    }
    const $205dd79fcd22fb9a$var$RobotImage = (props)=>{
        const [imgSrc, setImgSrc] = (0, $5uXOq.useState)();
        (0, $5uXOq.useEffect)(()=>{
            (parcelRequire("ayYh9")).then((src)=>setImgSrc(src.default));
        }, []);
        return (0, (0, parcelRequire("f8Sb3")).jsx)("img", {
            ...props,
            src: imgSrc
        });
    };
    var $205dd79fcd22fb9a$export$2e2bcd8739ae039 = (0, (0, parcelRequire("cb25w")).default)()((0, (0, parcelRequire("8RXs9")).default)($205dd79fcd22fb9a$var$ErrorBoundary));
});
parcelRegister("kuB9l", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$03efcb50a6bfc07f$export$2e2bcd8739ae039);
    var $03efcb50a6bfc07f$export$2e2bcd8739ae039 = 'data:image/svg+xml;base64,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';
});
parcelRegister("8ksBL", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$921547bd229f5a4a$export$2e2bcd8739ae039);
    var $921547bd229f5a4a$export$2e2bcd8739ae039 = `data:image/svg+xml;base64,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`;
});
parcelRegister("lUEIX", function(module, exports) {
    $parcel$export(module.exports, "getLoginUrl", ()=>$3f150925525e8b07$export$8abe2e83e8d74da2);
    var $7Ghqv;
    var $3f150925525e8b07$export$7dc6752a22ab011a;
    (function(Environment) {
        Environment["Staging"] = "stg";
        Environment["Production"] = "prod";
    })($3f150925525e8b07$export$7dc6752a22ab011a || ($3f150925525e8b07$export$7dc6752a22ab011a = {}));
    const $3f150925525e8b07$export$186d9db1ec46a9ca = (origin = window?.location?.origin)=>[
            'https://trello.com'
        ].includes(origin) ? "prod" : "stg";
    const $3f150925525e8b07$var$getProduct = (product)=>{
        if (product) {
            const lowerJira = (0, (0, parcelRequire("7Ghqv")).Product).JIRA.toLowerCase();
            const lowerProduct = product.toLowerCase();
            if (lowerProduct.includes(lowerJira)) return lowerJira;
            return lowerProduct;
        }
    };
    const $3f150925525e8b07$export$8abe2e83e8d74da2 = (productType, env = $3f150925525e8b07$export$186d9db1ec46a9ca(), continueUrl = String(window.location), loginHint)=>{
        const baseUrl = env === "prod" ? 'https://id.atlassian.com/login' : 'https://id.stg.internal.atlassian.com/login';
        const product = $3f150925525e8b07$var$getProduct(productType);
        return `${baseUrl}?continue=${encodeURIComponent(continueUrl)}${product ? `&application=${encodeURIComponent(product)}` : ''}
  ${loginHint ? `&login_hint=${encodeURIComponent(loginHint)}` : ''}`;
    };
});
parcelRegister("2hJAu", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$45ca83ffaf39f0d0$export$2e2bcd8739ae039);
    var $7VHMR;
    const $45ca83ffaf39f0d0$var$messages = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        emptyStateExploreProductsTitle: {
            id: 'fabric.atlassianSwitcher.emptyState.exploreProducts.title',
            defaultMessage: 'Get started with cloud',
            description: 'The title text for the empty state explore products content, which prompts users to try new products.'
        },
        emptyStateExploreProductsBody: {
            id: 'fabric.atlassianSwitcher.emptyState.exploreProducts.body',
            defaultMessage: 'Try a product to start collaborating with your team.',
            description: 'The body text for the empty state explore products content, which prompts users to try new products.'
        },
        emptyStateExploreProductsLink: {
            id: 'fabric.atlassianSwitcher.emptyState.exploreProducts.link',
            defaultMessage: 'Explore products',
            description: 'The text for the empty state explore products link, which prompts users to try new products.'
        },
        atlassianHome: {
            id: 'fabric.atlassianSwitcher.home',
            defaultMessage: 'Atlassian Home',
            description: 'The text of a link redirecting the user to the Home site'
        },
        atlassianStart: {
            id: 'fabric.atlassianSwitcher.start',
            defaultMessage: 'Atlassian Start',
            description: 'The text of a link redirecting the user to the Start site'
        },
        recent: {
            id: 'fabric.atlassianSwitcher.recent',
            defaultMessage: 'Recent',
            description: "In a context in which users are able to view recent projects or spaces they've viewed, this text is the title of the section displaying all the recent projects or spaces."
        },
        more: {
            id: 'fabric.atlassianSwitcher.more',
            defaultMessage: 'More',
            description: 'In a context in which users are able to view predefined custom links, this text is the title of the section displaying all existing custom links.'
        },
        try: {
            id: 'fabric.atlassianSwitcher.try',
            defaultMessage: 'Try',
            description: 'This text appears as a way to encourage the user to try a new Atlassian product.'
        },
        manageList: {
            id: 'fabric.atlassianSwitcher.manageList',
            defaultMessage: 'Manage list',
            description: 'This text is for the action for a user to manage the values present in an editable list of links.'
        },
        jiraProject: {
            id: 'fabric.atlassianSwitcher.jiraProject',
            defaultMessage: 'Jira project',
            description: 'In a context in which several items are listed , this text describes that the specific type of a given item is a Jira project'
        },
        confluenceSpace: {
            id: 'fabric.atlassianSwitcher.confluenceSpace',
            defaultMessage: 'Confluence space',
            description: 'In a context in which several items are listed , this text describes that the specific type of a given item is a Confluence space'
        },
        administration: {
            id: 'fabric.atlassianSwitcher.administration',
            defaultMessage: 'Administration',
            description: 'The text of a link redirecting the user to the site administration'
        },
        moreAtlassianProductsLink: {
            id: 'fabric.atlassianSwitcher.moreAtlassianProducts',
            defaultMessage: 'More Atlassian products',
            description: 'The text of a link redirecting the user to Discover More Atlassian products'
        },
        slackIntegrationLink: {
            id: 'fabric.atlassianSwitcher.slackIntegrationLink',
            defaultMessage: 'Slack',
            description: 'The text of a link which opens the Slack Authentication popup'
        },
        slackIntegrationLinkDescription: {
            id: 'fabric.atlassianSwitcher.slackIntegrationLinkDescription',
            defaultMessage: 'Integrate Slack with your Atlassian products',
            description: 'The description of a link which opens the Slack Authentication popup'
        },
        browseApps: {
            id: 'fabric.atlassianSwitcher.browseApps',
            defaultMessage: 'Browse Marketplace apps',
            description: 'The text of a link redirecting the user to Discover Embedded Marketplace within in the product (Marketplace is a brand name. Please dont translate it)'
        },
        errorEmptyPartialResults: {
            id: 'fabric.atlassianSwitcher.errorEmptyPartialResults',
            defaultMessage: "We can't display your products right now.",
            description: 'Heading of the error message when available products returns a partial result and no sites'
        },
        errorHeading: {
            id: 'fabric.atlassianSwitcher.errorHeading',
            defaultMessage: "Something\u2019s gone wrong",
            description: 'Heading of the error screen which is shown when an unknown error happens in the Atlassian Switcher. Usually due to failed network requests.'
        },
        errorText: {
            id: 'fabric.atlassianSwitcher.errorText',
            defaultMessage: "We keep track of these errors, but feel free to contact us if refreshing doesn\u2019t fix things",
            description: 'Text that is displayed when an unknown error happens in the Atlassian Switcher.'
        },
        errorImageAltText: {
            id: 'fabric.atlassianSwitcher.errorImageAltText',
            defaultMessage: 'A broken robot and a number of people busy fixing it.',
            description: 'Text displayed as alt text when an error occurs in the Atlassian Switcher'
        },
        errorTextNetwork: {
            id: 'fabric.atlassianSwitcher.errorTextNetwork',
            defaultMessage: "We couldn\u2019t load this list. Please reload the page and try again.",
            description: 'Text that is displayed when we detect a network issue.'
        },
        errorHeadingLoggedOut: {
            id: 'fabric.atlassianSwitcher.errorHeadingLoggedOut',
            defaultMessage: 'Your Atlassian account is logged out',
            description: 'Heading of the error screen which is shown when an unknown error happens in the Atlassian Switcher. Usually due to failed network requests.'
        },
        errorTextLoggedOut: {
            id: 'fabric.atlassianSwitcher.errorTextLoggedOut',
            defaultMessage: 'Log in again to use the Atlassian\u00A0switcher.',
            description: 'Text that is displayed when we detect user is logged out.'
        },
        errorHeadingUnverified: {
            id: 'fabric.atlassianSwitcher.errorHeadingUnverified',
            defaultMessage: 'Your account is unverified',
            description: 'Heading that is displayed when we detect user account is unverified.'
        },
        errorPartialResults: {
            id: 'fabric.atlassianSwitcher.errorPartialResults',
            defaultMessage: "We can't display some of your products right now.",
            description: 'Heading of the error message when available products returns a partial result and 1 or more sites'
        },
        errorPartialResultsRefresh: {
            id: 'fabric.atlassianSwitcher.errorPartialResultsRefresh',
            defaultMessage: 'Refresh the page, or try again later.',
            description: 'Subtitle of the error message when available products returns a partial result'
        },
        errorTextUnverified: {
            id: 'fabric.atlassianSwitcher.errorTextUnverified',
            defaultMessage: 'Please confirm your email address to view a list of available products.',
            description: 'Text that is displayed when we detect user account is unverified.'
        },
        login: {
            id: 'fabric.atlassianSwitcher.login',
            defaultMessage: 'Log in',
            description: 'Text in log in button.'
        },
        discover: {
            id: 'fabric.atlassianSwitcher.discover',
            defaultMessage: 'Discover',
            description: 'The header of "Discover" section'
        },
        productDescriptionConfluence: {
            id: 'fabric.atlassianSwitcher.product.description.confluence',
            defaultMessage: 'Document collaboration',
            description: 'Text displayed under the Confluence product recommendation.'
        },
        productDescriptionJiraServiceManagement: {
            id: 'fabric.atlassianSwitcher.product.description.jsm',
            defaultMessage: 'Collaborative IT service management',
            description: 'Text displayed under the Jira Service Management product recommendation.'
        },
        productDescriptionJiraSoftware: {
            id: 'fabric.atlassianSwitcher.product.description.jsw',
            defaultMessage: 'Project and issue tracking',
            description: 'Text displayed under the Jira Software product recommendation.'
        },
        productDescriptionOpsgenie: {
            id: 'fabric.atlassianSwitcher.product.description.opsgenie',
            defaultMessage: 'Modern incident management',
            description: 'Text displayed under the Opsgenie product recommendation.'
        },
        productDescriptionCompass: {
            id: 'fabric.atlassianSwitcher.product.description.compass',
            defaultMessage: 'Component manager',
            description: 'Text displayed under the Compass product recommendation.'
        },
        join: {
            id: 'fabric.atlassianSwitcher.join',
            defaultMessage: 'Join',
            description: 'Section Header in Atlassian Switcher. To set the expectation of what items would be shown in following section. Shown when an user has at least one joinable site via Domain Enabled Sign up with common collaborators.'
        }
    });
    var $45ca83ffaf39f0d0$export$2e2bcd8739ae039 = $45ca83ffaf39f0d0$var$messages;
});
parcelRegister("2cj0e", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$abbb7a21814ea675$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $9yOBd;
    function $abbb7a21814ea675$export$2e2bcd8739ae039(props) {
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9yOBd")).default), props);
    }
});
parcelRegister("86sdh", function(module, exports) {
    $parcel$export(module.exports, "SwitcherLoadErrorReason", ()=>$8b4037d96fe40f63$export$2c6136f6e27d3fdd);
    $parcel$export(module.exports, "SwitcherLoadError", ()=>$8b4037d96fe40f63$export$ff0950b3c2e7f03e);
    var $3JMPn;
    var $8b4037d96fe40f63$export$2c6136f6e27d3fdd;
    (function(SwitcherLoadErrorReason) {
        SwitcherLoadErrorReason["AVAILABLE_PRODUCTS"] = "availableProducts";
        SwitcherLoadErrorReason["PRODUCT_CONFIGURATION"] = "productConfiguration";
    })($8b4037d96fe40f63$export$2c6136f6e27d3fdd || ($8b4037d96fe40f63$export$2c6136f6e27d3fdd = {}));
    class $8b4037d96fe40f63$export$ff0950b3c2e7f03e extends Error {
        constructor(errorReason, resultError){
            super();
            this.errorReason = errorReason;
            this.resultError = resultError;
        }
        reason() {
            const potentialResultError = this.resultError;
            return {
                ...(0, (0, parcelRequire("3JMPn")).errorToReason)(potentialResultError.error ? potentialResultError.error : this.resultError),
                source: this.errorReason
            };
        }
    }
});
parcelRegister("cmYVy", function(module, exports) {
    $parcel$export(module.exports, "FETCH_ERROR_NAME", ()=>$53696f7e5e263d8c$export$83179404a61b001a);
    $parcel$export(module.exports, "FetchError", ()=>$53696f7e5e263d8c$export$26e841bcf1aeb894);
    const $53696f7e5e263d8c$export$83179404a61b001a = 'FetchError';
    class $53696f7e5e263d8c$export$26e841bcf1aeb894 extends Error {
        constructor(message, status){
            super(message), this.name = $53696f7e5e263d8c$export$83179404a61b001a;
            this.status = status;
        }
        static isFetchError(value) {
            return value instanceof $53696f7e5e263d8c$export$26e841bcf1aeb894;
        }
    }
});
parcelRegister("ayYh9", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("kQ774").then(()=>parcelRequire('dvSPx'));
});
parcelRegister("22RxY", function(module, exports) {
    $parcel$export(module.exports, "Experience", ()=>$d270989e07823e37$export$c90b54e658fc4d7c);
    $parcel$export(module.exports, "EXPERIENCE_CONFIGS", ()=>$d270989e07823e37$export$d54d7a2744fdf647);
    $parcel$export(module.exports, "ExperienceMark", ()=>$d270989e07823e37$export$cbf1e672c3e37474);
    $parcel$export(module.exports, "EXPERIENCES_TO_MARKS", ()=>$d270989e07823e37$export$755e75afbd377bc4);
    $parcel$export(module.exports, "MARKS_TO_EXPERIENCES", ()=>$d270989e07823e37$export$805ed806e0769ee4);
    $parcel$export(module.exports, "ExperienceMarkPhase", ()=>$d270989e07823e37$export$ec8391a70bbdbe59);
    $parcel$export(module.exports, "AbortReason", ()=>$d270989e07823e37$export$279d6315a97b520d);
    $parcel$export(module.exports, "SWITCHER_RENDER_START_PERFORMANCE_MARK", ()=>$d270989e07823e37$export$86919b84f9a64054);
    var $atdLB;
    var $g4yaf;
    var $d270989e07823e37$export$c90b54e658fc4d7c;
    (function(Experience) {
        Experience["RENDER_CUSTOM_LINKS_SECTION"] = "render-custom-links-section";
        Experience["RENDER_DISCOVER_SECTION"] = "render-discover-section";
        Experience["RENDER_JOIN_SECTION"] = "render-join-section";
        Experience["RENDER_RECENT_SECTION"] = "render-recent-section";
        Experience["RENDER_SWITCH_TO_SECTION"] = "render-switch-to-section";
        Experience["RENDER_SWITCHER_EMPTY_STATE"] = "render-switcher-empty-state";
    })($d270989e07823e37$export$c90b54e658fc4d7c || ($d270989e07823e37$export$c90b54e658fc4d7c = {}));
    const $d270989e07823e37$export$d54d7a2744fdf647 = {
        ["render-custom-links-section"]: {
            type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Load,
            performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).PageSegmentLoad
        },
        ["render-discover-section"]: {
            type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Load,
            performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).PageSegmentLoad
        },
        ["render-join-section"]: {
            type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Load,
            performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).PageSegmentLoad
        },
        ["render-recent-section"]: {
            type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Load,
            performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).PageSegmentLoad
        },
        ["render-switch-to-section"]: {
            type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Load,
            performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).PageSegmentLoad
        },
        ["render-switcher-empty-state"]: {
            type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Load,
            performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).PageSegmentLoad
        }
    };
    var $d270989e07823e37$export$cbf1e672c3e37474;
    (function(ExperienceMark) {
        ExperienceMark["API_APP_SWITCHER_BFF_AVAILABLE_PRODUCTS"] = "api-app-switcher-bff-available-products";
        ExperienceMark["API_AVAILABLE_PRODUCTS"] = "api-available-products";
        ExperienceMark["API_COLLABORATION_GRAPH_RECENT_CONTAINERS"] = "api-collaboration-graph-recent-containers";
        ExperienceMark["API_CONFLUENCE_CUSTOM_LINKS"] = "api-confluence-custom-links";
        ExperienceMark["API_FLIGHT_DECK"] = "api-flight-deck";
        ExperienceMark["API_JIRA_CUSTOM_LINKS"] = "api-jira-custom-links";
        ExperienceMark["API_JOINABLE_SITES"] = "api-joinable-sites";
        ExperienceMark["API_PERMISSIONS"] = "api-permissions";
        ExperienceMark["API_PRODUCT_CONFIGURATION"] = "api-product-configuration";
        ExperienceMark["API_PRODUCT_RECOMMENDATIONS"] = "api-product-recommendations";
        ExperienceMark["API_XFLOW_SETTINGS"] = "api-xflow-settings";
        ExperienceMark["SWITCHER_INITIAL_MOUNT"] = "switcher-initial-mount";
        ExperienceMark["SWITCHER_SKELETON_MOUNT"] = "switcher-skeleton-mount";
        ExperienceMark["TEST_MARK"] = "test-mark";
    })($d270989e07823e37$export$cbf1e672c3e37474 || ($d270989e07823e37$export$cbf1e672c3e37474 = {}));
    const $d270989e07823e37$var$allNonTestExperienceMarks = Object.values($d270989e07823e37$export$cbf1e672c3e37474).filter((mark)=>mark !== "test-mark");
    const $d270989e07823e37$export$755e75afbd377bc4 = {
        ["render-custom-links-section"]: $d270989e07823e37$var$allNonTestExperienceMarks,
        ["render-discover-section"]: $d270989e07823e37$var$allNonTestExperienceMarks,
        ["render-join-section"]: $d270989e07823e37$var$allNonTestExperienceMarks,
        ["render-recent-section"]: $d270989e07823e37$var$allNonTestExperienceMarks,
        ["render-switch-to-section"]: $d270989e07823e37$var$allNonTestExperienceMarks,
        ["render-switcher-empty-state"]: $d270989e07823e37$var$allNonTestExperienceMarks
    };
    const $d270989e07823e37$export$805ed806e0769ee4 = (0, (0, parcelRequire("g4yaf")).invertRecordOfArrays)($d270989e07823e37$export$755e75afbd377bc4);
    var $d270989e07823e37$export$ec8391a70bbdbe59;
    (function(ExperienceMarkPhase) {
        ExperienceMarkPhase["START"] = "start";
        ExperienceMarkPhase["END"] = "end";
    })($d270989e07823e37$export$ec8391a70bbdbe59 || ($d270989e07823e37$export$ec8391a70bbdbe59 = {}));
    var $d270989e07823e37$export$279d6315a97b520d;
    (function(AbortReason) {
        AbortReason["COMPONENT_UNMOUNTED"] = "component-unmounted";
        AbortReason["WINDOW_UNLOADING"] = "window-unloading";
    })($d270989e07823e37$export$279d6315a97b520d || ($d270989e07823e37$export$279d6315a97b520d = {}));
    const $d270989e07823e37$export$86919b84f9a64054 = 'atlassianSwitcher.render.start';
});
parcelRegister("g4yaf", function(module, exports) {
    $parcel$export(module.exports, "invertRecordOfArrays", ()=>$c43c26421979d057$export$c371a74fe5222b3);
    function $c43c26421979d057$export$c371a74fe5222b3(record) {
        const invertedRecord = {};
        Object.entries(record).forEach(([key, values])=>{
            values.forEach((value)=>{
                if (!invertedRecord[value]) invertedRecord[value] = [];
                invertedRecord[value].push(key);
            });
        });
        return invertedRecord;
    }
});
parcelRegister("hWyMn", function(module, exports) {
    $parcel$export(module.exports, "useExperienceSuccess", ()=>$bbee84552e9ea3c0$export$e94f0da4fc0603c6);
    $parcel$export(module.exports, "useExperienceRenderAndMountMark", ()=>$bbee84552e9ea3c0$export$fb30551804b67d63);
    var $9dCRm;
    var $5uXOq = parcelRequire("5uXOq");
    var $fH0uJ;
    function $bbee84552e9ea3c0$export$675e0d25df38d426(experienceName, customStartTime) {
        const experienceTracker = (0, (0, parcelRequire("9dCRm")).useExperienceTracker)();
        (0, (0, parcelRequire("fH0uJ")).useOnceImmediately)(()=>experienceTracker.start(experienceName, customStartTime));
    }
    function $bbee84552e9ea3c0$export$e94f0da4fc0603c6(experience, attributes) {
        const experienceTracker = (0, (0, parcelRequire("9dCRm")).useExperienceTracker)();
        (0, $5uXOq.useLayoutEffect)(()=>experienceTracker.success(experience, attributes), []);
    }
    function $bbee84552e9ea3c0$export$fb30551804b67d63(mark) {
        const experienceTracker = (0, (0, parcelRequire("9dCRm")).useExperienceTracker)();
        (0, (0, parcelRequire("fH0uJ")).useOnceImmediately)(()=>experienceTracker.markStart(mark));
        (0, $5uXOq.useLayoutEffect)(()=>experienceTracker.markEnd(mark), []);
    }
});
parcelRegister("fH0uJ", function(module, exports) {
    $parcel$export(module.exports, "useSingleton", ()=>$6e9973cd590aa017$export$abf4268d2dd55708);
    $parcel$export(module.exports, "useOnceImmediately", ()=>$6e9973cd590aa017$export$ad4f8d0eee7a0e24);
    var $5uXOq = parcelRequire("5uXOq");
    function $6e9973cd590aa017$export$abf4268d2dd55708(builder) {
        const ref = (0, $5uXOq.useRef)();
        if (!ref.current) ref.current = builder();
        return ref.current;
    }
    function $6e9973cd590aa017$export$ad4f8d0eee7a0e24(callback) {
        const wasCalledRef = (0, $5uXOq.useRef)(false);
        const result = (0, $5uXOq.useRef)();
        if (!wasCalledRef.current) {
            wasCalledRef.current = true;
            result.current = callback();
        }
        return result.current;
    }
});
parcelRegister("5xQkc", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("4w4yq").then(()=>parcelRequire('lsGkk'));
});
parcelRegister("dDgyP", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("03akO").then(()=>parcelRequire('dQGRb'));
});
parcelRegister("4DmXo", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("lrDLT").then(()=>parcelRequire('iedeb'));
});
parcelRegister("aZpkq", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("rzXSl").then(()=>parcelRequire('ifzLW'));
});
parcelRegister("eAU0Z", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("kMiW6").then(()=>parcelRequire('1xexx'));
});
parcelRegister("3THXg", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("bMovg").then(()=>parcelRequire('2ItOG'));
});
parcelRegister("4MkE7", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("1FvU5").then(()=>parcelRequire('4AltF'));
});
parcelRegister("l7EvD", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("cFZFA").then(()=>parcelRequire('9wotR'));
});
parcelRegister("fkxvI", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("hHjbx").then(()=>parcelRequire('bxuAW'));
});
parcelRegister("97vD6", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("iU6G0").then(()=>parcelRequire('byyT7'));
});
parcelRegister("eUeYp", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("RpbII").then(()=>parcelRequire('4Zoc6'));
});
parcelRegister("7EPVP", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("c3bpv").then(()=>parcelRequire('02NP0'));
});
parcelRegister("dewXY", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("kUgx3").then(()=>parcelRequire('hUelS'));
});
parcelRegister("6vQ0f", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("2zH6i").then(()=>parcelRequire('6yL5N'));
});
parcelRegister("7NHQ6", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("fqE7m").then(()=>parcelRequire('5qJOA'));
});
parcelRegister("dnmdG", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("6k2Ml").then(()=>parcelRequire('428T7'));
});
parcelRegister("6MX5c", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("60Nbf").then(()=>parcelRequire('lNp1U'));
});
parcelRegister("gp3bp", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("loQLa").then(()=>parcelRequire('bi7vZ'));
});
parcelRegister("f7OMn", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("liMu2").then(()=>parcelRequire('4yqs9'));
});
parcelRegister("bR1YP", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("7f0Ao").then(()=>parcelRequire('6NDIz'));
});
parcelRegister("4a6W0", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("kLuBa").then(()=>parcelRequire('cikNC'));
});
parcelRegister("gONld", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("aYJfI").then(()=>parcelRequire('ismI1'));
});
parcelRegister("6lV0p", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("jzOrb").then(()=>parcelRequire('4Img5'));
});
parcelRegister("fbptw", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("kvtv6").then(()=>parcelRequire('5Bvqf'));
});
parcelRegister("bg7cu", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("db25y").then(()=>parcelRequire('6Yr1v'));
});
parcelRegister("keX3y", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("83wMe").then(()=>parcelRequire('2jl59'));
});
parcelRegister("kxrQ7", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("kUz8X").then(()=>parcelRequire('lOfXr'));
});
parcelRegister("1AThx", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("7GDfJ").then(()=>parcelRequire('2Uk7p'));
});
parcelRegister("6ZkOb", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("2c8Nl").then(()=>parcelRequire('eTi98'));
});
parcelRegister("6xsm4", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("HFjG2").then(()=>parcelRequire('47XFm'));
});
parcelRegister("5WNqJ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2bf421fa15614840$export$2e2bcd8739ae039);
    var $7VHMR;
    const $2bf421fa15614840$var$messages = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        autoProvisionedSwitcherItemConfluenceDescription: {
            id: 'fabric.atlassianSwitcher.autoProvConfluenceUiUpdateExperimentDescription',
            defaultMessage: 'Document collaboration',
            description: 'When a user gets auto-provisioned Confluence, this is the text that will be in the description of the new Switcher Item'
        },
        atlassianStart: {
            id: 'fabric.atlassianSwitcher.start',
            defaultMessage: 'Atlassian Start',
            description: 'The text of a link redirecting the user to the Start site'
        },
        atlassianStartAriaLabel: {
            id: 'fabric.atlassianSwitcher.startAriaLabel',
            defaultMessage: 'Atlassian Start opens in a new tab',
            description: 'Aria-label for a link redirecting the user to the Start site'
        },
        switchTo: {
            id: 'fabric.atlassianSwitcher.switchTo',
            defaultMessage: 'Switch to',
            description: 'In a context in which users are able to switch between products, this text is the title of the category displaying the products the user is able to switch to.'
        },
        switchToTooltip: {
            id: 'fabric.atlassianSwitcher.switchToTooltip',
            defaultMessage: "Switch to\u2026",
            description: 'This text appears as a tooltip when a user hovers over the atlassian switcher icon before clicking on it.'
        },
        yourApps: {
            id: 'fabric.atlassianSwitcher.yourApps',
            defaultMessage: 'Your apps',
            description: 'In a context in which users are able to switch between products, this text is the title of the category displaying the products the user is able to switch to.'
        },
        yourAppsTooltip: {
            id: 'fabric.atlassianSwitcher.yourAppsTooltip',
            defaultMessage: "Your apps\u2026",
            description: 'This text appears as a tooltip when a user hovers over the atlassian switcher icon before clicking on it.'
        },
        jwmInactiveSwitcherWithJSWItemDescription: {
            id: 'fabric.atlassianSwitcher.jwmInactiveSwitcherWithJSWItemDescription',
            defaultMessage: 'Manage business projects, free with Jira Software',
            description: 'Description when a user has never used Jira Work Management but Jira Work Management has been activated and they have a Jira Software License'
        },
        jwmInactiveSwitcherWithDefaultItemDescription: {
            id: 'fabric.atlassianSwitcher.jwmInactiveSwitcherWithDefaultItemDescription',
            defaultMessage: 'Manage projects for business teams',
            description: 'Description when a user has never used Jira Work Management but Jira Work Management has been activated'
        },
        organisationsLabel: {
            id: 'fabric.atlassianSwitcher.organisationsLabel',
            defaultMessage: 'Organisations',
            description: 'The label of organisation tab list'
        },
        switcherModalLabel: {
            id: 'fabric.atlassianSwitcher.modalLabel',
            defaultMessage: 'Atlassian App Switcher',
            description: 'The label of the switcher modal'
        },
        resizeBarLabel: {
            id: 'fabric.atlassianSwitcher.resizeBarLabel',
            defaultMessage: '"Expand" or "Collapse" depending on state',
            description: 'The label of the resize bar'
        },
        resizeBarTooltipCollapsed: {
            id: 'fabric.atlassianSwitcher.resizeBarTooltipCollapsed',
            defaultMessage: 'Drag to resize{separator}Press to expand',
            description: 'The label of the resize bar tooltip when in collapsed state'
        },
        resizeBarTooltipExpanded: {
            id: 'fabric.atlassianSwitcher.resizeBarTooltipExpanded',
            defaultMessage: 'Drag to resize{separator}Press to collapse',
            description: 'The label of the resize bar tooltip when in expanded state'
        },
        resizeBarValueTextLabel: {
            id: 'fabric.atlassianSwitcher.resizeBarValueTextLabel',
            defaultMessage: 'Width',
            description: 'The value text label of the resize bar'
        }
    });
    var $2bf421fa15614840$export$2e2bcd8739ae039 = $2bf421fa15614840$var$messages;
});
parcelRegister("6HV40", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4e2305dbe349082f$export$2e2bcd8739ae039);
    var $eHiP8 = parcelRequire("eHiP8");
    var $6fYNv;
    var $jtD64;
    var $fynqv;
    var $lKWnb;
    var $4r7nA;
    var $814TT;
    function $4e2305dbe349082f$var$ownKeys(e, r) {
        var t = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
            var o = Object.getOwnPropertySymbols(e);
            r && (o = o.filter(function(r) {
                return Object.getOwnPropertyDescriptor(e, r).enumerable;
            })), t.push.apply(t, o);
        }
        return t;
    }
    function $4e2305dbe349082f$var$_objectSpread(e) {
        for(var r = 1; r < arguments.length; r++){
            var t = null != arguments[r] ? arguments[r] : {};
            r % 2 ? $4e2305dbe349082f$var$ownKeys(Object(t), !0).forEach(function(r) {
                (0, $eHiP8.default)(e, r, t[r]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $4e2305dbe349082f$var$ownKeys(Object(t)).forEach(function(r) {
                Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
            });
        }
        return e;
    }
    const $4e2305dbe349082f$var$STORAGE_KEY_BASE = "@atlassiansox/flight-deck-frontend-client";
    const $4e2305dbe349082f$var$RETRIABLE_FD_ERROR_MESSAGES = [
        "Failed to fetch",
        "NetworkError when attempting to fetch resource.",
        "Load failed"
    ];
    class $4e2305dbe349082f$export$2e2bcd8739ae039 {
        constructor(product, options = {
            handlers: {}
        }, fallbackArtifacts = []){
            (0, $eHiP8.default)(this, "fallbackArtifactMap", new Map());
            (0, $eHiP8.default)(this, "fetchFromFlightDeckPromises", new Map());
            this.expiryMS = options.expiryMS;
            this.handlers = options.handlers;
            this.product = product;
            this.storageClient = new (0, (0, parcelRequire("jtD64")).default)($4e2305dbe349082f$var$STORAGE_KEY_BASE, options);
            fallbackArtifacts.forEach((artifact)=>this.fallbackArtifactMap.set((0, (0, parcelRequire("4r7nA")).artifactKey)(artifact.name, artifact.dimensions), artifact.value));
            this.captureException = this.captureException.bind(this);
        }
        captureException(e, tags) {
            if (this.handlers.captureException) this.handlers.captureException(e, tags);
        }
        async fetchAndCacheArtifact(artifact, retryConfig) {
            const response = await (0, (0, parcelRequire("6fYNv")).retryOnException)(async ()=>{
                try {
                    const result = await (0, (0, parcelRequire("fynqv")).fetchFlightDeckConfiguration)(artifact.name, artifact.dimensions);
                    return result;
                } catch (error) {
                    throw new (0, (0, parcelRequire("lKWnb")).default)({
                        artifact: artifact.key,
                        dimensions: artifact.dimensions,
                        error: error
                    });
                }
            }, {
                captureException: this.captureException,
                retryOn: (err)=>$4e2305dbe349082f$var$RETRIABLE_FD_ERROR_MESSAGES.includes(err.message),
                intervalsMS: retryConfig === null || retryConfig === void 0 ? void 0 : retryConfig.intervalsMS,
                onRetry: retryConfig === null || retryConfig === void 0 ? void 0 : retryConfig.onRetry
            });
            if (!response) {
                const missingArtifactError = new Error(`Missing artifact: ${artifact.key}`);
                this.captureException(missingArtifactError);
                throw missingArtifactError;
            }
            this.storageClient.setItemWithExpiry(artifact.key, response, this.expiryMS);
            this.fetchFromFlightDeckPromises.delete(artifact.key);
            return response;
        }
        async fetchArtifactPromise(artifact, retryConfig) {
            if (this.fetchFromFlightDeckPromises.has(artifact.key)) return this.fetchFromFlightDeckPromises.get(artifact.key);
            const fetchPromise = this.fetchAndCacheArtifact(artifact, retryConfig);
            this.fetchFromFlightDeckPromises.set(artifact.key, fetchPromise);
            return fetchPromise;
        }
        async fetchConfigFromFlightDeck(artifact, retryConfig) {
            const experience = (0, (0, parcelRequire("814TT")).flightDeckClientExperience)();
            experience.start();
            try {
                const artifactWithKey = $4e2305dbe349082f$var$_objectSpread($4e2305dbe349082f$var$_objectSpread({}, artifact), {}, {
                    key: (0, (0, parcelRequire("4r7nA")).artifactKey)(artifact.name, artifact.dimensions)
                });
                experience.addMetadata({
                    key: artifactWithKey.key,
                    product: this.product
                });
                const artifactPromise = this.fetchArtifactPromise(artifactWithKey, retryConfig);
                const localConfig = this.storageClient.getItem(artifactWithKey.key);
                if (localConfig) {
                    experience.addMetadata({
                        configSource: "localStorage"
                    });
                    return localConfig;
                }
                if (this.fallbackArtifactMap.has(artifactWithKey.key)) {
                    experience.addMetadata({
                        configSource: "fallback"
                    });
                    return this.fallbackArtifactMap.get(artifactWithKey.key);
                }
                experience.addMetadata({
                    configSource: "fetch"
                });
                const result = await artifactPromise;
                return result;
            } catch (e) {
                experience.failure({
                    metadata: {
                        error: (0, (0, parcelRequire("814TT")).exceptionToMetadata)(e)
                    }
                });
                throw e;
            } finally{
                experience.success();
            }
        }
    }
});
parcelRegister("6fYNv", function(module, exports) {
    $parcel$export(module.exports, "retryOnException", ()=>$0dab620feb4778b8$export$1d94629c94e7a17f);
    $parcel$export(module.exports, "FailedFetchError", ()=>(parcelRequire("6sAya")).default);
    var $lLItl;
    var $daTxP;
    var $6sAya;
    const $0dab620feb4778b8$export$5c069c93d2b7493f = (ms)=>new Promise((resolve)=>{
            setTimeout(resolve, ms);
        });
    const $0dab620feb4778b8$var$NO_CALLS_ERROR = 'No calls made';
    const $0dab620feb4778b8$export$1d94629c94e7a17f = async (invokeOperation, { intervalsMS: intervalsMS = (0, (0, parcelRequire("daTxP")).NO_RETRIES), retryOn: retryOn = [
        (0, (0, parcelRequire("6sAya")).default)
    ], captureException: captureException, onRetry: onRetry })=>{
        const intervals = [
            ...intervalsMS
        ];
        let nextMSInterval = 0;
        let error = new Error($0dab620feb4778b8$var$NO_CALLS_ERROR);
        while(nextMSInterval !== undefined)try {
            if (nextMSInterval > 0) await $0dab620feb4778b8$export$5c069c93d2b7493f(nextMSInterval);
            if (onRetry && error.message !== $0dab620feb4778b8$var$NO_CALLS_ERROR) onRetry(error);
            return await invokeOperation();
        } catch (e) {
            error = (0, (0, parcelRequire("lLItl")).default)(e);
            if (captureException) captureException(error);
            if (typeof retryOn === 'function' ? retryOn(error) : retryOn.some((err)=>error instanceof err)) nextMSInterval = intervals.shift();
            else nextMSInterval = undefined;
        }
        throw error;
    };
});
parcelRegister("daTxP", function(module, exports) {
    $parcel$export(module.exports, "NO_RETRIES", ()=>$6d1feaff7ce645cb$export$a0a1c8f90becc136);
    const $6d1feaff7ce645cb$export$a0a1c8f90becc136 = [];
    const $6d1feaff7ce645cb$export$972171517b12aa4 = [
        0,
        0
    ];
    const $6d1feaff7ce645cb$export$746d2203ed8cdc40 = [
        0,
        50,
        100
    ];
    const $6d1feaff7ce645cb$export$f6858378b665f957 = [
        100,
        500,
        1000
    ];
});
parcelRegister("6sAya", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b434fbcc8a3be4d5$export$2e2bcd8739ae039);
    class $b434fbcc8a3be4d5$export$2e2bcd8739ae039 extends Error {
        constructor({ error: error, path: path, method: method }){
            super();
            this.name = 'FailedFetchError';
            this.message = error.message || 'Unknown fetch error';
            this.stack = error.stack;
            this.originalName = error.name;
            this.method = method;
            const p = path.split('?')[0];
            this.path = /^[/-a-z]+$/i.test(p) ? p : '';
        }
    }
});
parcelRegister("jtD64", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7fec5df08c1bfd78$export$2e2bcd8739ae039);
    var $fvm5n;
    const $7fec5df08c1bfd78$var$DEFAULT_STORAGE_ENGINE = 'localStorage';
    class $7fec5df08c1bfd78$export$2e2bcd8739ae039 {
        constructor(clientKey, options){
            this.getItem = (key, { useExpiredItem: useExpiredItem } = {
                useExpiredItem: false
            })=>{
                const item = this.client.getItem(this.itemKey(key));
                if (item) try {
                    const parsedItem = JSON.parse(item);
                    if (parsedItem.expires && new Date(parsedItem.expires) < new Date()) {
                        if (!useExpiredItem) return undefined;
                    }
                    return parsedItem.value;
                } catch (e) {
                    this.captureException(e);
                }
                return undefined;
            };
            this.removeItem = (key)=>{
                try {
                    this.client.removeItem(this.itemKey(key));
                } catch (e) {
                    this.captureException(e);
                }
            };
            this.setItemWithExpiry = (key, value, expireInMS)=>{
                const itemWithExpiry = {
                    value: value,
                    expires: typeof expireInMS === 'number' ? Date.now() + expireInMS : undefined
                };
                try {
                    this.client.setItem(this.itemKey(key), JSON.stringify(itemWithExpiry));
                } catch (e) {
                    this.captureException(e);
                }
            };
            this.clientKey = clientKey;
            this.handlers = options?.handlers;
            const storageEngine = options?.storageEngine || $7fec5df08c1bfd78$var$DEFAULT_STORAGE_ENGINE;
            if (!Object.prototype.hasOwnProperty.call(window, storageEngine)) (0, (0, parcelRequire("fvm5n")).mockWindowStorage)([
                storageEngine
            ]);
            this.client = window[storageEngine];
        }
        captureException(e, tags) {
            if (this.handlers?.captureException) this.handlers?.captureException(e, tags);
        }
        itemKey(key) {
            return `${this.clientKey}_${key}`;
        }
    }
});
parcelRegister("fvm5n", function(module, exports) {
    $parcel$export(module.exports, "mockWindowStorage", ()=>$e2c0533271428186$export$efebfe7859cae3c7);
    const $e2c0533271428186$export$c65e688d8b365035 = {
        _data: {},
        length: 0,
        setItem: function(id, val) {
            return this._data[id] = String(val);
        },
        getItem: function(id) {
            return this._data.hasOwnProperty(id) ? this._data[id] : undefined;
        },
        removeItem: function(id) {
            return delete this._data[id];
        },
        clear: function() {
            return this._data = {};
        },
        key: function(index) {
            return Object.keys(this._data)[index];
        }
    };
    const $e2c0533271428186$export$efebfe7859cae3c7 = (storageToMock = [
        'localStorage',
        'sessionStorage'
    ])=>{
        for (const storageToMockElement of storageToMock)Object.defineProperty(window, storageToMockElement, {
            value: {
                ...$e2c0533271428186$export$c65e688d8b365035
            },
            configurable: true
        });
    };
});
parcelRegister("fynqv", function(module, exports) {
    $parcel$export(module.exports, "fetchFlightDeckConfiguration", ()=>$b52c33ff29e619cd$export$6026918e023c9101);
    var $euiLX;
    var $6l8hg = parcelRequire("6l8hg");
    var $3TdLx;
    var $3Oidj;
    var $d5LIN;
    var $95uqQ;
    var $kJG1r = parcelRequire("kJG1r");
    const $b52c33ff29e619cd$var$defaultEnvType = "prod";
    const $b52c33ff29e619cd$var$defaultPerimeter = "commercial";
    async function $b52c33ff29e619cd$export$6026918e023c9101(artifactName, dim = {}) {
        var _dim$environmentType, _dim$perimeter;
        const environmentType = (_dim$environmentType = dim.environmentType) !== null && _dim$environmentType !== void 0 ? _dim$environmentType : $b52c33ff29e619cd$var$defaultEnvType;
        const perimeter = (_dim$perimeter = dim.perimeter) !== null && _dim$perimeter !== void 0 ? _dim$perimeter : $b52c33ff29e619cd$var$defaultPerimeter;
        const environment = $b52c33ff29e619cd$var$getEnvFromEnvType(environmentType);
        const locale = dim.locale && (0, (0, parcelRequire("euiLX")).default)(dim.locale);
        const artifactDimensions = {
            perimeter: perimeter,
            environment: environment,
            locale: locale
        };
        const client = await $b52c33ff29e619cd$var$getConfigClient(environmentType, perimeter);
        return client.getArtifact(artifactName, artifactDimensions);
    }
    async function $b52c33ff29e619cd$export$4abbe3ae0811355(dim = {}) {
        var _dim$environmentType2, _dim$perimeter2;
        const client = await $b52c33ff29e619cd$var$getConfigClient((_dim$environmentType2 = dim.environmentType) !== null && _dim$environmentType2 !== void 0 ? _dim$environmentType2 : $b52c33ff29e619cd$var$defaultEnvType, (_dim$perimeter2 = dim.perimeter) !== null && _dim$perimeter2 !== void 0 ? _dim$perimeter2 : $b52c33ff29e619cd$var$defaultPerimeter);
        return client.getLatestVersionMetadata();
    }
    async function $b52c33ff29e619cd$var$getConfigClient(env, perimeter) {
        const fetchArtifactExperience = await (0, (0, parcelRequire("95uqQ")).getFlightDeckFetchExperience)();
        const fetchVersionMetadataExperience = await (0, (0, parcelRequire("95uqQ")).getVersionMetadataFetchExperience)();
        return new (0, (0, parcelRequire("d5LIN")).ConfigClient)(new (0, (0, parcelRequire("3TdLx")).BifrostDataSource)(new (0, (0, parcelRequire("3Oidj")).BifrostHttpClientImpl)(env, perimeter), (0, $6l8hg.Versions).ManifestVersion), "Bifrost", fetchArtifactExperience, fetchVersionMetadataExperience);
    }
    function $b52c33ff29e619cd$var$getEnvFromEnvType(environment) {
        if (environment === undefined || environment === "prod") return "prod-west";
        switch(environment){
            case "stg":
                return "stg-west";
            case "adev":
                return "adev";
            case "ddev":
                return "ddev";
            case "pdev":
                return "pdev-apse2";
            case "fedex":
                return "stg-apse";
        }
    }
});
parcelRegister("euiLX", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$838bf5d423642311$export$2e2bcd8739ae039);
    const $838bf5d423642311$export$852ff24d0930c62f = (locale)=>{
        const standardizedLocale = locale.replace('_', '-');
        switch(standardizedLocale){
            case 'en-GB':
            case 'en-US':
            case 'en-XA':
            case 'en-XB':
            case 'en-ZZ':
            case 'pt-BR':
            case 'zh-CN':
            case 'zh-TW':
                return standardizedLocale;
            case 'en-UK':
                return 'en-GB';
            case 'en':
                return 'en-US';
            default:
                return standardizedLocale.split('-')[0];
        }
    };
    var $838bf5d423642311$export$2e2bcd8739ae039 = $838bf5d423642311$export$852ff24d0930c62f;
});
parcelRegister("6l8hg", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.Versions = module.exports.BaseUrls = module.exports.ConfigRegistryDataSource = module.exports.checkManifest = module.exports.parseVersionMetadata = module.exports.parseArtifactManifest = module.exports.tryGetArtifactData = module.exports.getArtifactFromSource = module.exports.Either = void 0;
    var $auuB0 = parcelRequire("auuB0");
    Object.defineProperty(module.exports, "Either", {
        enumerable: true,
        get: function() {
            return $auuB0.Either;
        }
    });
    var $2v7c1 = parcelRequire("2v7c1");
    Object.defineProperty(module.exports, "getArtifactFromSource", {
        enumerable: true,
        get: function() {
            return $2v7c1.getArtifactFromSource;
        }
    });
    Object.defineProperty(module.exports, "tryGetArtifactData", {
        enumerable: true,
        get: function() {
            return $2v7c1.tryGetArtifactData;
        }
    });
    var $8Xjp5 = parcelRequire("8Xjp5");
    Object.defineProperty(module.exports, "parseArtifactManifest", {
        enumerable: true,
        get: function() {
            return $8Xjp5.parseArtifactManifest;
        }
    });
    var $1NPzc = parcelRequire("1NPzc");
    Object.defineProperty(module.exports, "parseVersionMetadata", {
        enumerable: true,
        get: function() {
            return $1NPzc.parseVersionMetadata;
        }
    });
    var $5LTws = parcelRequire("5LTws");
    Object.defineProperty(module.exports, "checkManifest", {
        enumerable: true,
        get: function() {
            return $5LTws.checkManifest;
        }
    });
    var $6FHvZ = parcelRequire("6FHvZ");
    Object.defineProperty(module.exports, "ConfigRegistryDataSource", {
        enumerable: true,
        get: function() {
            return $6FHvZ.ConfigRegistryDataSource;
        }
    });
    var $3ijEk = parcelRequire("3ijEk");
    Object.defineProperty(module.exports, "BaseUrls", {
        enumerable: true,
        get: function() {
            return $3ijEk.BaseUrls;
        }
    });
    Object.defineProperty(module.exports, "Versions", {
        enumerable: true,
        get: function() {
            return $3ijEk.Versions;
        }
    });
});
parcelRegister("auuB0", function(module, exports) {
    "use strict";
    var $7a34706d0f0f02a3$var$__extends = module.exports && module.exports.__extends || function() {
        var extendStatics = function(d, b) {
            extendStatics = Object.setPrototypeOf || ({
                __proto__: []
            }) instanceof Array && function(d, b) {
                d.__proto__ = b;
            } || function(d, b) {
                for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
            };
            return extendStatics(d, b);
        };
        return function(d, b) {
            if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    }();
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.Either = void 0;
    var $7a34706d0f0f02a3$var$Either = function() {
        function Either() {}
        Either.prototype.map = function(f) {
            return this.flatMap(function(a) {
                return Either.right(f(a));
            });
        };
        Either.right = function(value) {
            return new $7a34706d0f0f02a3$var$Right(value);
        };
        Either.left = function(error) {
            return new $7a34706d0f0f02a3$var$Left(error);
        };
        return Either;
    }();
    module.exports.Either = $7a34706d0f0f02a3$var$Either;
    var $7a34706d0f0f02a3$var$Right = function(_super) {
        $7a34706d0f0f02a3$var$__extends(Right, _super);
        function Right(r) {
            var _this = _super.call(this) || this;
            _this.right = r;
            return _this;
        }
        Right.prototype.bimap = function(_f, g) {
            return $7a34706d0f0f02a3$var$Either.right(g(this.right));
        };
        Right.prototype.flatMap = function(f) {
            return f(this.right);
        };
        Right.prototype.fold = function(_onLeft, onRight) {
            return onRight(this.right);
        };
        Right.prototype.leftMap = function(_f) {
            return $7a34706d0f0f02a3$var$Either.right(this.right);
        };
        return Right;
    }($7a34706d0f0f02a3$var$Either);
    var $7a34706d0f0f02a3$var$Left = function(_super) {
        $7a34706d0f0f02a3$var$__extends(Left, _super);
        function Left(e) {
            var _this = _super.call(this) || this;
            _this.left = e;
            return _this;
        }
        Left.prototype.bimap = function(f, _g) {
            return $7a34706d0f0f02a3$var$Either.left(f(this.left));
        };
        Left.prototype.flatMap = function(_f) {
            return $7a34706d0f0f02a3$var$Either.left(this.left);
        };
        Left.prototype.fold = function(onLeft, _onRight) {
            return onLeft(this.left);
        };
        Left.prototype.leftMap = function(f) {
            return $7a34706d0f0f02a3$var$Either.left(f(this.left));
        };
        return Left;
    }($7a34706d0f0f02a3$var$Either);
});
parcelRegister("2v7c1", function(module, exports) {
    "use strict";
    var $1d240e683f64836f$var$__assign = module.exports && module.exports.__assign || function() {
        $1d240e683f64836f$var$__assign = Object.assign || function(t) {
            for(var s, i = 1, n = arguments.length; i < n; i++){
                s = arguments[i];
                for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }
            return t;
        };
        return $1d240e683f64836f$var$__assign.apply(this, arguments);
    };
    var $1d240e683f64836f$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
        function adopt(value) {
            return value instanceof P ? value : new P(function(resolve) {
                resolve(value);
            });
        }
        return new (P || (P = Promise))(function(resolve, reject) {
            function fulfilled(value) {
                try {
                    step(generator.next(value));
                } catch (e) {
                    reject(e);
                }
            }
            function rejected(value) {
                try {
                    step(generator["throw"](value));
                } catch (e) {
                    reject(e);
                }
            }
            function step(result) {
                result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
            }
            step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
    };
    var $1d240e683f64836f$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
        var _ = {
            label: 0,
            sent: function() {
                if (t[0] & 1) throw t[1];
                return t[1];
            },
            trys: [],
            ops: []
        }, f, y, t, g;
        return g = {
            next: verb(0),
            "throw": verb(1),
            "return": verb(2)
        }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
            return this;
        }), g;
        function verb(n) {
            return function(v) {
                return step([
                    n,
                    v
                ]);
            };
        }
        function step(op) {
            if (f) throw new TypeError("Generator is already executing.");
            while(g && (g = 0, op[0] && (_ = 0)), _)try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                if (y = 0, t) op = [
                    op[0] & 2,
                    t.value
                ];
                switch(op[0]){
                    case 0:
                    case 1:
                        t = op;
                        break;
                    case 4:
                        _.label++;
                        return {
                            value: op[1],
                            done: false
                        };
                    case 5:
                        _.label++;
                        y = op[1];
                        op = [
                            0
                        ];
                        continue;
                    case 7:
                        op = _.ops.pop();
                        _.trys.pop();
                        continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                            _ = 0;
                            continue;
                        }
                        if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                            _.label = op[1];
                            break;
                        }
                        if (op[0] === 6 && _.label < t[1]) {
                            _.label = t[1];
                            t = op;
                            break;
                        }
                        if (t && _.label < t[2]) {
                            _.label = t[2];
                            _.ops.push(op);
                            break;
                        }
                        if (t[2]) _.ops.pop();
                        _.trys.pop();
                        continue;
                }
                op = body.call(thisArg, _);
            } catch (e) {
                op = [
                    6,
                    e
                ];
                y = 0;
            } finally{
                f = t = 0;
            }
            if (op[0] & 5) throw op[1];
            return {
                value: op[0] ? op[1] : void 0,
                done: true
            };
        }
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.tryGetArtifactData = module.exports.getArtifactFromSource = void 0;
    var $hdDPm = parcelRequire("hdDPm");
    var $6l8hg = parcelRequire("6l8hg");
    var $9te7V = parcelRequire("9te7V");
    var $9P145 = parcelRequire("9P145");
    var $3evgk = parcelRequire("3evgk");
    function $1d240e683f64836f$var$getArtifactFromSource(dataSource, specifiedDimensions, deniedArtifactType) {
        return $1d240e683f64836f$var$__awaiter(this, void 0, void 0, function() {
            var manifestResult;
            var _this = this;
            return $1d240e683f64836f$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4,
                            dataSource.getManifest(specifiedDimensions.name, specifiedDimensions.version)
                        ];
                    case 1:
                        manifestResult = _a.sent();
                        return [
                            2,
                            manifestResult.fold(function(error) {
                                return Promise.resolve({
                                    type: "manifest-fetch-error",
                                    error: error
                                });
                            }, function(manifest) {
                                return $1d240e683f64836f$var$__awaiter(_this, void 0, void 0, function() {
                                    var manifestCheckResult, publishMetadata, dimensionContextResult;
                                    return $1d240e683f64836f$var$__generator(this, function(_a) {
                                        manifestCheckResult = (0, $6l8hg.checkManifest)(manifest, {
                                            name: specifiedDimensions.name,
                                            version: specifiedDimensions.version
                                        });
                                        if (manifestCheckResult.key !== "success") return [
                                            2,
                                            {
                                                type: manifestCheckResult.key
                                            }
                                        ];
                                        publishMetadata = manifest.publishMetadata;
                                        if (manifest.frontend && deniedArtifactType === "frontend") return [
                                            2,
                                            {
                                                type: "denied-artifact-type",
                                                deniedType: "frontend",
                                                publishMetadata: publishMetadata
                                            }
                                        ];
                                        else if (!manifest.frontend && deniedArtifactType === "backend") return [
                                            2,
                                            {
                                                type: "denied-artifact-type",
                                                deniedType: "backend",
                                                publishMetadata: publishMetadata
                                            }
                                        ];
                                        dimensionContextResult = (0, $9te7V.getDimensionContext)(specifiedDimensions, manifest);
                                        switch(dimensionContextResult.type){
                                            case "missing-dimension-specification":
                                                return [
                                                    2,
                                                    {
                                                        type: "missing-dimension-specification",
                                                        publishMetadata: publishMetadata
                                                    }
                                                ];
                                            case "unsupported-value-specified-for-supported-dimension":
                                                return [
                                                    2,
                                                    {
                                                        type: "unsupported-value-specified-for-supported-dimension",
                                                        publishMetadata: publishMetadata
                                                    }
                                                ];
                                            case "success":
                                                return [
                                                    2,
                                                    $1d240e683f64836f$var$getArtifact(dataSource, manifest, dimensionContextResult.dimensionContext)
                                                ];
                                            default:
                                                (0, $9P145.assertUnreachable)(dimensionContextResult);
                                        }
                                        return [
                                            2
                                        ];
                                    });
                                });
                            })
                        ];
                }
            });
        });
    }
    module.exports.getArtifactFromSource = $1d240e683f64836f$var$getArtifactFromSource;
    function $1d240e683f64836f$var$getArtifact(dataSource, manifest, dimensionContext) {
        return $1d240e683f64836f$var$__awaiter(this, void 0, void 0, function() {
            var publishMetadata, tag, artifactResult;
            var _this = this;
            return $1d240e683f64836f$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        publishMetadata = manifest.publishMetadata;
                        try {
                            tag = (0, $hdDPm.interpolateTagScheme)(manifest.tagScheme, $1d240e683f64836f$var$__assign($1d240e683f64836f$var$__assign({}, dimensionContext), {
                                name: manifest.name
                            }));
                        } catch (e) {
                            return [
                                2,
                                {
                                    type: "tag-scheme-interpolation-error",
                                    publishMetadata: publishMetadata
                                }
                            ];
                        }
                        return [
                            4,
                            dataSource.getArtifact(manifest.name, tag)
                        ];
                    case 1:
                        artifactResult = _a.sent();
                        return [
                            2,
                            artifactResult.fold(function(error) {
                                return Promise.resolve({
                                    type: "artifact-fetch-error",
                                    error: error,
                                    publishMetadata: publishMetadata
                                });
                            }, function(data) {
                                return $1d240e683f64836f$var$__awaiter(_this, void 0, void 0, function() {
                                    return $1d240e683f64836f$var$__generator(this, function(_a) {
                                        return [
                                            2,
                                            {
                                                type: "success",
                                                data: data,
                                                publishMetadata: publishMetadata,
                                                artifactVersion: dimensionContext["version"]
                                            }
                                        ];
                                    });
                                });
                            })
                        ];
                }
            });
        });
    }
    function $1d240e683f64836f$var$tryGetArtifactData(artifact, dataSourceName) {
        switch(artifact.type){
            case "manifest-fetch-error":
                throw new Error("Unable to fetch manifest due to ".concat(dataSourceName, " response error: ").concat((0, $3evgk.toPrettyJson)(artifact.error)));
            case "artifact-fetch-error":
                throw new Error("Unable to fetch artifact due to ".concat(dataSourceName, " response error: ").concat((0, $3evgk.toPrettyJson)(artifact.error)));
            case "denied-artifact-type":
                throw new Error("No artifacts should be denied, but type ".concat(artifact.deniedType, " was denied."));
            case "unsupported-value-specified-for-supported-dimension":
                throw new Error("An unsupported value was specified for a supported dimension");
            case "missing-dimension-specification":
                throw new Error("A required dimension specification was missing");
            case "tag-scheme-interpolation-error":
                throw new Error("Ran into failure when trying to interpolate tag scheme");
            case "mismatched-manifest-name":
                throw new Error("Manifest has been corrupted. Manifest name is mismatched.");
            case "mismatched-manifest-version":
                throw new Error("Manifest has been corrupted. Manifest version is mismatched.");
            case "success":
                return artifact.data;
            default:
                (0, $9P145.assertUnreachable)(artifact);
        }
    }
    module.exports.tryGetArtifactData = $1d240e683f64836f$var$tryGetArtifactData;
});
parcelRegister("hdDPm", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.getVersionMetadataTag = module.exports.getDataTagForManifest = module.exports.getDimensionsFromTagScheme = module.exports.generateTagScheme = module.exports.interpolateTagScheme = void 0;
    const $c8928b7419a5cc69$var$TAG_SCHEME_VERSION = 2;
    function $c8928b7419a5cc69$var$interpolateTagScheme(tagSchema, context) {
        const dimensions = Array.from($c8928b7419a5cc69$var$getDimensionsFromTagScheme(tagSchema));
        return dimensions.reduce((interpolatedTagScheme, dimension)=>{
            if (context.hasOwnProperty(dimension)) return interpolatedTagScheme.replace(new RegExp(`\\$${dimension}\\$`, "g"), context[dimension]);
            else {
                const contextAsJson = $c8928b7419a5cc69$var$toPrettyJson(context);
                throw new Error(`Bad variable "${dimension}" found enclosed in '$', so cannot infer
                     filename for artifact from tag schema: was expecting that
                     '${dimension}' would be a known dimension passed in context. This
                     is most likely a bug in Flight Deck. To help you debug, the Context
                     received was:\n"${contextAsJson}"\nOne of the keys in that object should
                     have been '${contextAsJson}'.`);
            }
        }, tagSchema);
    }
    module.exports.interpolateTagScheme = $c8928b7419a5cc69$var$interpolateTagScheme;
    function $c8928b7419a5cc69$var$generateTagScheme(dimensions, supportedDimensionPrefixes, effectiveContextDimension = (d)=>d) {
        const effectiveDimensions = new Set([
            ...dimensions
        ].map(effectiveContextDimension));
        for (const dimensionToInclude of effectiveDimensions){
            if (!supportedDimensionPrefixes.has(effectiveContextDimension(dimensionToInclude))) throw new Error([
                `Building a tag scheme failed! The dimension '${dimensionToInclude}' is not `,
                `recognized as a dimension (known dimensions are ${[
                    ...supportedDimensionPrefixes.keys()
                ].join(", ")}!`
            ].join(" "));
        }
        const padded_version = $c8928b7419a5cc69$var$TAG_SCHEME_VERSION.toString().padStart(3, "0");
        let tagScheme = `v${padded_version}`;
        for (const entry of supportedDimensionPrefixes.entries()){
            const [dimension, prefix] = entry;
            if (effectiveDimensions.has(dimension)) tagScheme += `-${prefix}_$${dimension}$`;
        }
        return tagScheme;
    }
    module.exports.generateTagScheme = $c8928b7419a5cc69$var$generateTagScheme;
    function $c8928b7419a5cc69$var$getDimensionsFromTagScheme(tagSchema) {
        const dimensionsFormat = /\$([A-Za-z]+)\$/g;
        const tagSchemeFormat = /^v\d{3}(?:-[a-z]_(\$[A-Za-z]+\$))+$/;
        const isValidTag = tagSchemeFormat.test(tagSchema);
        if (!isValidTag) throw new Error(`The provided tag scheme: "${tagSchema}" is invalid.
                Tag schemes must have the following format:
                v<3 digit number>-<letter>$<dimension_name>$
                where -<letter>$<dimension_name>$ can be repeated
                and all characters of <letter> and <dimension_name>
                must be alphabetical characters
                e.g "v001-n_$name$-d_$dimension$" is a valid tag scheme`);
        const allDim = Array.from(tagSchema.matchAll(dimensionsFormat));
        try {
            const captures = allDim.map(([_, capture])=>capture);
            const dimensions = new Set(captures);
            return dimensions;
        } catch (e) {
            throw new Error(`Could not capture dimensions. Expected dimension format to look like 
             ${dimensionsFormat}`);
        }
    }
    module.exports.getDimensionsFromTagScheme = $c8928b7419a5cc69$var$getDimensionsFromTagScheme;
    function $c8928b7419a5cc69$var$getDataTagForManifest(artifactName, manifestVersion, artifactVersion) {
        return artifactVersion === undefined ? `${artifactName}_manifest_${manifestVersion}` : `${artifactName}_${artifactVersion}_manifest_${manifestVersion}`;
    }
    module.exports.getDataTagForManifest = $c8928b7419a5cc69$var$getDataTagForManifest;
    function $c8928b7419a5cc69$var$getVersionMetadataTag(version) {
        return version ? `version_metadata_${version}` : "version_metadata";
    }
    module.exports.getVersionMetadataTag = $c8928b7419a5cc69$var$getVersionMetadataTag;
    function $c8928b7419a5cc69$var$toPrettyJson(obj) {
        return JSON.stringify(obj, null, 2);
    }
});
parcelRegister("9te7V", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.getDimensionContext = void 0;
    function $6e51c7c28a67d567$var$getDimensionContext(specifiedDimensions, manifest) {
        var dimensionToValues = {};
        for(var dimension in manifest.dimensions){
            var manifestDimensionSpecs = manifest.dimensions[dimension];
            var dimensionValue = specifiedDimensions[dimension];
            var fallback = manifestDimensionSpecs.fallback;
            if (dimensionValue === undefined) {
                if (fallback === undefined) return {
                    type: "missing-dimension-specification"
                };
                else dimensionValue = fallback;
            }
            if (!manifestDimensionSpecs.supported.includes(dimensionValue)) {
                if (fallback === undefined) return {
                    type: "unsupported-value-specified-for-supported-dimension"
                };
                else dimensionValue = fallback;
            }
            dimensionToValues[dimension] = dimensionValue;
        }
        return {
            type: "success",
            dimensionContext: dimensionToValues
        };
    }
    module.exports.getDimensionContext = $6e51c7c28a67d567$var$getDimensionContext;
});
parcelRegister("9P145", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.assertUnreachable = void 0;
    function $7269b3f523ad10e5$var$assertUnreachable(_x) {
        throw new Error("This function should never be called. This is for yielding compile errors on non-exhaustive case checking.");
    }
    module.exports.assertUnreachable = $7269b3f523ad10e5$var$assertUnreachable;
});
parcelRegister("3evgk", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.toPrettyJson = module.exports.toJson = void 0;
    function $25aaedf68a816fe7$var$toJson(buffer) {
        return JSON.parse(buffer.toString());
    }
    module.exports.toJson = $25aaedf68a816fe7$var$toJson;
    function $25aaedf68a816fe7$var$toPrettyJson(obj) {
        return JSON.stringify(obj, null, 2);
    }
    module.exports.toPrettyJson = $25aaedf68a816fe7$var$toPrettyJson;
});
parcelRegister("8Xjp5", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.parseArtifactManifest = void 0;
    var $4DuZk = parcelRequire("4DuZk");
    function $6852e290d659d0bd$var$parseMetricTags(metricTags) {
        var unparsedMetricTags = (0, $4DuZk.parseUnknownObject)(metricTags);
        var parsedMetricTags = {};
        for(var _i = 0, _a = Object.keys(unparsedMetricTags); _i < _a.length; _i++){
            var key = _a[_i];
            var tag = (0, $4DuZk.parseString)(unparsedMetricTags[key]);
            parsedMetricTags[key] = tag;
        }
        return parsedMetricTags;
    }
    function $6852e290d659d0bd$var$parsePublishMetadata(publishMetadata) {
        var unparsedPublishMetadata = (0, $4DuZk.parseUnknownObject)(publishMetadata);
        var metricTags = "metricTags" in unparsedPublishMetadata ? $6852e290d659d0bd$var$parseMetricTags(unparsedPublishMetadata.metricTags) : undefined;
        return {
            metricTags: metricTags
        };
    }
    function $6852e290d659d0bd$var$parseDimensions(dimensions) {
        var unparsedDimensions = (0, $4DuZk.parseUnknownObject)(dimensions);
        var supported = (0, $4DuZk.parseArray)(unparsedDimensions.supported).map($4DuZk.parseString);
        var fallback = (0, $4DuZk.parseUndefinedOr)($4DuZk.parseString, unparsedDimensions.fallback);
        return {
            fallback: fallback,
            supported: supported
        };
    }
    function $6852e290d659d0bd$var$parseDimensionsRecord(dimensionRecord) {
        var parsedDimensionRecord = {};
        var unparsedDimensionRecord = (0, $4DuZk.parseUnknownObject)(dimensionRecord);
        for(var _i = 0, _a = Object.keys(unparsedDimensionRecord); _i < _a.length; _i++){
            var key = _a[_i];
            var dimensionsSpec = $6852e290d659d0bd$var$parseDimensions(unparsedDimensionRecord[key]);
            parsedDimensionRecord[key] = dimensionsSpec;
        }
        return parsedDimensionRecord;
    }
    function $6852e290d659d0bd$var$parseArtifactManifest(potentialArtifactManifest) {
        var unparsedArtifactManifest = (0, $4DuZk.parseUnknownObject)(potentialArtifactManifest);
        var name = (0, $4DuZk.parseString)(unparsedArtifactManifest.name);
        var tagScheme = (0, $4DuZk.parseString)(unparsedArtifactManifest.tagScheme);
        var frontend = (0, $4DuZk.parseUndefinedOr)($4DuZk.parseBoolean, unparsedArtifactManifest.frontend);
        var dimensions = $6852e290d659d0bd$var$parseDimensionsRecord(unparsedArtifactManifest.dimensions);
        var publishMetadata = $6852e290d659d0bd$var$parsePublishMetadata(unparsedArtifactManifest.publishMetadata);
        return {
            name: name,
            frontend: frontend,
            tagScheme: tagScheme,
            dimensions: dimensions,
            publishMetadata: publishMetadata
        };
    }
    module.exports.parseArtifactManifest = $6852e290d659d0bd$var$parseArtifactManifest;
});
parcelRegister("4DuZk", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.parseUndefinedOr = module.exports.parseUnknownObject = module.exports.parseBoolean = module.exports.parseArray = module.exports.parseString = void 0;
    function $3602d78656005db6$var$parseString(string) {
        if (typeof string === "string") return string;
        throw new Error("Couldn't parse String");
    }
    module.exports.parseString = $3602d78656005db6$var$parseString;
    function $3602d78656005db6$var$parseArray(array) {
        if (Array.isArray(array)) return array;
        throw new Error("Couldn't parse List or Undefined");
    }
    module.exports.parseArray = $3602d78656005db6$var$parseArray;
    function $3602d78656005db6$var$parseBoolean(boolean) {
        if (typeof boolean === "boolean") return boolean;
        throw new Error("Couldn't parse Boolean or undefined");
    }
    module.exports.parseBoolean = $3602d78656005db6$var$parseBoolean;
    function $3602d78656005db6$var$parseUnknownObject(object) {
        if (typeof object === "object") return object;
        throw new Error("Couldn't parse object");
    }
    module.exports.parseUnknownObject = $3602d78656005db6$var$parseUnknownObject;
    function $3602d78656005db6$var$parseUndefinedOr(parse, thing) {
        if (typeof thing === "undefined") return thing;
        else return parse(thing);
    }
    module.exports.parseUndefinedOr = $3602d78656005db6$var$parseUndefinedOr;
});
parcelRegister("1NPzc", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.parseVersionMetadata = void 0;
    var $4DuZk = parcelRequire("4DuZk");
    function $15025e265438bcca$var$parseVersionMetadata(possiblyVersionMetadata) {
        var unknownObject = (0, $4DuZk.parseUnknownObject)(possiblyVersionMetadata);
        var version = (0, $4DuZk.parseString)(unknownObject.version);
        var publishTime = new Date((0, $4DuZk.parseString)(unknownObject.publishTime));
        var sidecarImageDigestVersion = (0, $4DuZk.parseString)(unknownObject.sidecarImageDigestVersion);
        return {
            version: version,
            publishTime: publishTime,
            sidecarImageDigestVersion: sidecarImageDigestVersion
        };
    }
    module.exports.parseVersionMetadata = $15025e265438bcca$var$parseVersionMetadata;
});
parcelRegister("5LTws", function(module, exports) {
    "use strict";
    var $433c69239a917447$var$__spreadArray = module.exports && module.exports.__spreadArray || function(to, from, pack) {
        if (pack || arguments.length === 2) {
            for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
                if (!ar) ar = Array.prototype.slice.call(from, 0, i);
                ar[i] = from[i];
            }
        }
        return to.concat(ar || Array.prototype.slice.call(from));
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.checkManifest = void 0;
    function $433c69239a917447$var$checkManifest(manifest, request) {
        if (manifest.name !== request.name) return {
            key: "mismatched-manifest-name"
        };
        var manifestVersionDimension = manifest.dimensions.version;
        if (request.version) {
            var manifestVersions = manifestVersionDimension ? $433c69239a917447$var$__spreadArray([
                manifestVersionDimension === null || manifestVersionDimension === void 0 ? void 0 : manifestVersionDimension.fallback
            ], manifestVersionDimension === null || manifestVersionDimension === void 0 ? void 0 : manifestVersionDimension.supported, true).filter(function(s) {
                return !!s;
            }) : [];
            var allVersionsMatch = manifestVersions.every(function(v) {
                return v === request.version;
            });
            if (!allVersionsMatch || manifestVersions.length === 0) return {
                key: "mismatched-manifest-version"
            };
        }
        return {
            key: "success"
        };
    }
    module.exports.checkManifest = $433c69239a917447$var$checkManifest;
});
parcelRegister("6FHvZ", function(module, exports) {
    "use strict";
    var $4db8538ddb439aee$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
        function adopt(value) {
            return value instanceof P ? value : new P(function(resolve) {
                resolve(value);
            });
        }
        return new (P || (P = Promise))(function(resolve, reject) {
            function fulfilled(value) {
                try {
                    step(generator.next(value));
                } catch (e) {
                    reject(e);
                }
            }
            function rejected(value) {
                try {
                    step(generator["throw"](value));
                } catch (e) {
                    reject(e);
                }
            }
            function step(result) {
                result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
            }
            step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
    };
    var $4db8538ddb439aee$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
        var _ = {
            label: 0,
            sent: function() {
                if (t[0] & 1) throw t[1];
                return t[1];
            },
            trys: [],
            ops: []
        }, f, y, t, g;
        return g = {
            next: verb(0),
            "throw": verb(1),
            "return": verb(2)
        }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
            return this;
        }), g;
        function verb(n) {
            return function(v) {
                return step([
                    n,
                    v
                ]);
            };
        }
        function step(op) {
            if (f) throw new TypeError("Generator is already executing.");
            while(g && (g = 0, op[0] && (_ = 0)), _)try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                if (y = 0, t) op = [
                    op[0] & 2,
                    t.value
                ];
                switch(op[0]){
                    case 0:
                    case 1:
                        t = op;
                        break;
                    case 4:
                        _.label++;
                        return {
                            value: op[1],
                            done: false
                        };
                    case 5:
                        _.label++;
                        y = op[1];
                        op = [
                            0
                        ];
                        continue;
                    case 7:
                        op = _.ops.pop();
                        _.trys.pop();
                        continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                            _ = 0;
                            continue;
                        }
                        if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                            _.label = op[1];
                            break;
                        }
                        if (op[0] === 6 && _.label < t[1]) {
                            _.label = t[1];
                            t = op;
                            break;
                        }
                        if (t && _.label < t[2]) {
                            _.label = t[2];
                            _.ops.push(op);
                            break;
                        }
                        if (t[2]) _.ops.pop();
                        _.trys.pop();
                        continue;
                }
                op = body.call(thisArg, _);
            } catch (e) {
                op = [
                    6,
                    e
                ];
                y = 0;
            } finally{
                f = t = 0;
            }
            if (op[0] & 5) throw op[1];
            return {
                value: op[0] ? op[1] : void 0,
                done: true
            };
        }
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.ConfigRegistryDataSource = void 0;
    var $hdDPm = parcelRequire("hdDPm");
    var $auuB0 = parcelRequire("auuB0");
    var $8Xjp5 = parcelRequire("8Xjp5");
    var $1NPzc = parcelRequire("1NPzc");
    var $4db8538ddb439aee$var$ConfigRegistryDataSource = function() {
        function ConfigRegistryDataSource(manifestVersion, configRegistryHttpClient) {
            this.manifestVersion = manifestVersion;
            this.configRegistryHttpClient = configRegistryHttpClient;
        }
        ConfigRegistryDataSource.prototype.getManifest = function(artifactName, artifactVersion) {
            return $4db8538ddb439aee$var$__awaiter(this, void 0, void 0, function() {
                var tag, configRegistryResponse, e_1;
                return $4db8538ddb439aee$var$__generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            tag = (0, $hdDPm.getDataTagForManifest)(artifactName, this.manifestVersion, artifactVersion);
                            _a.label = 1;
                        case 1:
                            _a.trys.push([
                                1,
                                3,
                                ,
                                4
                            ]);
                            return [
                                4,
                                this.configRegistryHttpClient.getBlob(tag)
                            ];
                        case 2:
                            configRegistryResponse = _a.sent();
                            return [
                                2,
                                configRegistryResponse.leftMap(function(e) {
                                    return e;
                                }).map($8Xjp5.parseArtifactManifest)
                            ];
                        case 3:
                            e_1 = _a.sent();
                            return [
                                2,
                                $auuB0.Either.left({
                                    key: "config-registry-error",
                                    error: e_1
                                })
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            });
        };
        ConfigRegistryDataSource.prototype.getArtifact = function(_artifactName, tag) {
            return $4db8538ddb439aee$var$__awaiter(this, void 0, void 0, function() {
                return $4db8538ddb439aee$var$__generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            return [
                                4,
                                this.configRegistryHttpClient.getBlob(tag)
                            ];
                        case 1:
                            return [
                                2,
                                _a.sent()
                            ];
                    }
                });
            });
        };
        ConfigRegistryDataSource.prototype.getLatestVersionMetadata = function() {
            return $4db8538ddb439aee$var$__awaiter(this, void 0, void 0, function() {
                var dataTag, configRegistryResponse;
                return $4db8538ddb439aee$var$__generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            dataTag = (0, $hdDPm.getVersionMetadataTag)();
                            return [
                                4,
                                this.configRegistryHttpClient.getBlob(dataTag)
                            ];
                        case 1:
                            configRegistryResponse = _a.sent();
                            return [
                                2,
                                configRegistryResponse.bimap(function(error) {
                                    return error;
                                }, function(response) {
                                    return (0, $1NPzc.parseVersionMetadata)(response);
                                })
                            ];
                    }
                });
            });
        };
        return ConfigRegistryDataSource;
    }();
    module.exports.ConfigRegistryDataSource = $4db8538ddb439aee$var$ConfigRegistryDataSource;
});
parcelRegister("3ijEk", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.Versions = module.exports.BaseUrls = void 0;
    var $26624b831163931e$var$BaseUrls = function() {
        function BaseUrls() {}
        BaseUrls.ConfigRegistryProd = "https://config-registry.prod.atl-paas.net";
        return BaseUrls;
    }();
    module.exports.BaseUrls = $26624b831163931e$var$BaseUrls;
    var $26624b831163931e$var$Versions = function() {
        function Versions() {}
        Versions.ManifestVersion = "v1";
        return Versions;
    }();
    module.exports.Versions = $26624b831163931e$var$Versions;
});
parcelRegister("3TdLx", function(module, exports) {
    $parcel$export(module.exports, "BifrostDataSource", ()=>$2d512fbe779401ec$export$2cb8d79200775058);
    var $6l8hg = parcelRequire("6l8hg");
    var $hdDPm = parcelRequire("hdDPm");
    class $2d512fbe779401ec$export$2cb8d79200775058 {
        constructor(bifrostClient, manifestVersion){
            this.bifrostClient = bifrostClient;
            this.manifestVersion = manifestVersion;
        }
        async getLatestVersionMetadata() {
            const tag = (0, $hdDPm.getVersionMetadataTag)();
            const bifrostResponse = await this.bifrostClient.getBlob(`${tag}.json`);
            return bifrostResponse.fold((error)=>{
                return (0, $6l8hg.Either).left(error);
            }, (response)=>{
                try {
                    const parsedVersionMetadata = (0, $6l8hg.parseVersionMetadata)(response);
                    return (0, $6l8hg.Either).right(parsedVersionMetadata);
                } catch (e) {
                    const error = {
                        key: "invalid-version-metadata"
                    };
                    return (0, $6l8hg.Either).left(error);
                }
            });
        }
        async getManifest(artifactName, artifactVersion) {
            const manifestTag = (0, $hdDPm.getDataTagForManifest)(artifactName, this.manifestVersion, artifactVersion);
            const bifrostResponse = await this.bifrostClient.getBlob(`${manifestTag}.json`, artifactName);
            return bifrostResponse.fold((error)=>{
                return (0, $6l8hg.Either).left(error);
            }, (response)=>{
                try {
                    const parsedArtifact = (0, $6l8hg.parseArtifactManifest)(response);
                    return (0, $6l8hg.Either).right(parsedArtifact);
                } catch (e) {
                    const error = {
                        key: "invalid-manifest"
                    };
                    return (0, $6l8hg.Either).left(error);
                }
            });
        }
        async getArtifact(artifactName, tag) {
            return this.bifrostClient.getBlob(`${tag}.json`, artifactName);
        }
    }
});
parcelRegister("3Oidj", function(module, exports) {
    $parcel$export(module.exports, "BifrostHttpClientImpl", ()=>$2c642b791ff52615$export$45c6d12ca9c14f83);
    var $6l8hg = parcelRequire("6l8hg");
    function $2c642b791ff52615$export$f654b28f82155665(env, perimeter) {
        if (perimeter === "commercial") switch(env){
            case "adev":
            case "ddev":
            case "pdev":
            case "stg":
                return "https://fd-config-bifrost.stg-east.frontend.public.atl-paas.net";
            case "prod":
                return "https://fd-config-bifrost.prod-east.frontend.public.atl-paas.net";
        }
        else if (perimeter === "fedramp-moderate") switch(env){
            case "stg":
                return "https://fd-config-bifrost.stg.frontend.cdn.atlassian-us-gov-mod.com";
            case "prod":
                return "https://fd-config-bifrost.frontend.cdn.atlassian-us-gov-mod.com";
        }
        return "https://fd-config-bifrost.prod-east.frontend.public.atl-paas.net";
    }
    class $2c642b791ff52615$export$45c6d12ca9c14f83 {
        constructor(env, perimeter){
            this.baseUrl = $2c642b791ff52615$export$f654b28f82155665(env, perimeter);
        }
        async getBlob(tag) {
            const endpoint = `${this.baseUrl}/assets/${tag}`;
            return new Promise((resolve)=>fetch(endpoint).then((response)=>{
                    if (!response.ok) resolve((0, $6l8hg.Either).left({
                        key: "unexpected-response-code",
                        httpResponseCode: response.status,
                        httpResponseStatusText: response.statusText
                    }));
                    response.json().then((json)=>resolve((0, $6l8hg.Either).right(json)));
                }).catch((error)=>resolve((0, $6l8hg.Either).left({
                        key: "failed-fetch",
                        error: "message" in error ? error.message : "unknown error"
                    }))));
        }
    }
});
parcelRegister("d5LIN", function(module, exports) {
    $parcel$export(module.exports, "ConfigClient", ()=>$9880c2778e17f5cd$export$8489e2f039bfcc4c);
    var $eHiP8 = parcelRequire("eHiP8");
    var $6l8hg = parcelRequire("6l8hg");
    var $4gZ5I;
    function $9880c2778e17f5cd$var$ownKeys(e, r) {
        var t = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
            var o = Object.getOwnPropertySymbols(e);
            r && (o = o.filter(function(r) {
                return Object.getOwnPropertyDescriptor(e, r).enumerable;
            })), t.push.apply(t, o);
        }
        return t;
    }
    function $9880c2778e17f5cd$var$_objectSpread(e) {
        for(var r = 1; r < arguments.length; r++){
            var t = null != arguments[r] ? arguments[r] : {};
            r % 2 ? $9880c2778e17f5cd$var$ownKeys(Object(t), !0).forEach(function(r) {
                (0, $eHiP8.default)(e, r, t[r]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9880c2778e17f5cd$var$ownKeys(Object(t)).forEach(function(r) {
                Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
            });
        }
        return e;
    }
    class $9880c2778e17f5cd$export$8489e2f039bfcc4c {
        constructor(dataSource, dataSourceName, fetchArtifactExperience, versionMetadataExperience){
            this.fetchArtifactExperience = fetchArtifactExperience;
            this.versionMetadataExperience = versionMetadataExperience;
            this.dataSource = new (0, (0, parcelRequire("4gZ5I")).ExperienceDataSourceWrapper)(dataSource, this.fetchArtifactExperience, this.versionMetadataExperience);
            this.dataSourceName = dataSourceName;
        }
        async getArtifact(artifactName, dimensions) {
            this.fetchArtifactExperience.addMetadata(dimensions);
            this.fetchArtifactExperience.start();
            const specifiedDimensions = $9880c2778e17f5cd$var$_objectSpread($9880c2778e17f5cd$var$_objectSpread({}, dimensions), {}, {
                name: artifactName
            });
            const artifact = await (0, $6l8hg.getArtifactFromSource)(this.dataSource, specifiedDimensions, "backend").catch((e)=>({
                    type: "artifact-fetch-error",
                    publishMetadata: {},
                    error: {
                        key: "unexpected-error",
                        error: e
                    }
                }));
            if (artifact.type === "success") this.fetchArtifactExperience.success();
            else {
                this.fetchArtifactExperience.addMetadata({
                    errorType: artifact.type,
                    error: "error" in artifact ? artifact.error.key : undefined
                });
                this.fetchArtifactExperience.failure();
            }
            return (0, $6l8hg.tryGetArtifactData)(artifact, this.dataSourceName);
        }
        async getLatestVersionMetadata() {
            this.versionMetadataExperience.start();
            const getVersionMetadataResult = await this.dataSource.getLatestVersionMetadata();
            return getVersionMetadataResult.fold((error)=>{
                this.versionMetadataExperience.addMetadata({
                    error: error.key
                });
                this.versionMetadataExperience.failure();
                throw new Error(`Unable to get latest version metadata from ${this.dataSourceName} due to error: ${error.key}`);
            }, (data)=>{
                this.versionMetadataExperience.success();
                return data;
            });
        }
    }
});
parcelRegister("4gZ5I", function(module, exports) {
    $parcel$export(module.exports, "ExperienceDataSourceWrapper", ()=>$31c80b8146ec82d5$export$1cc944571619e6e8);
    class $31c80b8146ec82d5$export$1cc944571619e6e8 {
        constructor(dataSource, artifactExperience, versionMetadataExperience){
            this.dataSource = dataSource;
            this.artifactExperience = artifactExperience;
            this.versionMetadataExperience = versionMetadataExperience;
        }
        getLatestVersionMetadata() {
            this.versionMetadataExperience.mark("start-fetch-metadata");
            const result = this.dataSource.getLatestVersionMetadata();
            this.versionMetadataExperience.mark("end-fetch-metadata");
            return result;
        }
        async getManifest(artifactName, artifactVersion) {
            this.artifactExperience.mark("start-fetch-artifact");
            const result = await this.dataSource.getManifest(artifactName, artifactVersion);
            result.leftMap((error)=>{
                this.artifactExperience.addMetadata({
                    getManifestError: error
                });
                return error;
            });
            this.artifactExperience.mark("end-fetch-artifact");
            return result;
        }
        async getArtifact(artifactName, tag) {
            this.artifactExperience.mark("start-fetch-manifest");
            const result = await this.dataSource.getArtifact(artifactName, tag);
            result.leftMap((error)=>{
                this.artifactExperience.addMetadata({
                    getArtifactError: error
                });
                return error;
            });
            this.artifactExperience.mark("end-fetch-manifest");
            return result;
        }
    }
});
parcelRegister("95uqQ", function(module, exports) {
    $parcel$export(module.exports, "getFlightDeckFetchExperience", ()=>$69dc2fdcb553c857$export$a3006f8f221c0a3b);
    $parcel$export(module.exports, "getVersionMetadataFetchExperience", ()=>$69dc2fdcb553c857$export$c3ac7702bfd47c1b);
    const $69dc2fdcb553c857$var$SAMPLING_RATE = 10;
    class $69dc2fdcb553c857$var$UFOExperienceWrapper {
        constructor(experience){
            this.experience = experience;
        }
        start(startTime) {
            return this.experience.start(startTime);
        }
        success() {
            return this.experience.success();
        }
        failure() {
            return this.experience.failure();
        }
        addMetadata(data) {
            return this.experience.addMetadata(data);
        }
        mark(mark) {
            return this.experience.mark(mark);
        }
    }
    class $69dc2fdcb553c857$export$5e7536cf7bc56fee {
        start() {
            return Promise.resolve();
        }
        success() {
            return Promise.resolve(null);
        }
        failure() {
            return Promise.resolve(null);
        }
        mark() {
            return;
        }
        addMetadata() {
            return;
        }
    }
    async function $69dc2fdcb553c857$var$flightDeckSDKOperationExperience(id, timings, metadata) {
        try {
            if (Math.random() * 100 > $69dc2fdcb553c857$var$SAMPLING_RATE) return new $69dc2fdcb553c857$export$5e7536cf7bc56fee();
            const { UFOExperience: UFOExperience, ExperienceTypes: ExperienceTypes, ExperiencePerformanceTypes: ExperiencePerformanceTypes } = await (parcelRequire("kmJoD"));
            const ufoExperience = new UFOExperience(id, {
                type: ExperienceTypes.Operation,
                performanceType: ExperiencePerformanceTypes.Custom,
                platform: {
                    component: "flight-deck-client"
                },
                timings: timings
            });
            ufoExperience.addMetadata(metadata);
            return new $69dc2fdcb553c857$var$UFOExperienceWrapper(ufoExperience);
        } catch (_unused) {
            return new $69dc2fdcb553c857$export$5e7536cf7bc56fee();
        }
    }
    const $69dc2fdcb553c857$export$a3006f8f221c0a3b = ()=>$69dc2fdcb553c857$var$flightDeckSDKOperationExperience("fetch", [
            {
                key: "fetch-artifact",
                endMark: "end-fetch-artifact",
                startMark: "start-fetch-artifact"
            },
            {
                key: "fetch-manifest",
                endMark: "end-fetch-manifest",
                startMark: "start-fetch-manifest"
            }
        ], {});
    const $69dc2fdcb553c857$export$c3ac7702bfd47c1b = ()=>$69dc2fdcb553c857$var$flightDeckSDKOperationExperience("fetch-version-metadata", [
            {
                key: "fetch-metadata",
                startMark: "start-fetch-metadata",
                endMark: "end-fetch-metadata"
            }
        ], {});
});
parcelRegister("kmJoD", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("cfDeu").then(()=>parcelRequire('8GXI8'));
});
parcelRegister("kJG1r", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.TargetedConfig = module.exports.parseConfigWithTargeting = void 0;
    var $fiwxX = parcelRequire("fiwxX");
    Object.defineProperty(module.exports, "parseConfigWithTargeting", {
        enumerable: true,
        get: function() {
            return $fiwxX.parseConfigWithTargeting;
        }
    });
    var $hTlW1 = parcelRequire("hTlW1");
    Object.defineProperty(module.exports, "TargetedConfig", {
        enumerable: true,
        get: function() {
            return $hTlW1.TargetedConfig;
        }
    });
});
parcelRegister("fiwxX", function(module, exports) {
    "use strict";
    var $b231c88986716fb9$var$__assign = module.exports && module.exports.__assign || function() {
        $b231c88986716fb9$var$__assign = Object.assign || function(t) {
            for(var s, i = 1, n = arguments.length; i < n; i++){
                s = arguments[i];
                for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }
            return t;
        };
        return $b231c88986716fb9$var$__assign.apply(this, arguments);
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.parseConfigWithTargeting = void 0;
    var $hTlW1 = parcelRequire("hTlW1");
    function $b231c88986716fb9$var$parseConfigWithTargeting(data) {
        if (typeof data === "object") {
            if (Array.isArray(data)) return data.map(function(element) {
                return $b231c88986716fb9$var$parseConfigWithTargeting(element);
            });
            else if (data) {
                var parsedObject_1 = data;
                var keys = Object.keys(parsedObject_1);
                if (keys.length === 1 && parsedObject_1.defaultConfig) return new $hTlW1.TargetedConfig({
                    defaultConfig: $b231c88986716fb9$var$parseConfigWithTargeting(parsedObject_1.defaultConfig)
                });
                else if (keys.length === 2 && parsedObject_1.defaultConfig && parsedObject_1.targeting) {
                    var parseResult = $b231c88986716fb9$var$parseTargeting(parsedObject_1.targeting);
                    if (parseResult.type === "match") return new $hTlW1.TargetedConfig({
                        targeting: parseResult.result,
                        defaultConfig: $b231c88986716fb9$var$parseConfigWithTargeting(parsedObject_1.defaultConfig)
                    });
                }
                return keys.reduce(function(accObject, key) {
                    var _a;
                    return $b231c88986716fb9$var$__assign($b231c88986716fb9$var$__assign({}, accObject), (_a = {}, _a[key] = $b231c88986716fb9$var$parseConfigWithTargeting(parsedObject_1[key]), _a));
                }, {});
            } else return null;
        } else return data;
    }
    module.exports.parseConfigWithTargeting = $b231c88986716fb9$var$parseConfigWithTargeting;
    function $b231c88986716fb9$var$parseTargeting(targeting) {
        if (typeof targeting === "object" && targeting && !Array.isArray(targeting)) {
            var targetingKeyValue = targeting;
            var targetingKeys = Object.keys(targetingKeyValue);
            if (targetingKeys.length == 2 && targetingKeyValue.targets && targetingKeyValue.targetedConfig) return {
                type: "match",
                result: {
                    targets: $b231c88986716fb9$var$parseTargets(targetingKeyValue.targets),
                    targetedConfig: $b231c88986716fb9$var$parseConfigWithTargeting(targetingKeyValue.targetedConfig)
                }
            };
        }
        return {
            type: "no-match"
        };
    }
    function $b231c88986716fb9$var$parseTargets(targets) {
        if (Array.isArray(targets)) return targets.map(function(target) {
            return {
                orgIds: $b231c88986716fb9$var$parseIdentifierList(target.orgIds),
                siteIds: $b231c88986716fb9$var$parseIdentifierList(target.siteIds),
                userIds: $b231c88986716fb9$var$parseIdentifierList(target.userIds)
            };
        });
        else throw new Error("The targets for Flight Deck targeted configuration must come in an array.");
    }
    function $b231c88986716fb9$var$parseIdentifierList(identifierList) {
        if (identifierList === undefined) return undefined;
        if (Array.isArray(identifierList)) return identifierList.map(function(id) {
            if (typeof id === "string") return id;
            else throw new Error("Identifiers for targets must be strings!");
        });
        else throw new Error("Identifier list must be an array!");
    }
});
parcelRegister("hTlW1", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.TargetedConfig = void 0;
    var $d068968b22fc3b5a$var$TargetedConfig = function() {
        function TargetedConfig(targetedConfigDefinition) {
            this.targetedConfigDefinition = targetedConfigDefinition;
        }
        TargetedConfig.prototype.resolve = function(target) {
            var targeting = this.targetedConfigDefinition.targeting;
            if (targeting) {
                var targeted = targeting.targets.some(function(configuredTarget) {
                    var criteria = [];
                    if (configuredTarget.orgIds) criteria.push({
                        allowList: configuredTarget.orgIds,
                        identifier: target.orgId
                    });
                    if (configuredTarget.siteIds) criteria.push({
                        allowList: configuredTarget.siteIds,
                        identifier: target.siteId
                    });
                    if (configuredTarget.userIds) criteria.push({
                        allowList: configuredTarget.userIds,
                        identifier: target.userId
                    });
                    if (criteria.length === 0) return false;
                    else return criteria.every(function(criteria) {
                        return $d068968b22fc3b5a$var$resolveForTargetCriteria(criteria);
                    });
                });
                if (targeted) return {
                    type: "targeted",
                    value: targeting.targetedConfig
                };
            }
            return {
                type: "default",
                value: this.targetedConfigDefinition.defaultConfig
            };
        };
        return TargetedConfig;
    }();
    module.exports.TargetedConfig = $d068968b22fc3b5a$var$TargetedConfig;
    function $d068968b22fc3b5a$var$resolveForTargetCriteria(criteria) {
        return !!criteria.identifier && criteria.allowList.includes(criteria.identifier);
    }
});
parcelRegister("lKWnb", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$fd6b2c7e02ec3fe7$export$2e2bcd8739ae039);
    class $fd6b2c7e02ec3fe7$export$2e2bcd8739ae039 extends Error {
        constructor({ artifact: artifact, dimensions: dimensions, error: error }){
            super(error instanceof Error && error.message ? error.message : "Unknown Flight Deck SDK error");
            this.name = "FlightDeckSDKError";
            this.error = error;
            this.artifact = artifact;
            this.environmentType = dimensions === null || dimensions === void 0 ? void 0 : dimensions.environmentType;
            this.locale = dimensions === null || dimensions === void 0 ? void 0 : dimensions.locale;
        }
    }
    const $fd6b2c7e02ec3fe7$export$1d76d155060824c9 = (e)=>e instanceof $fd6b2c7e02ec3fe7$export$2e2bcd8739ae039;
});
parcelRegister("4r7nA", function(module, exports) {
    $parcel$export(module.exports, "artifactKey", ()=>$33af6871e9658618$export$e3553dc63541d477);
    const $33af6871e9658618$export$e3553dc63541d477 = (artifactName, dimensions)=>{
        return `${artifactName}${dimensions ? "_" + Object.keys(dimensions).sort().map((key)=>dimensions[key]).filter(Boolean).join("_") : ""}`;
    };
});
parcelRegister("814TT", function(module, exports) {
    $parcel$export(module.exports, "flightDeckClientExperience", ()=>$5d6237e1ec8a6bfc$export$1e3a41a51f6457c5);
    $parcel$export(module.exports, "exceptionToMetadata", ()=>$5d6237e1ec8a6bfc$export$f33622abb5224195);
    var $eHiP8 = parcelRequire("eHiP8");
    var $atdLB;
    var $duUGa;
    function $5d6237e1ec8a6bfc$var$ownKeys(e, r) {
        var t = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
            var o = Object.getOwnPropertySymbols(e);
            r && (o = o.filter(function(r) {
                return Object.getOwnPropertyDescriptor(e, r).enumerable;
            })), t.push.apply(t, o);
        }
        return t;
    }
    function $5d6237e1ec8a6bfc$var$_objectSpread(e) {
        for(var r = 1; r < arguments.length; r++){
            var t = null != arguments[r] ? arguments[r] : {};
            r % 2 ? $5d6237e1ec8a6bfc$var$ownKeys(Object(t), !0).forEach(function(r) {
                (0, $eHiP8.default)(e, r, t[r]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $5d6237e1ec8a6bfc$var$ownKeys(Object(t)).forEach(function(r) {
                Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
            });
        }
        return e;
    }
    const $5d6237e1ec8a6bfc$export$6061a1a9a61f2e21 = ()=>new (0, (0, parcelRequire("duUGa")).UFOExperience)("fetch", {
            type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Operation,
            performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).Custom,
            platform: {
                component: "flight-deck-client"
            }
        });
    const $5d6237e1ec8a6bfc$export$1e3a41a51f6457c5 = ()=>new (0, (0, parcelRequire("duUGa")).UFOExperience)("retrieve-artifact", {
            type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Operation,
            performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).Custom,
            platform: {
                component: "flight-deck-client"
            }
        });
    const $5d6237e1ec8a6bfc$export$f33622abb5224195 = (e)=>{
        return e instanceof Error ? $5d6237e1ec8a6bfc$var$_objectSpread($5d6237e1ec8a6bfc$var$_objectSpread({}, e), {}, {
            cause: undefined
        }) : "unknown";
    };
});
parcelRegister("jcYbC", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1e3fbc9fddcea1b7$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    class $1e3fbc9fddcea1b7$export$2e2bcd8739ae039 extends (0, $5uXOq.PureComponent) {
        static{
            this.defaultProps = {
                fallback: null
            };
        }
        async componentDidMount() {
            const { client: client, messageId: messageId } = this.props;
            try {
                const started = await client.start(messageId);
                if (started) this.setState({
                    shouldRenderChildren: true
                });
            } catch (err) {
                console.error(`Unable to start flow message ${messageId}. ${err}`);
            }
        }
        injectStop(children) {
            return (0, $5uXOq.cloneElement)(children, {
                stop: this.stop
            });
        }
        render() {
            const { fallback: fallback, children: children } = this.props;
            const { shouldRenderChildren: shouldRenderChildren } = this.state;
            return shouldRenderChildren ? this.injectStop(children) : fallback;
        }
        constructor(...args){
            super(...args), this.state = {
                shouldRenderChildren: false
            }, this.stop = async ()=>{
                const { client: client, messageId: messageId } = this.props;
                try {
                    await client.stop(messageId);
                } catch (err) {
                    console.error(`Unable to stop flow message ${messageId}. ${err}`);
                }
            };
        }
    }
});
parcelRegister("8Mq6c", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$706129bebcc29179$export$2e2bcd8739ae039);
    var $1gxex;
    var $7CfdH;
    class $706129bebcc29179$export$2e2bcd8739ae039 {
        constructor(configOrCloudId, stargateUrl){
            let config;
            if (typeof configOrCloudId === 'string') config = {
                cloudId: configOrCloudId,
                stargateUrl: stargateUrl,
                isFedRAMPEnvironment: false
            };
            else config = configOrCloudId;
            if (!config.cloudId || !config.stargateUrl) throw new Error('Need a valid CloudId and Stargate url');
            this.cloudId = config.cloudId;
            this.stargateUrl = config.stargateUrl;
            this.orgId = config.orgId;
            this.workspaceId = config.workspaceId;
            this.coordinationOptions = config.coordinationOptions;
        }
        async start(messageId, variationId) {
            if (!(0, (0, parcelRequire("7CfdH")).isMessagingEnabled)()) return false;
            return (0, (0, parcelRequire("1gxex")).startMessage)({
                cloudId: this.cloudId,
                stargateUrl: this.stargateUrl,
                messageId: messageId,
                variationId: variationId,
                orgId: this.orgId,
                workspaceId: this.workspaceId
            }, this.coordinationOptions);
        }
        async stop(messageId) {
            if (!(0, (0, parcelRequire("7CfdH")).isMessagingEnabled)()) return false;
            return (0, (0, parcelRequire("1gxex")).stopMessage)({
                cloudId: this.cloudId,
                stargateUrl: this.stargateUrl,
                messageId: messageId,
                orgId: this.orgId,
                workspaceId: this.workspaceId
            }, this.coordinationOptions);
        }
    }
});
parcelRegister("5i4cN", function(module, exports) {
    $parcel$export(module.exports, "ChatOpenerSubscriber", ()=>$f445f44794d90802$export$6fa95a645837361b);
    var $5uXOq = parcelRequire("5uXOq");
    var $9oBwb;
    var $7Z8dX;
    var $hjiMw;
    var $jSnf2;
    const $f445f44794d90802$var$ignoredEvents = new Set([
        'editor-context-payload',
        'browser-context-payload',
        'agent-changed'
    ]);
    const $f445f44794d90802$var$eventsToSkipAnalytics = new Set([
        'editor-context-payload',
        'agent-changed'
    ]);
    const $f445f44794d90802$export$6fa95a645837361b = ({ onTriggerOpeningChat: onTriggerOpeningChat })=>{
        const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, (0, parcelRequire("jSnf2")).useAnalytics)();
        const [triggerOpen, setTriggerOpen] = (0, $5uXOq.useState)(!!(0, (0, parcelRequire("9oBwb")).getRovoParams)()?.triggerOpen);
        (0, $5uXOq.useEffect)(()=>{
            try {
                if (!triggerOpen) return;
                onTriggerOpeningChat();
                setTriggerOpen(false);
            } catch (error) {}
        }, [
            triggerOpen
        ]);
        (0, (0, parcelRequire("hjiMw")).useSubscribeAll)((payload)=>{
            const { type: type, source: source, openChat: openChat = true } = payload;
            const preventOpen = !openChat || $f445f44794d90802$var$ignoredEvents.has(type);
            if (!$f445f44794d90802$var$eventsToSkipAnalytics.has(type)) sendAnalyticsEvent({
                action: 'eventReceived',
                actionSubject: 'aiMatePubSubEvent',
                source: source,
                attributes: {
                    publisherSource: source,
                    payloadType: type,
                    eventTriggersChatOpen: !preventOpen
                }
            });
            if (preventOpen) return;
            onTriggerOpeningChat();
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7Z8dX")).RovoPostMessagePubsubListener), null));
    };
});
parcelRegister("9oBwb", function(module, exports) {
    $parcel$export(module.exports, "getRovoParams", ()=>$527b3a92d6af9e9e$export$6405071f390601f7);
    $parcel$export(module.exports, "addRovoParamsToUrl", ()=>$527b3a92d6af9e9e$export$ef04687636c850fe);
    $parcel$export(module.exports, "encodeRovoParams", ()=>$527b3a92d6af9e9e$export$eddc20a009406015);
    var $hhCQV;
    const $527b3a92d6af9e9e$export$fda91e425d265029 = (str)=>str.charAt(0).toUpperCase() + str.slice(1);
    const $527b3a92d6af9e9e$export$858653b7ee3cbb17 = (str)=>str.charAt(0).toLowerCase() + str.slice(1);
    const $527b3a92d6af9e9e$var$isValidURL = (url)=>{
        try {
            new URL(url);
            return true;
        } catch (error) {
            return false;
        }
    };
    const $527b3a92d6af9e9e$export$9748efee331ec573 = (param)=>`${0, (0, parcelRequire("hhCQV")).ROVO_PARAM_PREFIX}${$527b3a92d6af9e9e$export$fda91e425d265029(param)}`;
    const $527b3a92d6af9e9e$export$f2888183a34644d4 = (param)=>{
        return $527b3a92d6af9e9e$export$858653b7ee3cbb17(param.replace((0, (0, parcelRequire("hhCQV")).ROVO_PARAM_PREFIX), ''));
    };
    const $527b3a92d6af9e9e$var$processParams = (input, options = {
        filter: []
    })=>{
        const output = {};
        const safeSearchParamsInput = typeof input === 'string' ? $527b3a92d6af9e9e$var$isValidURL(input) ? new URLSearchParams(new URL(input).search) : new URLSearchParams(input) : input;
        const processedInput = new URLSearchParams(safeSearchParamsInput);
        const extracted = new URLSearchParams();
        safeSearchParamsInput.forEach((value, key)=>{
            if (!key.startsWith((0, (0, parcelRequire("hhCQV")).ROVO_PARAM_PREFIX))) return;
            const paramKey = $527b3a92d6af9e9e$export$f2888183a34644d4(key);
            if (options?.filter?.length) {
                if (options.filter.includes(paramKey)) {
                    output[paramKey] = decodeURIComponent(value);
                    extracted.append(key, value);
                }
            } else output[paramKey] = decodeURIComponent(value);
            processedInput.delete(key);
        });
        const combinedQueryString = [
            processedInput,
            extracted
        ].map((params)=>params.toString()).filter((part)=>part.length > 0).join('&');
        return {
            processed: processedInput,
            rovoParams: output,
            combinedQueryString: combinedQueryString
        };
    };
    const $527b3a92d6af9e9e$export$6405071f390601f7 = (url)=>{
        try {
            const search = url ? new URL(url).search : window.location.search;
            const q = new URLSearchParams(search);
            return $527b3a92d6af9e9e$var$processParams(q).rovoParams;
        } catch (error) {
            return {};
        }
    };
    const $527b3a92d6af9e9e$export$4a302fc7d977f7b3 = (params)=>{
        window.history.pushState({}, '', $527b3a92d6af9e9e$export$ef04687636c850fe(window.location.pathname, params));
    };
    const $527b3a92d6af9e9e$export$ef04687636c850fe = (url, params)=>{
        const { processed: processed, rovoParams: rovoParams } = $527b3a92d6af9e9e$var$processParams(url);
        const rovoParamsWithExisting = {
            ...rovoParams,
            ...params
        };
        const baseUrl = url.includes('?') ? url.split('?')[0] : url;
        const baseQuery = Array.from(processed).length ? `?${processed.toString()}&` : '?';
        const updatedRovoParamsString = $527b3a92d6af9e9e$export$eddc20a009406015(rovoParamsWithExisting);
        return `${baseUrl}${baseQuery}${updatedRovoParamsString}`;
    };
    const $527b3a92d6af9e9e$export$eddc20a009406015 = (params, encodeAsObject)=>{
        if (encodeAsObject) return Object.entries(params).reduce((acc, [key, value])=>{
            acc[$527b3a92d6af9e9e$export$9748efee331ec573(key)] = encodeURIComponent(value);
            return acc;
        }, {});
        return Object.entries(params).map(([key, value])=>{
            return `${$527b3a92d6af9e9e$export$9748efee331ec573(key)}=${encodeURIComponent(value)}`;
        }).join('&');
    };
    const $527b3a92d6af9e9e$export$ad5179fba4239081 = (params, fields)=>{
        return Object.entries(params).every(([key, value])=>{
            const field = fields.find((field)=>field === key);
            if (field) return value !== undefined;
            else return value === undefined;
        });
    };
    const $527b3a92d6af9e9e$export$9c55b0deb4e0c7df = ({ resourceRouterQuery: resourceRouterQuery = false } = {})=>{
        const suffix = resourceRouterQuery ? '!=false' : '';
        return (0, (0, parcelRequire("hhCQV")).ROVO_VALID_PARAMS).map((param)=>`${$527b3a92d6af9e9e$export$9748efee331ec573(param)}${suffix}`);
    };
});
parcelRegister("hhCQV", function(module, exports) {
    $parcel$export(module.exports, "ROVO_PARAM_PREFIX", ()=>$782eed6f93424f0d$export$5a550907ffbc9119);
    $parcel$export(module.exports, "ROVO_VALID_PARAMS", ()=>$782eed6f93424f0d$export$3cd6b610e7ede579);
    const $782eed6f93424f0d$export$5a550907ffbc9119 = 'rovoChat';
    const $782eed6f93424f0d$export$3cd6b610e7ede579 = [
        'pathway',
        'agentId',
        'conversationId',
        'prompt',
        'cloudId',
        'triggerOpen'
    ];
});
parcelRegister("jSnf2", function(module, exports) {
    $parcel$export(module.exports, "useAnalytics", ()=>$dfca0822997e10b2$export$e955abb82869dc84);
    var $5uXOq = parcelRequire("5uXOq");
    var $1SrMX;
    var $2NMNM;
    var $aFWqW;
    var $4eq41;
    var $VdqAi;
    var $eZRED;
    const $dfca0822997e10b2$var$isTownSquareEvent = ()=>[
            'home.atlassian.com',
            'team.atlassian.com'
        ].some((host)=>window.location?.host.includes(host));
    const $dfca0822997e10b2$var$DEFAULT_TAGS = [
        'atlaskit',
        'aiMate'
    ];
    const $dfca0822997e10b2$export$e955abb82869dc84 = ()=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const { propertiesRef: propertiesRef } = (0, (0, parcelRequire("aFWqW")).useAnalyticsPropertiesContext)();
        const maybeAtlasOperationalTags = (0, $5uXOq.useCallback)((inputPayload)=>{
            const payload = inputPayload instanceof (0, (0, parcelRequire("1SrMX")).default) ? inputPayload.payload : inputPayload;
            if (payload.actionSubject === 'ui' && payload.eventType === 'operational' && $dfca0822997e10b2$var$isTownSquareEvent()) return [
                'townsquare'
            ];
            return [];
        }, []);
        const getDefaultAttributes = (0, $5uXOq.useCallback)(()=>{
            const { agentCreatorType: agentCreatorType, agentId: agentId, agentVisibility: agentVisibility, agentExternalConfigReference: agentExternalConfigReference, agentIsDefault: agentIsDefault, conversationChannelId: conversationChannelId, experienceId: experienceId, fullScreen: fullScreen, product: product } = propertiesRef.current;
            return {
                [(0, (0, parcelRequire("4eq41")).AI_MATE_ATTRIBUTES).agentCreatorType]: agentCreatorType,
                [(0, (0, parcelRequire("4eq41")).AI_MATE_ATTRIBUTES).agentId]: agentId,
                [(0, (0, parcelRequire("4eq41")).AI_MATE_ATTRIBUTES).agentVisibility]: agentVisibility,
                [(0, (0, parcelRequire("4eq41")).AI_MATE_ATTRIBUTES).conversationChannelId]: conversationChannelId,
                [(0, (0, parcelRequire("4eq41")).AI_MATE_ATTRIBUTES).experienceId]: experienceId,
                [(0, (0, parcelRequire("4eq41")).AI_MATE_ATTRIBUTES).fullScreen]: fullScreen,
                [(0, (0, parcelRequire("4eq41")).AI_MATE_ATTRIBUTES).product]: product,
                [(0, (0, parcelRequire("4eq41")).AI_MATE_ATTRIBUTES).singleInstrumentationID]: conversationChannelId,
                [(0, (0, parcelRequire("4eq41")).AI_MATE_ATTRIBUTES).agentExternalConfigReference]: agentExternalConfigReference,
                [(0, (0, parcelRequire("4eq41")).AI_MATE_ATTRIBUTES).agentIsDefault]: agentIsDefault
            };
        }, [
            propertiesRef
        ]);
        const trackAIMAUEvent = (0, $5uXOq.useCallback)((payload)=>{
            const tags = [
                ...$dfca0822997e10b2$var$DEFAULT_TAGS
            ];
            if ($dfca0822997e10b2$var$isTownSquareEvent()) tags.push('townsquare');
            const { source: source, subjectId: subjectId, proactive: proactive, userGenerated: userGenerated, messageId: messageId, messageActions: messageActions, singleInstrumentationID: singleInstrumentationID, timestamp: timestamp, is3PLink: is3PLink } = payload;
            let attributes = {
                ...getDefaultAttributes(),
                isAIFeature: 1,
                proactiveAIGenerated: proactive ? 1 : 0,
                userGeneratedAI: userGenerated ? 1 : 0,
                aiFeatureName: 'aiChat',
                is3PLink: is3PLink
            };
            if (messageId) attributes.messageId = messageId;
            if (messageActions) attributes.messageActions = messageActions;
            if (timestamp) attributes.timestamp = timestamp;
            if (singleInstrumentationID) attributes.singleInstrumentationID = singleInstrumentationID;
            let eventPayload = {
                eventType: 'track',
                tags: tags,
                source: source,
                actionSubjectId: subjectId,
                attributes: attributes
            };
            switch(payload.type){
                case 'initiated':
                    eventPayload = {
                        ...eventPayload,
                        actionSubject: 'aiInteraction',
                        action: 'initiated'
                    };
                    break;
                case 'viewed':
                    eventPayload = {
                        ...eventPayload,
                        actionSubject: 'aiResult',
                        action: 'viewed'
                    };
                    break;
                case 'error':
                    eventPayload = {
                        ...eventPayload,
                        actionSubject: 'aiResult',
                        action: 'error'
                    };
                    break;
                case 'dismissed':
                    eventPayload = {
                        ...eventPayload,
                        actionSubject: 'aiInteraction',
                        action: 'dismissed'
                    };
                    break;
                case 'actioned':
                    eventPayload = {
                        ...eventPayload,
                        actionSubject: 'aiResult',
                        action: 'actioned',
                        attributes: {
                            ...eventPayload.attributes,
                            aiResultAction: payload.actionResult
                        }
                    };
                    break;
                case 'feedback':
                    eventPayload = {
                        ...eventPayload,
                        actionSubject: 'aiFeedback',
                        action: 'submitted',
                        attributes: {
                            ...eventPayload.attributes,
                            aiFeedbackResult: payload.feedbackResult
                        }
                    };
                    break;
            }
            const event = createAnalyticsEvent(eventPayload);
            const aiMateContextAttributes = (0, (0, parcelRequire("eZRED")).getAttributesFromContexts)(event.context);
            event.update({
                attributes: {
                    ...event.payload.attributes,
                    ...aiMateContextAttributes
                }
            }).fire((0, (0, parcelRequire("VdqAi")).ANALYTICS_CHANNEL));
        }, [
            createAnalyticsEvent,
            getDefaultAttributes
        ]);
        const sendAnalyticsEvent = (0, $5uXOq.useCallback)((payload, options)=>{
            const extraTags = options?.removeDefaultTags ? [] : $dfca0822997e10b2$var$DEFAULT_TAGS;
            const allTags = Array.from(new Set([
                ...extraTags,
                ...payload.tags || [],
                ...maybeAtlasOperationalTags(payload)
            ]));
            const defaultAttributes = getDefaultAttributes();
            if (payload instanceof (0, (0, parcelRequire("1SrMX")).default)) {
                const aiMateContextAttributes = (0, (0, parcelRequire("eZRED")).getAttributesFromContexts)(payload.context);
                payload.update({
                    ...payload.payload,
                    tags: allTags,
                    attributes: {
                        ...defaultAttributes,
                        ...payload.payload.attributes,
                        ...aiMateContextAttributes
                    }
                }).fire((0, (0, parcelRequire("VdqAi")).ANALYTICS_CHANNEL));
            } else {
                const event = createAnalyticsEvent({
                    ...payload,
                    tags: allTags,
                    attributes: {
                        ...defaultAttributes,
                        ...payload.attributes
                    }
                });
                const aiMateContextAttributes = (0, (0, parcelRequire("eZRED")).getAttributesFromContexts)(event.context);
                event.update({
                    attributes: {
                        ...event.payload.attributes,
                        ...aiMateContextAttributes
                    }
                }).fire((0, (0, parcelRequire("VdqAi")).ANALYTICS_CHANNEL));
            }
        }, [
            createAnalyticsEvent,
            maybeAtlasOperationalTags,
            getDefaultAttributes
        ]);
        return {
            sendAnalyticsEvent: sendAnalyticsEvent,
            trackAIMAUEvent: trackAIMAUEvent
        };
    };
});
parcelRegister("aFWqW", function(module, exports) {
    $parcel$export(module.exports, "AnalyticsContextWithSourceAndProperties", ()=>$ff5d4fd37d27263a$export$a00cd3c213413389);
    $parcel$export(module.exports, "useAnalyticsPropertiesContext", ()=>$ff5d4fd37d27263a$export$ab8aa3dfd687f012);
    var $5uXOq = parcelRequire("5uXOq");
    var $daJ0i;
    const $ff5d4fd37d27263a$var$initialState = {
        conversationChannelId: '',
        experienceId: '',
        product: '',
        agentId: null,
        agentExternalConfigReference: null,
        agentIsDefault: null,
        fullScreen: false,
        agentCreatorType: '',
        agentVisibility: '',
        singleInstrumentationID: ''
    };
    const $ff5d4fd37d27263a$var$AnalyticsPropertiesContext = (0, $5uXOq.createContext)({
        propertiesRef: {
            current: {
                ...$ff5d4fd37d27263a$var$initialState
            }
        },
        setAnalyticsPropertiesWithoutRerender: ()=>{}
    });
    const $ff5d4fd37d27263a$export$1aefd27d2ed3c1c9 = ({ children: children })=>{
        const propertiesRef = (0, $5uXOq.useRef)({
            ...$ff5d4fd37d27263a$var$initialState
        });
        const setAnalyticsPropertiesWithoutRerender = (0, $5uXOq.useCallback)((properties)=>{
            propertiesRef.current = {
                ...propertiesRef.current,
                ...properties
            };
        }, []);
        const value = (0, $5uXOq.useMemo)(()=>({
                propertiesRef: propertiesRef,
                setAnalyticsPropertiesWithoutRerender: setAnalyticsPropertiesWithoutRerender
            }), [
            setAnalyticsPropertiesWithoutRerender
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($ff5d4fd37d27263a$var$AnalyticsPropertiesContext.Provider, {
            value: value
        }, children);
    };
    const $ff5d4fd37d27263a$export$a00cd3c213413389 = ({ source: source, children: children })=>{
        const data = (0, $5uXOq.useMemo)(()=>({
                source: source
            }), [
            source
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("daJ0i")).default), {
            data: data
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($ff5d4fd37d27263a$export$1aefd27d2ed3c1c9, null, children));
    };
    const $ff5d4fd37d27263a$export$ab8aa3dfd687f012 = ()=>{
        return (0, $5uXOq.useContext)($ff5d4fd37d27263a$var$AnalyticsPropertiesContext);
    };
});
parcelRegister("4eq41", function(module, exports) {
    $parcel$export(module.exports, "AI_MATE_ATTRIBUTES", ()=>$3d29cfe9cceaa0f2$export$8cffc8b2c93affd4);
    const $3d29cfe9cceaa0f2$export$8cffc8b2c93affd4 = {
        agentCreatorType: 'agentCreatorType',
        agentId: 'agentId',
        agentVisibility: 'agentVisibility',
        agentExternalConfigReference: 'agentExternalConfigReference',
        agentIsDefault: 'agentIsDefault',
        conversationChannelId: 'conversationChannelId',
        experienceId: 'experienceId',
        fullScreen: 'fullScreen',
        product: 'product',
        singleInstrumentationID: 'singleInstrumentationID'
    };
});
parcelRegister("VdqAi", function(module, exports) {
    $parcel$export(module.exports, "ANALYTICS_CHANNEL", ()=>$0a756ecf0a3a3690$export$85183a312807388d);
    var $e8KHW = parcelRequire("e8KHW");
    const $0a756ecf0a3a3690$export$85183a312807388d = (0, $e8KHW.FabricChannel).aiMate;
});
parcelRegister("eZRED", function(module, exports) {
    $parcel$export(module.exports, "getAttributesFromContexts", ()=>$177e3d94a217ad2a$export$d97c97ed77ff09e8);
    var $1PVpv = parcelRequire("1PVpv");
    const $177e3d94a217ad2a$var$isSourceAndAttributes = (x)=>{
        if (typeof x !== 'object' || x === null) return false;
        if (!('source' in x) || !('attributes' in x) || typeof x.attributes !== 'object' || x.attributes === null) return false;
        return true;
    };
    const $177e3d94a217ad2a$export$d97c97ed77ff09e8 = (context)=>{
        if (!context || !Array.isArray(context)) return {};
        let aiMateOnly = context.filter((x)=>$177e3d94a217ad2a$var$isSourceAndAttributes(x) && x.source === 'AIMate' || x[0, $1PVpv.AI_MATE_CONTEXT]);
        return aiMateOnly.reduce((acc, x)=>{
            return {
                ...acc,
                ...x[0, $1PVpv.AI_MATE_CONTEXT]?.attributes ?? {},
                ...x.attributes ?? {}
            };
        }, {});
    };
});
parcelRegister("h4rOi", function(module, exports) {
    $parcel$export(module.exports, "useRovoEntitlement", ()=>$15b18b9de1edfe29$export$66d5dd4be64dea43);
    $parcel$export(module.exports, "RovoEntitlementSetter", ()=>$15b18b9de1edfe29$export$d03a05ad8547472c);
    var $5uXOq = parcelRequire("5uXOq");
    var $3sQ5x;
    var $iXqE5;
    const $15b18b9de1edfe29$var$rovoEntitlementStore = (0, (0, parcelRequire("iXqE5")).createStore)({
        initialState: {
            isRovoEnabled: false
        },
        name: 'RovoEntitlementStore',
        actions: {
            setIsRovoEnabled: (isRovoEnabled, reason)=>({ setState: setState })=>{
                    setState({
                        isRovoEnabled: isRovoEnabled,
                        reason: reason
                    });
                }
        }
    });
    const $15b18b9de1edfe29$var$useStateHook = (0, (0, parcelRequire("3sQ5x")).createStateHook)($15b18b9de1edfe29$var$rovoEntitlementStore);
    const $15b18b9de1edfe29$export$66d5dd4be64dea43 = ()=>{
        const result = $15b18b9de1edfe29$var$useStateHook();
        return {
            ...result,
            isRovoEnabled: result.isRovoEnabled
        };
    };
    const $15b18b9de1edfe29$export$8004893135276275 = (0, (0, parcelRequire("3sQ5x")).createActionsHook)($15b18b9de1edfe29$var$rovoEntitlementStore);
    const $15b18b9de1edfe29$export$d03a05ad8547472c = ({ isRovoEnabled: isRovoEnabled })=>{
        const { setIsRovoEnabled: setIsRovoEnabled } = $15b18b9de1edfe29$export$8004893135276275();
        (0, $5uXOq.useMemo)(()=>{
            setIsRovoEnabled(isRovoEnabled);
        }, [
            isRovoEnabled,
            setIsRovoEnabled
        ]);
        return null;
    };
});
parcelRegister("4QAPb", function(module, exports) {
    $parcel$export(module.exports, "ChatContextSubscriber", ()=>$1af6b8e2e84b8435$export$29ff0802eb3bb217);
    var $5uXOq = parcelRequire("5uXOq");
    var $hjiMw;
    var $1YYCC;
    const $1af6b8e2e84b8435$export$29ff0802eb3bb217 = ()=>{
        const { setEditorContext: setEditorContext, setBrowserContext: setBrowserContext } = (0, (0, parcelRequire("1YYCC")).useChatContextStoreActions)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hjiMw")).Subscriber), {
            topic: "ai-mate",
            onEvent: async (payload)=>{
                try {
                    switch(payload.type){
                        case 'editor-context-payload':
                            setEditorContext(payload.data);
                            break;
                        case 'browser-context-payload':
                            setBrowserContext(payload.data);
                            break;
                        default:
                    }
                } catch (error) {}
            }
        });
    };
});
parcelRegister("1YYCC", function(module, exports) {
    $parcel$export(module.exports, "useChatContextStoreActions", ()=>$ae2e3376a10d914c$export$53bf948a400e8426);
    $parcel$export(module.exports, "useChatContextEditorContext", ()=>$ae2e3376a10d914c$export$9465f65715425f1b);
    var $3sQ5x;
    var $iXqE5;
    const $ae2e3376a10d914c$var$store = (0, (0, parcelRequire("iXqE5")).createStore)({
        initialState: {
            editorContext: undefined,
            browserContext: undefined
        },
        actions: {
            getEditorContext: ()=>({ getState: getState })=>getState().editorContext,
            setEditorContext: (editorContext)=>({ setState: setState })=>{
                    setState({
                        editorContext: editorContext
                    });
                },
            getBrowserContext: ()=>({ getState: getState })=>getState().browserContext,
            setBrowserContext: (browserContext)=>({ setState: setState })=>{
                    setState({
                        browserContext: browserContext
                    });
                }
        }
    });
    const $ae2e3376a10d914c$export$53bf948a400e8426 = (0, (0, parcelRequire("3sQ5x")).createActionsHook)($ae2e3376a10d914c$var$store);
    const $ae2e3376a10d914c$export$9465f65715425f1b = (0, (0, parcelRequire("3sQ5x")).createHook)($ae2e3376a10d914c$var$store, {
        selector: (state)=>state.editorContext
    });
});
parcelRegister("hlVrS", function(module, exports) {
    $parcel$export(module.exports, "ConversationAssistantButton", ()=>$00f6bc802b15a660$export$7c328c0993982813);
    $parcel$export(module.exports, "ConversationAssistantButtonNav4", ()=>$00f6bc802b15a660$export$25e85d244cbf7845);
    var $5uXOq = parcelRequire("5uXOq");
    var $jZ4fr;
    var $kbqIt;
    var $koVbs;
    var $gKZoD;
    var $711X2;
    var $hqZzc;
    var $imZsD;
    var $k6T4f;
    var $5Fk4Z;
    var $VSDnB;
    var $jSnf2;
    var $fsNoS;
    var $5KAqU;
    var $9p6hi;
    var $Ee6JC;
    var $cccYj;
    const $00f6bc802b15a660$var$defaultButtonStyles = {
        paddingInline: '8px'
    };
    const $00f6bc802b15a660$var$inactiveButtonStyles = {
        background: "var(--ds-background-neutral, #091E420F)"
    };
    const $00f6bc802b15a660$var$disabledButtonStyles = {
        background: "var(--ds-background-disabled, #091E4208)",
        color: "var(--ds-text-disabled, #091E424F)"
    };
    const $00f6bc802b15a660$export$39aecc95f0365819 = ({ condition: condition, wrapper: wrapper, children: children })=>condition ? wrapper(children) : children;
    const $00f6bc802b15a660$var$getConversationAssistantButton = (Button = (0, (0, parcelRequire("711X2")).PrimaryButton))=>({ testId: testId, isActive: isActive, isDisabled: isDisabled = false, onClick: onClick, tooltipContent: tooltipContent, siteId: siteId, productKey: productKey })=>{
            (0, (0, parcelRequire("gKZoD")).di)((0, (0, parcelRequire("kbqIt")).useCoordination), (0, (0, parcelRequire("9p6hi")).useCoordinationClient));
            const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
            const { start: start } = (0, (0, parcelRequire("5KAqU")).useConversationAssistantSpotlightActions)();
            const [shouldShowMessage, setShouldShowMessage] = (0, $5uXOq.useState)(false);
            const messageId = productKey === 'confluence' ? 'confluence_rovo_chat_agents_spotlight_ga' : productKey === 'jira' ? 'jira_rovo_chat_agents_spotlight_ga' : '';
            const spotlightOnboardingFlagEnabled = (0, (0, parcelRequire("VSDnB")).fg)('rovo_chat_agents_spotlight_onboarding');
            const shouldUseCoordination = spotlightOnboardingFlagEnabled && !!messageId;
            const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, (0, parcelRequire("jSnf2")).useAnalytics)();
            const openRovoChat = (event, analyticsEvent)=>{
                if (!isActive && onClick) onClick(event, analyticsEvent);
            };
            const children = (0, ($parcel$interopDefault($5uXOq))).createElement(Button, {
                onMouseEnter: ()=>{
                    if (shouldShowMessage) {
                        sendAnalyticsEvent({
                            eventType: 'ui',
                            action: 'hovered',
                            actionSubject: 'rovoChatButtonSpotlight'
                        });
                        start();
                    }
                },
                style: {
                    ...$00f6bc802b15a660$var$defaultButtonStyles,
                    ...!isActive && $00f6bc802b15a660$var$inactiveButtonStyles,
                    ...isDisabled && $00f6bc802b15a660$var$disabledButtonStyles
                },
                iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hqZzc")).RovoIcon), {
                    size: "xsmall",
                    label: ""
                }),
                testId: testId,
                isSelected: isActive,
                onClick: onClick,
                isDisabled: isDisabled,
                tooltip: tooltipContent ?? formatMessage((0, (0, parcelRequire("cccYj")).messages).buttonLabel)
            }, formatMessage((0, (0, parcelRequire("cccYj")).messages).buttonLabel));
            return shouldUseCoordination ? (0, ($parcel$interopDefault($5uXOq))).createElement($00f6bc802b15a660$export$de76c194bfb85689, {
                setShouldShowMessage: setShouldShowMessage,
                messageId: messageId,
                siteId: siteId,
                children: children,
                shouldShowMessage: shouldShowMessage,
                openRovoChat: openRovoChat
            }) : children;
        };
    const $00f6bc802b15a660$export$7c328c0993982813 = $00f6bc802b15a660$var$getConversationAssistantButton((0, (0, parcelRequire("711X2")).PrimaryButton));
    const $00f6bc802b15a660$export$25e85d244cbf7845 = $00f6bc802b15a660$var$getConversationAssistantButton(function Nav4Button(props) {
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("Ee6JC")).Button), {
            ...props,
            iconBefore: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hqZzc")).RovoIcon), {
                    size: "xsmall",
                    label: ""
                })
        });
    });
    const $00f6bc802b15a660$export$de76c194bfb85689 = ({ children: children, messageId: messageId, siteId: siteId, setShouldShowMessage: setShouldShowMessage, shouldShowMessage: shouldShowMessage, openRovoChat: openRovoChat })=>{
        const { activeSpotlight: activeSpotlight } = (0, (0, parcelRequire("5KAqU")).useConversationAssistantSpotlightState)();
        const coordinationClient = (0, (0, parcelRequire("9p6hi")).useCoordinationClient)(siteId);
        const [onboardingStarted, stopOnboarding] = (0, (0, parcelRequire("kbqIt")).useCoordination)(coordinationClient, messageId);
        const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, (0, parcelRequire("jSnf2")).useAnalytics)();
        const useBlanketTint = (0, (0, parcelRequire("VSDnB")).fg)('rovo_chat_agents_spotlight_use_blanket_tint');
        const onDismissMessage = ()=>{
            setShouldShowMessage(false);
            stopOnboarding();
        };
        (0, $5uXOq.useEffect)(()=>{
            if (shouldShowMessage && activeSpotlight !== null) sendAnalyticsEvent({
                eventType: 'ui',
                action: 'shown',
                actionSubject: 'rovoChatButtonSpotlight'
            });
        }, [
            shouldShowMessage,
            activeSpotlight,
            sendAnalyticsEvent
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (onboardingStarted) setShouldShowMessage(true);
        }, [
            onboardingStarted,
            setShouldShowMessage
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($00f6bc802b15a660$export$39aecc95f0365819, {
            condition: shouldShowMessage,
            wrapper: (children)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("imZsD")).default), {
                    blanketIsTinted: useBlanketTint
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5Fk4Z")).default), {
                    name: (0, $aa59d7827e216af2$export$12496216771c6bdd)
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k6T4f")).Pulse), {
                    radius: 3,
                    pulse: activeSpotlight === null
                }, children, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fsNoS")).ConversationAssistantOnboardingSpotlight), {
                    onDismiss: onDismissMessage,
                    openRovoChat: openRovoChat
                }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jZ4fr")).EngagementSpotlight), {
                    engagementId: (0, $aa59d7827e216af2$export$12496216771c6bdd)
                }))))
        }, children);
    };
});
parcelRegister("jZ4fr", function(module, exports) {
    $parcel$export(module.exports, "EngagementSpotlight", ()=>$bfd4434fdcf1c696$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $1QiBP;
    var $gPtFm;
    var $bPTaj;
    var $f9Hff;
    var $iQWvK;
    const $bfd4434fdcf1c696$var$SpotlightWithVariables = (0, (0, parcelRequire("gPtFm")).default)((0, (0, parcelRequire("iQWvK")).default));
    const $bfd4434fdcf1c696$export$f57123e11f24bec9 = (0, (0, parcelRequire("bPTaj")).default)($bfd4434fdcf1c696$var$SpotlightWithVariables);
    const $bfd4434fdcf1c696$var$SpotlightWithMessage = (0, (0, parcelRequire("f9Hff")).default)($bfd4434fdcf1c696$export$f57123e11f24bec9, 'spotlight');
    function $bfd4434fdcf1c696$export$2e2bcd8739ae039(props) {
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1QiBP")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement($bfd4434fdcf1c696$var$SpotlightWithMessage, props));
    }
});
parcelRegister("gPtFm", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$aefa8c8d82352ccc$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $5yTPS;
    function $aefa8c8d82352ccc$export$2e2bcd8739ae039(TargetComponent) {
        class WithVariables extends (0, $5uXOq.Component) {
            static{
                this.displayName = `${TargetComponent.displayName || TargetComponent.name || ''}WithEPVariables`;
            }
            render() {
                const props = $aefa8c8d82352ccc$var$runMessagePropsReplacement(this.props);
                if (!props) return null;
                return (0, ($parcel$interopDefault($5uXOq))).createElement(TargetComponent, props);
            }
        }
        return WithVariables;
    }
    function $aefa8c8d82352ccc$var$runMessagePropsReplacement(props) {
        const { variables: variables, ...otherProps } = props;
        const { title: title, body: body, primaryText: primaryText, primaryAction: primaryAction, secondaryText: secondaryText, secondaryAction: secondaryAction } = props;
        const inputs = {
            title: title,
            body: body,
            primaryText: primaryText,
            primaryActionUrl: primaryAction && primaryAction.data && primaryAction.data.url,
            secondaryText: secondaryText,
            secondaryActionUrl: secondaryAction && secondaryAction.data && secondaryAction.data.url
        };
        const replacedInputs = (0, (0, parcelRequire("5yTPS")).runTemplateOnInputs)(variables || {}, inputs);
        if (!replacedInputs) return null;
        const outputProps = {
            ...otherProps,
            title: replacedInputs.title,
            body: replacedInputs.body,
            primaryText: replacedInputs.primaryText,
            secondaryText: replacedInputs.secondaryText
        };
        if (primaryAction) outputProps.primaryAction = (0, (0, parcelRequire("5yTPS")).rebuildButtonAction)(replacedInputs.primaryActionUrl, primaryAction);
        if (secondaryAction) outputProps.secondaryAction = (0, (0, parcelRequire("5yTPS")).rebuildButtonAction)(replacedInputs.secondaryActionUrl, secondaryAction);
        return outputProps;
    }
});
parcelRegister("5yTPS", function(module, exports) {
    $parcel$export(module.exports, "rebuildButtonAction", ()=>$622ebbd98b1631f7$export$5d0ec4f796aceeb1);
    $parcel$export(module.exports, "runTemplateOnInputs", ()=>$622ebbd98b1631f7$export$d808999430a3f186);
    var $4KQrx;
    function $622ebbd98b1631f7$export$5d0ec4f796aceeb1(replacedUrl, action) {
        return {
            ...action,
            data: action.data && {
                ...action.data,
                url: replacedUrl
            }
        };
    }
    function $622ebbd98b1631f7$export$d808999430a3f186(variables, messageInputs) {
        const keys = Object.keys(messageInputs);
        const output = {};
        for(let i = 0; i < keys.length; i++){
            const key = keys[i];
            const input = messageInputs[key];
            if (input) {
                const isUrl = key === 'primaryActionUrl' || key === 'secondaryActionUrl';
                const replacedInput = isUrl ? (0, (0, parcelRequire("4KQrx")).runTemplateForUrl)(input, variables) : (0, (0, parcelRequire("4KQrx")).runTemplateForHtml)(input, variables);
                if (replacedInput.type === (0, $c9ec58d20996f864$export$edb46161045fece7)) return null;
                output[key] = replacedInput.result;
            }
        }
        return output;
    }
});
const $c9ec58d20996f864$export$e26f00bd90899835 = 'success';
const $c9ec58d20996f864$export$edb46161045fece7 = 'error';
parcelRegister("4KQrx", function(module, exports) {
    $parcel$export(module.exports, "runTemplateForUrl", ()=>$ac5798f8b467fc46$export$416b2ef51d91ea20);
    $parcel$export(module.exports, "runTemplateForHtml", ()=>$ac5798f8b467fc46$export$5681b97796b74884);
    var $aw4un;
    var $jgdnH;
    var $9OzUk;
    function $ac5798f8b467fc46$export$5d49303889cd00ad(template) {
        const parsedTemplate = (0, (0, parcelRequire("aw4un")).default)(template);
        return (0, (0, parcelRequire("9OzUk")).getRequiredVariablesFromTemplate)(parsedTemplate);
    }
    function $ac5798f8b467fc46$export$416b2ef51d91ea20(template, variables) {
        const epTemplate = (0, (0, parcelRequire("aw4un")).default)(template);
        return (0, (0, parcelRequire("jgdnH")).replaceForUrl)(epTemplate, variables);
    }
    function $ac5798f8b467fc46$export$5681b97796b74884(template, variables) {
        const epTemplate = (0, (0, parcelRequire("aw4un")).default)(template);
        return (0, (0, parcelRequire("jgdnH")).replaceForHtml)(epTemplate, variables);
    }
});
parcelRegister("aw4un", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$66b88773aebc8159$export$2e2bcd8739ae039);
    var $2zjmT;
    const $66b88773aebc8159$var$PARSE_VARIABLES_REGEXP = /({{{(((?!}}}).)+)}}})|({{(((?!}}).)+)}})/g;
    const $66b88773aebc8159$var$UNESCAPED_MATCH = 1;
    const $66b88773aebc8159$var$UNESCAPED_GROUP_CONTENTS = 2;
    const $66b88773aebc8159$var$ESCAPED_GROUP_CONTENTS = 5;
    function $66b88773aebc8159$export$2e2bcd8739ae039(template) {
        const parts = (0, (0, parcelRequire("2zjmT")).regexpParts)(template, $66b88773aebc8159$var$PARSE_VARIABLES_REGEXP);
        return {
            parts: parts.map((regexpPart)=>{
                if (regexpPart.type === 'text') return regexpPart;
                if (regexpPart.match[$66b88773aebc8159$var$UNESCAPED_MATCH]) return {
                    type: 'unescaped',
                    variableName: regexpPart.match[$66b88773aebc8159$var$UNESCAPED_GROUP_CONTENTS] || ''
                };
                return {
                    type: 'escaped',
                    variableName: regexpPart.match[$66b88773aebc8159$var$ESCAPED_GROUP_CONTENTS] || ''
                };
            })
        };
    }
});
parcelRegister("2zjmT", function(module, exports) {
    $parcel$export(module.exports, "regexpParts", ()=>$08d9fc1afbfb58e1$export$b16d411b3b6d6dff);
    function $08d9fc1afbfb58e1$export$b16d411b3b6d6dff(input, regexp) {
        const allMatches = $08d9fc1afbfb58e1$export$1ab25a4faafb1ac3(input, regexp);
        const state = allMatches.reduce((memo, matchResult)=>{
            const leadingIndex = matchResult.index || 0;
            const leading = input.slice(memo.currentPosition, leadingIndex);
            if (leading) memo.result.push({
                type: 'text',
                text: leading
            });
            memo.result.push({
                type: 'match',
                match: matchResult
            });
            return {
                currentPosition: leadingIndex + $08d9fc1afbfb58e1$export$3aff5fb0c83cea11(matchResult),
                result: memo.result
            };
        }, {
            currentPosition: 0,
            result: []
        });
        const trailing = input.slice(state.currentPosition, input.length);
        if (trailing) state.result.push({
            type: 'text',
            text: trailing
        });
        return state.result;
    }
    function $08d9fc1afbfb58e1$export$1ab25a4faafb1ac3(input, regexp) {
        const result = [];
        for(let m = regexp.exec(input); m; m = regexp.exec(input))result.push(m);
        return result;
    }
    function $08d9fc1afbfb58e1$export$3aff5fb0c83cea11(matchResult) {
        return matchResult[0] ? matchResult[0].length : 0;
    }
});
parcelRegister("jgdnH", function(module, exports) {
    $parcel$export(module.exports, "replaceForUrl", ()=>$05830e2163b9771d$export$d10ae881b12b8ef2);
    $parcel$export(module.exports, "replaceForHtml", ()=>$05830e2163b9771d$export$ca536300dbd6350);
    var $9OzUk;
    var $e4chf;
    function $05830e2163b9771d$var$withVariableValidation(template, variables, fn) {
        const requiredKeys = (0, (0, parcelRequire("9OzUk")).getRequiredVariablesFromTemplate)(template);
        const missingKeys = requiredKeys.filter((variableName)=>!variables[variableName]);
        if (missingKeys.length) return {
            type: 'error',
            errorType: 'missing-variables-error',
            missingVariables: missingKeys
        };
        return {
            type: 'success',
            result: fn(template, variables)
        };
    }
    function $05830e2163b9771d$var$rawReplaceVariables(template, variables, escapeFn) {
        return template.parts.map((templatePart)=>{
            if (templatePart.type === 'text') return templatePart.text;
            if (templatePart.type === 'escaped') return escapeFn(variables[templatePart.variableName]);
            return variables[templatePart.variableName];
        }).join('');
    }
    function $05830e2163b9771d$var$rawReplaceVariablesForUrl(template, variables) {
        return $05830e2163b9771d$var$rawReplaceVariables(template, variables, encodeURIComponent);
    }
    function $05830e2163b9771d$var$rawReplaceVariablesForHtml(template, variables) {
        return $05830e2163b9771d$var$rawReplaceVariables(template, variables, (0, (0, parcelRequire("e4chf")).default));
    }
    function $05830e2163b9771d$export$d10ae881b12b8ef2(template, variables) {
        return $05830e2163b9771d$var$withVariableValidation(template, variables, $05830e2163b9771d$var$rawReplaceVariablesForUrl);
    }
    function $05830e2163b9771d$export$ca536300dbd6350(template, variables) {
        return $05830e2163b9771d$var$withVariableValidation(template, variables, $05830e2163b9771d$var$rawReplaceVariablesForHtml);
    }
});
parcelRegister("9OzUk", function(module, exports) {
    $parcel$export(module.exports, "getRequiredVariablesFromTemplate", ()=>$e84b2def1adf6c31$export$4a33186abb06007b);
    var $49Drv;
    function $e84b2def1adf6c31$export$bf97a83dc861479c(template) {
        const variableParts = template.parts.filter((part)=>part.type === 'escaped' || part.type === 'unescaped');
        return variableParts;
    }
    function $e84b2def1adf6c31$export$4a33186abb06007b(template) {
        const variableParts = $e84b2def1adf6c31$export$bf97a83dc861479c(template);
        const variableNames = variableParts.map((part)=>part.variableName);
        return (0, (0, parcelRequire("49Drv")).uniqStrings)(variableNames);
    }
});
parcelRegister("49Drv", function(module, exports) {
    $parcel$export(module.exports, "uniqStrings", ()=>$87c69c0fd6ae5d16$export$c150c7c1a29f33d8);
    function $87c69c0fd6ae5d16$export$c150c7c1a29f33d8(strings) {
        const ourSet = {};
        for(let i = 0; i < strings.length; i++)ourSet[strings[i]] = null;
        return Object.keys(ourSet);
    }
});
parcelRegister("e4chf", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a9ff333996c100ad$export$2e2bcd8739ae039);
    function $a9ff333996c100ad$export$2e2bcd8739ae039(input) {
        return input.replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/'/g, '&#39');
    }
});
parcelRegister("iQWvK", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$80ccf854c3896af1$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $7gs1W;
    var $02CEF;
    var $9pLR7;
    class $80ccf854c3896af1$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
        static{
            this.defaultProps = {
                fireClickEvent: (0, ($parcel$interopDefault($8Rkzz)))
            };
        }
        getButtonClickHandler(buttonType, action) {
            const { fireClickEvent: fireClickEvent } = this.props;
            switch(action.type){
                case (0, (0, parcelRequire("02CEF")).buttonActionTypes).LINK:
                    return ()=>{
                        fireClickEvent(`${buttonType}`);
                        window.open(action.data.url, action.data.target);
                    };
                default:
                    return ()=>{
                        fireClickEvent(`${buttonType}`);
                    };
            }
        }
        getButtonActions() {
            const { primaryAction: primaryAction, primaryText: primaryText, secondaryAction: secondaryAction, secondaryText: secondaryText } = this.props;
            const actions = [];
            if (secondaryAction && secondaryText) actions.push({
                onClick: this.getButtonClickHandler('secondary', secondaryAction),
                text: secondaryText,
                appearance: secondaryAction.appearance
            });
            if (primaryAction && primaryText) actions.push({
                onClick: this.getButtonClickHandler('primary', primaryAction),
                text: primaryText,
                appearance: primaryAction.appearance,
                autoFocus: true
            });
            return actions;
        }
        render() {
            const { body: body, dialogPlacement: dialogPlacement, dialogWidth: dialogWidth, title: title, image: image, pulse: pulse, target: target, targetBgColor: targetBgColor, targetRadius: targetRadius } = this.props;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7gs1W")).default), {
                actions: this.getButtonActions(),
                dialogPlacement: dialogPlacement,
                dialogWidth: dialogWidth,
                heading: title,
                image: image,
                pulse: pulse,
                target: target,
                targetBgColor: targetBgColor,
                targetRadius: targetRadius
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9pLR7")).default), {
                html: body
            }));
        }
    }
});
parcelRegister("kbqIt", function(module, exports) {
    $parcel$export(module.exports, "useCoordination", ()=>$88a44f4ad6e3d72a$export$3c29cca421979b0e);
    var $5uXOq = parcelRequire("5uXOq");
    const $88a44f4ad6e3d72a$export$3c29cca421979b0e = (coordinationClient, messageId)=>{
        const [started, setStarted] = (0, $5uXOq.useState)(false);
        (0, $5uXOq.useEffect)(()=>{
            (async ()=>{
                try {
                    const started = await coordinationClient.start(messageId);
                    if (started) setStarted(true);
                } catch (err) {
                    console.error(`Unable to start flow message ${messageId}. ${err}`);
                }
            })();
        }, [
            coordinationClient,
            messageId
        ]);
        const stop = (0, $5uXOq.useCallback)(async (force)=>{
            if (!force && !started) return;
            try {
                await coordinationClient.stop(messageId);
            } catch (err) {
                console.error(`Unable to stop flow message ${messageId}. ${err}`);
            }
        }, [
            started,
            coordinationClient,
            messageId
        ]);
        return [
            started,
            stop
        ];
    };
});
parcelRegister("fsNoS", function(module, exports) {
    $parcel$export(module.exports, "ConversationAssistantOnboardingSpotlight", ()=>$7622f7ff4a4a9070$export$e4abc8af2fc5e2ac);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $gKZoD;
    var $7gs1W;
    var $VSDnB;
    var $jSnf2;
    var $5KAqU;
    var $idu9A;
    const $7622f7ff4a4a9070$export$e4abc8af2fc5e2ac = ({ openRovoChat: openRovoChat, openAgentSelectorMenu: openAgentSelectorMenu, onDismiss: onDismiss })=>{
        (0, (0, parcelRequire("gKZoD")).di)((0, (0, parcelRequire("5KAqU")).useConversationAssistantSpotlightState));
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { end: end } = (0, (0, parcelRequire("5KAqU")).useConversationAssistantSpotlightActions)();
        const { activeSpotlight: activeSpotlight } = (0, (0, parcelRequire("5KAqU")).useConversationAssistantSpotlightState)();
        const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, (0, parcelRequire("jSnf2")).useAnalytics)();
        const renderActiveSpotlight = ()=>{
            const spotlights = [
                (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7gs1W")).default), {
                    actions: [
                        {
                            onClick: (event, analyticsEvent)=>{
                                if (openRovoChat) openRovoChat(event, analyticsEvent);
                                end();
                                onDismiss();
                                sendAnalyticsEvent({
                                    eventType: 'ui',
                                    action: 'dismissed',
                                    actionSubject: 'rovoChatButtonSpotlight'
                                });
                            },
                            text: formatMessage((0, (0, parcelRequire("idu9A")).default).tryChat)
                        }
                    ],
                    heading: formatMessage((0, (0, parcelRequire("idu9A")).default).onboardingHeading),
                    target: (0, $aa59d7827e216af2$export$12496216771c6bdd),
                    key: (0, $aa59d7827e216af2$export$12496216771c6bdd),
                    targetRadius: 3
                }, formatMessage((0, (0, parcelRequire("idu9A")).default).onboardingDescription))
            ];
            if (!(0, (0, parcelRequire("VSDnB")).fg)('rovo_chat_agents_spotlight_onboarding')) return null;
            if (activeSpotlight === null) return null;
            return spotlights[activeSpotlight];
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Fragment), null, renderActiveSpotlight());
    };
});
parcelRegister("5KAqU", function(module, exports) {
    $parcel$export(module.exports, "useConversationAssistantSpotlightActions", ()=>$c316b97c3ee7919f$export$283f4929c8863814);
    $parcel$export(module.exports, "useConversationAssistantSpotlightState", ()=>$c316b97c3ee7919f$export$258c2a6b93cdef4a);
    var $3sQ5x;
    var $iXqE5;
    const $c316b97c3ee7919f$var$initialState = {
        activeSpotlight: null
    };
    const $c316b97c3ee7919f$var$actions = {
        start: ()=>({ setState: setState })=>{
                setState({
                    activeSpotlight: 0
                });
            },
        next: ()=>({ setState: setState, getState: getState })=>{
                setState({
                    activeSpotlight: (getState().activeSpotlight || 0) + 1
                });
            },
        end: ()=>({ setState: setState })=>{
                setState({
                    activeSpotlight: null
                });
            }
    };
    const $c316b97c3ee7919f$var$ConversationAssistantSpotlightStore = (0, (0, parcelRequire("iXqE5")).createStore)({
        initialState: $c316b97c3ee7919f$var$initialState,
        actions: $c316b97c3ee7919f$var$actions,
        name: 'ConversationAssistantSpotlightStore'
    });
    const $c316b97c3ee7919f$export$283f4929c8863814 = (0, (0, parcelRequire("3sQ5x")).createActionsHook)($c316b97c3ee7919f$var$ConversationAssistantSpotlightStore);
    const $c316b97c3ee7919f$export$258c2a6b93cdef4a = (0, (0, parcelRequire("3sQ5x")).createStateHook)($c316b97c3ee7919f$var$ConversationAssistantSpotlightStore);
});
const $aa59d7827e216af2$export$12496216771c6bdd = 'rovo-chat-button';
parcelRegister("idu9A", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$817b3ce69fd4391b$export$2e2bcd8739ae039);
    var $7VHMR;
    var $817b3ce69fd4391b$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        tryChat: {
            id: 'rovo-onboarding-try-chat',
            defaultMessage: 'Try Chat',
            description: 'Action button for rovo onboarding spotlight'
        },
        onboardingHeading: {
            id: 'rovo-onboarding-heading',
            defaultMessage: 'Harness company knowledge',
            description: 'Onboarding step heading'
        },
        onboardingDescription: {
            id: 'rovo-onboarding-description',
            defaultMessage: 'Rovo Chat is an expert in your company. It knows the people, the projects, and the way things work.',
            description: 'Onboarding step description'
        }
    });
});
parcelRegister("9p6hi", function(module, exports) {
    $parcel$export(module.exports, "useCoordinationClient", ()=>$9751ca993e8ba900$export$ddc368dc94a41e62);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Mq6c;
    const $9751ca993e8ba900$export$ddc368dc94a41e62 = (cloudId, workspaceId, orgId)=>{
        return (0, $5uXOq.useMemo)(()=>new (0, (0, parcelRequire("8Mq6c")).default)({
                cloudId: cloudId,
                stargateUrl: '/gateway/api',
                workspaceId: workspaceId,
                orgId: orgId
            }), [
            cloudId,
            workspaceId,
            orgId
        ]);
    };
});
parcelRegister("cccYj", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$772596c67e72ecec$export$defe85febe8b728c);
    var $7VHMR;
    const $772596c67e72ecec$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        buttonLabel: {
            id: 'conversation-assistant-button.label',
            defaultMessage: 'Chat',
            description: 'Label for the button that opens the conversation assistant'
        }
    });
});
parcelRegister("12QNw", function(module, exports) {
    $parcel$export(module.exports, "BREAK", ()=>$0c2eeee3dc68c900$export$a89c95c098ac2a58);
    $parcel$export(module.exports, "visit", ()=>$0c2eeee3dc68c900$export$bf638b60ea8b89b7);
    $parcel$export(module.exports, "getVisitFn", ()=>$0c2eeee3dc68c900$export$c9c25cca74db6e70);
    $parcel$export(module.exports, "visitInParallel", ()=>$0c2eeee3dc68c900$export$728beebeea393478);
    var $yEDl8;
    var $98oUl;
    var $0c2eeee3dc68c900$export$4fcd777a40ccf407 = {
        Name: [],
        Document: [
            'definitions'
        ],
        OperationDefinition: [
            'name',
            'variableDefinitions',
            'directives',
            'selectionSet'
        ],
        VariableDefinition: [
            'variable',
            'type',
            'defaultValue',
            'directives'
        ],
        Variable: [
            'name'
        ],
        SelectionSet: [
            'selections'
        ],
        Field: [
            'alias',
            'name',
            'arguments',
            'directives',
            'selectionSet'
        ],
        Argument: [
            'name',
            'value'
        ],
        FragmentSpread: [
            'name',
            'directives'
        ],
        InlineFragment: [
            'typeCondition',
            'directives',
            'selectionSet'
        ],
        FragmentDefinition: [
            'name',
            'variableDefinitions',
            'typeCondition',
            'directives',
            'selectionSet'
        ],
        IntValue: [],
        FloatValue: [],
        StringValue: [],
        BooleanValue: [],
        NullValue: [],
        EnumValue: [],
        ListValue: [
            'values'
        ],
        ObjectValue: [
            'fields'
        ],
        ObjectField: [
            'name',
            'value'
        ],
        Directive: [
            'name',
            'arguments'
        ],
        NamedType: [
            'name'
        ],
        ListType: [
            'type'
        ],
        NonNullType: [
            'type'
        ],
        SchemaDefinition: [
            'description',
            'directives',
            'operationTypes'
        ],
        OperationTypeDefinition: [
            'type'
        ],
        ScalarTypeDefinition: [
            'description',
            'name',
            'directives'
        ],
        ObjectTypeDefinition: [
            'description',
            'name',
            'interfaces',
            'directives',
            'fields'
        ],
        FieldDefinition: [
            'description',
            'name',
            'arguments',
            'type',
            'directives'
        ],
        InputValueDefinition: [
            'description',
            'name',
            'type',
            'defaultValue',
            'directives'
        ],
        InterfaceTypeDefinition: [
            'description',
            'name',
            'interfaces',
            'directives',
            'fields'
        ],
        UnionTypeDefinition: [
            'description',
            'name',
            'directives',
            'types'
        ],
        EnumTypeDefinition: [
            'description',
            'name',
            'directives',
            'values'
        ],
        EnumValueDefinition: [
            'description',
            'name',
            'directives'
        ],
        InputObjectTypeDefinition: [
            'description',
            'name',
            'directives',
            'fields'
        ],
        DirectiveDefinition: [
            'description',
            'name',
            'arguments',
            'locations'
        ],
        SchemaExtension: [
            'directives',
            'operationTypes'
        ],
        ScalarTypeExtension: [
            'name',
            'directives'
        ],
        ObjectTypeExtension: [
            'name',
            'interfaces',
            'directives',
            'fields'
        ],
        InterfaceTypeExtension: [
            'name',
            'interfaces',
            'directives',
            'fields'
        ],
        UnionTypeExtension: [
            'name',
            'directives',
            'types'
        ],
        EnumTypeExtension: [
            'name',
            'directives',
            'values'
        ],
        InputObjectTypeExtension: [
            'name',
            'directives',
            'fields'
        ]
    };
    var $0c2eeee3dc68c900$export$a89c95c098ac2a58 = Object.freeze({});
    function $0c2eeee3dc68c900$export$bf638b60ea8b89b7(root, visitor) {
        var visitorKeys = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : $0c2eeee3dc68c900$export$4fcd777a40ccf407;
        var stack = undefined;
        var inArray = Array.isArray(root);
        var keys = [
            root
        ];
        var index = -1;
        var edits = [];
        var node = undefined;
        var key = undefined;
        var parent = undefined;
        var path = [];
        var ancestors = [];
        var newRoot = root;
        do {
            index++;
            var isLeaving = index === keys.length;
            var isEdited = isLeaving && edits.length !== 0;
            if (isLeaving) {
                key = ancestors.length === 0 ? undefined : path[path.length - 1];
                node = parent;
                parent = ancestors.pop();
                if (isEdited) {
                    if (inArray) node = node.slice();
                    else {
                        var clone = {};
                        for(var _i2 = 0, _Object$keys2 = Object.keys(node); _i2 < _Object$keys2.length; _i2++){
                            var k = _Object$keys2[_i2];
                            clone[k] = node[k];
                        }
                        node = clone;
                    }
                    var editOffset = 0;
                    for(var ii = 0; ii < edits.length; ii++){
                        var editKey = edits[ii][0];
                        var editValue = edits[ii][1];
                        if (inArray) editKey -= editOffset;
                        if (inArray && editValue === null) {
                            node.splice(editKey, 1);
                            editOffset++;
                        } else node[editKey] = editValue;
                    }
                }
                index = stack.index;
                keys = stack.keys;
                edits = stack.edits;
                inArray = stack.inArray;
                stack = stack.prev;
            } else {
                key = parent ? inArray ? index : keys[index] : undefined;
                node = parent ? parent[key] : newRoot;
                if (node === null || node === undefined) continue;
                if (parent) path.push(key);
            }
            var result = void 0;
            if (!Array.isArray(node)) {
                if (!(0, (0, parcelRequire("98oUl")).isNode)(node)) throw new Error("Invalid AST Node: ".concat((0, (0, parcelRequire("yEDl8")).default)(node), "."));
                var visitFn = $0c2eeee3dc68c900$export$c9c25cca74db6e70(visitor, node.kind, isLeaving);
                if (visitFn) {
                    result = visitFn.call(visitor, node, key, parent, path, ancestors);
                    if (result === $0c2eeee3dc68c900$export$a89c95c098ac2a58) break;
                    if (result === false) {
                        if (!isLeaving) {
                            path.pop();
                            continue;
                        }
                    } else if (result !== undefined) {
                        edits.push([
                            key,
                            result
                        ]);
                        if (!isLeaving) {
                            if ((0, (0, parcelRequire("98oUl")).isNode)(result)) node = result;
                            else {
                                path.pop();
                                continue;
                            }
                        }
                    }
                }
            }
            if (result === undefined && isEdited) edits.push([
                key,
                node
            ]);
            if (isLeaving) path.pop();
            else {
                var _visitorKeys$node$kin;
                stack = {
                    inArray: inArray,
                    index: index,
                    keys: keys,
                    edits: edits,
                    prev: stack
                };
                inArray = Array.isArray(node);
                keys = inArray ? node : (_visitorKeys$node$kin = visitorKeys[node.kind]) !== null && _visitorKeys$node$kin !== void 0 ? _visitorKeys$node$kin : [];
                index = -1;
                edits = [];
                if (parent) ancestors.push(parent);
                parent = node;
            }
        }while (stack !== undefined)
        if (edits.length !== 0) newRoot = edits[edits.length - 1][1];
        return newRoot;
    }
    function $0c2eeee3dc68c900$export$728beebeea393478(visitors) {
        var skipping = new Array(visitors.length);
        return {
            enter: function enter(node) {
                for(var i = 0; i < visitors.length; i++)if (skipping[i] == null) {
                    var fn = $0c2eeee3dc68c900$export$c9c25cca74db6e70(visitors[i], node.kind, false);
                    if (fn) {
                        var result = fn.apply(visitors[i], arguments);
                        if (result === false) skipping[i] = node;
                        else if (result === $0c2eeee3dc68c900$export$a89c95c098ac2a58) skipping[i] = $0c2eeee3dc68c900$export$a89c95c098ac2a58;
                        else if (result !== undefined) return result;
                    }
                }
            },
            leave: function leave(node) {
                for(var i = 0; i < visitors.length; i++){
                    if (skipping[i] == null) {
                        var fn = $0c2eeee3dc68c900$export$c9c25cca74db6e70(visitors[i], node.kind, true);
                        if (fn) {
                            var result = fn.apply(visitors[i], arguments);
                            if (result === $0c2eeee3dc68c900$export$a89c95c098ac2a58) skipping[i] = $0c2eeee3dc68c900$export$a89c95c098ac2a58;
                            else if (result !== undefined && result !== false) return result;
                        }
                    } else if (skipping[i] === node) skipping[i] = null;
                }
            }
        };
    }
    function $0c2eeee3dc68c900$export$c9c25cca74db6e70(visitor, kind, isLeaving) {
        var kindVisitor = visitor[kind];
        if (kindVisitor) {
            if (!isLeaving && typeof kindVisitor === 'function') return kindVisitor;
            var kindSpecificVisitor = isLeaving ? kindVisitor.leave : kindVisitor.enter;
            if (typeof kindSpecificVisitor === 'function') return kindSpecificVisitor;
        } else {
            var specificVisitor = isLeaving ? visitor.leave : visitor.enter;
            if (specificVisitor) {
                if (typeof specificVisitor === 'function') return specificVisitor;
                var specificKindVisitor = specificVisitor[kind];
                if (typeof specificKindVisitor === 'function') return specificKindVisitor;
            }
        }
    }
});
parcelRegister("yEDl8", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0682b20f61c706c4$export$2e2bcd8739ae039);
    var $7NbHY;
    function $0682b20f61c706c4$var$_typeof(obj) {
        "@babel/helpers - typeof";
        if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $0682b20f61c706c4$var$_typeof = function _typeof(obj) {
            return typeof obj;
        };
        else $0682b20f61c706c4$var$_typeof = function _typeof(obj) {
            return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        };
        return $0682b20f61c706c4$var$_typeof(obj);
    }
    var $0682b20f61c706c4$var$MAX_ARRAY_LENGTH = 10;
    var $0682b20f61c706c4$var$MAX_RECURSIVE_DEPTH = 2;
    function $0682b20f61c706c4$export$2e2bcd8739ae039(value) {
        return $0682b20f61c706c4$var$formatValue(value, []);
    }
    function $0682b20f61c706c4$var$formatValue(value, seenValues) {
        switch($0682b20f61c706c4$var$_typeof(value)){
            case 'string':
                return JSON.stringify(value);
            case 'function':
                return value.name ? "[function ".concat(value.name, "]") : '[function]';
            case 'object':
                if (value === null) return 'null';
                return $0682b20f61c706c4$var$formatObjectValue(value, seenValues);
            default:
                return String(value);
        }
    }
    function $0682b20f61c706c4$var$formatObjectValue(value, previouslySeenValues) {
        if (previouslySeenValues.indexOf(value) !== -1) return '[Circular]';
        var seenValues = [].concat(previouslySeenValues, [
            value
        ]);
        var customInspectFn = $0682b20f61c706c4$var$getCustomFn(value);
        if (customInspectFn !== undefined) {
            var customValue = customInspectFn.call(value);
            if (customValue !== value) return typeof customValue === 'string' ? customValue : $0682b20f61c706c4$var$formatValue(customValue, seenValues);
        } else if (Array.isArray(value)) return $0682b20f61c706c4$var$formatArray(value, seenValues);
        return $0682b20f61c706c4$var$formatObject(value, seenValues);
    }
    function $0682b20f61c706c4$var$formatObject(object, seenValues) {
        var keys = Object.keys(object);
        if (keys.length === 0) return '{}';
        if (seenValues.length > $0682b20f61c706c4$var$MAX_RECURSIVE_DEPTH) return '[' + $0682b20f61c706c4$var$getObjectTag(object) + ']';
        var properties = keys.map(function(key) {
            var value = $0682b20f61c706c4$var$formatValue(object[key], seenValues);
            return key + ': ' + value;
        });
        return '{ ' + properties.join(', ') + ' }';
    }
    function $0682b20f61c706c4$var$formatArray(array, seenValues) {
        if (array.length === 0) return '[]';
        if (seenValues.length > $0682b20f61c706c4$var$MAX_RECURSIVE_DEPTH) return '[Array]';
        var len = Math.min($0682b20f61c706c4$var$MAX_ARRAY_LENGTH, array.length);
        var remaining = array.length - len;
        var items = [];
        for(var i = 0; i < len; ++i)items.push($0682b20f61c706c4$var$formatValue(array[i], seenValues));
        if (remaining === 1) items.push('... 1 more item');
        else if (remaining > 1) items.push("... ".concat(remaining, " more items"));
        return '[' + items.join(', ') + ']';
    }
    function $0682b20f61c706c4$var$getCustomFn(object) {
        var customInspectFn = object[String((0, (0, parcelRequire("7NbHY")).default))];
        if (typeof customInspectFn === 'function') return customInspectFn;
        if (typeof object.inspect === 'function') return object.inspect;
    }
    function $0682b20f61c706c4$var$getObjectTag(object) {
        var tag = Object.prototype.toString.call(object).replace(/^\[object /, '').replace(/]$/, '');
        if (tag === 'Object' && typeof object.constructor === 'function') {
            var name = object.constructor.name;
            if (typeof name === 'string' && name !== '') return name;
        }
        return tag;
    }
});
parcelRegister("7NbHY", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5ac63109fd04dae2$export$2e2bcd8739ae039);
    var $5ac63109fd04dae2$var$nodejsCustomInspectSymbol = typeof Symbol === 'function' && typeof Symbol.for === 'function' ? Symbol.for('nodejs.util.inspect.custom') : undefined;
    var $5ac63109fd04dae2$export$2e2bcd8739ae039 = $5ac63109fd04dae2$var$nodejsCustomInspectSymbol;
});
parcelRegister("98oUl", function(module, exports) {
    $parcel$export(module.exports, "Location", ()=>$6a682e985d2af3c5$export$18a2be9195644f38);
    $parcel$export(module.exports, "Token", ()=>$6a682e985d2af3c5$export$50792b0e93539fde);
    $parcel$export(module.exports, "isNode", ()=>$6a682e985d2af3c5$export$8ee0fc9ee280b4ee);
    var $520Pd;
    var $6a682e985d2af3c5$export$18a2be9195644f38 = function() {
        function Location(startToken, endToken, source) {
            this.start = startToken.start;
            this.end = endToken.end;
            this.startToken = startToken;
            this.endToken = endToken;
            this.source = source;
        }
        var _proto = Location.prototype;
        _proto.toJSON = function toJSON() {
            return {
                start: this.start,
                end: this.end
            };
        };
        return Location;
    }();
    (0, (0, parcelRequire("520Pd")).default)($6a682e985d2af3c5$export$18a2be9195644f38);
    var $6a682e985d2af3c5$export$50792b0e93539fde = function() {
        function Token(kind, start, end, line, column, prev, value) {
            this.kind = kind;
            this.start = start;
            this.end = end;
            this.line = line;
            this.column = column;
            this.value = value;
            this.prev = prev;
            this.next = null;
        }
        var _proto2 = Token.prototype;
        _proto2.toJSON = function toJSON() {
            return {
                kind: this.kind,
                value: this.value,
                line: this.line,
                column: this.column
            };
        };
        return Token;
    }();
    (0, (0, parcelRequire("520Pd")).default)($6a682e985d2af3c5$export$50792b0e93539fde);
    function $6a682e985d2af3c5$export$8ee0fc9ee280b4ee(maybeNode) {
        return maybeNode != null && typeof maybeNode.kind === 'string';
    }
});
parcelRegister("520Pd", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3a9dc77a0e8a6949$export$2e2bcd8739ae039);
    var $fM9AB;
    var $7NbHY;
    function $3a9dc77a0e8a6949$export$2e2bcd8739ae039(classObject) {
        var fn = classObject.prototype.toJSON;
        typeof fn === 'function' || (0, (0, parcelRequire("fM9AB")).default)(0);
        classObject.prototype.inspect = fn;
        if (0, (0, parcelRequire("7NbHY")).default) classObject.prototype[0, (0, parcelRequire("7NbHY")).default] = fn;
    }
});
parcelRegister("fM9AB", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b7c2c6f03066157d$export$2e2bcd8739ae039);
    function $b7c2c6f03066157d$export$2e2bcd8739ae039(condition, message) {
        var booleanCondition = Boolean(condition);
        if (!booleanCondition) throw new Error(message != null ? message : 'Unexpected invariant triggered.');
    }
});
parcelRegister("5cllN", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3c8ea2810a9abcde$export$2e2bcd8739ae039);
    var $3VFsf;
    var $8uUC9;
    var $3c8ea2810a9abcde$var$docCache = new Map();
    var $3c8ea2810a9abcde$var$fragmentSourceMap = new Map();
    var $3c8ea2810a9abcde$var$printFragmentWarnings = true;
    var $3c8ea2810a9abcde$var$experimentalFragmentVariables = false;
    function $3c8ea2810a9abcde$var$normalize(string) {
        return string.replace(/[\s,]+/g, ' ').trim();
    }
    function $3c8ea2810a9abcde$var$cacheKeyFromLoc(loc) {
        return $3c8ea2810a9abcde$var$normalize(loc.source.body.substring(loc.start, loc.end));
    }
    function $3c8ea2810a9abcde$var$processFragments(ast) {
        var seenKeys = new Set();
        var definitions = [];
        ast.definitions.forEach(function(fragmentDefinition) {
            if (fragmentDefinition.kind === 'FragmentDefinition') {
                var fragmentName = fragmentDefinition.name.value;
                var sourceKey = $3c8ea2810a9abcde$var$cacheKeyFromLoc(fragmentDefinition.loc);
                var sourceKeySet = $3c8ea2810a9abcde$var$fragmentSourceMap.get(fragmentName);
                if (sourceKeySet && !sourceKeySet.has(sourceKey)) {
                    if ($3c8ea2810a9abcde$var$printFragmentWarnings) console.warn("Warning: fragment with name " + fragmentName + " already exists.\n" + "graphql-tag enforces all fragment names across your application to be unique; read more about\n" + "this in the docs: http://dev.apollodata.com/core/fragments.html#unique-names");
                } else if (!sourceKeySet) $3c8ea2810a9abcde$var$fragmentSourceMap.set(fragmentName, sourceKeySet = new Set);
                sourceKeySet.add(sourceKey);
                if (!seenKeys.has(sourceKey)) {
                    seenKeys.add(sourceKey);
                    definitions.push(fragmentDefinition);
                }
            } else definitions.push(fragmentDefinition);
        });
        return (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, ast), {
            definitions: definitions
        });
    }
    function $3c8ea2810a9abcde$var$stripLoc(doc) {
        var workSet = new Set(doc.definitions);
        workSet.forEach(function(node) {
            if (node.loc) delete node.loc;
            Object.keys(node).forEach(function(key) {
                var value = node[key];
                if (value && typeof value === 'object') workSet.add(value);
            });
        });
        var loc = doc.loc;
        if (loc) {
            delete loc.startToken;
            delete loc.endToken;
        }
        return doc;
    }
    function $3c8ea2810a9abcde$var$parseDocument(source) {
        var cacheKey = $3c8ea2810a9abcde$var$normalize(source);
        if (!$3c8ea2810a9abcde$var$docCache.has(cacheKey)) {
            var parsed = (0, (0, parcelRequire("8uUC9")).parse)(source, {
                experimentalFragmentVariables: $3c8ea2810a9abcde$var$experimentalFragmentVariables,
                allowLegacyFragmentVariables: $3c8ea2810a9abcde$var$experimentalFragmentVariables
            });
            if (!parsed || parsed.kind !== 'Document') throw new Error('Not a valid GraphQL document.');
            $3c8ea2810a9abcde$var$docCache.set(cacheKey, $3c8ea2810a9abcde$var$stripLoc($3c8ea2810a9abcde$var$processFragments(parsed)));
        }
        return $3c8ea2810a9abcde$var$docCache.get(cacheKey);
    }
    function $3c8ea2810a9abcde$export$72e4926bf8358653(literals) {
        var args = [];
        for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
        if (typeof literals === 'string') literals = [
            literals
        ];
        var result = literals[0];
        args.forEach(function(arg, i) {
            if (arg && arg.kind === 'Document') result += arg.loc.source.body;
            else result += arg;
            result += literals[i + 1];
        });
        return $3c8ea2810a9abcde$var$parseDocument(result);
    }
    function $3c8ea2810a9abcde$export$657554ef4dc7ac2d() {
        $3c8ea2810a9abcde$var$docCache.clear();
        $3c8ea2810a9abcde$var$fragmentSourceMap.clear();
    }
    function $3c8ea2810a9abcde$export$e4294e638636c6ab() {
        $3c8ea2810a9abcde$var$printFragmentWarnings = false;
    }
    function $3c8ea2810a9abcde$export$78cf889af350c840() {
        $3c8ea2810a9abcde$var$experimentalFragmentVariables = true;
    }
    function $3c8ea2810a9abcde$export$5290df9bbbd3cfa() {
        $3c8ea2810a9abcde$var$experimentalFragmentVariables = false;
    }
    var $3c8ea2810a9abcde$var$extras = {
        gql: $3c8ea2810a9abcde$export$72e4926bf8358653,
        resetCaches: $3c8ea2810a9abcde$export$657554ef4dc7ac2d,
        disableFragmentWarnings: $3c8ea2810a9abcde$export$e4294e638636c6ab,
        enableExperimentalFragmentVariables: $3c8ea2810a9abcde$export$78cf889af350c840,
        disableExperimentalFragmentVariables: $3c8ea2810a9abcde$export$5290df9bbbd3cfa
    };
    (function(gql_1) {
        gql_1.gql = $3c8ea2810a9abcde$var$extras.gql, gql_1.resetCaches = $3c8ea2810a9abcde$var$extras.resetCaches, gql_1.disableFragmentWarnings = $3c8ea2810a9abcde$var$extras.disableFragmentWarnings, gql_1.enableExperimentalFragmentVariables = $3c8ea2810a9abcde$var$extras.enableExperimentalFragmentVariables, gql_1.disableExperimentalFragmentVariables = $3c8ea2810a9abcde$var$extras.disableExperimentalFragmentVariables;
    })($3c8ea2810a9abcde$export$72e4926bf8358653 || ($3c8ea2810a9abcde$export$72e4926bf8358653 = {}));
    $3c8ea2810a9abcde$export$72e4926bf8358653["default"] = $3c8ea2810a9abcde$export$72e4926bf8358653;
    var $3c8ea2810a9abcde$export$2e2bcd8739ae039 = $3c8ea2810a9abcde$export$72e4926bf8358653;
});
parcelRegister("8uUC9", function(module, exports) {
    $parcel$export(module.exports, "parse", ()=>$62fd0a8327627af8$export$98e6a39c04603d36);
    $parcel$export(module.exports, "parseValue", ()=>$62fd0a8327627af8$export$5303528d1070ff6f);
    var $7ZXKi;
    var $bzIlO;
    var $98oUl;
    var $2z7TS;
    var $6vk4Q;
    var $jADQJ;
    var $jkcJk;
    function $62fd0a8327627af8$export$98e6a39c04603d36(source, options) {
        var parser = new $62fd0a8327627af8$export$7acfa6ed01010e37(source, options);
        return parser.parseDocument();
    }
    function $62fd0a8327627af8$export$5303528d1070ff6f(source, options) {
        var parser = new $62fd0a8327627af8$export$7acfa6ed01010e37(source, options);
        parser.expectToken((0, (0, parcelRequire("2z7TS")).TokenKind).SOF);
        var value = parser.parseValueLiteral(false);
        parser.expectToken((0, (0, parcelRequire("2z7TS")).TokenKind).EOF);
        return value;
    }
    function $62fd0a8327627af8$export$28b8f402ccc88182(source, options) {
        var parser = new $62fd0a8327627af8$export$7acfa6ed01010e37(source, options);
        parser.expectToken((0, (0, parcelRequire("2z7TS")).TokenKind).SOF);
        var type = parser.parseTypeReference();
        parser.expectToken((0, (0, parcelRequire("2z7TS")).TokenKind).EOF);
        return type;
    }
    var $62fd0a8327627af8$export$7acfa6ed01010e37 = function() {
        function Parser(source, options) {
            var sourceObj = (0, (0, parcelRequire("6vk4Q")).isSource)(source) ? source : new (0, (0, parcelRequire("6vk4Q")).Source)(source);
            this._lexer = new (0, (0, parcelRequire("jkcJk")).Lexer)(sourceObj);
            this._options = options;
        }
        var _proto = Parser.prototype;
        _proto.parseName = function parseName() {
            var token = this.expectToken((0, (0, parcelRequire("2z7TS")).TokenKind).NAME);
            return {
                kind: (0, (0, parcelRequire("bzIlO")).Kind).NAME,
                value: token.value,
                loc: this.loc(token)
            };
        };
        _proto.parseDocument = function parseDocument() {
            var start = this._lexer.token;
            return {
                kind: (0, (0, parcelRequire("bzIlO")).Kind).DOCUMENT,
                definitions: this.many((0, (0, parcelRequire("2z7TS")).TokenKind).SOF, this.parseDefinition, (0, (0, parcelRequire("2z7TS")).TokenKind).EOF),
                loc: this.loc(start)
            };
        };
        _proto.parseDefinition = function parseDefinition() {
            if (this.peek((0, (0, parcelRequire("2z7TS")).TokenKind).NAME)) switch(this._lexer.token.value){
                case 'query':
                case 'mutation':
                case 'subscription':
                    return this.parseOperationDefinition();
                case 'fragment':
                    return this.parseFragmentDefinition();
                case 'schema':
                case 'scalar':
                case 'type':
                case 'interface':
                case 'union':
                case 'enum':
                case 'input':
                case 'directive':
                    return this.parseTypeSystemDefinition();
                case 'extend':
                    return this.parseTypeSystemExtension();
            }
            else if (this.peek((0, (0, parcelRequire("2z7TS")).TokenKind).BRACE_L)) return this.parseOperationDefinition();
            else if (this.peekDescription()) return this.parseTypeSystemDefinition();
            throw this.unexpected();
        };
        _proto.parseOperationDefinition = function parseOperationDefinition() {
            var start = this._lexer.token;
            if (this.peek((0, (0, parcelRequire("2z7TS")).TokenKind).BRACE_L)) return {
                kind: (0, (0, parcelRequire("bzIlO")).Kind).OPERATION_DEFINITION,
                operation: 'query',
                name: undefined,
                variableDefinitions: [],
                directives: [],
                selectionSet: this.parseSelectionSet(),
                loc: this.loc(start)
            };
            var operation = this.parseOperationType();
            var name;
            if (this.peek((0, (0, parcelRequire("2z7TS")).TokenKind).NAME)) name = this.parseName();
            return {
                kind: (0, (0, parcelRequire("bzIlO")).Kind).OPERATION_DEFINITION,
                operation: operation,
                name: name,
                variableDefinitions: this.parseVariableDefinitions(),
                directives: this.parseDirectives(false),
                selectionSet: this.parseSelectionSet(),
                loc: this.loc(start)
            };
        };
        _proto.parseOperationType = function parseOperationType() {
            var operationToken = this.expectToken((0, (0, parcelRequire("2z7TS")).TokenKind).NAME);
            switch(operationToken.value){
                case 'query':
                    return 'query';
                case 'mutation':
                    return 'mutation';
                case 'subscription':
                    return 'subscription';
            }
            throw this.unexpected(operationToken);
        };
        _proto.parseVariableDefinitions = function parseVariableDefinitions() {
            return this.optionalMany((0, (0, parcelRequire("2z7TS")).TokenKind).PAREN_L, this.parseVariableDefinition, (0, (0, parcelRequire("2z7TS")).TokenKind).PAREN_R);
        };
        _proto.parseVariableDefinition = function parseVariableDefinition() {
            var start = this._lexer.token;
            return {
                kind: (0, (0, parcelRequire("bzIlO")).Kind).VARIABLE_DEFINITION,
                variable: this.parseVariable(),
                type: (this.expectToken((0, (0, parcelRequire("2z7TS")).TokenKind).COLON), this.parseTypeReference()),
                defaultValue: this.expectOptionalToken((0, (0, parcelRequire("2z7TS")).TokenKind).EQUALS) ? this.parseValueLiteral(true) : undefined,
                directives: this.parseDirectives(true),
                loc: this.loc(start)
            };
        };
        _proto.parseVariable = function parseVariable() {
            var start = this._lexer.token;
            this.expectToken((0, (0, parcelRequire("2z7TS")).TokenKind).DOLLAR);
            return {
                kind: (0, (0, parcelRequire("bzIlO")).Kind).VARIABLE,
                name: this.parseName(),
                loc: this.loc(start)
            };
        };
        _proto.parseSelectionSet = function parseSelectionSet() {
            var start = this._lexer.token;
            return {
                kind: (0, (0, parcelRequire("bzIlO")).Kind).SELECTION_SET,
                selections: this.many((0, (0, parcelRequire("2z7TS")).TokenKind).BRACE_L, this.parseSelection, (0, (0, parcelRequire("2z7TS")).TokenKind).BRACE_R),
                loc: this.loc(start)
            };
        };
        _proto.parseSelection = function parseSelection() {
            return this.peek((0, (0, parcelRequire("2z7TS")).TokenKind).SPREAD) ? this.parseFragment() : this.parseField();
        };
        _proto.parseField = function parseField() {
            var start = this._lexer.token;
            var nameOrAlias = this.parseName();
            var alias;
            var name;
            if (this.expectOptionalToken((0, (0, parcelRequire("2z7TS")).TokenKind).COLON)) {
                alias = nameOrAlias;
                name = this.parseName();
            } else name = nameOrAlias;
            return {
                kind: (0, (0, parcelRequire("bzIlO")).Kind).FIELD,
                alias: alias,
                name: name,
                arguments: this.parseArguments(false),
                directives: this.parseDirectives(false),
                selectionSet: this.peek((0, (0, parcelRequire("2z7TS")).TokenKind).BRACE_L) ? this.parseSelectionSet() : undefined,
                loc: this.loc(start)
            };
        };
        _proto.parseArguments = function parseArguments(isConst) {
            var item = isConst ? this.parseConstArgument : this.parseArgument;
            return this.optionalMany((0, (0, parcelRequire("2z7TS")).TokenKind).PAREN_L, item, (0, (0, parcelRequire("2z7TS")).TokenKind).PAREN_R);
        };
        _proto.parseArgument = function parseArgument() {
            var start = this._lexer.token;
            var name = this.parseName();
            this.expectToken((0, (0, parcelRequire("2z7TS")).TokenKind).COLON);
            return {
                kind: (0, (0, parcelRequire("bzIlO")).Kind).ARGUMENT,
                name: name,
                value: this.parseValueLiteral(false),
                loc: this.loc(start)
            };
        };
        _proto.parseConstArgument = function parseConstArgument() {
            var start = this._lexer.token;
            return {
                kind: (0, (0, parcelRequire("bzIlO")).Kind).ARGUMENT,
                name: this.parseName(),
                value: (this.expectToken((0, (0, parcelRequire("2z7TS")).TokenKind).COLON), this.parseValueLiteral(true)),
                loc: this.loc(start)
            };
        };
        _proto.parseFragment = function parseFragment() {
            var start = this._lexer.token;
            this.expectToken((0, (0, parcelRequire("2z7TS")).TokenKind).SPREAD);
            var hasTypeCondition = this.expectOptionalKeyword('on');
            if (!hasTypeCondition && this.peek((0, (0, parcelRequire("2z7TS")).TokenKind).NAME)) return {
                kind: (0, (0, parcelRequire("bzIlO")).Kind).FRAGMENT_SPREAD,
                name: this.parseFragmentName(),
                directives: this.parseDirectives(false),
                loc: this.loc(start)
            };
            return {
                kind: (0, (0, parcelRequire("bzIlO")).Kind).INLINE_FRAGMENT,
                typeCondition: hasTypeCondition ? this.parseNamedType() : undefined,
                directives: this.parseDirectives(false),
                selectionSet: this.parseSelectionSet(),
                loc: this.loc(start)
            };
        };
        _proto.parseFragmentDefinition = function parseFragmentDefinition() {
            var _this$_options;
            var start = this._lexer.token;
            this.expectKeyword('fragment');
            if (((_this$_options = this._options) === null || _this$_options === void 0 ? void 0 : _this$_options.experimentalFragmentVariables) === true) return {
                kind: (0, (0, parcelRequire("bzIlO")).Kind).FRAGMENT_DEFINITION,
                name: this.parseFragmentName(),
                variableDefinitions: this.parseVariableDefinitions(),
                typeCondition: (this.expectKeyword('on'), this.parseNamedType()),
                directives: this.parseDirectives(false),
                selectionSet: this.parseSelectionSet(),
                loc: this.loc(start)
            };
            return {
                kind: (0, (0, parcelRequire("bzIlO")).Kind).FRAGMENT_DEFINITION,
                name: this.parseFragmentName(),
                typeCondition: (this.expectKeyword('on'), this.parseNamedType()),
                directives: this.parseDirectives(false),
                selectionSet: this.parseSelectionSet(),
                loc: this.loc(start)
            };
        };
        _proto.parseFragmentName = function parseFragmentName() {
            if (this._lexer.token.value === 'on') throw this.unexpected();
            return this.parseName();
        };
        _proto.parseValueLiteral = function parseValueLiteral(isConst) {
            var token = this._lexer.token;
            switch(token.kind){
                case (0, (0, parcelRequire("2z7TS")).TokenKind).BRACKET_L:
                    return this.parseList(isConst);
                case (0, (0, parcelRequire("2z7TS")).TokenKind).BRACE_L:
                    return this.parseObject(isConst);
                case (0, (0, parcelRequire("2z7TS")).TokenKind).INT:
                    this._lexer.advance();
                    return {
                        kind: (0, (0, parcelRequire("bzIlO")).Kind).INT,
                        value: token.value,
                        loc: this.loc(token)
                    };
                case (0, (0, parcelRequire("2z7TS")).TokenKind).FLOAT:
                    this._lexer.advance();
                    return {
                        kind: (0, (0, parcelRequire("bzIlO")).Kind).FLOAT,
                        value: token.value,
                        loc: this.loc(token)
                    };
                case (0, (0, parcelRequire("2z7TS")).TokenKind).STRING:
                case (0, (0, parcelRequire("2z7TS")).TokenKind).BLOCK_STRING:
                    return this.parseStringLiteral();
                case (0, (0, parcelRequire("2z7TS")).TokenKind).NAME:
                    this._lexer.advance();
                    switch(token.value){
                        case 'true':
                            return {
                                kind: (0, (0, parcelRequire("bzIlO")).Kind).BOOLEAN,
                                value: true,
                                loc: this.loc(token)
                            };
                        case 'false':
                            return {
                                kind: (0, (0, parcelRequire("bzIlO")).Kind).BOOLEAN,
                                value: false,
                                loc: this.loc(token)
                            };
                        case 'null':
                            return {
                                kind: (0, (0, parcelRequire("bzIlO")).Kind).NULL,
                                loc: this.loc(token)
                            };
                        default:
                            return {
                                kind: (0, (0, parcelRequire("bzIlO")).Kind).ENUM,
                                value: token.value,
                                loc: this.loc(token)
                            };
                    }
                case (0, (0, parcelRequire("2z7TS")).TokenKind).DOLLAR:
                    if (!isConst) return this.parseVariable();
                    break;
            }
            throw this.unexpected();
        };
        _proto.parseStringLiteral = function parseStringLiteral() {
            var token = this._lexer.token;
            this._lexer.advance();
            return {
                kind: (0, (0, parcelRequire("bzIlO")).Kind).STRING,
                value: token.value,
                block: token.kind === (0, (0, parcelRequire("2z7TS")).TokenKind).BLOCK_STRING,
                loc: this.loc(token)
            };
        };
        _proto.parseList = function parseList(isConst) {
            var _this = this;
            var start = this._lexer.token;
            var item = function item() {
                return _this.parseValueLiteral(isConst);
            };
            return {
                kind: (0, (0, parcelRequire("bzIlO")).Kind).LIST,
                values: this.any((0, (0, parcelRequire("2z7TS")).TokenKind).BRACKET_L, item, (0, (0, parcelRequire("2z7TS")).TokenKind).BRACKET_R),
                loc: this.loc(start)
            };
        };
        _proto.parseObject = function parseObject(isConst) {
            var _this2 = this;
            var start = this._lexer.token;
            var item = function item() {
                return _this2.parseObjectField(isConst);
            };
            return {
                kind: (0, (0, parcelRequire("bzIlO")).Kind).OBJECT,
                fields: this.any((0, (0, parcelRequire("2z7TS")).TokenKind).BRACE_L, item, (0, (0, parcelRequire("2z7TS")).TokenKind).BRACE_R),
                loc: this.loc(start)
            };
        };
        _proto.parseObjectField = function parseObjectField(isConst) {
            var start = this._lexer.token;
            var name = this.parseName();
            this.expectToken((0, (0, parcelRequire("2z7TS")).TokenKind).COLON);
            return {
                kind: (0, (0, parcelRequire("bzIlO")).Kind).OBJECT_FIELD,
                name: name,
                value: this.parseValueLiteral(isConst),
                loc: this.loc(start)
            };
        };
        _proto.parseDirectives = function parseDirectives(isConst) {
            var directives = [];
            while(this.peek((0, (0, parcelRequire("2z7TS")).TokenKind).AT))directives.push(this.parseDirective(isConst));
            return directives;
        };
        _proto.parseDirective = function parseDirective(isConst) {
            var start = this._lexer.token;
            this.expectToken((0, (0, parcelRequire("2z7TS")).TokenKind).AT);
            return {
                kind: (0, (0, parcelRequire("bzIlO")).Kind).DIRECTIVE,
                name: this.parseName(),
                arguments: this.parseArguments(isConst),
                loc: this.loc(start)
            };
        };
        _proto.parseTypeReference = function parseTypeReference() {
            var start = this._lexer.token;
            var type;
            if (this.expectOptionalToken((0, (0, parcelRequire("2z7TS")).TokenKind).BRACKET_L)) {
                type = this.parseTypeReference();
                this.expectToken((0, (0, parcelRequire("2z7TS")).TokenKind).BRACKET_R);
                type = {
                    kind: (0, (0, parcelRequire("bzIlO")).Kind).LIST_TYPE,
                    type: type,
                    loc: this.loc(start)
                };
            } else type = this.parseNamedType();
            if (this.expectOptionalToken((0, (0, parcelRequire("2z7TS")).TokenKind).BANG)) return {
                kind: (0, (0, parcelRequire("bzIlO")).Kind).NON_NULL_TYPE,
                type: type,
                loc: this.loc(start)
            };
            return type;
        };
        _proto.parseNamedType = function parseNamedType() {
            var start = this._lexer.token;
            return {
                kind: (0, (0, parcelRequire("bzIlO")).Kind).NAMED_TYPE,
                name: this.parseName(),
                loc: this.loc(start)
            };
        };
        _proto.parseTypeSystemDefinition = function parseTypeSystemDefinition() {
            var keywordToken = this.peekDescription() ? this._lexer.lookahead() : this._lexer.token;
            if (keywordToken.kind === (0, (0, parcelRequire("2z7TS")).TokenKind).NAME) switch(keywordToken.value){
                case 'schema':
                    return this.parseSchemaDefinition();
                case 'scalar':
                    return this.parseScalarTypeDefinition();
                case 'type':
                    return this.parseObjectTypeDefinition();
                case 'interface':
                    return this.parseInterfaceTypeDefinition();
                case 'union':
                    return this.parseUnionTypeDefinition();
                case 'enum':
                    return this.parseEnumTypeDefinition();
                case 'input':
                    return this.parseInputObjectTypeDefinition();
                case 'directive':
                    return this.parseDirectiveDefinition();
            }
            throw this.unexpected(keywordToken);
        };
        _proto.peekDescription = function peekDescription() {
            return this.peek((0, (0, parcelRequire("2z7TS")).TokenKind).STRING) || this.peek((0, (0, parcelRequire("2z7TS")).TokenKind).BLOCK_STRING);
        };
        _proto.parseDescription = function parseDescription() {
            if (this.peekDescription()) return this.parseStringLiteral();
        };
        _proto.parseSchemaDefinition = function parseSchemaDefinition() {
            var start = this._lexer.token;
            var description = this.parseDescription();
            this.expectKeyword('schema');
            var directives = this.parseDirectives(true);
            var operationTypes = this.many((0, (0, parcelRequire("2z7TS")).TokenKind).BRACE_L, this.parseOperationTypeDefinition, (0, (0, parcelRequire("2z7TS")).TokenKind).BRACE_R);
            return {
                kind: (0, (0, parcelRequire("bzIlO")).Kind).SCHEMA_DEFINITION,
                description: description,
                directives: directives,
                operationTypes: operationTypes,
                loc: this.loc(start)
            };
        };
        _proto.parseOperationTypeDefinition = function parseOperationTypeDefinition() {
            var start = this._lexer.token;
            var operation = this.parseOperationType();
            this.expectToken((0, (0, parcelRequire("2z7TS")).TokenKind).COLON);
            var type = this.parseNamedType();
            return {
                kind: (0, (0, parcelRequire("bzIlO")).Kind).OPERATION_TYPE_DEFINITION,
                operation: operation,
                type: type,
                loc: this.loc(start)
            };
        };
        _proto.parseScalarTypeDefinition = function parseScalarTypeDefinition() {
            var start = this._lexer.token;
            var description = this.parseDescription();
            this.expectKeyword('scalar');
            var name = this.parseName();
            var directives = this.parseDirectives(true);
            return {
                kind: (0, (0, parcelRequire("bzIlO")).Kind).SCALAR_TYPE_DEFINITION,
                description: description,
                name: name,
                directives: directives,
                loc: this.loc(start)
            };
        };
        _proto.parseObjectTypeDefinition = function parseObjectTypeDefinition() {
            var start = this._lexer.token;
            var description = this.parseDescription();
            this.expectKeyword('type');
            var name = this.parseName();
            var interfaces = this.parseImplementsInterfaces();
            var directives = this.parseDirectives(true);
            var fields = this.parseFieldsDefinition();
            return {
                kind: (0, (0, parcelRequire("bzIlO")).Kind).OBJECT_TYPE_DEFINITION,
                description: description,
                name: name,
                interfaces: interfaces,
                directives: directives,
                fields: fields,
                loc: this.loc(start)
            };
        };
        _proto.parseImplementsInterfaces = function parseImplementsInterfaces() {
            var _this$_options2;
            if (!this.expectOptionalKeyword('implements')) return [];
            if (((_this$_options2 = this._options) === null || _this$_options2 === void 0 ? void 0 : _this$_options2.allowLegacySDLImplementsInterfaces) === true) {
                var types = [];
                this.expectOptionalToken((0, (0, parcelRequire("2z7TS")).TokenKind).AMP);
                do types.push(this.parseNamedType());
                while (this.expectOptionalToken((0, (0, parcelRequire("2z7TS")).TokenKind).AMP) || this.peek((0, (0, parcelRequire("2z7TS")).TokenKind).NAME))
                return types;
            }
            return this.delimitedMany((0, (0, parcelRequire("2z7TS")).TokenKind).AMP, this.parseNamedType);
        };
        _proto.parseFieldsDefinition = function parseFieldsDefinition() {
            var _this$_options3;
            if (((_this$_options3 = this._options) === null || _this$_options3 === void 0 ? void 0 : _this$_options3.allowLegacySDLEmptyFields) === true && this.peek((0, (0, parcelRequire("2z7TS")).TokenKind).BRACE_L) && this._lexer.lookahead().kind === (0, (0, parcelRequire("2z7TS")).TokenKind).BRACE_R) {
                this._lexer.advance();
                this._lexer.advance();
                return [];
            }
            return this.optionalMany((0, (0, parcelRequire("2z7TS")).TokenKind).BRACE_L, this.parseFieldDefinition, (0, (0, parcelRequire("2z7TS")).TokenKind).BRACE_R);
        };
        _proto.parseFieldDefinition = function parseFieldDefinition() {
            var start = this._lexer.token;
            var description = this.parseDescription();
            var name = this.parseName();
            var args = this.parseArgumentDefs();
            this.expectToken((0, (0, parcelRequire("2z7TS")).TokenKind).COLON);
            var type = this.parseTypeReference();
            var directives = this.parseDirectives(true);
            return {
                kind: (0, (0, parcelRequire("bzIlO")).Kind).FIELD_DEFINITION,
                description: description,
                name: name,
                arguments: args,
                type: type,
                directives: directives,
                loc: this.loc(start)
            };
        };
        _proto.parseArgumentDefs = function parseArgumentDefs() {
            return this.optionalMany((0, (0, parcelRequire("2z7TS")).TokenKind).PAREN_L, this.parseInputValueDef, (0, (0, parcelRequire("2z7TS")).TokenKind).PAREN_R);
        };
        _proto.parseInputValueDef = function parseInputValueDef() {
            var start = this._lexer.token;
            var description = this.parseDescription();
            var name = this.parseName();
            this.expectToken((0, (0, parcelRequire("2z7TS")).TokenKind).COLON);
            var type = this.parseTypeReference();
            var defaultValue;
            if (this.expectOptionalToken((0, (0, parcelRequire("2z7TS")).TokenKind).EQUALS)) defaultValue = this.parseValueLiteral(true);
            var directives = this.parseDirectives(true);
            return {
                kind: (0, (0, parcelRequire("bzIlO")).Kind).INPUT_VALUE_DEFINITION,
                description: description,
                name: name,
                type: type,
                defaultValue: defaultValue,
                directives: directives,
                loc: this.loc(start)
            };
        };
        _proto.parseInterfaceTypeDefinition = function parseInterfaceTypeDefinition() {
            var start = this._lexer.token;
            var description = this.parseDescription();
            this.expectKeyword('interface');
            var name = this.parseName();
            var interfaces = this.parseImplementsInterfaces();
            var directives = this.parseDirectives(true);
            var fields = this.parseFieldsDefinition();
            return {
                kind: (0, (0, parcelRequire("bzIlO")).Kind).INTERFACE_TYPE_DEFINITION,
                description: description,
                name: name,
                interfaces: interfaces,
                directives: directives,
                fields: fields,
                loc: this.loc(start)
            };
        };
        _proto.parseUnionTypeDefinition = function parseUnionTypeDefinition() {
            var start = this._lexer.token;
            var description = this.parseDescription();
            this.expectKeyword('union');
            var name = this.parseName();
            var directives = this.parseDirectives(true);
            var types = this.parseUnionMemberTypes();
            return {
                kind: (0, (0, parcelRequire("bzIlO")).Kind).UNION_TYPE_DEFINITION,
                description: description,
                name: name,
                directives: directives,
                types: types,
                loc: this.loc(start)
            };
        };
        _proto.parseUnionMemberTypes = function parseUnionMemberTypes() {
            return this.expectOptionalToken((0, (0, parcelRequire("2z7TS")).TokenKind).EQUALS) ? this.delimitedMany((0, (0, parcelRequire("2z7TS")).TokenKind).PIPE, this.parseNamedType) : [];
        };
        _proto.parseEnumTypeDefinition = function parseEnumTypeDefinition() {
            var start = this._lexer.token;
            var description = this.parseDescription();
            this.expectKeyword('enum');
            var name = this.parseName();
            var directives = this.parseDirectives(true);
            var values = this.parseEnumValuesDefinition();
            return {
                kind: (0, (0, parcelRequire("bzIlO")).Kind).ENUM_TYPE_DEFINITION,
                description: description,
                name: name,
                directives: directives,
                values: values,
                loc: this.loc(start)
            };
        };
        _proto.parseEnumValuesDefinition = function parseEnumValuesDefinition() {
            return this.optionalMany((0, (0, parcelRequire("2z7TS")).TokenKind).BRACE_L, this.parseEnumValueDefinition, (0, (0, parcelRequire("2z7TS")).TokenKind).BRACE_R);
        };
        _proto.parseEnumValueDefinition = function parseEnumValueDefinition() {
            var start = this._lexer.token;
            var description = this.parseDescription();
            var name = this.parseName();
            var directives = this.parseDirectives(true);
            return {
                kind: (0, (0, parcelRequire("bzIlO")).Kind).ENUM_VALUE_DEFINITION,
                description: description,
                name: name,
                directives: directives,
                loc: this.loc(start)
            };
        };
        _proto.parseInputObjectTypeDefinition = function parseInputObjectTypeDefinition() {
            var start = this._lexer.token;
            var description = this.parseDescription();
            this.expectKeyword('input');
            var name = this.parseName();
            var directives = this.parseDirectives(true);
            var fields = this.parseInputFieldsDefinition();
            return {
                kind: (0, (0, parcelRequire("bzIlO")).Kind).INPUT_OBJECT_TYPE_DEFINITION,
                description: description,
                name: name,
                directives: directives,
                fields: fields,
                loc: this.loc(start)
            };
        };
        _proto.parseInputFieldsDefinition = function parseInputFieldsDefinition() {
            return this.optionalMany((0, (0, parcelRequire("2z7TS")).TokenKind).BRACE_L, this.parseInputValueDef, (0, (0, parcelRequire("2z7TS")).TokenKind).BRACE_R);
        };
        _proto.parseTypeSystemExtension = function parseTypeSystemExtension() {
            var keywordToken = this._lexer.lookahead();
            if (keywordToken.kind === (0, (0, parcelRequire("2z7TS")).TokenKind).NAME) switch(keywordToken.value){
                case 'schema':
                    return this.parseSchemaExtension();
                case 'scalar':
                    return this.parseScalarTypeExtension();
                case 'type':
                    return this.parseObjectTypeExtension();
                case 'interface':
                    return this.parseInterfaceTypeExtension();
                case 'union':
                    return this.parseUnionTypeExtension();
                case 'enum':
                    return this.parseEnumTypeExtension();
                case 'input':
                    return this.parseInputObjectTypeExtension();
            }
            throw this.unexpected(keywordToken);
        };
        _proto.parseSchemaExtension = function parseSchemaExtension() {
            var start = this._lexer.token;
            this.expectKeyword('extend');
            this.expectKeyword('schema');
            var directives = this.parseDirectives(true);
            var operationTypes = this.optionalMany((0, (0, parcelRequire("2z7TS")).TokenKind).BRACE_L, this.parseOperationTypeDefinition, (0, (0, parcelRequire("2z7TS")).TokenKind).BRACE_R);
            if (directives.length === 0 && operationTypes.length === 0) throw this.unexpected();
            return {
                kind: (0, (0, parcelRequire("bzIlO")).Kind).SCHEMA_EXTENSION,
                directives: directives,
                operationTypes: operationTypes,
                loc: this.loc(start)
            };
        };
        _proto.parseScalarTypeExtension = function parseScalarTypeExtension() {
            var start = this._lexer.token;
            this.expectKeyword('extend');
            this.expectKeyword('scalar');
            var name = this.parseName();
            var directives = this.parseDirectives(true);
            if (directives.length === 0) throw this.unexpected();
            return {
                kind: (0, (0, parcelRequire("bzIlO")).Kind).SCALAR_TYPE_EXTENSION,
                name: name,
                directives: directives,
                loc: this.loc(start)
            };
        };
        _proto.parseObjectTypeExtension = function parseObjectTypeExtension() {
            var start = this._lexer.token;
            this.expectKeyword('extend');
            this.expectKeyword('type');
            var name = this.parseName();
            var interfaces = this.parseImplementsInterfaces();
            var directives = this.parseDirectives(true);
            var fields = this.parseFieldsDefinition();
            if (interfaces.length === 0 && directives.length === 0 && fields.length === 0) throw this.unexpected();
            return {
                kind: (0, (0, parcelRequire("bzIlO")).Kind).OBJECT_TYPE_EXTENSION,
                name: name,
                interfaces: interfaces,
                directives: directives,
                fields: fields,
                loc: this.loc(start)
            };
        };
        _proto.parseInterfaceTypeExtension = function parseInterfaceTypeExtension() {
            var start = this._lexer.token;
            this.expectKeyword('extend');
            this.expectKeyword('interface');
            var name = this.parseName();
            var interfaces = this.parseImplementsInterfaces();
            var directives = this.parseDirectives(true);
            var fields = this.parseFieldsDefinition();
            if (interfaces.length === 0 && directives.length === 0 && fields.length === 0) throw this.unexpected();
            return {
                kind: (0, (0, parcelRequire("bzIlO")).Kind).INTERFACE_TYPE_EXTENSION,
                name: name,
                interfaces: interfaces,
                directives: directives,
                fields: fields,
                loc: this.loc(start)
            };
        };
        _proto.parseUnionTypeExtension = function parseUnionTypeExtension() {
            var start = this._lexer.token;
            this.expectKeyword('extend');
            this.expectKeyword('union');
            var name = this.parseName();
            var directives = this.parseDirectives(true);
            var types = this.parseUnionMemberTypes();
            if (directives.length === 0 && types.length === 0) throw this.unexpected();
            return {
                kind: (0, (0, parcelRequire("bzIlO")).Kind).UNION_TYPE_EXTENSION,
                name: name,
                directives: directives,
                types: types,
                loc: this.loc(start)
            };
        };
        _proto.parseEnumTypeExtension = function parseEnumTypeExtension() {
            var start = this._lexer.token;
            this.expectKeyword('extend');
            this.expectKeyword('enum');
            var name = this.parseName();
            var directives = this.parseDirectives(true);
            var values = this.parseEnumValuesDefinition();
            if (directives.length === 0 && values.length === 0) throw this.unexpected();
            return {
                kind: (0, (0, parcelRequire("bzIlO")).Kind).ENUM_TYPE_EXTENSION,
                name: name,
                directives: directives,
                values: values,
                loc: this.loc(start)
            };
        };
        _proto.parseInputObjectTypeExtension = function parseInputObjectTypeExtension() {
            var start = this._lexer.token;
            this.expectKeyword('extend');
            this.expectKeyword('input');
            var name = this.parseName();
            var directives = this.parseDirectives(true);
            var fields = this.parseInputFieldsDefinition();
            if (directives.length === 0 && fields.length === 0) throw this.unexpected();
            return {
                kind: (0, (0, parcelRequire("bzIlO")).Kind).INPUT_OBJECT_TYPE_EXTENSION,
                name: name,
                directives: directives,
                fields: fields,
                loc: this.loc(start)
            };
        };
        _proto.parseDirectiveDefinition = function parseDirectiveDefinition() {
            var start = this._lexer.token;
            var description = this.parseDescription();
            this.expectKeyword('directive');
            this.expectToken((0, (0, parcelRequire("2z7TS")).TokenKind).AT);
            var name = this.parseName();
            var args = this.parseArgumentDefs();
            var repeatable = this.expectOptionalKeyword('repeatable');
            this.expectKeyword('on');
            var locations = this.parseDirectiveLocations();
            return {
                kind: (0, (0, parcelRequire("bzIlO")).Kind).DIRECTIVE_DEFINITION,
                description: description,
                name: name,
                arguments: args,
                repeatable: repeatable,
                locations: locations,
                loc: this.loc(start)
            };
        };
        _proto.parseDirectiveLocations = function parseDirectiveLocations() {
            return this.delimitedMany((0, (0, parcelRequire("2z7TS")).TokenKind).PIPE, this.parseDirectiveLocation);
        };
        _proto.parseDirectiveLocation = function parseDirectiveLocation() {
            var start = this._lexer.token;
            var name = this.parseName();
            if ((0, (0, parcelRequire("jADQJ")).DirectiveLocation)[name.value] !== undefined) return name;
            throw this.unexpected(start);
        };
        _proto.loc = function loc(startToken) {
            var _this$_options4;
            if (((_this$_options4 = this._options) === null || _this$_options4 === void 0 ? void 0 : _this$_options4.noLocation) !== true) return new (0, (0, parcelRequire("98oUl")).Location)(startToken, this._lexer.lastToken, this._lexer.source);
        };
        _proto.peek = function peek(kind) {
            return this._lexer.token.kind === kind;
        };
        _proto.expectToken = function expectToken(kind) {
            var token = this._lexer.token;
            if (token.kind === kind) {
                this._lexer.advance();
                return token;
            }
            throw (0, (0, parcelRequire("7ZXKi")).syntaxError)(this._lexer.source, token.start, "Expected ".concat($62fd0a8327627af8$var$getTokenKindDesc(kind), ", found ").concat($62fd0a8327627af8$var$getTokenDesc(token), "."));
        };
        _proto.expectOptionalToken = function expectOptionalToken(kind) {
            var token = this._lexer.token;
            if (token.kind === kind) {
                this._lexer.advance();
                return token;
            }
            return undefined;
        };
        _proto.expectKeyword = function expectKeyword(value) {
            var token = this._lexer.token;
            if (token.kind === (0, (0, parcelRequire("2z7TS")).TokenKind).NAME && token.value === value) this._lexer.advance();
            else throw (0, (0, parcelRequire("7ZXKi")).syntaxError)(this._lexer.source, token.start, "Expected \"".concat(value, "\", found ").concat($62fd0a8327627af8$var$getTokenDesc(token), "."));
        };
        _proto.expectOptionalKeyword = function expectOptionalKeyword(value) {
            var token = this._lexer.token;
            if (token.kind === (0, (0, parcelRequire("2z7TS")).TokenKind).NAME && token.value === value) {
                this._lexer.advance();
                return true;
            }
            return false;
        };
        _proto.unexpected = function unexpected(atToken) {
            var token = atToken !== null && atToken !== void 0 ? atToken : this._lexer.token;
            return (0, (0, parcelRequire("7ZXKi")).syntaxError)(this._lexer.source, token.start, "Unexpected ".concat($62fd0a8327627af8$var$getTokenDesc(token), "."));
        };
        _proto.any = function any(openKind, parseFn, closeKind) {
            this.expectToken(openKind);
            var nodes = [];
            while(!this.expectOptionalToken(closeKind))nodes.push(parseFn.call(this));
            return nodes;
        };
        _proto.optionalMany = function optionalMany(openKind, parseFn, closeKind) {
            if (this.expectOptionalToken(openKind)) {
                var nodes = [];
                do nodes.push(parseFn.call(this));
                while (!this.expectOptionalToken(closeKind))
                return nodes;
            }
            return [];
        };
        _proto.many = function many(openKind, parseFn, closeKind) {
            this.expectToken(openKind);
            var nodes = [];
            do nodes.push(parseFn.call(this));
            while (!this.expectOptionalToken(closeKind))
            return nodes;
        };
        _proto.delimitedMany = function delimitedMany(delimiterKind, parseFn) {
            this.expectOptionalToken(delimiterKind);
            var nodes = [];
            do nodes.push(parseFn.call(this));
            while (this.expectOptionalToken(delimiterKind))
            return nodes;
        };
        return Parser;
    }();
    function $62fd0a8327627af8$var$getTokenDesc(token) {
        var value = token.value;
        return $62fd0a8327627af8$var$getTokenKindDesc(token.kind) + (value != null ? " \"".concat(value, "\"") : '');
    }
    function $62fd0a8327627af8$var$getTokenKindDesc(kind) {
        return (0, (0, parcelRequire("jkcJk")).isPunctuatorTokenKind)(kind) ? "\"".concat(kind, "\"") : kind;
    }
});
parcelRegister("7ZXKi", function(module, exports) {
    $parcel$export(module.exports, "syntaxError", ()=>$5d2c9324f08528ec$export$bbee0c6176c019d4);
    var $g5yZB;
    function $5d2c9324f08528ec$export$bbee0c6176c019d4(source, position, description) {
        return new (0, (0, parcelRequire("g5yZB")).GraphQLError)("Syntax Error: ".concat(description), undefined, source, [
            position
        ]);
    }
});
parcelRegister("g5yZB", function(module, exports) {
    $parcel$export(module.exports, "GraphQLError", ()=>$bb6841c873fb42f5$export$92d6ed0888e7cb7f);
    var $cJPdE;
    var $6DBwa;
    var $3DTMg;
    var $4Zjco;
    function $bb6841c873fb42f5$var$_typeof(obj) {
        "@babel/helpers - typeof";
        if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $bb6841c873fb42f5$var$_typeof = function _typeof(obj) {
            return typeof obj;
        };
        else $bb6841c873fb42f5$var$_typeof = function _typeof(obj) {
            return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        };
        return $bb6841c873fb42f5$var$_typeof(obj);
    }
    function $bb6841c873fb42f5$var$ownKeys(object, enumerableOnly) {
        var keys = Object.keys(object);
        if (Object.getOwnPropertySymbols) {
            var symbols = Object.getOwnPropertySymbols(object);
            if (enumerableOnly) symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
            keys.push.apply(keys, symbols);
        }
        return keys;
    }
    function $bb6841c873fb42f5$var$_objectSpread(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i] != null ? arguments[i] : {};
            if (i % 2) $bb6841c873fb42f5$var$ownKeys(Object(source), true).forEach(function(key) {
                $bb6841c873fb42f5$var$_defineProperty(target, key, source[key]);
            });
            else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
            else $bb6841c873fb42f5$var$ownKeys(Object(source)).forEach(function(key) {
                Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
            });
        }
        return target;
    }
    function $bb6841c873fb42f5$var$_defineProperty(obj, key, value) {
        if (key in obj) Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
        else obj[key] = value;
        return obj;
    }
    function $bb6841c873fb42f5$var$_classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
    }
    function $bb6841c873fb42f5$var$_defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    function $bb6841c873fb42f5$var$_createClass(Constructor, protoProps, staticProps) {
        if (protoProps) $bb6841c873fb42f5$var$_defineProperties(Constructor.prototype, protoProps);
        if (staticProps) $bb6841c873fb42f5$var$_defineProperties(Constructor, staticProps);
        return Constructor;
    }
    function $bb6841c873fb42f5$var$_inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
        subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
                value: subClass,
                writable: true,
                configurable: true
            }
        });
        if (superClass) $bb6841c873fb42f5$var$_setPrototypeOf(subClass, superClass);
    }
    function $bb6841c873fb42f5$var$_createSuper(Derived) {
        var hasNativeReflectConstruct = $bb6841c873fb42f5$var$_isNativeReflectConstruct();
        return function _createSuperInternal() {
            var Super = $bb6841c873fb42f5$var$_getPrototypeOf(Derived), result;
            if (hasNativeReflectConstruct) {
                var NewTarget = $bb6841c873fb42f5$var$_getPrototypeOf(this).constructor;
                result = Reflect.construct(Super, arguments, NewTarget);
            } else result = Super.apply(this, arguments);
            return $bb6841c873fb42f5$var$_possibleConstructorReturn(this, result);
        };
    }
    function $bb6841c873fb42f5$var$_possibleConstructorReturn(self, call) {
        if (call && ($bb6841c873fb42f5$var$_typeof(call) === "object" || typeof call === "function")) return call;
        return $bb6841c873fb42f5$var$_assertThisInitialized(self);
    }
    function $bb6841c873fb42f5$var$_assertThisInitialized(self) {
        if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return self;
    }
    function $bb6841c873fb42f5$var$_wrapNativeSuper(Class) {
        var _cache = typeof Map === "function" ? new Map() : undefined;
        $bb6841c873fb42f5$var$_wrapNativeSuper = function _wrapNativeSuper(Class) {
            if (Class === null || !$bb6841c873fb42f5$var$_isNativeFunction(Class)) return Class;
            if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
            if (typeof _cache !== "undefined") {
                if (_cache.has(Class)) return _cache.get(Class);
                _cache.set(Class, Wrapper);
            }
            function Wrapper() {
                return $bb6841c873fb42f5$var$_construct(Class, arguments, $bb6841c873fb42f5$var$_getPrototypeOf(this).constructor);
            }
            Wrapper.prototype = Object.create(Class.prototype, {
                constructor: {
                    value: Wrapper,
                    enumerable: false,
                    writable: true,
                    configurable: true
                }
            });
            return $bb6841c873fb42f5$var$_setPrototypeOf(Wrapper, Class);
        };
        return $bb6841c873fb42f5$var$_wrapNativeSuper(Class);
    }
    function $bb6841c873fb42f5$var$_construct(Parent, args, Class) {
        if ($bb6841c873fb42f5$var$_isNativeReflectConstruct()) $bb6841c873fb42f5$var$_construct = Reflect.construct;
        else $bb6841c873fb42f5$var$_construct = function _construct(Parent, args, Class) {
            var a = [
                null
            ];
            a.push.apply(a, args);
            var Constructor = Function.bind.apply(Parent, a);
            var instance = new Constructor();
            if (Class) $bb6841c873fb42f5$var$_setPrototypeOf(instance, Class.prototype);
            return instance;
        };
        return $bb6841c873fb42f5$var$_construct.apply(null, arguments);
    }
    function $bb6841c873fb42f5$var$_isNativeReflectConstruct() {
        if (typeof Reflect === "undefined" || !Reflect.construct) return false;
        if (Reflect.construct.sham) return false;
        if (typeof Proxy === "function") return true;
        try {
            Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
            return true;
        } catch (e) {
            return false;
        }
    }
    function $bb6841c873fb42f5$var$_isNativeFunction(fn) {
        return Function.toString.call(fn).indexOf("[native code]") !== -1;
    }
    function $bb6841c873fb42f5$var$_setPrototypeOf(o, p) {
        $bb6841c873fb42f5$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
            o.__proto__ = p;
            return o;
        };
        return $bb6841c873fb42f5$var$_setPrototypeOf(o, p);
    }
    function $bb6841c873fb42f5$var$_getPrototypeOf(o) {
        $bb6841c873fb42f5$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
            return o.__proto__ || Object.getPrototypeOf(o);
        };
        return $bb6841c873fb42f5$var$_getPrototypeOf(o);
    }
    var $bb6841c873fb42f5$export$92d6ed0888e7cb7f = function(_Error) {
        $bb6841c873fb42f5$var$_inherits(GraphQLError, _Error);
        var _super = $bb6841c873fb42f5$var$_createSuper(GraphQLError);
        function GraphQLError(message, nodes, source, positions, path, originalError, extensions) {
            var _nodeLocations, _nodeLocations2, _nodeLocations3;
            var _this;
            $bb6841c873fb42f5$var$_classCallCheck(this, GraphQLError);
            _this = _super.call(this, message);
            _this.name = 'GraphQLError';
            _this.originalError = originalError !== null && originalError !== void 0 ? originalError : undefined;
            _this.nodes = $bb6841c873fb42f5$var$undefinedIfEmpty(Array.isArray(nodes) ? nodes : nodes ? [
                nodes
            ] : undefined);
            var nodeLocations = [];
            for(var _i2 = 0, _ref3 = (_this$nodes = _this.nodes) !== null && _this$nodes !== void 0 ? _this$nodes : []; _i2 < _ref3.length; _i2++){
                var _this$nodes;
                var _ref4 = _ref3[_i2];
                var loc = _ref4.loc;
                if (loc != null) nodeLocations.push(loc);
            }
            nodeLocations = $bb6841c873fb42f5$var$undefinedIfEmpty(nodeLocations);
            _this.source = source !== null && source !== void 0 ? source : (_nodeLocations = nodeLocations) === null || _nodeLocations === void 0 ? void 0 : _nodeLocations[0].source;
            _this.positions = positions !== null && positions !== void 0 ? positions : (_nodeLocations2 = nodeLocations) === null || _nodeLocations2 === void 0 ? void 0 : _nodeLocations2.map(function(loc) {
                return loc.start;
            });
            _this.locations = positions && source ? positions.map(function(pos) {
                return (0, (0, parcelRequire("3DTMg")).getLocation)(source, pos);
            }) : (_nodeLocations3 = nodeLocations) === null || _nodeLocations3 === void 0 ? void 0 : _nodeLocations3.map(function(loc) {
                return (0, (0, parcelRequire("3DTMg")).getLocation)(loc.source, loc.start);
            });
            _this.path = path !== null && path !== void 0 ? path : undefined;
            var originalExtensions = originalError === null || originalError === void 0 ? void 0 : originalError.extensions;
            if (extensions == null && (0, (0, parcelRequire("cJPdE")).default)(originalExtensions)) _this.extensions = $bb6841c873fb42f5$var$_objectSpread({}, originalExtensions);
            else _this.extensions = extensions !== null && extensions !== void 0 ? extensions : {};
            Object.defineProperties($bb6841c873fb42f5$var$_assertThisInitialized(_this), {
                message: {
                    enumerable: true
                },
                locations: {
                    enumerable: _this.locations != null
                },
                path: {
                    enumerable: _this.path != null
                },
                extensions: {
                    enumerable: _this.extensions != null && Object.keys(_this.extensions).length > 0
                },
                name: {
                    enumerable: false
                },
                nodes: {
                    enumerable: false
                },
                source: {
                    enumerable: false
                },
                positions: {
                    enumerable: false
                },
                originalError: {
                    enumerable: false
                }
            });
            if (originalError !== null && originalError !== void 0 && originalError.stack) {
                Object.defineProperty($bb6841c873fb42f5$var$_assertThisInitialized(_this), 'stack', {
                    value: originalError.stack,
                    writable: true,
                    configurable: true
                });
                return $bb6841c873fb42f5$var$_possibleConstructorReturn(_this);
            }
            if (Error.captureStackTrace) Error.captureStackTrace($bb6841c873fb42f5$var$_assertThisInitialized(_this), GraphQLError);
            else Object.defineProperty($bb6841c873fb42f5$var$_assertThisInitialized(_this), 'stack', {
                value: Error().stack,
                writable: true,
                configurable: true
            });
            return _this;
        }
        $bb6841c873fb42f5$var$_createClass(GraphQLError, [
            {
                key: "toString",
                value: function toString() {
                    return $bb6841c873fb42f5$export$55ee1551a3f962e6(this);
                }
            },
            {
                key: (0, (0, parcelRequire("6DBwa")).SYMBOL_TO_STRING_TAG),
                get: function get() {
                    return 'Object';
                }
            }
        ]);
        return GraphQLError;
    }($bb6841c873fb42f5$var$_wrapNativeSuper(Error));
    function $bb6841c873fb42f5$var$undefinedIfEmpty(array) {
        return array === undefined || array.length === 0 ? undefined : array;
    }
    function $bb6841c873fb42f5$export$55ee1551a3f962e6(error) {
        var output = error.message;
        if (error.nodes) for(var _i4 = 0, _error$nodes2 = error.nodes; _i4 < _error$nodes2.length; _i4++){
            var node = _error$nodes2[_i4];
            if (node.loc) output += '\n\n' + (0, (0, parcelRequire("4Zjco")).printLocation)(node.loc);
        }
        else if (error.source && error.locations) for(var _i6 = 0, _error$locations2 = error.locations; _i6 < _error$locations2.length; _i6++){
            var location = _error$locations2[_i6];
            output += '\n\n' + (0, (0, parcelRequire("4Zjco")).printSourceLocation)(error.source, location);
        }
        return output;
    }
});
parcelRegister("cJPdE", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$94616b0c7295e50a$export$2e2bcd8739ae039);
    function $94616b0c7295e50a$var$_typeof(obj) {
        "@babel/helpers - typeof";
        if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $94616b0c7295e50a$var$_typeof = function _typeof(obj) {
            return typeof obj;
        };
        else $94616b0c7295e50a$var$_typeof = function _typeof(obj) {
            return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        };
        return $94616b0c7295e50a$var$_typeof(obj);
    }
    function $94616b0c7295e50a$export$2e2bcd8739ae039(value) {
        return $94616b0c7295e50a$var$_typeof(value) == 'object' && value !== null;
    }
});
parcelRegister("6DBwa", function(module, exports) {
    $parcel$export(module.exports, "SYMBOL_ITERATOR", ()=>$4d537cd703fb8e64$export$f6cdee3c26d6da57);
    $parcel$export(module.exports, "SYMBOL_ASYNC_ITERATOR", ()=>$4d537cd703fb8e64$export$8d0083df0471478e);
    $parcel$export(module.exports, "SYMBOL_TO_STRING_TAG", ()=>$4d537cd703fb8e64$export$5deadc579ccc7c9c);
    var $4d537cd703fb8e64$export$f6cdee3c26d6da57 = typeof Symbol === 'function' && Symbol.iterator != null ? Symbol.iterator : '@@iterator';
    var $4d537cd703fb8e64$export$8d0083df0471478e = typeof Symbol === 'function' && Symbol.asyncIterator != null ? Symbol.asyncIterator : '@@asyncIterator';
    var $4d537cd703fb8e64$export$5deadc579ccc7c9c = typeof Symbol === 'function' && Symbol.toStringTag != null ? Symbol.toStringTag : '@@toStringTag';
});
parcelRegister("3DTMg", function(module, exports) {
    $parcel$export(module.exports, "getLocation", ()=>$2a7047dfe88e1e3e$export$e7fd20fad3cf4b5f);
    function $2a7047dfe88e1e3e$export$e7fd20fad3cf4b5f(source, position) {
        var lineRegexp = /\r\n|[\n\r]/g;
        var line = 1;
        var column = position + 1;
        var match;
        while((match = lineRegexp.exec(source.body)) && match.index < position){
            line += 1;
            column = position + 1 - (match.index + match[0].length);
        }
        return {
            line: line,
            column: column
        };
    }
});
parcelRegister("4Zjco", function(module, exports) {
    $parcel$export(module.exports, "printLocation", ()=>$3a1bc06740b7fb42$export$96a9681e539deed);
    $parcel$export(module.exports, "printSourceLocation", ()=>$3a1bc06740b7fb42$export$867940333fd9f869);
    var $3DTMg;
    function $3a1bc06740b7fb42$export$96a9681e539deed(location) {
        return $3a1bc06740b7fb42$export$867940333fd9f869(location.source, (0, (0, parcelRequire("3DTMg")).getLocation)(location.source, location.start));
    }
    function $3a1bc06740b7fb42$export$867940333fd9f869(source, sourceLocation) {
        var firstLineColumnOffset = source.locationOffset.column - 1;
        var body = $3a1bc06740b7fb42$var$whitespace(firstLineColumnOffset) + source.body;
        var lineIndex = sourceLocation.line - 1;
        var lineOffset = source.locationOffset.line - 1;
        var lineNum = sourceLocation.line + lineOffset;
        var columnOffset = sourceLocation.line === 1 ? firstLineColumnOffset : 0;
        var columnNum = sourceLocation.column + columnOffset;
        var locationStr = "".concat(source.name, ":").concat(lineNum, ":").concat(columnNum, "\n");
        var lines = body.split(/\r\n|[\n\r]/g);
        var locationLine = lines[lineIndex];
        if (locationLine.length > 120) {
            var subLineIndex = Math.floor(columnNum / 80);
            var subLineColumnNum = columnNum % 80;
            var subLines = [];
            for(var i = 0; i < locationLine.length; i += 80)subLines.push(locationLine.slice(i, i + 80));
            return locationStr + $3a1bc06740b7fb42$var$printPrefixedLines([
                [
                    "".concat(lineNum),
                    subLines[0]
                ]
            ].concat(subLines.slice(1, subLineIndex + 1).map(function(subLine) {
                return [
                    '',
                    subLine
                ];
            }), [
                [
                    ' ',
                    $3a1bc06740b7fb42$var$whitespace(subLineColumnNum - 1) + '^'
                ],
                [
                    '',
                    subLines[subLineIndex + 1]
                ]
            ]));
        }
        return locationStr + $3a1bc06740b7fb42$var$printPrefixedLines([
            [
                "".concat(lineNum - 1),
                lines[lineIndex - 1]
            ],
            [
                "".concat(lineNum),
                locationLine
            ],
            [
                '',
                $3a1bc06740b7fb42$var$whitespace(columnNum - 1) + '^'
            ],
            [
                "".concat(lineNum + 1),
                lines[lineIndex + 1]
            ]
        ]);
    }
    function $3a1bc06740b7fb42$var$printPrefixedLines(lines) {
        var existingLines = lines.filter(function(_ref) {
            var _ = _ref[0], line = _ref[1];
            return line !== undefined;
        });
        var padLen = Math.max.apply(Math, existingLines.map(function(_ref2) {
            var prefix = _ref2[0];
            return prefix.length;
        }));
        return existingLines.map(function(_ref3) {
            var prefix = _ref3[0], line = _ref3[1];
            return $3a1bc06740b7fb42$var$leftPad(padLen, prefix) + (line ? ' | ' + line : ' |');
        }).join('\n');
    }
    function $3a1bc06740b7fb42$var$whitespace(len) {
        return Array(len + 1).join(' ');
    }
    function $3a1bc06740b7fb42$var$leftPad(len, str) {
        return $3a1bc06740b7fb42$var$whitespace(len - str.length) + str;
    }
});
parcelRegister("bzIlO", function(module, exports) {
    $parcel$export(module.exports, "Kind", ()=>$86d55dbd37d1d598$export$a84bdc57c5122798);
    var $86d55dbd37d1d598$export$a84bdc57c5122798 = Object.freeze({
        NAME: 'Name',
        DOCUMENT: 'Document',
        OPERATION_DEFINITION: 'OperationDefinition',
        VARIABLE_DEFINITION: 'VariableDefinition',
        SELECTION_SET: 'SelectionSet',
        FIELD: 'Field',
        ARGUMENT: 'Argument',
        FRAGMENT_SPREAD: 'FragmentSpread',
        INLINE_FRAGMENT: 'InlineFragment',
        FRAGMENT_DEFINITION: 'FragmentDefinition',
        VARIABLE: 'Variable',
        INT: 'IntValue',
        FLOAT: 'FloatValue',
        STRING: 'StringValue',
        BOOLEAN: 'BooleanValue',
        NULL: 'NullValue',
        ENUM: 'EnumValue',
        LIST: 'ListValue',
        OBJECT: 'ObjectValue',
        OBJECT_FIELD: 'ObjectField',
        DIRECTIVE: 'Directive',
        NAMED_TYPE: 'NamedType',
        LIST_TYPE: 'ListType',
        NON_NULL_TYPE: 'NonNullType',
        SCHEMA_DEFINITION: 'SchemaDefinition',
        OPERATION_TYPE_DEFINITION: 'OperationTypeDefinition',
        SCALAR_TYPE_DEFINITION: 'ScalarTypeDefinition',
        OBJECT_TYPE_DEFINITION: 'ObjectTypeDefinition',
        FIELD_DEFINITION: 'FieldDefinition',
        INPUT_VALUE_DEFINITION: 'InputValueDefinition',
        INTERFACE_TYPE_DEFINITION: 'InterfaceTypeDefinition',
        UNION_TYPE_DEFINITION: 'UnionTypeDefinition',
        ENUM_TYPE_DEFINITION: 'EnumTypeDefinition',
        ENUM_VALUE_DEFINITION: 'EnumValueDefinition',
        INPUT_OBJECT_TYPE_DEFINITION: 'InputObjectTypeDefinition',
        DIRECTIVE_DEFINITION: 'DirectiveDefinition',
        SCHEMA_EXTENSION: 'SchemaExtension',
        SCALAR_TYPE_EXTENSION: 'ScalarTypeExtension',
        OBJECT_TYPE_EXTENSION: 'ObjectTypeExtension',
        INTERFACE_TYPE_EXTENSION: 'InterfaceTypeExtension',
        UNION_TYPE_EXTENSION: 'UnionTypeExtension',
        ENUM_TYPE_EXTENSION: 'EnumTypeExtension',
        INPUT_OBJECT_TYPE_EXTENSION: 'InputObjectTypeExtension'
    });
});
parcelRegister("2z7TS", function(module, exports) {
    $parcel$export(module.exports, "TokenKind", ()=>$1de4fa7b8080613f$export$8b9d26ab11394711);
    var $1de4fa7b8080613f$export$8b9d26ab11394711 = Object.freeze({
        SOF: '<SOF>',
        EOF: '<EOF>',
        BANG: '!',
        DOLLAR: '$',
        AMP: '&',
        PAREN_L: '(',
        PAREN_R: ')',
        SPREAD: '...',
        COLON: ':',
        EQUALS: '=',
        AT: '@',
        BRACKET_L: '[',
        BRACKET_R: ']',
        BRACE_L: '{',
        PIPE: '|',
        BRACE_R: '}',
        NAME: 'Name',
        INT: 'Int',
        FLOAT: 'Float',
        STRING: 'String',
        BLOCK_STRING: 'BlockString',
        COMMENT: 'Comment'
    });
});
parcelRegister("6vk4Q", function(module, exports) {
    $parcel$export(module.exports, "Source", ()=>$4bc536350d5671b9$export$1d2df86270c81ecb);
    $parcel$export(module.exports, "isSource", ()=>$4bc536350d5671b9$export$75135ee9ed6e435b);
    var $6DBwa;
    var $yEDl8;
    var $a1qmV;
    var $6B4dU;
    function $4bc536350d5671b9$var$_defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    function $4bc536350d5671b9$var$_createClass(Constructor, protoProps, staticProps) {
        if (protoProps) $4bc536350d5671b9$var$_defineProperties(Constructor.prototype, protoProps);
        if (staticProps) $4bc536350d5671b9$var$_defineProperties(Constructor, staticProps);
        return Constructor;
    }
    var $4bc536350d5671b9$export$1d2df86270c81ecb = function() {
        function Source(body) {
            var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'GraphQL request';
            var locationOffset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
                line: 1,
                column: 1
            };
            typeof body === 'string' || (0, (0, parcelRequire("a1qmV")).default)(0, "Body must be a string. Received: ".concat((0, (0, parcelRequire("yEDl8")).default)(body), "."));
            this.body = body;
            this.name = name;
            this.locationOffset = locationOffset;
            this.locationOffset.line > 0 || (0, (0, parcelRequire("a1qmV")).default)(0, 'line in locationOffset is 1-indexed and must be positive.');
            this.locationOffset.column > 0 || (0, (0, parcelRequire("a1qmV")).default)(0, 'column in locationOffset is 1-indexed and must be positive.');
        }
        $4bc536350d5671b9$var$_createClass(Source, [
            {
                key: (0, (0, parcelRequire("6DBwa")).SYMBOL_TO_STRING_TAG),
                get: function get() {
                    return 'Source';
                }
            }
        ]);
        return Source;
    }();
    function $4bc536350d5671b9$export$75135ee9ed6e435b(source) {
        return (0, (0, parcelRequire("6B4dU")).default)(source, $4bc536350d5671b9$export$1d2df86270c81ecb);
    }
});
parcelRegister("a1qmV", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$74be73ae076c40a2$export$2e2bcd8739ae039);
    function $74be73ae076c40a2$export$2e2bcd8739ae039(condition, message) {
        var booleanCondition = Boolean(condition);
        if (!booleanCondition) throw new Error(message);
    }
});
parcelRegister("6B4dU", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4cd9796d6ab57d14$export$2e2bcd8739ae039);
    function $4cd9796d6ab57d14$var$_typeof(obj) {
        "@babel/helpers - typeof";
        if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $4cd9796d6ab57d14$var$_typeof = function _typeof(obj) {
            return typeof obj;
        };
        else $4cd9796d6ab57d14$var$_typeof = function _typeof(obj) {
            return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        };
        return $4cd9796d6ab57d14$var$_typeof(obj);
    }
    var $4cd9796d6ab57d14$export$2e2bcd8739ae039 = function instanceOf(value, constructor) {
        return value instanceof constructor;
    };
});
parcelRegister("jADQJ", function(module, exports) {
    $parcel$export(module.exports, "DirectiveLocation", ()=>$e4304a67ae3cac6f$export$b45ffd2948484c41);
    var $e4304a67ae3cac6f$export$b45ffd2948484c41 = Object.freeze({
        QUERY: 'QUERY',
        MUTATION: 'MUTATION',
        SUBSCRIPTION: 'SUBSCRIPTION',
        FIELD: 'FIELD',
        FRAGMENT_DEFINITION: 'FRAGMENT_DEFINITION',
        FRAGMENT_SPREAD: 'FRAGMENT_SPREAD',
        INLINE_FRAGMENT: 'INLINE_FRAGMENT',
        VARIABLE_DEFINITION: 'VARIABLE_DEFINITION',
        SCHEMA: 'SCHEMA',
        SCALAR: 'SCALAR',
        OBJECT: 'OBJECT',
        FIELD_DEFINITION: 'FIELD_DEFINITION',
        ARGUMENT_DEFINITION: 'ARGUMENT_DEFINITION',
        INTERFACE: 'INTERFACE',
        UNION: 'UNION',
        ENUM: 'ENUM',
        ENUM_VALUE: 'ENUM_VALUE',
        INPUT_OBJECT: 'INPUT_OBJECT',
        INPUT_FIELD_DEFINITION: 'INPUT_FIELD_DEFINITION'
    });
});
parcelRegister("jkcJk", function(module, exports) {
    $parcel$export(module.exports, "Lexer", ()=>$e119c27db9a87f5b$export$6168dc8908a6c652);
    $parcel$export(module.exports, "isPunctuatorTokenKind", ()=>$e119c27db9a87f5b$export$59ac0f4da287406a);
    var $7ZXKi;
    var $98oUl;
    var $2z7TS;
    var $541Mz;
    var $e119c27db9a87f5b$export$6168dc8908a6c652 = function() {
        function Lexer(source) {
            var startOfFileToken = new (0, (0, parcelRequire("98oUl")).Token)((0, (0, parcelRequire("2z7TS")).TokenKind).SOF, 0, 0, 0, 0, null);
            this.source = source;
            this.lastToken = startOfFileToken;
            this.token = startOfFileToken;
            this.line = 1;
            this.lineStart = 0;
        }
        var _proto = Lexer.prototype;
        _proto.advance = function advance() {
            this.lastToken = this.token;
            var token = this.token = this.lookahead();
            return token;
        };
        _proto.lookahead = function lookahead() {
            var token = this.token;
            if (token.kind !== (0, (0, parcelRequire("2z7TS")).TokenKind).EOF) do {
                var _token$next;
                token = (_token$next = token.next) !== null && _token$next !== void 0 ? _token$next : token.next = $e119c27db9a87f5b$var$readToken(this, token);
            }while (token.kind === (0, (0, parcelRequire("2z7TS")).TokenKind).COMMENT)
            return token;
        };
        return Lexer;
    }();
    function $e119c27db9a87f5b$export$59ac0f4da287406a(kind) {
        return kind === (0, (0, parcelRequire("2z7TS")).TokenKind).BANG || kind === (0, (0, parcelRequire("2z7TS")).TokenKind).DOLLAR || kind === (0, (0, parcelRequire("2z7TS")).TokenKind).AMP || kind === (0, (0, parcelRequire("2z7TS")).TokenKind).PAREN_L || kind === (0, (0, parcelRequire("2z7TS")).TokenKind).PAREN_R || kind === (0, (0, parcelRequire("2z7TS")).TokenKind).SPREAD || kind === (0, (0, parcelRequire("2z7TS")).TokenKind).COLON || kind === (0, (0, parcelRequire("2z7TS")).TokenKind).EQUALS || kind === (0, (0, parcelRequire("2z7TS")).TokenKind).AT || kind === (0, (0, parcelRequire("2z7TS")).TokenKind).BRACKET_L || kind === (0, (0, parcelRequire("2z7TS")).TokenKind).BRACKET_R || kind === (0, (0, parcelRequire("2z7TS")).TokenKind).BRACE_L || kind === (0, (0, parcelRequire("2z7TS")).TokenKind).PIPE || kind === (0, (0, parcelRequire("2z7TS")).TokenKind).BRACE_R;
    }
    function $e119c27db9a87f5b$var$printCharCode(code) {
        return isNaN(code) ? (0, (0, parcelRequire("2z7TS")).TokenKind).EOF : code < 0x007f ? JSON.stringify(String.fromCharCode(code)) : "\"\\u".concat(('00' + code.toString(16).toUpperCase()).slice(-4), "\"");
    }
    function $e119c27db9a87f5b$var$readToken(lexer, prev) {
        var source = lexer.source;
        var body = source.body;
        var bodyLength = body.length;
        var pos = prev.end;
        while(pos < bodyLength){
            var code = body.charCodeAt(pos);
            var _line = lexer.line;
            var _col = 1 + pos - lexer.lineStart;
            switch(code){
                case 0xfeff:
                case 9:
                case 32:
                case 44:
                    ++pos;
                    continue;
                case 10:
                    ++pos;
                    ++lexer.line;
                    lexer.lineStart = pos;
                    continue;
                case 13:
                    if (body.charCodeAt(pos + 1) === 10) pos += 2;
                    else ++pos;
                    ++lexer.line;
                    lexer.lineStart = pos;
                    continue;
                case 33:
                    return new (0, (0, parcelRequire("98oUl")).Token)((0, (0, parcelRequire("2z7TS")).TokenKind).BANG, pos, pos + 1, _line, _col, prev);
                case 35:
                    return $e119c27db9a87f5b$var$readComment(source, pos, _line, _col, prev);
                case 36:
                    return new (0, (0, parcelRequire("98oUl")).Token)((0, (0, parcelRequire("2z7TS")).TokenKind).DOLLAR, pos, pos + 1, _line, _col, prev);
                case 38:
                    return new (0, (0, parcelRequire("98oUl")).Token)((0, (0, parcelRequire("2z7TS")).TokenKind).AMP, pos, pos + 1, _line, _col, prev);
                case 40:
                    return new (0, (0, parcelRequire("98oUl")).Token)((0, (0, parcelRequire("2z7TS")).TokenKind).PAREN_L, pos, pos + 1, _line, _col, prev);
                case 41:
                    return new (0, (0, parcelRequire("98oUl")).Token)((0, (0, parcelRequire("2z7TS")).TokenKind).PAREN_R, pos, pos + 1, _line, _col, prev);
                case 46:
                    if (body.charCodeAt(pos + 1) === 46 && body.charCodeAt(pos + 2) === 46) return new (0, (0, parcelRequire("98oUl")).Token)((0, (0, parcelRequire("2z7TS")).TokenKind).SPREAD, pos, pos + 3, _line, _col, prev);
                    break;
                case 58:
                    return new (0, (0, parcelRequire("98oUl")).Token)((0, (0, parcelRequire("2z7TS")).TokenKind).COLON, pos, pos + 1, _line, _col, prev);
                case 61:
                    return new (0, (0, parcelRequire("98oUl")).Token)((0, (0, parcelRequire("2z7TS")).TokenKind).EQUALS, pos, pos + 1, _line, _col, prev);
                case 64:
                    return new (0, (0, parcelRequire("98oUl")).Token)((0, (0, parcelRequire("2z7TS")).TokenKind).AT, pos, pos + 1, _line, _col, prev);
                case 91:
                    return new (0, (0, parcelRequire("98oUl")).Token)((0, (0, parcelRequire("2z7TS")).TokenKind).BRACKET_L, pos, pos + 1, _line, _col, prev);
                case 93:
                    return new (0, (0, parcelRequire("98oUl")).Token)((0, (0, parcelRequire("2z7TS")).TokenKind).BRACKET_R, pos, pos + 1, _line, _col, prev);
                case 123:
                    return new (0, (0, parcelRequire("98oUl")).Token)((0, (0, parcelRequire("2z7TS")).TokenKind).BRACE_L, pos, pos + 1, _line, _col, prev);
                case 124:
                    return new (0, (0, parcelRequire("98oUl")).Token)((0, (0, parcelRequire("2z7TS")).TokenKind).PIPE, pos, pos + 1, _line, _col, prev);
                case 125:
                    return new (0, (0, parcelRequire("98oUl")).Token)((0, (0, parcelRequire("2z7TS")).TokenKind).BRACE_R, pos, pos + 1, _line, _col, prev);
                case 34:
                    if (body.charCodeAt(pos + 1) === 34 && body.charCodeAt(pos + 2) === 34) return $e119c27db9a87f5b$var$readBlockString(source, pos, _line, _col, prev, lexer);
                    return $e119c27db9a87f5b$var$readString(source, pos, _line, _col, prev);
                case 45:
                case 48:
                case 49:
                case 50:
                case 51:
                case 52:
                case 53:
                case 54:
                case 55:
                case 56:
                case 57:
                    return $e119c27db9a87f5b$var$readNumber(source, pos, code, _line, _col, prev);
                case 65:
                case 66:
                case 67:
                case 68:
                case 69:
                case 70:
                case 71:
                case 72:
                case 73:
                case 74:
                case 75:
                case 76:
                case 77:
                case 78:
                case 79:
                case 80:
                case 81:
                case 82:
                case 83:
                case 84:
                case 85:
                case 86:
                case 87:
                case 88:
                case 89:
                case 90:
                case 95:
                case 97:
                case 98:
                case 99:
                case 100:
                case 101:
                case 102:
                case 103:
                case 104:
                case 105:
                case 106:
                case 107:
                case 108:
                case 109:
                case 110:
                case 111:
                case 112:
                case 113:
                case 114:
                case 115:
                case 116:
                case 117:
                case 118:
                case 119:
                case 120:
                case 121:
                case 122:
                    return $e119c27db9a87f5b$var$readName(source, pos, _line, _col, prev);
            }
            throw (0, (0, parcelRequire("7ZXKi")).syntaxError)(source, pos, $e119c27db9a87f5b$var$unexpectedCharacterMessage(code));
        }
        var line = lexer.line;
        var col = 1 + pos - lexer.lineStart;
        return new (0, (0, parcelRequire("98oUl")).Token)((0, (0, parcelRequire("2z7TS")).TokenKind).EOF, bodyLength, bodyLength, line, col, prev);
    }
    function $e119c27db9a87f5b$var$unexpectedCharacterMessage(code) {
        if (code < 0x0020 && code !== 0x0009 && code !== 0x000a && code !== 0x000d) return "Cannot contain the invalid character ".concat($e119c27db9a87f5b$var$printCharCode(code), ".");
        if (code === 39) return 'Unexpected single quote character (\'), did you mean to use a double quote (")?';
        return "Cannot parse the unexpected character ".concat($e119c27db9a87f5b$var$printCharCode(code), ".");
    }
    function $e119c27db9a87f5b$var$readComment(source, start, line, col, prev) {
        var body = source.body;
        var code;
        var position = start;
        do code = body.charCodeAt(++position);
        while (!isNaN(code) && (code > 0x001f || code === 0x0009))
        return new (0, (0, parcelRequire("98oUl")).Token)((0, (0, parcelRequire("2z7TS")).TokenKind).COMMENT, start, position, line, col, prev, body.slice(start + 1, position));
    }
    function $e119c27db9a87f5b$var$readNumber(source, start, firstCode, line, col, prev) {
        var body = source.body;
        var code = firstCode;
        var position = start;
        var isFloat = false;
        if (code === 45) code = body.charCodeAt(++position);
        if (code === 48) {
            code = body.charCodeAt(++position);
            if (code >= 48 && code <= 57) throw (0, (0, parcelRequire("7ZXKi")).syntaxError)(source, position, "Invalid number, unexpected digit after 0: ".concat($e119c27db9a87f5b$var$printCharCode(code), "."));
        } else {
            position = $e119c27db9a87f5b$var$readDigits(source, position, code);
            code = body.charCodeAt(position);
        }
        if (code === 46) {
            isFloat = true;
            code = body.charCodeAt(++position);
            position = $e119c27db9a87f5b$var$readDigits(source, position, code);
            code = body.charCodeAt(position);
        }
        if (code === 69 || code === 101) {
            isFloat = true;
            code = body.charCodeAt(++position);
            if (code === 43 || code === 45) code = body.charCodeAt(++position);
            position = $e119c27db9a87f5b$var$readDigits(source, position, code);
            code = body.charCodeAt(position);
        }
        if (code === 46 || $e119c27db9a87f5b$var$isNameStart(code)) throw (0, (0, parcelRequire("7ZXKi")).syntaxError)(source, position, "Invalid number, expected digit but got: ".concat($e119c27db9a87f5b$var$printCharCode(code), "."));
        return new (0, (0, parcelRequire("98oUl")).Token)(isFloat ? (0, (0, parcelRequire("2z7TS")).TokenKind).FLOAT : (0, (0, parcelRequire("2z7TS")).TokenKind).INT, start, position, line, col, prev, body.slice(start, position));
    }
    function $e119c27db9a87f5b$var$readDigits(source, start, firstCode) {
        var body = source.body;
        var position = start;
        var code = firstCode;
        if (code >= 48 && code <= 57) {
            do code = body.charCodeAt(++position);
            while (code >= 48 && code <= 57)
            return position;
        }
        throw (0, (0, parcelRequire("7ZXKi")).syntaxError)(source, position, "Invalid number, expected digit but got: ".concat($e119c27db9a87f5b$var$printCharCode(code), "."));
    }
    function $e119c27db9a87f5b$var$readString(source, start, line, col, prev) {
        var body = source.body;
        var position = start + 1;
        var chunkStart = position;
        var code = 0;
        var value = '';
        while(position < body.length && !isNaN(code = body.charCodeAt(position)) && code !== 0x000a && code !== 0x000d){
            if (code === 34) {
                value += body.slice(chunkStart, position);
                return new (0, (0, parcelRequire("98oUl")).Token)((0, (0, parcelRequire("2z7TS")).TokenKind).STRING, start, position + 1, line, col, prev, value);
            }
            if (code < 0x0020 && code !== 0x0009) throw (0, (0, parcelRequire("7ZXKi")).syntaxError)(source, position, "Invalid character within String: ".concat($e119c27db9a87f5b$var$printCharCode(code), "."));
            ++position;
            if (code === 92) {
                value += body.slice(chunkStart, position - 1);
                code = body.charCodeAt(position);
                switch(code){
                    case 34:
                        value += '"';
                        break;
                    case 47:
                        value += '/';
                        break;
                    case 92:
                        value += '\\';
                        break;
                    case 98:
                        value += '\b';
                        break;
                    case 102:
                        value += '\f';
                        break;
                    case 110:
                        value += '\n';
                        break;
                    case 114:
                        value += '\r';
                        break;
                    case 116:
                        value += '\t';
                        break;
                    case 117:
                        var charCode = $e119c27db9a87f5b$var$uniCharCode(body.charCodeAt(position + 1), body.charCodeAt(position + 2), body.charCodeAt(position + 3), body.charCodeAt(position + 4));
                        if (charCode < 0) {
                            var invalidSequence = body.slice(position + 1, position + 5);
                            throw (0, (0, parcelRequire("7ZXKi")).syntaxError)(source, position, "Invalid character escape sequence: \\u".concat(invalidSequence, "."));
                        }
                        value += String.fromCharCode(charCode);
                        position += 4;
                        break;
                    default:
                        throw (0, (0, parcelRequire("7ZXKi")).syntaxError)(source, position, "Invalid character escape sequence: \\".concat(String.fromCharCode(code), "."));
                }
                ++position;
                chunkStart = position;
            }
        }
        throw (0, (0, parcelRequire("7ZXKi")).syntaxError)(source, position, 'Unterminated string.');
    }
    function $e119c27db9a87f5b$var$readBlockString(source, start, line, col, prev, lexer) {
        var body = source.body;
        var position = start + 3;
        var chunkStart = position;
        var code = 0;
        var rawValue = '';
        while(position < body.length && !isNaN(code = body.charCodeAt(position))){
            if (code === 34 && body.charCodeAt(position + 1) === 34 && body.charCodeAt(position + 2) === 34) {
                rawValue += body.slice(chunkStart, position);
                return new (0, (0, parcelRequire("98oUl")).Token)((0, (0, parcelRequire("2z7TS")).TokenKind).BLOCK_STRING, start, position + 3, line, col, prev, (0, (0, parcelRequire("541Mz")).dedentBlockStringValue)(rawValue));
            }
            if (code < 0x0020 && code !== 0x0009 && code !== 0x000a && code !== 0x000d) throw (0, (0, parcelRequire("7ZXKi")).syntaxError)(source, position, "Invalid character within String: ".concat($e119c27db9a87f5b$var$printCharCode(code), "."));
            if (code === 10) {
                ++position;
                ++lexer.line;
                lexer.lineStart = position;
            } else if (code === 13) {
                if (body.charCodeAt(position + 1) === 10) position += 2;
                else ++position;
                ++lexer.line;
                lexer.lineStart = position;
            } else if (code === 92 && body.charCodeAt(position + 1) === 34 && body.charCodeAt(position + 2) === 34 && body.charCodeAt(position + 3) === 34) {
                rawValue += body.slice(chunkStart, position) + '"""';
                position += 4;
                chunkStart = position;
            } else ++position;
        }
        throw (0, (0, parcelRequire("7ZXKi")).syntaxError)(source, position, 'Unterminated string.');
    }
    function $e119c27db9a87f5b$var$uniCharCode(a, b, c, d) {
        return $e119c27db9a87f5b$var$char2hex(a) << 12 | $e119c27db9a87f5b$var$char2hex(b) << 8 | $e119c27db9a87f5b$var$char2hex(c) << 4 | $e119c27db9a87f5b$var$char2hex(d);
    }
    function $e119c27db9a87f5b$var$char2hex(a) {
        return a >= 48 && a <= 57 ? a - 48 : a >= 65 && a <= 70 ? a - 55 : a >= 97 && a <= 102 ? a - 87 : -1;
    }
    function $e119c27db9a87f5b$var$readName(source, start, line, col, prev) {
        var body = source.body;
        var bodyLength = body.length;
        var position = start + 1;
        var code = 0;
        while(position !== bodyLength && !isNaN(code = body.charCodeAt(position)) && (code === 95 || code >= 48 && code <= 57 || code >= 65 && code <= 90 || code >= 97 && code <= 122))++position;
        return new (0, (0, parcelRequire("98oUl")).Token)((0, (0, parcelRequire("2z7TS")).TokenKind).NAME, start, position, line, col, prev, body.slice(start, position));
    }
    function $e119c27db9a87f5b$var$isNameStart(code) {
        return code === 95 || code >= 65 && code <= 90 || code >= 97 && code <= 122;
    }
});
parcelRegister("541Mz", function(module, exports) {
    $parcel$export(module.exports, "dedentBlockStringValue", ()=>$3afeb56b3b6851c5$export$fd88c0b652c46ccc);
    $parcel$export(module.exports, "printBlockString", ()=>$3afeb56b3b6851c5$export$adb6ca997eeb1f45);
    function $3afeb56b3b6851c5$export$fd88c0b652c46ccc(rawString) {
        var lines = rawString.split(/\r\n|[\n\r]/g);
        var commonIndent = $3afeb56b3b6851c5$export$3c95bfdc680af0c(rawString);
        if (commonIndent !== 0) for(var i = 1; i < lines.length; i++)lines[i] = lines[i].slice(commonIndent);
        var startLine = 0;
        while(startLine < lines.length && $3afeb56b3b6851c5$var$isBlank(lines[startLine]))++startLine;
        var endLine = lines.length;
        while(endLine > startLine && $3afeb56b3b6851c5$var$isBlank(lines[endLine - 1]))--endLine;
        return lines.slice(startLine, endLine).join('\n');
    }
    function $3afeb56b3b6851c5$var$isBlank(str) {
        for(var i = 0; i < str.length; ++i){
            if (str[i] !== ' ' && str[i] !== '\t') return false;
        }
        return true;
    }
    function $3afeb56b3b6851c5$export$3c95bfdc680af0c(value) {
        var _commonIndent;
        var isFirstLine = true;
        var isEmptyLine = true;
        var indent = 0;
        var commonIndent = null;
        for(var i = 0; i < value.length; ++i)switch(value.charCodeAt(i)){
            case 13:
                if (value.charCodeAt(i + 1) === 10) ++i;
            case 10:
                isFirstLine = false;
                isEmptyLine = true;
                indent = 0;
                break;
            case 9:
            case 32:
                ++indent;
                break;
            default:
                if (isEmptyLine && !isFirstLine && (commonIndent === null || indent < commonIndent)) commonIndent = indent;
                isEmptyLine = false;
        }
        return (_commonIndent = commonIndent) !== null && _commonIndent !== void 0 ? _commonIndent : 0;
    }
    function $3afeb56b3b6851c5$export$adb6ca997eeb1f45(value) {
        var indentation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
        var preferMultipleLines = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
        var isSingleLine = value.indexOf('\n') === -1;
        var hasLeadingSpace = value[0] === ' ' || value[0] === '\t';
        var hasTrailingQuote = value[value.length - 1] === '"';
        var hasTrailingSlash = value[value.length - 1] === '\\';
        var printAsMultipleLines = !isSingleLine || hasTrailingQuote || hasTrailingSlash || preferMultipleLines;
        var result = '';
        if (printAsMultipleLines && !(isSingleLine && hasLeadingSpace)) result += '\n' + indentation;
        result += indentation ? value.replace(/\n/g, '\n' + indentation) : value;
        if (printAsMultipleLines) result += '\n';
        return '"""' + result.replace(/"""/g, '\\"""') + '"""';
    }
});
parcelRegister("dS9cn", function(module, exports) {
    $parcel$export(module.exports, "AbstractResource", ()=>(parcelRequire("99RON")).AbstractResource);
    $parcel$export(module.exports, "utils", ()=>$6539d5230a113c0b$export$eab97d15b1788b8d);
    parcelRequire("3bFmZ");
    parcelRequire("99RON");
    var $aF8YM = parcelRequire("aF8YM");
    const $6539d5230a113c0b$export$eab97d15b1788b8d = $aF8YM;
});
parcelRegister("3bFmZ", function(module, exports) {
    $parcel$export(module.exports, "buildCredentials", ()=>$1dde2ae50887ec17$export$2ac26f1ab7eda637);
    const $1dde2ae50887ec17$export$2ac26f1ab7eda637 = (secOptions)=>{
        return secOptions && secOptions.omitCredentials ? 'omit' : 'include';
    };
});
parcelRegister("99RON", function(module, exports) {
    $parcel$export(module.exports, "AbstractResource", ()=>$e1e58db2ea52ba80$export$4529f10aed0950d4);
    class $e1e58db2ea52ba80$export$4529f10aed0950d4 {
        subscribe(onChange) {
            this.listeners.add(onChange);
            if (this.lastResult) onChange.result(this.lastResult);
        }
        unsubscribe(onChange) {
            this.listeners.delete(onChange);
        }
        notifyResult(result) {
            this.listeners.forEach((onChange)=>{
                onChange.result(result);
            });
        }
        notifyError(error) {
            this.listeners.forEach((onChange)=>{
                if (onChange.error) onChange.error(error);
            });
        }
        notifyInfo(info) {
            this.listeners.forEach((onChange)=>{
                if (onChange.info) onChange.info(info);
            });
        }
        notifyNotReady() {
            this.listeners.forEach((onChange)=>{
                if (onChange.notReady) onChange.notReady();
            });
        }
        constructor(){
            this.listeners = new Set();
        }
    }
});
parcelRegister("aF8YM", function(module, exports) {
    $parcel$export(module.exports, "requestService", ()=>$4cb3782fbf0bac5b$export$97bfde5a702aaeca);
    var $3bFmZ = parcelRequire("3bFmZ");
    const $4cb3782fbf0bac5b$var$defaultRequestServiceOptions = {};
    const $4cb3782fbf0bac5b$var$buildUrl = (baseUrl, path = '', queryParams, secOptions)=>{
        const searchParam = new URLSearchParams(new URL(baseUrl, 'https://BASE_FALLBACK').search || undefined);
        baseUrl = baseUrl.split('?')[0];
        if (queryParams) {
            for(const key in queryParams)if (({}).hasOwnProperty.call(queryParams, key)) searchParam.append(key, queryParams[key]);
        }
        if (secOptions && secOptions.params) {
            for(const key in secOptions.params)if (({}).hasOwnProperty.call(secOptions.params, key)) {
                const values = secOptions.params[key];
                if (Array.isArray(values)) for(let i = 0; i < values.length; i++)searchParam.append(key, values[i]);
                else searchParam.append(key, values);
            }
        }
        let separator = '';
        if (path && baseUrl.substr(-1) !== '/' && !path.startsWith('/')) separator = '/';
        let params = searchParam.toString();
        if (params) params = '?' + params;
        return `${baseUrl}${separator}${path}${params}`;
    };
    const $4cb3782fbf0bac5b$var$addToHeaders = (headers, keyValues)=>{
        if (keyValues) {
            for(const key in keyValues)if (({}).hasOwnProperty.call(keyValues, key)) {
                const values = keyValues[key];
                if (Array.isArray(values)) for(let i = 0; i < values.length; i++)headers[key] = values[i];
                else headers[key] = values;
            }
        }
    };
    const $4cb3782fbf0bac5b$var$buildHeaders = (secOptions, extraHeaders)=>{
        const headers = {};
        $4cb3782fbf0bac5b$var$addToHeaders(headers, extraHeaders);
        if (secOptions) $4cb3782fbf0bac5b$var$addToHeaders(headers, secOptions.headers);
        return headers;
    };
    const $4cb3782fbf0bac5b$export$97bfde5a702aaeca = (serviceConfig, options)=>{
        const { url: url, securityProvider: securityProvider, refreshedSecurityProvider: refreshedSecurityProvider } = serviceConfig;
        const { path: path, queryParams: queryParams, requestInit: requestInit } = options || $4cb3782fbf0bac5b$var$defaultRequestServiceOptions;
        const secOptions = securityProvider && securityProvider();
        const requestUrl = $4cb3782fbf0bac5b$var$buildUrl(url, path, queryParams, secOptions);
        const headers = $4cb3782fbf0bac5b$var$buildHeaders(secOptions, requestInit && requestInit.headers);
        const credentials = (0, $3bFmZ.buildCredentials)(secOptions);
        const ignoreResponsePayload = options?.ignoreResponsePayload || false;
        const requestOptions = {
            ...requestInit,
            headers: headers,
            credentials: credentials
        };
        return fetch(requestUrl, requestOptions).then((response)=>{
            if (response.status === 204) return Promise.resolve();
            else if (response.ok) return ignoreResponsePayload ? Promise.resolve() : response.json();
            else if (response.status === 401 && refreshedSecurityProvider) return refreshedSecurityProvider().then((newSecOptions)=>{
                const retryServiceConfig = {
                    url: url,
                    securityProvider: ()=>newSecOptions
                };
                return $4cb3782fbf0bac5b$export$97bfde5a702aaeca(retryServiceConfig, options);
            });
            return Promise.reject({
                code: response.status,
                reason: response.statusText
            });
        });
    };
});
parcelRegister("1c8Um", function(module, exports) {
    $parcel$export(module.exports, "print", ()=>$0dedd2672864572f$export$c2d084dc44961371);
    var $12QNw;
    var $541Mz;
    function $0dedd2672864572f$export$c2d084dc44961371(ast) {
        return (0, (0, parcelRequire("12QNw")).visit)(ast, {
            leave: $0dedd2672864572f$var$printDocASTReducer
        });
    }
    var $0dedd2672864572f$var$MAX_LINE_LENGTH = 80;
    var $0dedd2672864572f$var$printDocASTReducer = {
        Name: function Name(node) {
            return node.value;
        },
        Variable: function Variable(node) {
            return '$' + node.name;
        },
        Document: function Document(node) {
            return $0dedd2672864572f$var$join(node.definitions, '\n\n') + '\n';
        },
        OperationDefinition: function OperationDefinition(node) {
            var op = node.operation;
            var name = node.name;
            var varDefs = $0dedd2672864572f$var$wrap('(', $0dedd2672864572f$var$join(node.variableDefinitions, ', '), ')');
            var directives = $0dedd2672864572f$var$join(node.directives, ' ');
            var selectionSet = node.selectionSet;
            return !name && !directives && !varDefs && op === 'query' ? selectionSet : $0dedd2672864572f$var$join([
                op,
                $0dedd2672864572f$var$join([
                    name,
                    varDefs
                ]),
                directives,
                selectionSet
            ], ' ');
        },
        VariableDefinition: function VariableDefinition(_ref) {
            var variable = _ref.variable, type = _ref.type, defaultValue = _ref.defaultValue, directives = _ref.directives;
            return variable + ': ' + type + $0dedd2672864572f$var$wrap(' = ', defaultValue) + $0dedd2672864572f$var$wrap(' ', $0dedd2672864572f$var$join(directives, ' '));
        },
        SelectionSet: function SelectionSet(_ref2) {
            var selections = _ref2.selections;
            return $0dedd2672864572f$var$block(selections);
        },
        Field: function Field(_ref3) {
            var alias = _ref3.alias, name = _ref3.name, args = _ref3.arguments, directives = _ref3.directives, selectionSet = _ref3.selectionSet;
            var prefix = $0dedd2672864572f$var$wrap('', alias, ': ') + name;
            var argsLine = prefix + $0dedd2672864572f$var$wrap('(', $0dedd2672864572f$var$join(args, ', '), ')');
            if (argsLine.length > $0dedd2672864572f$var$MAX_LINE_LENGTH) argsLine = prefix + $0dedd2672864572f$var$wrap('(\n', $0dedd2672864572f$var$indent($0dedd2672864572f$var$join(args, '\n')), '\n)');
            return $0dedd2672864572f$var$join([
                argsLine,
                $0dedd2672864572f$var$join(directives, ' '),
                selectionSet
            ], ' ');
        },
        Argument: function Argument(_ref4) {
            var name = _ref4.name, value = _ref4.value;
            return name + ': ' + value;
        },
        FragmentSpread: function FragmentSpread(_ref5) {
            var name = _ref5.name, directives = _ref5.directives;
            return '...' + name + $0dedd2672864572f$var$wrap(' ', $0dedd2672864572f$var$join(directives, ' '));
        },
        InlineFragment: function InlineFragment(_ref6) {
            var typeCondition = _ref6.typeCondition, directives = _ref6.directives, selectionSet = _ref6.selectionSet;
            return $0dedd2672864572f$var$join([
                '...',
                $0dedd2672864572f$var$wrap('on ', typeCondition),
                $0dedd2672864572f$var$join(directives, ' '),
                selectionSet
            ], ' ');
        },
        FragmentDefinition: function FragmentDefinition(_ref7) {
            var name = _ref7.name, typeCondition = _ref7.typeCondition, variableDefinitions = _ref7.variableDefinitions, directives = _ref7.directives, selectionSet = _ref7.selectionSet;
            return ("fragment ".concat(name).concat($0dedd2672864572f$var$wrap('(', $0dedd2672864572f$var$join(variableDefinitions, ', '), ')'), " ") + "on ".concat(typeCondition, " ").concat($0dedd2672864572f$var$wrap('', $0dedd2672864572f$var$join(directives, ' '), ' ')) + selectionSet);
        },
        IntValue: function IntValue(_ref8) {
            var value = _ref8.value;
            return value;
        },
        FloatValue: function FloatValue(_ref9) {
            var value = _ref9.value;
            return value;
        },
        StringValue: function StringValue(_ref10, key) {
            var value = _ref10.value, isBlockString = _ref10.block;
            return isBlockString ? (0, (0, parcelRequire("541Mz")).printBlockString)(value, key === 'description' ? '' : '  ') : JSON.stringify(value);
        },
        BooleanValue: function BooleanValue(_ref11) {
            var value = _ref11.value;
            return value ? 'true' : 'false';
        },
        NullValue: function NullValue() {
            return 'null';
        },
        EnumValue: function EnumValue(_ref12) {
            var value = _ref12.value;
            return value;
        },
        ListValue: function ListValue(_ref13) {
            var values = _ref13.values;
            return '[' + $0dedd2672864572f$var$join(values, ', ') + ']';
        },
        ObjectValue: function ObjectValue(_ref14) {
            var fields = _ref14.fields;
            return '{' + $0dedd2672864572f$var$join(fields, ', ') + '}';
        },
        ObjectField: function ObjectField(_ref15) {
            var name = _ref15.name, value = _ref15.value;
            return name + ': ' + value;
        },
        Directive: function Directive(_ref16) {
            var name = _ref16.name, args = _ref16.arguments;
            return '@' + name + $0dedd2672864572f$var$wrap('(', $0dedd2672864572f$var$join(args, ', '), ')');
        },
        NamedType: function NamedType(_ref17) {
            var name = _ref17.name;
            return name;
        },
        ListType: function ListType(_ref18) {
            var type = _ref18.type;
            return '[' + type + ']';
        },
        NonNullType: function NonNullType(_ref19) {
            var type = _ref19.type;
            return type + '!';
        },
        SchemaDefinition: $0dedd2672864572f$var$addDescription(function(_ref20) {
            var directives = _ref20.directives, operationTypes = _ref20.operationTypes;
            return $0dedd2672864572f$var$join([
                'schema',
                $0dedd2672864572f$var$join(directives, ' '),
                $0dedd2672864572f$var$block(operationTypes)
            ], ' ');
        }),
        OperationTypeDefinition: function OperationTypeDefinition(_ref21) {
            var operation = _ref21.operation, type = _ref21.type;
            return operation + ': ' + type;
        },
        ScalarTypeDefinition: $0dedd2672864572f$var$addDescription(function(_ref22) {
            var name = _ref22.name, directives = _ref22.directives;
            return $0dedd2672864572f$var$join([
                'scalar',
                name,
                $0dedd2672864572f$var$join(directives, ' ')
            ], ' ');
        }),
        ObjectTypeDefinition: $0dedd2672864572f$var$addDescription(function(_ref23) {
            var name = _ref23.name, interfaces = _ref23.interfaces, directives = _ref23.directives, fields = _ref23.fields;
            return $0dedd2672864572f$var$join([
                'type',
                name,
                $0dedd2672864572f$var$wrap('implements ', $0dedd2672864572f$var$join(interfaces, ' & ')),
                $0dedd2672864572f$var$join(directives, ' '),
                $0dedd2672864572f$var$block(fields)
            ], ' ');
        }),
        FieldDefinition: $0dedd2672864572f$var$addDescription(function(_ref24) {
            var name = _ref24.name, args = _ref24.arguments, type = _ref24.type, directives = _ref24.directives;
            return name + ($0dedd2672864572f$var$hasMultilineItems(args) ? $0dedd2672864572f$var$wrap('(\n', $0dedd2672864572f$var$indent($0dedd2672864572f$var$join(args, '\n')), '\n)') : $0dedd2672864572f$var$wrap('(', $0dedd2672864572f$var$join(args, ', '), ')')) + ': ' + type + $0dedd2672864572f$var$wrap(' ', $0dedd2672864572f$var$join(directives, ' '));
        }),
        InputValueDefinition: $0dedd2672864572f$var$addDescription(function(_ref25) {
            var name = _ref25.name, type = _ref25.type, defaultValue = _ref25.defaultValue, directives = _ref25.directives;
            return $0dedd2672864572f$var$join([
                name + ': ' + type,
                $0dedd2672864572f$var$wrap('= ', defaultValue),
                $0dedd2672864572f$var$join(directives, ' ')
            ], ' ');
        }),
        InterfaceTypeDefinition: $0dedd2672864572f$var$addDescription(function(_ref26) {
            var name = _ref26.name, interfaces = _ref26.interfaces, directives = _ref26.directives, fields = _ref26.fields;
            return $0dedd2672864572f$var$join([
                'interface',
                name,
                $0dedd2672864572f$var$wrap('implements ', $0dedd2672864572f$var$join(interfaces, ' & ')),
                $0dedd2672864572f$var$join(directives, ' '),
                $0dedd2672864572f$var$block(fields)
            ], ' ');
        }),
        UnionTypeDefinition: $0dedd2672864572f$var$addDescription(function(_ref27) {
            var name = _ref27.name, directives = _ref27.directives, types = _ref27.types;
            return $0dedd2672864572f$var$join([
                'union',
                name,
                $0dedd2672864572f$var$join(directives, ' '),
                types && types.length !== 0 ? '= ' + $0dedd2672864572f$var$join(types, ' | ') : ''
            ], ' ');
        }),
        EnumTypeDefinition: $0dedd2672864572f$var$addDescription(function(_ref28) {
            var name = _ref28.name, directives = _ref28.directives, values = _ref28.values;
            return $0dedd2672864572f$var$join([
                'enum',
                name,
                $0dedd2672864572f$var$join(directives, ' '),
                $0dedd2672864572f$var$block(values)
            ], ' ');
        }),
        EnumValueDefinition: $0dedd2672864572f$var$addDescription(function(_ref29) {
            var name = _ref29.name, directives = _ref29.directives;
            return $0dedd2672864572f$var$join([
                name,
                $0dedd2672864572f$var$join(directives, ' ')
            ], ' ');
        }),
        InputObjectTypeDefinition: $0dedd2672864572f$var$addDescription(function(_ref30) {
            var name = _ref30.name, directives = _ref30.directives, fields = _ref30.fields;
            return $0dedd2672864572f$var$join([
                'input',
                name,
                $0dedd2672864572f$var$join(directives, ' '),
                $0dedd2672864572f$var$block(fields)
            ], ' ');
        }),
        DirectiveDefinition: $0dedd2672864572f$var$addDescription(function(_ref31) {
            var name = _ref31.name, args = _ref31.arguments, repeatable = _ref31.repeatable, locations = _ref31.locations;
            return 'directive @' + name + ($0dedd2672864572f$var$hasMultilineItems(args) ? $0dedd2672864572f$var$wrap('(\n', $0dedd2672864572f$var$indent($0dedd2672864572f$var$join(args, '\n')), '\n)') : $0dedd2672864572f$var$wrap('(', $0dedd2672864572f$var$join(args, ', '), ')')) + (repeatable ? ' repeatable' : '') + ' on ' + $0dedd2672864572f$var$join(locations, ' | ');
        }),
        SchemaExtension: function SchemaExtension(_ref32) {
            var directives = _ref32.directives, operationTypes = _ref32.operationTypes;
            return $0dedd2672864572f$var$join([
                'extend schema',
                $0dedd2672864572f$var$join(directives, ' '),
                $0dedd2672864572f$var$block(operationTypes)
            ], ' ');
        },
        ScalarTypeExtension: function ScalarTypeExtension(_ref33) {
            var name = _ref33.name, directives = _ref33.directives;
            return $0dedd2672864572f$var$join([
                'extend scalar',
                name,
                $0dedd2672864572f$var$join(directives, ' ')
            ], ' ');
        },
        ObjectTypeExtension: function ObjectTypeExtension(_ref34) {
            var name = _ref34.name, interfaces = _ref34.interfaces, directives = _ref34.directives, fields = _ref34.fields;
            return $0dedd2672864572f$var$join([
                'extend type',
                name,
                $0dedd2672864572f$var$wrap('implements ', $0dedd2672864572f$var$join(interfaces, ' & ')),
                $0dedd2672864572f$var$join(directives, ' '),
                $0dedd2672864572f$var$block(fields)
            ], ' ');
        },
        InterfaceTypeExtension: function InterfaceTypeExtension(_ref35) {
            var name = _ref35.name, interfaces = _ref35.interfaces, directives = _ref35.directives, fields = _ref35.fields;
            return $0dedd2672864572f$var$join([
                'extend interface',
                name,
                $0dedd2672864572f$var$wrap('implements ', $0dedd2672864572f$var$join(interfaces, ' & ')),
                $0dedd2672864572f$var$join(directives, ' '),
                $0dedd2672864572f$var$block(fields)
            ], ' ');
        },
        UnionTypeExtension: function UnionTypeExtension(_ref36) {
            var name = _ref36.name, directives = _ref36.directives, types = _ref36.types;
            return $0dedd2672864572f$var$join([
                'extend union',
                name,
                $0dedd2672864572f$var$join(directives, ' '),
                types && types.length !== 0 ? '= ' + $0dedd2672864572f$var$join(types, ' | ') : ''
            ], ' ');
        },
        EnumTypeExtension: function EnumTypeExtension(_ref37) {
            var name = _ref37.name, directives = _ref37.directives, values = _ref37.values;
            return $0dedd2672864572f$var$join([
                'extend enum',
                name,
                $0dedd2672864572f$var$join(directives, ' '),
                $0dedd2672864572f$var$block(values)
            ], ' ');
        },
        InputObjectTypeExtension: function InputObjectTypeExtension(_ref38) {
            var name = _ref38.name, directives = _ref38.directives, fields = _ref38.fields;
            return $0dedd2672864572f$var$join([
                'extend input',
                name,
                $0dedd2672864572f$var$join(directives, ' '),
                $0dedd2672864572f$var$block(fields)
            ], ' ');
        }
    };
    function $0dedd2672864572f$var$addDescription(cb) {
        return function(node) {
            return $0dedd2672864572f$var$join([
                node.description,
                cb(node)
            ], '\n');
        };
    }
    function $0dedd2672864572f$var$join(maybeArray) {
        var _maybeArray$filter$jo;
        var separator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
        return (_maybeArray$filter$jo = maybeArray === null || maybeArray === void 0 ? void 0 : maybeArray.filter(function(x) {
            return x;
        }).join(separator)) !== null && _maybeArray$filter$jo !== void 0 ? _maybeArray$filter$jo : '';
    }
    function $0dedd2672864572f$var$block(array) {
        return $0dedd2672864572f$var$wrap('{\n', $0dedd2672864572f$var$indent($0dedd2672864572f$var$join(array, '\n')), '\n}');
    }
    function $0dedd2672864572f$var$wrap(start, maybeString) {
        var end = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
        return maybeString != null && maybeString !== '' ? start + maybeString + end : '';
    }
    function $0dedd2672864572f$var$indent(str) {
        return $0dedd2672864572f$var$wrap('  ', str.replace(/\n/g, '\n  '));
    }
    function $0dedd2672864572f$var$isMultiline(str) {
        return str.indexOf('\n') !== -1;
    }
    function $0dedd2672864572f$var$hasMultilineItems(maybeArray) {
        return maybeArray != null && maybeArray.some($0dedd2672864572f$var$isMultiline);
    }
});
parcelRegister("1Y49U", function(module, exports) {
    $parcel$export(module.exports, "JiraServicedeskQueueAri", ()=>$16ee9eeb56acb423$export$555c8ae00f64ebff);
    var $IfwMb;
    var $9KGzW;
    var $1C2Ux;
    var $16ee9eeb56acb423$var$jiraServicedeskQueueAriStaticOpts = {
        qualifier: "ari",
        platformQualifier: "cloud",
        cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
        resourceOwner: (0, (0, parcelRequire("IfwMb")).JiraServicedeskQueueAriResourceOwner),
        resourceType: (0, (0, parcelRequire("IfwMb")).JiraServicedeskQueueAriResourceType),
        resourceIdSlug: "activation/{activationId}/{queueId}",
        resourceIdSegmentFormats: {
            activationId: /[a-zA-Z0-9\-]+/,
            queueId: /[0-9]+/
        }
    };
    var $16ee9eeb56acb423$export$555c8ae00f64ebff = class _JiraServicedeskQueueAri extends (0, (0, parcelRequire("9KGzW")).RegisteredAri) {
        constructor(opts){
            super(opts);
            this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._queueId = opts.resourceIdSegmentValues.queueId;
        }
        get siteId() {
            return this._siteId;
        }
        get activationId() {
            return this._activationId;
        }
        get queueId() {
            return this._queueId;
        }
        static create(opts) {
            let derivedOpts = {
                qualifier: $16ee9eeb56acb423$var$jiraServicedeskQueueAriStaticOpts.qualifier,
                platformQualifier: $16ee9eeb56acb423$var$jiraServicedeskQueueAriStaticOpts.platformQualifier,
                cloudId: opts.siteId,
                resourceOwner: $16ee9eeb56acb423$var$jiraServicedeskQueueAriStaticOpts.resourceOwner,
                resourceType: $16ee9eeb56acb423$var$jiraServicedeskQueueAriStaticOpts.resourceType,
                resourceId: `activation/${opts.activationId}/${opts.queueId}`,
                resourceIdSegmentValues: {
                    activationId: opts.activationId,
                    queueId: opts.queueId
                }
            }, ariOpts = (0, (0, parcelRequire("1C2Ux")).AriParser).fromOpts(derivedOpts, $16ee9eeb56acb423$var$jiraServicedeskQueueAriStaticOpts);
            return new _JiraServicedeskQueueAri(ariOpts);
        }
        static parse(maybeAri) {
            let opts = (0, (0, parcelRequire("1C2Ux")).AriParser).fromString(maybeAri, $16ee9eeb56acb423$var$jiraServicedeskQueueAriStaticOpts);
            return new _JiraServicedeskQueueAri(opts);
        }
        getVariables() {
            return {
                siteId: this.siteId,
                activationId: this.activationId,
                queueId: this.queueId
            };
        }
    };
});
parcelRegister("IfwMb", function(module, exports) {
    $parcel$export(module.exports, "JiraServicedeskQueueAriResourceOwner", ()=>$085027a493012871$export$704112eeb385ceab);
    $parcel$export(module.exports, "JiraServicedeskQueueAriResourceType", ()=>$085027a493012871$export$6adb8c07b8bc2c5a);
    var $085027a493012871$export$704112eeb385ceab = "jira-servicedesk", $085027a493012871$export$6adb8c07b8bc2c5a = "queue";
});
parcelRegister("1WQct", function(module, exports) {
    $parcel$export(module.exports, "JiraSoftwareBoardAri", ()=>$16b3b3167d49c971$export$fcd404066e55a7a8);
    var $8ANGM;
    var $9KGzW;
    var $1C2Ux;
    var $16b3b3167d49c971$var$jiraSoftwareBoardAriStaticOpts = {
        qualifier: "ari",
        platformQualifier: "cloud",
        cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
        resourceOwner: (0, (0, parcelRequire("8ANGM")).JiraSoftwareBoardAriResourceOwner),
        resourceType: (0, (0, parcelRequire("8ANGM")).JiraSoftwareBoardAriResourceType),
        resourceIdSlug: "{boardId}",
        resourceIdSegmentFormats: {
            boardId: /[!a-zA-Z0-9\-_.~@:{}=]+(\/[!a-zA-Z0-9\-_.~@:{}=]+)*/
        }
    };
    var $16b3b3167d49c971$export$fcd404066e55a7a8 = class _JiraSoftwareBoardAri extends (0, (0, parcelRequire("9KGzW")).RegisteredAri) {
        constructor(opts){
            super(opts);
            this._siteId = opts.cloudId || "", this._boardId = opts.resourceIdSegmentValues.boardId;
        }
        get siteId() {
            return this._siteId;
        }
        get boardId() {
            return this._boardId;
        }
        static create(opts) {
            let derivedOpts = {
                qualifier: $16b3b3167d49c971$var$jiraSoftwareBoardAriStaticOpts.qualifier,
                platformQualifier: $16b3b3167d49c971$var$jiraSoftwareBoardAriStaticOpts.platformQualifier,
                cloudId: opts.siteId,
                resourceOwner: $16b3b3167d49c971$var$jiraSoftwareBoardAriStaticOpts.resourceOwner,
                resourceType: $16b3b3167d49c971$var$jiraSoftwareBoardAriStaticOpts.resourceType,
                resourceId: `${opts.boardId}`,
                resourceIdSegmentValues: {
                    boardId: opts.boardId
                }
            }, ariOpts = (0, (0, parcelRequire("1C2Ux")).AriParser).fromOpts(derivedOpts, $16b3b3167d49c971$var$jiraSoftwareBoardAriStaticOpts);
            return new _JiraSoftwareBoardAri(ariOpts);
        }
        static parse(maybeAri) {
            let opts = (0, (0, parcelRequire("1C2Ux")).AriParser).fromString(maybeAri, $16b3b3167d49c971$var$jiraSoftwareBoardAriStaticOpts);
            return new _JiraSoftwareBoardAri(opts);
        }
        getVariables() {
            return {
                siteId: this.siteId,
                boardId: this.boardId
            };
        }
    };
});
parcelRegister("8ANGM", function(module, exports) {
    $parcel$export(module.exports, "JiraSoftwareBoardAriResourceOwner", ()=>$64183abbeecc9672$export$d716ba4f5572ec86);
    $parcel$export(module.exports, "JiraSoftwareBoardAriResourceType", ()=>$64183abbeecc9672$export$d4b70c04cf2221a5);
    var $64183abbeecc9672$export$d716ba4f5572ec86 = "jira-software", $64183abbeecc9672$export$d4b70c04cf2221a5 = "board";
});
parcelRegister("k0goX", function(module, exports) {
    $parcel$export(module.exports, "JiraDashboardAri", ()=>$e90087bcd5853238$export$b7d4016f0f5da5b8);
    var $6H9w3;
    var $9KGzW;
    var $1C2Ux;
    var $e90087bcd5853238$var$jiraDashboardAriStaticOpts = {
        qualifier: "ari",
        platformQualifier: "cloud",
        cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
        resourceOwner: (0, (0, parcelRequire("6H9w3")).JiraDashboardAriResourceOwner),
        resourceType: (0, (0, parcelRequire("6H9w3")).JiraDashboardAriResourceType),
        resourceIdSlug: "activation/{activationId}/{dashboardId}",
        resourceIdSegmentFormats: {
            activationId: /[a-zA-Z0-9\-]+/,
            dashboardId: /[!a-zA-Z0-9\-_.~@:{}=]+(\/[!a-zA-Z0-9\-_.~@:{}=]+)*/
        }
    };
    var $e90087bcd5853238$export$b7d4016f0f5da5b8 = class _JiraDashboardAri extends (0, (0, parcelRequire("9KGzW")).RegisteredAri) {
        constructor(opts){
            super(opts);
            this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._dashboardId = opts.resourceIdSegmentValues.dashboardId;
        }
        get siteId() {
            return this._siteId;
        }
        get activationId() {
            return this._activationId;
        }
        get dashboardId() {
            return this._dashboardId;
        }
        static create(opts) {
            let derivedOpts = {
                qualifier: $e90087bcd5853238$var$jiraDashboardAriStaticOpts.qualifier,
                platformQualifier: $e90087bcd5853238$var$jiraDashboardAriStaticOpts.platformQualifier,
                cloudId: opts.siteId,
                resourceOwner: $e90087bcd5853238$var$jiraDashboardAriStaticOpts.resourceOwner,
                resourceType: $e90087bcd5853238$var$jiraDashboardAriStaticOpts.resourceType,
                resourceId: `activation/${opts.activationId}/${opts.dashboardId}`,
                resourceIdSegmentValues: {
                    activationId: opts.activationId,
                    dashboardId: opts.dashboardId
                }
            }, ariOpts = (0, (0, parcelRequire("1C2Ux")).AriParser).fromOpts(derivedOpts, $e90087bcd5853238$var$jiraDashboardAriStaticOpts);
            return new _JiraDashboardAri(ariOpts);
        }
        static parse(maybeAri) {
            let opts = (0, (0, parcelRequire("1C2Ux")).AriParser).fromString(maybeAri, $e90087bcd5853238$var$jiraDashboardAriStaticOpts);
            return new _JiraDashboardAri(opts);
        }
        getVariables() {
            return {
                siteId: this.siteId,
                activationId: this.activationId,
                dashboardId: this.dashboardId
            };
        }
    };
});
parcelRegister("6H9w3", function(module, exports) {
    $parcel$export(module.exports, "JiraDashboardAriResourceOwner", ()=>$014208d660d71eea$export$62c1deae25c41d24);
    $parcel$export(module.exports, "JiraDashboardAriResourceType", ()=>$014208d660d71eea$export$e4e3a57a5e435aff);
    var $014208d660d71eea$export$62c1deae25c41d24 = "jira", $014208d660d71eea$export$e4e3a57a5e435aff = "dashboard";
});
parcelRegister("89DrR", function(module, exports) {
    $parcel$export(module.exports, "JiraPlanAri", ()=>$5efdc39c8e0dee87$export$6d2eb3641569f26);
    var $fi2nK;
    var $9KGzW;
    var $1C2Ux;
    var $5efdc39c8e0dee87$var$jiraPlanAriStaticOpts = {
        qualifier: "ari",
        platformQualifier: "cloud",
        cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
        resourceOwner: (0, (0, parcelRequire("fi2nK")).JiraPlanAriResourceOwner),
        resourceType: (0, (0, parcelRequire("fi2nK")).JiraPlanAriResourceType),
        resourceIdSlug: "activation/{activationId}/{planId}",
        resourceIdSegmentFormats: {
            activationId: /[a-zA-Z0-9\-]+/,
            planId: /[0-9]+/
        }
    };
    var $5efdc39c8e0dee87$export$6d2eb3641569f26 = class _JiraPlanAri extends (0, (0, parcelRequire("9KGzW")).RegisteredAri) {
        constructor(opts){
            super(opts);
            this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._planId = opts.resourceIdSegmentValues.planId;
        }
        get siteId() {
            return this._siteId;
        }
        get activationId() {
            return this._activationId;
        }
        get planId() {
            return this._planId;
        }
        static create(opts) {
            let derivedOpts = {
                qualifier: $5efdc39c8e0dee87$var$jiraPlanAriStaticOpts.qualifier,
                platformQualifier: $5efdc39c8e0dee87$var$jiraPlanAriStaticOpts.platformQualifier,
                cloudId: opts.siteId,
                resourceOwner: $5efdc39c8e0dee87$var$jiraPlanAriStaticOpts.resourceOwner,
                resourceType: $5efdc39c8e0dee87$var$jiraPlanAriStaticOpts.resourceType,
                resourceId: `activation/${opts.activationId}/${opts.planId}`,
                resourceIdSegmentValues: {
                    activationId: opts.activationId,
                    planId: opts.planId
                }
            }, ariOpts = (0, (0, parcelRequire("1C2Ux")).AriParser).fromOpts(derivedOpts, $5efdc39c8e0dee87$var$jiraPlanAriStaticOpts);
            return new _JiraPlanAri(ariOpts);
        }
        static parse(maybeAri) {
            let opts = (0, (0, parcelRequire("1C2Ux")).AriParser).fromString(maybeAri, $5efdc39c8e0dee87$var$jiraPlanAriStaticOpts);
            return new _JiraPlanAri(opts);
        }
        getVariables() {
            return {
                siteId: this.siteId,
                activationId: this.activationId,
                planId: this.planId
            };
        }
    };
});
parcelRegister("fi2nK", function(module, exports) {
    $parcel$export(module.exports, "JiraPlanAriResourceOwner", ()=>$b21a627cc548ba69$export$bfd26af3c5e1b90d);
    $parcel$export(module.exports, "JiraPlanAriResourceType", ()=>$b21a627cc548ba69$export$d6abe08eb30f433d);
    var $b21a627cc548ba69$export$bfd26af3c5e1b90d = "jira", $b21a627cc548ba69$export$d6abe08eb30f433d = "plan";
});
parcelRegister("j5YhT", function(module, exports) {
    $parcel$export(module.exports, "JiraProjectAri", ()=>$de6d3fcbf97a80dc$export$75a0a0a7cb0a58ae);
    var $FYyiD;
    var $9KGzW;
    var $1C2Ux;
    var $de6d3fcbf97a80dc$var$jiraProjectAriStaticOpts = {
        qualifier: "ari",
        platformQualifier: "cloud",
        cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
        resourceOwner: (0, (0, parcelRequire("FYyiD")).JiraProjectAriResourceOwner),
        resourceType: (0, (0, parcelRequire("FYyiD")).JiraProjectAriResourceType),
        resourceIdSlug: "{projectId}",
        resourceIdSegmentFormats: {
            projectId: /[0-9]+/
        }
    };
    var $de6d3fcbf97a80dc$export$75a0a0a7cb0a58ae = class _JiraProjectAri extends (0, (0, parcelRequire("9KGzW")).RegisteredAri) {
        constructor(opts){
            super(opts);
            this._siteId = opts.cloudId || "", this._projectId = opts.resourceIdSegmentValues.projectId;
        }
        get siteId() {
            return this._siteId;
        }
        get projectId() {
            return this._projectId;
        }
        static create(opts) {
            let derivedOpts = {
                qualifier: $de6d3fcbf97a80dc$var$jiraProjectAriStaticOpts.qualifier,
                platformQualifier: $de6d3fcbf97a80dc$var$jiraProjectAriStaticOpts.platformQualifier,
                cloudId: opts.siteId,
                resourceOwner: $de6d3fcbf97a80dc$var$jiraProjectAriStaticOpts.resourceOwner,
                resourceType: $de6d3fcbf97a80dc$var$jiraProjectAriStaticOpts.resourceType,
                resourceId: `${opts.projectId}`,
                resourceIdSegmentValues: {
                    projectId: opts.projectId
                }
            }, ariOpts = (0, (0, parcelRequire("1C2Ux")).AriParser).fromOpts(derivedOpts, $de6d3fcbf97a80dc$var$jiraProjectAriStaticOpts);
            return new _JiraProjectAri(ariOpts);
        }
        static parse(maybeAri) {
            let opts = (0, (0, parcelRequire("1C2Ux")).AriParser).fromString(maybeAri, $de6d3fcbf97a80dc$var$jiraProjectAriStaticOpts);
            return new _JiraProjectAri(opts);
        }
        getVariables() {
            return {
                siteId: this.siteId,
                projectId: this.projectId
            };
        }
    };
});
parcelRegister("FYyiD", function(module, exports) {
    $parcel$export(module.exports, "JiraProjectAriResourceOwner", ()=>$07e2ccdc15c7364e$export$99d538a3b04916b1);
    $parcel$export(module.exports, "JiraProjectAriResourceType", ()=>$07e2ccdc15c7364e$export$736763838d3aa22e);
    var $07e2ccdc15c7364e$export$99d538a3b04916b1 = "jira", $07e2ccdc15c7364e$export$736763838d3aa22e = "project";
});
parcelRegister("1pgoX", function(module, exports) {
    $parcel$export(module.exports, "NotificationLogClient", ()=>(parcelRequire("5s0dN")).default);
    var $5s0dN = parcelRequire("5s0dN");
});
parcelRegister("5s0dN", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$bc40da511b16d48e$export$2e2bcd8739ae039);
    var $dS9cn = parcelRequire("dS9cn");
    const $bc40da511b16d48e$export$b055de0e665cb20c = 'atlaskitNotificationLogClient';
    class $bc40da511b16d48e$export$2e2bcd8739ae039 {
        constructor(baseUrl, cloudId, source = $bc40da511b16d48e$export$b055de0e665cb20c){
            this.serviceConfig = {
                url: baseUrl
            };
            this.cloudId = cloudId;
            this.source = source;
        }
        async countUnseenNotifications(options = {}) {
            const mergedOptions = {
                path: '/api/3/notifications/count/unseen',
                ...options,
                queryParams: {
                    ...this.cloudId && {
                        cloudId: this.cloudId
                    },
                    source: this.source,
                    ...options.queryParams || {}
                },
                requestInit: {
                    mode: 'cors',
                    headers: {
                        'x-app-version': `${"0.0.0-use.local"}-${$bc40da511b16d48e$export$b055de0e665cb20c}`
                    },
                    ...options.requestInit || {}
                }
            };
            return (0, $dS9cn.utils).requestService(this.serviceConfig, mergedOptions);
        }
    }
});
parcelRegister("hYRTO", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4c991245d2b4e078$export$2e2bcd8739ae039);
    var $4yzdo;
    var $4c991245d2b4e078$export$2e2bcd8739ae039 = (0, (0, parcelRequire("4yzdo")).default);
});
parcelRegister("4yzdo", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$622bc2f4e61c3830$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $fNobW;
    var $3IRJU;
    var $kkxr3;
    function $622bc2f4e61c3830$export$2e2bcd8739ae039({ name: name, children: children, fallback: fallback = null }) {
        const waitContext = (0, $5uXOq.useContext)((0, (0, parcelRequire("kkxr3")).WaitContext));
        const shouldHold = !waitContext || !!waitContext.currentValue();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3IRJU")).LazySuspense), {
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, fallback, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fNobW")).default), {
                name: name,
                hold: shouldHold
            })),
            name: name
        }, children);
    }
});
parcelRegister("3IRJU", function(module, exports) {
    $parcel$export(module.exports, "LazySuspense", ()=>$3a440dc8cf81cf35$export$256c542058532d6f);
    var $5uXOq = parcelRequire("5uXOq");
    const $3a440dc8cf81cf35$var$isNodeEnvironment = ()=>{
        return typeof window === 'undefined' || window.name === 'nodejs';
    };
    const $3a440dc8cf81cf35$var$LazySuspenseContext = (0, $5uXOq.createContext)({
        fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Fragment), null),
        setFallback: ()=>{
            console.warn('Missing <LooselySuspense /> boundary');
        },
        name: ''
    });
    const $3a440dc8cf81cf35$var$DynamicFallback = ({ children: children, outsideSuspense: outsideSuspense })=>{
        const { fallback: fallback, setFallback: setFallback } = (0, ($parcel$interopDefault($5uXOq))).useContext($3a440dc8cf81cf35$var$LazySuspenseContext);
        (0, $5uXOq.useLayoutEffect)(()=>{
            return ()=>{
                if (!outsideSuspense) setFallback(null);
            };
        }, [
            outsideSuspense,
            setFallback
        ]);
        return children(outsideSuspense ? null : fallback);
    };
    $3a440dc8cf81cf35$var$DynamicFallback.displayName = 'DynamicFallback';
    const $3a440dc8cf81cf35$export$256c542058532d6f = ({ fallback: fallback, children: children, name: name })=>{
        const [hydrationFallback, setHydrationFallback] = (0, $5uXOq.useState)(null);
        const mountedRef = (0, $5uXOq.useRef)(false);
        (0, $5uXOq.useLayoutEffect)(()=>{
            mountedRef.current = true;
            return ()=>{
                mountedRef.current = false;
            };
        }, []);
        const contextValue = (0, $5uXOq.useMemo)(()=>({
                fallback: fallback,
                setFallback: (newFallback)=>{
                    if (hydrationFallback === newFallback) return;
                    setHydrationFallback(newFallback);
                },
                name: name
            }), [
            fallback,
            hydrationFallback,
            name
        ]);
        const renderFallback = (outsideSuspense)=>(0, ($parcel$interopDefault($5uXOq))).createElement($3a440dc8cf81cf35$var$DynamicFallback, {
                outsideSuspense: outsideSuspense
            }, (resolvedFallback)=>outsideSuspense && hydrationFallback ? hydrationFallback : resolvedFallback);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($3a440dc8cf81cf35$var$LazySuspenseContext.Provider, {
            value: contextValue
        }, $3a440dc8cf81cf35$var$isNodeEnvironment() ? children : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Suspense), {
            fallback: renderFallback(false)
        }, children), (!mountedRef.current || hydrationFallback) && renderFallback(true)));
    };
    $3a440dc8cf81cf35$export$256c542058532d6f.displayName = 'LazySuspense';
});
parcelRegister("kkxr3", function(module, exports) {
    $parcel$export(module.exports, "WaitContext", ()=>$68c2fcae5074d5f5$export$9ba3fe09d15de47b);
    var $5uXOq = parcelRequire("5uXOq");
    const $68c2fcae5074d5f5$export$9ba3fe09d15de47b = (0, $5uXOq.createContext)({
        subscribe: ()=>()=>{},
        currentValue: ()=>1
    });
});
parcelRegister("kc9vJ", function(module, exports) {
    $parcel$export(module.exports, "lazyForPaint", ()=>(parcelRequire("8DfXF")).lazyForPaint);
    $parcel$export(module.exports, "lazyAfterPaint", ()=>(parcelRequire("8DfXF")).lazyAfterPaint);
    $parcel$export(module.exports, "lazy", ()=>(parcelRequire("8DfXF")).lazy);
    $parcel$export(module.exports, "LazySuspense", ()=>(parcelRequire("ihijj")).LazySuspense);
    $parcel$export(module.exports, "useLazyPhase", ()=>(parcelRequire("7j6wR")).useLazyPhase);
    parcelRequire("9tT5O");
    var $0431B = parcelRequire("0431B");
    var $bh45B = parcelRequire("bh45B");
    var $8DfXF = parcelRequire("8DfXF");
    parcelRequire("3iU61");
    var $8gCAq = parcelRequire("8gCAq");
    var $hxt6y = parcelRequire("hxt6y");
    parcelRequire("41yqT");
    var $ihijj = parcelRequire("ihijj");
    parcelRequire("1Cn7k");
    var $7j6wR = parcelRequire("7j6wR");
    var $lUR7e = parcelRequire("lUR7e");
});
parcelRegister("9tT5O", function(module, exports) {
    $parcel$export(module.exports, "getConfig", ()=>$6e718ebf0a3d5ffc$export$44487a86467333c3);
    $parcel$export(module.exports, "setConfig", ()=>$6e718ebf0a3d5ffc$export$940a7873bb071df8);
    $parcel$export(module.exports, "MODE", ()=>(parcelRequire("0431B")).MODE);
    var $0431B = parcelRequire("0431B");
    const $6e718ebf0a3d5ffc$var$DEFAULT_CROSS_ORIGIN = undefined;
    const $6e718ebf0a3d5ffc$var$DEFAULT_MANIFEST = {
        publicPath: '/',
        assets: {}
    };
    const $6e718ebf0a3d5ffc$var$DEFAULT_MODE = (0, $0431B.MODE).HYDRATE;
    const $6e718ebf0a3d5ffc$var$DEFAULT_RETRY = 2;
    const $6e718ebf0a3d5ffc$var$config = {
        crossOrigin: $6e718ebf0a3d5ffc$var$DEFAULT_CROSS_ORIGIN,
        manifest: $6e718ebf0a3d5ffc$var$DEFAULT_MANIFEST,
        mode: $6e718ebf0a3d5ffc$var$DEFAULT_MODE,
        retry: $6e718ebf0a3d5ffc$var$DEFAULT_RETRY
    };
    const $6e718ebf0a3d5ffc$export$44487a86467333c3 = ()=>$6e718ebf0a3d5ffc$var$config;
    const $6e718ebf0a3d5ffc$export$940a7873bb071df8 = (nextConfig)=>{
        var _nextConfig$crossOrig, _nextConfig$manifest, _nextConfig$mode, _nextConfig$retry;
        $6e718ebf0a3d5ffc$var$config.crossOrigin = (_nextConfig$crossOrig = nextConfig.crossOrigin) != null ? _nextConfig$crossOrig : $6e718ebf0a3d5ffc$var$DEFAULT_CROSS_ORIGIN;
        $6e718ebf0a3d5ffc$var$config.manifest = (_nextConfig$manifest = nextConfig.manifest) != null ? _nextConfig$manifest : $6e718ebf0a3d5ffc$var$DEFAULT_MANIFEST;
        $6e718ebf0a3d5ffc$var$config.mode = (_nextConfig$mode = nextConfig.mode) != null ? _nextConfig$mode : $6e718ebf0a3d5ffc$var$DEFAULT_MODE;
        $6e718ebf0a3d5ffc$var$config.retry = (_nextConfig$retry = nextConfig.retry) != null ? _nextConfig$retry : $6e718ebf0a3d5ffc$var$DEFAULT_RETRY;
    };
});
parcelRegister("0431B", function(module, exports) {
    $parcel$export(module.exports, "MODE", ()=>$00c2b881b8fbcee5$export$e48589d9e4824227);
    const $00c2b881b8fbcee5$export$e48589d9e4824227 = {
        RENDER: 'RENDER',
        HYDRATE: 'HYDRATE'
    };
});
parcelRegister("bh45B", function(module, exports) {
    var $PZ2tE = parcelRequire("PZ2tE");
    var $9tT5O = parcelRequire("9tT5O");
    parcelRequire("1Cn7k");
    var $7BvXL = parcelRequire("7BvXL");
    var $7j6wR = parcelRequire("7j6wR");
    var $fEDkH = parcelRequire("fEDkH");
    const $83547451e376d6d0$export$33c5f161e1d4706 = {
        init: (config)=>{
            (0, $9tT5O.setConfig)(config);
            (0, $7BvXL.LISTENERS).length = 0;
            (0, $7j6wR.setCurrent)(0);
            if (!(0, $fEDkH.isNodeEnvironment)()) (0, $PZ2tE.collect)();
        }
    };
});
parcelRegister("PZ2tE", function(module, exports) {
    $parcel$export(module.exports, "collect", ()=>$09c41c99821e965e$export$bb44f104e3c54dae);
    var $9tT5O = parcelRequire("9tT5O");
    var $0431B = parcelRequire("0431B");
    var $gRvGe = parcelRequire("gRvGe");
    var $cIwb8 = parcelRequire("cIwb8");
    var $916oJ = parcelRequire("916oJ");
    const $09c41c99821e965e$export$bb44f104e3c54dae = ()=>{
        const markers = document.querySelectorAll('input[data-lazy-begin]');
        const { mode: mode } = (0, $9tT5O.getConfig)();
        for(let i = 0, j = markers.length; i < j; i += 1){
            const el = markers[i];
            const { lazyBegin: lazyBegin } = el.dataset || {};
            const value = mode === (0, $0431B.MODE).RENDER ? (0, $cIwb8.cloneElements)(markers[i], lazyBegin) : (0, $916oJ.refElements)(markers[i], lazyBegin);
            if ((0, $gRvGe.COLLECTED).has(lazyBegin)) (0, $gRvGe.COLLECTED).get(lazyBegin).push(value);
            else (0, $gRvGe.COLLECTED).set(lazyBegin, [
                value
            ]);
        }
    };
});
parcelRegister("gRvGe", function(module, exports) {
    $parcel$export(module.exports, "PHASE", ()=>$c46a2b9a383e79ee$export$2cc7a2eaaea7809f);
    $parcel$export(module.exports, "COLLECTED", ()=>$c46a2b9a383e79ee$export$4831ef3968ea94ef);
    const $c46a2b9a383e79ee$export$2cc7a2eaaea7809f = {
        PAINT: 0,
        AFTER_PAINT: 1,
        LAZY: 2
    };
    const $c46a2b9a383e79ee$export$4831ef3968ea94ef = new Map();
});
parcelRegister("cIwb8", function(module, exports) {
    $parcel$export(module.exports, "cloneElements", ()=>$94228e13ffd964de$export$c42217d53a7ebafb);
    const $94228e13ffd964de$export$c42217d53a7ebafb = (fromEl, id)=>{
        const fragment = document.createElement('div');
        let el = fromEl;
        while(el = el.nextSibling){
            if (el.dataset && el.dataset.lazyEnd === id) break;
            fragment.appendChild(el.cloneNode(true));
        }
        return Array.from(fragment.childNodes);
    };
});
parcelRegister("916oJ", function(module, exports) {
    $parcel$export(module.exports, "refElements", ()=>$69092b84bd4d8839$export$c69443129766a7fc);
    const $69092b84bd4d8839$export$c69443129766a7fc = (fromEl, id)=>{
        const result = [];
        let el = fromEl;
        while(el = el.nextSibling){
            if (el.dataset && el.dataset.lazyEnd === id) break;
            result.push(el);
        }
        return result;
    };
});
parcelRegister("1Cn7k", function(module, exports) {
    $parcel$export(module.exports, "LazyPhaseContext", ()=>(parcelRequire("7j6wR")).LazyPhaseContext);
    $parcel$export(module.exports, "setCurrent", ()=>(parcelRequire("7j6wR")).setCurrent);
    $parcel$export(module.exports, "useLazyPhase", ()=>(parcelRequire("7j6wR")).useLazyPhase);
    $parcel$export(module.exports, "LISTENERS", ()=>(parcelRequire("7BvXL")).LISTENERS);
    var $7j6wR = parcelRequire("7j6wR");
    var $7BvXL = parcelRequire("7BvXL");
    var $hLAzE = parcelRequire("hLAzE");
});
parcelRegister("7j6wR", function(module, exports) {
    $parcel$export(module.exports, "setCurrent", ()=>$551f5f4ab1e13682$export$5f80f094fd31fffd);
    $parcel$export(module.exports, "LazyPhaseContext", ()=>$551f5f4ab1e13682$export$5a25eca35e5debcb);
    $parcel$export(module.exports, "useLazyPhase", ()=>$551f5f4ab1e13682$export$1dc361b277327f88);
    var $5uXOq = parcelRequire("5uXOq");
    var $gRvGe = parcelRequire("gRvGe");
    var $7BvXL = parcelRequire("7BvXL");
    var $hLAzE = parcelRequire("hLAzE");
    let $551f5f4ab1e13682$var$CURRENT_PHASE = (0, $gRvGe.PHASE).PAINT;
    const $551f5f4ab1e13682$export$5f80f094fd31fffd = (phase)=>{
        $551f5f4ab1e13682$var$CURRENT_PHASE = phase;
        (0, $7BvXL.LISTENERS).slice(0).forEach((listener)=>listener(phase));
    };
    const $551f5f4ab1e13682$export$5a25eca35e5debcb = (0, $5uXOq.createContext)({
        subscribe: (0, $hLAzE.createSubscribe)((0, $7BvXL.LISTENERS)),
        currentValue: ()=>$551f5f4ab1e13682$var$CURRENT_PHASE,
        api: {
            startNextPhase: ()=>{
                $551f5f4ab1e13682$export$5f80f094fd31fffd((0, $gRvGe.PHASE).AFTER_PAINT);
            },
            resetPhase: ()=>$551f5f4ab1e13682$export$5f80f094fd31fffd((0, $gRvGe.PHASE).PAINT)
        }
    });
    const $551f5f4ab1e13682$export$1dc361b277327f88 = ()=>{
        const v = (0, $5uXOq.useContext)($551f5f4ab1e13682$export$5a25eca35e5debcb);
        return v.api;
    };
});
parcelRegister("7BvXL", function(module, exports) {
    $parcel$export(module.exports, "LISTENERS", ()=>$5894c846af183bf2$export$81b9c458a026d68f);
    const $5894c846af183bf2$export$81b9c458a026d68f = [];
});
parcelRegister("hLAzE", function(module, exports) {
    $parcel$export(module.exports, "createSubscribe", ()=>$cef3324da336be99$export$364097d812234b3f);
    const $cef3324da336be99$export$364097d812234b3f = (listeners)=>(listener)=>{
            listeners.push(listener);
            return ()=>{
                const index = listeners.indexOf(listener);
                if (index !== -1) listeners.splice(index, 1);
            };
        };
});
parcelRegister("fEDkH", function(module, exports) {
    $parcel$export(module.exports, "getExport", ()=>$b6591a2169faf79a$export$d4c07b1daf44a7f);
    $parcel$export(module.exports, "displayNameFromId", ()=>$b6591a2169faf79a$export$4429f98ef60d2d87);
    $parcel$export(module.exports, "isNodeEnvironment", ()=>$b6591a2169faf79a$export$283635c04a02cc36);
    $parcel$export(module.exports, "attrToProp", ()=>$b6591a2169faf79a$export$62bf630d0de3d781);
    $parcel$export(module.exports, "hash", ()=>(parcelRequire("i0Mqq")).default);
    var $i0Mqq = parcelRequire("i0Mqq");
    const $b6591a2169faf79a$export$d4c07b1daf44a7f = (m)=>'default' in m ? m.default : m;
    const $b6591a2169faf79a$export$4429f98ef60d2d87 = (id)=>{
        const fName = id.split('/').slice(-3).join('/');
        return fName || 'Component';
    };
    const $b6591a2169faf79a$export$283635c04a02cc36 = ()=>{
        if (typeof window === 'undefined') return true;
        if (window.name === 'nodejs') return true;
        return false;
    };
    function $b6591a2169faf79a$export$62bf630d0de3d781(props, attr) {
        switch(attr.name){
            case 'style':
                break;
            case 'class':
                props.className = attr.value;
                break;
            case 'crossorigin':
                props.crossOrigin = attr.value;
                break;
            default:
                props[attr.name] = attr.value;
        }
        return props;
    }
});
parcelRegister("i0Mqq", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d1cdca4fd0ee8fb9$export$2e2bcd8739ae039);
    function $d1cdca4fd0ee8fb9$export$2e2bcd8739ae039(str) {
        var l = str.length, h = l ^ l, i = 0, k;
        while(l >= 4){
            k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
            k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
            k ^= k >>> 24;
            k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
            h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16) ^ k;
            l -= 4;
            ++i;
        }
        switch(l){
            case 3:
                h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
            case 2:
                h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
            case 1:
                h ^= str.charCodeAt(i) & 0xff;
                h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
        }
        h ^= h >>> 13;
        h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
        h ^= h >>> 15;
        return (h >>> 0).toString(36);
    }
});
parcelRegister("8DfXF", function(module, exports) {
    $parcel$export(module.exports, "lazyForPaint", ()=>$648e58dc5a799d99$export$c952e5f94576010e);
    $parcel$export(module.exports, "lazyAfterPaint", ()=>$648e58dc5a799d99$export$291dd592399bdafa);
    $parcel$export(module.exports, "lazy", ()=>$648e58dc5a799d99$export$488013bae63b21da);
    var $3aJOa;
    var $9tT5O = parcelRequire("9tT5O");
    var $gRvGe = parcelRequire("gRvGe");
    var $fEDkH = parcelRequire("fEDkH");
    var $i0Mqq = parcelRequire("i0Mqq");
    var $9Ww7D = parcelRequire("9Ww7D");
    var $eqm16 = parcelRequire("eqm16");
    var $3ro9P = parcelRequire("3ro9P");
    var $5pJCH = parcelRequire("5pJCH");
    var $2LsHW = parcelRequire("2LsHW");
    var $gNYzn = parcelRequire("gNYzn");
    var $gI8wo = parcelRequire("gI8wo");
    function $648e58dc5a799d99$var$_extends() {
        $648e58dc5a799d99$var$_extends = Object.assign || function(target) {
            for(var i = 1; i < arguments.length; i++){
                var source = arguments[i];
                for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
            }
            return target;
        };
        return $648e58dc5a799d99$var$_extends.apply(this, arguments);
    }
    function $648e58dc5a799d99$var$lazyProxy(_loader, { defer: defer = (0, $gRvGe.PHASE).PAINT, moduleId: moduleId = '', ssr: ssr = true } = {}) {
        const isServer = (0, $fEDkH.isNodeEnvironment)();
        const dataLazyId = (0, $i0Mqq.default)(moduleId);
        const LazyInternal = isServer ? (0, $3ro9P.createComponentServer)({
            dataLazyId: dataLazyId,
            defer: defer,
            loader: _loader,
            moduleId: moduleId,
            ssr: ssr
        }) : (0, $eqm16.createComponentClient)({
            dataLazyId: dataLazyId,
            defer: defer,
            deferred: (0, $5pJCH.createDeferred)({
                loader: ()=>{
                    const { retry: maxAttempts } = (0, $9tT5O.getConfig)();
                    return (0, $gNYzn.retry)(_loader, {
                        delay: (0, $9Ww7D.RETRY_DELAY),
                        factor: (0, $9Ww7D.RETRY_FACTOR),
                        maxAttempts: maxAttempts
                    });
                },
                preload: _loader
            }),
            moduleId: moduleId
        });
        LazyInternal.displayName = `Lazy(${(0, $fEDkH.displayNameFromId)(moduleId)})`;
        const getAssetUrls = ()=>{
            const { manifest: manifest } = (0, $9tT5O.getConfig)();
            return (0, (0, parcelRequire("3aJOa")).getAssetUrlsFromId)(manifest, moduleId);
        };
        const preload = (priority)=>{
            const p = priority != null ? priority : defer === (0, $gRvGe.PHASE).PAINT ? (0, $9Ww7D.PRIORITY).HIGH : (0, $9Ww7D.PRIORITY).LOW;
            return (0, $2LsHW.preloadAsset)({
                loader: _loader,
                moduleId: moduleId,
                priority: p
            });
        };
        return Object.assign(LazyInternal, {
            getAssetUrls: getAssetUrls,
            preload: preload
        });
    }
    const $648e58dc5a799d99$export$93ca5d3f8675ae4c = {
        lazyForPaint: {
            ssr: true,
            defer: (0, $gRvGe.PHASE).PAINT
        },
        lazyAfterPaint: {
            ssr: true,
            defer: (0, $gRvGe.PHASE).AFTER_PAINT
        },
        lazy: {
            ssr: false,
            defer: (0, $gRvGe.PHASE).LAZY
        }
    };
    function $648e58dc5a799d99$export$c952e5f94576010e(loader, opts) {
        return $648e58dc5a799d99$var$lazyProxy(loader, $648e58dc5a799d99$var$_extends({}, $648e58dc5a799d99$export$93ca5d3f8675ae4c.lazyForPaint, opts || {}));
    }
    function $648e58dc5a799d99$export$291dd592399bdafa(loader, opts) {
        return $648e58dc5a799d99$var$lazyProxy(loader, $648e58dc5a799d99$var$_extends({}, $648e58dc5a799d99$export$93ca5d3f8675ae4c.lazyAfterPaint, opts || {}));
    }
    function $648e58dc5a799d99$export$488013bae63b21da(loader, opts) {
        return $648e58dc5a799d99$var$lazyProxy(loader, $648e58dc5a799d99$var$_extends({}, $648e58dc5a799d99$export$93ca5d3f8675ae4c.lazy, opts || {}));
    }
});
parcelRegister("3aJOa", function(module, exports) {
    $parcel$export(module.exports, "getAssetUrlsFromId", ()=>$24f5d6cbe7374307$export$303f43e55cf1ef2f);
    const $24f5d6cbe7374307$export$303f43e55cf1ef2f = (manifest, id)=>{
        if (!manifest.assets || !manifest.assets[id]) return;
        return manifest.assets[id].map((asset)=>`${manifest.publicPath}${asset}`);
    };
});
parcelRegister("9Ww7D", function(module, exports) {
    $parcel$export(module.exports, "PRIORITY", ()=>$73d2729ff937408e$export$bb34f3538ba26c7e);
    $parcel$export(module.exports, "RETRY_DELAY", ()=>$73d2729ff937408e$export$a339266ad71b2447);
    $parcel$export(module.exports, "RETRY_FACTOR", ()=>$73d2729ff937408e$export$ba64c908e55507fe);
    const $73d2729ff937408e$export$bb34f3538ba26c7e = {
        HIGH: 0,
        LOW: 2
    };
    const $73d2729ff937408e$export$a339266ad71b2447 = 300;
    const $73d2729ff937408e$export$ba64c908e55507fe = 1;
});
parcelRegister("eqm16", function(module, exports) {
    $parcel$export(module.exports, "createComponentClient", ()=>$a804927df56ebdb2$export$6898b5504b58699a);
    var $5uXOq = parcelRequire("5uXOq");
    var $9tT5O = parcelRequire("9tT5O");
    var $0431B = parcelRequire("0431B");
    var $gRvGe = parcelRequire("gRvGe");
    parcelRequire("3iU61");
    var $hxt6y = parcelRequire("hxt6y");
    parcelRequire("1Cn7k");
    var $7j6wR = parcelRequire("7j6wR");
    parcelRequire("41yqT");
    var $7t9v5 = parcelRequire("7t9v5");
    var $gI8wo = parcelRequire("gI8wo");
    var $b1mtW = parcelRequire("b1mtW");
    var $2uJW6 = parcelRequire("2uJW6");
    var $lUR7e = parcelRequire("lUR7e");
    var $k8XtJ = parcelRequire("k8XtJ");
    function $a804927df56ebdb2$export$6898b5504b58699a({ defer: defer, deferred: deferred, dataLazyId: dataLazyId, moduleId: moduleId }) {
        const ResolvedLazy = (0, $5uXOq.lazy)(()=>deferred.promise);
        return (props)=>{
            const [status, bubbleError] = (0, $5uXOq.useState)(()=>({
                    noWait: undefined,
                    phase: defer === (0, $gRvGe.PHASE).AFTER_PAINT ? false : true,
                    preloaded: defer === (0, $gRvGe.PHASE).AFTER_PAINT ? false : true,
                    started: false
                }));
            const profiler = (0, $5uXOq.useContext)((0, $lUR7e.ProfilerContext)).current;
            const load = ()=>{
                if (status.started || !status.phase || !status.noWait) return;
                status.started = true;
                let onResolve;
                if (profiler) {
                    const eventInfo = {
                        identifier: moduleId
                    };
                    onResolve = ()=>{
                        profiler.onLoadComplete(eventInfo);
                    };
                    profiler.onLoadStart(eventInfo);
                }
                const result = deferred.start().catch((err)=>{
                    bubbleError(()=>{
                        throw (0, $gI8wo.createLoaderError)(err);
                    });
                });
                if (onResolve) result.then(onResolve);
            };
            (0, $k8XtJ.useSubscription)({
                context: (0, $hxt6y.WaitContext),
                load: load,
                onValue: (v)=>status.noWait = v === 1
            });
            if (defer === (0, $gRvGe.PHASE).AFTER_PAINT) (0, $k8XtJ.useSubscription)({
                context: (0, $7j6wR.LazyPhaseContext),
                load: load,
                onValue: (v)=>status.phase = v >= defer
            });
            const { setFallback: setFallback } = (0, $5uXOq.useContext)((0, $7t9v5.LazySuspenseContext));
            (0, $5uXOq.useMemo)(()=>{
                const content = ((0, $gRvGe.COLLECTED).get(dataLazyId) || []).shift();
                if (!content) return;
                const component = (0, $9tT5O.getConfig)().mode === (0, $0431B.MODE).RENDER ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, $b1mtW.PlaceholderFallbackRender), {
                    id: dataLazyId,
                    content: content
                }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, $2uJW6.PlaceholderFallbackHydrate), {
                    id: dataLazyId,
                    content: content
                });
                setFallback(component);
            }, [
                setFallback
            ]);
            return (0, ($parcel$interopDefault($5uXOq))).createElement(ResolvedLazy, props);
        };
    }
});
parcelRegister("3iU61", function(module, exports) {
    $parcel$export(module.exports, "WaitContext", ()=>(parcelRequire("hxt6y")).WaitContext);
    var $hxt6y = parcelRequire("hxt6y");
    var $8gCAq = parcelRequire("8gCAq");
});
parcelRegister("hxt6y", function(module, exports) {
    $parcel$export(module.exports, "WaitContext", ()=>$cc4c1850a13fcdaa$export$9ba3fe09d15de47b);
    var $5uXOq = parcelRequire("5uXOq");
    var $3Sq3c = parcelRequire("3Sq3c");
    const $cc4c1850a13fcdaa$export$9ba3fe09d15de47b = (0, $5uXOq.createContext)({
        subscribe: ()=>(0, $3Sq3c.noopCleanup),
        currentValue: ()=>1
    });
});
parcelRegister("3Sq3c", function(module, exports) {
    $parcel$export(module.exports, "noopCleanup", ()=>$2d2a9f5ddab5681f$export$276c7dbda7675aec);
    const $2d2a9f5ddab5681f$export$276c7dbda7675aec = ()=>{};
});
parcelRegister("8gCAq", function(module, exports) {
    var $5uXOq = parcelRequire("5uXOq");
    var $hxt6y = parcelRequire("hxt6y");
    const $604dbfd3e71469c9$export$7bf6cf03fd32cddb = ({ until: until, children: children })=>{
        const closestWait = (0, $5uXOq.useContext)((0, $hxt6y.WaitContext));
        const value = (0, $5uXOq.useRef)(until && closestWait.currentValue() ? 1 : 0);
        const subscribers = (0, $5uXOq.useRef)(new Set());
        const api = (0, $5uXOq.useRef)({
            subscribe: (subscriber)=>{
                subscribers.current.add(subscriber);
                return ()=>{
                    subscribers.current.delete(subscriber);
                };
            },
            currentValue: ()=>value.current
        });
        (0, $5uXOq.useEffect)(()=>{
            const notify = ()=>{
                value.current = closestWait.currentValue() && until ? 1 : 0;
                subscribers.current.forEach((subscriber)=>subscriber());
            };
            notify();
            return closestWait.subscribe(notify);
        }, [
            closestWait,
            until
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $hxt6y.WaitContext).Provider, {
            value: api.current
        }, children);
    };
});
parcelRegister("41yqT", function(module, exports) {
    $parcel$export(module.exports, "LazySuspense", ()=>(parcelRequire("ihijj")).LazySuspense);
    $parcel$export(module.exports, "LazySuspenseContext", ()=>(parcelRequire("7t9v5")).LazySuspenseContext);
    var $ihijj = parcelRequire("ihijj");
    var $7t9v5 = parcelRequire("7t9v5");
});
parcelRegister("ihijj", function(module, exports) {
    $parcel$export(module.exports, "LazySuspense", ()=>$d4e8049b2be3a01c$export$256c542058532d6f);
    var $5uXOq = parcelRequire("5uXOq");
    var $fEDkH = parcelRequire("fEDkH");
    var $7t9v5 = parcelRequire("7t9v5");
    class $d4e8049b2be3a01c$export$256c542058532d6f extends (0, $5uXOq.Component) {
        constructor(props){
            super(props);
            this.state = {
                fallback: this.props.fallback,
                setFallback: (fallback)=>{
                    if (this.hydrationFallback === fallback) return;
                    this.hydrationFallback = fallback;
                    if (this.mounted) this.forceUpdate();
                },
                name: this.props.name
            };
            this.hydrationFallback = null;
            this.mounted = false;
            this.DynamicFallback = ({ children: children, outsideSuspense: outsideSuspense })=>{
                (0, $5uXOq.useLayoutEffect)(()=>{
                    return ()=>{
                        if (!outsideSuspense) this.state.setFallback(null);
                    };
                }, [
                    outsideSuspense
                ]);
                return outsideSuspense ? children(this.hydrationFallback ? this.hydrationFallback : null) : children(this.hydrationFallback ? null : this.props.fallback);
            };
            this.DynamicFallback.displayName = 'DynamicFallback';
        }
        componentDidMount() {
            this.mounted = true;
        }
        renderFallback(outsideSuspense) {
            const { DynamicFallback: DynamicFallback } = this;
            return (0, ($parcel$interopDefault($5uXOq))).createElement(DynamicFallback, {
                outsideSuspense: outsideSuspense
            }, (fallback)=>fallback);
        }
        renderServer() {
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $7t9v5.LazySuspenseContext).Provider, {
                value: this.state
            }, this.props.children);
        }
        renderClient() {
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $7t9v5.LazySuspenseContext).Provider, {
                value: this.state
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Suspense), {
                fallback: this.renderFallback(false)
            }, this.props.children), (!this.mounted || this.hydrationFallback) && this.renderFallback(true));
        }
        render() {
            return (0, $fEDkH.isNodeEnvironment)() ? this.renderServer() : this.renderClient();
        }
    }
});
parcelRegister("7t9v5", function(module, exports) {
    $parcel$export(module.exports, "LazySuspenseContext", ()=>$57029c6f61e78061$export$c33990e84065970c);
    var $5uXOq = parcelRequire("5uXOq");
    const $57029c6f61e78061$export$c33990e84065970c = (0, $5uXOq.createContext)({
        fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Fragment), null),
        setFallback: ()=>{
            console.warn('Missing <LooselySuspense /> boundary');
        }
    });
});
parcelRegister("gI8wo", function(module, exports) {
    $parcel$export(module.exports, "createLoaderError", ()=>$c2a75d9d2b1d4ac6$export$c73a6a6f0bf7d425);
    const $c2a75d9d2b1d4ac6$export$6aa69c1258005366 = Symbol.for('react-loosely-lazy/loader-error');
    const $c2a75d9d2b1d4ac6$export$c73a6a6f0bf7d425 = (error)=>{
        if (typeof error === 'object') return Object.assign(error, {
            [$c2a75d9d2b1d4ac6$export$6aa69c1258005366]: true
        });
        return error;
    };
    const $c2a75d9d2b1d4ac6$export$16a03aca4a3508b4 = (error)=>Object.getOwnPropertySymbols(error).includes($c2a75d9d2b1d4ac6$export$6aa69c1258005366);
});
parcelRegister("b1mtW", function(module, exports) {
    $parcel$export(module.exports, "PlaceholderFallbackRender", ()=>$80613a2b6be8c4b1$export$d55db778a3e1446b);
    var $5uXOq = parcelRequire("5uXOq");
    var $lUR7e = parcelRequire("lUR7e");
    parcelRequire("3iU61");
    var $hxt6y = parcelRequire("hxt6y");
    parcelRequire("41yqT");
    var $7t9v5 = parcelRequire("7t9v5");
    function $80613a2b6be8c4b1$var$isLinkPrefetch(el) {
        return el.tagName === 'LINK' && el.rel === 'prefetch';
    }
    const $80613a2b6be8c4b1$var$usePlaceholderRender = (resolveId, content)=>{
        const hydrationRef = (0, $5uXOq.useRef)(null);
        const { current: ssrDomNodes } = (0, $5uXOq.useRef)(content || []);
        const profilerContext = (0, $5uXOq.useContext)((0, $lUR7e.ProfilerContext)).current;
        const waitContext = (0, $5uXOq.useContext)((0, $hxt6y.WaitContext));
        const suspenseContext = (0, $5uXOq.useContext)((0, $7t9v5.LazySuspenseContext));
        (0, $5uXOq.useLayoutEffect)(()=>{
            const element = hydrationRef.current;
            const { parentNode: parentNode } = element || {};
            profilerContext === null || profilerContext.placeholderFallBackMounted(resolveId, suspenseContext.name, !waitContext.currentValue());
            if (parentNode && !parentNode.contains(ssrDomNodes[0])) ssrDomNodes.reverse().forEach((node)=>{
                if ($80613a2b6be8c4b1$var$isLinkPrefetch(node)) node.rel = '';
                parentNode.insertBefore(node, element.nextSibling);
            });
            return ()=>{
                profilerContext === null || profilerContext.placeholderFallBackUnmounted(resolveId, suspenseContext.name, !waitContext.currentValue());
                ssrDomNodes.forEach((node)=>{
                    var _node$parentNode;
                    return (_node$parentNode = node.parentNode) == null ? void 0 : _node$parentNode.removeChild(node);
                });
            };
        }, []);
        return hydrationRef;
    };
    const $80613a2b6be8c4b1$export$d55db778a3e1446b = ({ id: id, content: content })=>{
        const placeholderRef = $80613a2b6be8c4b1$var$usePlaceholderRender(id, content);
        return (0, ($parcel$interopDefault($5uXOq))).createElement("input", {
            type: "hidden",
            "data-lazy-begin": id,
            ref: placeholderRef
        });
    };
});
parcelRegister("lUR7e", function(module, exports) {
    $parcel$export(module.exports, "GlobalReactLooselyLazyProfiler", ()=>$ff4807977d1ff541$export$e2d53c0cbedd2710);
    $parcel$export(module.exports, "ProfilerContext", ()=>$ff4807977d1ff541$export$8146ab57a3f7a7cb);
    var $5uXOq = parcelRequire("5uXOq");
    const $ff4807977d1ff541$export$e2d53c0cbedd2710 = {
        current: null
    };
    const $ff4807977d1ff541$export$8146ab57a3f7a7cb = (0, $5uXOq.createContext)($ff4807977d1ff541$export$e2d53c0cbedd2710);
});
parcelRegister("2uJW6", function(module, exports) {
    $parcel$export(module.exports, "PlaceholderFallbackHydrate", ()=>$1d1204150993c3dd$export$ca5b8fbc835d95e4);
    var $5uXOq = parcelRequire("5uXOq");
    var $fEDkH = parcelRequire("fEDkH");
    function $1d1204150993c3dd$var$_extends() {
        $1d1204150993c3dd$var$_extends = Object.assign || function(target) {
            for(var i = 1; i < arguments.length; i++){
                var source = arguments[i];
                for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
            }
            return target;
        };
        return $1d1204150993c3dd$var$_extends.apply(this, arguments);
    }
    const $1d1204150993c3dd$export$ca5b8fbc835d95e4 = ({ id: id, content: content })=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement("input", {
            type: "hidden",
            "data-lazy-begin": id
        }), content.map((el, i)=>{
            const { tagName: tagName = '', childNodes: childNodes = [], attributes: attributes = [] } = el;
            const props = Array.from(attributes).reduce((0, $fEDkH.attrToProp), {
                key: String(i)
            });
            if (!tagName) return (0, $5uXOq.createElement)((0, $5uXOq.Fragment), props, el.textContent);
            if (!childNodes.length) return (0, $5uXOq.createElement)(tagName.toLowerCase(), props);
            return (0, $5uXOq.createElement)(tagName.toLowerCase(), $1d1204150993c3dd$var$_extends({}, props, {
                dangerouslySetInnerHTML: {
                    __html: ''
                },
                suppressHydrationWarning: true
            }));
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("input", {
            type: "hidden",
            "data-lazy-end": id
        }));
    };
});
parcelRegister("k8XtJ", function(module, exports) {
    $parcel$export(module.exports, "useSubscription", ()=>$eaa2b1340dc6db34$export$368b4214baeb914c);
    var $5uXOq = parcelRequire("5uXOq");
    function $eaa2b1340dc6db34$export$368b4214baeb914c({ context: context, load: load, onValue: onValue }) {
        const { subscribe: subscribe, currentValue: currentValue } = (0, $5uXOq.useContext)(context);
        (0, $5uXOq.useMemo)(()=>{
            let unsubscribe = null;
            const check = ()=>{
                const done = onValue(currentValue());
                if (done) load();
                if (done && unsubscribe) unsubscribe();
                return done;
            };
            unsubscribe = !check() ? subscribe(check) : null;
        }, []);
    }
});
parcelRegister("3ro9P", function(module, exports) {
    $parcel$export(module.exports, "createComponentServer", ()=>$2816a1dec93a8449$export$eb2e4b04351cdd9e);
    var $3aJOa;
    var $5uXOq = parcelRequire("5uXOq");
    var $9tT5O = parcelRequire("9tT5O");
    var $gRvGe = parcelRequire("gRvGe");
    parcelRequire("41yqT");
    var $7t9v5 = parcelRequire("7t9v5");
    var $fEDkH = parcelRequire("fEDkH");
    var $gI8wo = parcelRequire("gI8wo");
    function $2816a1dec93a8449$var$load(moduleId, loader) {
        try {
            return (0, $fEDkH.getExport)(loader());
        } catch (err) {
            throw (0, $gI8wo.createLoaderError)(err);
        }
    }
    function $2816a1dec93a8449$export$eb2e4b04351cdd9e({ dataLazyId: dataLazyId, defer: defer, loader: loader, moduleId: moduleId, ssr: ssr }) {
        return (props)=>{
            var _getAssetUrlsFromId;
            const Resolved = ssr ? $2816a1dec93a8449$var$load(moduleId, loader) : null;
            const { fallback: fallback } = (0, $5uXOq.useContext)((0, $7t9v5.LazySuspenseContext));
            const { crossOrigin: crossOrigin, manifest: manifest } = (0, $9tT5O.getConfig)();
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement("input", {
                type: "hidden",
                "data-lazy-begin": dataLazyId
            }), defer !== (0, $gRvGe.PHASE).LAZY && ((_getAssetUrlsFromId = (0, (0, parcelRequire("3aJOa")).getAssetUrlsFromId)(manifest, moduleId)) == null ? void 0 : _getAssetUrlsFromId.map((url)=>(0, ($parcel$interopDefault($5uXOq))).createElement("link", {
                    key: url,
                    rel: defer === (0, $gRvGe.PHASE).PAINT ? 'preload' : 'prefetch',
                    href: url,
                    crossOrigin: crossOrigin,
                    as: "script"
                }))), Resolved ? (0, ($parcel$interopDefault($5uXOq))).createElement(Resolved, props) : fallback, (0, ($parcel$interopDefault($5uXOq))).createElement("input", {
                type: "hidden",
                "data-lazy-end": dataLazyId
            }));
        };
    }
});
parcelRegister("5pJCH", function(module, exports) {
    $parcel$export(module.exports, "createDeferred", ()=>$3f12ad617063b5b1$export$e673efccd97e4223);
    const $3f12ad617063b5b1$export$e673efccd97e4223 = ({ loader: loader, preload: preload })=>{
        let resolve;
        const deferred = {
            promise: new Promise((res)=>{
                resolve = (m)=>{
                    let withDefault;
                    deferred.result = m;
                    if (!m.default) withDefault = {
                        default: m
                    };
                    res(withDefault ? withDefault : m);
                };
            }),
            result: undefined,
            preload: function(_preload) {
                function preload() {
                    return _preload.apply(this, arguments);
                }
                preload.toString = function() {
                    return _preload.toString();
                };
                return preload;
            }(()=>{
                if (deferred.result) return;
                preload().then((m)=>{
                    deferred.result = m;
                }).catch(()=>{});
            }),
            start: ()=>{
                if (deferred.result) {
                    resolve(deferred.result);
                    return Promise.resolve();
                }
                return loader().then(resolve);
            }
        };
        return deferred;
    };
});
parcelRegister("2LsHW", function(module, exports) {
    $parcel$export(module.exports, "preloadAsset", ()=>$20363d4ed5cd2af1$export$25bad4aa00c45355);
    var $3aJOa;
    var $3Sq3c = parcelRequire("3Sq3c");
    var $9tT5O = parcelRequire("9tT5O");
    var $fEDkH = parcelRequire("fEDkH");
    var $9Ww7D = parcelRequire("9Ww7D");
    var $6MxP6 = parcelRequire("6MxP6");
    var $lUR7e = parcelRequire("lUR7e");
    function $20363d4ed5cd2af1$export$3af04dbcb01bad4d({ moduleId: moduleId, rel: rel }) {
        const { manifest: manifest } = (0, $9tT5O.getConfig)();
        const assets = (0, (0, parcelRequire("3aJOa")).getAssetUrlsFromId)(manifest, moduleId);
        if (!assets) throw new Error('Unsupported preload strategy');
        const cleanupLinkTags = assets.map((url)=>(0, $6MxP6.insertLinkTag)(url, rel));
        return ()=>{
            for (const cleanupLinkTag of cleanupLinkTags)cleanupLinkTag();
        };
    }
    const $20363d4ed5cd2af1$var$fakePromise = {
        then: ()=>$20363d4ed5cd2af1$var$fakePromise,
        catch: ()=>$20363d4ed5cd2af1$var$fakePromise,
        finally: ()=>$20363d4ed5cd2af1$var$fakePromise
    };
    function $20363d4ed5cd2af1$export$1046fd6a49d5e7a({ loader: loader, rel: rel }) {
        if (typeof __webpack_require__ === 'undefined' || typeof __webpack_get_script_filename__ === 'undefined') throw new Error('Unsupported preload strategy');
        const requireEnsure = __webpack_require__.e;
        const cleanupLinkTags = [];
        __webpack_require__.e = function requirePreload(chunkId) {
            const href = __webpack_get_script_filename__(chunkId);
            cleanupLinkTags.push((0, $6MxP6.insertLinkTag)(href, rel));
            return $20363d4ed5cd2af1$var$fakePromise;
        };
        try {
            loader();
        } catch (err) {}
        __webpack_require__.e = requireEnsure;
        return ()=>{
            for (const cleanupLinkTag of cleanupLinkTags)cleanupLinkTag();
        };
    }
    function $20363d4ed5cd2af1$export$eb05139fa4dcf992({ loader: loader }) {
        loader();
        return 0, $3Sq3c.noopCleanup;
    }
    function $20363d4ed5cd2af1$export$25bad4aa00c45355({ loader: loader, moduleId: moduleId, priority: priority }) {
        var _GlobalReactLooselyLa;
        if ((0, $fEDkH.isNodeEnvironment)()) return 0, $3Sq3c.noopCleanup;
        (_GlobalReactLooselyLa = (0, $lUR7e.GlobalReactLooselyLazyProfiler).current) == null || _GlobalReactLooselyLa.onPreload(moduleId, priority);
        const rel = priority === (0, $9Ww7D.PRIORITY).HIGH ? 'preload' : 'prefetch';
        const preloadStrategies = [
            $20363d4ed5cd2af1$export$3af04dbcb01bad4d,
            $20363d4ed5cd2af1$export$1046fd6a49d5e7a,
            $20363d4ed5cd2af1$export$eb05139fa4dcf992
        ];
        for (const strategy of preloadStrategies)try {
            return strategy({
                loader: loader,
                moduleId: moduleId,
                rel: rel
            });
        } catch (_) {}
        return 0, $3Sq3c.noopCleanup;
    }
});
parcelRegister("6MxP6", function(module, exports) {
    $parcel$export(module.exports, "insertLinkTag", ()=>$4f01765b3d259822$export$6610512821c8a4ce);
    var $lUR7e = parcelRequire("lUR7e");
    var $3Sq3c = parcelRequire("3Sq3c");
    var $9tT5O = parcelRequire("9tT5O");
    function $4f01765b3d259822$export$6610512821c8a4ce(href, rel) {
        var _document$head;
        if (document.querySelector(`link[href="${href}"]`) || document.querySelector(`script[src="${href}"]`)) return 0, $3Sq3c.noopCleanup;
        const { crossOrigin: crossOrigin } = (0, $9tT5O.getConfig)();
        const link = document.createElement('link');
        link.rel = rel;
        link.as = 'script';
        if (crossOrigin) link.crossOrigin = crossOrigin;
        link.href = href;
        const profiler = (0, $lUR7e.GlobalReactLooselyLazyProfiler).current;
        let removableListener = null;
        if (profiler) {
            const eventInfo = {
                identifier: href
            };
            const listener = ()=>{
                link.removeEventListener('onload', listener);
                removableListener = null;
                profiler.onLoadComplete(eventInfo);
            };
            link.addEventListener('onload', listener);
            removableListener = listener;
            profiler.onLoadStart(eventInfo);
        }
        (_document$head = document.head) == null || _document$head.appendChild(link);
        return ()=>{
            if (link.parentNode === document.head) {
                var _document$head2;
                (_document$head2 = document.head) == null || _document$head2.removeChild(link);
            }
            if (removableListener) link.removeEventListener('onload', removableListener);
        };
    }
});
parcelRegister("gNYzn", function(module, exports) {
    $parcel$export(module.exports, "retry", ()=>$032842ea9e8e4a24$export$9369b12211e1fce4);
    const $032842ea9e8e4a24$var$calculateDelay = (context, policy)=>{
        const { attempt: attempt } = context;
        const { delay: delay, factor: factor } = policy;
        const retryAttempt = attempt - 1;
        if (retryAttempt === 1 || delay === 0) return 0;
        const add = factor * delay;
        return delay + add * (retryAttempt - 2);
    };
    const $032842ea9e8e4a24$var$sleep = (delay)=>new Promise((resolve)=>setTimeout(resolve, delay));
    const $032842ea9e8e4a24$var$getPolicy = (configuration)=>{
        var _configuration$delay, _configuration$factor, _configuration$maxAtt;
        return {
            delay: Math.max(0, (_configuration$delay = configuration.delay) != null ? _configuration$delay : 0),
            factor: Math.max(0, (_configuration$factor = configuration.factor) != null ? _configuration$factor : 0),
            maxAttempts: Math.max(0, (_configuration$maxAtt = configuration.maxAttempts) != null ? _configuration$maxAtt : 0)
        };
    };
    function $032842ea9e8e4a24$export$9369b12211e1fce4(retryable, policyConfiguration = {}) {
        const policy = $032842ea9e8e4a24$var$getPolicy(policyConfiguration);
        const { maxAttempts: maxAttempts } = policy;
        const context = {
            attempt: 1,
            attemptsRemaining: maxAttempts
        };
        const onError = async (err)=>{
            if (context.attemptsRemaining === 0) throw err;
            context.attempt += 1;
            context.attemptsRemaining -= 1;
            const delay = $032842ea9e8e4a24$var$calculateDelay(context, policy);
            if (delay) await $032842ea9e8e4a24$var$sleep(delay);
            return retryable().catch(onError);
        };
        return retryable().catch(onError);
    }
});
parcelRegister("hoYXe", function(module, exports) {
    $parcel$export(module.exports, "createActivityClient", ()=>$30574e88272de3f4$export$224367b01f71f2aa);
    var $9yZqs;
    var $7trIV;
    let $30574e88272de3f4$var$previousClientVersion;
    const $30574e88272de3f4$export$224367b01f71f2aa = (version, product, logger, baseUrl, configFetch)=>{
        if ($30574e88272de3f4$var$previousClientVersion && $30574e88272de3f4$var$previousClientVersion !== version && logger?.captureWarning) logger.captureWarning(`ActivityClient version has changed, is this intentional?`);
        $30574e88272de3f4$var$previousClientVersion = version || 'v3';
        if (version === 'v2') return new (0, (0, parcelRequire("9yZqs")).ActivityClientV2)(product, baseUrl);
        return new (0, (0, parcelRequire("7trIV")).ActivityClientV3)(product, baseUrl, logger, configFetch);
    };
});
parcelRegister("9yZqs", function(module, exports) {
    $parcel$export(module.exports, "ActivityClientV2", ()=>$fff1f13eb7277558$export$330ab0047f2fb745);
    var $cXq43;
    var $3Bknq;
    var $gVYg8;
    class $fff1f13eb7277558$export$330ab0047f2fb745 extends (0, (0, parcelRequire("3Bknq")).ActivityClient) {
        constructor(product, baseUrl){
            super('v2', product, undefined, baseUrl), this.fetchActivities = async (retryMS, filters, activityQueries)=>{
                return (0, (0, parcelRequire("cXq43")).fetchActivitiesWithExperience)((experience)=>(0, (0, parcelRequire("gVYg8")).fetchActivitiesV2)({
                        experience: experience,
                        product: this.product,
                        retryMS: retryMS,
                        filters: filters,
                        activityQueries: activityQueries,
                        baseUrl: this.baseUrl
                    }), 'v2');
            }, this.setProduct = (product)=>{
                this.product = product;
            };
        }
    }
});
parcelRegister("cXq43", function(module, exports) {
    $parcel$export(module.exports, "fetchActivitiesWithExperience", ()=>$12ea6ddffbcd8f57$export$4a906f16800734f3);
    var $iFmUA;
    var $1b4ym;
    var $4cDQS;
    async function $12ea6ddffbcd8f57$export$4a906f16800734f3(fetchActivities, clientVersion) {
        const experience = clientVersion === 'v2' ? (0, (0, parcelRequire("4cDQS")).recentWorkClientExperienceV2)() : (0, (0, parcelRequire("4cDQS")).recentWorkClientExperienceV3)();
        try {
            experience.start();
            experience.addMetadata({
                clientVersion: clientVersion,
                packageName: (0, parcelRequire("1b4ym")).packageName,
                packageVersion: (0, parcelRequire("1b4ym")).packageVersion
            });
            const data = await fetchActivities(experience);
            experience.success();
            return data;
        } catch (e) {
            experience.failure({
                metadata: {
                    error: $12ea6ddffbcd8f57$export$f33622abb5224195(e)
                }
            });
            throw e;
        }
    }
    const $12ea6ddffbcd8f57$export$f33622abb5224195 = (e)=>{
        if (e instanceof (0, (0, parcelRequire("iFmUA")).default)) return {
            ...e,
            xRequestId: e.xRequestId ?? undefined,
            cause: undefined
        };
        return e instanceof Error ? {
            ...e,
            cause: undefined
        } : 'unknown';
    };
});
parcelRegister("iFmUA", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0aef1aaaf8d64fa1$export$2e2bcd8739ae039);
    class $0aef1aaaf8d64fa1$export$2e2bcd8739ae039 extends Error {
        constructor({ message: message, statusCode: statusCode, path: path, method: method, xRequestId: xRequestId, headers: headers }){
            super();
            this.name = 'HttpError';
            this.message = message;
            const p = path.split('?')[0];
            this.path = /^[/-a-z]+$/i.test(p) ? p : '';
            this.method = method;
            this.statusCode = statusCode;
            this.xRequestId = xRequestId;
            this.headers = Array.from(headers.entries()).map((value, key)=>`${key}:${value}`).sort().join(',');
        }
    }
    const $0aef1aaaf8d64fa1$export$97b788730ba59845 = (e)=>e instanceof $0aef1aaaf8d64fa1$export$2e2bcd8739ae039;
});
parcelRegister("1b4ym", function(module, exports) {
    $parcel$export(module.exports, "packageName", ()=>$42bb1ba4b82855c2$export$9345d7360ffe0722);
    $parcel$export(module.exports, "packageVersion", ()=>$42bb1ba4b82855c2$export$91546b032799aa40);
    const $42bb1ba4b82855c2$export$9345d7360ffe0722 = "platform-pkg";
    const $42bb1ba4b82855c2$export$91546b032799aa40 = "0.0.0-use.local";
});
parcelRegister("4cDQS", function(module, exports) {
    $parcel$export(module.exports, "recentWorkClientExperienceV2", ()=>$cf5f22aa1bc15bc4$export$d7769758f5eaa63b);
    $parcel$export(module.exports, "recentWorkClientExperienceV3", ()=>$cf5f22aa1bc15bc4$export$9e32a4ed888f4717);
    var $atdLB;
    var $duUGa;
    const $cf5f22aa1bc15bc4$var$keyToTiming = (key)=>({
            key: key,
            startMark: `${key}_start`,
            endMark: `${key}_end`
        });
    const $cf5f22aa1bc15bc4$var$timings = [
        'FetchedActivities',
        'TransformedActivityItems',
        'GeneratedQueryWithFilters'
    ].map($cf5f22aa1bc15bc4$var$keyToTiming);
    const $cf5f22aa1bc15bc4$export$d7769758f5eaa63b = ()=>{
        return new (0, (0, parcelRequire("duUGa")).UFOExperience)('client', {
            type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Load,
            performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).Custom,
            platform: {
                component: 'recent-work'
            },
            timings: $cf5f22aa1bc15bc4$var$timings
        });
    };
    const $cf5f22aa1bc15bc4$export$9e32a4ed888f4717 = ()=>new (0, (0, parcelRequire("duUGa")).UFOExperience)('client-v3', {
            type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Load,
            performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).Custom,
            platform: {
                component: 'recent-work'
            },
            timings: $cf5f22aa1bc15bc4$var$timings
        });
});
parcelRegister("3Bknq", function(module, exports) {
    $parcel$export(module.exports, "ActivityClient", ()=>$d3363d88c8d5ff9b$export$157740f5433f3dbe);
    var $3l0ly;
    class $d3363d88c8d5ff9b$export$157740f5433f3dbe {
        constructor(clientVersion, product, headers, baseUrl){
            this.product = 'unknown';
            this.baseUrl = (0, (0, parcelRequire("3l0ly")).GRAPHQL_GATEWAY_PATH);
            if (product) this.product = product;
            this.clientVersion = clientVersion;
            this.headers = headers ?? {};
            if (baseUrl) this.baseUrl = baseUrl;
        }
    }
});
parcelRegister("3l0ly", function(module, exports) {
    $parcel$export(module.exports, "GRAPHQL_GATEWAY_PATH", ()=>$4167449aedd1da1b$export$851c5df667ca24c8);
    $parcel$export(module.exports, "WORKED_EVENT", ()=>$4167449aedd1da1b$export$eb4e9f525aef1cc3);
    const $4167449aedd1da1b$export$851c5df667ca24c8 = '/gateway/api/graphql';
    var $4167449aedd1da1b$export$d245b105c09339d8;
    (function(VIEWED_EVENT) {
        VIEWED_EVENT["VIEWED"] = "viewed";
    })($4167449aedd1da1b$export$d245b105c09339d8 || ($4167449aedd1da1b$export$d245b105c09339d8 = {}));
    var $4167449aedd1da1b$export$eb4e9f525aef1cc3;
    (function(WORKED_EVENT) {
        WORKED_EVENT["COMMENTED"] = "commented";
        WORKED_EVENT["CREATED"] = "created";
        WORKED_EVENT["EDITED"] = "edited";
        WORKED_EVENT["PUBLISHED"] = "published";
        WORKED_EVENT["UPDATED"] = "updated";
    })($4167449aedd1da1b$export$eb4e9f525aef1cc3 || ($4167449aedd1da1b$export$eb4e9f525aef1cc3 = {}));
    var $4167449aedd1da1b$export$d02a56686be43f69;
    (function(ActivityObjectType) {
        ActivityObjectType["BLOGPOST"] = "BLOGPOST";
        ActivityObjectType["COMMENT"] = "COMMENT";
        ActivityObjectType["ISSUE"] = "ISSUE";
        ActivityObjectType["PAGE"] = "PAGE";
        ActivityObjectType["PROJECT"] = "PROJECT";
        ActivityObjectType["SITE"] = "SITE";
        ActivityObjectType["SPACE"] = "SPACE";
        ActivityObjectType["TASK"] = "TASK";
    })($4167449aedd1da1b$export$d02a56686be43f69 || ($4167449aedd1da1b$export$d02a56686be43f69 = {}));
});
parcelRegister("gVYg8", function(module, exports) {
    $parcel$export(module.exports, "fetchActivitiesV2", ()=>$9bc87a88656ac7d1$export$750ec7816fdd2f9e);
    var $f3gfD;
    var $e35Gx;
    var $aHtVh;
    var $lB6CZ;
    const $9bc87a88656ac7d1$var$ACTIVITIES_LIMIT = 50;
    const $9bc87a88656ac7d1$var$isMyActivitiesConnection = (activities)=>{
        return activities.myActivities !== undefined;
    };
    const $9bc87a88656ac7d1$var$V2_AVAILABLE_PRODUCTS = [
        'teamCentral',
        'editor',
        'people',
        'jira',
        'townsquare',
        'apOnboarding',
        'worklens',
        'confluence',
        'start'
    ];
    const $9bc87a88656ac7d1$export$750ec7816fdd2f9e = async ({ experience: experience, product: product, retryMS: retryMS, filters: filters = {}, activityQueries: activityQueries, baseUrl: baseUrl })=>{
        const { limit: limit = $9bc87a88656ac7d1$var$ACTIVITIES_LIMIT, ...restFilters } = filters;
        experience.mark('GeneratedQueryWithFilters_start');
        const { query: query, queryFilters: queryFilters } = (0, (0, parcelRequire("aHtVh")).generateActivityQueryWithFilters)(product, restFilters, activityQueries);
        experience.mark('GeneratedQueryWithFilters_end');
        const operationProduct = $9bc87a88656ac7d1$var$V2_AVAILABLE_PRODUCTS.includes(product) ? product : 'start';
        experience.mark('FetchedActivities_start');
        let response;
        try {
            response = await (0, (0, parcelRequire("e35Gx")).postResource)(baseUrl, {
                operationName: (0, (0, parcelRequire("f3gfD")).getOperationName)(operationProduct),
                query: query,
                variables: {
                    first: limit,
                    filters: queryFilters
                }
            }, retryMS);
        } catch (error) {
            if (!error || error.statusCode !== 401 && error.message !== 'The operation was aborted.') throw error;
        }
        experience.mark('FetchedActivities_end');
        let workedOn = [], viewed = [], all = [];
        if (!response || !response.data?.activities) return {
            all: all,
            workedOn: workedOn,
            viewed: viewed
        };
        experience.mark('TransformedActivityItems_start');
        if ($9bc87a88656ac7d1$var$isMyActivitiesConnection(response.data.activities)) {
            if (response.data.activities.myActivities.workedOn && activityQueries.includes('workedOn')) workedOn = (0, (0, parcelRequire("lB6CZ")).transformActivitiesItems)('workedOn', response.data.activities.myActivities.workedOn);
            if (response.data.activities.myActivities.viewed && activityQueries.includes('viewed')) viewed = (0, (0, parcelRequire("lB6CZ")).transformActivitiesItems)('viewed', response.data.activities.myActivities.viewed);
            if (response.data.activities.myActivities.all && activityQueries.includes('all')) all = (0, (0, parcelRequire("lB6CZ")).transformActivitiesItems)('all', response.data.activities.myActivities.all);
        } else {
            if (response.data.activities.workedOn && activityQueries.includes('workedOn')) workedOn = (0, (0, parcelRequire("lB6CZ")).transformActivitiesItems)('workedOn', response.data.activities.workedOn);
            if (response.data.activities.all && activityQueries.includes('all')) all = (0, (0, parcelRequire("lB6CZ")).transformActivitiesItems)('all', response.data.activities.all);
        }
        experience.mark('TransformedActivityItems_end');
        return {
            all: all,
            viewed: viewed,
            workedOn: workedOn
        };
    };
});
parcelRegister("f3gfD", function(module, exports) {
    $parcel$export(module.exports, "getOperationName", ()=>$461d79ecc23ca794$export$41bca9dc6871dd4e);
    var $e4eHl = parcelRequire("e4eHl");
    const $461d79ecc23ca794$export$ad1e21d37f385bcb = (product)=>{
        return (0, ($parcel$interopDefault($e4eHl)))(product);
    };
    const $461d79ecc23ca794$export$41bca9dc6871dd4e = (product)=>{
        return `${$461d79ecc23ca794$export$ad1e21d37f385bcb(product)}_activity_recentWorkClient`;
    };
});
parcelRegister("e35Gx", function(module, exports) {
    $parcel$export(module.exports, "postResource", ()=>$e89fe5eb68802860$export$2ff3e1f219ccfad6);
    parcelRequire("6fYNv");
    var $6sAya;
    var $6fYNv;
    var $lP65p;
    var $iFmUA;
    const $e89fe5eb68802860$var$fetchResource = async (path, method, options = {})=>{
        const url = (0, (0, parcelRequire("lP65p")).getFullUrl)(path);
        const response = await fetch(url, {
            credentials: 'include',
            method: method,
            ...options
        }).catch((error)=>{
            throw new (0, (0, parcelRequire("6sAya")).default)({
                error: error,
                path: path,
                method: method
            });
        });
        const statusCode = response.status;
        if (!response.ok) {
            statusCode;
            const text = $e89fe5eb68802860$var$scrubTimestampFromErrorBody(await response.text());
            const httpError = new (0, (0, parcelRequire("iFmUA")).default)({
                message: text,
                method: method,
                path: path,
                statusCode: statusCode,
                xRequestId: response.headers.get('x-request-id'),
                headers: response.headers
            });
            throw httpError;
        }
        return response;
    };
    const $e89fe5eb68802860$var$makeJsonRquest = async (path, method, additionalFetchOptions = {})=>{
        const response = await $e89fe5eb68802860$var$fetchResource(path, method, additionalFetchOptions);
        const text = await response.text();
        return text ? JSON.parse(text) : {};
    };
    const $e89fe5eb68802860$export$2ff3e1f219ccfad6 = async (path, data, retryMS, extraHeaders)=>(0, (0, parcelRequire("6fYNv")).retryOnException)(()=>$e89fe5eb68802860$var$makeJsonRquest(path, 'POST', {
                body: JSON.stringify(data),
                headers: {
                    'content-type': 'application/json',
                    ...extraHeaders
                }
            }), {
            intervalsMS: retryMS ?? []
        });
    function $e89fe5eb68802860$var$scrubTimestampFromErrorBody(text) {
        let json;
        try {
            json = JSON.parse(text);
        } catch (err) {
            return text;
        }
        delete json.timestamp;
        return JSON.stringify(json);
    }
});
parcelRegister("lP65p", function(module, exports) {
    $parcel$export(module.exports, "getFullUrl", ()=>$196111106f21b511$export$2414511207262909);
    const $196111106f21b511$var$urlRegex = new RegExp(/^https?:\/\//);
    function $196111106f21b511$export$2414511207262909(path, hostConfig = {
        host: window.location.hostname,
        port: window.location.port
    }) {
        if ($196111106f21b511$var$urlRegex.test(path)) return path;
        return hostConfig.host === 'localhost' ? `http://${hostConfig.host}:${hostConfig.port}${path}` : path;
    }
});
parcelRegister("aHtVh", function(module, exports) {
    $parcel$export(module.exports, "generateActivityQueryWithFilters", ()=>$3a68129fd7fbdd1f$export$855cd08371c65b8c);
    var $f3gfD;
    var $dcvAS;
    const $3a68129fd7fbdd1f$var$ACTIVITIES = `
  nodes {
    id
    timestamp
    object {
      id
      name
      cloudId
      localResourceId
      product
      type
      url
      iconUrl
      containers {
        name
      }
      contributors {
        profile {
          accountId
          name
          picture
        }
      }
      events {
        eventType
      }
      extension {
        ... on ActivitiesJiraIssue {
          issueKey
        }
      }
    }
  }
`;
    const $3a68129fd7fbdd1f$var$WORKED_ON_QUERY = `
   workedOn(first: $first, filters: $filters) {
     ${$3a68129fd7fbdd1f$var$ACTIVITIES}
   }
`;
    const $3a68129fd7fbdd1f$var$VIEWED__QUERY = `
   viewed(first: $first, filters: $filters) {
     ${$3a68129fd7fbdd1f$var$ACTIVITIES}
   }
`;
    const $3a68129fd7fbdd1f$var$ALL__QUERY = `
    all(first: $first, filters: $filters) {
      ${$3a68129fd7fbdd1f$var$ACTIVITIES}
    }
`;
    const $3a68129fd7fbdd1f$var$activityQueryMap = new Map([
        [
            'workedOn',
            $3a68129fd7fbdd1f$var$WORKED_ON_QUERY
        ],
        [
            'viewed',
            $3a68129fd7fbdd1f$var$VIEWED__QUERY
        ],
        [
            'all',
            $3a68129fd7fbdd1f$var$ALL__QUERY
        ]
    ]);
    const $3a68129fd7fbdd1f$var$getMyActivitiesQuery = (queries)=>`
      myActivities {
        ${queries.join('\n')}
      }
`;
    const $3a68129fd7fbdd1f$var$getActivitiesQuery = (product, content)=>`
    query ${(0, (0, parcelRequire("f3gfD")).getOperationName)(product)}($first: Int, $filters: [ActivitiesFilter!]) {
      activities {
        ${content}
      }
    }
`;
    const $3a68129fd7fbdd1f$export$855cd08371c65b8c = (product, filters, activityQueries)=>{
        if (Array.isArray(filters.actors)) {
            const filteredAccountQueries = activityQueries.filter((query)=>query !== 'viewed');
            return {
                query: $3a68129fd7fbdd1f$var$getActivitiesQuery(product, filteredAccountQueries.map((query)=>$3a68129fd7fbdd1f$var$activityQueryMap.get(query)).join('\n')),
                queryFilters: (0, (0, parcelRequire("dcvAS")).ACTIVITY_FILTER_COLLECTION).v2.get('activities')(filters)
            };
        } else return {
            query: $3a68129fd7fbdd1f$var$getActivitiesQuery(product, $3a68129fd7fbdd1f$var$getMyActivitiesQuery(activityQueries.map((query)=>$3a68129fd7fbdd1f$var$activityQueryMap.get(query)))),
            queryFilters: (0, (0, parcelRequire("dcvAS")).ACTIVITY_FILTER_COLLECTION).v2.get('myActivity')(filters)
        };
    };
});
parcelRegister("dcvAS", function(module, exports) {
    $parcel$export(module.exports, "ACTIVITY_FILTER_COLLECTION", ()=>$1d4997441d4b8586$export$5201d39848130041);
    var $1THyP;
    var $62oeH;
    const $1d4997441d4b8586$export$5201d39848130041 = {
        v2: (0, (0, parcelRequire("1THyP")).ACTIVITY_FILTER_V2_MAP),
        v3: (0, (0, parcelRequire("62oeH")).ACTIVITY_FILTER_V3_MAP)
    };
});
parcelRegister("1THyP", function(module, exports) {
    $parcel$export(module.exports, "ACTIVITY_FILTER_V2_MAP", ()=>$a1a68e27645236e3$export$1dca7bc1ec360897);
    var $4hkqF;
    var $afWIG;
    const $a1a68e27645236e3$export$1dca7bc1ec360897 = new Map([
        [
            'myActivity',
            (0, (0, parcelRequire("afWIG")).default)
        ],
        [
            'activities',
            (0, (0, parcelRequire("4hkqF")).default)
        ]
    ]);
});
parcelRegister("4hkqF", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$46c6a95053cc1f7b$export$2e2bcd8739ae039);
    var $74JGD;
    const $46c6a95053cc1f7b$var$generateV2ActivitiesFilters = (filters = {})=>{
        const { limit: limit, ...restFilters } = filters;
        return (0, (0, parcelRequire("74JGD")).generateActivityFiltersV2)(restFilters);
    };
    var $46c6a95053cc1f7b$export$2e2bcd8739ae039 = $46c6a95053cc1f7b$var$generateV2ActivitiesFilters;
});
parcelRegister("74JGD", function(module, exports) {
    $parcel$export(module.exports, "generateActivityFiltersV2", ()=>$683b63762cac319c$export$ebef9c1f1e15c057);
    var $MQuHl;
    const $683b63762cac319c$var$FILTERS_TO_TRANSFORM__UPPERCASE = [
        'products',
        'eventTypes',
        'objectTypes'
    ];
    const $683b63762cac319c$var$KEYS_TO_TRANSFROM = new Map([
        [
            'actors',
            'accountIds'
        ]
    ]);
    const $683b63762cac319c$export$ebef9c1f1e15c057 = (filters = {})=>(0, (0, parcelRequire("MQuHl")).generateActivityFilters)(filters, (originalkey, originalFilter)=>{
            const filter = Array.isArray(originalFilter) && $683b63762cac319c$var$FILTERS_TO_TRANSFORM__UPPERCASE.includes(originalkey) ? originalFilter.map((f)=>f.toUpperCase()) : originalFilter;
            const key = $683b63762cac319c$var$KEYS_TO_TRANSFROM.has(originalkey) ? $683b63762cac319c$var$KEYS_TO_TRANSFROM.get(originalkey) : originalkey;
            return {
                [key]: filter
            };
        });
});
parcelRegister("MQuHl", function(module, exports) {
    $parcel$export(module.exports, "generateActivityFilters", ()=>$0ef7a6884f8128bf$export$23c75313f46dd54e);
    const $0ef7a6884f8128bf$export$23c75313f46dd54e = (filters = {}, transform, rootLevelFilters)=>{
        return Object.entries(filters).reduce((acc, [key, filter])=>{
            const entry = transform ? transform(key, filter) : {
                [key]: filter
            };
            return rootLevelFilters?.includes(key) ? {
                ...acc,
                ...entry
            } : {
                ...acc,
                arguments: {
                    ...acc.arguments,
                    ...entry
                }
            };
        }, {
            type: 'AND',
            arguments: {}
        });
    };
});
parcelRegister("afWIG", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b3c453a00bc0f6ca$export$2e2bcd8739ae039);
    var $74JGD;
    const $b3c453a00bc0f6ca$var$generateV2MyActivityFilters = (filters = {})=>{
        const { limit: limit, actors: actors, ...restFilters } = filters;
        return (0, (0, parcelRequire("74JGD")).generateActivityFiltersV2)(restFilters);
    };
    var $b3c453a00bc0f6ca$export$2e2bcd8739ae039 = $b3c453a00bc0f6ca$var$generateV2MyActivityFilters;
});
parcelRegister("62oeH", function(module, exports) {
    $parcel$export(module.exports, "ACTIVITY_FILTER_V3_MAP", ()=>$a356d323f8207676$export$9a1782843b6e99d2);
    var $hU3MB;
    var $gQxYK;
    const $a356d323f8207676$export$9a1782843b6e99d2 = new Map([
        [
            'myActivity',
            (0, (0, parcelRequire("gQxYK")).default)
        ],
        [
            'activities',
            (0, (0, parcelRequire("hU3MB")).default)
        ]
    ]);
});
parcelRegister("hU3MB", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$84a6b56b296ed055$export$2e2bcd8739ae039);
    var $glhs7;
    const $84a6b56b296ed055$var$generateV3ActivityFilters = (filters = {})=>{
        const { limit: limit, ...restFilters } = filters;
        return (0, (0, parcelRequire("glhs7")).generateActivityFiltersV3)(restFilters);
    };
    var $84a6b56b296ed055$export$2e2bcd8739ae039 = $84a6b56b296ed055$var$generateV3ActivityFilters;
});
parcelRegister("glhs7", function(module, exports) {
    $parcel$export(module.exports, "generateActivityFiltersV3", ()=>$3cb34394a8624fd6$export$e73fe7ded3fe2664);
    var $MQuHl;
    const $3cb34394a8624fd6$var$FILTERS_TO_TRANSFORM__LOWERCASE = [
        'products',
        'eventTypes',
        'objectTypes'
    ];
    const $3cb34394a8624fd6$var$ROOT_LEVEL_FILTERS = [
        'actors',
        'rootContainerIds'
    ];
    const $3cb34394a8624fd6$export$e73fe7ded3fe2664 = (filters = {})=>(0, (0, parcelRequire("MQuHl")).generateActivityFilters)(filters, (key, filter)=>Array.isArray(filter) && $3cb34394a8624fd6$var$FILTERS_TO_TRANSFORM__LOWERCASE.includes(key) ? {
                [key]: filter.map((f)=>f.toLowerCase())
            } : {
                [key]: filter
            }, $3cb34394a8624fd6$var$ROOT_LEVEL_FILTERS);
});
parcelRegister("gQxYK", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$840ac7ca8bd740a4$export$2e2bcd8739ae039);
    var $glhs7;
    const $840ac7ca8bd740a4$var$generateV3MyActivityFilters = (filters = {})=>{
        const { limit: limit, actors: actors, ...restFilters } = filters;
        return (0, (0, parcelRequire("glhs7")).generateActivityFiltersV3)(restFilters);
    };
    var $840ac7ca8bd740a4$export$2e2bcd8739ae039 = $840ac7ca8bd740a4$var$generateV3MyActivityFilters;
});
parcelRegister("lB6CZ", function(module, exports) {
    $parcel$export(module.exports, "transformActivitiesItems", ()=>$ccb3637438790056$export$306a8b649360ca6f);
    const $ccb3637438790056$var$SITE_ARI_PREFIX = 'ari:cloud:platform::site/';
    function $ccb3637438790056$export$306a8b649360ca6f(query, activities = {}) {
        if (!activities || !activities.nodes) return [];
        return activities.nodes.map((item)=>{
            const { object: object, timestamp: timestamp } = item;
            const { cloudId: cloudId, events: events, extension: extension, iconUrl: iconUrl, id: id, localResourceId: localResourceId, name: name, product: product, url: url, type: type } = object;
            const eventType = events[0].eventType.toLowerCase();
            const issueKey = extension && extension.issueKey;
            let containers = [];
            if (issueKey) containers.push({
                name: issueKey
            });
            if (Array.isArray(object.containers)) containers = containers.concat(object.containers);
            containers = containers.filter((container)=>!!container.name);
            return {
                query: query,
                containers: containers,
                contributors: (object.contributors || []).reduce((contributors, contributor)=>{
                    if (contributor.profile) {
                        const { accountId: accountId, picture: picture } = contributor.profile;
                        contributors.push({
                            accountId: accountId,
                            name: contributor.profile.name,
                            picture: picture
                        });
                    }
                    return contributors;
                }, []),
                eventType: eventType,
                object: {
                    rootContainerIdentifier: {
                        id: cloudId,
                        type: 'SITE',
                        ari: `${$ccb3637438790056$var$SITE_ARI_PREFIX}${cloudId}`
                    },
                    deduplicateId: id,
                    icon: {
                        type: 'URL',
                        value: iconUrl
                    },
                    id: id,
                    localResourceId: localResourceId,
                    name: name,
                    product: product,
                    subProduct: null,
                    type: type,
                    url: url
                },
                timestamp: timestamp
            };
        });
    }
});
parcelRegister("7trIV", function(module, exports) {
    $parcel$export(module.exports, "ActivityClientV3", ()=>$36bf5d2659940c95$export$3c3c237c92ca1fb9);
    var $6fYNv;
    var $3l0ly;
    var $1b4ym;
    var $cXq43;
    var $e35Gx;
    var $dMJiM;
    var $4HxlV;
    var $fTeQf;
    var $jkCM1;
    var $65vGW;
    var $3LJ9C;
    var $3Bknq;
    var $55Gxu;
    var $66K4V;
    var $hTLIi;
    const $36bf5d2659940c95$var$CONFLUENCE_COMMENT_TYPENAMES = [
        'ConfluenceComment',
        'ConfluenceFooterComment',
        'ConfluenceInlineComment'
    ];
    const $36bf5d2659940c95$var$IGNORED_HTTP_ERRORS = new Map([
        [
            401,
            [
                /.*/
            ]
        ],
        [
            403,
            [
                /Invalid CORS request/
            ]
        ]
    ]);
    const $36bf5d2659940c95$var$IGNORED_ERROR_MESSAGES = [
        'The operation was aborted.'
    ];
    const $36bf5d2659940c95$var$DEFAULT_TAGS = {
        source: (0, (0, parcelRequire("1b4ym")).packageName),
        sourcePackageVersion: (0, (0, parcelRequire("1b4ym")).packageVersion)
    };
    class $36bf5d2659940c95$export$3c3c237c92ca1fb9 extends (0, (0, parcelRequire("3Bknq")).ActivityClient) {
        constructor(product, baseUrl, logger, configFetch){
            super('v3', product, {
                'X-ExperimentalApi': 'ActivityV3Api'
            }, baseUrl), this.setProduct = (product)=>{
                this.product = product;
            }, this.captureException = (error, tags)=>{
                if (this.clientHandlers) this.clientHandlers.captureException(error, {
                    ...$36bf5d2659940c95$var$DEFAULT_TAGS,
                    ...tags
                });
            }, this.captureWarning = (message, tags)=>{
                if (this.clientHandlers) this.clientHandlers.captureWarning(message, {
                    ...$36bf5d2659940c95$var$DEFAULT_TAGS,
                    ...tags
                });
            }, this.fetchHydratorConfig = async ()=>await this.hydratorConfigClient.fetchConfig(), this.handleGraphQLErrors = (errors)=>{
                const invalidFragments = [];
                if (Array.isArray(errors)) {
                    for (const err of errors){
                        this.captureException(new (0, (0, parcelRequire("4HxlV")).GraphQLJSError)(err));
                        const invalidFragment = (0, (0, parcelRequire("55Gxu")).default)(err);
                        if (invalidFragment) invalidFragments.push(invalidFragment);
                    }
                    return invalidFragments;
                }
                return [];
            }, this.fetchActivitiesV3 = async (experience, retryMS, filters, activityQueries, deduplicateActivities = true)=>{
                let { fragments: fragments, hydrators: hydrators } = await this.fetchHydratorConfig();
                experience.mark('GeneratedQueryWithFilters_start');
                let response;
                try {
                    response = await (0, (0, parcelRequire("6fYNv")).retryOnException)(async ()=>{
                        const request = (0, (0, parcelRequire("66K4V")).generateGraphQLRequest)(this.product, filters, activityQueries, fragments);
                        experience.mark('GeneratedQueryWithFilters_end');
                        experience.mark('FetchedActivities_start');
                        experience.addMetadata({
                            filters: (0, (0, parcelRequire("hTLIi")).filtersToMetadata)(filters)
                        });
                        const res = await (0, (0, parcelRequire("e35Gx")).postResource)(this.baseUrl, request, retryMS, {
                            ...this.headers
                        });
                        experience.mark('FetchedActivities_end');
                        const invalidFragments = this.handleGraphQLErrors(res?.errors);
                        if (invalidFragments.length > 0) {
                            fragments = (0, (0, parcelRequire("hTLIi")).filterInvalidFragments)(invalidFragments, fragments);
                            throw new (0, (0, parcelRequire("dMJiM")).GraphQLFragmentError)(`Missing fragments: [${invalidFragments.toString()}]`);
                        }
                        return res;
                    }, {
                        intervalsMS: [
                            0,
                            0,
                            0
                        ],
                        retryOn: (err)=>[
                                (0, (0, parcelRequire("dMJiM")).GraphQLFragmentError)
                            ].some((retriableErr)=>err instanceof retriableErr),
                        captureException: this.captureException
                    });
                } catch (error) {
                    if (!error || !$36bf5d2659940c95$var$IGNORED_HTTP_ERRORS.get(error.statusCode)?.some((regExp)=>regExp.test(error.message)) && !$36bf5d2659940c95$var$IGNORED_ERROR_MESSAGES.includes(error.message)) throw error;
                }
                if ((0, (0, parcelRequire("hTLIi")).isEmptyActivitiesWithErrorsResponse)(response)) throw new (0, (0, parcelRequire("fTeQf")).GraphQLNoResultsError)(response.errors);
                if (!response || !response.data?.activity) return {
                    workedOn: [],
                    viewed: [],
                    all: []
                };
                experience.mark('TransformedActivityItems_start');
                const workedOn = $36bf5d2659940c95$var$transformActivityItem('workedOn', (0, (0, parcelRequire("hTLIi")).activityRoot)(response.data.activity)?.workedOn?.edges || [], hydrators, this.captureException);
                const viewed = $36bf5d2659940c95$var$transformActivityItem('viewed', response.data.activity?.myActivity?.viewed?.edges || [], hydrators, this.captureException);
                const all = $36bf5d2659940c95$var$transformActivityItem('all', (0, (0, parcelRequire("hTLIi")).activityRoot)(response.data.activity)?.all?.edges || [], hydrators, this.captureException);
                experience.mark('TransformedActivityItems_end');
                const activities = {
                    viewed: viewed,
                    workedOn: workedOn,
                    all: all
                };
                return deduplicateActivities ? (0, (0, parcelRequire("hTLIi")).rollupActivitiesData)(activities) : activities;
            }, this.fetchActivities = async (retryMS, filters, activityQueries, deduplicateActivities = true)=>{
                return (0, (0, parcelRequire("cXq43")).fetchActivitiesWithExperience)((experience)=>this.fetchActivitiesV3(experience, retryMS, filters, activityQueries, deduplicateActivities), 'v3');
            };
            this.clientHandlers = logger;
            this.hydratorConfigClient = new (0, (0, parcelRequire("3LJ9C")).default)({
                captureException: this.captureException,
                captureWarning: this.captureWarning
            }, product, configFetch);
        }
    }
    function $36bf5d2659940c95$var$transformActivityItem(query, activities, hydrators, captureException) {
        return activities.reduce((acc, item)=>{
            if (item && item.node && item.node.object && item.node.event) {
                const { object: object, event: event } = item.node;
                if (!object.product || !object.type) return acc;
                const containers = [];
                let c = object.contributors || [];
                const contributors = c.reduce((contributors, contributor)=>{
                    if (contributor.profile) {
                        const { accountId: accountId, picture: picture } = contributor.profile;
                        contributors.push({
                            accountId: accountId,
                            name: contributor.profile.name,
                            picture: picture
                        });
                    }
                    return contributors;
                }, []);
                const hydratedData = (0, (0, parcelRequire("jkCM1")).hydratePolymorphicData)(hydrators, object.data, captureException);
                if (hydratedData) {
                    if (hydratedData.key) containers.push({
                        name: (0, (0, parcelRequire("65vGW")).hydratedValueToString)(hydratedData.key, ' ')
                    });
                    if (hydratedData.containers) containers.push({
                        name: (0, (0, parcelRequire("65vGW")).hydratedValueToString)(hydratedData.containers, ' ')
                    });
                    const actor = event.actor ? {
                        name: event.actor.name,
                        picture: event.actor.picture,
                        accountId: event.actor.accountId
                    } : undefined;
                    const eventType = object.type === 'comment' && event.eventType === (0, (0, parcelRequire("3l0ly")).WORKED_EVENT).CREATED ? (0, (0, parcelRequire("3l0ly")).WORKED_EVENT).COMMENTED : event.eventType;
                    acc.push({
                        actor: actor,
                        query: query,
                        containers: containers,
                        contributors: contributors,
                        eventType: eventType,
                        object: {
                            rootContainerIdentifier: (0, (0, parcelRequire("hTLIi")).parseRootContainerARI)(object.rootContainerId),
                            icon: $36bf5d2659940c95$var$CONFLUENCE_COMMENT_TYPENAMES.includes(object.data.__typename) ? (0, (0, parcelRequire("65vGW")).hydrateConfluenceIcon)(object.data?.container?.__typename, hydratedData.icon, hydratedData.staticFallbacks) : (0, (0, parcelRequire("65vGW")).hydrateIcon)(hydratedData.icon, hydratedData.staticFallbacks),
                            id: object.id,
                            deduplicateId: (0, (0, parcelRequire("65vGW")).hydratedValueToString)(hydratedData.deduplicateId) || object.id,
                            localResourceId: (0, (0, parcelRequire("65vGW")).hydratedValueToString)(hydratedData.localResourceId),
                            name: (0, (0, parcelRequire("65vGW")).hydratedValueToString)(hydratedData.name, ' '),
                            product: object.product,
                            subProduct: object.subProduct,
                            type: object.type,
                            url: (0, (0, parcelRequire("65vGW")).hydratedValueToString)(hydratedData.url)
                        },
                        timestamp: event.timestamp
                    });
                }
            }
            return acc;
        }, []);
    }
});
parcelRegister("dMJiM", function(module, exports) {
    $parcel$export(module.exports, "GraphQLFragmentError", ()=>$37a211a3da9949b9$export$2d1b192199788179);
    class $37a211a3da9949b9$export$2d1b192199788179 extends Error {
        constructor(message){
            super(message);
            this.name = 'GraphQLFragmentError';
            this.message = message;
        }
    }
});
parcelRegister("4HxlV", function(module, exports) {
    $parcel$export(module.exports, "GraphQLJSError", ()=>$098e0a3de69a420c$export$8d4af49ee2a0fbe2);
    class $098e0a3de69a420c$export$8d4af49ee2a0fbe2 extends Error {
        constructor(graphQLError){
            super(graphQLError.message);
            this.name = 'GraphQLJSError';
            this.error = graphQLError;
            this.message = graphQLError.message;
        }
    }
});
parcelRegister("fTeQf", function(module, exports) {
    $parcel$export(module.exports, "GraphQLNoResultsError", ()=>$9ec383f2a327fd66$export$3f19ff30d409b70);
    class $9ec383f2a327fd66$export$3f19ff30d409b70 extends Error {
        constructor(graphQLErrors){
            super();
            this.name = 'GraphQLNoResultsError';
            this.errors = graphQLErrors;
            this.message = 'GraphQL returned errors & no results';
            this.errorMessages = graphQLErrors.map((error)=>error.message);
        }
    }
});
parcelRegister("jkCM1", function(module, exports) {
    $parcel$export(module.exports, "hydratePolymorphicData", ()=>$d64b966f022ff0ad$export$d658049bf1a63492);
    var $9XE6b = parcelRequire("9XE6b");
    var $9cIED;
    const $d64b966f022ff0ad$export$d658049bf1a63492 = (hydrators, data, captureException)=>{
        if (data) {
            if ('__typename' in data) {
                const hydrator = hydrators[data.__typename];
                if (hydrator) try {
                    return $d64b966f022ff0ad$var$hydrateData(data, hydrator);
                } catch (error) {
                    captureException && captureException(new (0, (0, parcelRequire("9cIED")).default)({
                        error: error,
                        message: `Hydrator failed for [${data.__typename}].`
                    }));
                }
                else captureException && captureException(new (0, (0, parcelRequire("9cIED")).default)({
                    message: `Missing hydrator for [${data.__typename}].`
                }));
            } else captureException && captureException(new (0, (0, parcelRequire("9cIED")).default)({
                message: `Missing [__typename] field from data.`
            }));
        }
        return null;
    };
    function $d64b966f022ff0ad$var$getOrSearch(object, path) {
        if (!object) return object;
        if (path.includes(':')) {
            const [searchField, searchValue] = path.split(':');
            return $d64b966f022ff0ad$var$findNodeByField(object, searchField.trim(), searchValue.trim().replace(/"/g, ''));
        }
        return (0, ($parcel$interopDefault($9XE6b)))(object, path);
    }
    function $d64b966f022ff0ad$var$resolvePath(object, path) {
        const splitPath = path.split(/\(|\)./);
        let current = object;
        for (const split of splitPath)current = $d64b966f022ff0ad$var$getOrSearch(current, split);
        return current;
    }
    function $d64b966f022ff0ad$var$findNodeByField(edges, fieldId, searchValue) {
        return edges.find((edge)=>(0, ($parcel$interopDefault($9XE6b)))(edge, fieldId) === searchValue);
    }
    function $d64b966f022ff0ad$export$a5c4301012ad6f07(object, paths) {
        return paths.map((path)=>$d64b966f022ff0ad$var$resolvePath(object, path));
    }
    const $d64b966f022ff0ad$var$hydrateData = (data, hydrator)=>{
        const { hydratorPaths: hydratorPaths, staticFallbacks: staticFallbacks } = hydrator;
        return {
            staticFallbacks: staticFallbacks,
            ...Object.entries(hydratorPaths).reduce((acc, [key, dataValue])=>{
                const item = $d64b966f022ff0ad$export$a5c4301012ad6f07(data, dataValue);
                if (item) acc[key] = item;
                else throw new Error(`Bad hydrator path: ${key}`);
                return acc;
            }, {})
        };
    };
});
parcelRegister("9cIED", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5eebec53575108e7$export$2e2bcd8739ae039);
    class $5eebec53575108e7$export$2e2bcd8739ae039 extends Error {
        constructor({ error: error, message: message }){
            super();
            const err = error instanceof Error ? error : new Error();
            this.name = 'HydratorError';
            this.message = message;
            this.originalMessage = err.message;
            this.stack = err.stack;
            this.originalName = err.name;
        }
    }
});
parcelRegister("65vGW", function(module, exports) {
    $parcel$export(module.exports, "hydratedValueToString", ()=>$e885246460d7ca94$export$c5cea44a1f75b431);
    $parcel$export(module.exports, "hydrateConfluenceIcon", ()=>$e885246460d7ca94$export$86b9f44277b105a6);
    $parcel$export(module.exports, "hydrateIcon", ()=>$e885246460d7ca94$export$a328b2bb0d21d984);
    const $e885246460d7ca94$export$c5cea44a1f75b431 = (value, separator = '')=>{
        if (!value) return null;
        return Array.isArray(value) ? value.join(separator) : value;
    };
    function $e885246460d7ca94$var$isURL(icon) {
        return typeof icon === 'string';
    }
    function $e885246460d7ca94$var$isValidEmoji(icon) {
        return typeof icon === 'object' && icon.value !== undefined && !!icon.value;
    }
    const $e885246460d7ca94$export$86b9f44277b105a6 = (confluenceContainerType, icons, fallbacks)=>{
        switch(confluenceContainerType){
            case 'ConfluenceBlogPost':
                return $e885246460d7ca94$export$a328b2bb0d21d984(icons, fallbacks, 'confluenceBlogIcon') || $e885246460d7ca94$export$a328b2bb0d21d984(icons, fallbacks);
            case 'ConfluencePage':
                return $e885246460d7ca94$export$a328b2bb0d21d984(icons, fallbacks, 'confluencePageIcon') || $e885246460d7ca94$export$a328b2bb0d21d984(icons, fallbacks);
            default:
                return $e885246460d7ca94$export$a328b2bb0d21d984(icons, fallbacks);
        }
    };
    const $e885246460d7ca94$export$a328b2bb0d21d984 = (icons, fallbacks, fallbackKey = 'icon')=>{
        if (Array.isArray(icons) && icons.length > 0) {
            const emojiIcons = icons.filter($e885246460d7ca94$var$isValidEmoji);
            if (emojiIcons.length > 0) return {
                type: 'EMOJI',
                value: emojiIcons[0].value,
                fallback: fallbacks?.[fallbackKey]
            };
            const urlIcons = icons.filter($e885246460d7ca94$var$isURL);
            if (urlIcons.length > 0) {
                const hydratedIcons = $e885246460d7ca94$export$c5cea44a1f75b431(urlIcons);
                if (hydratedIcons !== null) return {
                    type: 'URL',
                    value: hydratedIcons
                };
            }
        }
        if (fallbacks && fallbackKey in fallbacks && fallbacks[fallbackKey]) return {
            type: 'URL',
            value: fallbacks[fallbackKey]
        };
        return null;
    };
});
parcelRegister("3LJ9C", function(module, exports) {
    $parcel$export(module.exports, "FD_CLIENT_FETCH_PROPS", ()=>$974e1d856d308c8e$export$c270c412a04ff3e6);
    $parcel$export(module.exports, "default", ()=>$974e1d856d308c8e$export$2e2bcd8739ae039);
    var $6HV40;
    var $4Zo3D;
    const $974e1d856d308c8e$var$RECENT_WORK_ARTIFACT = 'recent-work-service';
    const $974e1d856d308c8e$var$FD_ENVIRONMENT = 'prod';
    const $974e1d856d308c8e$export$c270c412a04ff3e6 = {
        name: $974e1d856d308c8e$var$RECENT_WORK_ARTIFACT,
        dimensions: {
            environmentType: $974e1d856d308c8e$var$FD_ENVIRONMENT
        }
    };
    class $974e1d856d308c8e$export$2e2bcd8739ae039 {
        constructor(handlers, product, artifactFetch){
            this.fetchConfig = async ()=>{
                const artifact = await this.fetchArtifact();
                const { queryFragments: fragments, hydrators: hydrators } = artifact;
                return {
                    fragments: fragments,
                    hydrators: hydrators
                };
            };
            this.flightDeck = new (0, (0, parcelRequire("6HV40")).default)(product || 'recent-work-client', {
                handlers: handlers
            }, [
                {
                    name: 'recent-work-service',
                    dimensions: {
                        environmentType: $974e1d856d308c8e$var$FD_ENVIRONMENT
                    },
                    value: (0, (0, parcelRequire("4Zo3D")).default)
                }
            ]);
            this.artifactFetch = artifactFetch;
        }
        async fetchArtifact() {
            if (this.artifactFetch) return this.artifactFetch();
            return this.flightDeck.fetchConfigFromFlightDeck($974e1d856d308c8e$export$c270c412a04ff3e6, {
                intervalsMS: [
                    100,
                    500
                ]
            });
        }
    }
});
parcelRegister("4Zo3D", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$cc65f19f715aa294$export$2e2bcd8739ae039);
    var $cc65f19f715aa294$export$2e2bcd8739ae039 = {
        localization: {
            eventTypes: {
                commented: {
                    absolute: 'You commented on {absoluteTime}',
                    relative: 'You commented {relativeTime}',
                    standalone: 'You commented',
                    multiAbsolute: 'Commented on {absoluteTime}',
                    multiRelative: 'Commented {relativeTime}',
                    multiStandalone: 'Commented'
                },
                created: {
                    absolute: 'You created on {absoluteTime}',
                    relative: 'You created {relativeTime}',
                    standalone: 'You created',
                    multiAbsolute: 'Created on {absoluteTime}',
                    multiRelative: 'Created {relativeTime}',
                    multiStandalone: 'Created'
                },
                edited: {
                    absolute: 'You edited on {absoluteTime}',
                    relative: 'You edited {relativeTime}',
                    standalone: 'You edited',
                    multiAbsolute: 'Edited on {absoluteTime}',
                    multiRelative: 'Edited {relativeTime}',
                    multiStandalone: 'Edited'
                },
                published: {
                    absolute: 'You published on {absoluteTime}',
                    relative: 'You published {relativeTime}',
                    standalone: 'You published',
                    multiAbsolute: 'Published on {absoluteTime}',
                    multiRelative: 'Published {relativeTime}',
                    multiStandalone: 'Published'
                },
                updated: {
                    absolute: 'You updated on {absoluteTime}',
                    relative: 'You updated {relativeTime}',
                    standalone: 'You updated',
                    multiAbsolute: 'Updated on {absoluteTime}',
                    multiRelative: 'Updated {relativeTime}',
                    multiStandalone: 'Updated'
                },
                viewed: {
                    absolute: 'You viewed on {absoluteTime}',
                    relative: 'You viewed {relativeTime}',
                    standalone: 'You viewed',
                    multiAbsolute: 'Viewed on {absoluteTime}',
                    multiRelative: 'Viewed {relativeTime}',
                    multiStandalone: 'Viewed'
                }
            }
        },
        hydrators: {
            TownsquareGoal: {
                hydratorPaths: {
                    id: [
                        'id'
                    ],
                    key: [
                        'key'
                    ],
                    name: [
                        'name'
                    ],
                    url: [
                        'url'
                    ],
                    icon: [
                        'iconData'
                    ]
                }
            },
            TownsquareProject: {
                hydratorPaths: {
                    id: [
                        'id'
                    ],
                    key: [
                        'key'
                    ],
                    name: [
                        'name'
                    ],
                    url: [
                        'url'
                    ],
                    icon: [
                        'iconData'
                    ]
                }
            },
            TownsquareComment: {
                hydratorPaths: {
                    id: [
                        'id'
                    ],
                    key: [
                        'container.key'
                    ],
                    name: [
                        'container.name'
                    ],
                    url: [
                        'container.url'
                    ],
                    icon: [
                        'container.iconData'
                    ],
                    deduplicateId: [
                        'container.id'
                    ]
                }
            },
            ConfluencePage: {
                hydratorPaths: {
                    id: [
                        'id'
                    ],
                    name: [
                        'title'
                    ],
                    localResourceId: [
                        'pageId'
                    ],
                    url: [
                        'links.base',
                        'links.webUi'
                    ],
                    containers: [
                        'space.name'
                    ]
                },
                staticFallbacks: {
                    icon: 'https://fd-assets.prod.atl-paas.net/image/misc-icons/confluence/page.svg'
                }
            },
            ConfluenceBlogPost: {
                hydratorPaths: {
                    id: [
                        'id'
                    ],
                    name: [
                        'title'
                    ],
                    localResourceId: [
                        'blogPostId'
                    ],
                    url: [
                        'links.base',
                        'links.webUi'
                    ],
                    containers: [
                        'space.name'
                    ]
                },
                staticFallbacks: {
                    icon: 'https://fd-assets.prod.atl-paas.net/image/misc-icons/confluence/blogpost.svg'
                }
            },
            ConfluenceComment: {
                hydratorPaths: {
                    id: [
                        'id'
                    ],
                    name: [
                        'container.title'
                    ],
                    url: [
                        'links.base',
                        'links.webUi'
                    ],
                    containers: [
                        'container.space.name'
                    ],
                    deduplicateId: [
                        'container.id'
                    ]
                },
                staticFallbacks: {
                    icon: 'https://fd-assets.prod.atl-paas.net/image/misc-icons/confluence/page.svg',
                    confluenceBlogIcon: 'https://fd-assets.prod.atl-paas.net/image/misc-icons/confluence/blogpost.svg',
                    confluencePageIcon: 'https://fd-assets.prod.atl-paas.net/image/misc-icons/confluence/page.svg'
                }
            },
            ConfluenceFooterComment: {
                hydratorPaths: {
                    id: [
                        'id'
                    ],
                    name: [
                        'container.title'
                    ],
                    url: [
                        'links.base',
                        'links.webUi'
                    ],
                    containers: [
                        'container.space.name'
                    ],
                    deduplicateId: [
                        'container.id'
                    ]
                },
                staticFallbacks: {
                    icon: 'https://fd-assets.prod.atl-paas.net/image/misc-icons/confluence/page.svg',
                    confluenceBlogIcon: 'https://fd-assets.prod.atl-paas.net/image/misc-icons/confluence/blogpost.svg',
                    confluencePageIcon: 'https://fd-assets.prod.atl-paas.net/image/misc-icons/confluence/page.svg'
                }
            },
            ConfluenceInlineComment: {
                hydratorPaths: {
                    id: [
                        'id'
                    ],
                    name: [
                        'container.title'
                    ],
                    url: [
                        'links.base',
                        'links.webUi'
                    ],
                    containers: [
                        'container.space.name'
                    ],
                    deduplicateId: [
                        'container.id'
                    ]
                },
                staticFallbacks: {
                    icon: 'https://fd-assets.prod.atl-paas.net/image/misc-icons/confluence/page.svg',
                    confluenceBlogIcon: 'https://fd-assets.prod.atl-paas.net/image/misc-icons/confluence/blogpost.svg',
                    confluencePageIcon: 'https://fd-assets.prod.atl-paas.net/image/misc-icons/confluence/page.svg'
                }
            },
            JiraIssue: {
                hydratorPaths: {
                    id: [
                        'id'
                    ],
                    name: [
                        'fieldsById.edges(node.fieldId: "summary").node.text'
                    ],
                    url: [
                        'webUrl'
                    ],
                    containers: [
                        'fieldsById.edges(node.fieldId: "project").node.project.name'
                    ],
                    icon: [
                        'fieldsById.edges(node.fieldId: "issuetype").node.issueType.avatar.xsmall'
                    ],
                    key: [
                        'key'
                    ]
                }
            },
            JiraPlatformComment: {
                hydratorPaths: {
                    id: [
                        'commentId'
                    ],
                    name: [
                        'issue.fieldsById.edges(node.fieldId: "summary").node.text'
                    ],
                    url: [
                        'webUrl'
                    ],
                    containers: [
                        'issue.fieldsById.edges(node.fieldId: "project").node.project.name'
                    ],
                    icon: [
                        'issue.fieldsById.edges(node.fieldId: "issuetype").node.issueType.avatar.xsmall'
                    ],
                    key: [
                        'issue.key'
                    ],
                    deduplicateId: [
                        'issue.id'
                    ]
                }
            },
            JiraServiceManagementComment: {
                hydratorPaths: {
                    id: [
                        'commentId'
                    ],
                    name: [
                        'issue.fieldsById.edges(node.fieldId: "summary").node.text'
                    ],
                    url: [
                        'webUrl'
                    ],
                    containers: [
                        'issue.fieldsById.edges(node.fieldId: "project").node.project.name'
                    ],
                    icon: [
                        'issue.fieldsById.edges(node.fieldId: "issuetype").node.issueType.avatar.xsmall'
                    ],
                    key: [
                        'issue.key'
                    ],
                    deduplicateId: [
                        'issue.id'
                    ]
                }
            }
        },
        queryFragments: '\n\n  fragment townsquareGoal on TownsquareGoal {\n    id\n    key\n    name\n    url\n    iconData\n  }\n\n\n  fragment townsquareProject on TownsquareProject {\n    id\n    key\n    name\n    url\n    iconData\n  }\n\n\n  fragment townsquareComment on TownsquareComment {\n    id\n    url\n    container {\n      __typename\n      ...townsquareGoal\n      ...townsquareProject\n    }\n  }\n\n\n  fragment confluencePage on ConfluencePage {\n    id\n    title\n    pageId\n    links {\n      base\n      webUi\n    }\n    space {\n      name\n    }\n  }\n\n\n  fragment confluenceBlogPost on ConfluenceBlogPost {\n    id\n    title\n    blogPostId\n    links {\n      base\n      webUi\n    }\n    space {\n      name\n    }\n  }\n\n\n  fragment confluenceComment on ConfluenceComment {\n    id\n    links {\n      base\n      webUi\n    }\n    container {\n      __typename\n      ...confluenceBlogPost\n      ...confluencePage\n    }\n  }\n\n\n  fragment confluenceFooterComment on ConfluenceFooterComment {\n    id\n    links {\n      base\n      webUi\n    }\n    container {\n      __typename\n      ...confluenceBlogPost\n      ...confluencePage\n    }\n  }\n\n\n  fragment confluenceInlineComment on ConfluenceInlineComment {\n    id\n    links {\n      base\n      webUi\n    }\n    container {\n      __typename\n      ...confluenceBlogPost\n      ...confluencePage\n    }\n  }\n\n\nfragment jiraIssue on JiraIssue {\n  id\n  key\n  webUrl\n  fieldsById(ids: ["summary", "issuetype", "project"]) {\n    edges {\n      node {\n        __typename\n        fieldId\n        ...jiraSingleLineTextField\n        ...jiraIssueTypeField\n        ...jiraProjectField\n      }\n    }\n  }\n}\nfragment jiraSingleLineTextField on JiraSingleLineTextField {\n  text\n}\nfragment jiraIssueTypeField on JiraIssueTypeField {\n  issueType {\n    avatar {\n      xsmall\n    }\n  }\n}\nfragment jiraProjectField on JiraProjectField {\n  project {\n    name\n  }\n}\n\n\nfragment jiraPlatformComment on JiraPlatformComment {\n  commentId\n  webUrl\n  issue {\n    ...jiraIssue\n  }\n}\n\n\nfragment jiraServiceManagementComment on JiraServiceManagementComment {\n  commentId\n  webUrl\n  issue {\n    ...jiraIssue\n  }\n}\n\nfragment activityItemEdge on ActivityItemEdge {\n  cursor\n  node {\n    id\n    object {\n      id\n      type\n      product\n      subProduct\n      rootContainerId\n      contributors {\n        profile {\n          name\n          picture\n          accountId\n        }\n      }\n      data {\n        __typename\n\t...townsquareGoal\n\t...townsquareProject\n\t...townsquareComment\n\t...confluencePage\n\t...confluenceBlogPost\n\t...confluenceComment\n\t...confluenceFooterComment\n\t...confluenceInlineComment\n\t...jiraIssue\n\t...jiraPlatformComment\n\t...jiraServiceManagementComment\n      }\n    }\n    event {\n      id\n      timestamp\n      eventType\n      actor {\n        name\n        picture\n        accountId\n      }\n    }\n  }\n}\nfragment activityItemConnection on ActivityConnection {\n  edges {\n    ...activityItemEdge\n  }\n}\n\n'
    };
});
parcelRegister("55Gxu", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$33cd97b94b378eac$export$2e2bcd8739ae039);
    var $fQ0JV;
    const $33cd97b94b378eac$var$errorHandlerMap = new Map([
        [
            'ValidationError',
            (0, (0, parcelRequire("fQ0JV")).default)
        ]
    ]);
    const $33cd97b94b378eac$var$graphQLErrorHandler = (err)=>{
        const errorHandler = $33cd97b94b378eac$var$errorHandlerMap.get(err.extensions.classification);
        if (typeof errorHandler === 'function') return errorHandler(err);
        return null;
    };
    var $33cd97b94b378eac$export$2e2bcd8739ae039 = $33cd97b94b378eac$var$graphQLErrorHandler;
});
parcelRegister("fQ0JV", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$cc94d91a337842e7$export$2e2bcd8739ae039);
    const $cc94d91a337842e7$var$captureRegex = new RegExp(/^Validation error.*?@ '(\w+)/);
    const $cc94d91a337842e7$var$validationErrorHandler = (graphQLError)=>{
        const invalidFragmentMatch = $cc94d91a337842e7$var$captureRegex.exec(graphQLError.message);
        if (Array.isArray(invalidFragmentMatch)) {
            const invalidFragment = invalidFragmentMatch[1];
            if (invalidFragment) return invalidFragment;
        }
        return null;
    };
    var $cc94d91a337842e7$export$2e2bcd8739ae039 = $cc94d91a337842e7$var$validationErrorHandler;
});
parcelRegister("66K4V", function(module, exports) {
    $parcel$export(module.exports, "generateGraphQLRequest", ()=>$cf1fca899d4c9068$export$7489a6ef09862e48);
    var $f3gfD;
    var $dcvAS;
    const $cf1fca899d4c9068$var$ACTIVITIES_LIMIT = 50;
    const $cf1fca899d4c9068$var$WORKED_ON_QUERY = `
   workedOn(first: $first, filter: $filter) {
     ...activityItemConnection
   }
`;
    const $cf1fca899d4c9068$var$VIEWED__QUERY = `
   viewed(first: $first, filter: $filter) {
     ...activityItemConnection
   }
`;
    const $cf1fca899d4c9068$var$ALL__QUERY = `
    all(first: $first, filter: $filter) {
      ...activityItemConnection
    }
`;
    const $cf1fca899d4c9068$var$activityQueryMap = new Map([
        [
            'workedOn',
            $cf1fca899d4c9068$var$WORKED_ON_QUERY
        ],
        [
            'viewed',
            $cf1fca899d4c9068$var$VIEWED__QUERY
        ],
        [
            'all',
            $cf1fca899d4c9068$var$ALL__QUERY
        ]
    ]);
    const $cf1fca899d4c9068$var$getMyActivitiesQuery = (queries)=>`
      myActivity {
        ${queries.join('\n')}
      }
`;
    const $cf1fca899d4c9068$var$getActivitiesQuery = (product, content, fragments, activityFilterType = 'ActivityFilter')=>`
    query ${(0, (0, parcelRequire("f3gfD")).getOperationName)(product)}($first: Int, $filter: ${activityFilterType}) {
      activity {
        ${content}
      }
    }
${fragments}
`;
    const $cf1fca899d4c9068$export$855cd08371c65b8c = (product, filters, activityQueries, fragments)=>{
        if (Array.isArray(filters.actors)) {
            const filteredAccountQueries = activityQueries.filter((query)=>query !== 'viewed');
            return {
                query: $cf1fca899d4c9068$var$getActivitiesQuery(product, filteredAccountQueries.map((query)=>$cf1fca899d4c9068$var$activityQueryMap.get(query)).join('\n'), fragments, 'ActivityFilter'),
                queryFilters: (0, (0, parcelRequire("dcvAS")).ACTIVITY_FILTER_COLLECTION).v3.get('activities')(filters)
            };
        } else return {
            query: $cf1fca899d4c9068$var$getActivitiesQuery(product, $cf1fca899d4c9068$var$getMyActivitiesQuery(activityQueries.map((query)=>$cf1fca899d4c9068$var$activityQueryMap.get(query))), fragments, 'MyActivityFilter'),
            queryFilters: (0, (0, parcelRequire("dcvAS")).ACTIVITY_FILTER_COLLECTION).v3.get('myActivity')(filters)
        };
    };
    const $cf1fca899d4c9068$export$7489a6ef09862e48 = (product, filters, activityQueries, fragments)=>{
        const { limit: limit = $cf1fca899d4c9068$var$ACTIVITIES_LIMIT, ...restFilters } = filters;
        const { query: query, queryFilters: queryFilters } = $cf1fca899d4c9068$export$855cd08371c65b8c(product, restFilters, activityQueries, fragments);
        return {
            operationName: (0, (0, parcelRequire("f3gfD")).getOperationName)(product),
            query: query,
            variables: {
                first: limit,
                filter: queryFilters
            }
        };
    };
});
parcelRegister("hTLIi", function(module, exports) {
    $parcel$export(module.exports, "rollupActivitiesData", ()=>$56093000e314999c$export$750d93207e30f59a);
    $parcel$export(module.exports, "activityRoot", ()=>$56093000e314999c$export$ea55e8e0446efa94);
    $parcel$export(module.exports, "parseRootContainerARI", ()=>$56093000e314999c$export$788e6013936a6bb4);
    $parcel$export(module.exports, "filtersToMetadata", ()=>$56093000e314999c$export$e8f56bed6776c7ea);
    $parcel$export(module.exports, "filterInvalidFragments", ()=>$56093000e314999c$export$e22863ec502608d2);
    $parcel$export(module.exports, "isEmptyActivitiesWithErrorsResponse", ()=>$56093000e314999c$export$c939d6148e47244a);
    function $56093000e314999c$export$750d93207e30f59a(activitiesData) {
        const { all: all, viewed: viewed, workedOn: workedOn } = activitiesData;
        return {
            all: $56093000e314999c$var$rollUpActivityItems(all),
            viewed: $56093000e314999c$var$rollUpActivityItems(viewed),
            workedOn: $56093000e314999c$var$rollUpActivityItems(workedOn)
        };
    }
    function $56093000e314999c$var$rollUpActivityItems(activityItems) {
        const latestActivityItemsObjectWithLatestTimestamp = activityItems.reduce((acc, activityItem)=>{
            const deduplicateId = activityItem.object.deduplicateId || activityItem.object.id;
            const existingItem = acc[deduplicateId];
            if (existingItem) {
                const aggregatedItems = existingItem.aggregatedActivityItems || [];
                if (Date.parse(existingItem.timestamp) < Date.parse(activityItem.timestamp)) {
                    activityItem.aggregatedActivityItems = [
                        ...aggregatedItems,
                        existingItem
                    ];
                    delete acc[deduplicateId];
                    acc[deduplicateId] = activityItem;
                } else acc[deduplicateId].aggregatedActivityItems = [
                    ...aggregatedItems,
                    activityItem
                ];
            } else acc[deduplicateId] = activityItem;
            return acc;
        }, {});
        return Object.values(latestActivityItemsObjectWithLatestTimestamp);
    }
    const $56093000e314999c$export$213ba2e9f2d143b9 = (key)=>{
        return new RegExp(`fragment ${$56093000e314999c$var$fragmentName(key)} on ${$56093000e314999c$var$fragmentType(key)} ({(.|\\n)+?(?=fragment))`, 'gm');
    };
    const $56093000e314999c$var$fragmentName = (key)=>key.charAt(0).toLowerCase() + key.slice(1);
    const $56093000e314999c$var$fragmentType = (key)=>key.charAt(0).toUpperCase() + key.slice(1);
    const $56093000e314999c$export$ea55e8e0446efa94 = (activity)=>{
        if (activity.myActivity) return activity.myActivity;
        return activity;
    };
    const $56093000e314999c$var$SITE_ARI_PREFIX = 'ari:cloud:platform::site/';
    const $56093000e314999c$var$containerMapTypes = new Map([
        [
            $56093000e314999c$var$SITE_ARI_PREFIX,
            'SITE'
        ]
    ]);
    function $56093000e314999c$export$788e6013936a6bb4(rootContainerARI) {
        const ariSplitIndex = rootContainerARI.indexOf('/');
        return {
            ari: rootContainerARI,
            id: rootContainerARI.slice(ariSplitIndex + 1),
            type: $56093000e314999c$var$containerMapTypes.get(rootContainerARI.slice(0, ariSplitIndex + 1)) || 'OTHER'
        };
    }
    function $56093000e314999c$export$e8f56bed6776c7ea(filters) {
        return {
            ...filters,
            actors: filters.actors?.length,
            containerIds: filters.containerIds?.length,
            products: filters.products?.join(','),
            eventTypes: filters.eventTypes?.join(','),
            objectTypes: filters.objectTypes?.join(','),
            rootContainerIds: filters.rootContainerIds?.join(',')
        };
    }
    const $56093000e314999c$var$RESTRICTED_FRAGMENTS = [
        'activity',
        'all',
        'myActivity',
        'workedOn',
        'viewed',
        'activityItemConnection',
        'activityItemEdge'
    ];
    function $56093000e314999c$export$e22863ec502608d2(invalidFragments, allFragments) {
        return invalidFragments.filter((fragment)=>!$56093000e314999c$var$RESTRICTED_FRAGMENTS.includes(fragment)).reduce((acc, invalidFragment)=>{
            return acc.replace(new RegExp(`...${invalidFragment}\n`, 'g'), '').replace($56093000e314999c$export$213ba2e9f2d143b9(invalidFragment), '');
        }, allFragments);
    }
    const $56093000e314999c$var$IGNORED_ERROR_CLASSIFICATIONS = [
        'IncorrectAuthException'
    ];
    function $56093000e314999c$export$c939d6148e47244a(response) {
        if (!response?.data || !Array.isArray(response.errors)) return false;
        const filteredAggErrors = response.errors.filter((e)=>!e.extensions.classification || !$56093000e314999c$var$IGNORED_ERROR_CLASSIFICATIONS.includes(e.extensions.classification));
        return filteredAggErrors.length > 0 && $56093000e314999c$export$884573c560ed3600(response.data);
    }
    function $56093000e314999c$export$884573c560ed3600(queryData) {
        return !queryData.activity || $56093000e314999c$export$ea55e8e0446efa94(queryData.activity).all?.edges?.length === 0 && $56093000e314999c$export$ea55e8e0446efa94(queryData.activity).workedOn?.edges?.length === 0 && queryData.activity?.myActivity?.viewed?.edges?.length === 0;
    }
});
parcelRegister("2AbEM", function(module, exports) {
    $parcel$export(module.exports, "ThemeProvider", ()=>$7a9ddac47e3fba86$export$d8964aec282183a3);
    $parcel$export(module.exports, "useTheme", ()=>$7a9ddac47e3fba86$export$93d4e7f90805808f);
    var $5uXOq = parcelRequire("5uXOq");
    var $1UikQ = parcelRequire("1UikQ");
    const $7a9ddac47e3fba86$export$e6c62eb05a8288ed = {
        default: {
            default: {
                backgroundColor: `var(--ds-background-input, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
                color: `var(--ds-text-subtlest, ${(0, $829f609a65d26a98$export$f563ee71e9ee74cd)})`,
                borderColor: `var(--ds-border-input, ${(0, $829f609a65d26a98$export$d6447c357493214f)})`,
                borderWidth: "var(--ds-border-width, 1px)",
                iconColor: `var(--ds-icon-subtle, ${(0, $829f609a65d26a98$export$7090862dc3038a9f)})`
            },
            focus: {
                borderColor: `var(--ds-border-focused, ${(0, $829f609a65d26a98$export$ecfc1dff386a3e7a)})`,
                backgroundColor: `var(--ds-background-input-pressed, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
                boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${`var(--ds-border-input, ${(0, $829f609a65d26a98$export$d6447c357493214f)})`}`
            },
            hover: {
                backgroundColor: "var(--ds-background-input-hovered, rgba(222, 235, 255, 0.9))"
            }
        }
    };
    const $7a9ddac47e3fba86$var$getTheme = (searchCSS)=>{
        if (!searchCSS) return $7a9ddac47e3fba86$export$e6c62eb05a8288ed.default;
        return (0, ($parcel$interopDefault($1UikQ)))({}, $7a9ddac47e3fba86$export$e6c62eb05a8288ed.default, searchCSS);
    };
    const $7a9ddac47e3fba86$var$ctx = (0, $5uXOq.createContext)($7a9ddac47e3fba86$export$e6c62eb05a8288ed.default);
    const $7a9ddac47e3fba86$export$d8964aec282183a3 = ({ value: value, partialSearchCSS: partialSearchCSS, children: children })=>{
        const theme = $7a9ddac47e3fba86$var$getTheme(partialSearchCSS || value);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($7a9ddac47e3fba86$var$ctx.Provider, {
            value: theme
        }, children);
    };
    const $7a9ddac47e3fba86$export$93d4e7f90805808f = ()=>{
        return (0, $5uXOq.useContext)($7a9ddac47e3fba86$var$ctx);
    };
    const $7a9ddac47e3fba86$export$f9bb738f552c610d = $7a9ddac47e3fba86$var$ctx;
    const $7a9ddac47e3fba86$export$62640b580a501775 = (suppliedTheme)=>{
        return suppliedTheme;
    };
});
parcelRegister("6I8Kl", function(module, exports) {
    $parcel$export(module.exports, "SearchIcon", ()=>$4439160c76b81f6f$export$82eafebb825fc23f);
    var $5uXOq = parcelRequire("5uXOq");
    var $26g7Y;
    const $4439160c76b81f6f$export$82eafebb825fc23f = ({ isExpanded: isExpanded, theme: theme, size: size = 'small', primaryColor: primaryColor = `var(--ds-text, ${0, $829f609a65d26a98$export$7d61b15e0da132af})`, label: label = '' })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("26g7Y"))))), {
            label: label,
            LEGACY_primaryColor: isExpanded ? primaryColor : theme.default.color,
            LEGACY_size: size,
            color: isExpanded ? primaryColor : theme.default.color
        });
});
parcelRegister("b9NEf", function(module, exports) {
    $parcel$export(module.exports, "MobileSearchIconWrapper", ()=>$978931f79bc05084$export$63e083aca343a6ae);
    $parcel$export(module.exports, "DesktopSearchIconWrapper", ()=>$978931f79bc05084$export$9673cb6b61244e6e);
    $parcel$export(module.exports, "InputBoxOverlayRight", ()=>$978931f79bc05084$export$1da38d078e896a10);
    $parcel$export(module.exports, "ClearIconWrapper", ()=>$978931f79bc05084$export$ff9b1a25d343474d);
    $parcel$export(module.exports, "ArrowIconWrapper", ()=>$978931f79bc05084$export$54c466678ae7c638);
    $parcel$export(module.exports, "SearchInputContainer", ()=>$978931f79bc05084$export$c2b37b18a8b54130);
    $parcel$export(module.exports, "SearchInputField", ()=>$978931f79bc05084$export$b6261a2c5ea449d);
    $parcel$export(module.exports, "HiddenTooltip", ()=>$978931f79bc05084$export$ca6fe3402791d08e);
    $parcel$export(module.exports, "SSRsearchInputField", ()=>$978931f79bc05084$export$6d53dccb772ed720);
    $parcel$export(module.exports, "SSRsearchInputWrapper", ()=>$978931f79bc05084$export$c47d4a3e1f1297f1);
    $parcel$export(module.exports, "SSRformContainer", ()=>$978931f79bc05084$export$58ae19ee1fc7be8a);
    $parcel$export(module.exports, "SSRsearchInputContainer", ()=>$978931f79bc05084$export$b40f2abde293e8e4);
    $parcel$export(module.exports, "SSRdesktopSearchIconWrapper", ()=>$978931f79bc05084$export$eb4e9f55bbe045df);
    $parcel$export(module.exports, "SSRmobileSearchIconWrapper", ()=>$978931f79bc05084$export$3f33ed4b273b43d);
    var $f8Sb3;
    var $btzsC;
    var $3JZ8k;
    var $bWGt6 = parcelRequire("bWGt6");
    function $978931f79bc05084$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $978931f79bc05084$var$expandedPlaceholderColor = "var(--ds-text-subtlest, #B5BEC9)";
    const $978931f79bc05084$export$63e083aca343a6ae = (0, $bWGt6.default)("span", {
        target: "eq4kchp13"
    })("display:none;@media screen and (max-width: ", (0, (0, parcelRequire("3JZ8k")).dialogPageTakeoverWidth), "px){display:", (props)=>props.isExpanded ? 'none' : 'block', ";}");
    const $978931f79bc05084$export$9673cb6b61244e6e = (0, $bWGt6.default)('span', {
        target: "eq4kchp12"
    })("width:", (0, (0, parcelRequire("3JZ8k")).grid).multiple(2).px, ";height:", (0, (0, parcelRequire("3JZ8k")).grid).multiple(2).px, ";position:absolute;top:", (0, (0, parcelRequire("3JZ8k")).grid).px, ";left:", (0, (0, parcelRequire("3JZ8k")).grid).px, ";color:", (props)=>props.isExpanded ? `var(--ds-text, ${0, $829f609a65d26a98$export$fbda843f0a27fe96})` : props.default.color, ";display:inline-flex;align-items:baseline;:focus{box-shadow:0 0 0 2px ", `var(--ds-border-focused, ${(0, $829f609a65d26a98$export$215b7063051591f1)})`, ";border-radius:100%;outline:none;}&>span[role='img']{line-height:0;}@media screen and (max-width: ", (0, (0, parcelRequire("3JZ8k")).dialogPageTakeoverWidth), "px){display:none;}");
    const $978931f79bc05084$export$1da38d078e896a10 = (0, $bWGt6.default)('div', {
        target: "eq4kchp11"
    })("position:absolute;display:flex;top:0;right:0;height:100%;align-items:center;margin:auto 0;@media screen and (max-width: ", (0, (0, parcelRequire("3JZ8k")).dialogPageTakeoverWidth), "px){right:24px;}");
    const $978931f79bc05084$export$ff9b1a25d343474d = (0, $bWGt6.default)('div', {
        target: "eq4kchp10"
    })("width:", (0, (0, parcelRequire("3JZ8k")).grid).multiple(2).px, ";height:", (0, (0, parcelRequire("3JZ8k")).grid).multiple(2).px, ";padding:5px var(--ds-space-075, 6px);color:", `var(--ds-text-subtlest, ${(0, $829f609a65d26a98$export$5f71e19f3a7ad9de)})`, ";background-color:transparent;@media screen and (max-width: ", (0, (0, parcelRequire("3JZ8k")).dialogPageTakeoverWidth), "px){display:none;}:hover{cursor:pointer;color:", `var(--ds-icon, ${(0, $829f609a65d26a98$export$c39c0fe0f26207ae)})`, ";}&>span>svg{vertical-align:unset;}");
    const $978931f79bc05084$export$54c466678ae7c638 = (0, $bWGt6.default)('div', {
        target: "eq4kchp9"
    })("display:none;margin:0 ", (0, (0, parcelRequire("3JZ8k")).grid).px, ";height:", (0, (0, parcelRequire("3JZ8k")).grid).multiple(4).px, ";padding-bottom:", (0, (0, parcelRequire("3JZ8k")).grid).multiple(0.25).px, ";color:", (props)=>props.default.color, ";@media screen and (max-width: ", (0, (0, parcelRequire("3JZ8k")).dialogPageTakeoverWidth), "px){display:flex;align-items:center;}:hover{border-radius:100%;background-color:", (props)=>props.hover.backgroundColor, ";color:", (props)=>props.hover.color, ";}");
    var $978931f79bc05084$var$_ref = {
        name: "1d3w5wq",
        styles: "width:100%"
    };
    const $978931f79bc05084$export$c2b37b18a8b54130 = (0, $bWGt6.default)('div', {
        target: "eq4kchp8"
    })((0, (0, parcelRequire("f8Sb3")).css)("position:relative;max-width:100%; @media screen and (max-width: ", (0, (0, parcelRequire("3JZ8k")).dialogPageTakeoverWidth), "px){ width:100%;}"), (props)=>{
        const boundedStyles = (0, (0, parcelRequire("f8Sb3")).css)({
            width: props.isExpanded ? (0, (0, parcelRequire("3JZ8k")).dialogWidth) : (0, (0, parcelRequire("3JZ8k")).collapsedSearchInputWidth)
        });
        const fluidStyles = $978931f79bc05084$var$_ref;
        const styles = props.shouldFillContainer ? fluidStyles : boundedStyles;
        if (props.isExpanded) return (0, (0, parcelRequire("f8Sb3")).css)(styles, " @media screen and (max-width: ", (0, (0, parcelRequire("3JZ8k")).dialogPageTakeoverWidth), "px){width:100%;height:", (0, (0, parcelRequire("3JZ8k")).atlassianNavigationHeight), ";background-color:", props.default.backgroundColor, "; display:flex;align-items:center;max-width:initial;}");
        return styles;
    });
    const $978931f79bc05084$export$b6261a2c5ea449d = (0, $bWGt6.default)("input", {
        target: "eq4kchp7"
    })("height:", (0, (0, parcelRequire("3JZ8k")).inputFieldHeight).px, ";width:100%;padding:0px var(--ds-space-150, 12px) 0px 30px;box-sizing:border-box;outline:none;border-radius:5px;font-size:14px;line-height:20px;", (props)=>`
    border: ${"var(--ds-border-width, 1px)"} solid ${props.isExpanded ? props.focus.borderColor : props.default.borderColor};
    box-shadow: ${props.isExpanded ? `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${props.focus.borderColor}, -12px 0 24px 0 ${props.default.backgroundColor}` : 'none'};
    background-color: ${props.isExpanded ? props.focus.backgroundColor : props.default.backgroundColor};
    color: ${props.isExpanded ? props.focus.color : props.default.color};

    &::placeholder {
      color: ${props.isExpanded ? $978931f79bc05084$var$expandedPlaceholderColor : props.default.color};
    }
    :focus {
      border: ${"var(--ds-border-width, 1px)"} solid ${props.focus.borderColor};
    }
    @media screen and (max-width: ${0, (0, parcelRequire("3JZ8k")).dialogPageTakeoverWidth}px) {
      ${props.isExpanded ? `
            padding: 0 ${(0, (0, parcelRequire("3JZ8k")).grid).multiple(1.5).px} ${(0, (0, parcelRequire("3JZ8k")).grid).multiple(0.25).px};
            margin: 0 ${(0, (0, parcelRequire("3JZ8k")).grid).multiple(3).px} 0 0;` : `
            display: none;
          `}
    }
  `, ";");
    const $978931f79bc05084$export$ca6fe3402791d08e = (0, $bWGt6.default)((0, (0, parcelRequire("btzsC")).default), {
        target: "eq4kchp6"
    })({
        name: "eivff4",
        styles: "display:none"
    });
    const $978931f79bc05084$export$6d53dccb772ed720 = (0, $bWGt6.default)('input', {
        target: "eq4kchp5"
    })("height:", (0, (0, parcelRequire("3JZ8k")).inputFieldHeight).px, ";width:100%;padding:0px var(--ds-space-150, 12px) 0px 30px;box-sizing:border-box;outline:none;border-radius:5px;font-size:14px;line-height:20px;border:", ()=>`${"var(--ds-border-width, 1px)"} solid ${`var(--ds-border-input, ${0, $829f609a65d26a98$export$d6447c357493214f})`}`, ";background-color:var(--ds-background-input, rgb(255, 255, 255));color:", `var(--ds-text-subtlest, ${(0, $829f609a65d26a98$export$f563ee71e9ee74cd)})`, ";:hover{background-color:var(--ds-background-input-hovered, rgb(255, 255, 255));}:focus{color:", `var(--ds-text, ${(0, $829f609a65d26a98$export$fbda843f0a27fe96)})`, ";box-shadow:", ()=>`inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${`var(--ds-border-input, ${0, $829f609a65d26a98$export$d6447c357493214f})`}`, ";}@media screen and (max-width: ", (0, (0, parcelRequire("3JZ8k")).dialogPageTakeoverWidth), "px){display:none;}");
    const $978931f79bc05084$export$c47d4a3e1f1297f1 = (0, $bWGt6.default)('div', {
        target: "eq4kchp4"
    })({
        name: "6vqrnl",
        styles: "position:relative;@media screen and (min-width: 781px){min-width:200px;}height:32px"
    });
    const $978931f79bc05084$export$58ae19ee1fc7be8a = (0, $bWGt6.default)('div', {
        target: "eq4kchp3"
    })({
        name: "bjn8wh",
        styles: "position:relative"
    });
    const $978931f79bc05084$export$b40f2abde293e8e4 = (0, $bWGt6.default)('div', {
        target: "eq4kchp2"
    })("position:relative;max-width:100%;@media screen and (max-width: ", (0, (0, parcelRequire("3JZ8k")).dialogPageTakeoverWidth), "px){width:100%;}width:", (props)=>{
        if (props.shouldFillContainer) return '100%';
        return 0, (0, parcelRequire("3JZ8k")).collapsedSearchInputWidth;
    }, ";");
    const $978931f79bc05084$export$eb4e9f55bbe045df = (0, $bWGt6.default)('span', {
        target: "eq4kchp1"
    })("width:", (0, (0, parcelRequire("3JZ8k")).grid).multiple(2).px, ";height:", (0, (0, parcelRequire("3JZ8k")).grid).multiple(2).px, ";position:absolute;top:", (0, (0, parcelRequire("3JZ8k")).grid).px, ";left:", (0, (0, parcelRequire("3JZ8k")).grid).px, ";color:rgb(107, 119, 140);display:inline-flex;align-items:baseline;@media screen and (max-width: ", (0, (0, parcelRequire("3JZ8k")).dialogPageTakeoverWidth), "px){display:none;}");
    const $978931f79bc05084$export$3f33ed4b273b43d = (0, $bWGt6.default)('span', {
        target: "eq4kchp0"
    })("display:none;padding:", (0, (0, parcelRequire("3JZ8k")).grid).multiple(0.5).px, ";padding-right:var(--ds-space-025, 2px);color:rgb(52, 69, 99);@media screen and (max-width: ", (0, (0, parcelRequire("3JZ8k")).dialogPageTakeoverWidth), "px){display:flex;}");
});
parcelRegister("3JZ8k", function(module, exports) {
    $parcel$export(module.exports, "zIndex", ()=>$f8d02d6b2df072ff$export$56446adcecbeec34);
    $parcel$export(module.exports, "grid", ()=>$f8d02d6b2df072ff$export$85fc379452d91af0);
    $parcel$export(module.exports, "atlassianNavigationHeight", ()=>$f8d02d6b2df072ff$export$b9930dabfa4a3a3);
    $parcel$export(module.exports, "collapsedSearchInputWidth", ()=>$f8d02d6b2df072ff$export$f6af7620e8789c39);
    $parcel$export(module.exports, "dialogWidth", ()=>$f8d02d6b2df072ff$export$a3da89b899389ed8);
    $parcel$export(module.exports, "dialogPageTakeoverWidth", ()=>$f8d02d6b2df072ff$export$ce4512df260a325a);
    $parcel$export(module.exports, "dialogPageCentreWidth", ()=>$f8d02d6b2df072ff$export$a406031ed42c8e02);
    $parcel$export(module.exports, "inputFieldHeight", ()=>$f8d02d6b2df072ff$export$e00021bea368c518);
    $parcel$export(module.exports, "enlargedInputFieldHeight", ()=>$f8d02d6b2df072ff$export$30310ee354b45eb0);
    $parcel$export(module.exports, "primaryTextColour", ()=>$f8d02d6b2df072ff$export$eeb0307e2964e28d);
    $parcel$export(module.exports, "itemLinkSecondaryColor", ()=>$f8d02d6b2df072ff$export$7168c0a11fb9ab29);
    $parcel$export(module.exports, "itemHighlightColor", ()=>$f8d02d6b2df072ff$export$4ac85ff259fe4fce);
    $parcel$export(module.exports, "visitedLinkColor", ()=>$f8d02d6b2df072ff$export$271fb8b1437b1d62);
    $parcel$export(module.exports, "nowrapEllipsis", ()=>$f8d02d6b2df072ff$export$b6b16ffe83ef4b56);
    var $k5uoT;
    function $f8d02d6b2df072ff$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $f8d02d6b2df072ff$var$GRID_UNIT = (0, (0, parcelRequire("k5uoT")).gridSize)();
    const $f8d02d6b2df072ff$var$AkGrid = (num = 1)=>({
            px: `${num * $f8d02d6b2df072ff$var$GRID_UNIT}px`,
            unitless: num * $f8d02d6b2df072ff$var$GRID_UNIT,
            multiple: (multiplier)=>$f8d02d6b2df072ff$var$AkGrid(multiplier * num),
            half: ()=>$f8d02d6b2df072ff$var$AkGrid(0.5 * num),
            twice: ()=>$f8d02d6b2df072ff$var$AkGrid(2 * num)
        });
    const $f8d02d6b2df072ff$export$56446adcecbeec34 = {
        searchDialog: (0, (0, parcelRequire("k5uoT")).layers).dialog()
    };
    const $f8d02d6b2df072ff$export$85fc379452d91af0 = $f8d02d6b2df072ff$var$AkGrid(1);
    const $f8d02d6b2df072ff$export$b9930dabfa4a3a3 = '56px';
    const $f8d02d6b2df072ff$export$f6af7620e8789c39 = '200px';
    const $f8d02d6b2df072ff$export$64d8573e83b64ff8 = '150px';
    const $f8d02d6b2df072ff$export$a3da89b899389ed8 = '780px';
    const $f8d02d6b2df072ff$export$ce4512df260a325a = 780;
    const $f8d02d6b2df072ff$export$a406031ed42c8e02 = '1130px';
    const $f8d02d6b2df072ff$export$e00021bea368c518 = $f8d02d6b2df072ff$export$85fc379452d91af0.multiple(4);
    const $f8d02d6b2df072ff$export$30310ee354b45eb0 = $f8d02d6b2df072ff$export$85fc379452d91af0.multiple(6);
    const $f8d02d6b2df072ff$export$eeb0307e2964e28d = `var(--ds-text, ${(0, $829f609a65d26a98$export$fbda843f0a27fe96)})`;
    const $f8d02d6b2df072ff$export$7168c0a11fb9ab29 = `var(--ds-text-subtlest, ${(0, $829f609a65d26a98$export$f563ee71e9ee74cd)})`;
    const $f8d02d6b2df072ff$export$4ac85ff259fe4fce = `var(--ds-background-neutral-subtle-hovered, ${(0, $829f609a65d26a98$export$9fdfb749e33cdf97)})`;
    const $f8d02d6b2df072ff$export$271fb8b1437b1d62 = `var(--ds-link-visited, ${(0, $829f609a65d26a98$export$b48405b95304b5a1)})`;
    const $f8d02d6b2df072ff$export$b6b16ffe83ef4b56 = {
        name: "sqm42b",
        styles: "text-overflow:ellipsis;white-space:nowrap;overflow:hidden"
    };
});
parcelRegister("cFUJK", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$de03a6aae28371f7$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $2AbEM;
    var $b9NEf;
    var $hLeR9;
    var $6I8Kl;
    var $42CjB;
    var $j1SOM;
    var $8I7W7;
    const $de03a6aae28371f7$var$MAX_INPUT_LENGTH = 500;
    const $de03a6aae28371f7$export$9b2f977cfc67f251 = (props)=>{
        const theme = (0, (0, parcelRequire("2AbEM")).useTheme)();
        const { forwardRef: forwardRef, features: features, shouldFillContainer: shouldFillContainer, placeholder: nonFeaturesPlaceholder } = props;
        const { enabled: enabled, advancedSearchUrl: advancedSearchUrl, placeholder: placeholder, customScriptDataAttributes: customScriptDataAttributes } = features?.interactiveSkeleton || {};
        if (enabled || (0, (0, parcelRequire("j1SOM")).getInputSkeletonFocus)()) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8I7W7")).SSRsearchInput), {
            shouldFillContainer: shouldFillContainer,
            advancedSearchUrl: advancedSearchUrl,
            placeholder: placeholder || nonFeaturesPlaceholder,
            customScriptDataAttributes: customScriptDataAttributes,
            theme: theme
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hLeR9")).SearchAnchorWrapper), {
            shouldFillContainer: shouldFillContainer
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("b9NEf")).SearchInputContainer), {
            ...theme,
            shouldFillContainer: shouldFillContainer,
            isExpanded: false,
            role: "search"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("b9NEf")).MobileSearchIconWrapper), {
            isExpanded: false
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("42CjB")).default), {
            label: "Search",
            icon: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6I8Kl")).SearchIcon), {
                    theme: theme,
                    isExpanded: false,
                    size: "medium"
                })
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("b9NEf")).DesktopSearchIconWrapper), {
            ...theme,
            isExpanded: false
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6I8Kl")).SearchIcon), {
            theme: theme,
            isExpanded: false
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("b9NEf")).SearchInputField), {
            "data-test-id": "search-dialog-search-skeleton",
            isExpanded: false,
            placeholder: placeholder,
            ref: forwardRef || undefined,
            disabled: true,
            value: "",
            maxLength: $de03a6aae28371f7$var$MAX_INPUT_LENGTH,
            onChange: ()=>{},
            "aria-label": placeholder,
            ...theme
        })));
    };
    var $de03a6aae28371f7$export$2e2bcd8739ae039 = (0, ($parcel$interopDefault($5uXOq))).forwardRef((props, ref)=>(0, ($parcel$interopDefault($5uXOq))).createElement($de03a6aae28371f7$export$9b2f977cfc67f251, {
            ...props,
            forwardRef: ref
        }));
});
parcelRegister("hLeR9", function(module, exports) {
    $parcel$export(module.exports, "AbsoluteContainer", ()=>$0b21a022edbcff7e$export$36aa0f4a98890c96);
    $parcel$export(module.exports, "SearchDialogAnchor", ()=>$0b21a022edbcff7e$export$f565ce1043dae7c9);
    $parcel$export(module.exports, "SearchAnchorWrapper", ()=>$0b21a022edbcff7e$export$dfece74a62f1398d);
    $parcel$export(module.exports, "EnlargedSearchAnchorWrapper", ()=>$0b21a022edbcff7e$export$5566658d36f6ca7b);
    var $f8Sb3;
    var $3JZ8k;
    var $bWGt6 = parcelRequire("bWGt6");
    const $0b21a022edbcff7e$export$36aa0f4a98890c96 = (0, $bWGt6.default)('div', {
        target: "exl9bxq3"
    })("", (props)=>{
        if (props.isExpanded) return (0, (0, parcelRequire("f8Sb3")).css)({
            position: 'absolute',
            ...props.shouldFillContainer && {
                left: 0
            },
            right: 0,
            zIndex: (0, (0, parcelRequire("3JZ8k")).zIndex).searchDialog
        });
        return {};
    });
    const $0b21a022edbcff7e$export$f565ce1043dae7c9 = (0, $bWGt6.default)('div', {
        target: "exl9bxq2"
    })("position:relative;", (props)=>{
        if (props.isExpanded) return (0, (0, parcelRequire("f8Sb3")).css)("@media screen and (max-width: ", (0, (0, parcelRequire("3JZ8k")).dialogPageCentreWidth), "){ position:", props.shouldFillContainer ? 'static' : 'fixed', "; z-index:", (0, (0, parcelRequire("3JZ8k")).zIndex).searchDialog, ";left:calc((100% - ", (0, (0, parcelRequire("3JZ8k")).dialogWidth), ") / 2);;}@media screen and (max-width: ", (0, (0, parcelRequire("3JZ8k")).dialogPageTakeoverWidth), "px){ ", props.shouldFillContainer && 'position: fixed;', ";top:0;right:0;bottom:0;left:0;display:flex;flex-direction:column;overflow:auto;}");
        return {};
    });
    const $0b21a022edbcff7e$export$dfece74a62f1398d = (0, $bWGt6.default)("div", {
        target: "exl9bxq1"
    })("position:relative;@media screen and (min-width: ", (0, (0, parcelRequire("3JZ8k")).dialogPageTakeoverWidth) + 1, "px){", (props)=>props.shouldFillContainer ? 'width: 100%;' : 'min-width: 200px;', ";}", (props)=>props.shouldFillContainer ? 'max-width: 780px;' : '', " width:", (0, (0, parcelRequire("3JZ8k")).inputFieldHeight).px, ";height:", (0, (0, parcelRequire("3JZ8k")).inputFieldHeight).px, ";");
    const $0b21a022edbcff7e$export$5566658d36f6ca7b = (0, $bWGt6.default)($0b21a022edbcff7e$export$dfece74a62f1398d, {
        target: "exl9bxq0"
    })("height:", (props)=>props.isExpanded ? (0, (0, parcelRequire("3JZ8k")).enlargedInputFieldHeight).px : (0, (0, parcelRequire("3JZ8k")).inputFieldHeight).px, ";");
});
parcelRegister("j1SOM", function(module, exports) {
    $parcel$export(module.exports, "getInputSkeletonQuery", ()=>$a306a1ec994c7560$export$b8b6c2e7a0664212);
    $parcel$export(module.exports, "setInputSkeletonQuery", ()=>$a306a1ec994c7560$export$baa1c819dd4691f3);
    $parcel$export(module.exports, "getInputSkeletonFocus", ()=>$a306a1ec994c7560$export$38fcbc98be180790);
    $parcel$export(module.exports, "setInputSkeletonIsFocus", ()=>$a306a1ec994c7560$export$d3c6894b4e9af000);
    $parcel$export(module.exports, "getInputSkeletonSelection", ()=>$a306a1ec994c7560$export$a0c71b3bd9ec143c);
    $parcel$export(module.exports, "setInputSkeletonSelection", ()=>$a306a1ec994c7560$export$e0d745255b135363);
    $parcel$export(module.exports, "resetInputSkeletonState", ()=>$a306a1ec994c7560$export$c89dd2d5d4024c5e);
    $parcel$export(module.exports, "removeInputSkeletonEventListeners", ()=>$a306a1ec994c7560$export$166ce39761ad7743);
    $parcel$export(module.exports, "removeInputSkeletonState", ()=>$a306a1ec994c7560$export$c830bcf42e072a93);
    const $a306a1ec994c7560$export$b8b6c2e7a0664212 = ()=>{
        return window?.inputSkeletonState?.query || '';
    };
    const $a306a1ec994c7560$export$baa1c819dd4691f3 = (newQuery)=>{
        if (window?.inputSkeletonState) window.inputSkeletonState.query = newQuery;
    };
    const $a306a1ec994c7560$export$38fcbc98be180790 = ()=>{
        return window?.inputSkeletonState?.isFocused || false;
    };
    const $a306a1ec994c7560$export$d3c6894b4e9af000 = (newIsFocused)=>{
        if (window?.inputSkeletonState) window.inputSkeletonState.isFocused = newIsFocused;
    };
    const $a306a1ec994c7560$export$a0c71b3bd9ec143c = ()=>{
        const selectionStart = window?.inputSkeletonState?.selectionStart || 0;
        const selectionEnd = window?.inputSkeletonState?.selectionEnd || 0;
        const selectionDirection = window?.inputSkeletonState?.selectionDirection || 'none';
        return {
            selectionStart: selectionStart,
            selectionEnd: selectionEnd,
            selectionDirection: selectionDirection
        };
    };
    const $a306a1ec994c7560$export$e0d745255b135363 = (newSelectionStart, newSelectionEnd, newSelectionDirection)=>{
        if (window?.inputSkeletonState) {
            window.inputSkeletonState.selectionStart = newSelectionStart;
            window.inputSkeletonState.selectionEnd = newSelectionEnd;
            window.inputSkeletonState.selectionDirection = newSelectionDirection;
        }
    };
    const $a306a1ec994c7560$export$c89dd2d5d4024c5e = ()=>{
        window.inputSkeletonState = {
            query: '',
            placeholder: '',
            isFocused: false,
            selectionStart: 0,
            selectionEnd: 0,
            selectionDirection: 'none',
            listeners: []
        };
    };
    const $a306a1ec994c7560$export$166ce39761ad7743 = ()=>{
        if (window.inputSkeletonState) {
            window.inputSkeletonState.listeners.forEach((ssrEventListener)=>{
                const [target, event, handler] = ssrEventListener;
                target.removeEventListener(event, handler);
            });
            window.inputSkeletonState.listeners = [];
        }
    };
    const $a306a1ec994c7560$export$c830bcf42e072a93 = ()=>{
        if (window['inputSkeletonState']) {
            $a306a1ec994c7560$export$166ce39761ad7743();
            delete window['inputSkeletonState'];
        }
    };
});
parcelRegister("8I7W7", function(module, exports) {
    $parcel$export(module.exports, "SSRsearchInput", ()=>SSRsearchInput);
    var $5uXOq = parcelRequire("5uXOq");
    var $b9NEf;
    var $6I8Kl;
    const SSRsearchInput = ({ advancedSearchUrl, placeholder, customScriptDataAttributes, theme, shouldFillContainer })=>{
        const scriptRef = (0, $5uXOq.useRef)(null);
        (0, $5uXOq.useLayoutEffect)(()=>{
            const current = scriptRef?.current;
            if (current) eval(current.innerHTML);
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("b9NEf")).SSRsearchInputWrapper), null, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            id: "ssr-search-input-popout-container"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("b9NEf")).SSRformContainer), {
            id: "ssr-form-container"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("form", {
            method: "get",
            action: advancedSearchUrl
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("b9NEf")).SSRsearchInputContainer), {
            shouldFillContainer: shouldFillContainer,
            id: "ssr-input-container",
            role: "search"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("b9NEf")).SSRmobileSearchIconWrapper), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6I8Kl")).SearchIcon), {
            theme: theme,
            isExpanded: false,
            size: "medium"
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("b9NEf")).SSRdesktopSearchIconWrapper), {
            id: "ssr-search-icon-wrapper"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6I8Kl")).SearchIcon), {
            theme: theme,
            isExpanded: false
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("b9NEf")).SSRsearchInputField), {
            id: "ssr-search-input",
            name: "text",
            placeholder: placeholder,
            autoComplete: "off"
        })), (0, ($parcel$interopDefault($5uXOq))).createElement("script", {
            "data-test-id": "ssr-scripts-init",
            ref: scriptRef,
            dangerouslySetInnerHTML: {
                __html: (0, $9b06243a4405ae90$export$bc237d627614fc48)
            },
            ...customScriptDataAttributes
        })))));
    };
});
const $9b06243a4405ae90$export$bc237d627614fc48 = `(function(document,window){var _a;var getWeakRef=function(queryId){var element=document.getElementById(queryId);if(!element){return null}return new WeakRef(element)};var currentInput=getWeakRef("ssr-search-input");var container=getWeakRef("ssr-input-container");var topContainer=getWeakRef("ssr-search-input-popout-container");var iconWrapper=getWeakRef("ssr-search-icon-wrapper");var formContainer=getWeakRef("ssr-form-container");var pageWidth=window.innerWidth||document.documentElement.clientWidth||document.body.clientWidth;if(window["inputSkeletonState"]){for(var _i=0,_b=window["inputSkeletonState"].listeners;_i<_b.length;_i++){var listener=_b[_i];var target=listener[0],event_1=listener[1],handler=listener[2];target.removeEventListener(event_1,handler)}window["inputSkeletonState"].listeners=[]}function setExpandedStyles(){var _a,_b,_c,_d,_e,_f;(_a=iconWrapper===null||iconWrapper===void 0?void 0:iconWrapper.deref())===null||_a===void 0?void 0:_a.setAttribute("style","color: rgb(9, 30, 66);");if(pageWidth<=1130){(_b=topContainer===null||topContainer===void 0?void 0:topContainer.deref())===null||_b===void 0?void 0:_b.setAttribute("style","position: absolute;right: 0px;z-index: 300;");(_c=formContainer===null||formContainer===void 0?void 0:formContainer.deref())===null||_c===void 0?void 0:_c.setAttribute("style","position: fixed;z-index: 300;left: calc((100% - 780px) / 2);");(_d=container===null||container===void 0?void 0:container.deref())===null||_d===void 0?void 0:_d.setAttribute("style","position: relative;max-width: 100%;width: 780px;")}else{(_e=topContainer===null||topContainer===void 0?void 0:topContainer.deref())===null||_e===void 0?void 0:_e.setAttribute("style","position: absolute; right:0px; z-index:300;");(_f=container===null||container===void 0?void 0:container.deref())===null||_f===void 0?void 0:_f.setAttribute("style","width: 780px;")}}function resetInputSkeleton(){window["inputSkeletonState"]={query:"",placeholder:"",isFocused:false,selectionStart:0,selectionEnd:0,selectionDirection:"none",listeners:[]}}if(window["inputSkeletonState"]){var inputRef=currentInput===null||currentInput===void 0?void 0:currentInput.deref();if(window.inputSkeletonState.isFocused&&inputRef){inputRef.value=window.inputSkeletonState.query;inputRef.placeholder=window.inputSkeletonState.placeholder;inputRef.focus();inputRef.setSelectionRange(window.inputSkeletonState.selectionStart,window.inputSkeletonState.selectionEnd,window.inputSkeletonState.selectionDirection);setExpandedStyles()}}else{resetInputSkeleton()}var queryValue=window.sessionStorage.getItem("atlassian.search-dialog-query");if(window.sessionStorage.getItem("atlassian.search-dialog-sticky")==="true"&&!!queryValue){var inputRef=currentInput===null||currentInput===void 0?void 0:currentInput.deref();if(inputRef){inputRef.value=queryValue}}var mediaQuery=window.matchMedia("(max-width: 1130px)");function handleSmallScreen(){var _a,_b,_c;if(window["inputSkeletonState"]){if(window.inputSkeletonState.isFocused){(_a=topContainer===null||topContainer===void 0?void 0:topContainer.deref())===null||_a===void 0?void 0:_a.setAttribute("style","position: absolute;right: 0px;z-index: 300;");(_b=formContainer===null||formContainer===void 0?void 0:formContainer.deref())===null||_b===void 0?void 0:_b.setAttribute("style","position: fixed;z-index: 300;left: calc((100% - 780px) / 2);");(_c=container===null||container===void 0?void 0:container.deref())===null||_c===void 0?void 0:_c.setAttribute("style","position: relative;max-width: 100%;width: 780px;")}}}(_a=mediaQuery===null||mediaQuery===void 0?void 0:mediaQuery.addEventListener)===null||_a===void 0?void 0:_a.call(mediaQuery,"change",function(){return handleSmallScreen()});function changeHandler(e){var input=e.target;if(window.inputSkeletonState){window.inputSkeletonState.query=input===null||input===void 0?void 0:input.value;if(window.sessionStorage.getItem("atlassian.search-dialog-sticky")==="true"){window.sessionStorage.setItem("atlassian.search-dialog-query",input.value)}var inputRef=currentInput===null||currentInput===void 0?void 0:currentInput.deref();if(inputRef){window.inputSkeletonState.selectionStart=inputRef.selectionStart||0;window.inputSkeletonState.selectionEnd=inputRef.selectionEnd||0;window.inputSkeletonState.selectionDirection=inputRef.selectionDirection||"none"}}}function focusHandler(e){if(window.inputSkeletonState){window.inputSkeletonState.isFocused=true;var inputRef=currentInput===null||currentInput===void 0?void 0:currentInput.deref();if(inputRef){window.inputSkeletonState.placeholder=inputRef.placeholder}}setExpandedStyles()}function blurClickHandler(e){var _a,_b,_c,_d,_e;var inputRef=currentInput===null||currentInput===void 0?void 0:currentInput.deref();if(!inputRef){return}if(currentInput&&e.target===inputRef&&window.inputSkeletonState){window.inputSkeletonState.selectionStart=inputRef.selectionStart||0;window.inputSkeletonState.selectionEnd=inputRef.selectionEnd||0;window.inputSkeletonState.selectionDirection=inputRef.selectionDirection||"none";if(!((_a=topContainer===null||topContainer===void 0?void 0:topContainer.deref())===null||_a===void 0?void 0:_a.hasAttribute("style"))){window.inputSkeletonState.isFocused=true;setExpandedStyles()}}if(currentInput&&e.target!==inputRef){resetInputSkeleton();var sessionQuery=window.sessionStorage.getItem("atlassian.search-dialog-query");if(window.sessionStorage.getItem("atlassian.search-dialog-sticky")==="true"&&!!sessionQuery){inputRef.value=sessionQuery}else{inputRef.value=""}(_b=topContainer===null||topContainer===void 0?void 0:topContainer.deref())===null||_b===void 0?void 0:_b.removeAttribute("style");(_c=container===null||container===void 0?void 0:container.deref())===null||_c===void 0?void 0:_c.removeAttribute("style");(_d=iconWrapper===null||iconWrapper===void 0?void 0:iconWrapper.deref())===null||_d===void 0?void 0:_d.removeAttribute("style");inputRef.removeAttribute("style");(_e=formContainer===null||formContainer===void 0?void 0:formContainer.deref())===null||_e===void 0?void 0:_e.removeAttribute("style")}}function addListener(target,event,handler){var _a;target.addEventListener(event,handler);(_a=window===null||window===void 0?void 0:window.inputSkeletonState)===null||_a===void 0?void 0:_a.listeners.push([target,event,handler])}{var inputRef=currentInput===null||currentInput===void 0?void 0:currentInput.deref();if(inputRef){addListener(inputRef,"input",changeHandler);addListener(inputRef,"select",changeHandler);addListener(inputRef,"keydown",changeHandler);addListener(inputRef,"focus",focusHandler)}}addListener(document,"click",blurClickHandler)})(document,window);`;
parcelRegister("0Wtmq", function(module, exports) {
    $parcel$export(module.exports, "PeopleAndTeamsConfigurationProvider", ()=>$7fcc2b6dd0426004$export$d3f5bd36d1c6597e);
    $parcel$export(module.exports, "usePeopleAndTeamsConfigurationContext", ()=>$7fcc2b6dd0426004$export$130340d16a670190);
    var $5uXOq = parcelRequire("5uXOq");
    var $btDaU;
    var $fkT8h;
    var $9Xnkh;
    var $epGv3;
    const $7fcc2b6dd0426004$export$8a37839ac1e08b25 = (0, $5uXOq.createContext)((0, (0, parcelRequire("9Xnkh")).DEFAULT_CONTEXT));
    const $7fcc2b6dd0426004$export$3bf19eb896b777b8 = ({ children: children, locale: locale, product: product, teamPermissions: teamPermissions, orgId: orgId, teamPermissionCheckEnabled: teamPermissionCheckEnabled = false })=>{
        const overrides = (0, (0, parcelRequire("epGv3")).usePeopleAndTeamsConfigurationOverrides)(teamPermissionCheckEnabled, orgId, teamPermissions);
        const artifact = (0, (0, parcelRequire("fkT8h")).usePeopleAndTeamsRemoteArtifact)(product, locale, overrides);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($7fcc2b6dd0426004$export$8a37839ac1e08b25.Provider, {
            value: artifact || (0, (0, parcelRequire("9Xnkh")).DEFAULT_CONTEXT)
        }, children);
    };
    const $7fcc2b6dd0426004$export$d3f5bd36d1c6597e = ({ children: children, locale: locale, product: product, teamPermissions: teamPermissions, teamPermissionCheckEnabled: teamPermissionCheckEnabled, orgId: orgId, ...flightDeckProps })=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("btDaU")).FlightDeckProvider), {
            product: product,
            ...flightDeckProps
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($7fcc2b6dd0426004$export$3bf19eb896b777b8, {
            locale: locale,
            product: product,
            teamPermissions: teamPermissions,
            teamPermissionCheckEnabled: teamPermissionCheckEnabled,
            orgId: orgId
        }, children));
    };
    const $7fcc2b6dd0426004$export$130340d16a670190 = ()=>(0, ($parcel$interopDefault($5uXOq))).useContext($7fcc2b6dd0426004$export$8a37839ac1e08b25);
});
parcelRegister("btDaU", function(module, exports) {
    $parcel$export(module.exports, "FlightDeckProvider", ()=>$85b0ca77dee62619$export$56da85ac9d40dbcd);
    $parcel$export(module.exports, "useFlightDeckContext", ()=>$85b0ca77dee62619$export$73c96350a5e69ec);
    $parcel$export(module.exports, "useFlightDeckArtifact", ()=>$85b0ca77dee62619$export$3b241cde208d2c5e);
    var $5uXOq = parcelRequire("5uXOq");
    var $6HV40;
    const $85b0ca77dee62619$export$ca1b33377afa620 = (0, ($parcel$interopDefault($5uXOq))).createContext({
        getArtifact: null
    });
    function $85b0ca77dee62619$export$56da85ac9d40dbcd({ children: children, product: product, config: config, fallbackArtifacts: fallbackArtifacts }) {
        const flightDeckClient = (0, ($parcel$interopDefault($5uXOq))).useMemo(()=>{
            return new (0, (0, parcelRequire("6HV40")).default)(product, {
                handlers: {
                    captureException: config === null || config === void 0 ? void 0 : config.captureException
                }
            }, fallbackArtifacts);
        }, [
            product,
            config === null || config === void 0 ? void 0 : config.captureException,
            fallbackArtifacts
        ]);
        const getArtifact = (0, ($parcel$interopDefault($5uXOq))).useCallback(async (name, dimensions)=>{
            return flightDeckClient.fetchConfigFromFlightDeck({
                name: name,
                dimensions: dimensions
            });
        }, [
            flightDeckClient
        ]);
        const providerValue = (0, ($parcel$interopDefault($5uXOq))).useMemo(()=>({
                getArtifact: getArtifact
            }), [
            getArtifact
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($85b0ca77dee62619$export$ca1b33377afa620.Provider, {
            value: providerValue
        }, children);
    }
    const $85b0ca77dee62619$export$73c96350a5e69ec = ()=>(0, ($parcel$interopDefault($5uXOq))).useContext($85b0ca77dee62619$export$ca1b33377afa620);
    function $85b0ca77dee62619$export$3b241cde208d2c5e(key, dimensions) {
        const [artifact, setArtifact] = (0, ($parcel$interopDefault($5uXOq))).useState();
        const { getArtifact: getArtifact } = $85b0ca77dee62619$export$73c96350a5e69ec();
        (0, ($parcel$interopDefault($5uXOq))).useEffect(()=>{
            if (!getArtifact) throw new Error("Flight Deck Context not provided");
            getArtifact(key, dimensions).then((resp)=>setArtifact(resp)).catch();
        }, [
            dimensions,
            key,
            getArtifact,
            setArtifact
        ]);
        return artifact;
    }
});
parcelRegister("fkT8h", function(module, exports) {
    $parcel$export(module.exports, "usePeopleAndTeamsRemoteArtifact", ()=>$540fc5e41500614e$export$233293b7afb7b362);
    var $5uXOq = parcelRequire("5uXOq");
    var $btDaU;
    var $a5HGt;
    const $540fc5e41500614e$var$transformArtifactsWithOverrides = (artifact, overrideKeys)=>{
        if (!artifact?.overrides?.length || overrideKeys.length === 0) return artifact;
        return overrideKeys.reduce((acc, overrideKey)=>{
            return {
                ...acc,
                ...artifact.overrides && artifact.overrides.find((override)=>override.key === overrideKey)?.item || null
            };
        }, artifact);
    };
    const $540fc5e41500614e$export$233293b7afb7b362 = (product, locale, overridesKeys)=>{
        const dimensions = (0, $5uXOq.useMemo)(()=>({
                ...(0, (0, parcelRequire("a5HGt")).FD_CLIENT_FETCH_PROPS).dimensions,
                locale: locale
            }), [
            locale
        ]);
        const artifact = (0, (0, parcelRequire("btDaU")).useFlightDeckArtifact)((0, (0, parcelRequire("a5HGt")).FD_CLIENT_FETCH_PROPS).name, dimensions);
        return (0, $5uXOq.useMemo)(()=>{
            const productArtifact = artifact ? product in artifact['people-menu'] ? artifact['people-menu'][product] : artifact['people-menu'].default : null;
            return {
                ['people-menu']: $540fc5e41500614e$var$transformArtifactsWithOverrides(productArtifact, overridesKeys ? overridesKeys['people-menu'] : [])
            };
        }, [
            artifact,
            product,
            overridesKeys
        ]);
    };
});
parcelRegister("a5HGt", function(module, exports) {
    $parcel$export(module.exports, "FD_CLIENT_FETCH_PROPS", ()=>$72142315cc1ea029$export$c270c412a04ff3e6);
    var $aIZdc;
    const $72142315cc1ea029$export$953923d576277fd6 = 'people-and-teams-configuration-service';
    const $72142315cc1ea029$export$71f196808ce40e60 = 'prod';
    const $72142315cc1ea029$export$6392ca3738ed1e9 = 'fedramp-moderate';
    const $72142315cc1ea029$export$e836203c1e95eac3 = 'commercial';
    const $72142315cc1ea029$export$c270c412a04ff3e6 = {
        name: $72142315cc1ea029$export$953923d576277fd6,
        dimensions: {
            environmentType: $72142315cc1ea029$export$71f196808ce40e60,
            perimeter: (0, (0, parcelRequire("aIZdc")).isFedRamp)() ? $72142315cc1ea029$export$6392ca3738ed1e9 : $72142315cc1ea029$export$e836203c1e95eac3
        }
    };
});
parcelRegister("9Xnkh", function(module, exports) {
    $parcel$export(module.exports, "DEFAULT_CONTEXT", ()=>$68376ad28bbe1625$export$9c542858adf7dcd0);
    const $68376ad28bbe1625$export$9c542858adf7dcd0 = {
        ['people-menu']: null
    };
});
parcelRegister("epGv3", function(module, exports) {
    $parcel$export(module.exports, "usePeopleAndTeamsConfigurationOverrides", ()=>$9b52f5c51e77c65a$export$66d7d96ce076bcd6);
    var $95nUS;
    var $5wXDQ;
    const $9b52f5c51e77c65a$export$66d7d96ce076bcd6 = (teamPermissionCheckEnabled, orgId, teamPermissionsProps)=>{
        const { permissions: teamPermissionsFromHook } = (0, (0, parcelRequire("95nUS")).useTeamsPermissionsService)(orgId, {
            enabled: teamPermissionCheckEnabled && !teamPermissionsProps
        });
        const teamPermissions = teamPermissionsProps || teamPermissionsFromHook;
        return {
            'people-menu': [
                ...!teamPermissions?.canCreateTeams ? [
                    (0, (0, parcelRequire("5wXDQ")).PeopleMenuOverrides).createTeamsDisabled
                ] : [],
                ...!teamPermissions?.canViewTeams ? [
                    (0, (0, parcelRequire("5wXDQ")).PeopleMenuOverrides).viewTeamsDisabled
                ] : []
            ]
        };
    };
});
parcelRegister("95nUS", function(module, exports) {
    $parcel$export(module.exports, "useTeamsPermissionsService", ()=>$6e4bacc142514b25$export$b24dcbe1ec677a8);
    var $5uXOq = parcelRequire("5uXOq");
    var $2NMNM;
    var $3mE7N;
    var $lXyXX;
    const $6e4bacc142514b25$export$b24dcbe1ec677a8 = (scope, { enabled: enabled, attributes: attributes } = {
        enabled: false,
        attributes: {}
    })=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const { orgId: orgId, cloudId: cloudId } = typeof scope === 'string' || !scope ? {
            orgId: scope,
            cloudId: undefined
        } : scope;
        const [state, { getPermissions: getPermissions }] = (0, (0, parcelRequire("lXyXX")).useTeamsPermissionsStore)();
        const fetchData = (0, $5uXOq.useCallback)(async ()=>{
            getPermissions({
                orgId: orgId,
                cloudId: cloudId,
                enabled: enabled
            }, {
                onFetch: ()=>(0, (0, parcelRequire("3mE7N")).fireOperationalEvent)(createAnalyticsEvent, {
                        action: 'fetched',
                        actionSubject: 'use-team-permissions',
                        attributes: {
                            userId: attributes?.userId,
                            orgId: orgId,
                            cloudId: cloudId
                        }
                    })
            });
        }, [
            orgId,
            cloudId,
            enabled,
            getPermissions,
            createAnalyticsEvent,
            attributes?.userId
        ]);
        (0, $5uXOq.useEffect)(()=>{
            fetchData();
        }, [
            fetchData
        ]);
        return {
            loading: state.isLoading,
            data: state.permissionsResponse,
            error: state.error,
            ...state
        };
    };
});
parcelRegister("3mE7N", function(module, exports) {
    $parcel$export(module.exports, "fireOperationalEvent", ()=>$f93bde5d7fdaaaab$export$a1fb57756f0de62b);
    $parcel$export(module.exports, "fireScreenEvent", ()=>$f93bde5d7fdaaaab$export$59608e0169622110);
    $parcel$export(module.exports, "fireTrackEvent", ()=>$f93bde5d7fdaaaab$export$574d2f19a52d67ca);
    $parcel$export(module.exports, "fireUIEvent", ()=>$f93bde5d7fdaaaab$export$7eca133280843f9e);
    $parcel$export(module.exports, "isSeriousError", ()=>$f93bde5d7fdaaaab$export$91c413c8a5c77e19);
    const $f93bde5d7fdaaaab$var$ANALYTICS_CHANNEL = 'peopleTeams';
    const $f93bde5d7fdaaaab$var$runItLater = (cb)=>{
        if (window.requestIdleCallback === 'function') return window.requestIdleCallback(cb);
        if (typeof window.requestAnimationFrame === 'function') return window.requestAnimationFrame(cb);
        return ()=>setTimeout(cb);
    };
    const $f93bde5d7fdaaaab$var$fireEvent = (kind)=>(createAnalyticsEvent, body)=>{
            if (!createAnalyticsEvent) return;
            $f93bde5d7fdaaaab$var$runItLater(()=>{
                createAnalyticsEvent({
                    eventType: kind,
                    ...body
                }).fire($f93bde5d7fdaaaab$var$ANALYTICS_CHANNEL);
            });
        };
    const $f93bde5d7fdaaaab$export$a1fb57756f0de62b = $f93bde5d7fdaaaab$var$fireEvent('operational');
    const $f93bde5d7fdaaaab$export$59608e0169622110 = $f93bde5d7fdaaaab$var$fireEvent('screen');
    const $f93bde5d7fdaaaab$export$574d2f19a52d67ca = $f93bde5d7fdaaaab$var$fireEvent('track');
    const $f93bde5d7fdaaaab$export$7eca133280843f9e = $f93bde5d7fdaaaab$var$fireEvent('ui');
    const $f93bde5d7fdaaaab$export$91c413c8a5c77e19 = (error)=>{
        if (!error) return false;
        if ('status' in error && error['status'] === 403 || error.message.includes(' 403')) return false;
        if ('status' in error && error['status'] === 401 || error.message.includes(' 401')) return false;
        if ('status' in error && error['status'] === 429 || error.message.includes(' 429')) return false;
        if (error.message === 'Failed to fetch') return false;
        return true;
    };
});
parcelRegister("lXyXX", function(module, exports) {
    $parcel$export(module.exports, "useTeamsPermissionsStore", ()=>$20332b07e72ce3e2$export$4e7a1c55cba5a168);
    var $3sQ5x;
    var $iXqE5;
    var $1K4T6;
    var $dmOdc;
    var $ddoT6;
    const $20332b07e72ce3e2$var$actions = {
        getPermissions: ({ orgId: orgId, cloudId: cloudId, enabled: enabled }, { onFetch: onFetch })=>async ({ setState: setState, getState: getState, dispatch: dispatch })=>{
                const { hasLoaded: hasLoaded, isLoading: isLoading } = getState();
                if (hasLoaded || isLoading || !enabled || !orgId || !cloudId) return;
                try {
                    setState({
                        isLoading: true
                    });
                    (0, (0, parcelRequire("dmOdc")).teamsClient).setContext({
                        orgId: orgId,
                        cloudId: cloudId
                    });
                    const response = await (0, (0, parcelRequire("dmOdc")).teamsClient).getPermissions();
                    dispatch($20332b07e72ce3e2$var$actions.setPermissions(response.permissions));
                    onFetch?.();
                } catch (error) {
                    dispatch($20332b07e72ce3e2$var$actions.setError(error instanceof (0, (0, parcelRequire("1K4T6")).HttpError) ? error : new Error('Failed to fetch permissions')));
                }
            },
        setError: (error)=>({ setState: setState })=>{
                setState({
                    hasLoaded: true,
                    isLoading: false,
                    error: error
                });
            },
        setLoading: (isLoading)=>({ setState: setState })=>{
                setState({
                    isLoading: isLoading
                });
            },
        setPermissions: (permissions)=>({ setState: setState })=>{
                setState({
                    hasLoaded: true,
                    isLoading: false,
                    permissions: (0, (0, parcelRequire("ddoT6")).transformPermissions)(permissions),
                    permissionsResponse: {
                        permissions: permissions
                    }
                });
            }
    };
    const $20332b07e72ce3e2$var$Store = (0, (0, parcelRequire("iXqE5")).createStore)({
        initialState: {
            error: undefined,
            hasLoaded: false,
            isLoading: false,
            permissions: {
                canCreateTeams: true,
                canViewTeams: true,
                canAdminTeams: false
            }
        },
        actions: $20332b07e72ce3e2$var$actions,
        name: 'teams-permissions'
    });
    const $20332b07e72ce3e2$export$4e7a1c55cba5a168 = (0, (0, parcelRequire("3sQ5x")).createHook)($20332b07e72ce3e2$var$Store);
});
parcelRegister("1K4T6", function(module, exports) {
    $parcel$export(module.exports, "StatusCode", ()=>$5767c51dc6f9e25d$export$f66f92b8741acd5b);
    $parcel$export(module.exports, "isAuthError", ()=>$5767c51dc6f9e25d$export$cde1786a482f9a1c);
    $parcel$export(module.exports, "isErrorStatusCode", ()=>$5767c51dc6f9e25d$export$9677d7c364ada66c);
    $parcel$export(module.exports, "DefaultError", ()=>$5767c51dc6f9e25d$export$c73ca302efeda3b4);
    $parcel$export(module.exports, "SLOIgnoreError", ()=>$5767c51dc6f9e25d$export$d87f401f8106d7a2);
    $parcel$export(module.exports, "HttpError", ()=>$5767c51dc6f9e25d$export$65bd6083489bd8bb);
    $parcel$export(module.exports, "SLOIgnoreHttpError", ()=>$5767c51dc6f9e25d$export$826a3d65b8435adf);
    $parcel$export(module.exports, "GraphQLError", ()=>$5767c51dc6f9e25d$export$92d6ed0888e7cb7f);
    $parcel$export(module.exports, "isNetworkError", ()=>$5767c51dc6f9e25d$export$476aa014e2fd89d5);
    var $5767c51dc6f9e25d$export$fe4bb20808298551;
    (function(ErrorCategory) {
        ErrorCategory["NotFound"] = "NotFound";
        ErrorCategory["NotPermitted"] = "NotPermitted";
        ErrorCategory["MalformedInput"] = "MalformedInput";
        ErrorCategory["Internal"] = "Internal";
    })($5767c51dc6f9e25d$export$fe4bb20808298551 || ($5767c51dc6f9e25d$export$fe4bb20808298551 = {}));
    var $5767c51dc6f9e25d$export$f66f92b8741acd5b;
    (function(StatusCode) {
        StatusCode[StatusCode["UNAUTHORIZED"] = 401] = "UNAUTHORIZED";
        StatusCode[StatusCode["FORBIDDEN"] = 403] = "FORBIDDEN";
        StatusCode[StatusCode["TIMEOUT"] = 408] = "TIMEOUT";
        StatusCode[StatusCode["GONE"] = 410] = "GONE";
        StatusCode[StatusCode["PAYLOAD_TOO_LARGE"] = 413] = "PAYLOAD_TOO_LARGE";
    })($5767c51dc6f9e25d$export$f66f92b8741acd5b || ($5767c51dc6f9e25d$export$f66f92b8741acd5b = {}));
    function $5767c51dc6f9e25d$export$cde1786a482f9a1c(error) {
        return $5767c51dc6f9e25d$export$9677d7c364ada66c(401, error) || $5767c51dc6f9e25d$export$9677d7c364ada66c(403, error);
    }
    function $5767c51dc6f9e25d$export$9677d7c364ada66c(statusCode, error) {
        if (!error) return false;
        if (error['status'] === statusCode || error['statusCode'] === statusCode) return true;
        const reg = new RegExp(`status (code)?.*(${statusCode})`);
        return !!error?.message?.match(reg);
    }
    function $5767c51dc6f9e25d$export$7c7624f23566b6ff(statusCode, message) {
        const reg = new RegExp(`status .*(${statusCode})`);
        return reg.test(message);
    }
    var $5767c51dc6f9e25d$export$c33cd4757598521c;
    (function(TeamErrorType) {
        TeamErrorType["TEAM_NOT_ACTIVE"] = "Team must be active";
    })($5767c51dc6f9e25d$export$c33cd4757598521c || ($5767c51dc6f9e25d$export$c33cd4757598521c = {}));
    class $5767c51dc6f9e25d$var$CommonError extends Error {
        constructor(message){
            super(message);
            this.name = this.constructor.name;
            this.message = message || 'UnknownError';
            this.stack = new Error(message).stack || '';
        }
    }
    class $5767c51dc6f9e25d$export$c73ca302efeda3b4 extends $5767c51dc6f9e25d$var$CommonError {
        constructor({ message: message }){
            super(message || 'UnknownError');
            Object.setPrototypeOf(this, $5767c51dc6f9e25d$export$c73ca302efeda3b4.prototype);
        }
    }
    class $5767c51dc6f9e25d$export$d87f401f8106d7a2 extends $5767c51dc6f9e25d$var$CommonError {
        constructor({ message: message }){
            super(`SentryIgnore: ${message || 'UnknownError'}`);
            Object.setPrototypeOf(this, $5767c51dc6f9e25d$export$d87f401f8106d7a2.prototype);
        }
    }
    class $5767c51dc6f9e25d$export$65bd6083489bd8bb extends $5767c51dc6f9e25d$var$CommonError {
        constructor({ message: message, status: status, traceId: traceId, path: path }){
            super(message);
            Object.setPrototypeOf(this, $5767c51dc6f9e25d$export$65bd6083489bd8bb.prototype);
            this.status = status;
            this.traceId = traceId;
            this.path = path;
        }
    }
    class $5767c51dc6f9e25d$export$826a3d65b8435adf extends $5767c51dc6f9e25d$export$65bd6083489bd8bb {
        constructor(props){
            super(props);
            Object.setPrototypeOf(this, $5767c51dc6f9e25d$export$826a3d65b8435adf.prototype);
        }
    }
    class $5767c51dc6f9e25d$export$92d6ed0888e7cb7f extends $5767c51dc6f9e25d$var$CommonError {
        constructor({ message: message, category: category = 'default', fields: fields }){
            super(message);
            Object.setPrototypeOf(this, $5767c51dc6f9e25d$export$92d6ed0888e7cb7f.prototype);
            this.category = category;
            if (fields) this.fields = fields;
        }
        static{
            this.from = (rawErrors)=>{
                const firstError = rawErrors[0];
                const errorData = {
                    category: firstError.category,
                    message: firstError.message
                };
                if (firstError.fields) errorData.fields = firstError.fields.reduce((obj, item)=>{
                    obj[item.field] = item.message;
                    return obj;
                }, {});
                return new $5767c51dc6f9e25d$export$92d6ed0888e7cb7f(errorData);
            };
        }
    }
    function $5767c51dc6f9e25d$export$476aa014e2fd89d5(error) {
        return error && !!error.message && (error.message.includes('NetworkError') || error.message.startsWith('Failed to fetch') || error.message.includes('GraphQL error: Failed to fetch') || error.message.includes('GraphQL error: The operation was aborted') || error.message.includes('GraphQL error: cancelled') || error.message.includes('Abgebrochen') || error.message.includes("\u043E\u0442\u043C\u0435\u043D\u0435\u043D\u043E") || error.message.includes("\u0421\u0435\u0442\u0435\u0432\u043E\u0435 \u0441\u043E\u0435\u0434\u0438\u043D\u0435\u043D\u0438\u0435 \u043F\u043E\u0442\u0435\u0440\u044F\u043D\u043E.") || error.message.includes('anulowane') || error.message.includes("annul\xe9") || error.message.includes("\u5DF2\u53D6\u6D88") || error.message.includes('cancelado') || error.message.includes("\u30AD\u30E3\u30F3\u30BB\u30EB\u3057\u307E\u3057\u305F") || error.message.includes('cancelled') || error.message.includes('Network error') || !!(error['graphQLErrors'] && error['networkError']));
    }
});
parcelRegister("dmOdc", function(module, exports) {
    $parcel$export(module.exports, "teamsClient", ()=>$1a92ea71d53eeb2b$export$5ed932c3646b89c6);
    var $hzxsr;
    var $gTh2z;
    var $cHmJ2;
    var $49fYn;
    var $gnKBB;
    var $7pLOg;
    var $8MCmh;
    var $13Kx5;
    var $h46cM;
    var $1B4EX;
    var $7thbw;
    var $93qCC;
    var $9zuJU;
    class $1a92ea71d53eeb2b$export$db59823f35bf78ce {
        constructor(context){
            this._aggClient = (0, (0, parcelRequire("gTh2z")).aggClient);
            this._directoryClient = (0, (0, parcelRequire("49fYn")).directoryClient);
            this._legionClient = (0, (0, parcelRequire("8MCmh")).defaultLegionClient);
            this._mutabilityClient = (0, (0, parcelRequire("13Kx5")).default);
            this._permsClient = (0, (0, parcelRequire("1B4EX")).default);
            this._publicApiClient = (0, (0, parcelRequire("7thbw")).default);
            this._invitationsClient = (0, (0, parcelRequire("7pLOg")).default);
            this._userPreferencesClient = (0, (0, parcelRequire("9zuJU")).default);
            this._objectResolverClient = (0, (0, parcelRequire("h46cM")).default);
            this._teamsInSlackClient = (0, (0, parcelRequire("93qCC")).default);
            this._collaborationGraphClient = (0, (0, parcelRequire("cHmJ2")).default);
            this._identityClient = (0, (0, parcelRequire("gnKBB")).default);
            if (context) this.setContext(context);
        }
        async measurePerformance(name, fn) {
            const exp = (0, (0, parcelRequire("hzxsr")).TEAMS_CLIENT_EXPERIENCES).get(name);
            if (!exp) return fn();
            exp.start();
            try {
                const result = await fn();
                exp.success();
                return result;
            } catch (e) {
                exp.failWithError(e);
                throw e;
            }
        }
        setBaseUrl(baseUrl) {
            this._aggClient.setBaseUrl(baseUrl);
            this._directoryClient.setBaseUrl(baseUrl);
        }
        setContext(context) {
            this._aggClient.setContext(context);
            this._directoryClient.setContext(context);
            this._legionClient.setContext(context);
            this._permsClient.setContext(context);
            this._mutabilityClient.setContext(context);
            this._publicApiClient.setContext(context);
            this._invitationsClient.setContext(context);
        }
        setDirectoryBaseUrl(baseUrl) {
            console.warn('setDirectoryBaseUrl is deprecated, use setBaseUrl instead');
            return this._directoryClient.setBaseUrl(baseUrl);
        }
        async querySettings(cloudId, product) {
            if (cloudId) this.setContext({
                cloudId: cloudId
            });
            return this.measurePerformance('querySettings', async ()=>{
                if (!product) throw new Error('Product is required');
                const response = await this._legionClient.retrieveBrowseUserPermission(product);
                return {
                    'internal.browse-users-allowed': response.canSearchUsers
                };
            });
        }
        async getPermissions() {
            return this.measurePerformance('getPermissions', ()=>this._legionClient.getPermissions());
        }
        async queryFeatureFlags(...args) {
            return this.measurePerformance('queryFeatureFlags', ()=>this._directoryClient.queryFeatureFlags(...args));
        }
        async queryTeamMemberships(teamId, membershipState = [
            'FULL_MEMBER'
        ], pageInfo = {
            first: 100
        }) {
            return this._aggClient.queryTeamMemberships(teamId, membershipState, pageInfo);
        }
        async queryAGGUser(userId) {
            return this._aggClient.queryAGGUser(userId);
        }
        queryUser(...args) {
            return this.measurePerformance('queryUser', ()=>this._directoryClient.queryUser(...args));
        }
        setLegionRootUrl(url) {
            return this._legionClient.setRootUrl(url);
        }
        async getTeamById(teamId) {
            return this.measurePerformance('getTeamById', ()=>this._legionClient.getTeamById(teamId));
        }
        async getAllTeams(...args) {
            return this.measurePerformance('getAllTeams', ()=>this._legionClient.getAllTeams(...args));
        }
        async updateTeamById(...args) {
            return this.measurePerformance('updateTeamById', ()=>this._legionClient.updateTeamById(...args));
        }
        async inviteUsersToTeam(...args) {
            return this.measurePerformance('inviteUsersToTeam', ()=>this._legionClient.inviteUsersToTeam(...args));
        }
        async getMyTeamMembership(...args) {
            return this.measurePerformance('getMyTeamMembership', ()=>this._legionClient.getMyTeamMembership(...args));
        }
        async getTeamLinksByTeamId(teamId) {
            return this.measurePerformance('getTeamLinksByTeamId', ()=>this._legionClient.getTeamLinksByTeamId(teamId));
        }
        async createTeamLink(...args) {
            return this.measurePerformance('createTeamLink', ()=>this._legionClient.createTeamLink(...args));
        }
        async updateTeamLink(...args) {
            return this.measurePerformance('updateTeamLink', ()=>this._legionClient.updateTeamLink(...args));
        }
        async deleteTeamLink(...args) {
            return this.measurePerformance('deleteTeamLink', ()=>this._legionClient.deleteTeamLink(...args));
        }
        async reorderTeamLink(...args) {
            return this.measurePerformance('reorderTeamLink', ()=>this._legionClient.reorderTeamLink(...args));
        }
        async acceptTeamInvitation(...args) {
            return this.measurePerformance('acceptTeamInvitation', ()=>this._legionClient.acceptTeamInvitation(...args));
        }
        async declineTeamInvitation(...args) {
            return this.measurePerformance('declineTeamInvitation', ()=>this._legionClient.declineTeamInvitation(...args));
        }
        async selfJoinTeam(...args) {
            return this.measurePerformance('selfJoinTeam', ()=>this._legionClient.selfJoinTeam(...args));
        }
        async cancelJoinRequest(teamId) {
            return this.measurePerformance('cancelJoinRequest', ()=>this._legionClient.cancelJoinRequest(teamId));
        }
        async acceptJoinRequest(...args) {
            return this.measurePerformance('acceptJoinRequest', ()=>this._legionClient.acceptJoinRequest(...args));
        }
        async declineJoinRequest(...args) {
            return this.measurePerformance('declineJoinRequest', ()=>this._legionClient.declineJoinRequest(...args));
        }
        async deleteTeamMembership(...args) {
            return this.measurePerformance('deleteTeamMembership', ()=>this._legionClient.deleteTeamMembership(...args));
        }
        async revokeTeamInvite(...args) {
            return this.measurePerformance('revokeTeamInvite', ()=>this._legionClient.revokeTeamInvite(...args));
        }
        async deleteTeam(teamId) {
            return this.measurePerformance('deleteTeam', ()=>this._legionClient.deleteTeam(teamId));
        }
        async isSingleFullMemberTeam(teamId) {
            return this._legionClient.isSingleFullMemberTeam(teamId);
        }
        async createTeam(...args) {
            return this.measurePerformance('createTeam', ()=>this._legionClient.createTeam(...args));
        }
        async createExternalTeam(...args) {
            return this.measurePerformance('createExternalTeam', ()=>this._legionClient.createExternalTeam(...args));
        }
        async getLinkedTeamsBulk(...args) {
            return this.measurePerformance('getLinkedTeamsBulk', ()=>this._legionClient.getLinkedTeamsBulk(...args));
        }
        async getOrgScope(...args) {
            return this.measurePerformance('getOrgScope', ()=>this._legionClient.getOrgScope(...args));
        }
        async restoreTeamToSyncedGroup(...args) {
            return this.measurePerformance('restoreTeamToSyncedGroup', ()=>this._legionClient.restoreTeamToSyncedGroup(...args));
        }
        async getTeamAndGroupDiff(...args) {
            return this.measurePerformance('getTeamAndGroupDiff', ()=>this._legionClient.getTeamAndGroupDiff(...args));
        }
        async linkExistingTeamToGroup(...args) {
            return this.measurePerformance('linkExistingTeamToGroup', ()=>this._legionClient.linkExistingTeamToGroup(...args));
        }
        async getTeamProfileDetailsByTeamId(...args) {
            return this.measurePerformance('getTeamProfileDetails', ()=>this._legionClient.getTeamProfileDetails(...args));
        }
        async getSoftDeletdTeamById(teamId) {
            return this.measurePerformance('getSoftDeletedTeamById', ()=>this._legionClient.getSoftDeletedTeamById(teamId));
        }
        async getUserInSiteUserBase(userId) {
            return this.measurePerformance('getUserInSiteUserBase', ()=>this._legionClient.getUserInSiteUserBase(userId));
        }
        trimTeamARI(teamId = '') {
            return this._legionClient.trimTeamARI(teamId);
        }
        async getProfileWithMutability(...args) {
            return this.measurePerformance('getProfileWithMutability', ()=>this._mutabilityClient.getProfileWithMutability(...args));
        }
        getIsSiteAdmin(...args) {
            return this.measurePerformance('getIsSiteAdmin', ()=>this._permsClient.getIsSiteAdmin(...args));
        }
        addUsersToTeam(...args) {
            return this.measurePerformance('addUsersToTeam', ()=>this._publicApiClient.addUsersToTeam(...args));
        }
        removeTeamMemberships(...args) {
            return this.measurePerformance('removeTeamMemberships', ()=>this._publicApiClient.removeTeamMemberships(...args));
        }
        restoreTeam(...args) {
            return this.measurePerformance('restoreTeam', ()=>this._publicApiClient.restoreTeam(...args));
        }
        getRecommendedProducts(...args) {
            return this.measurePerformance('getRecommendedProducts', ()=>this._invitationsClient.getProductRecommendations(...args));
        }
        joinOrRequestDefaultAccessToProductsBulk(...args) {
            return this.measurePerformance('joinOrRequestDefaultAccessToProductsBulk', ()=>this._invitationsClient.joinOrRequestDefaultAccessToProductsBulk(...args));
        }
        async getWriteTeamMediaToken() {
            return this.measurePerformance('getWriteTeamMediaToken', ()=>this._legionClient.getWriteMediaToken());
        }
        async getReadMediaToken(...args) {
            return this.measurePerformance('getReadMediaToken', ()=>this._userPreferencesClient.getReadMediaToken(...args));
        }
        async getWriteUserMediaToken() {
            return this.measurePerformance('getWriteUserMediaToken', ()=>this._userPreferencesClient.getWriteMediaToken());
        }
        async updateUserHeaderImage(headerImageId) {
            return this.measurePerformance('updateUserHeaderImage', ()=>this._userPreferencesClient.updateUserHeaderImage(headerImageId));
        }
        async getUserContainers(...args) {
            return this.measurePerformance('getUserContainers', ()=>this._collaborationGraphClient.getUserContainers(...args));
        }
        async getUserManageConfig(...args) {
            return this.measurePerformance('getUserManageConfig', ()=>this._identityClient.getUserManageConfig(...args));
        }
        async getMyAvatarUploadedStatus(...args) {
            return this.measurePerformance('getMyAvatarUploadedStatus', ()=>this._identityClient.getMyAvatarUploadedStatus(...args));
        }
        async getTeamLinkIcons(...args) {
            return this.measurePerformance('getTeamLinkIcons', ()=>this._objectResolverClient.getTeamLinkIcons(...args));
        }
        async getTeamInSlack(...args) {
            return this.measurePerformance('getTeamInSlack', ()=>this._teamsInSlackClient.getTeamInSlack(...args));
        }
    }
    const $1a92ea71d53eeb2b$export$5ed932c3646b89c6 = new $1a92ea71d53eeb2b$export$db59823f35bf78ce();
});
parcelRegister("hzxsr", function(module, exports) {
    $parcel$export(module.exports, "TEAMS_CLIENT_EXPERIENCES", ()=>$e069606520fb7fe4$export$879344107b04120c);
    var $atdLB;
    var $baNgi;
    const $e069606520fb7fe4$var$TeamsClientExperienceKeyList = [
        'getAllTeams',
        'getTeamById',
        'updateTeamById',
        'querySettings',
        'queryFeatureFlags',
        'queryTeamMemberships',
        'queryUser',
        'inviteUsersToTeam',
        'getMyTeamMembership',
        'getTeamLinksByTeamId',
        'createTeamLink',
        'updateTeamLink',
        'deleteTeamLink',
        'reorderTeamLink',
        'acceptTeamInvitation',
        'declineTeamInvitation',
        'selfJoinTeam',
        'cancelJoinRequest',
        'acceptJoinRequest',
        'declineJoinRequest',
        'deleteTeamMembership',
        'revokeTeamInvite',
        'deleteTeam',
        'isSingleFullMemberTeam',
        'createTeam',
        'createExternalTeam',
        'getProfileWithMutability',
        'getIsSiteAdmin',
        'addUsersToTeam',
        'removeTeamMemberships',
        'getRecommendedProducts',
        'joinOrRequestDefaultAccessToProductsBulk',
        'getReadMediaToken',
        'getWriteUserMediaToken',
        'updateUserHeaderImage',
        'getWriteTeamMediaToken',
        'getSoftDeletedTeamById',
        'restoreTeam',
        'getUserInSiteUserBase',
        'getLinkedTeamsBulk',
        'getTeamProfileDetails',
        'getUserContainers',
        'getPermissions',
        'getUserManageConfig',
        'getMyAvatarUploadedStatus',
        'getTeamLinkIcons',
        'getTeamInSlack',
        'getOrgScope',
        'restoreTeamToSyncedGroup',
        'getTeamAndGroupDiff',
        'linkExistingTeamToGroup'
    ];
    const $e069606520fb7fe4$export$879344107b04120c = new Map([
        ...$e069606520fb7fe4$var$TeamsClientExperienceKeyList.map((key)=>[
                key,
                new (0, (0, parcelRequire("baNgi")).TeamsUFOExperience)(`teams-client-${key.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase()}`, {
                    type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Operation,
                    performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).Custom,
                    platform: {
                        component: 'people'
                    }
                })
            ])
    ]);
});
parcelRegister("baNgi", function(module, exports) {
    $parcel$export(module.exports, "TeamsUFOExperience", ()=>$01e6318fcd37fd21$export$9a18529d1e90e81a);
    var $duUGa;
    var $1K4T6;
    var $139Gm;
    class $01e6318fcd37fd21$export$9a18529d1e90e81a extends (0, (0, parcelRequire("duUGa")).UFOExperience) {
        abortWithError(error, reason) {
            return super.abort({
                metadata: {
                    error: (0, (0, parcelRequire("139Gm")).createErrorMetadata)(error),
                    reason: reason
                }
            });
        }
        failWithError(error) {
            if (error instanceof Error) {
                if ((0, (0, parcelRequire("1K4T6")).isAuthError)(error)) return this.abortWithError(error, 'Abort due to user unauthenticated');
                if ((0, (0, parcelRequire("1K4T6")).isErrorStatusCode)((0, (0, parcelRequire("1K4T6")).StatusCode).GONE, error)) return this.abortWithError(error, 'Abort due to unavailable resource');
                if ((0, (0, parcelRequire("139Gm")).isIgnoredError)(error)) return this.abortWithError(error, 'Abort due to an error in ignore list');
                if ((0, (0, parcelRequire("1K4T6")).isNetworkError)(error)) return this.abortWithError(error, 'Abort due to network error');
                return super.failure({
                    metadata: {
                        error: (0, (0, parcelRequire("139Gm")).createErrorMetadata)(error),
                        packageVersion: "0.0.0-use.local",
                        packageName: "platform-pkg"
                    }
                });
            }
            return super.failure({
                metadata: {
                    error: 'unknown error',
                    packageVersion: "0.0.0-use.local",
                    packageName: "platform-pkg"
                }
            });
        }
    }
});
parcelRegister("139Gm", function(module, exports) {
    $parcel$export(module.exports, "createErrorMetadata", ()=>$07d4c8a32da63d6e$export$7286a0fb7b5aab6b);
    $parcel$export(module.exports, "isIgnoredError", ()=>$07d4c8a32da63d6e$export$a8da197a8bcc7e95);
    var $1K4T6;
    const $07d4c8a32da63d6e$export$7286a0fb7b5aab6b = (error)=>({
            error: {
                name: error.name,
                message: error.message,
                stack: error.stack,
                traceId: error instanceof (0, (0, parcelRequire("1K4T6")).HttpError) ? error.traceId : undefined,
                status: error instanceof (0, (0, parcelRequire("1K4T6")).HttpError) ? error.status : undefined
            }
        });
    const $07d4c8a32da63d6e$var$ignoredErrors = [
        'SLOIgnoreError',
        'SLOIgnoreHttpError'
    ];
    const $07d4c8a32da63d6e$export$a8da197a8bcc7e95 = (error)=>{
        const errorName = error?.constructor.name;
        if (!errorName) return false;
        return $07d4c8a32da63d6e$var$ignoredErrors.includes(errorName);
    };
});
parcelRegister("gTh2z", function(module, exports) {
    $parcel$export(module.exports, "aggClient", ()=>$68dbf55e48e6d3f1$export$464c991dbf0b2393);
    var $7FbBq;
    var $aOgFy;
    var $cPPyF;
    var $6laLp;
    var $7KcJC;
    var $iPviR;
    var $dEcp8;
    class $68dbf55e48e6d3f1$export$b44e5dafe13af7b3 extends (0, (0, parcelRequire("cPPyF")).BaseGraphQlClient) {
        constructor(baseUrl, config){
            super(`${baseUrl}/graphql`, config);
        }
        setBaseUrl(baseUrl) {
            this.setServiceUrl(`${baseUrl}/graphql`);
        }
        async queryTeamMemberships(teamId, membershipState = [
            'FULL_MEMBER'
        ], pageInfo = {
            first: 100
        }) {
            const response = await this.makeGraphQLRequest({
                query: (0, (0, parcelRequire("7KcJC")).default),
                variables: {
                    teamId: teamId,
                    membershipState: membershipState,
                    siteId: this.getCloudId(),
                    ...pageInfo
                }
            }, {
                operationName: 'TeamMembership'
            });
            return {
                edges: response.team.teamV2.members.edges.map(({ node: node })=>({
                        membershipId: {
                            teamId: teamId,
                            memberId: (0, (0, parcelRequire("7FbBq")).toUserId)(node.member.id)
                        },
                        state: node.state,
                        role: node.role,
                        user: {
                            id: (0, (0, parcelRequire("7FbBq")).toUserId)(node.member.id),
                            fullName: node.member.name,
                            avatarUrl: node.member.picture,
                            status: node.member.accountStatus,
                            title: node.member.extendedProfile?.jobTitle ?? undefined,
                            userType: (0, (0, parcelRequire("dEcp8")).toUserType)({
                                appType: node.member.appType
                            })
                        }
                    })),
                pageInfo: response.team.teamV2.members.pageInfo
            };
        }
        async queryAGGUser(userId) {
            const response = await this.makeGraphQLRequest({
                query: (0, (0, parcelRequire("iPviR")).TeamsUserQuery),
                variables: {
                    userId: userId
                }
            }, {
                operationName: 'TeamsUserQuery'
            });
            return response.user;
        }
    }
    const $68dbf55e48e6d3f1$export$464c991dbf0b2393 = new $68dbf55e48e6d3f1$export$b44e5dafe13af7b3((0, (0, parcelRequire("aOgFy")).DEFAULT_CONFIG).stargateRoot, {
        logException: (0, parcelRequire("6laLp")).logException
    });
});
parcelRegister("7FbBq", function(module, exports) {
    $parcel$export(module.exports, "toUserId", ()=>$17ec50633f4e2e7f$export$1d0eef1d33b05366);
    const $17ec50633f4e2e7f$export$caac29844ad91f64 = (ari)=>ari.startsWith((0, $11a0bc56687bdc88$export$470b0d72e4fdc43a));
    const $17ec50633f4e2e7f$export$1d0eef1d33b05366 = (ari)=>{
        if ($17ec50633f4e2e7f$export$caac29844ad91f64(ari)) return ari.replace((0, $11a0bc56687bdc88$export$470b0d72e4fdc43a), '');
        throw new Error('Invalid UserARI');
    };
    const $17ec50633f4e2e7f$export$fca6a88adb58674a = (userId)=>{
        return $17ec50633f4e2e7f$export$caac29844ad91f64(userId) ? userId : `${0, $11a0bc56687bdc88$export$470b0d72e4fdc43a}${userId}`;
    };
    const $17ec50633f4e2e7f$export$7b81d5dfd83c8166 = (ari)=>ari.startsWith((0, $11a0bc56687bdc88$export$cfedc369802e0c68));
    const $17ec50633f4e2e7f$export$e78216c959b9f3af = (ari)=>{
        if ($17ec50633f4e2e7f$export$7b81d5dfd83c8166(ari)) return ari.replace((0, $11a0bc56687bdc88$export$cfedc369802e0c68), '');
        throw new Error('Invalid TeamARI');
    };
    const $17ec50633f4e2e7f$export$2bcc6e4924859c6f = (teamId)=>{
        return $17ec50633f4e2e7f$export$7b81d5dfd83c8166(teamId) ? teamId : `${0, $11a0bc56687bdc88$export$cfedc369802e0c68}${teamId}`;
    };
});
const $11a0bc56687bdc88$export$470b0d72e4fdc43a = 'ari:cloud:identity::user/';
const $11a0bc56687bdc88$export$cfedc369802e0c68 = 'ari:cloud:identity::team/';
parcelRegister("aOgFy", function(module, exports) {
    $parcel$export(module.exports, "DEFAULT_CONFIG", ()=>$63e5f3a0103519a1$export$c2f8e0cc249a8d8f);
    const $63e5f3a0103519a1$export$c2f8e0cc249a8d8f = {
        stargateRoot: '/gateway/api',
        permsServiceUrl: '/gateway/api/permissions',
        publicApiRoot: '/gateway/api/public',
        invitationsServiceUrl: '/gateway/api/invitations',
        collaborationGraphUrl: '/gateway/api/collaboration'
    };
});
parcelRegister("cPPyF", function(module, exports) {
    $parcel$export(module.exports, "BaseGraphQlClient", ()=>$50423a8c851cd9c1$export$42f6d6baced34b2d);
    var $1K4T6;
    var $cIUqK;
    var $e5X66;
    class $50423a8c851cd9c1$export$42f6d6baced34b2d extends (0, (0, parcelRequire("cIUqK")).BaseClient) {
        constructor(serviceUrl, config){
            super(config);
            this.serviceUrl = serviceUrl;
        }
        setServiceUrl(serviceUrl) {
            this.serviceUrl = serviceUrl;
        }
        async makeGraphQLRequest(body, options = {}) {
            try {
                return (0, (0, parcelRequire("e5X66")).handleGraphQLRequest)(this.serviceUrl, body, options);
            } catch (error) {
                if (error instanceof (0, (0, parcelRequire("1K4T6")).GraphQLError)) throw error;
                this.logException(error, 'UnknownError in GraphQLClient.makeGraphQLRequestWithoutRetries');
                throw new (0, (0, parcelRequire("1K4T6")).DefaultError)({});
            }
        }
    }
});
parcelRegister("cIUqK", function(module, exports) {
    $parcel$export(module.exports, "BaseClient", ()=>$f6a5ca6563f596bf$export$4f22f74eddb7716a);
    var $6laLp;
    class $f6a5ca6563f596bf$export$4f22f74eddb7716a {
        constructor(config){
            this.cache = {};
            this.logException = (ex, name, context)=>{
                (0, (0, parcelRequire("6laLp")).logException)(ex, name, context);
                this.config.logException(ex, name, context);
            };
            this.config = config;
            this.context = {
                cloudId: 'None'
            };
        }
        setContext(context) {
            this.context = {
                ...context,
                cloudId: context.cloudId || 'None'
            };
        }
        getContext() {
            return this.context;
        }
        getOrgId(localValue) {
            const orgId = localValue || this.getContext().orgId;
            if (!orgId) {
                const err = new Error('No orgId set');
                this.logException(err, 'No orgId set');
                throw err;
            }
            return orgId;
        }
        getCloudId(localValue) {
            return localValue || this.getContext().cloudId;
        }
        keyWithContext(key) {
            return `${this.getContext().cloudId}-${this.getContext().orgId ?? 'no-org-id'}-${this.getContext().userId ?? 'no-user-id'}-${key}`;
        }
        cacheValue(key, value, expiryMs = 300000) {
            this.cache[this.keyWithContext(key)] = {
                data: value,
                expiration: Date.now() + expiryMs
            };
        }
        getCachedValue(key) {
            const record = this.cache[this.keyWithContext(key)];
            if (record && record.expiration > Date.now()) return record.data;
            return undefined;
        }
    }
});
parcelRegister("6laLp", function(module, exports) {
    $parcel$export(module.exports, "logException", ()=>$b8ae333ac130caf8$export$f86b2a1a2ce291b3);
    $parcel$export(module.exports, "logInfoMessage", ()=>$b8ae333ac130caf8$export$386587bcf05ee8ea);
    $parcel$export(module.exports, "logExceptionWithPackageContext", ()=>$b8ae333ac130caf8$export$7208e9272a946c36);
    $parcel$export(module.exports, "logErrorMessageWithPackageContext", ()=>$b8ae333ac130caf8$export$dbd2da61a76fb8d2);
    $parcel$export(module.exports, "logInfoMessageWithPackageContext", ()=>$b8ae333ac130caf8$export$f242834c5699e597);
    $parcel$export(module.exports, "createErrorHandlerWithPackageContext", ()=>$b8ae333ac130caf8$export$6b2a307bf7c6c1dc);
    $parcel$export(module.exports, "addBreadcrumb", ()=>$b8ae333ac130caf8$export$efda9a273d7a036d);
    var $6jQUd;
    function $b8ae333ac130caf8$var$decorateScope(scope, context) {
        const { tags: tags, ...otherContext } = context;
        if (tags) scope.setTags(tags);
        if (Object.keys(otherContext).length) scope.setExtras(otherContext);
        return scope;
    }
    async function $b8ae333ac130caf8$export$f86b2a1a2ce291b3(ex, name, context = {}) {
        try {
            const sentryClient = await (0, (0, parcelRequire("6jQUd")).getSentryClient)();
            if (!sentryClient || typeof sentryClient.captureException !== 'function') return;
            sentryClient.withScope((scope)=>{
                $b8ae333ac130caf8$var$decorateScope(scope, context);
                scope.setTag('name', name);
                scope.setTag('packageName', context.packageName ?? 'unknown');
                scope.setTag('packageVersion', context.packageVersion ?? 'unknown');
                sentryClient.captureException(ex, scope);
            });
        } catch  {}
    }
    async function $b8ae333ac130caf8$var$logMessage(severity, message, context = {}) {
        const sentryClient = await (0, (0, parcelRequire("6jQUd")).getSentryClient)();
        if (!sentryClient || typeof sentryClient.captureException !== 'function') return;
        sentryClient.withScope((scope)=>{
            $b8ae333ac130caf8$var$decorateScope(scope, context);
            scope.setLevel(severity);
            scope.setTag('packageName', context.packageName ?? 'unknown');
            scope.setTag('packageVersion', context.packageVersion ?? 'unknown');
            sentryClient.captureMessage(message, scope);
        });
    }
    function $b8ae333ac130caf8$export$ece28f5cfa04608(message, context = {}) {
        $b8ae333ac130caf8$var$logMessage('error', message, context).catch(()=>{});
    }
    function $b8ae333ac130caf8$export$386587bcf05ee8ea(message, context = {}) {
        $b8ae333ac130caf8$var$logMessage('info', message, context).catch(()=>{});
    }
    const $b8ae333ac130caf8$export$9edc7d6f1c33ddc = (details)=>{
        return (error, message, tags = {})=>{
            $b8ae333ac130caf8$export$f86b2a1a2ce291b3(error, message, {
                tags: {
                    ...details,
                    ...tags
                }
            });
        };
    };
    const $b8ae333ac130caf8$export$7208e9272a946c36 = (packageContext)=>(...args)=>{
            $b8ae333ac130caf8$export$f86b2a1a2ce291b3(args[0], args[1], {
                ...args[2],
                packageName: packageContext.packageName,
                packageVersion: packageContext.packageVersion
            });
        };
    const $b8ae333ac130caf8$export$dbd2da61a76fb8d2 = (packageContext)=>(...args)=>{
            $b8ae333ac130caf8$export$ece28f5cfa04608(args[0], {
                ...args[1],
                packageName: packageContext.packageName,
                packageVersion: packageContext.packageVersion
            });
        };
    const $b8ae333ac130caf8$export$f242834c5699e597 = (packageContext)=>(...args)=>{
            $b8ae333ac130caf8$export$386587bcf05ee8ea(args[0], {
                ...args[1],
                packageName: packageContext.packageName,
                packageVersion: packageContext.packageVersion
            });
        };
    const $b8ae333ac130caf8$export$6b2a307bf7c6c1dc = (packageContext)=>(...args)=>$b8ae333ac130caf8$export$9edc7d6f1c33ddc({
                ...args[0],
                packageName: packageContext.packageName,
                packageVersion: packageContext.packageVersion
            });
    async function $b8ae333ac130caf8$export$efda9a273d7a036d(crumb) {
        const sentryClient = await (0, (0, parcelRequire("6jQUd")).getSentryClient)();
        sentryClient.withScope((scope)=>{
            scope.addBreadcrumb(typeof crumb === 'string' ? {
                message: crumb
            } : crumb);
        });
    }
});
parcelRegister("6jQUd", function(module, exports) {
    $parcel$export(module.exports, "sentryClient", ()=>$1a080a899118f506$export$ac71c212168fcd2b);
    $parcel$export(module.exports, "setSentryClient", ()=>$1a080a899118f506$export$7d446c6f4e54de82);
    $parcel$export(module.exports, "getSentryClient", ()=>$1a080a899118f506$export$f553e8b08ef59d31);
    $parcel$export(module.exports, "setupSentryClient", ()=>$1a080a899118f506$export$d8bd0edf6c978788);
    var $cESX7;
    var $f90f5;
    let $1a080a899118f506$export$ac71c212168fcd2b;
    const $1a080a899118f506$export$7d446c6f4e54de82 = (client)=>{
        $1a080a899118f506$export$ac71c212168fcd2b = client;
    };
    const $1a080a899118f506$export$f553e8b08ef59d31 = async ()=>{
        if (!$1a080a899118f506$export$ac71c212168fcd2b) await $1a080a899118f506$export$d8bd0edf6c978788({});
        return $1a080a899118f506$export$ac71c212168fcd2b;
    };
    async function $1a080a899118f506$export$d8bd0edf6c978788({ appName: appName, env: env }) {
        const sentryClient = await $1a080a899118f506$var$requireSentryLib();
        if (!sentryClient) return;
        (0, (0, parcelRequire("f90f5")).initialiseSentry)(sentryClient, {
            initialScope: {
                tags: {
                    renderMode: appName || 'unknown',
                    productBuild: window.BUILD_KEY || window.__buildInfo?.FRONTEND_VERSION || 'unknown',
                    product: $1a080a899118f506$var$getProduct()
                }
            },
            env: env,
            noGlobals: true,
            dsn: (0, (0, parcelRequire("cESX7")).SENTRY_DSN),
            attachStacktrace: true
        });
    }
    async function $1a080a899118f506$var$requireSentryLib() {
        try {
            return (parcelRequire("2ktdj"));
        } catch (error) {
            console.warn('Ignoring rejected promise when loading sentry resource.', error);
        }
    }
    function $1a080a899118f506$var$getProduct() {
        const path = window.location.pathname;
        if (path.includes('/jira/people')) return 'jira';
        else if (path.includes('/wiki/people')) return 'confluence';
        return 'unknown';
    }
});
parcelRegister("cESX7", function(module, exports) {
    $parcel$export(module.exports, "SENTRY_DSN", ()=>$7172257c54583cfa$export$6faa4a850bc4d0ce);
    var $aIZdc;
    const $7172257c54583cfa$export$9cf97fd92bea5d81 = '1dc056d49dfe4df8961dc1b810e4620d';
    const $7172257c54583cfa$export$68c35ed3898e185a = '5988845';
    const $7172257c54583cfa$var$SENTRY_COMMERCIAL_DSN = `https://${$7172257c54583cfa$export$9cf97fd92bea5d81}@o55978.ingest.sentry.io/${$7172257c54583cfa$export$68c35ed3898e185a}`;
    const $7172257c54583cfa$var$SENTRY_FEDRAMP_DSN = `https://${$7172257c54583cfa$export$9cf97fd92bea5d81}@sentry.atlassian-us-gov-mod.com/${$7172257c54583cfa$export$68c35ed3898e185a}`;
    const $7172257c54583cfa$export$6faa4a850bc4d0ce = (0, (0, parcelRequire("aIZdc")).isFedRamp)() ? $7172257c54583cfa$var$SENTRY_FEDRAMP_DSN : $7172257c54583cfa$var$SENTRY_COMMERCIAL_DSN;
});
parcelRegister("f90f5", function(module, exports) {
    $parcel$export(module.exports, "initialiseSentry", ()=>$bb873a2430dbd9e0$export$357606956af25316);
    var $lqMqM;
    var $6jQUd;
    const $bb873a2430dbd9e0$var$DISABLED_INTEGRATIONS = [
        'onerror',
        'onunhandledrejection',
        'Dedupe'
    ];
    async function $bb873a2430dbd9e0$export$357606956af25316(client, options) {
        if (0, (0, parcelRequire("6jQUd")).sentryClient) return;
        if (!client) return;
        (0, (0, parcelRequire("6jQUd")).setSentryClient)(client);
        const sentryConfig = (0, (0, parcelRequire("lqMqM")).getSentryConfig)(options);
        (0, (0, parcelRequire("6jQUd")).sentryClient).init({
            ...sentryConfig,
            integrations: function(integrations) {
                return integrations.filter(function(integration) {
                    return $bb873a2430dbd9e0$var$DISABLED_INTEGRATIONS.indexOf(integration.name) === -1;
                });
            }
        });
    }
});
parcelRegister("lqMqM", function(module, exports) {
    $parcel$export(module.exports, "getSentryConfig", ()=>$0ea77fabdacad2ed$export$5580e6304e95c792);
    var $cESX7;
    const $0ea77fabdacad2ed$var$DEFAULT_SENTRY_CONFIG = {
        whitelistUrls: [
            /atl-paas.net/,
            /localhost/
        ],
        ignoreErrors: [
            /^SentryIgnore:/,
            'The operation was aborted',
            'Software caused connection abort',
            'GraphQL error: Failed to fetch',
            'TypeError: Failed to fetch',
            'TypeError: NetworkError when attempting to fetch resource.',
            'AbortError: The user aborted a request.',
            /^network error/i,
            /^network failure/i,
            /^NetworkError/i,
            /^Unexpected token ..*/
        ],
        ignoreUrls: [
            /extensions\//i,
            /^chrome:\/\//i
        ],
        dsn: (0, (0, parcelRequire("cESX7")).SENTRY_DSN),
        attachStacktrace: true
    };
    function $0ea77fabdacad2ed$export$5580e6304e95c792(options) {
        const { env: env, version: version, noGlobals: _, ...otherOptions } = options;
        return {
            ...otherOptions,
            ...$0ea77fabdacad2ed$var$DEFAULT_SENTRY_CONFIG,
            release: `${"platform-pkg"}@${"0.0.0-use.local"}` || window.BUILD_KEY || window.__buildInfo?.FRONTEND_VERSION || '---',
            environment: env || 'prod'
        };
    }
});
parcelRegister("2ktdj", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("3OU89").then(()=>parcelRequire('godCI'));
});
parcelRegister("e5X66", function(module, exports) {
    $parcel$export(module.exports, "handleGraphQLRequest", ()=>$dacc5a55576333f2$export$7feffc86760ee7ce);
    var $1K4T6;
    var $4F5SC;
    var $hdjej;
    async function $dacc5a55576333f2$export$93d33e3b46bf00e7(serviceUrl, body, options = {}) {
        const operationNameQuery = options.operationName ? `?q=${options.operationName}` : '';
        const errorPolicy = options.errorPolicy || 'none';
        const url = serviceUrl + operationNameQuery;
        const request = fetch(url, {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json'
            }),
            credentials: 'include',
            body: JSON.stringify(body)
        }).then((res)=>{
            if (res.status < 300 || res.status === 400) return res.json();
            else throw res;
        });
        try {
            const response = await request;
            const errors = response.errors;
            if (errors) {
                if (errorPolicy === 'none') throw (0, (0, parcelRequire("1K4T6")).GraphQLError).from(errors);
                else if (errorPolicy === 'all') return new Promise((resolve, reject)=>{
                    setTimeout(()=>{
                        reject((0, (0, parcelRequire("1K4T6")).GraphQLError).from(errors));
                    }, 0);
                });
            }
            return response.data;
        } catch (error) {
            if (error instanceof Response) return {
                response: error
            };
            if (Object(error).hasOwnProperty('response')) throw error;
            return error;
        }
    }
    async function $dacc5a55576333f2$export$7feffc86760ee7ce(serviceUrl, body, options = {}) {
        const makeGraphQLRequestWithRetries = (0, (0, parcelRequire("4F5SC")).withExponentialBackoff)($dacc5a55576333f2$export$93d33e3b46bf00e7, {
            initial: (0, (0, parcelRequire("4F5SC")).EXPONENTIAL_BACKOFF_RETRY_POLICY).INITIAL_DELAY,
            jitter: (0, (0, parcelRequire("4F5SC")).EXPONENTIAL_BACKOFF_RETRY_POLICY).JITTER,
            max: (0, (0, parcelRequire("4F5SC")).EXPONENTIAL_BACKOFF_RETRY_POLICY).MAX_RETRIES,
            retryIf: (data)=>{
                return (0, (0, parcelRequire("4F5SC")).isFetchResponse)(data) && (0, (0, parcelRequire("4F5SC")).is5xx)(data.response.status);
            }
        });
        const result = await makeGraphQLRequestWithRetries(serviceUrl, body, options);
        const response = result?.response;
        if (response) {
            const status = response.status;
            const statusText = response.statusText;
            const traceId = response.headers.get('atl-traceid');
            (0, (0, parcelRequire("hdjej")).handleResponse)(response);
            if (status > 400 && status <= 599) throw new (0, (0, parcelRequire("1K4T6")).HttpError)({
                message: statusText,
                status: status,
                traceId: traceId ?? undefined
            });
        }
        return result;
    }
});
parcelRegister("4F5SC", function(module, exports) {
    $parcel$export(module.exports, "EXPONENTIAL_BACKOFF_RETRY_POLICY", ()=>$0bcb1394a3249358$export$8f4286bf21155381);
    $parcel$export(module.exports, "is5xx", ()=>$0bcb1394a3249358$export$55b2fbd5d4a32495);
    $parcel$export(module.exports, "isFetchResponse", ()=>$0bcb1394a3249358$export$81f27058be86d7ea);
    $parcel$export(module.exports, "withExponentialBackoff", ()=>$0bcb1394a3249358$export$20eaa22f2295996f);
    $parcel$export(module.exports, "fetchWithExponentialBackoff", ()=>$0bcb1394a3249358$export$b4c0bf5325504bf3);
    const $0bcb1394a3249358$export$8f4286bf21155381 = {
        INITIAL_DELAY: 200,
        MAX_RETRIES: 5,
        JITTER: true
    };
    function $0bcb1394a3249358$export$55b2fbd5d4a32495(status) {
        return 500 <= status && status <= 599;
    }
    function $0bcb1394a3249358$export$81f27058be86d7ea(data) {
        if (!data || !data.hasOwnProperty('response')) return false;
        return data.response instanceof Response;
    }
    const $0bcb1394a3249358$var$defaultRetryIfCallback = (a)=>!a;
    const $0bcb1394a3249358$var$defaultOptions = {
        initial: 200,
        jitter: false,
        max: 5,
        retryIf: $0bcb1394a3249358$var$defaultRetryIfCallback
    };
    function $0bcb1394a3249358$export$20eaa22f2295996f(toTry, hofOptions = $0bcb1394a3249358$var$defaultOptions) {
        const { initial: initial, jitter: jitter, max: max, retryIf: retryIf } = hofOptions;
        let attemptsRemaining = max;
        let delay = initial;
        return async function tryWithExponentialBackoff(...args) {
            const result = await toTry(...args);
            --attemptsRemaining;
            if (retryIf && retryIf(result) && attemptsRemaining > 0) {
                await new Promise((resolve)=>setTimeout(resolve, jitter ? Math.random() * delay : delay));
                delay *= 2;
                return tryWithExponentialBackoff(...args);
            }
            return result;
        };
    }
    const $0bcb1394a3249358$export$b4c0bf5325504bf3 = $0bcb1394a3249358$export$20eaa22f2295996f((url, init)=>fetch(url, init), {
        initial: $0bcb1394a3249358$export$8f4286bf21155381.INITIAL_DELAY,
        jitter: $0bcb1394a3249358$export$8f4286bf21155381.JITTER,
        max: $0bcb1394a3249358$export$8f4286bf21155381.MAX_RETRIES,
        retryIf: (response)=>$0bcb1394a3249358$export$55b2fbd5d4a32495(response.status)
    });
});
parcelRegister("hdjej", function(module, exports) {
    $parcel$export(module.exports, "handleResponse", ()=>$9c1b9c6605e9f581$export$c113a67a6762ad2e);
    const $9c1b9c6605e9f581$export$8c005e458e12d501 = {
        handlers: {},
        get () {
            return $9c1b9c6605e9f581$export$8c005e458e12d501.handlers;
        },
        setHandlers (handlers) {
            $9c1b9c6605e9f581$export$8c005e458e12d501.handlers = handlers;
        }
    };
    function $9c1b9c6605e9f581$export$c113a67a6762ad2e(response) {
        const { status: status } = response;
        const handler = $9c1b9c6605e9f581$export$8c005e458e12d501.get()[status];
        if (typeof handler === 'function') handler(response);
    }
});
parcelRegister("7KcJC", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$db20d2370669efd9$export$2e2bcd8739ae039);
    var $VSDnB;
    const $db20d2370669efd9$var$TeamMembershipQuery = `query TeamMembership($teamId: ID!, $siteId: String!, $membershipState: [TeamMembershipState!]!, $first: Int!, $after: String) {
  team {
    teamV2(
      id: $teamId
      siteId: $siteId
    ) @optIn(to: "Team-v2") {
      members(state: $membershipState, first: $first, after: $after) {
        edges {
          node {
            member {
              id
              name
              picture
              accountStatus
              ... on AtlassianAccountUser {
                extendedProfile {
                  jobTitle
                }
              }
            }
            role
            state
          }
        }
        pageInfo {
          endCursor
          hasNextPage
        }
      }
    }
  }
}`;
    const $db20d2370669efd9$var$TeamMembershipQueryNext = `query app_user_characteristics($teamId: ID!, $siteId: String!, $membershipState: [TeamMembershipState!]!, $first: Int!, $after: String) {
    team {
      teamV2(
        id: $teamId
        siteId: $siteId
      ) @optIn(to: "Team-v2") {
        members(state: $membershipState, first: $first, after: $after) {
          edges {
            node {
              member {
                id
                name
                picture
                accountStatus
                ... on AtlassianAccountUser {
                  extendedProfile {
                    jobTitle
                  }
                }
                ... on AppUser {
                  appType
                }
              }
              role
              state
            }
          }
          pageInfo {
            endCursor
            hasNextPage
          }
        }
      }
    }
  }`;
    var $db20d2370669efd9$export$2e2bcd8739ae039 = (0, (0, parcelRequire("VSDnB")).fg)('enable_teams_for_agents') ? $db20d2370669efd9$var$TeamMembershipQueryNext : $db20d2370669efd9$var$TeamMembershipQuery;
});
parcelRegister("iPviR", function(module, exports) {
    $parcel$export(module.exports, "TeamsUserQuery", ()=>$35ae14e4e07b2810$export$9963ed3cbf7b791c);
    var $1c8Um;
    var $5cllN;
    const $35ae14e4e07b2810$export$9963ed3cbf7b791c = (0, (0, parcelRequire("1c8Um")).print)((0, (0, parcelRequire("5cllN")).default)`
	query TeamsUserQuery($userId: ID!) {
		user(accountId: $userId) {
			id
			name
			picture
			accountStatus
			__typename
			... on AtlassianAccountUser {
				email
				nickname
				locale
				zoneinfo
				extendedProfile {
					jobTitle
					organization
					department
					location
					phoneNumbers {
						type
						value
					}
					closedDate
					inactiveDate
				}
			}
			... on CustomerUser {
				email
				locale
				zoneinfo
			}
			... on AppUser {
				appType
			}
		}
	}
`);
});
parcelRegister("dEcp8", function(module, exports) {
    $parcel$export(module.exports, "toUserType", ()=>$ed1cf12a11d1cbd9$export$6b53fef091c7e27d);
    function $ed1cf12a11d1cbd9$export$6b53fef091c7e27d({ isBot: isBot, appType: appType }) {
        if (appType?.toLocaleLowerCase() === 'agent') return 'agent';
        if (isBot) return 'bot';
        return 'user';
    }
});
parcelRegister("cHmJ2", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6a1db79055c7f98d$export$2e2bcd8739ae039);
    var $aOgFy;
    var $hrPaF;
    var $6a1db79055c7f98d$var$CONTAINER_TYPE;
    (function(CONTAINER_TYPE) {
        CONTAINER_TYPE["JIRA_PROJECT"] = "jiraProject";
        CONTAINER_TYPE["CONFLUENCE_SPACE"] = "confluenceSpace";
    })($6a1db79055c7f98d$var$CONTAINER_TYPE || ($6a1db79055c7f98d$var$CONTAINER_TYPE = {}));
    var $6a1db79055c7f98d$var$ENTITY_TYPE;
    (function(ENTITY_TYPE) {
        ENTITY_TYPE["CONTAINER"] = "CONTAINER";
        ENTITY_TYPE["USER"] = "USER";
    })($6a1db79055c7f98d$var$ENTITY_TYPE || ($6a1db79055c7f98d$var$ENTITY_TYPE = {}));
    class $6a1db79055c7f98d$export$cd5b4a06db0ea4e2 extends (0, (0, parcelRequire("hrPaF")).RestClient) {
        getUserContainers({ userId: userId, principalId: principalId, siteId: siteId, sessionId: sessionId, maxNumberOfResults: maxNumberOfResults }) {
            return this.postResource('/v1/collaborationgraph/user/container', {
                context: {
                    contextType: 'atlassianDirectory',
                    principalId: principalId,
                    siteId: siteId,
                    sessionId: sessionId
                },
                containerTypes: [
                    'confluenceSpace',
                    'jiraProject'
                ],
                maxNumberOfResults: maxNumberOfResults,
                userId: userId,
                expanded: true
            });
        }
    }
    var $6a1db79055c7f98d$export$2e2bcd8739ae039 = new $6a1db79055c7f98d$export$cd5b4a06db0ea4e2({
        serviceUrl: (0, (0, parcelRequire("aOgFy")).DEFAULT_CONFIG).collaborationGraphUrl
    });
});
parcelRegister("hrPaF", function(module, exports) {
    $parcel$export(module.exports, "RestClient", ()=>$0c6f97fa956e6402$export$ea8b5b3aea9558ce);
    var $bxYf9 = parcelRequire("bxYf9");
    var $1K4T6;
    var $4F5SC;
    var $hdjej;
    var $cIUqK;
    var $9WYOs;
    var $gnGnQ;
    var $cKoHA;
    var $3lXoL;
    const $0c6f97fa956e6402$var$defaultFetchOptions = {
        credentials: 'include',
        headers: {
            Accept: 'application/json'
        },
        mode: 'cors'
    };
    let $0c6f97fa956e6402$var$incrementRedirectCount;
    let $0c6f97fa956e6402$var$clearRedirectCount;
    $0c6f97fa956e6402$export$7a0fc52d8c359feb();
    function $0c6f97fa956e6402$export$7a0fc52d8c359feb() {
        $0c6f97fa956e6402$var$incrementRedirectCount = (0, ($parcel$interopDefault($bxYf9)))(()=>(0, (0, parcelRequire("9WYOs")).setCookie)((0, (0, parcelRequire("9WYOs")).REDIRECT_COUNT), (0, (0, parcelRequire("9WYOs")).getCookieAsInteger)((0, (0, parcelRequire("9WYOs")).REDIRECT_COUNT)) + 1));
        $0c6f97fa956e6402$var$clearRedirectCount = (0, ($parcel$interopDefault($bxYf9)))(()=>(0, (0, parcelRequire("9WYOs")).clearCookie)((0, (0, parcelRequire("9WYOs")).REDIRECT_COUNT)));
    }
    class $0c6f97fa956e6402$export$ea8b5b3aea9558ce extends (0, (0, parcelRequire("cIUqK")).BaseClient) {
        constructor({ serviceUrl: serviceUrl = '', config: config = {
            logException: ()=>{}
        } }){
            super(config), this.preventInfiniteRedirectLoop = (response)=>{
                if (!response.ok) {
                    const responseStatusCode = response.status;
                    if (responseStatusCode === 401) $0c6f97fa956e6402$var$incrementRedirectCount();
                } else $0c6f97fa956e6402$var$clearRedirectCount();
            };
            this.serviceUrl = serviceUrl;
        }
        setServiceUrl(serviceUrl) {
            this.serviceUrl = serviceUrl;
        }
        async getResource(path, fetchOptions = {}) {
            return this.makeRequest(path, fetchOptions);
        }
        async getResourceCached(path, fetchOptions = {}, cacheOptions) {
            const cacheKey = path;
            const cacheRecord = this.getCachedValue(cacheKey);
            if (cacheRecord) return cacheRecord;
            const response = await this.getResource(path, fetchOptions);
            this.cacheValue(cacheKey, response, cacheOptions?.expiration);
            return response;
        }
        async postResource(path, data, fetchOptions = {}) {
            return this.postResourceRaw(path, JSON.stringify(data), fetchOptions);
        }
        async postResourceRaw(path, data, fetchOptions = {}) {
            fetchOptions = {
                method: 'post',
                headers: {},
                ...fetchOptions
            };
            if (data) fetchOptions = {
                body: data,
                ...fetchOptions,
                headers: {
                    'Content-Type': 'application/json',
                    ...fetchOptions.headers
                }
            };
            return this.makeRequest(path, fetchOptions);
        }
        async patchResource(path, data) {
            let fetchOptions = {
                method: 'PATCH'
            };
            if (data) fetchOptions = {
                ...fetchOptions,
                body: JSON.stringify(data),
                headers: {
                    'Content-Type': 'application/json'
                }
            };
            return this.makeRequest(path, fetchOptions);
        }
        async putResource(path, data, additionalFetchOptions = {}) {
            const fetchOptions = {
                method: 'put'
            };
            if (data) Object.assign(fetchOptions, {
                body: JSON.stringify(data),
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            return this.makeRequest(path, {
                ...fetchOptions,
                ...additionalFetchOptions
            });
        }
        async deleteResource(path, options = {}) {
            const fetchOptions = {
                ...options,
                method: 'delete'
            };
            return this.makeRequest(path, fetchOptions);
        }
        async makeRequest(path, additionalFetchOptions = {
            shouldLogError: (e)=>e.status !== 429
        }) {
            const url = this.serviceUrl + path;
            const options = {
                ...$0c6f97fa956e6402$var$defaultFetchOptions,
                ...additionalFetchOptions
            };
            const response = await (0, (0, parcelRequire("4F5SC")).fetchWithExponentialBackoff)(url, options);
            this.preventInfiniteRedirectLoop(response);
            (0, (0, parcelRequire("hdjej")).handleResponse)(response);
            const responseStatusCode = response.status;
            const traceId = response.headers.get('atl-traceid');
            if (!response.ok) {
                if (responseStatusCode === 401) throw new (0, (0, parcelRequire("1K4T6")).SLOIgnoreError)({
                    message: 'Unauthorized Request - incrementing redirect count'
                });
                else {
                    const message = await (0, (0, parcelRequire("gnGnQ")).parseErrorMessage)(response);
                    const httpError = new (0, (0, parcelRequire("1K4T6")).HttpError)({
                        message: message,
                        status: responseStatusCode,
                        traceId: traceId ?? undefined,
                        path: path
                    });
                    if (options.shouldLogError && options.shouldLogError(httpError)) this.logException(httpError, (0, (0, parcelRequire("3lXoL")).stripUUIDFromPath)(path), {
                        method: options.method || 'GET',
                        url: url,
                        status: responseStatusCode
                    });
                    throw httpError;
                }
            }
            return additionalFetchOptions.ignoreResponse ? null : (0, (0, parcelRequire("cKoHA")).parseResponse)(response);
        }
    }
});
parcelRegister("9WYOs", function(module, exports) {
    $parcel$export(module.exports, "REDIRECT_COUNT", ()=>$bf41c8766f9a88e5$export$f6101897f0230549);
    $parcel$export(module.exports, "setCookie", ()=>$bf41c8766f9a88e5$export$110700823644f4a6);
    $parcel$export(module.exports, "getCookieAsInteger", ()=>$bf41c8766f9a88e5$export$6a289e5003f59269);
    $parcel$export(module.exports, "clearCookie", ()=>$bf41c8766f9a88e5$export$ad3506281d5a5e5d);
    const $bf41c8766f9a88e5$export$f6101897f0230549 = 'redirectCount';
    const $bf41c8766f9a88e5$export$5a7d8afb87170e45 = 'avatar.csrf.token';
    function $bf41c8766f9a88e5$export$110700823644f4a6(key, value) {
        document.cookie = `${key}=${value};path=/;max-age=30`;
    }
    function $bf41c8766f9a88e5$export$6a289e5003f59269(key, defaultValue = 0) {
        const regex = new RegExp(`${key}=(\\d+)`);
        const result = document.cookie.match(regex);
        return result ? parseInt(result[1], 10) : defaultValue;
    }
    function $bf41c8766f9a88e5$export$ad3506281d5a5e5d(key) {
        document.cookie = `${key}=doesntmatter;path=/;expires=Thu, 01 Jan 1970 00:00:01 GMT`;
    }
});
parcelRegister("gnGnQ", function(module, exports) {
    $parcel$export(module.exports, "parseErrorMessage", ()=>$dbd61437f2184940$export$91c32f1b22d29b2d);
    async function $dbd61437f2184940$export$91c32f1b22d29b2d(response) {
        let json;
        const text = await response.text();
        try {
            json = JSON.parse(text);
        } catch (err) {
            return text;
        }
        delete json.timestamp;
        if (json.error) return `${json.status || 'UNKNOWN_STATUS'} ${json.error || 'MISSING_ERROR_MESSAGE'}`;
        else if (json.status) return `${json.status} MISSING_ERROR_MESSAGE`;
        else if (json.errors) {
            const errs = json.errors.map((error)=>typeof error === 'string' ? error : error.code || error.message || 'MISSING_ERROR_MESSAGE');
            return errs.join('\n - ');
        }
        return JSON.stringify(json);
    }
});
parcelRegister("cKoHA", function(module, exports) {
    $parcel$export(module.exports, "parseResponse", ()=>$571f67df8e1c13fb$export$ba14d9a5a581e827);
    function $571f67df8e1c13fb$export$ba14d9a5a581e827(response) {
        const responseStatusCode = response.status;
        if (responseStatusCode === 204 || responseStatusCode === 202) return null;
        const contentType = response.headers.get('content-type');
        if (!contentType || contentType.includes('text/html') || contentType.includes('text/plain')) return response.text();
        if (contentType.includes('application/json')) return response.json();
        return null;
    }
});
parcelRegister("3lXoL", function(module, exports) {
    $parcel$export(module.exports, "stripUUIDFromPath", ()=>$a95ff77b07a38502$export$6bd073e2c6dda996);
    const $a95ff77b07a38502$var$UUID_REGEX = new RegExp(/((\w{4,12}-?)){5}/g);
    const $a95ff77b07a38502$export$6bd073e2c6dda996 = (path)=>{
        return path.replace($a95ff77b07a38502$var$UUID_REGEX, '<UUID>');
    };
});
parcelRegister("49fYn", function(module, exports) {
    $parcel$export(module.exports, "directoryClient", ()=>$4b31d9e631f37e0f$export$ead519165de472de);
    var $aOgFy;
    var $cPPyF;
    var $6laLp;
    const $4b31d9e631f37e0f$export$28456d095a642fd = 'internal.browse-users-allowed';
    const $4b31d9e631f37e0f$var$buildTeamMembershipQuery = (teamId, membershipState)=>({
            query: `query TeamMembership($teamId: String!, $membershipState: [TeamMembershipStatus]) {
    TeamMembership: TeamMembership(teamId: $teamId, membershipStates: $membershipState) {
      user: profile {
        id,
        fullName,
        title,
        avatarUrl,
        timezone,
        status
      },
      state:membershipStatus,
      role,
      membershipId {
        teamId, memberId
      }
    }
  }`,
            variables: {
                teamId: teamId,
                membershipState: membershipState
            }
        });
    const $4b31d9e631f37e0f$var$buildUserQuery = (userId, cloudId)=>({
            query: `query CloudUser($userId: String!, $cloudId: String!) {
    CloudUser(userId: $userId, cloudId: $cloudId) {
      avatarUrl
      id
      fullName
      title
    }
  }`,
            variables: {
                userId: userId,
                cloudId: cloudId
            }
        });
    const $4b31d9e631f37e0f$var$delay = (millis)=>new Promise((resolve)=>{
            setTimeout(resolve, millis);
        });
    class $4b31d9e631f37e0f$export$c8a50bf6c196fc10 extends (0, (0, parcelRequire("cPPyF")).BaseGraphQlClient) {
        constructor(baseUrl, config){
            super(`${baseUrl}/directory/graphql`, config);
        }
        setBaseUrl(baseUrl) {
            this.setServiceUrl(`${baseUrl}/directory/graphql`);
        }
        async queryFeatureFlags(cloudId, flags) {
            const queryFeatureFlags = {
                query: `query FeatureFlags($cloudId: String!, $flags: [String]!) {
        FeatureFlags(cloudId: $cloudId, flags: $flags) {
          flag
          enabled
        }
      }`,
                variables: {
                    cloudId: this.getCloudId(cloudId),
                    flags: flags
                }
            };
            const { FeatureFlags: FeatureFlags } = await this.makeGraphQLRequest(queryFeatureFlags, {
                operationName: 'FeatureFlags'
            });
            return FeatureFlags.map(({ flag: flag, enabled: enabled })=>[
                    flag,
                    enabled
                ]).reduce((acc, val)=>(acc[val[0]] = val[1], acc), {});
        }
        canRetryError(pendingRetries, error) {
            return pendingRetries > 0 && !!error && typeof error === 'object' && 'category' in error && error.category === 'NotFound';
        }
        queryTeamMemberships(teamId, membershipStatus = [
            'FULL_MEMBER'
        ]) {
            console.warn('Directory queryTeamMemberships is deprecated, use AGG instead');
            const teamMembershipsQuery = $4b31d9e631f37e0f$var$buildTeamMembershipQuery(teamId, membershipStatus);
            const performRequest = async (pendingRetries = 3, backoffMaxDelay = 2000)=>{
                try {
                    return await this.makeGraphQLRequest(teamMembershipsQuery, {
                        operationName: 'TeamMembership'
                    });
                } catch (error) {
                    if (this.canRetryError(pendingRetries, error)) {
                        await $4b31d9e631f37e0f$var$delay(backoffMaxDelay / pendingRetries);
                        return performRequest(pendingRetries - 1);
                    }
                    throw error;
                }
            };
            return performRequest().then(({ TeamMembership: TeamMembership })=>TeamMembership);
        }
        queryUser(userId, cloudId) {
            const userQuery = $4b31d9e631f37e0f$var$buildUserQuery(userId, this.getCloudId(cloudId));
            const performRequest = async (pendingRetries = 3, backoffMaxDelay = 2000)=>{
                try {
                    return await this.makeGraphQLRequest(userQuery, {
                        operationName: 'CloudUser'
                    });
                } catch (error) {
                    if (this.canRetryError(pendingRetries, error)) {
                        await $4b31d9e631f37e0f$var$delay(backoffMaxDelay / pendingRetries);
                        return performRequest(pendingRetries - 1);
                    }
                    throw error;
                }
            };
            return performRequest();
        }
    }
    const $4b31d9e631f37e0f$export$ead519165de472de = new $4b31d9e631f37e0f$export$c8a50bf6c196fc10((0, (0, parcelRequire("aOgFy")).DEFAULT_CONFIG).stargateRoot, {
        logException: (0, parcelRequire("6laLp")).logException
    });
});
parcelRegister("gnKBB", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$38997081039c300e$export$2e2bcd8739ae039);
    var $aOgFy;
    var $hrPaF;
    var $hcbtx;
    const $38997081039c300e$var$defaultConfig = {
        serviceUrl: `${(0, (0, parcelRequire("aOgFy")).DEFAULT_CONFIG).stargateRoot}/users`
    };
    class $38997081039c300e$export$f9c003efee04f318 extends (0, (0, parcelRequire("hrPaF")).RestClient) {
        constructor(config = {}){
            super({
                ...$38997081039c300e$var$defaultConfig,
                ...config
            });
        }
        async getUserManageConfig(userId) {
            return this.getResourceCached(`/${userId}/manage`).then((resp)=>{
                return (0, (0, parcelRequire("hcbtx")).transformUserManageConfig)(resp);
            });
        }
        async getMyAvatarUploadedStatus(userId) {
            return this.getResourceCached(`/${userId}/manage/avatar`);
        }
    }
    var $38997081039c300e$export$2e2bcd8739ae039 = new $38997081039c300e$export$f9c003efee04f318();
});
parcelRegister("hcbtx", function(module, exports) {
    $parcel$export(module.exports, "transformUserManageConfig", ()=>$e90b5aaa9134b760$export$d7725d3d27b80a68);
    var $e90b5aaa9134b760$export$ed12481c953b8653;
    (function(FieldType) {
        FieldType["FullName"] = "fullName";
        FieldType["Nickname"] = "nickname";
        FieldType["Title"] = "title";
        FieldType["Department"] = "department";
        FieldType["CompanyName"] = "companyName";
        FieldType["Location"] = "location";
        FieldType["Timezone"] = "timezone";
        FieldType["Email"] = "email";
        FieldType["PhoneNumber"] = "phoneNumber";
        FieldType["Avatar"] = "picture";
        FieldType["Language"] = "language";
        FieldType["LocalTime"] = "localTime";
        FieldType["RemoteWeekdayIndex"] = "remoteWeekdayIndex";
        FieldType["RemoteWeekdayString"] = "remoteWeekdayString";
        FieldType["RemoteTimeString"] = "remoteTimeString";
    })($e90b5aaa9134b760$export$ed12481c953b8653 || ($e90b5aaa9134b760$export$ed12481c953b8653 = {}));
    const $e90b5aaa9134b760$export$78158d2c2c6998d9 = {
        fullName: 'name',
        nickname: 'nickname',
        timezone: 'zoneinfo',
        locale: 'locale',
        email: 'email',
        title: 'extended_profile.job_title',
        phoneNumber: 'extended_profile.phone_number',
        companyName: 'extended_profile.organization',
        department: 'extended_profile.department',
        location: 'extended_profile.location'
    };
    const $e90b5aaa9134b760$export$2ff7b92b9e1bb4d2 = {
        email: 'email.initiateChange',
        picture: 'avatar'
    };
    const $e90b5aaa9134b760$var$getFieldConfig = (data, field)=>{
        if ((field === 'email' || field === 'picture') && $e90b5aaa9134b760$export$2ff7b92b9e1bb4d2[field]) return data[$e90b5aaa9134b760$export$2ff7b92b9e1bb4d2[field]];
        const mappedFieldKey = field in $e90b5aaa9134b760$export$78158d2c2c6998d9 ? $e90b5aaa9134b760$export$78158d2c2c6998d9[field] : undefined;
        if (!mappedFieldKey) return undefined;
        const profileWrite = data['profile.write'];
        return profileWrite[mappedFieldKey];
    };
    const $e90b5aaa9134b760$var$convertFieldKeyToFieldType = (key)=>{
        if (Object.values($e90b5aaa9134b760$export$ed12481c953b8653).includes(key)) return key;
        return undefined;
    };
    const $e90b5aaa9134b760$var$getMutabilityConstraintFor = (data, field)=>{
        const fieldConfig = $e90b5aaa9134b760$var$getFieldConfig(data, field);
        if (!fieldConfig || fieldConfig.allowed) return undefined;
        const convertedField = $e90b5aaa9134b760$var$convertFieldKeyToFieldType(field);
        if (!convertedField) return undefined;
        const reason = fieldConfig.reason;
        return {
            field: convertedField,
            reason: reason && reason.key || null
        };
    };
    const $e90b5aaa9134b760$export$d7725d3d27b80a68 = (data)=>({
            mutabilityConstraints: Object.keys($e90b5aaa9134b760$export$78158d2c2c6998d9).map((field)=>$e90b5aaa9134b760$var$getMutabilityConstraintFor(data, field)).filter((constraint)=>constraint !== undefined)
        });
});
parcelRegister("7pLOg", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b9ae585c7017b5f5$export$2e2bcd8739ae039);
    var $aOgFy;
    var $hrPaF;
    var $6laLp;
    var $9yQ7J;
    const $b9ae585c7017b5f5$var$PRODUCT_RECCOMENDATIONS = '/v1/product-recommendations';
    const $b9ae585c7017b5f5$var$PRODUCT_JOIN_OR_REQUEST_BULK = '/v1/access-requests/bulk/request';
    const $b9ae585c7017b5f5$var$ALL_SUPPORTED_PRODUCTS = [
        'confluence',
        'jira',
        'jira-core',
        'jira-servicedesk',
        'jira-software',
        'jira-incident-manager',
        'jira-product-discovery',
        'opsgenie',
        'statuspage',
        'avocado',
        'townsquare',
        'compass',
        'avp',
        'beacon',
        'mercury'
    ];
    class $b9ae585c7017b5f5$export$3209eb31343f39d extends (0, (0, parcelRequire("hrPaF")).RestClient) {
        constructor(serviceUrl, config){
            super({
                serviceUrl: serviceUrl,
                config: config
            });
        }
        async getProductRecommendationsInner(supportedProducts = $b9ae585c7017b5f5$var$ALL_SUPPORTED_PRODUCTS, capabilities) {
            try {
                const orgId = this.getOrgId();
                const queryProducts = supportedProducts && supportedProducts.length > 0 ? supportedProducts : $b9ae585c7017b5f5$var$ALL_SUPPORTED_PRODUCTS;
                const productQueryParams = queryProducts.map((product)=>`product=${product}`).join('&');
                const capabilityQueryParams = capabilities && capabilities.length > 0 ? '&' + capabilities.map((capability)=>`capability=${capability}`).join('&') : '';
                const url = `${$b9ae585c7017b5f5$var$PRODUCT_RECCOMENDATIONS}?orgId=${orgId}&${productQueryParams}${capabilityQueryParams}`;
                return await this.getResource(url);
            } catch (error) {
                this.logException(error, 'An error occurred while getting product recommendations.');
                throw error;
            }
        }
        async getProductRecommendations(supportedProducts = $b9ae585c7017b5f5$var$ALL_SUPPORTED_PRODUCTS, capabilities) {
            const result = await this.getProductRecommendationsInner(supportedProducts, capabilities);
            try {
                const deduplicatedResult = (0, (0, parcelRequire("9yQ7J")).removeDuplicateRecommendations)(result);
                return deduplicatedResult;
            } catch (error) {
                this.logException(error, 'An error occurred while deduplicating product recommendations.');
                throw error;
            }
        }
        async joinOrRequestDefaultAccessToProductsBulk(simplifiedRequest) {
            if (simplifiedRequest.productAris.length === 0) return Promise.resolve([]);
            try {
                const resources = simplifiedRequest.productAris.map((ari)=>({
                        ari: ari,
                        role: 'product/member'
                    }));
                const request = {
                    resources: resources,
                    note: simplifiedRequest.note,
                    accessMode: simplifiedRequest.accessMode,
                    source: simplifiedRequest.source
                };
                return await this.postResource($b9ae585c7017b5f5$var$PRODUCT_JOIN_OR_REQUEST_BULK, request);
            } catch (error) {
                this.logException(error, 'An error occurred while joining or requesting access to products.');
                throw error;
            }
        }
    }
    var $b9ae585c7017b5f5$export$2e2bcd8739ae039 = new $b9ae585c7017b5f5$export$3209eb31343f39d((0, (0, parcelRequire("aOgFy")).DEFAULT_CONFIG).invitationsServiceUrl, {
        logException: (0, parcelRequire("6laLp")).logException
    });
});
parcelRegister("9yQ7J", function(module, exports) {
    $parcel$export(module.exports, "removeDuplicateRecommendations", ()=>$3c835b25600ef74b$export$d9d1c981635dd213);
    const $3c835b25600ef74b$var$compareCapability = (a, b)=>{
        if (a === b) return 0;
        return a === 'DIRECT_ACCESS' ? -1 : 1;
    };
    const $3c835b25600ef74b$var$compareMode = (a, b)=>{
        if (a === b) return 0;
        if (!a) return 1;
        if (!b) return -1;
        return a === 'OPEN' ? -1 : 1;
    };
    const $3c835b25600ef74b$var$compareRecommendations = (a, b)=>{
        if (a.resourceId !== b.resourceId) throw new Error('Recommendations must have the same resource ID');
        if ($3c835b25600ef74b$var$compareCapability(a.capability, b.capability) < 0) return -1;
        else if ($3c835b25600ef74b$var$compareCapability(a.capability, b.capability) > 0) return 1;
        else if ($3c835b25600ef74b$var$compareMode(a.mode, b.mode) < 0) return -1;
        else if ($3c835b25600ef74b$var$compareMode(a.mode, b.mode) > 0) return 1;
        return 0;
    };
    const $3c835b25600ef74b$var$toRecommendation = (recommendation)=>{
        const { capability: capability, ...rest } = recommendation;
        return {
            ...rest
        };
    };
    const $3c835b25600ef74b$export$d9d1c981635dd213 = (recommendations)=>{
        const { DIRECT_ACCESS: DIRECT_ACCESS, REQUEST_ACCESS: REQUEST_ACCESS } = recommendations.capability;
        const uniqueRecommendations = {};
        const allRecommendations = [
            ...DIRECT_ACCESS.map((recommendation)=>({
                    ...recommendation,
                    capability: 'DIRECT_ACCESS'
                })),
            ...REQUEST_ACCESS.map((recommendation)=>({
                    ...recommendation,
                    capability: 'REQUEST_ACCESS'
                }))
        ];
        allRecommendations.forEach((recommendation)=>{
            const existing = uniqueRecommendations[recommendation.resourceId];
            if (existing && $3c835b25600ef74b$var$compareRecommendations(existing, recommendation) <= 0) return;
            uniqueRecommendations[recommendation.resourceId] = recommendation;
        });
        const allUniqueRecommendations = Object.values(uniqueRecommendations);
        return {
            capability: {
                DIRECT_ACCESS: allUniqueRecommendations.filter((recommendation)=>recommendation.capability === 'DIRECT_ACCESS').map($3c835b25600ef74b$var$toRecommendation),
                REQUEST_ACCESS: allUniqueRecommendations.filter((recommendation)=>recommendation.capability === 'REQUEST_ACCESS').map($3c835b25600ef74b$var$toRecommendation)
            }
        };
    };
});
parcelRegister("8MCmh", function(module, exports) {
    $parcel$export(module.exports, "defaultLegionClient", ()=>$2443af7a75778c61$export$95c697fe95d86a77);
    var $aOgFy;
    var $hrPaF;
    const $2443af7a75778c61$var$v3UrlPath = `/v3/teams`;
    const $2443af7a75778c61$var$v4UrlPath = `/v4/teams`;
    class $2443af7a75778c61$export$68a6a391e3cf23be extends (0, (0, parcelRequire("hrPaF")).RestClient) {
        constructor(serviceUrl){
            super({
                serviceUrl: serviceUrl
            });
            this.serviceUrlRoot = serviceUrl;
        }
        setRootUrl(url) {
            if (url === this.serviceUrlRoot) return;
            this.serviceUrlRoot = url;
            this.setServiceUrl(url);
        }
        async getTeamById(teamId) {
            const siteId = this.getCloudId();
            const teamResponse = await this.getResource(`${$2443af7a75778c61$var$v4UrlPath}/${this.trimTeamARI(teamId)}?siteId=${siteId}`);
            return this.mapTeamResponseV4ToTeam(teamResponse);
        }
        async getAllTeams(allTeamsQuery) {
            try {
                const orgId = this.getOrgId(allTeamsQuery.orgId);
                const siteId = this.getCloudId();
                const { entities: entities, cursor: cursor } = await this.postResource(`${$2443af7a75778c61$var$v4UrlPath}/search`, {
                    organizationId: orgId,
                    siteId: siteId,
                    limit: allTeamsQuery.limit,
                    query: allTeamsQuery.searchQuery,
                    cursor: allTeamsQuery.cursor || '',
                    sortBy: allTeamsQuery.useDefaultSort ? null : [
                        {
                            field: 'displayName',
                            order: 'asc'
                        }
                    ],
                    membership: {
                        memberAccountIds: allTeamsQuery.memberAccountIds
                    },
                    showEmptyTeams: allTeamsQuery.showEmptyTeams
                });
                const teams = entities.map((t)=>this.mapTeamSearchResponseV4ToTeamWithMembership(t));
                return {
                    cursor: cursor,
                    teams: teams
                };
            } catch (error) {
                this.logException(error, 'getAllTeams');
                return {
                    cursor: '',
                    teams: [],
                    error: error instanceof Error ? error : undefined
                };
            }
        }
        async updateTeamById(teamId, data) {
            const teamResponse = await this.patchResource(`${$2443af7a75778c61$var$v4UrlPath}/${this.trimTeamARI(teamId)}`, data);
            return this.mapTeamResponseV4ToTeam(teamResponse);
        }
        async inviteUsersToTeam(teamId, users, originQuery) {
            if (!users || users.length === 0) return Promise.resolve([]);
            const emails = [];
            const ids = [];
            users.forEach((user)=>{
                if (user.id) ids.push(user.id);
                else if (user.email) emails.push(user.email);
            });
            const url = `${$2443af7a75778c61$var$v3UrlPath}/ui/${this.trimTeamARI(teamId)}/membership/invite?${this.constructProductOriginParams(originQuery)}`;
            return this.postResource(url, {
                emailAddresses: emails,
                atlassianAccounts: ids
            });
        }
        async getMyTeamMembership(teamId) {
            return this.getResource(`${$2443af7a75778c61$var$v4UrlPath}/${this.trimTeamARI(teamId)}/membership/me?siteId=${this.getCloudId()}`, {
                shouldLogError: (e)=>e.status !== 400
            });
        }
        async getTeamLinksByTeamId(teamId) {
            let siteId = this.getCloudId();
            let response = await this.getResource(`${$2443af7a75778c61$var$v4UrlPath}/${this.trimTeamARI(teamId)}/links?siteId=${siteId}`);
            return this.mapLegionTeamLinksResponseV4ToTeamLinkResponse(response);
        }
        async createTeamLink(teamId, link) {
            const sanitisedTeamLink = {
                contentTitle: link.contentTitle.trim(),
                linkUri: link.linkUri.trim(),
                description: link.description.trim(),
                ...link.creationTime ? {
                    creationTime: link.creationTime.trim()
                } : {},
                ...link.teamId ? {
                    teamId: link.teamId.trim()
                } : {}
            };
            const response = await this.postResource(`${$2443af7a75778c61$var$v4UrlPath}/${this.trimTeamARI(teamId)}/links`, sanitisedTeamLink);
            return this.mapLegionTeamLinkResponseV4ToTeamLink(response);
        }
        async updateTeamLink(teamId, linkId, { linkUri: linkUri, ...linkFields }) {
            const response = await this.putResource(`${$2443af7a75778c61$var$v4UrlPath}/${this.trimTeamARI(teamId)}/links/${linkId}`, {
                linkUri: linkUri.trim(),
                ...linkFields
            });
            return this.mapLegionTeamLinkResponseV4ToTeamLink(response);
        }
        async deleteTeamLink(teamId, linkId) {
            return this.deleteResource(`${$2443af7a75778c61$var$v4UrlPath}/${this.trimTeamARI(teamId)}/links/${linkId}`);
        }
        async reorderTeamLink(teamId, linkId, newPosition) {
            const queryArgs = `?linkId=${linkId}&newPosition=${newPosition}`;
            return this.postResource(`${$2443af7a75778c61$var$v4UrlPath}/${this.trimTeamARI(teamId)}/links/order${queryArgs}`);
        }
        async acceptTeamInvitation(teamId) {
            return this.postResource(`${$2443af7a75778c61$var$v3UrlPath}/ui/${this.trimTeamARI(teamId)}/membership/accept`);
        }
        async declineTeamInvitation(teamId) {
            return this.postResource(`${$2443af7a75778c61$var$v3UrlPath}/ui/${this.trimTeamARI(teamId)}/membership/decline`);
        }
        async selfJoinTeam(teamId, originQuery) {
            const url = `${$2443af7a75778c61$var$v4UrlPath}/${this.trimTeamARI(teamId)}/membership/join?${this.constructProductOriginParams(originQuery)}`;
            return this.postResource(url);
        }
        async cancelJoinRequest(teamId) {
            return this.deleteResource(`${$2443af7a75778c61$var$v4UrlPath}/${this.trimTeamARI(teamId)}/membership/request`);
        }
        async acceptJoinRequest(teamId, memberId) {
            return this.postResource(`${$2443af7a75778c61$var$v4UrlPath}/${this.trimTeamARI(teamId)}/membership/${memberId}/request/accept`);
        }
        async declineJoinRequest(teamId, memberId) {
            return this.postResource(`${$2443af7a75778c61$var$v4UrlPath}/${this.trimTeamARI(teamId)}/membership/${memberId}/request/decline`);
        }
        async deleteTeamMembership(teamId, memberId) {
            return this.deleteResource(`${$2443af7a75778c61$var$v3UrlPath}/${this.trimTeamARI(teamId)}/members/${memberId}`);
        }
        async revokeTeamInvite(teamId, memberId) {
            return this.deleteResource(`${$2443af7a75778c61$var$v3UrlPath}/ui/${this.trimTeamARI(teamId)}/membership/${memberId}/revoke`);
        }
        async deleteTeam(teamId) {
            return this.deleteResource(`${$2443af7a75778c61$var$v4UrlPath}/${this.trimTeamARI(teamId)}`);
        }
        async isSingleFullMemberTeam(teamId) {
            const members = await this.getResource(`${$2443af7a75778c61$var$v4UrlPath}/${this.trimTeamARI(teamId)}/members?size=2&membershipState=FULL_MEMBER&siteId=${this.getCloudId()}`);
            return members.entities.length === 1;
        }
        async createTeam(displayName, originQuery, members, membershipSettings = 'OPEN') {
            const organizationId = this.getContext().orgId;
            if (!organizationId) {
                const err = new Error('Organization ID is required');
                this.logException(err, 'createTeam');
                throw err;
            }
            const url = `${$2443af7a75778c61$var$v4UrlPath}?${this.constructProductOriginParams(originQuery)}`;
            const legionTeam = await this.postResource(url, {
                displayName: displayName,
                description: '',
                membershipSettings: membershipSettings,
                siteId: this.getCloudId(),
                organizationId: organizationId,
                members: [
                    ...new Set(members)
                ]
            });
            return this.mapTeamCreateResponseV4ToTeam(legionTeam);
        }
        async createExternalTeam(description, externalReference, teamName, siteId) {
            const organizationId = this.getContext().orgId;
            const cloudId = this.getContext().cloudId;
            if (!organizationId) {
                const err = new Error('Organization ID is required');
                this.logException(err, 'createTeam');
                throw err;
            }
            const url = `${$2443af7a75778c61$var$v4UrlPath}/external?origin.cloudId=${encodeURIComponent(this.getCloudId(siteId || cloudId))}`;
            const legionExternalTeam = await this.postResource(url, {
                description: description,
                externalReference: externalReference,
                organizationId: organizationId,
                siteId: siteId || cloudId,
                displayName: teamName
            });
            return this.mapTeamCreateResponseV4ToTeam(legionExternalTeam);
        }
        async getTeamAndGroupDiff(teamId, externalReference) {
            const siteId = this.getCloudId();
            return this.postResource(`${$2443af7a75778c61$var$v4UrlPath}/${this.trimTeamARI(teamId)}/external/diff`, {
                siteId: siteId,
                externalReference: externalReference
            });
        }
        async linkExistingTeamToGroup(teamId, externalReference) {
            return this.postResource(`${$2443af7a75778c61$var$v4UrlPath}/${this.trimTeamARI(teamId)}/external/link`, {
                externalReference: externalReference
            });
        }
        async getWriteMediaToken() {
            return this.getResource('/v4/teams/header-image/media-upload').then((response)=>({
                    ...response,
                    baseUrl: response.baseUrl?.endsWith('/') ? response.baseUrl.slice(0, -1) : response.baseUrl
                }));
        }
        async getSoftDeletedTeamById(teamId) {
            const orgId = this.getOrgId();
            const siteId = this.getCloudId();
            return this.getResource(`${$2443af7a75778c61$var$v4UrlPath}/org/${orgId}/soft-deleted/${this.trimTeamARI(teamId)}?siteId=${siteId}`).then((response)=>({
                    ...response.teamResponse,
                    id: teamId
                }));
        }
        async getUserInSiteUserBase(userId) {
            const siteId = this.getCloudId();
            return this.getResource(`/teams/site/${siteId}/users/${userId}/exists`, {
                headers: {
                    Accept: 'application/json',
                    'X-header-client-id': 'ptc-fe'
                }
            });
        }
        async retrieveBrowseUserPermission(product) {
            return this.getResourceCached(`/teams/site/${this.getCloudId()}/canSearchUsers?product=${product}`, undefined, {
                expiration: 120000
            });
        }
        async getPermissions() {
            const orgId = this.getContext().orgId;
            const siteId = this.getCloudId();
            if (!orgId) {
                const err = new Error('Organization ID is required');
                this.logException(err, 'getPermissions');
                throw err;
            }
            return this.getResourceCached(`${$2443af7a75778c61$var$v4UrlPath}/permission/self/organization/${orgId}?siteId=${siteId}`);
        }
        async getLinkedTeamsBulk(groupIds) {
            const organizationId = this.getContext().orgId;
            if (!organizationId) {
                const err = new Error('Organization ID is required');
                this.logException(err, 'getLinkedTeamsBulk');
                throw err;
            }
            const legionExternalTeam = await this.postResource(`${$2443af7a75778c61$var$v4UrlPath}/external/bulk`, {
                organizationId: organizationId,
                source: 'ATLASSIAN_GROUP',
                externalIds: groupIds
            });
            return legionExternalTeam;
        }
        async getTeamProfileDetails(teamId) {
            const siteId = this.getCloudId();
            if (!siteId) {
                const err = new Error('Site ID is required');
                this.logException(err, 'getTeamProfileDetails');
                throw err;
            }
            const linkedTeamsProfileDetails = await this.getResource(`${$2443af7a75778c61$var$v4UrlPath}/${teamId}/profile?siteId=${this.getCloudId()}`);
            return linkedTeamsProfileDetails;
        }
        async getOrgScope() {
            const orgId = this.getContext().orgId;
            if (!orgId) {
                const err = new Error('Organization ID is required');
                this.logException(err, 'getOrgScope');
                throw err;
            }
            const orgScope = await this.getResourceCached(`${$2443af7a75778c61$var$v4UrlPath}/org/${orgId}/scope`);
            return orgScope;
        }
        async restoreTeamToSyncedGroup(teamId, externalReference) {
            return await this.postResource(`${$2443af7a75778c61$var$v4UrlPath}/${teamId}/external/restore`, {
                externalReference: externalReference
            });
        }
        trimTeamARI(teamId = '') {
            const OLD_TEAM_ARI_PREFIX = 'ari:cloud:teams::team/';
            const TEAM_ARI_PREFIX = 'ari:cloud:identity::team/';
            return teamId.replace(TEAM_ARI_PREFIX, '').replace(OLD_TEAM_ARI_PREFIX, '');
        }
        constructProductOriginParams(originQuery) {
            const product = (originQuery.product || '').toUpperCase();
            const queries = [
                `origin.cloudId=${encodeURIComponent(this.getCloudId(originQuery.cloudId))}`
            ];
            if (product) queries.push(`origin.product=${encodeURIComponent(product)}`);
            return queries.join('&');
        }
        mapTeamResponseV4ToTeam(teamResponse) {
            return {
                id: teamResponse.id,
                displayName: teamResponse.displayName,
                description: teamResponse.description,
                state: teamResponse.state,
                membershipSettings: teamResponse.membershipSettings,
                organizationId: teamResponse.organizationId,
                restriction: 'ORG_MEMBERS',
                creatorId: teamResponse.creatorId,
                permission: teamResponse.permission,
                orgId: teamResponse.organizationId,
                smallHeaderImageUrl: teamResponse.smallHeaderImageUrl,
                largeHeaderImageUrl: teamResponse.largeHeaderImageUrl,
                smallAvatarImageUrl: teamResponse.smallAvatarImageUrl,
                largeAvatarImageUrl: teamResponse.largeAvatarImageUrl,
                scopeMode: teamResponse.scopeMode,
                isVerified: teamResponse.isVerified
            };
        }
        mapTeamCreateResponseV4ToTeam(teamResponse) {
            return {
                id: teamResponse.id,
                displayName: teamResponse.displayName,
                description: teamResponse.description,
                state: teamResponse.state,
                membershipSettings: teamResponse.membershipSettings,
                organizationId: teamResponse.organizationId,
                restriction: 'ORG_MEMBERS',
                creatorId: teamResponse.creatorId,
                permission: teamResponse.permission,
                orgId: teamResponse.organizationId,
                memberIds: teamResponse.membership?.members?.map((m)=>m.membershipId.memberId) || [],
                membership: teamResponse.membership
            };
        }
        mapTeamSearchResponseV4ToTeamWithMembership(teamResponse) {
            return {
                id: teamResponse.id,
                displayName: teamResponse.displayName,
                description: teamResponse.description,
                state: teamResponse.state,
                membershipSettings: teamResponse.membershipSettings,
                organizationId: teamResponse.organizationId,
                restriction: 'ORG_MEMBERS',
                smallHeaderImageUrl: teamResponse.smallHeaderImageUrl,
                largeAvatarImageUrl: teamResponse.largeAvatarImageUrl,
                smallAvatarImageUrl: teamResponse.smallAvatarImageUrl,
                largeHeaderImageUrl: teamResponse.largeHeaderImageUrl,
                memberCount: teamResponse.memberCount,
                includesYou: teamResponse.includesYou,
                memberIds: [],
                members: [],
                membership: {
                    members: [],
                    errors: []
                },
                isVerified: teamResponse.isVerified
            };
        }
        mapLegionTeamLinksResponseV3ToTeamLinkResponse(response) {
            return {
                entities: response.entities.map(this.mapLegionTeamLinkResponseV3ToTeamLink)
            };
        }
        mapLegionTeamLinksResponseV4ToTeamLinkResponse(response) {
            return {
                entities: response.entities.map(this.mapLegionTeamLinkResponseV4ToTeamLink)
            };
        }
        mapLegionTeamLinkResponseV3ToTeamLink(legionLinkResponseV3) {
            return {
                contentTitle: legionLinkResponseV3.contentTitle,
                description: legionLinkResponseV3.description,
                creationTime: legionLinkResponseV3.creationTime,
                linkUri: legionLinkResponseV3.linkUri,
                linkId: legionLinkResponseV3.linkId,
                teamId: legionLinkResponseV3.teamId
            };
        }
        mapLegionTeamLinkResponseV4ToTeamLink(legionLinkResponseV4) {
            return {
                contentTitle: legionLinkResponseV4.contentTitle,
                description: legionLinkResponseV4.description,
                linkUri: legionLinkResponseV4.linkUri,
                linkId: legionLinkResponseV4.linkId,
                teamId: legionLinkResponseV4.teamId
            };
        }
    }
    const $2443af7a75778c61$export$95c697fe95d86a77 = new $2443af7a75778c61$export$68a6a391e3cf23be((0, (0, parcelRequire("aOgFy")).DEFAULT_CONFIG).stargateRoot);
});
parcelRegister("13Kx5", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$96e9f24df4d329d9$export$2e2bcd8739ae039);
    var $1K4T6;
    var $aOgFy;
    var $hrPaF;
    const $96e9f24df4d329d9$var$defaultConfig = {
        serviceUrl: `${(0, (0, parcelRequire("aOgFy")).DEFAULT_CONFIG).stargateRoot}/users/manage`
    };
    const $96e9f24df4d329d9$var$NOT_EDITABLE = 'not_editable';
    const $96e9f24df4d329d9$var$NOT_EDITABLE_FIELD = 'field';
    const $96e9f24df4d329d9$var$NOT_EDITABLE_REASON = 'reason';
    class $96e9f24df4d329d9$export$1f387592ab3ca6d0 extends (0, (0, parcelRequire("hrPaF")).RestClient) {
        constructor(config = {}){
            super({
                ...$96e9f24df4d329d9$var$defaultConfig,
                ...config
            });
        }
        async getProfileWithMutability(userId) {
            return this.getResource(`/${userId}/profile`).then((resp)=>{
                return $96e9f24df4d329d9$var$mapToMutabilityConstraints(resp);
            });
        }
    }
    function $96e9f24df4d329d9$var$mapToMutabilityConstraints(json) {
        let constraints = [];
        if (json[$96e9f24df4d329d9$var$NOT_EDITABLE] != null) for (const value of json[$96e9f24df4d329d9$var$NOT_EDITABLE])constraints = constraints.concat({
            field: value[$96e9f24df4d329d9$var$NOT_EDITABLE_FIELD],
            reason: $96e9f24df4d329d9$var$determineReason(value[$96e9f24df4d329d9$var$NOT_EDITABLE_REASON])
        });
        return constraints;
    }
    function $96e9f24df4d329d9$var$determineReason(value) {
        switch(value){
            case 'managed':
            case 'ext.dir.scim':
            case 'ext.dir.google':
                return value;
            default:
                throw new (0, (0, parcelRequire("1K4T6")).DefaultError)({
                    message: `Unknown mutability constraint reason: ${value}`
                });
        }
    }
    var $96e9f24df4d329d9$export$2e2bcd8739ae039 = new $96e9f24df4d329d9$export$1f387592ab3ca6d0();
});
parcelRegister("h46cM", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6f2e78061b0eb028$export$2e2bcd8739ae039);
    var $aOgFy;
    var $hrPaF;
    var $hjCdE;
    const $6f2e78061b0eb028$var$defaultConfig = {
        serviceUrl: `${(0, (0, parcelRequire("aOgFy")).DEFAULT_CONFIG).stargateRoot}`
    };
    class $6f2e78061b0eb028$export$a78b00aedb6cb3e9 extends (0, (0, parcelRequire("hrPaF")).RestClient) {
        constructor(config = {}){
            super({
                ...$6f2e78061b0eb028$var$defaultConfig,
                ...config
            });
        }
        async getTeamLinkIcons(teamLinkUrls) {
            const requestBody = teamLinkUrls.map((url)=>({
                    resourceUrl: url
                }));
            return this.postResourceRaw(`/object-resolver/resolve/batch`, JSON.stringify(requestBody)).then((0, (0, parcelRequire("hjCdE")).transformIconData));
        }
    }
    var $6f2e78061b0eb028$export$2e2bcd8739ae039 = new $6f2e78061b0eb028$export$a78b00aedb6cb3e9();
});
parcelRegister("hjCdE", function(module, exports) {
    $parcel$export(module.exports, "transformIconData", ()=>$9290a635b7c41737$export$39f4468adf4cb57c);
    var $FZDfl;
    const $9290a635b7c41737$export$c64ca1c808335e8b = (jsonLd)=>{
        const { url: url, generator: { name: name, icon: icon } } = jsonLd;
        switch(name){
            case (0, (0, parcelRequire("FZDfl")).ProviderNames).CONFLUENCE:
                return {
                    linkUrl: url,
                    iconUrl: $9290a635b7c41737$var$getConfluenceFavicon(url),
                    productName: name
                };
            case (0, (0, parcelRequire("FZDfl")).ProviderNames).JIRA:
                return {
                    linkUrl: url,
                    iconUrl: $9290a635b7c41737$var$getJiraFavicon(url),
                    productName: name
                };
            default:
                return {
                    linkUrl: url,
                    iconUrl: typeof icon === 'object' ? icon['url'] : icon,
                    productName: name
                };
        }
    };
    const $9290a635b7c41737$var$isIconItemSuccess = (response)=>{
        return response.status === 200;
    };
    const $9290a635b7c41737$export$39f4468adf4cb57c = (batchResp)=>batchResp.filter($9290a635b7c41737$var$isIconItemSuccess).map((resp)=>resp.body.data).map($9290a635b7c41737$export$c64ca1c808335e8b).filter((linkIconData)=>linkIconData.iconUrl !== undefined);
    const $9290a635b7c41737$var$getConfluenceFavicon = (url)=>`https://${new URL(url).hostname}/wiki/favicon.ico`;
    const $9290a635b7c41737$var$getJiraFavicon = (url)=>`https://${new URL(url).hostname}/favicon.ico`;
});
parcelRegister("FZDfl", function(module, exports) {
    $parcel$export(module.exports, "ProviderNames", ()=>$584160994f259bf9$export$132d457a8475f4c8);
    var $584160994f259bf9$export$132d457a8475f4c8;
    (function(ProviderNames) {
        ProviderNames["CONFLUENCE"] = "Confluence";
        ProviderNames["JIRA"] = "Jira";
    })($584160994f259bf9$export$132d457a8475f4c8 || ($584160994f259bf9$export$132d457a8475f4c8 = {}));
});
parcelRegister("1B4EX", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4da5dc8a7e4131fb$export$2e2bcd8739ae039);
    var $aOgFy;
    var $hrPaF;
    class $4da5dc8a7e4131fb$export$23820d8d740dd467 extends (0, (0, parcelRequire("hrPaF")).RestClient) {
        getIsSiteAdmin(cloudId) {
            return this.postResource('/permitted', {
                permissionId: 'manage',
                resourceId: `ari:cloud:platform::site/${this.getCloudId(cloudId)}`
            }).then((response)=>response.permitted);
        }
    }
    var $4da5dc8a7e4131fb$export$2e2bcd8739ae039 = new $4da5dc8a7e4131fb$export$23820d8d740dd467({
        serviceUrl: (0, (0, parcelRequire("aOgFy")).DEFAULT_CONFIG).permsServiceUrl
    });
});
parcelRegister("7thbw", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$cc096c4ff7130f7b$export$2e2bcd8739ae039);
    var $1K4T6;
    var $aOgFy;
    var $hrPaF;
    const $cc096c4ff7130f7b$var$V1_URL = '/teams/v1';
    const $cc096c4ff7130f7b$var$SENTRY_IGNORED_ERROR_MESSAGES_CREATE = [
        'TEAM_NOT_FOUND'
    ];
    class $cc096c4ff7130f7b$export$38575d07403d67c extends (0, (0, parcelRequire("hrPaF")).RestClient) {
        constructor(serviceUrlRoot){
            super({
                serviceUrl: serviceUrlRoot
            });
        }
        async addUsersToTeam(teamId, members) {
            if (!members || members.length === 0) {
                const missingMembersError = new Error('Missing members to add');
                this.logException(missingMembersError, 'addUsersToTeam');
                throw missingMembersError;
            }
            const membersWithIds = members.filter((member)=>!!member.accountId);
            if (membersWithIds.length !== members.length) this.logException(new Error('Missing accountIds for some members'), 'addUsersToTeam');
            if (membersWithIds.length === 0) {
                const missingMembersError = new Error('Missing accountIds for all members');
                this.logException(missingMembersError, 'addUsersToTeam');
                throw missingMembersError;
            }
            try {
                const orgId = this.getOrgId();
                const url = `${$cc096c4ff7130f7b$var$V1_URL}/org/${orgId}/teams/${teamId}/members/add`;
                const response = await this.postResource(url, {
                    members: membersWithIds
                });
                return response;
            } catch (e) {
                this.logException(e, 'addUsersToTeam');
                if (e instanceof (0, (0, parcelRequire("1K4T6")).HttpError) && $cc096c4ff7130f7b$var$SENTRY_IGNORED_ERROR_MESSAGES_CREATE.includes(e.message)) throw new (0, (0, parcelRequire("1K4T6")).SLOIgnoreHttpError)(e);
                throw e;
            }
        }
        async removeTeamMemberships(teamId, members) {
            if (!members || members.length === 0) {
                const missingMembersError = new Error('Missing members to remove');
                this.logException(missingMembersError, 'removeTeamMemberships');
                throw missingMembersError;
            }
            const membersWithIds = members.filter((member)=>!!member.accountId);
            if (membersWithIds.length !== members.length) this.logException(new Error('Missing accountIds for some members'), 'addUsersToTeam');
            if (membersWithIds.length === 0) {
                const missingMembersError = new Error('Missing accountIds for all members');
                this.logException(missingMembersError, 'removeTeamMemberships');
                throw missingMembersError;
            }
            try {
                const orgId = this.getOrgId();
                const url = `${$cc096c4ff7130f7b$var$V1_URL}/org/${orgId}/teams/${teamId}/members/remove`;
                const response = await this.postResource(url, {
                    members: membersWithIds
                });
                return response;
            } catch (e) {
                this.logException(e, 'removeTeamMemberships');
                throw e;
            }
        }
        async getTeamDetails(teamId) {
            try {
                const orgId = this.getOrgId();
                const url = `${$cc096c4ff7130f7b$var$V1_URL}/org/${orgId}/teams/${teamId}`;
                const response = await this.getResource(url);
                return response;
            } catch (e) {
                this.logException(e, 'getTeamDetails');
                throw e;
            }
        }
        async getTeamMembers(teamId, first = 50, after) {
            try {
                const orgId = this.getOrgId();
                const url = `${$cc096c4ff7130f7b$var$V1_URL}/org/${orgId}/teams/${teamId}/members`;
                const response = await this.postResource(url, {
                    after: after,
                    first: first
                });
                return response;
            } catch (e) {
                this.logException(e, 'getTeamMembers');
                throw e;
            }
        }
        async restoreTeam(teamId) {
            try {
                const orgId = this.getOrgId();
                const url = `${$cc096c4ff7130f7b$var$V1_URL}/org/${orgId}/teams/${teamId}/restore`;
                return this.postResource(url);
            } catch (e) {
                this.logException(e, 'restoreTeam');
                throw e;
            }
        }
    }
    var $cc096c4ff7130f7b$export$2e2bcd8739ae039 = new $cc096c4ff7130f7b$export$38575d07403d67c((0, (0, parcelRequire("aOgFy")).DEFAULT_CONFIG).publicApiRoot);
});
parcelRegister("93qCC", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$105914cb6e0318f1$export$2e2bcd8739ae039);
    var $aOgFy;
    var $hrPaF;
    const $105914cb6e0318f1$var$defaultConfig = {
        serviceUrl: `${(0, (0, parcelRequire("aOgFy")).DEFAULT_CONFIG).stargateRoot}/teamsslack/api/team`
    };
    class $105914cb6e0318f1$export$9509cbc6b0605446 extends (0, (0, parcelRequire("hrPaF")).RestClient) {
        constructor(config = {}){
            super({
                ...$105914cb6e0318f1$var$defaultConfig,
                ...config
            });
        }
        async getTeamInSlack(teamId, teamName) {
            return this.getResource(`/${teamId}?teamName=${encodeURIComponent(teamName)}`).then((response)=>({
                    id: teamId,
                    ...response
                }));
        }
    }
    var $105914cb6e0318f1$export$2e2bcd8739ae039 = new $105914cb6e0318f1$export$9509cbc6b0605446();
});
parcelRegister("9zuJU", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$257161ecf26ea5c9$export$2e2bcd8739ae039);
    var $aOgFy;
    var $hrPaF;
    const $257161ecf26ea5c9$var$buildGetReadTokenURL = (accountId)=>`/api/user-image/${accountId}/header-image/read`;
    class $257161ecf26ea5c9$export$3c27e20d1b94924 extends (0, (0, parcelRequire("hrPaF")).RestClient) {
        async getReadMediaToken(accountId) {
            return this.getResource($257161ecf26ea5c9$var$buildGetReadTokenURL(accountId)).then((response)=>response);
        }
        async getWriteMediaToken() {
            return this.getResource('/api/user-image/header-image/write').then((response)=>response);
        }
        async updateUserHeaderImage(headerImageId) {
            return await this.putResource('/api/user-image/self/header-image', {
                headerImageId: headerImageId
            });
        }
    }
    var $257161ecf26ea5c9$export$2e2bcd8739ae039 = new $257161ecf26ea5c9$export$3c27e20d1b94924({
        serviceUrl: (0, (0, parcelRequire("aOgFy")).DEFAULT_CONFIG).stargateRoot
    });
});
parcelRegister("ddoT6", function(module, exports) {
    $parcel$export(module.exports, "transformPermissions", ()=>$e6270b31ac69c64a$export$7fe0bfa353103198);
    const $e6270b31ac69c64a$export$7fe0bfa353103198 = (permissions)=>{
        return permissions.reduce((acc, permission)=>{
            switch(permission){
                case 'CAN_CREATE_TEAMS':
                    return {
                        ...acc,
                        canCreateTeams: true
                    };
                case 'CAN_VIEW_TEAMS':
                    return {
                        ...acc,
                        canViewTeams: true
                    };
                case 'CAN_ADMIN_TEAMS':
                    return {
                        ...acc,
                        canAdminTeams: true
                    };
                default:
                    return acc;
            }
        }, {
            canCreateTeams: false,
            canViewTeams: false,
            canAdminTeams: false
        });
    };
});
parcelRegister("5wXDQ", function(module, exports) {
    $parcel$export(module.exports, "PeopleMenuOverrides", ()=>$0d7d2d743503c251$export$c6e6fe52d34907dc);
    var $0d7d2d743503c251$export$c6e6fe52d34907dc;
    (function(PeopleMenuOverrides) {
        PeopleMenuOverrides["createTeamsDisabled"] = "create-teams-disabled";
        PeopleMenuOverrides["viewTeamsDisabled"] = "view-teams-disabled";
    })($0d7d2d743503c251$export$c6e6fe52d34907dc || ($0d7d2d743503c251$export$c6e6fe52d34907dc = {}));
});
parcelRegister("v6X2P", function(module, exports) {
    $parcel$export(module.exports, "ErrorWithContext", ()=>$f420277b82de59c9$export$6e749dfbce027249);
    class $f420277b82de59c9$export$6e749dfbce027249 extends Error {
        constructor(message, context){
            super(message);
            this.context = context;
        }
    }
});
parcelRegister("fWjEu", function(module, exports) {
    $parcel$export(module.exports, "usePeopleAndTeamsPeopleMenuConfiguration", ()=>$8887fdd411539e99$export$c616dd7f2557d148);
    $parcel$export(module.exports, "withMandatoryPeopleMenuConfiguration", ()=>$8887fdd411539e99$export$aecb6ab9d1724228);
    var $0Wtmq;
    var $lQhhz;
    const $8887fdd411539e99$var$KEY = 'people-menu';
    const $8887fdd411539e99$export$c616dd7f2557d148 = ()=>{
        const configuration = (0, (0, parcelRequire("0Wtmq")).usePeopleAndTeamsConfigurationContext)();
        return configuration[$8887fdd411539e99$var$KEY];
    };
    const $8887fdd411539e99$export$aecb6ab9d1724228 = (WrappedComponent)=>(0, (0, parcelRequire("lQhhz")).withMandatoryPeopleAndTeamsConfiguration)(WrappedComponent, $8887fdd411539e99$var$KEY);
});
parcelRegister("lQhhz", function(module, exports) {
    $parcel$export(module.exports, "withMandatoryPeopleAndTeamsConfiguration", ()=>$d501cd0f5e905518$export$aead0eac38c797a5);
    var $5uXOq = parcelRequire("5uXOq");
    var $0Wtmq;
    function $d501cd0f5e905518$var$isMandatoryPeopleAndTeamsConfiguration(context) {
        return Boolean(context);
    }
    const $d501cd0f5e905518$export$aead0eac38c797a5 = (WrappedComponent, key)=>(props)=>{
            const remoteConfig = (0, (0, parcelRequire("0Wtmq")).usePeopleAndTeamsConfigurationContext)();
            if (!remoteConfig) return null;
            const keyedConfig = remoteConfig[key];
            if (!$d501cd0f5e905518$var$isMandatoryPeopleAndTeamsConfiguration(keyedConfig)) return null;
            return (0, ($parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
                remoteConfig: keyedConfig,
                ...props
            });
        };
});
parcelRegister("cISRa", function(module, exports) {
    $parcel$export(module.exports, "LazyIntlProvider", ()=>$765cbbd932b03192$export$b4f1ecc6daf5eb10);
    var $5uXOq = parcelRequire("5uXOq");
    var $i5FdW;
    var $koVbs;
    const $765cbbd932b03192$export$94d2d72df36bbb16 = [
        'cs-CZ',
        'da-DK',
        'de-DE',
        'es-ES',
        'et-EE',
        'fi-FI',
        'fr-FR',
        'hu-HU',
        'is-IS',
        'it-IT',
        'ja-JP',
        'ko-KR',
        'nb-NB',
        'nl-NL',
        'pl-PL',
        'pt-BR',
        'pt-PT',
        'ro-RO',
        'ru-RU',
        'sk-SK',
        'sv-SE',
        'tr-TR',
        'th-TH',
        'uk-UK',
        'vi-VI',
        'zh-TW',
        'zh-HK',
        'zh-ZH',
        'zh-CN'
    ];
    const $765cbbd932b03192$export$4d25b49b6dc1b540 = (locale)=>{
        const match = /([a-z]*)[_-]?([A-Z]*)/i.exec(locale);
        if (!match) throw Error('Unable to get language and country from invalid Locale');
        const [, language, country] = match;
        return {
            language: language.toLowerCase(),
            country: country ? country.toUpperCase() : ''
        };
    };
    function $765cbbd932b03192$export$5ac26fa9b941854e(locale, fetchLanguageFile) {
        const [messages, setMessages] = (0, $5uXOq.useState)({});
        const [isLoading, setIsLoading] = (0, $5uXOq.useState)(false);
        (0, $5uXOq.useEffect)(()=>{
            async function startToFetchMessagesByLocale() {
                const { language: language, country: country } = $765cbbd932b03192$export$4d25b49b6dc1b540(locale);
                if (language === 'en') return;
                try {
                    setIsLoading(true);
                    const finalLocale = country ? `${language}-${country}` : language;
                    const module = await fetchLanguageFile(finalLocale);
                    const newMessages = module.default || module;
                    setMessages(newMessages);
                } catch (e) {} finally{
                    setIsLoading(false);
                }
            }
            startToFetchMessagesByLocale();
        }, [
            locale,
            fetchLanguageFile
        ]);
        return {
            messages: messages,
            isLoading: isLoading
        };
    }
    const $765cbbd932b03192$export$b4f1ecc6daf5eb10 = (props)=>{
        const { children: children, fetchLanguageFile: fetchLanguageFile, ...rest } = props;
        const { locale: locale, messages: allMessages = {} } = (0, (0, parcelRequire("koVbs")).default)();
        const { messages: messages } = $765cbbd932b03192$export$5ac26fa9b941854e(locale, fetchLanguageFile);
        for(const key in messages)if (!allMessages[key]) allMessages[key] = messages[key];
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("i5FdW")).default), {
            ...rest,
            messages: allMessages,
            key: locale,
            locale: locale,
            defaultLocale: "en-US"
        }, children);
    };
});
parcelRegister("3ys0B", function(module, exports) {
    $parcel$export(module.exports, "constructProductOriginParams", ()=>$3d96dc0719b6030c$export$d479c7e8f449d360);
    $parcel$export(module.exports, "getPeopleDirectoryHomePageWithOrgId", ()=>$3d96dc0719b6030c$export$873f5b458fb2c7bd);
    $parcel$export(module.exports, "getPeopleProfilePage", ()=>$3d96dc0719b6030c$export$8d1c08ae3a193cc5);
    $parcel$export(module.exports, "getTeamProfilePageLinkWithOrgId", ()=>$3d96dc0719b6030c$export$143be302a1686103);
    $parcel$export(module.exports, "trimLastForwardSlash", ()=>$3d96dc0719b6030c$export$41ba1f3da3359c4);
    function $3d96dc0719b6030c$var$toStrParams(obj) {
        const str = Object.keys(obj).map((k)=>{
            const v = obj[k];
            return v ? `${k}=${encodeURIComponent(v)}` : undefined;
        }).filter((it)=>!!it).join('&');
        return str ? `?${str}` : '';
    }
    function $3d96dc0719b6030c$export$d479c7e8f449d360(originQuery) {
        return $3d96dc0719b6030c$var$toStrParams({
            'origin.cloudId': originQuery.cloudId,
            'origin.product': originQuery.product?.toUpperCase() || ''
        });
    }
    function $3d96dc0719b6030c$export$575daf737e125483(remoteConfigResources) {
        return remoteConfigResources?.baseUrl || '';
    }
    function $3d96dc0719b6030c$export$873f5b458fb2c7bd({ remoteConfigResources: remoteConfigResources, orgId: orgId, ref: ref, src: src }) {
        const params = {
            ref: ref,
            src: src
        };
        return `${$3d96dc0719b6030c$export$575daf737e125483(remoteConfigResources)}${(remoteConfigResources?.peopleDirectoryHome || '').replace(':orgId', orgId ?? '')}${$3d96dc0719b6030c$var$toStrParams(params)}`;
    }
    function $3d96dc0719b6030c$export$a8c794e14e33c8e9(remoteConfigResources, ref, src) {
        const params = {
            ref: ref,
            src: src
        };
        return `${$3d96dc0719b6030c$export$575daf737e125483(remoteConfigResources)}${remoteConfigResources?.peopleDirectoryHome || ''}${$3d96dc0719b6030c$var$toStrParams(params)}`;
    }
    function $3d96dc0719b6030c$export$8d1c08ae3a193cc5(remoteConfigResources, userId, ref, src) {
        const params = {
            ref: ref,
            src: src
        };
        return `${$3d96dc0719b6030c$export$575daf737e125483(remoteConfigResources)}${(remoteConfigResources?.peopleProfile || '').replace(':userId', userId)}${$3d96dc0719b6030c$var$toStrParams(params)}`;
    }
    function $3d96dc0719b6030c$export$143be302a1686103({ remoteConfigResources: remoteConfigResources, teamId: teamId, orgId: orgId, ref: ref, src: src }) {
        const params = {
            ref: ref,
            src: src
        };
        return `${$3d96dc0719b6030c$export$575daf737e125483(remoteConfigResources)}${(remoteConfigResources?.teamProfile || '').replace(':teamId', teamId).replace(':orgId', orgId ?? '')}${$3d96dc0719b6030c$var$toStrParams(params)}`;
    }
    function $3d96dc0719b6030c$export$8b8a898467a65284(remoteConfigResources, teamId, ref, src) {
        const params = {
            ref: ref,
            src: src
        };
        return `${$3d96dc0719b6030c$export$575daf737e125483(remoteConfigResources)}${(remoteConfigResources?.teamProfile || '').replace(':teamId', teamId)}${$3d96dc0719b6030c$var$toStrParams(params)}`;
    }
    function $3d96dc0719b6030c$export$41ba1f3da3359c4(url = '') {
        if (url[url.length - 1] === '/') return url.slice(0, -1);
        return url;
    }
});
parcelRegister("jtAXU", function(module, exports) {
    $parcel$export(module.exports, "fetchJson", ()=>$ce30f9eae95058a3$export$6d71b655afe1638d);
    $parcel$export(module.exports, "postJson", ()=>$ce30f9eae95058a3$export$c776284ef4b1209a);
    const $ce30f9eae95058a3$export$83179404a61b001a = 'FetchError';
    function $ce30f9eae95058a3$export$847691ec04985fa0(error, status, traceId) {
        return {
            name: $ce30f9eae95058a3$export$83179404a61b001a,
            message: error.message,
            stack: error.stack,
            status: status,
            traceId: traceId
        };
    }
    const $ce30f9eae95058a3$export$6d71b655afe1638d = (url, init)=>{
        return fetch(url, {
            credentials: 'include',
            ...init
        }).then((response)=>{
            if (response.ok) return response.json();
            const traceId = response?.headers?.get('atl-traceid') || undefined;
            throw $ce30f9eae95058a3$export$847691ec04985fa0(new Error(`Unable to fetch ${url} ${response.status} ${response.statusText}`), response.status, traceId);
        });
    };
    const $ce30f9eae95058a3$export$c776284ef4b1209a = (url, data, headers)=>$ce30f9eae95058a3$export$6d71b655afe1638d(url, {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
                ...headers
            },
            body: JSON.stringify(data)
        });
});
parcelRegister("b8vEv", function(module, exports) {
    $parcel$export(module.exports, "searchTeamsOfUser", ()=>$5b88913fa719a883$export$c52386bca71fd065);
    $parcel$export(module.exports, "postCreateTeam", ()=>$5b88913fa719a883$export$db3c0c162386baf4);
    var $dmOdc;
    var $3ys0B;
    var $1XkTN;
    var $v6X2P;
    var $jtAXU;
    const $5b88913fa719a883$var$LIMIT_RESULTS = 5;
    const $5b88913fa719a883$export$51eb1e4b266d279a = '/gateway/api';
    const $5b88913fa719a883$export$a6635dd972d6facf = `${$5b88913fa719a883$export$51eb1e4b266d279a}/v3/teams`;
    const $5b88913fa719a883$export$8ebb304bc6fdbba2 = `${$5b88913fa719a883$export$51eb1e4b266d279a}/v4/teams`;
    const $5b88913fa719a883$export$d6cee1ef1aa86c6d = `${$5b88913fa719a883$export$a6635dd972d6facf}/of-user`;
    const $5b88913fa719a883$export$5c5040d455d75334 = `${$5b88913fa719a883$export$8ebb304bc6fdbba2}/search`;
    const $5b88913fa719a883$export$2964ca5e058bf0b = (userId, cloudId, product, tenantUrl = '', orgId)=>{
        const params = [
            `limit=${$5b88913fa719a883$var$LIMIT_RESULTS}`,
            'cursor=',
            `organizationId=${orgId ?? ''}`,
            `origin.cloudId=${cloudId}`,
            `origin.product=${product.toUpperCase()}`
        ];
        return `${tenantUrl}${$5b88913fa719a883$export$d6cee1ef1aa86c6d}/${userId}?&${params.join('&')}`;
    };
    const $5b88913fa719a883$export$8c9e20a1ace4ac54 = (cloudId, product, tenantUrl = '')=>`${tenantUrl}${$5b88913fa719a883$export$5c5040d455d75334}${(0, (0, parcelRequire("3ys0B")).constructProductOriginParams)({
            product: product,
            cloudId: cloudId
        })}`;
    const $5b88913fa719a883$export$d084da02a78b32a4 = (userId, cloudId, product, tenantUrl = '', orgId)=>orgId ? (0, (0, parcelRequire("jtAXU")).fetchJson)($5b88913fa719a883$export$2964ca5e058bf0b(userId, cloudId, product, tenantUrl, orgId)) : new Promise(()=>{});
    const $5b88913fa719a883$export$c52386bca71fd065 = (userId, cloudId, product, tenantUrl = '', orgId)=>{
        if (!userId || !cloudId || !orgId) throw new (0, (0, parcelRequire("v6X2P")).ErrorWithContext)('Missing parameters', {
            userId: userId,
            cloudId: cloudId,
            orgId: orgId,
            product: product,
            tenantUrl: tenantUrl
        });
        const url = $5b88913fa719a883$export$8c9e20a1ace4ac54(cloudId, product, tenantUrl);
        const postData = {
            organizationId: orgId,
            siteId: cloudId,
            limit: $5b88913fa719a883$var$LIMIT_RESULTS,
            membership: {
                memberAccountIds: [
                    userId
                ]
            }
        };
        return (0, (0, parcelRequire("jtAXU")).postJson)(url, postData);
    };
    const $5b88913fa719a883$export$db3c0c162386baf4 = async (teamName, membershipSettings, metaData)=>{
        (0, (0, parcelRequire("dmOdc")).teamsClient).setContext({
            cloudId: metaData.cloudId,
            orgId: metaData.orgId
        });
        (0, (0, parcelRequire("dmOdc")).teamsClient).setBaseUrl(`${metaData.tenantUrl ?? ''}${$5b88913fa719a883$export$51eb1e4b266d279a}`);
        const result = await (0, (0, parcelRequire("dmOdc")).teamsClient).createTeam(teamName, {
            product: metaData.product
        }, [
            ...new Set(metaData.members)
        ], membershipSettings === (0, (0, parcelRequire("1XkTN")).TeamMembershipSettings).OPEN ? 'OPEN' : 'MEMBER_INVITE');
        return {
            id: result.id,
            displayName: result.displayName,
            description: result.description,
            state: result.state === 'ACTIVE' ? (0, (0, parcelRequire("1XkTN")).TeamState).ACTIVE : (0, (0, parcelRequire("1XkTN")).TeamState).PURGED,
            membershipSettings: result.membershipSettings === 'OPEN' ? (0, (0, parcelRequire("1XkTN")).TeamMembershipSettings).OPEN : (0, (0, parcelRequire("1XkTN")).TeamMembershipSettings).INVITE_ONLY,
            memberCount: result.memberIds?.length ?? 0,
            teamAri: `ari:cloud:teams::team/${result.id}`,
            discoverable: (0, (0, parcelRequire("1XkTN")).TeamDiscoverability).DISCOVERABLE,
            organizationId: result.organizationId,
            restriction: (0, (0, parcelRequire("1XkTN")).TeamRestriction).NO_RESTRICTION,
            creatorId: result.creatorId,
            memberIds: result.memberIds,
            permission: result.permission === 'FULL_WRITE' ? (0, (0, parcelRequire("1XkTN")).TeamPermission).FULL_WRITE : result.permission === 'FULL_READ' ? (0, (0, parcelRequire("1XkTN")).TeamPermission).FULL_READ : (0, (0, parcelRequire("1XkTN")).TeamPermission).NONE
        };
    };
    const $5b88913fa719a883$export$76780145274bc285 = (teamId, { product: product, cloudId: cloudId, tenantUrl: tenantUrl = '' })=>{
        return `${tenantUrl}${$5b88913fa719a883$export$a6635dd972d6facf}/ui/${teamId}/membership/invite${(0, (0, parcelRequire("3ys0B")).constructProductOriginParams)({
            product: product,
            cloudId: cloudId
        })}`;
    };
    const $5b88913fa719a883$export$9cb3b92426f8e2eb = async (teamId, users, metaData)=>{
        if (!users || users.length === 0) return Promise.resolve(undefined);
        const emails = [];
        const ids = [];
        users.forEach((user)=>{
            if (user.id) ids.push(user.id);
            else if (user.email) emails.push(user.email);
        });
        const url = $5b88913fa719a883$export$76780145274bc285(teamId, metaData);
        const postData = {
            emailAddresses: emails,
            atlassianAccounts: ids
        };
        return (0, (0, parcelRequire("jtAXU")).postJson)(url, postData);
    };
});
parcelRegister("1XkTN", function(module, exports) {
    $parcel$export(module.exports, "TeamState", ()=>$2e4d2173f996bc4f$export$c5c56131401e0716);
    $parcel$export(module.exports, "TeamMembershipSettings", ()=>$2e4d2173f996bc4f$export$93b1c6cf9d16dce6);
    $parcel$export(module.exports, "TeamDiscoverability", ()=>$2e4d2173f996bc4f$export$c698762b98da6685);
    $parcel$export(module.exports, "TeamRestriction", ()=>$2e4d2173f996bc4f$export$e94592bde85a4d74);
    $parcel$export(module.exports, "TeamPermission", ()=>$2e4d2173f996bc4f$export$4db108522156032a);
    var $2e4d2173f996bc4f$export$c5c56131401e0716;
    (function(TeamState) {
        TeamState["ACTIVE"] = "ACTIVE";
        TeamState["DISBANDED"] = "DISBANDED";
        TeamState["PURGED"] = "PURGED";
    })($2e4d2173f996bc4f$export$c5c56131401e0716 || ($2e4d2173f996bc4f$export$c5c56131401e0716 = {}));
    var $2e4d2173f996bc4f$export$93b1c6cf9d16dce6;
    (function(TeamMembershipSettings) {
        TeamMembershipSettings["OPEN"] = "OPEN";
        TeamMembershipSettings["INVITE_ONLY"] = "MEMBER_INVITE";
        TeamMembershipSettings["EXTERNAL"] = "EXTERNAL";
    })($2e4d2173f996bc4f$export$93b1c6cf9d16dce6 || ($2e4d2173f996bc4f$export$93b1c6cf9d16dce6 = {}));
    var $2e4d2173f996bc4f$export$c698762b98da6685;
    (function(TeamDiscoverability) {
        TeamDiscoverability["DISCOVERABLE"] = "DISCOVERABLE";
    })($2e4d2173f996bc4f$export$c698762b98da6685 || ($2e4d2173f996bc4f$export$c698762b98da6685 = {}));
    var $2e4d2173f996bc4f$export$e94592bde85a4d74;
    (function(TeamRestriction) {
        TeamRestriction["ORG_MEMBERS"] = "ORG_MEMBERS";
        TeamRestriction["NO_RESTRICTION"] = "NO_RESTRICTION";
    })($2e4d2173f996bc4f$export$e94592bde85a4d74 || ($2e4d2173f996bc4f$export$e94592bde85a4d74 = {}));
    var $2e4d2173f996bc4f$export$4db108522156032a;
    (function(TeamPermission) {
        TeamPermission["FULL_WRITE"] = "FULL_WRITE";
        TeamPermission["FULL_READ"] = "FULL_READ";
        TeamPermission["NONE"] = "NONE";
    })($2e4d2173f996bc4f$export$4db108522156032a || ($2e4d2173f996bc4f$export$4db108522156032a = {}));
});
parcelRegister("eS2nd", function(module, exports) {
    $parcel$export(module.exports, "trimTeamAriInObject", ()=>$d1bcb2947e62ab7a$export$c75c12ecb0b3724e);
    $parcel$export(module.exports, "transformTeams", ()=>$d1bcb2947e62ab7a$export$fd398a52d6f57b46);
    function $d1bcb2947e62ab7a$export$c75c12ecb0b3724e(team) {
        if (!team) return team;
        return {
            ...team,
            id: team.id.replace('ari:cloud:teams::team/', '').replace('ari:cloud:identity::team/', '')
        };
    }
    const $d1bcb2947e62ab7a$export$fd398a52d6f57b46 = (data)=>{
        if (!data || !data.entities) return [];
        return data.entities.map($d1bcb2947e62ab7a$export$c75c12ecb0b3724e);
    };
});
parcelRegister("lKN3j", function(module, exports) {
    $parcel$export(module.exports, "useService", ()=>$72edefc047c53cbc$export$6de4685a6c88b4e9);
    var $5uXOq = parcelRequire("5uXOq");
    const $72edefc047c53cbc$export$6de4685a6c88b4e9 = (request, initialState = {})=>{
        const [state, setStateRaw] = (0, $5uXOq.useState)({
            loading: false,
            ...initialState
        });
        const isMounted = (0, $5uXOq.useRef)(true);
        (0, $5uXOq.useEffect)(()=>{
            isMounted.current = true;
            return ()=>{
                isMounted.current = false;
            };
        });
        const setState = (0, $5uXOq.useCallback)((state)=>{
            if (isMounted.current) setStateRaw(state);
        }, []);
        const fetchData = (0, $5uXOq.useCallback)(async ()=>{
            setState({
                loading: true,
                error: undefined,
                data: undefined
            });
            try {
                const data = await request();
                setState({
                    loading: false,
                    error: undefined,
                    data: data
                });
            } catch (error) {
                setState({
                    loading: false,
                    error: error,
                    data: undefined
                });
            }
        }, [
            request,
            setState
        ]);
        return {
            ...state,
            fetchData: fetchData
        };
    };
});
parcelRegister("jFpmD", function(module, exports) {
    $parcel$export(module.exports, "useActivityClient", ()=>$7287efdb57b3bb52$export$6620595b7f837f8f);
    var $5uXOq = parcelRequire("5uXOq");
    var $btDaU;
    var $3LJ9C;
    var $hoYXe;
    const $7287efdb57b3bb52$export$6620595b7f837f8f = (version, product, logger, baseUrl)=>{
        const { getArtifact: getArtifact } = (0, (0, parcelRequire("btDaU")).useFlightDeckContext)();
        return (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("hoYXe")).createActivityClient)(version, product, logger, baseUrl, getArtifact ? ()=>getArtifact((0, (0, parcelRequire("3LJ9C")).FD_CLIENT_FETCH_PROPS).name, (0, (0, parcelRequire("3LJ9C")).FD_CLIENT_FETCH_PROPS).dimensions) : undefined), [
            version,
            product,
            logger,
            baseUrl,
            getArtifact
        ]);
    };
});
parcelRegister("9dZ1c", function(module, exports) {
    $parcel$export(module.exports, "useNudgeController", ()=>$6a0467752d0c968a$export$9a533735412babca);
    $parcel$export(module.exports, "useRegisterNudgeTarget", ()=>$6a0467752d0c968a$export$eb8a96124d659f2d);
    var $5uXOq = parcelRequire("5uXOq");
    class $6a0467752d0c968a$var$NudgeController {
        static{
            this.instance = new $6a0467752d0c968a$var$NudgeController();
        }
        registerNudgeTarget(id, ref) {
            this.nudgeTargetsMap.set(id, ref);
            this.notifySubscribers(id);
            return ()=>{
                this.nudgeTargetsMap.delete(id);
            };
        }
        subscribe(id, callback) {
            const subscribers = this.subscribers.get(id) ?? [];
            subscribers.push(callback);
            this.subscribers.set(id, subscribers);
            return ()=>{
                const subscribersOnCleanup = this.subscribers.get(id) ?? [];
                this.subscribers.set(id, subscribersOnCleanup.filter((cb)=>cb !== callback));
            };
        }
        notifySubscribers(id) {
            const subscribers = this.subscribers.get(id) ?? [];
            subscribers.forEach((subscriber)=>{
                subscriber();
            });
        }
        constructor(){
            this.nudgeTargetsMap = new Map();
            this.subscribers = new Map();
        }
    }
    const $6a0467752d0c968a$export$9a533735412babca = ()=>$6a0467752d0c968a$var$NudgeController.instance;
    const $6a0467752d0c968a$export$eb8a96124d659f2d = (id, shouldRegister = true)=>{
        const controller = $6a0467752d0c968a$export$9a533735412babca();
        const ref = (0, $5uXOq.useRef)(null);
        (0, $5uXOq.useLayoutEffect)(()=>{
            if (shouldRegister) {
                const unregister = controller.registerNudgeTarget(id, ref);
                return ()=>{
                    unregister();
                };
            }
        }, [
            controller,
            id,
            shouldRegister
        ]);
        return {
            ref: ref
        };
    };
});
parcelRegister("fSeA2", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$38abab37a6ae6abe$export$2e2bcd8739ae039);
    var $8D6em;
    var $38abab37a6ae6abe$export$2e2bcd8739ae039 = (0, (0, parcelRequire("8D6em")).default);
});
parcelRegister("8D6em", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8b76e34713086949$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $cb25w;
    var $2bzBV;
    var $1I7E8;
    var $hEofo;
    var $5iwOw;
    var $dS8wI;
    var $gFH8O;
    var $9iwCj;
    var $jHmRo;
    var $7U5E9;
    var $4144s;
    var $4AXtg;
    var $14DM3;
    const $8b76e34713086949$var$OFFSET_FOR_MORE_BUTTON_VIEW = '12px -11px';
    const $8b76e34713086949$var$eventuallyClearHoverMeasure = ()=>{
        setTimeout(()=>{
            (0, (0, parcelRequire("gFH8O")).clearMeasure)('hoverAndClick');
        }, 5 * $8b76e34713086949$var$SECOND);
    };
    const $8b76e34713086949$var$SECOND = 1000;
    function $8b76e34713086949$export$b26ac1e1a63fbe24(props) {
        const { customChevronIcon: customChevronIcon, isHighlighted: isHighlighted, enablePreFetchingByHovering: enablePreFetchingByHovering, createAnalyticsEvent: createAnalyticsEvent, peopleText: peopleText, onClick: onClick = (0, (0, parcelRequire("dS8wI")).VOID_FUNC) } = props;
        const [canPrefetch, setCanPrefetch] = (0, $5uXOq.useState)(false);
        const { testId: testId, isPeopleMenuOpen: isPeopleMenuOpen, isSSR: isSSR, cloudId: cloudId, orgId: orgId, userId: userId, product: product, tenantUrl: tenantUrl, togglePeopleMenu: togglePeopleMenu = (0, (0, parcelRequire("dS8wI")).VOID_FUNC), renotifyExperimentProps: renotifyExperimentProps, shouldRenderToParent: shouldRenderToParent = false } = (0, $5uXOq.useContext)((0, (0, parcelRequire("hEofo")).PeopleMenuContext));
        const { isVisible: isVisible } = (0, (0, parcelRequire("2bzBV")).useOverflowStatus)();
        const closeMenu = (0, $5uXOq.useCallback)(()=>togglePeopleMenu(false), [
            togglePeopleMenu
        ]);
        const handleClickOnTriggerButton = (0, $5uXOq.useCallback)(()=>{
            onClick(!isPeopleMenuOpen);
            togglePeopleMenu(!isPeopleMenuOpen);
            (0, (0, parcelRequire("gFH8O")).startMeasure)('clickAndShow');
            (0, (0, parcelRequire("gFH8O")).stopMeasure)('hoverAndClick', (duration, startTime)=>{
                (0, (0, parcelRequire("9iwCj")).triggerAnalyticsForHoverAndClick)(createAnalyticsEvent, duration, startTime);
            });
        }, [
            createAnalyticsEvent,
            isPeopleMenuOpen,
            onClick,
            togglePeopleMenu
        ]);
        const handleMouseEnterTriggerButton = (0, $5uXOq.useCallback)(()=>{
            (0, (0, parcelRequire("jHmRo")).MenuContent).preload();
            if (!canPrefetch) {
                setCanPrefetch(true);
                (0, (0, parcelRequire("gFH8O")).startMeasure)('hoverAndClick');
                $8b76e34713086949$var$eventuallyClearHoverMeasure();
            }
        }, [
            canPrefetch,
            setCanPrefetch
        ]);
        const buttonProps = {
            isSelected: isPeopleMenuOpen,
            onClick: handleClickOnTriggerButton,
            onMouseEnter: handleMouseEnterTriggerButton,
            testId: `${testId}-people-primary-button`,
            peopleText: peopleText
        };
        const PopupContent = (0, $5uXOq.useCallback)(()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7U5E9")).PeopleMenuContentInternal), null), []);
        if (isSSR) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4AXtg")).PeopleMenuTriggerSSR), {
            testId: testId,
            peopleText: peopleText
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1I7E8")).default), {
            offset: isVisible ? undefined : $8b76e34713086949$var$OFFSET_FOR_MORE_BUTTON_VIEW,
            content: PopupContent,
            isOpen: isPeopleMenuOpen,
            placement: isVisible ? 'bottom-start' : 'right-start',
            onClose: closeMenu,
            shouldRenderToParent: shouldRenderToParent,
            trigger: (triggerProps)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4AXtg")).default), {
                    isVisible: isVisible,
                    isHighlighted: isHighlighted,
                    customChevronIcon: customChevronIcon,
                    triggerProps: triggerProps,
                    ...buttonProps
                })
        }), enablePreFetchingByHovering && canPrefetch && (0, (0, parcelRequire("5iwOw")).isCachedDataClear)() && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("14DM3")).UsersTeamsPreFetch), {
            cloudId: cloudId,
            orgId: orgId,
            userId: userId,
            product: product,
            tenantUrl: tenantUrl,
            renotifyExperiment: renotifyExperimentProps
        }));
    }
    const $8b76e34713086949$var$PeopleMenuInternalWithAnalytics = (0, (0, parcelRequire("cb25w")).default)()($8b76e34713086949$export$b26ac1e1a63fbe24);
    function $8b76e34713086949$export$2e2bcd8739ae039(props) {
        const { isHighlighted: isHighlighted, onClick: onClick, enablePreFetchingByHovering: enablePreFetchingByHovering, customChevronIcon: customChevronIcon, peopleText: peopleText, ...providerProps } = {
            ...props
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4144s")).default), providerProps, (0, ($parcel$interopDefault($5uXOq))).createElement($8b76e34713086949$var$PeopleMenuInternalWithAnalytics, {
            customChevronIcon: customChevronIcon,
            isHighlighted: isHighlighted,
            onClick: onClick,
            enablePreFetchingByHovering: enablePreFetchingByHovering,
            peopleText: peopleText
        }));
    }
});
parcelRegister("hEofo", function(module, exports) {
    $parcel$export(module.exports, "PeopleMenuContext", ()=>$04cbb00093c742e6$export$c92ff8b73313c89);
    $parcel$export(module.exports, "PeopleMenuContextProvider", ()=>$04cbb00093c742e6$export$4e812997de4564ae);
    $parcel$export(module.exports, "usePeopleMenuContext", ()=>$04cbb00093c742e6$export$c8d82c28669da5dc);
    var $5uXOq = parcelRequire("5uXOq");
    parcelRequire("kc9vJ");
    var $ihijj = parcelRequire("ihijj");
    var $dC5iT;
    var $8CUq3;
    parcelRequire("9iwCj");
    var $7kP9q;
    var $gkHKx;
    var $eSTPq;
    const $04cbb00093c742e6$var$AKModalTransition = (0, $5uXOq.lazy)(()=>(parcelRequire("dXyDo")).then((module)=>({
                default: module.ModalTransition
            })));
    const $04cbb00093c742e6$var$TeamCreateDialog = (0, $5uXOq.lazy)(()=>(parcelRequire("joyAX")).then((module)=>({
                default: module.TeamCreateDialog
            })));
    const $04cbb00093c742e6$var$DialogWrapper = (0, (0, parcelRequire("8CUq3")).xcss)({
        width: 'space.0',
        height: 'space.0',
        margin: '0',
        padding: '0',
        '::before': {
            width: 'space.0',
            height: 'space.0',
            margin: '0',
            padding: '0'
        },
        '::after': {
            width: 'space.0',
            height: 'space.0',
            margin: '0',
            padding: '0'
        }
    });
    const $04cbb00093c742e6$var$analyticsAttrsTeamCreateDialog = {
        ref: (0, (0, parcelRequire("7kP9q")).AnalyticsSource).PEOPLE_MENU
    };
    const $04cbb00093c742e6$export$c92ff8b73313c89 = (0, ($parcel$interopDefault($5uXOq))).createContext({
        orgId: '',
        cloudId: '',
        userId: '',
        product: 'confluence',
        testId: '',
        isPeopleMenuOpen: false,
        isSSR: false,
        onClickedItem: ()=>undefined,
        pushRoute: ()=>undefined,
        togglePeopleMenu: ()=>undefined,
        toggleTeamCreateDialog: ()=>undefined,
        _hasError: undefined,
        teamCreateDialogProps: {},
        renotifyExperimentProps: {
            isLoading: false,
            isEnrolled: false
        },
        showRenotifyMessage: false,
        shouldRenderToParent: false,
        isSectionList: false
    });
    function $04cbb00093c742e6$export$4e812997de4564ae(props) {
        const { isSSR: isSSR = false, cloudId: cloudId, renotifyExperimentProps: renotifyExperimentProps } = props;
        const [isOpenTeamCreateDialog, toggleOpenTeamCreateDialog] = (0, $5uXOq.useState)(false);
        const [renotifyDismissed, setRenotifyDismissed] = (0, $5uXOq.useState)(false);
        const [isSpotlightActive, setIsSpotlightActive] = (0, $5uXOq.useState)(undefined);
        const [showRenotifyModal, setShowRenotifyModal] = (0, $5uXOq.useState)(false);
        const { children: children, isOpen: isOpen, onOpen: onOpen, onClose: onClose, ...otherProps } = props;
        const pendingUsersResponse = (0, (0, parcelRequire("eSTPq")).usePendingUsers)({
            cloudId: cloudId,
            startFetching: isOpen,
            renotifyExperiment: renotifyExperimentProps,
            product: props?.product
        });
        const renotifyEligible = pendingUsersResponse.status === (0, (0, parcelRequire("eSTPq")).RenotifyStatus).ELIGIBLE;
        const pendingUsers = renotifyEligible ? pendingUsersResponse.pendingUsers : undefined;
        const showRenotifyMessage = renotifyEligible && !renotifyDismissed;
        const togglePeopleMenu = (0, $5uXOq.useCallback)((newState)=>{
            if (newState === isOpen) return;
            if (newState) onOpen();
            else onClose();
        }, [
            isOpen,
            onClose,
            onOpen
        ]);
        const toggleTeamCreateDialog = (0, $5uXOq.useCallback)((isOpen)=>{
            toggleOpenTeamCreateDialog(isOpen);
        }, [
            toggleOpenTeamCreateDialog
        ]);
        const toggleRenotifyModal = (0, $5uXOq.useCallback)(()=>{
            setShowRenotifyModal((prevState)=>{
                return !prevState;
            });
        }, []);
        const values = (0, $5uXOq.useMemo)(()=>({
                teamCreateDialogProps: {},
                ...otherProps,
                isPeopleMenuOpen: isOpen,
                togglePeopleMenu: togglePeopleMenu,
                toggleTeamCreateDialog: toggleTeamCreateDialog,
                toggleRenotifyModal: toggleRenotifyModal,
                pendingUsers: pendingUsers,
                renotifyEligible: renotifyEligible,
                showRenotifyMessage: showRenotifyMessage,
                setRenotifyDismissed: setRenotifyDismissed,
                isSpotlightActive: isSpotlightActive,
                setIsSpotlightActive: setIsSpotlightActive
            }), [
            otherProps,
            isOpen,
            togglePeopleMenu,
            toggleTeamCreateDialog,
            toggleRenotifyModal,
            pendingUsers,
            renotifyEligible,
            showRenotifyMessage,
            setRenotifyDismissed,
            isSpotlightActive,
            setIsSpotlightActive
        ]);
        const closeTeamCreateDialog = (0, $5uXOq.useCallback)(()=>{
            toggleOpenTeamCreateDialog(false);
            if (typeof values.teamCreateDialogProps?.onClose === 'function') values.teamCreateDialogProps.onClose();
        }, [
            toggleOpenTeamCreateDialog,
            values.teamCreateDialogProps
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($04cbb00093c742e6$export$c92ff8b73313c89.Provider, {
            value: values
        }, children, !isSSR && isOpenTeamCreateDialog && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $04cbb00093c742e6$var$DialogWrapper,
            testId: `${otherProps.testId}-team-create-dialog-wrapper`
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Suspense), {
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($04cbb00093c742e6$var$AKModalTransition, null, isOpenTeamCreateDialog && (0, ($parcel$interopDefault($5uXOq))).createElement($04cbb00093c742e6$var$TeamCreateDialog, {
            cloudId: values.cloudId,
            orgId: values.orgId,
            product: values.product,
            principalId: values.userId,
            addFlag: values.addFlag,
            pushRoute: values.pushRoute,
            extraAnalyticsAttrs: $04cbb00093c742e6$var$analyticsAttrsTeamCreateDialog,
            ...values.teamCreateDialogProps,
            onClose: closeTeamCreateDialog
        })))), !isSSR && showRenotifyModal && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $04cbb00093c742e6$var$DialogWrapper
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $ihijj.LazySuspense), {
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($04cbb00093c742e6$var$AKModalTransition, null, showRenotifyModal && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gkHKx")).RenotifyModal), null)))));
    }
    const $04cbb00093c742e6$export$c8d82c28669da5dc = ()=>(0, $5uXOq.useContext)($04cbb00093c742e6$export$c92ff8b73313c89);
});
parcelRegister("9iwCj", function(module, exports) {
    $parcel$export(module.exports, "triggerAnalyticsForClickCreateNewTeam", ()=>$36e53a66a40086f1$export$c22050996e7c2c8a);
    $parcel$export(module.exports, "triggerAnalyticsForMenuLink", ()=>$36e53a66a40086f1$export$e2de484c93cb7dd8);
    $parcel$export(module.exports, "triggerAnalyticsForClickViewDirectory", ()=>$36e53a66a40086f1$export$e3be20a27c367b1d);
    $parcel$export(module.exports, "triggerAnalyticsForClickInvitePeople", ()=>$36e53a66a40086f1$export$bb6086ba6d61c34e);
    $parcel$export(module.exports, "triggerAnalyticsForClickOnPeople", ()=>$36e53a66a40086f1$export$8c5588f22f5cd9d8);
    $parcel$export(module.exports, "triggerAnalyticsForClickOnTeam", ()=>$36e53a66a40086f1$export$580e4977bd9f636d);
    $parcel$export(module.exports, "triggerAnalyticsForViewedPeopleMenu", ()=>$36e53a66a40086f1$export$b7b4061d9dd52eb9);
    $parcel$export(module.exports, "triggerAnalyticsForRenderedInvitePeople", ()=>$36e53a66a40086f1$export$3e9b11df8135b7cb);
    $parcel$export(module.exports, "triggerAnalyticsForPreFetchData", ()=>$36e53a66a40086f1$export$750c07c02477d2f7);
    $parcel$export(module.exports, "triggerAnalyticsForLoadingIndicator", ()=>$36e53a66a40086f1$export$d88a623841ba7b50);
    $parcel$export(module.exports, "triggerAnalyticsForFetchingData", ()=>$36e53a66a40086f1$export$bda81aea2199d550);
    $parcel$export(module.exports, "triggerAnalyticsForHoverAndClick", ()=>$36e53a66a40086f1$export$f2cf5fec906275c6);
    $parcel$export(module.exports, "triggerAnalyticsForViewedFullUsersAndTeams", ()=>$36e53a66a40086f1$export$589011fd49e3f6d6);
    $parcel$export(module.exports, "triggerAnalyticsForNoBrowsePeoplePermission", ()=>$36e53a66a40086f1$export$1eb2f70fed6b75f7);
    $parcel$export(module.exports, "triggerAnalyticsForRenotifyMessageNotNow", ()=>$36e53a66a40086f1$export$a5bdd25287196af4);
    $parcel$export(module.exports, "triggerAnalyticsForRenotifyMessageRemindTeam", ()=>$36e53a66a40086f1$export$881b6b12fd147cc);
    $parcel$export(module.exports, "triggerAnalyticsForRenotifyMessageViewed", ()=>$36e53a66a40086f1$export$451dcd11e28959);
    $parcel$export(module.exports, "triggerAnalyticsForRenotifyModalViewed", ()=>$36e53a66a40086f1$export$fdfb31060bc22a02);
    $parcel$export(module.exports, "triggerAnalyticsForRenotifyModalCopyLink", ()=>$36e53a66a40086f1$export$5deab56d147776ca);
    $parcel$export(module.exports, "triggerAnalyticsForRenotifyModalCancelButton", ()=>$36e53a66a40086f1$export$a4a63a010743799d);
    $parcel$export(module.exports, "triggerAnalyticsForRenotifyModalSendReminderButton", ()=>$36e53a66a40086f1$export$faf6c5030f38bba5);
    $parcel$export(module.exports, "triggerAnalyticsForRenotifyFetchInactiveUsersSucceeded", ()=>$36e53a66a40086f1$export$736bb3246fa74c1f);
    $parcel$export(module.exports, "triggerAnalyticsForRenotifyFetchInactiveUsersFailed", ()=>$36e53a66a40086f1$export$794d511945a81231);
    $parcel$export(module.exports, "triggerAnalyticsForRenotifySendInvitesSucceeded", ()=>$36e53a66a40086f1$export$866a7379b396a7e3);
    $parcel$export(module.exports, "triggerAnalyticsForRenotifySendInvitesFailed", ()=>$36e53a66a40086f1$export$498c81c82596e8ea);
    $parcel$export(module.exports, "triggerAnalyticsForRenotifyNotEligible", ()=>$36e53a66a40086f1$export$644347da17a1bc39);
    $parcel$export(module.exports, "triggerAnalyticsForRenotifySpotlightViewed", ()=>$36e53a66a40086f1$export$68b8d9efc6f7f58f);
    $parcel$export(module.exports, "triggerAnalyticsForRenotifySpotlightCancelButton", ()=>$36e53a66a40086f1$export$f900d0881e38df06);
    $parcel$export(module.exports, "triggerAnalyticsForRenotifySpotlightConfirmButton", ()=>$36e53a66a40086f1$export$acbad06cf5c53b17);
    $parcel$export(module.exports, "AnalyticsActionSubject", ()=>(parcelRequire("7kP9q")).AnalyticsActionSubject);
    $parcel$export(module.exports, "AnalyticsAction", ()=>(parcelRequire("7kP9q")).AnalyticsAction);
    $parcel$export(module.exports, "AnalyticsSource", ()=>(parcelRequire("7kP9q")).AnalyticsSource);
    var $3mE7N;
    var $7kP9q;
    var $6uNb2;
    const $36e53a66a40086f1$export$c22050996e7c2c8a = (createAnalyticsEvent)=>{
        (0, (0, parcelRequire("3mE7N")).fireUIEvent)(createAnalyticsEvent, {
            actionSubject: (0, (0, parcelRequire("7kP9q")).AnalyticsActionSubject).CREATE_NEW_TEAM_LINK,
            action: (0, (0, parcelRequire("7kP9q")).AnalyticsAction).CLICKED
        });
    };
    const $36e53a66a40086f1$export$e2de484c93cb7dd8 = (additionalLinkId, action, createAnalyticsEvent, attributes)=>{
        (0, (0, parcelRequire("3mE7N")).fireUIEvent)(createAnalyticsEvent, {
            actionSubject: (0, (0, parcelRequire("7kP9q")).AnalyticsActionSubject).VIEW_PEOPLE_ADDITIONAL_LINK,
            actionSubjectId: additionalLinkId,
            action: action,
            attributes: {
                integration: 'peopleMenu',
                ...attributes
            }
        });
    };
    const $36e53a66a40086f1$export$e3be20a27c367b1d = (createAnalyticsEvent, isLeftClick = false)=>{
        (0, (0, parcelRequire("3mE7N")).fireUIEvent)(createAnalyticsEvent, {
            actionSubject: (0, (0, parcelRequire("7kP9q")).AnalyticsActionSubject).VIEW_PEOPLE_DIRECTORY_LINK,
            action: (0, (0, parcelRequire("7kP9q")).AnalyticsAction).CLICKED,
            attributes: {
                isLeftClick: isLeftClick
            }
        });
    };
    const $36e53a66a40086f1$export$bb6086ba6d61c34e = (createAnalyticsEvent, attributes)=>{
        (0, (0, parcelRequire("3mE7N")).fireUIEvent)(createAnalyticsEvent, {
            actionSubject: (0, (0, parcelRequire("7kP9q")).AnalyticsActionSubject).NAVIGATION_MENU_ITEM,
            actionSubjectId: 'addPeopleNavigationMenuItem',
            action: (0, (0, parcelRequire("7kP9q")).AnalyticsAction).CLICKED,
            attributes: {
                integration: 'peopleMenu',
                ...attributes
            }
        });
    };
    const $36e53a66a40086f1$export$8c5588f22f5cd9d8 = (createAnalyticsEvent, isLeftClick = false)=>{
        (0, (0, parcelRequire("3mE7N")).fireUIEvent)(createAnalyticsEvent, {
            actionSubject: (0, (0, parcelRequire("7kP9q")).AnalyticsActionSubject).PEOPLE_MENU_LINK,
            action: (0, (0, parcelRequire("7kP9q")).AnalyticsAction).CLICKED,
            attributes: {
                isLeftClick: isLeftClick
            }
        });
    };
    const $36e53a66a40086f1$export$580e4977bd9f636d = (createAnalyticsEvent, isLeftClick = false)=>{
        (0, (0, parcelRequire("3mE7N")).fireUIEvent)(createAnalyticsEvent, {
            actionSubject: (0, (0, parcelRequire("7kP9q")).AnalyticsActionSubject).TEAM_MENU_LINK,
            action: (0, (0, parcelRequire("7kP9q")).AnalyticsAction).CLICKED,
            attributes: {
                isLeftClick: isLeftClick
            }
        });
    };
    const $36e53a66a40086f1$export$b7b4061d9dd52eb9 = (createAnalyticsEvent, isCacheEmpty = false)=>{
        (0, (0, parcelRequire("3mE7N")).fireScreenEvent)(createAnalyticsEvent, {
            name: 'peopleMenu',
            attributes: {
                isCacheEmpty: isCacheEmpty
            }
        });
    };
    const $36e53a66a40086f1$export$3e9b11df8135b7cb = (createAnalyticsEvent)=>{
        (0, (0, parcelRequire("3mE7N")).fireUIEvent)(createAnalyticsEvent, {
            actionSubject: 'addPeopleNavigationItem',
            action: (0, (0, parcelRequire("7kP9q")).AnalyticsAction).RENDERED
        });
    };
    const $36e53a66a40086f1$export$750c07c02477d2f7 = (createAnalyticsEvent)=>{
        (0, (0, parcelRequire("3mE7N")).fireTrackEvent)(createAnalyticsEvent, {
            actionSubject: (0, (0, parcelRequire("7kP9q")).AnalyticsActionSubject).PRE_FETCH_DATA,
            action: (0, (0, parcelRequire("7kP9q")).AnalyticsAction).TRIGGERED
        });
    };
    const $36e53a66a40086f1$export$d88a623841ba7b50 = (createAnalyticsEvent, duration = 0, startTime = 0)=>{
        (0, (0, parcelRequire("3mE7N")).fireUIEvent)(createAnalyticsEvent, {
            actionSubject: (0, (0, parcelRequire("7kP9q")).AnalyticsActionSubject).PEOPLE_MENU,
            actionSubjectId: 'loadingIndicator',
            action: (0, (0, parcelRequire("7kP9q")).AnalyticsAction).VIEWED,
            attributes: {
                duration: duration,
                startTime: startTime
            }
        });
    };
    const $36e53a66a40086f1$export$bda81aea2199d550 = (createAnalyticsEvent, duration = 0, startTime = 0)=>{
        (0, (0, parcelRequire("3mE7N")).fireTrackEvent)(createAnalyticsEvent, {
            actionSubject: (0, (0, parcelRequire("7kP9q")).AnalyticsActionSubject).FETCHING_USERS_TEAMS_DATA,
            action: (0, (0, parcelRequire("7kP9q")).AnalyticsAction).MEASURED,
            attributes: {
                duration: duration,
                startTime: startTime
            }
        });
    };
    const $36e53a66a40086f1$export$f2cf5fec906275c6 = (createAnalyticsEvent, duration = 0, startTime = 0)=>{
        (0, (0, parcelRequire("3mE7N")).fireTrackEvent)(createAnalyticsEvent, {
            actionSubject: (0, (0, parcelRequire("7kP9q")).AnalyticsActionSubject).HOVER_AND_CLICK_PEOPLE_BUTTON,
            action: (0, (0, parcelRequire("7kP9q")).AnalyticsAction).MEASURED,
            attributes: {
                duration: duration,
                startTime: startTime
            }
        });
    };
    const $36e53a66a40086f1$export$589011fd49e3f6d6 = (createAnalyticsEvent, usersCount = 0, teamsCount = 0, duration = 0, startTime = 0)=>{
        (0, (0, parcelRequire("3mE7N")).fireTrackEvent)(createAnalyticsEvent, {
            actionSubject: (0, (0, parcelRequire("7kP9q")).AnalyticsActionSubject).PEOPLE_MENU,
            action: (0, (0, parcelRequire("7kP9q")).AnalyticsAction).SUCCEEDED,
            attributes: {
                usersCount: usersCount,
                teamsCount: teamsCount,
                duration: duration,
                startTime: startTime
            }
        });
    };
    const $36e53a66a40086f1$export$1eb2f70fed6b75f7 = (createAnalyticsEvent)=>{
        (0, (0, parcelRequire("3mE7N")).fireUIEvent)(createAnalyticsEvent, {
            actionSubject: (0, (0, parcelRequire("7kP9q")).AnalyticsActionSubject).PEOPLE_MENU,
            action: (0, (0, parcelRequire("7kP9q")).AnalyticsAction).VIEWED,
            actionSubjectId: 'noBrowsePermission'
        });
    };
    const $36e53a66a40086f1$export$a5bdd25287196af4 = (createAnalyticsEvent)=>{
        (0, (0, parcelRequire("3mE7N")).fireUIEvent)(createAnalyticsEvent, {
            actionSubject: (0, (0, parcelRequire("7kP9q")).AnalyticsActionSubject).BUTTON,
            action: (0, (0, parcelRequire("7kP9q")).AnalyticsAction).CLICKED,
            actionSubjectId: 'dismissButton',
            source: (0, (0, parcelRequire("7kP9q")).AnalyticsSource).RENOTIFY_MESSAGE
        });
    };
    const $36e53a66a40086f1$export$881b6b12fd147cc = (createAnalyticsEvent)=>{
        (0, (0, parcelRequire("3mE7N")).fireUIEvent)(createAnalyticsEvent, {
            actionSubject: (0, (0, parcelRequire("7kP9q")).AnalyticsActionSubject).BUTTON,
            action: (0, (0, parcelRequire("7kP9q")).AnalyticsAction).CLICKED,
            actionSubjectId: 'remindTeamMembersButton',
            source: (0, (0, parcelRequire("7kP9q")).AnalyticsSource).RENOTIFY_MESSAGE
        });
    };
    const $36e53a66a40086f1$export$451dcd11e28959 = (createAnalyticsEvent)=>{
        (0, (0, parcelRequire("3mE7N")).fireScreenEvent)(createAnalyticsEvent, {
            action: (0, (0, parcelRequire("7kP9q")).AnalyticsAction).VIEWED,
            name: (0, (0, parcelRequire("7kP9q")).AnalyticsSource).RENOTIFY_MESSAGE
        });
    };
    const $36e53a66a40086f1$export$fdfb31060bc22a02 = (createAnalyticsEvent)=>{
        (0, (0, parcelRequire("3mE7N")).fireScreenEvent)(createAnalyticsEvent, {
            action: (0, (0, parcelRequire("7kP9q")).AnalyticsAction).VIEWED,
            name: (0, (0, parcelRequire("7kP9q")).AnalyticsSource).RENOTIFY_MODAL
        });
    };
    const $36e53a66a40086f1$export$5deab56d147776ca = (createAnalyticsEvent, attributes)=>{
        (0, (0, parcelRequire("3mE7N")).fireUIEvent)(createAnalyticsEvent, {
            actionSubject: (0, (0, parcelRequire("7kP9q")).AnalyticsActionSubject).BUTTON,
            action: (0, (0, parcelRequire("7kP9q")).AnalyticsAction).CLICKED,
            actionSubjectId: 'copyInviteLinkButton',
            source: (0, (0, parcelRequire("7kP9q")).AnalyticsSource).RENOTIFY_MODAL,
            attributes: attributes
        });
    };
    const $36e53a66a40086f1$export$a4a63a010743799d = (createAnalyticsEvent)=>{
        (0, (0, parcelRequire("3mE7N")).fireUIEvent)(createAnalyticsEvent, {
            actionSubject: (0, (0, parcelRequire("7kP9q")).AnalyticsActionSubject).BUTTON,
            action: (0, (0, parcelRequire("7kP9q")).AnalyticsAction).CLICKED,
            actionSubjectId: 'dismissButton',
            source: (0, (0, parcelRequire("7kP9q")).AnalyticsSource).RENOTIFY_MODAL
        });
    };
    const $36e53a66a40086f1$export$faf6c5030f38bba5 = (createAnalyticsEvent, attributes)=>{
        (0, (0, parcelRequire("3mE7N")).fireUIEvent)(createAnalyticsEvent, {
            actionSubject: (0, (0, parcelRequire("7kP9q")).AnalyticsActionSubject).BUTTON,
            action: (0, (0, parcelRequire("7kP9q")).AnalyticsAction).CLICKED,
            actionSubjectId: 'sendReminderButton',
            source: (0, (0, parcelRequire("7kP9q")).AnalyticsSource).RENOTIFY_MODAL,
            attributes: attributes
        });
    };
    const $36e53a66a40086f1$export$736bb3246fa74c1f = (createAnalyticsEvent, attributes)=>{
        (0, (0, parcelRequire("3mE7N")).fireOperationalEvent)(createAnalyticsEvent, {
            actionSubject: (0, (0, parcelRequire("7kP9q")).AnalyticsActionSubject).FETCH_INACTIVE_USERS_DATA,
            action: (0, (0, parcelRequire("7kP9q")).AnalyticsAction).SUCCEEDED,
            source: (0, (0, parcelRequire("7kP9q")).AnalyticsSource).RENOTIFY_MODAL,
            attributes: attributes
        });
    };
    const $36e53a66a40086f1$export$794d511945a81231 = (createAnalyticsEvent)=>{
        (0, (0, parcelRequire("3mE7N")).fireOperationalEvent)(createAnalyticsEvent, {
            actionSubject: (0, (0, parcelRequire("7kP9q")).AnalyticsActionSubject).FETCH_INACTIVE_USERS_DATA,
            action: (0, (0, parcelRequire("7kP9q")).AnalyticsAction).FAILED,
            source: (0, (0, parcelRequire("7kP9q")).AnalyticsSource).RENOTIFY_MODAL
        });
    };
    const $36e53a66a40086f1$export$866a7379b396a7e3 = (createAnalyticsEvent, attributes)=>{
        (0, (0, parcelRequire("3mE7N")).fireOperationalEvent)(createAnalyticsEvent, {
            actionSubject: (0, (0, parcelRequire("7kP9q")).AnalyticsActionSubject).SEND_REINVITES,
            action: (0, (0, parcelRequire("7kP9q")).AnalyticsAction).SUCCEEDED,
            source: (0, (0, parcelRequire("7kP9q")).AnalyticsSource).RENOTIFY_MODAL,
            attributes: attributes
        });
    };
    const $36e53a66a40086f1$export$498c81c82596e8ea = (createAnalyticsEvent, attributes)=>{
        (0, (0, parcelRequire("3mE7N")).fireOperationalEvent)(createAnalyticsEvent, {
            actionSubject: (0, (0, parcelRequire("7kP9q")).AnalyticsActionSubject).SEND_REINVITES,
            action: (0, (0, parcelRequire("7kP9q")).AnalyticsAction).FAILED,
            source: (0, (0, parcelRequire("7kP9q")).AnalyticsSource).RENOTIFY_MODAL,
            attributes: attributes
        });
    };
    const $36e53a66a40086f1$export$644347da17a1bc39 = (createAnalyticsEvent, attributes)=>{
        (0, (0, parcelRequire("3mE7N")).fireTrackEvent)(createAnalyticsEvent, {
            actionSubject: (0, (0, parcelRequire("7kP9q")).AnalyticsActionSubject).RENOTIFY_EXPERIMENT,
            action: (0, (0, parcelRequire("7kP9q")).AnalyticsAction).INELIGIBLE,
            source: (0, (0, parcelRequire("7kP9q")).AnalyticsSource).RENOTIFY_MESSAGE,
            attributes: attributes
        });
    };
    const $36e53a66a40086f1$export$68b8d9efc6f7f58f = (createAnalyticsEvent)=>{
        (0, (0, parcelRequire("3mE7N")).fireScreenEvent)(createAnalyticsEvent, {
            action: (0, (0, parcelRequire("7kP9q")).AnalyticsAction).VIEWED,
            name: (0, (0, parcelRequire("7kP9q")).AnalyticsSource).RENOTIFY_SPOTLIGHT
        });
    };
    const $36e53a66a40086f1$export$f900d0881e38df06 = (createAnalyticsEvent)=>{
        (0, (0, parcelRequire("3mE7N")).fireUIEvent)(createAnalyticsEvent, {
            actionSubject: (0, (0, parcelRequire("7kP9q")).AnalyticsActionSubject).BUTTON,
            action: (0, (0, parcelRequire("7kP9q")).AnalyticsAction).CLICKED,
            actionSubjectId: 'renotifySpotlightDismissButton',
            source: (0, (0, parcelRequire("7kP9q")).AnalyticsSource).RENOTIFY_SPOTLIGHT
        });
    };
    const $36e53a66a40086f1$export$acbad06cf5c53b17 = (createAnalyticsEvent)=>{
        (0, (0, parcelRequire("3mE7N")).fireUIEvent)(createAnalyticsEvent, {
            actionSubject: (0, (0, parcelRequire("7kP9q")).AnalyticsActionSubject).BUTTON,
            action: (0, (0, parcelRequire("7kP9q")).AnalyticsAction).CLICKED,
            actionSubjectId: 'renotifySpotlightConfirmButton',
            source: (0, (0, parcelRequire("7kP9q")).AnalyticsSource).RENOTIFY_SPOTLIGHT
        });
    };
});
parcelRegister("7kP9q", function(module, exports) {
    $parcel$export(module.exports, "AnalyticsActionSubject", ()=>$2156eaa79e4b3f27$export$4bce2c1f3a5d9f61);
    $parcel$export(module.exports, "AnalyticsAction", ()=>$2156eaa79e4b3f27$export$30c16f5c43437fd7);
    $parcel$export(module.exports, "AnalyticsSource", ()=>$2156eaa79e4b3f27$export$6890652a1aff7d1c);
    var $2156eaa79e4b3f27$export$4bce2c1f3a5d9f61;
    (function(AnalyticsActionSubject) {
        AnalyticsActionSubject["ERROR_BOUNDARY"] = "errorBoundary";
        AnalyticsActionSubject["VIEW_PEOPLE_ADDITIONAL_LINK"] = "additionalMenuLink";
        AnalyticsActionSubject["VIEW_PEOPLE_DIRECTORY_LINK"] = "viewAllPeopleDirectory";
        AnalyticsActionSubject["CREATE_NEW_TEAM_LINK"] = "createNewTeamLink";
        AnalyticsActionSubject["PEOPLE_MENU_LINK"] = "peopleMenuLink";
        AnalyticsActionSubject["TEAM_MENU_LINK"] = "teamMenuLink";
        AnalyticsActionSubject["PEOPLE_MENU"] = "peopleMenu";
        AnalyticsActionSubject["NAVIGATION_MENU_ITEM"] = "navigationMenuItem";
        AnalyticsActionSubject["PRE_FETCH_DATA"] = "preFetchData";
        AnalyticsActionSubject["FETCHING_USERS_TEAMS_DATA"] = "fetchingUsersTeamsData";
        AnalyticsActionSubject["HOVER_AND_CLICK_PEOPLE_BUTTON"] = "hoverAndClickPeopleButton";
        AnalyticsActionSubject["BUTTON"] = "button";
        AnalyticsActionSubject["FETCH_INACTIVE_USERS_DATA"] = "fetchInactiveUsersData";
        AnalyticsActionSubject["SEND_REINVITES"] = "sendReinvites";
        AnalyticsActionSubject["RENOTIFY_EXPERIMENT"] = "renotifyExperiment";
    })($2156eaa79e4b3f27$export$4bce2c1f3a5d9f61 || ($2156eaa79e4b3f27$export$4bce2c1f3a5d9f61 = {}));
    var $2156eaa79e4b3f27$export$30c16f5c43437fd7;
    (function(AnalyticsAction) {
        AnalyticsAction["RENDERED"] = "rendered";
        AnalyticsAction["CLICKED"] = "clicked";
        AnalyticsAction["EXPOSED"] = "exposed";
        AnalyticsAction["FAILED"] = "failed";
        AnalyticsAction["SUCCEEDED"] = "succeeded";
        AnalyticsAction["VIEWED"] = "viewed";
        AnalyticsAction["TRIGGERED"] = "triggered";
        AnalyticsAction["MEASURED"] = "measured";
        AnalyticsAction["INELIGIBLE"] = "ineligible";
    })($2156eaa79e4b3f27$export$30c16f5c43437fd7 || ($2156eaa79e4b3f27$export$30c16f5c43437fd7 = {}));
    var $2156eaa79e4b3f27$export$6890652a1aff7d1c;
    (function(AnalyticsSource) {
        AnalyticsSource["PEOPLE_MENU"] = "peopleMenu";
        AnalyticsSource["RENOTIFY_MESSAGE"] = "renotifyMessage";
        AnalyticsSource["RENOTIFY_MODAL"] = "renotifyModal";
        AnalyticsSource["RENOTIFY_SPOTLIGHT"] = "renotifySpotlight";
    })($2156eaa79e4b3f27$export$6890652a1aff7d1c || ($2156eaa79e4b3f27$export$6890652a1aff7d1c = {}));
});
parcelRegister("6uNb2", function(module, exports) {
    $parcel$export(module.exports, "triggerAnalyticsForLoadedPeople", ()=>$9ae06323a5a66ecb$export$62ecc9342d32a444);
    $parcel$export(module.exports, "triggerAnalyticsForLoadedTeam", ()=>$9ae06323a5a66ecb$export$e648838c8bbef986);
    var $3mE7N;
    parcelRequire("9iwCj");
    var $7kP9q;
    const $9ae06323a5a66ecb$export$62ecc9342d32a444 = (action, createAnalyticsEvent, status, error)=>{
        (0, (0, parcelRequire("3mE7N")).fireOperationalEvent)(createAnalyticsEvent, {
            actionSubject: (0, (0, parcelRequire("7kP9q")).AnalyticsActionSubject).PEOPLE_MENU_LINK,
            action: action === 'succeeded' ? (0, (0, parcelRequire("7kP9q")).AnalyticsAction).SUCCEEDED : (0, (0, parcelRequire("7kP9q")).AnalyticsAction).FAILED,
            attributes: {
                status: status,
                error: error?.message || JSON.stringify(error)
            }
        });
    };
    const $9ae06323a5a66ecb$export$e648838c8bbef986 = (action, createAnalyticsEvent, status, error)=>{
        (0, (0, parcelRequire("3mE7N")).fireOperationalEvent)(createAnalyticsEvent, {
            actionSubject: (0, (0, parcelRequire("7kP9q")).AnalyticsActionSubject).TEAM_MENU_LINK,
            action: action === 'succeeded' ? (0, (0, parcelRequire("7kP9q")).AnalyticsAction).SUCCEEDED : (0, (0, parcelRequire("7kP9q")).AnalyticsAction).FAILED,
            attributes: {
                status: status,
                error: error?.message || JSON.stringify(error)
            }
        });
    };
});
parcelRegister("gkHKx", function(module, exports) {
    $parcel$export(module.exports, "RenotifyModal", ()=>$91b44ddfc984aebd$export$c68d29a05874a11b);
    parcelRequire("kc9vJ");
    var $8DfXF = parcelRequire("8DfXF");
    const $91b44ddfc984aebd$export$c68d29a05874a11b = (0, $8DfXF.lazy)(()=>(parcelRequire("kfCY2")));
});
parcelRegister("kfCY2", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("2K6xe")
    ]).then(()=>parcelRequire('gokUt'));
});
parcelRegister("eSTPq", function(module, exports) {
    $parcel$export(module.exports, "RenotifyStatus", ()=>$f55d0919c5fd27e7$export$e1b7db4c83021afe);
    $parcel$export(module.exports, "usePendingUsers", ()=>$f55d0919c5fd27e7$export$8d720c7cdd23491d);
    var $5uXOq = parcelRequire("5uXOq");
    var $2NMNM;
    var $9iwCj;
    var $5hWD5;
    const $f55d0919c5fd27e7$export$50fd3325777ce4bc = new Map();
    const $f55d0919c5fd27e7$export$7149af0c7f6b6e85 = 'pendingUsers';
    const $f55d0919c5fd27e7$export$c9c3fbf7cb17786e = 'renotifyEligibility';
    var $f55d0919c5fd27e7$export$e1b7db4c83021afe;
    (function(RenotifyStatus) {
        RenotifyStatus["IS_LOADING"] = "isLoading";
        RenotifyStatus["ELIGIBLE"] = "eligible";
        RenotifyStatus["INELIGIBLE"] = "ineligible";
        RenotifyStatus["ERROR"] = "error";
    })($f55d0919c5fd27e7$export$e1b7db4c83021afe || ($f55d0919c5fd27e7$export$e1b7db4c83021afe = {}));
    const $f55d0919c5fd27e7$var$REQUEST_CACHE_TIMEOUT_PENDING_USERS = 600000;
    function $f55d0919c5fd27e7$export$8d720c7cdd23491d({ cloudId: cloudId, startFetching: startFetching, renotifyExperiment: renotifyExperiment, product: product, requestCacheTimeout: requestCacheTimeout }) {
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const [pendingUsers, setPendingUsers] = (0, $5uXOq.useState)($f55d0919c5fd27e7$export$50fd3325777ce4bc.get($f55d0919c5fd27e7$export$7149af0c7f6b6e85));
        const [renotifyEligible, setRenotifyEligibility] = (0, $5uXOq.useState)($f55d0919c5fd27e7$export$50fd3325777ce4bc.get($f55d0919c5fd27e7$export$c9c3fbf7cb17786e));
        const { loading: pendingUsersLoading, error: pendingUsersError, data: pendingUsersData, fetchData: fetchPendingUsers } = (0, (0, parcelRequire("5hWD5")).usePendingUsersService)(cloudId, requestCacheTimeout === undefined ? $f55d0919c5fd27e7$var$REQUEST_CACHE_TIMEOUT_PENDING_USERS : requestCacheTimeout, product);
        (0, $5uXOq.useEffect)(()=>{
            if (renotifyEligible !== undefined || renotifyExperiment?.isLoading || !startFetching) return;
            if (renotifyExperiment?.isEnrolled) fetchPendingUsers();
            else {
                $f55d0919c5fd27e7$export$50fd3325777ce4bc.set($f55d0919c5fd27e7$export$c9c3fbf7cb17786e, false);
                setRenotifyEligibility(false);
            }
        }, [
            renotifyEligible,
            fetchPendingUsers,
            renotifyExperiment?.isLoading,
            renotifyExperiment?.isEnrolled,
            startFetching
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (pendingUsersError) {
                (0, (0, parcelRequire("9iwCj")).triggerAnalyticsForRenotifyFetchInactiveUsersFailed)(createAnalyticsEvent);
                $f55d0919c5fd27e7$export$50fd3325777ce4bc.set($f55d0919c5fd27e7$export$c9c3fbf7cb17786e, false);
                setRenotifyEligibility(false);
                return;
            }
            if (pendingUsersData === undefined || pendingUsersLoading) return;
            $f55d0919c5fd27e7$export$50fd3325777ce4bc.set($f55d0919c5fd27e7$export$7149af0c7f6b6e85, pendingUsersData);
            setPendingUsers(pendingUsersData);
            if (pendingUsersData?.length) {
                (0, (0, parcelRequire("9iwCj")).triggerAnalyticsForRenotifyFetchInactiveUsersSucceeded)(createAnalyticsEvent, {
                    numberOfInviteeEmails: pendingUsersData?.length
                });
                $f55d0919c5fd27e7$export$50fd3325777ce4bc.set($f55d0919c5fd27e7$export$c9c3fbf7cb17786e, true);
                if (renotifyExperiment?.isEnrolled) setRenotifyEligibility(true);
            } else {
                (0, (0, parcelRequire("9iwCj")).triggerAnalyticsForRenotifyNotEligible)(createAnalyticsEvent, {
                    reason: 'No pending users'
                });
                $f55d0919c5fd27e7$export$50fd3325777ce4bc.set($f55d0919c5fd27e7$export$c9c3fbf7cb17786e, false);
                setRenotifyEligibility(false);
            }
        }, [
            createAnalyticsEvent,
            pendingUsersData,
            pendingUsersError,
            pendingUsersLoading,
            renotifyExperiment
        ]);
        if (pendingUsersLoading || renotifyExperiment?.isLoading) return {
            status: "isLoading",
            isLoading: true
        };
        if (pendingUsersError) return {
            status: "error",
            pendingUsersError: pendingUsersError ?? new Error('Invalid pending user response'),
            isLoading: false
        };
        if (renotifyEligible === false || !pendingUsers) return {
            status: "ineligible",
            isLoading: false
        };
        return {
            status: "eligible",
            isLoading: false,
            pendingUsers: pendingUsers
        };
    }
});
parcelRegister("5hWD5", function(module, exports) {
    $parcel$export(module.exports, "usePendingUsersService", ()=>$b6986ac8ac2209a9$export$4e16c66a0a5052e1);
    var $5uXOq = parcelRequire("5uXOq");
    var $jFIGx;
    var $lKN3j;
    var $dCmT9;
    var $hEofo;
    const $b6986ac8ac2209a9$var$mapFetchInactiveUserFnByTimeout = new Map();
    function $b6986ac8ac2209a9$var$getFetchInactiveUsersCachedFn(timeout = (0, (0, parcelRequire("jFIGx")).DEFAULT_RELEASE_RESOLVED_PROMISE_DELAY)) {
        let fn = $b6986ac8ac2209a9$var$mapFetchInactiveUserFnByTimeout.get(timeout);
        if (fn) return fn;
        fn = (0, (0, parcelRequire("jFIGx")).withCached)((0, (0, parcelRequire("dCmT9")).fetchInactiveUsers), timeout);
        $b6986ac8ac2209a9$var$mapFetchInactiveUserFnByTimeout.set(timeout, fn);
        return fn;
    }
    function $b6986ac8ac2209a9$export$4e16c66a0a5052e1(cloudId, cacheTimeout, product) {
        const { product: contextProduct } = (0, (0, parcelRequire("hEofo")).usePeopleMenuContext)();
        const request = (0, $5uXOq.useCallback)(()=>{
            if (cacheTimeout) {
                const fn = $b6986ac8ac2209a9$var$getFetchInactiveUsersCachedFn(cacheTimeout);
                return fn(cloudId, product ?? contextProduct);
            }
            return (0, (0, parcelRequire("dCmT9")).fetchInactiveUsers)(cloudId, product ?? contextProduct);
        }, [
            cacheTimeout,
            cloudId,
            product,
            contextProduct
        ]);
        const { loading: loading, error: error, data: data, fetchData: fetchData } = (0, (0, parcelRequire("lKN3j")).useService)(request);
        return {
            loading: loading,
            error: error,
            data: data?.users,
            fetchData: fetchData
        };
    }
});
parcelRegister("jFIGx", function(module, exports) {
    $parcel$export(module.exports, "DEFAULT_RELEASE_RESOLVED_PROMISE_DELAY", ()=>$66b55f654aa333ec$export$d8b1aa62ff4847fc);
    $parcel$export(module.exports, "withCached", ()=>$66b55f654aa333ec$export$7f51828d6b6af163);
    const $66b55f654aa333ec$var$ONE_SECOND = 1000;
    const $66b55f654aa333ec$export$d8b1aa62ff4847fc = 5 * $66b55f654aa333ec$var$ONE_SECOND;
    const $66b55f654aa333ec$var$isPromise = (p)=>{
        return p !== undefined && typeof p.then === 'function' && typeof p.catch === 'function';
    };
    const $66b55f654aa333ec$export$7f51828d6b6af163 = (fn, timeout = $66b55f654aa333ec$export$d8b1aa62ff4847fc)=>{
        const resultCache = new Map();
        const promiseCache = new Map();
        function getCacheKey(...args) {
            return JSON.stringify(args);
        }
        const cached = (...args)=>{
            const cacheKey = getCacheKey(...args);
            return resultCache.get(cacheKey);
        };
        const reset = ()=>{
            resultCache.clear();
            promiseCache.clear();
        };
        const execute = (...args)=>{
            const cacheKey = getCacheKey(...args);
            const cachedPromise = promiseCache.get(cacheKey);
            if (cachedPromise !== undefined) return cachedPromise;
            const maybePromise = fn(...args);
            if ($66b55f654aa333ec$var$isPromise(maybePromise)) {
                promiseCache.set(cacheKey, maybePromise);
                maybePromise.then((result)=>{
                    resultCache.set(cacheKey, result);
                    setTimeout(()=>{
                        promiseCache.delete(cacheKey);
                        resultCache.delete(cacheKey);
                    }, timeout);
                }).catch(()=>{
                    promiseCache.delete(cacheKey);
                    resultCache.delete(cacheKey);
                });
            }
            return maybePromise;
        };
        return Object.assign(execute, fn, {
            cached: cached,
            reset: reset
        });
    };
});
parcelRegister("dCmT9", function(module, exports) {
    $parcel$export(module.exports, "fetchInactiveUsers", ()=>$133024ceef7b0aad$export$b6000772b84436c7);
    $parcel$export(module.exports, "sendReinvites", ()=>$133024ceef7b0aad$export$df764bf7318de5);
    var $g1fRS;
    const $133024ceef7b0aad$var$EXPERIMENT_API_BASE = '/gateway/api/growth/';
    const $133024ceef7b0aad$var$getExperimentAPICommonPath = (product)=>`${$133024ceef7b0aad$var$EXPERIMENT_API_BASE}${product === 'confluence' ? 'notify-if-invitee-never-logged-in-confluence' : 'notify-if-invitee-never-logged-in'}`;
    const $133024ceef7b0aad$var$getInactiveUsersUrl = (cloudId, product)=>`${$133024ceef7b0aad$var$getExperimentAPICommonPath(product)}/get-inactive-users?cloudId=${cloudId}`;
    const $133024ceef7b0aad$export$b6000772b84436c7 = (cloudId, product)=>(0, (0, parcelRequire("g1fRS")).fetchJson)($133024ceef7b0aad$var$getInactiveUsersUrl(cloudId, product));
    const $133024ceef7b0aad$var$getReinviteUrl = (product)=>`${$133024ceef7b0aad$var$getExperimentAPICommonPath(product)}/reinvite`;
    const $133024ceef7b0aad$export$df764bf7318de5 = (cloudId, reInvites, product)=>{
        return (0, (0, parcelRequire("g1fRS")).postJson)($133024ceef7b0aad$var$getReinviteUrl(product), {
            owner: `ari:cloud:platform::site/${cloudId}`,
            reInvites: reInvites.map(({ userId: userId, continueUrl: continueUrl })=>({
                    inviteeId: `ari:cloud:identity::user/${userId}`,
                    continueUrl: continueUrl
                }))
        });
    };
});
parcelRegister("g1fRS", function(module, exports) {
    $parcel$export(module.exports, "fetchJson", ()=>$267b2825c14900b3$export$6d71b655afe1638d);
    $parcel$export(module.exports, "postJson", ()=>$267b2825c14900b3$export$c776284ef4b1209a);
    const $267b2825c14900b3$export$83179404a61b001a = 'FetchError';
    function $267b2825c14900b3$export$847691ec04985fa0(error, status) {
        return {
            name: $267b2825c14900b3$export$83179404a61b001a,
            message: error.message,
            stack: error.stack,
            status: status
        };
    }
    const $267b2825c14900b3$export$6d71b655afe1638d = (url, init)=>fetch(url, {
            credentials: 'include',
            ...init
        }).then((response)=>{
            if (response.ok) return response.json();
            throw $267b2825c14900b3$export$847691ec04985fa0(new Error(`Unable to fetch ${url} ${response.status} ${response.statusText}`), response.status);
        });
    const $267b2825c14900b3$export$c776284ef4b1209a = (url, data)=>$267b2825c14900b3$export$6d71b655afe1638d(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        });
});
parcelRegister("joyAX", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("e4yNo")
    ]).then(()=>parcelRequire('8degK'));
});
parcelRegister("5iwOw", function(module, exports) {
    $parcel$export(module.exports, "isCachedDataClear", ()=>$b65fff219f4109a7$export$cee8b843259f0f74);
    $parcel$export(module.exports, "default", ()=>$b65fff219f4109a7$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $jm65K;
    var $hOaMz;
    const $b65fff219f4109a7$export$50fd3325777ce4bc = new Map();
    const $b65fff219f4109a7$export$cd84c175965a58da = 'collaborators';
    const $b65fff219f4109a7$export$b5c382592ac689a7 = 'teams';
    const $b65fff219f4109a7$var$ONE_SEC = 1000;
    const $b65fff219f4109a7$var$ONE_MINUTE = $b65fff219f4109a7$var$ONE_SEC * 60;
    const $b65fff219f4109a7$var$REQUEST_CACHE_TIMEOUT_TEAMS = $b65fff219f4109a7$var$ONE_MINUTE;
    const $b65fff219f4109a7$var$REQUEST_CACHE_TIMEOUT_USERS = $b65fff219f4109a7$var$ONE_MINUTE * 5;
    function $b65fff219f4109a7$export$cee8b843259f0f74() {
        return $b65fff219f4109a7$export$50fd3325777ce4bc.size === 0;
    }
    function $b65fff219f4109a7$export$2e2bcd8739ae039(cloudId, userId, product, tenantUrl, requestCacheTimeout, orgId) {
        const [dataUsers, setDataUsers] = (0, $5uXOq.useState)(undefined);
        const [dataTeams, setDataTeams] = (0, $5uXOq.useState)(undefined);
        const { loading: isLoadingUsers, error: errorUsers, data: users } = (0, (0, parcelRequire("jm65K")).useCollaboratorsService)(cloudId, 'context', tenantUrl, requestCacheTimeout === undefined ? $b65fff219f4109a7$var$REQUEST_CACHE_TIMEOUT_USERS : requestCacheTimeout);
        const { loading: isLoadingTeams, error: errorTeams, data: teams } = (0, (0, parcelRequire("hOaMz")).useTeamsOfService)(userId, cloudId, product, tenantUrl, requestCacheTimeout === undefined ? $b65fff219f4109a7$var$REQUEST_CACHE_TIMEOUT_TEAMS : requestCacheTimeout, orgId);
        (0, $5uXOq.useEffect)(()=>{
            if (!users || isLoadingUsers || errorUsers) return;
            $b65fff219f4109a7$export$50fd3325777ce4bc.set($b65fff219f4109a7$export$cd84c175965a58da, users);
            setDataUsers(users);
        }, [
            users,
            isLoadingUsers,
            errorUsers
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (!teams || isLoadingTeams || errorTeams) return;
            $b65fff219f4109a7$export$50fd3325777ce4bc.set($b65fff219f4109a7$export$b5c382592ac689a7, teams);
            setDataTeams(teams);
        }, [
            teams,
            isLoadingTeams,
            errorTeams
        ]);
        return {
            users: dataUsers && dataUsers.length ? dataUsers : $b65fff219f4109a7$export$50fd3325777ce4bc.get($b65fff219f4109a7$export$cd84c175965a58da),
            teams: dataTeams && dataTeams.length ? dataTeams : $b65fff219f4109a7$export$50fd3325777ce4bc.get($b65fff219f4109a7$export$b5c382592ac689a7),
            errorTeams: errorTeams,
            errorUsers: errorUsers,
            isLoading: isLoadingUsers || isLoadingTeams
        };
    }
});
parcelRegister("jm65K", function(module, exports) {
    $parcel$export(module.exports, "useCollaboratorsService", ()=>$a01b882127eb026f$export$979a4f9449b8be53);
    var $5uXOq = parcelRequire("5uXOq");
    var $7j6lB;
    var $4QMKv;
    var $jFIGx;
    var $lKN3j;
    const $a01b882127eb026f$var$mapFetchCollaboratorsFnByTimeout = new Map();
    function $a01b882127eb026f$var$getFetchCollaboratorsCachedFn(timeout = (0, (0, parcelRequire("jFIGx")).DEFAULT_RELEASE_RESOLVED_PROMISE_DELAY)) {
        let fn = $a01b882127eb026f$var$mapFetchCollaboratorsFnByTimeout.get(timeout);
        if (fn) return fn;
        fn = (0, (0, parcelRequire("jFIGx")).withCached)((0, (0, parcelRequire("7j6lB")).fetchCollaborators), timeout);
        $a01b882127eb026f$var$mapFetchCollaboratorsFnByTimeout.set(timeout, fn);
        return fn;
    }
    function $a01b882127eb026f$export$979a4f9449b8be53(cloudId, userId = 'context', tenantUrl = '', cacheTimeout) {
        const request = (0, $5uXOq.useCallback)(()=>{
            if (cacheTimeout) {
                const fn = $a01b882127eb026f$var$getFetchCollaboratorsCachedFn(cacheTimeout);
                return fn(cloudId, userId, tenantUrl);
            }
            return (0, (0, parcelRequire("7j6lB")).fetchCollaborators)(cloudId, userId, tenantUrl);
        }, [
            cacheTimeout,
            cloudId,
            userId,
            tenantUrl
        ]);
        const { loading: loading, error: error, data: data, fetchData: fetchData } = (0, (0, parcelRequire("lKN3j")).useService)(request, {
            loading: true
        });
        (0, $5uXOq.useEffect)(()=>{
            fetchData();
        }, [
            fetchData
        ]);
        const memoizedData = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("4QMKv")).transformCollabsDataToUsers)(data), [
            data
        ]);
        return {
            loading: loading,
            error: error,
            data: memoizedData,
            fetchData: fetchData
        };
    }
});
parcelRegister("7j6lB", function(module, exports) {
    $parcel$export(module.exports, "fetchCollaborators", ()=>$1e130a4c1c3e3780$export$cadad85c3acf2ad8);
    var $jtAXU;
    const $1e130a4c1c3e3780$export$42623aff9edf525f = '/gateway/api/collaboration/v1/collaborationgraph/user/user';
    const $1e130a4c1c3e3780$var$LIMIT_RESULTS = 5;
    const $1e130a4c1c3e3780$export$cadad85c3acf2ad8 = (cloudId, userId = 'context', tenantUrl = '')=>(0, (0, parcelRequire("jtAXU")).postJson)(`${tenantUrl}${$1e130a4c1c3e3780$export$42623aff9edf525f}`, {
            context: {
                contextType: 'atlassianPeoplePackage',
                principalId: userId,
                siteId: cloudId
            },
            maxNumberOfResults: $1e130a4c1c3e3780$var$LIMIT_RESULTS,
            userId: userId,
            expanded: true
        });
});
parcelRegister("4QMKv", function(module, exports) {
    $parcel$export(module.exports, "transformCollabsDataToUsers", ()=>$33301444de547d8e$export$1eb7590d078520b8);
    var $dt9VY;
    const $33301444de547d8e$var$userMapper = (user)=>{
        const { userProfile: userProfile, entityType: entityType } = user;
        if (!userProfile || entityType !== (0, (0, parcelRequire("dt9VY")).ENTITY_TYPE).USER) return null;
        return {
            id: user.id,
            fullName: userProfile.name,
            nickname: userProfile.nickname,
            email: userProfile.email,
            avatarUrl: userProfile.picture,
            collaborationGraphScore: user.score,
            status: userProfile.account_status
        };
    };
    const $33301444de547d8e$export$1eb7590d078520b8 = (data)=>{
        if (!data) return [];
        const { collaborationGraphEntities: collaborationGraphEntities = [] } = data;
        return collaborationGraphEntities.map($33301444de547d8e$var$userMapper).filter((item)=>item) || [];
    };
});
parcelRegister("dt9VY", function(module, exports) {
    $parcel$export(module.exports, "ENTITY_TYPE", ()=>$c64d873f35a96cde$export$49be827a0aef75dd);
    var $c64d873f35a96cde$export$49be827a0aef75dd;
    (function(ENTITY_TYPE) {
        ENTITY_TYPE["CONTAINER"] = "CONTAINER";
        ENTITY_TYPE["USER"] = "USER";
    })($c64d873f35a96cde$export$49be827a0aef75dd || ($c64d873f35a96cde$export$49be827a0aef75dd = {}));
    var $c64d873f35a96cde$export$fba7c3adda5094d9;
    (function(CONTAINER_TYPE) {
        CONTAINER_TYPE["JIRA_PROJECT"] = "jiraProject";
        CONTAINER_TYPE["CONFLUENCE_SPACE"] = "confluenceSpace";
    })($c64d873f35a96cde$export$fba7c3adda5094d9 || ($c64d873f35a96cde$export$fba7c3adda5094d9 = {}));
});
parcelRegister("hOaMz", function(module, exports) {
    $parcel$export(module.exports, "useTeamsOfService", ()=>$71e3afc4a862a4a9$export$668750a034956301);
    var $5uXOq = parcelRequire("5uXOq");
    var $b8vEv;
    var $eS2nd;
    var $jFIGx;
    var $lKN3j;
    const $71e3afc4a862a4a9$var$mapFetchMyTeamsFnByTimeout = new Map();
    function $71e3afc4a862a4a9$var$getFetchMyTeamsCachedFn(timeout = (0, (0, parcelRequire("jFIGx")).DEFAULT_RELEASE_RESOLVED_PROMISE_DELAY)) {
        let fn = $71e3afc4a862a4a9$var$mapFetchMyTeamsFnByTimeout.get(timeout);
        if (fn) return fn;
        fn = (0, (0, parcelRequire("jFIGx")).withCached)((0, (0, parcelRequire("b8vEv")).searchTeamsOfUser), timeout);
        $71e3afc4a862a4a9$var$mapFetchMyTeamsFnByTimeout.set(timeout, fn);
        return fn;
    }
    function $71e3afc4a862a4a9$export$668750a034956301(userId, cloudId, product, tenantUrl = '', cacheTimeout, orgId) {
        const request = (0, $5uXOq.useCallback)(()=>{
            if (cacheTimeout) {
                const fn = $71e3afc4a862a4a9$var$getFetchMyTeamsCachedFn(cacheTimeout);
                return fn(userId, cloudId, product, tenantUrl, orgId);
            }
            return (0, (0, parcelRequire("b8vEv")).searchTeamsOfUser)(userId, cloudId, product, tenantUrl, orgId);
        }, [
            cacheTimeout,
            userId,
            cloudId,
            product,
            tenantUrl,
            orgId
        ]);
        const { loading: loading, error: error, data: data, fetchData: fetchData } = (0, (0, parcelRequire("lKN3j")).useService)(request, {
            loading: true
        });
        (0, $5uXOq.useEffect)(()=>{
            fetchData();
        }, [
            fetchData
        ]);
        const memoizedData = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("eS2nd")).transformTeams)(data), [
            data
        ]);
        return {
            loading: loading,
            error: error,
            data: memoizedData,
            fetchData: fetchData
        };
    }
});
parcelRegister("dS8wI", function(module, exports) {
    $parcel$export(module.exports, "VOID_FUNC", ()=>$83eda9ae9b3c8996$export$7e6ba5d480e9bd2f);
    const $83eda9ae9b3c8996$export$53bb833296af4a30 = 5;
    const $83eda9ae9b3c8996$export$88d6945644578407 = 3;
    const $83eda9ae9b3c8996$export$7e6ba5d480e9bd2f = ()=>undefined;
});
parcelRegister("gFH8O", function(module, exports) {
    $parcel$export(module.exports, "startMeasure", ()=>$b257cb8dc2555f00$export$b62aa2130c86b59b);
    $parcel$export(module.exports, "stopMeasure", ()=>$b257cb8dc2555f00$export$37c25be427bec097);
    $parcel$export(module.exports, "clearMeasure", ()=>$b257cb8dc2555f00$export$6f766653554dac02);
    const $b257cb8dc2555f00$var$isPerformanceAPIAvailable = ()=>{
        return typeof window !== 'undefined' && 'performance' in window && [
            'measure',
            'clearMeasures',
            'clearMarks',
            'getEntriesByName',
            'getEntriesByType'
        ].every((api)=>!!performance[api]);
    };
    const $b257cb8dc2555f00$var$hasPerformanceAPIAvailable = $b257cb8dc2555f00$var$isPerformanceAPIAvailable();
    const $b257cb8dc2555f00$var$measureMap = new Map();
    function $b257cb8dc2555f00$export$b62aa2130c86b59b(measureName) {
        if (!$b257cb8dc2555f00$var$hasPerformanceAPIAvailable) return;
        performance.mark(`${measureName}::start`);
        $b257cb8dc2555f00$var$measureMap.set(measureName, performance.now());
    }
    function $b257cb8dc2555f00$export$37c25be427bec097(measureName, onMeasureComplete) {
        if (!$b257cb8dc2555f00$var$hasPerformanceAPIAvailable) return;
        if (!$b257cb8dc2555f00$var$measureMap.get(measureName)) return;
        performance.mark(`${measureName}::end`);
        const start = onMeasureComplete ? $b257cb8dc2555f00$var$measureMap.get(measureName) : undefined;
        try {
            performance.measure(measureName, `${measureName}::start`, `${measureName}::end`);
        } catch (error) {} finally{
            if (onMeasureComplete) {
                const entry = performance.getEntriesByName(measureName).pop();
                if (entry) onMeasureComplete(entry.duration, entry.startTime);
                else if (start) onMeasureComplete(performance.now() - start, start);
            }
            $b257cb8dc2555f00$export$6f766653554dac02(measureName);
        }
    }
    function $b257cb8dc2555f00$export$6f766653554dac02(measureName) {
        if (!$b257cb8dc2555f00$var$hasPerformanceAPIAvailable) return;
        $b257cb8dc2555f00$var$measureMap.delete(measureName);
        performance.clearMarks(`${measureName}::start`);
        performance.clearMarks(`${measureName}::end`);
        performance.clearMeasures(measureName);
    }
});
parcelRegister("jHmRo", function(module, exports) {
    $parcel$export(module.exports, "MenuContent", ()=>$f5293b335fdac1fe$export$479f0f2f71193efe);
    $parcel$export(module.exports, "MenuContentFallback", ()=>$f5293b335fdac1fe$export$48b47052ec2aea7f);
    var $5uXOq = parcelRequire("5uXOq");
    parcelRequire("kc9vJ");
    var $8DfXF = parcelRequire("8DfXF");
    var $eZUJu;
    var $hEofo;
    var $5iwOw;
    var $ihfgn;
    var $5IiJH;
    const $f5293b335fdac1fe$export$479f0f2f71193efe = (0, $8DfXF.lazyForPaint)(()=>(parcelRequire("3YEti")));
    const $f5293b335fdac1fe$export$b0396be60c0e9152 = 480;
    const $f5293b335fdac1fe$export$3f133812f81dfa49 = 320;
    const $f5293b335fdac1fe$export$94aaf6acd960c412 = 'calc(100vh - 79px)';
    function $f5293b335fdac1fe$export$48b47052ec2aea7f() {
        const { cloudId: cloudId, tenantUrl: tenantUrl, userId: userId, product: product, testId: testId, orgId: orgId } = (0, $5uXOq.useContext)((0, (0, parcelRequire("hEofo")).PeopleMenuContext));
        (0, (0, parcelRequire("5iwOw")).default)(cloudId, userId, product, tenantUrl, undefined, orgId);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eZUJu")).default), {
            testId: `${testId}-group-loading`,
            maxWidth: $f5293b335fdac1fe$export$b0396be60c0e9152,
            maxHeight: $f5293b335fdac1fe$export$94aaf6acd960c412,
            minWidth: $f5293b335fdac1fe$export$3f133812f81dfa49
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ihfgn")).MenuGroupPeople), {
            isLoading: true
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5IiJH")).MenuGroupTeams), {
            isLoading: true
        }));
    }
});
parcelRegister("ihfgn", function(module, exports) {
    $parcel$export(module.exports, "MenuGroupPeople", ()=>$96009d3d2861caf5$export$c521b8e86241ef89);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $cb25w;
    var $3Z96c;
    var $fWjEu;
    var $3ys0B;
    var $hEofo;
    var $dS8wI;
    var $c5ORg;
    parcelRequire("9iwCj");
    var $7kP9q;
    var $9iwCj;
    var $ckanx;
    var $cf0l8;
    var $c2P5e;
    const $96009d3d2861caf5$export$2e63129145f0c868 = (props)=>{
        const intl = (0, (0, parcelRequire("koVbs")).default)();
        const { users: users = [], createAnalyticsEvent: createAnalyticsEvent, isLoading: isLoading, remoteConfig: remoteConfig } = props;
        const { testId: testId, product: product, onClickedItem: onClickedItem = (0, (0, parcelRequire("dS8wI")).VOID_FUNC), pushRoute: pushRoute = (0, (0, parcelRequire("dS8wI")).VOID_FUNC), togglePeopleMenu: togglePeopleMenu = (0, (0, parcelRequire("dS8wI")).VOID_FUNC) } = (0, $5uXOq.useContext)((0, (0, parcelRequire("hEofo")).PeopleMenuContext));
        const handleClickOnPeople = (0, $5uXOq.useCallback)((id)=>(event)=>{
                const isLeftClick = !(0, (0, parcelRequire("c5ORg")).isModifiedEvent)(event);
                (0, (0, parcelRequire("9iwCj")).triggerAnalyticsForClickOnPeople)(createAnalyticsEvent, isLeftClick);
                onClickedItem(id, 'people', event);
                if (isLeftClick) {
                    const peopleProfilePage = (0, (0, parcelRequire("3ys0B")).getPeopleProfilePage)(remoteConfig.resources, id, product, (0, (0, parcelRequire("7kP9q")).AnalyticsActionSubject).PEOPLE_MENU);
                    pushRoute(peopleProfilePage);
                    event.preventDefault();
                }
                togglePeopleMenu(false);
            }, [
            createAnalyticsEvent,
            onClickedItem,
            product,
            pushRoute,
            remoteConfig.resources,
            togglePeopleMenu
        ]);
        if (!remoteConfig.sections.collaborators.enabled) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cf0l8")).MenuGroupSection), {
            title: remoteConfig.sections.collaborators.label ?? intl.formatMessage((0, (0, parcelRequire("ckanx")).messages).yourCollab),
            testId: `${testId}-people-section`,
            isLoading: isLoading,
            isEmpty: users.length === 0,
            sectionType: 'user',
            maxItems: remoteConfig.sections.collaborators.maxItems
        }, users.slice(0, remoteConfig.sections.collaborators.maxItems).map((user)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3Z96c")).default), {
                key: user.id,
                iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("c2P5e")).ImgIcon), {
                    src: user.avatarUrl,
                    alt: ""
                }),
                testId: `${testId}-people-item`,
                href: (0, (0, parcelRequire("3ys0B")).getPeopleProfilePage)(remoteConfig.resources, user.id, product, (0, (0, parcelRequire("7kP9q")).AnalyticsActionSubject).PEOPLE_MENU),
                onClick: handleClickOnPeople(user.id)
            }, user.fullName)));
    };
    const $96009d3d2861caf5$export$c521b8e86241ef89 = (0, (0, parcelRequire("cb25w")).default)()((0, (0, parcelRequire("fWjEu")).withMandatoryPeopleMenuConfiguration)($96009d3d2861caf5$export$2e63129145f0c868));
});
parcelRegister("c5ORg", function(module, exports) {
    $parcel$export(module.exports, "isModifiedEvent", ()=>$5872d4f5b124a4bb$export$642c6f14f6d4bbd5);
    const $5872d4f5b124a4bb$export$642c6f14f6d4bbd5 = (event)=>!!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
});
parcelRegister("ckanx", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$dce0e5ac2ce66eb1$export$defe85febe8b728c);
    var $7VHMR;
    const $dce0e5ac2ce66eb1$var$PREFIX = 'ptc.pm';
    const $dce0e5ac2ce66eb1$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        yourCollab: {
            id: `${$dce0e5ac2ce66eb1$var$PREFIX}.collaborators.title`,
            defaultMessage: 'Your Collaborators',
            description: 'A title of Your-Collaborators section in People Menu dropdown'
        },
        yourTeams: {
            id: `${$dce0e5ac2ce66eb1$var$PREFIX}.your-teams.title`,
            defaultMessage: 'Your Teams',
            description: 'A title of a Your-Teams section in People Menu dropdown'
        },
        viewYourProfile: {
            id: `${$dce0e5ac2ce66eb1$var$PREFIX}.view-your-profile`,
            defaultMessage: 'View your profile',
            description: 'A link in People Menu. Clicking on it will navigate the user to their personal profile'
        },
        errorHeading: {
            id: `${$dce0e5ac2ce66eb1$var$PREFIX}.error-heading`,
            defaultMessage: "Something\u2019s gone wrong",
            description: 'Heading of the error screen which is shown when an unknown error happens in the People Menu. Usually due to failed network requests.'
        },
        errorText: {
            id: `${$dce0e5ac2ce66eb1$var$PREFIX}.error-text`,
            defaultMessage: "We keep track of these errors, but feel free to contact us if refreshing doesn\u2019t fix things",
            description: 'Text that is displayed when an unknown error happens in the People Menu.'
        },
        errorImageAltText: {
            id: `${$dce0e5ac2ce66eb1$var$PREFIX}.error-image-alt-text`,
            defaultMessage: 'A broken robot and a number of people busy fixing it.',
            description: 'Text displayed as alt text when an error occurs in the People Menu'
        },
        people: {
            id: `${$dce0e5ac2ce66eb1$var$PREFIX}.people`,
            defaultMessage: 'People',
            description: 'A default title of primary People menu'
        },
        teams: {
            id: `${$dce0e5ac2ce66eb1$var$PREFIX}.teams`,
            defaultMessage: 'Teams',
            description: 'A new default title of primary People menu'
        },
        numMembers: {
            id: `${$dce0e5ac2ce66eb1$var$PREFIX}.num-members`,
            defaultMessage: `{memberCount, plural,
    one {# member}
    other {# members}
}`,
            description: 'Subtext of the number of members belonging to a team'
        }
    });
});
parcelRegister("cf0l8", function(module, exports) {
    $parcel$export(module.exports, "MenuGroupSection", ()=>$69942e80fb1d50dd$export$33b4adfb29dd0d95);
    var $5uXOq = parcelRequire("5uXOq");
    var $9UCCQ;
    var $eaGfl;
    var $hEofo;
    var $9hDzh;
    const $69942e80fb1d50dd$export$33b4adfb29dd0d95 = ({ title: title, isEmpty: isEmpty, isLoading: isLoading, children: children, testId: testId, maxItems: maxItems, sectionType: sectionType })=>{
        const { isSectionList: isSectionList = false } = (0, $5uXOq.useContext)((0, (0, parcelRequire("hEofo")).PeopleMenuContext));
        if (!isLoading && isEmpty) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9UCCQ")).default), {
            title: isLoading ? undefined : title,
            testId: testId,
            isList: isSectionList
        }, isLoading ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eaGfl")).default), {
            testId: `${sectionType}-skeleton-heading`
        }), Array(maxItems).fill(undefined).map((_, index)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9hDzh")).default), {
                key: `${sectionType}-${index}`
            }))) : children);
    };
});
parcelRegister("9hDzh", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7c4742eecef207b9$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $iwwXK;
    var $c2P5e;
    const $7c4742eecef207b9$var$cssFn = ()=>{
        return {
            '&::before': {
                backgroundColor: `var(--ds-skeleton, ${0, $829f609a65d26a98$export$8d43898f60b96a82})`,
                borderRadius: '100%',
                flexShrink: 0,
                content: '""',
                marginLeft: 0,
                marginRight: "var(--ds-space-150, 12px)",
                width: (0, (0, parcelRequire("c2P5e")).ICON_SIZE),
                height: (0, (0, parcelRequire("c2P5e")).ICON_SIZE)
            }
        };
    };
    function $7c4742eecef207b9$export$2e2bcd8739ae039() {
        return ((0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iwwXK")).default), {
            hasAvatar: true,
            cssFn: $7c4742eecef207b9$var$cssFn,
            testId: "people-menu-skeleton-item"
        }));
    }
});
parcelRegister("c2P5e", function(module, exports) {
    $parcel$export(module.exports, "ICON_SIZE", ()=>$13590cfc2fac79d5$export$91a15f1424900d33);
    $parcel$export(module.exports, "MAX_POPUP_WIDTH", ()=>$13590cfc2fac79d5$export$b0396be60c0e9152);
    $parcel$export(module.exports, "MIN_POPUP_WIDTH", ()=>$13590cfc2fac79d5$export$3f133812f81dfa49);
    $parcel$export(module.exports, "MAX_POPUP_HEIGHT", ()=>$13590cfc2fac79d5$export$94aaf6acd960c412);
    $parcel$export(module.exports, "ImgIcon", ()=>$13590cfc2fac79d5$export$804b6389edcac2c2);
    $parcel$export(module.exports, "Buggy", ()=>$13590cfc2fac79d5$export$6b52db8960fbef38);
    $parcel$export(module.exports, "fireRenderPeopleNavMenuFail", ()=>$13590cfc2fac79d5$export$5884f4bd467a603a);
    var $5uXOq = parcelRequire("5uXOq");
    var $v6X2P;
    var $6IwYZ;
    const $13590cfc2fac79d5$export$91a15f1424900d33 = 32;
    const $13590cfc2fac79d5$export$b0396be60c0e9152 = 480;
    const $13590cfc2fac79d5$export$3f133812f81dfa49 = 320;
    const $13590cfc2fac79d5$export$94aaf6acd960c412 = 'calc(100vh - 79px)';
    function $13590cfc2fac79d5$export$804b6389edcac2c2({ src: src, alt: alt }) {
        return (0, ($parcel$interopDefault($5uXOq))).createElement("img", {
            src: src || '',
            alt: alt,
            height: $13590cfc2fac79d5$export$91a15f1424900d33,
            width: $13590cfc2fac79d5$export$91a15f1424900d33,
            style: {
                borderRadius: $13590cfc2fac79d5$export$91a15f1424900d33 / 2
            }
        });
    }
    function $13590cfc2fac79d5$export$6b52db8960fbef38() {
        (0, $5uXOq.useEffect)(()=>{
            throw new Error('Something wrong inside People menu.');
        });
        return null;
    }
    const $13590cfc2fac79d5$export$5884f4bd467a603a = (error)=>{
        (0, (0, parcelRequire("6IwYZ")).renderPeopleNavMenuExp).failure({
            metadata: {
                ...error && 'status' in error ? {
                    status: error.status
                } : {},
                ...error instanceof (0, (0, parcelRequire("v6X2P")).ErrorWithContext) ? {
                    context: error.context
                } : {},
                error: error?.message
            }
        });
    };
});
parcelRegister("6IwYZ", function(module, exports) {
    $parcel$export(module.exports, "renderPeopleNavMenuExp", ()=>$0c056f8279034760$export$a0db9187c809008d);
    var $atdLB;
    var $duUGa;
    var $bSD7G;
    class $0c056f8279034760$var$UFOExperienceWithPackageContext extends (0, (0, parcelRequire("duUGa")).UFOExperience) {
        async success() {
            return super.success({
                metadata: {
                    ...(0, (0, parcelRequire("bSD7G")).packageContext)
                }
            });
        }
        async failure(config) {
            return super.failure({
                force: config?.force,
                metadata: {
                    ...config?.metadata ?? {},
                    ...(0, (0, parcelRequire("bSD7G")).packageContext)
                }
            });
        }
        async abort() {
            return super.abort({
                metadata: {
                    ...(0, (0, parcelRequire("bSD7G")).packageContext)
                }
            });
        }
    }
    const $0c056f8279034760$export$a0db9187c809008d = new $0c056f8279034760$var$UFOExperienceWithPackageContext('render-people-nav-menu', {
        type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).InlineResult,
        platform: {
            component: 'people'
        }
    });
});
parcelRegister("bSD7G", function(module, exports) {
    $parcel$export(module.exports, "packageContext", ()=>$7c6b76e7041bc9a3$export$beac86d91b8e8b21);
    const $7c6b76e7041bc9a3$export$beac86d91b8e8b21 = {
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    };
});
parcelRegister("5IiJH", function(module, exports) {
    $parcel$export(module.exports, "MenuGroupTeams", ()=>$bb1377fb4ffc4d3f$export$c3915c5ac3f99d49);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $cb25w;
    var $3Z96c;
    var $fWjEu;
    var $3ys0B;
    var $hEofo;
    var $dS8wI;
    var $c5ORg;
    parcelRequire("9iwCj");
    var $7kP9q;
    var $9iwCj;
    var $ckanx;
    var $cf0l8;
    var $c2P5e;
    const $bb1377fb4ffc4d3f$export$86c994b04df922e = (props)=>{
        const intl = (0, (0, parcelRequire("koVbs")).default)();
        const { orgId: orgId } = (0, (0, parcelRequire("hEofo")).usePeopleMenuContext)();
        const { teams: teams = [], createAnalyticsEvent: createAnalyticsEvent, isLoading: isLoading, remoteConfig: remoteConfig } = props;
        const { testId: testId, product: product, onClickedItem: onClickedItem = (0, (0, parcelRequire("dS8wI")).VOID_FUNC), pushRoute: pushRoute = (0, (0, parcelRequire("dS8wI")).VOID_FUNC), togglePeopleMenu: togglePeopleMenu = (0, (0, parcelRequire("dS8wI")).VOID_FUNC) } = (0, $5uXOq.useContext)((0, (0, parcelRequire("hEofo")).PeopleMenuContext));
        const handleClickOnTeam = (0, $5uXOq.useCallback)((id)=>(event)=>{
                const isLeftClick = !(0, (0, parcelRequire("c5ORg")).isModifiedEvent)(event);
                (0, (0, parcelRequire("9iwCj")).triggerAnalyticsForClickOnTeam)(createAnalyticsEvent, isLeftClick);
                onClickedItem(id, 'team', event);
                if (isLeftClick) {
                    const teamUrl = (0, (0, parcelRequire("3ys0B")).getTeamProfilePageLinkWithOrgId)({
                        remoteConfigResources: remoteConfig.resources,
                        teamId: id,
                        orgId: orgId,
                        ref: product,
                        src: (0, (0, parcelRequire("7kP9q")).AnalyticsActionSubject).PEOPLE_MENU
                    });
                    pushRoute(teamUrl);
                    event.preventDefault();
                }
                togglePeopleMenu(false);
            }, [
            createAnalyticsEvent,
            onClickedItem,
            orgId,
            product,
            pushRoute,
            remoteConfig.resources,
            togglePeopleMenu
        ]);
        if (!remoteConfig.sections.teams.enabled) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cf0l8")).MenuGroupSection), {
            title: remoteConfig.sections.teams.label ?? intl.formatMessage((0, (0, parcelRequire("ckanx")).messages).yourTeams),
            testId: `${testId}-teams-section`,
            isLoading: isLoading,
            isEmpty: teams.length === 0,
            sectionType: 'team',
            maxItems: remoteConfig.sections.teams.maxItems
        }, teams.slice(0, remoteConfig.sections.teams.maxItems).map((team)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3Z96c")).default), {
                key: team.id,
                href: (0, (0, parcelRequire("3ys0B")).getTeamProfilePageLinkWithOrgId)({
                    remoteConfigResources: remoteConfig.resources,
                    teamId: team.id,
                    orgId: orgId
                }),
                onClick: handleClickOnTeam(team.id),
                iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("c2P5e")).ImgIcon), {
                    src: team.smallAvatarImageUrl || team.smallHeaderImageUrl,
                    alt: team.displayName
                }),
                description: intl.formatMessage((0, (0, parcelRequire("ckanx")).messages).numMembers, {
                    memberCount: team.memberCount ?? 1
                }),
                testId: `${testId}-team-item`
            }, team.displayName)));
    };
    const $bb1377fb4ffc4d3f$export$c3915c5ac3f99d49 = (0, (0, parcelRequire("cb25w")).default)()((0, (0, parcelRequire("fWjEu")).withMandatoryPeopleMenuConfiguration)($bb1377fb4ffc4d3f$export$86c994b04df922e));
});
parcelRegister("3YEti", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("iNZ4I").then(()=>parcelRequire('gRkfD'));
});
parcelRegister("7U5E9", function(module, exports) {
    $parcel$export(module.exports, "PeopleMenuContentInternal", ()=>$912805c3f7a736e5$export$78306a734b6419e6);
    var $5uXOq = parcelRequire("5uXOq");
    parcelRequire("kc9vJ");
    var $ihijj = parcelRequire("ihijj");
    var $hEofo;
    var $nRreb;
    var $dS8wI;
    var $jHmRo;
    var $4144s;
    const $912805c3f7a736e5$var$stopPropagation = (e)=>e.stopPropagation();
    const $912805c3f7a736e5$export$78306a734b6419e6 = (0, $5uXOq.memo)(()=>{
        const { isBrowseUsersEnabled: isBrowseUsersEnabled } = (0, $5uXOq.useContext)((0, (0, parcelRequire("hEofo")).PeopleMenuContext));
        const { loading: isLoadingPermission, hasPermission: hasPermission } = (0, (0, parcelRequire("nRreb")).default)(isBrowseUsersEnabled);
        return ((0, ($parcel$interopDefault($5uXOq))).createElement("span", {
            onClick: $912805c3f7a736e5$var$stopPropagation
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $ihijj.LazySuspense), {
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jHmRo")).MenuContentFallback), null)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jHmRo")).MenuContent), {
            isLoadingPermission: isLoadingPermission,
            hasPermission: hasPermission
        }))));
    });
    const $912805c3f7a736e5$var$PeopleMenuContent = (props)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4144s")).default), {
            isOpen: true,
            onOpen: (0, (0, parcelRequire("dS8wI")).VOID_FUNC),
            onClose: (0, (0, parcelRequire("dS8wI")).VOID_FUNC),
            ...props
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($912805c3f7a736e5$export$78306a734b6419e6, null));
    };
    var $912805c3f7a736e5$export$2e2bcd8739ae039 = $912805c3f7a736e5$var$PeopleMenuContent;
});
parcelRegister("nRreb", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$fbf7656828aeee5c$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    function $fbf7656828aeee5c$export$2e2bcd8739ae039(permissionPromise) {
        const noQuery = !permissionPromise;
        const [hasPermission, setPermission] = (0, $5uXOq.useState)(noQuery);
        const [loading, setLoading] = (0, $5uXOq.useState)(!noQuery);
        (0, $5uXOq.useEffect)(()=>{
            if (permissionPromise) permissionPromise().then((permissionResult)=>{
                setPermission(permissionResult);
                setLoading(false);
            }).catch(()=>{
                setPermission(false);
                setLoading(false);
            });
        }, [
            permissionPromise,
            setLoading,
            setPermission
        ]);
        return {
            loading: loading,
            hasPermission: hasPermission
        };
    }
});
parcelRegister("4144s", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c08e04c739d3d984$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $daJ0i;
    var $cISRa;
    var $3ys0B;
    var $hEofo;
    var $bSD7G;
    parcelRequire("9iwCj");
    var $7kP9q;
    var $2eTLr;
    const $c08e04c739d3d984$var$defaultProps = {
        onClickedMenuLink: ()=>Promise.reject('No handler defined. Using default props value.'),
        testId: 'menu',
        isSSR: false
    };
    const $c08e04c739d3d984$var$PeopleMenuProviders = (props)=>{
        const { children: children, product: product, subProduct: subProduct, cloudId: cloudId, orgId: orgId, userId: userId, isBrowseUsersEnabled: isBrowseUsersEnabled, testId: testId, tenantUrl: tenantUrl, onClickedItem: onClickedItem, onClickedMenuLink: onClickedMenuLink, invitePeopleHandlers: invitePeopleHandlers, onOpen: onOpen, onClose: onClose, pushRoute: pushRoute, _hasError: _hasError, addFlag: addFlag, isOpen: isOpen, isSSR: isSSR, teamCreateDialogProps: teamCreateDialogProps, renotifyExperimentProps: renotifyExperimentProps, shouldRenderToParent: shouldRenderToParent, isSectionList: isSectionList } = {
            ...$c08e04c739d3d984$var$defaultProps,
            ...props
        };
        const analyticsContextData = {
            product: product,
            source: (0, (0, parcelRequire("7kP9q")).AnalyticsSource).PEOPLE_MENU,
            componentName: (0, (0, parcelRequire("7kP9q")).AnalyticsSource).PEOPLE_MENU,
            ...(0, (0, parcelRequire("bSD7G")).packageContext)
        };
        const commonPropsInContext = {
            cloudId: cloudId,
            orgId: orgId,
            product: product,
            subProduct: subProduct,
            userId: userId,
            isBrowseUsersEnabled: isBrowseUsersEnabled,
            isSSR: isSSR,
            testId: testId,
            tenantUrl: (0, (0, parcelRequire("3ys0B")).trimLastForwardSlash)(tenantUrl),
            onClickedItem: onClickedItem,
            onClickedMenuLink: onClickedMenuLink,
            invitePeopleHandlers: invitePeopleHandlers,
            onOpen: onOpen,
            onClose: onClose,
            pushRoute: pushRoute,
            _hasError: _hasError,
            addFlag: addFlag,
            isPeopleMenuOpen: false,
            isOpen: isOpen,
            teamCreateDialogProps: teamCreateDialogProps,
            renotifyExperimentProps: renotifyExperimentProps,
            shouldRenderToParent: shouldRenderToParent,
            isSectionList: isSectionList
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hEofo")).PeopleMenuContextProvider), commonPropsInContext, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cISRa")).LazyIntlProvider), {
            fetchLanguageFile: (0, (0, parcelRequire("2eTLr")).fetchLanguageFile)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("daJ0i")).default), {
            data: analyticsContextData
        }, children)));
    };
    var $c08e04c739d3d984$export$2e2bcd8739ae039 = $c08e04c739d3d984$var$PeopleMenuProviders;
});
parcelRegister("2eTLr", function(module, exports) {
    $parcel$export(module.exports, "fetchLanguageFile", ()=>$97c2677f18f80a57$export$c08b58fa4727b0d2);
    var $dX8RA;
    function $97c2677f18f80a57$export$c08b58fa4727b0d2(locale) {
        switch(locale){
            case 'cs-CZ':
            case 'cs':
                return (0, parcelRequire("dX8RA")).cs();
            case 'da-DK':
            case 'da':
                return (0, parcelRequire("dX8RA")).da();
            case 'de-DE':
            case 'de':
                return (0, parcelRequire("dX8RA")).de();
            case 'en-GB':
                return (0, parcelRequire("dX8RA")).engb();
            case 'en-US':
            case 'en':
                return (0, parcelRequire("dX8RA")).en();
            case 'en-ZZ':
                return (0, parcelRequire("dX8RA")).enzz();
            case 'es-ES':
            case 'es':
                return (0, parcelRequire("dX8RA")).es();
            case 'et-EE':
            case 'et':
                return (0, parcelRequire("dX8RA")).et();
            case 'fi-FI':
            case 'fi':
                return (0, parcelRequire("dX8RA")).fi();
            case 'fr-FR':
            case 'fr':
                return (0, parcelRequire("dX8RA")).fr();
            case 'hu-HU':
            case 'hu':
                return (0, parcelRequire("dX8RA")).hu();
            case 'is-IS':
            case 'is':
                return (0, parcelRequire("dX8RA")).is();
            case 'it-IT':
            case 'it':
                return (0, parcelRequire("dX8RA")).it();
            case 'ja-JP':
            case 'ja':
                return (0, parcelRequire("dX8RA")).ja();
            case 'ko-KR':
            case 'ko':
                return (0, parcelRequire("dX8RA")).ko();
            case 'nb-NB':
            case 'nb':
                return (0, parcelRequire("dX8RA")).nb();
            case 'nl-NL':
            case 'nl':
                return (0, parcelRequire("dX8RA")).nl();
            case 'pl-PL':
            case 'pl':
                return (0, parcelRequire("dX8RA")).pl();
            case 'pt-PT':
            case 'pt_PT':
            case 'pt':
                return (0, parcelRequire("dX8RA")).pt();
            case 'pt-BR':
            case 'pt_BR':
                return (0, parcelRequire("dX8RA")).ptbr();
            case 'ro-RO':
            case 'ro':
                return (0, parcelRequire("dX8RA")).ro();
            case 'ru-RU':
            case 'ru':
                return (0, parcelRequire("dX8RA")).ru();
            case 'sk-SK':
            case 'sk':
                return (0, parcelRequire("dX8RA")).sk();
            case 'sv-SE':
            case 'sv':
                return (0, parcelRequire("dX8RA")).sv();
            case 'tr-TR':
            case 'tr':
                return (0, parcelRequire("dX8RA")).tr();
            case 'th-TH':
            case 'th':
                return (0, parcelRequire("dX8RA")).th();
            case 'uk-UK':
            case 'uk':
                return (0, parcelRequire("dX8RA")).uk();
            case 'vi-VI':
            case 'vi':
                return (0, parcelRequire("dX8RA")).vi();
            case 'zh-TW':
            case 'zh-HK':
                return (0, parcelRequire("dX8RA")).zhtw();
            case 'zh-ZH':
            case 'zh-CN':
            case 'zh':
                return (0, parcelRequire("dX8RA")).zh();
        }
        return (0, parcelRequire("dX8RA")).fallback();
    }
});
parcelRegister("dX8RA", function(module, exports) {
    $parcel$export(module.exports, "fallback", ()=>$2bfa8f80c65d815a$export$bcd1dd1f397bba12);
    $parcel$export(module.exports, "cs", ()=>$2bfa8f80c65d815a$export$bde1ed0f60b38f2f);
    $parcel$export(module.exports, "da", ()=>$2bfa8f80c65d815a$export$8c8450b83b664ba4);
    $parcel$export(module.exports, "de", ()=>$2bfa8f80c65d815a$export$2fa162a495d26869);
    $parcel$export(module.exports, "en", ()=>$2bfa8f80c65d815a$export$84584c2a98eb6753);
    $parcel$export(module.exports, "engb", ()=>$2bfa8f80c65d815a$export$141cd05f569bae45);
    $parcel$export(module.exports, "enzz", ()=>$2bfa8f80c65d815a$export$a3f288d6c3177b8a);
    $parcel$export(module.exports, "es", ()=>$2bfa8f80c65d815a$export$ca5e4045a55e76d2);
    $parcel$export(module.exports, "et", ()=>$2bfa8f80c65d815a$export$457177dcde8472be);
    $parcel$export(module.exports, "fi", ()=>$2bfa8f80c65d815a$export$ed5179c818622fb);
    $parcel$export(module.exports, "fr", ()=>$2bfa8f80c65d815a$export$acb2a88f7d552ebf);
    $parcel$export(module.exports, "hu", ()=>$2bfa8f80c65d815a$export$9901d21957972d53);
    $parcel$export(module.exports, "is", ()=>$2bfa8f80c65d815a$export$226b3eccf92c9ed9);
    $parcel$export(module.exports, "it", ()=>$2bfa8f80c65d815a$export$3486a10f30cf1ee4);
    $parcel$export(module.exports, "ja", ()=>$2bfa8f80c65d815a$export$8c6f505e9474ce90);
    $parcel$export(module.exports, "ko", ()=>$2bfa8f80c65d815a$export$798cf677954c9533);
    $parcel$export(module.exports, "nb", ()=>$2bfa8f80c65d815a$export$38ef0e3f791a121e);
    $parcel$export(module.exports, "nl", ()=>$2bfa8f80c65d815a$export$9c64ee4d84d79ce1);
    $parcel$export(module.exports, "pl", ()=>$2bfa8f80c65d815a$export$6ea5311eda92944f);
    $parcel$export(module.exports, "pt", ()=>$2bfa8f80c65d815a$export$84175d5f1cb4e39d);
    $parcel$export(module.exports, "ptbr", ()=>$2bfa8f80c65d815a$export$82924b14976e7373);
    $parcel$export(module.exports, "ro", ()=>$2bfa8f80c65d815a$export$ea30ec7f37fb148d);
    $parcel$export(module.exports, "ru", ()=>$2bfa8f80c65d815a$export$cf48009033a0126b);
    $parcel$export(module.exports, "sk", ()=>$2bfa8f80c65d815a$export$d608fa5b5bfd2021);
    $parcel$export(module.exports, "sv", ()=>$2bfa8f80c65d815a$export$65540e5f7f6e7dce);
    $parcel$export(module.exports, "tr", ()=>$2bfa8f80c65d815a$export$72451b88a72ad9c2);
    $parcel$export(module.exports, "th", ()=>$2bfa8f80c65d815a$export$d657bc098992a431);
    $parcel$export(module.exports, "uk", ()=>$2bfa8f80c65d815a$export$312745a8a3013c00);
    $parcel$export(module.exports, "vi", ()=>$2bfa8f80c65d815a$export$e3786bf10a8abdf2);
    $parcel$export(module.exports, "zh", ()=>$2bfa8f80c65d815a$export$b65a7f08f2280505);
    $parcel$export(module.exports, "zhtw", ()=>$2bfa8f80c65d815a$export$41779e6acd26e15f);
    const $2bfa8f80c65d815a$export$bcd1dd1f397bba12 = ()=>Promise.resolve({
            default: {}
        });
    const $2bfa8f80c65d815a$export$bde1ed0f60b38f2f = ()=>(parcelRequire("h81Th"));
    const $2bfa8f80c65d815a$export$8c8450b83b664ba4 = ()=>(parcelRequire("lKYWs"));
    const $2bfa8f80c65d815a$export$2fa162a495d26869 = ()=>(parcelRequire("5IzoK"));
    const $2bfa8f80c65d815a$export$84584c2a98eb6753 = ()=>(parcelRequire("h7dRq"));
    const $2bfa8f80c65d815a$export$141cd05f569bae45 = ()=>(parcelRequire("5F5iw"));
    const $2bfa8f80c65d815a$export$a3f288d6c3177b8a = ()=>(parcelRequire("aAuvR"));
    const $2bfa8f80c65d815a$export$ca5e4045a55e76d2 = ()=>(parcelRequire("20Lov"));
    const $2bfa8f80c65d815a$export$457177dcde8472be = ()=>(parcelRequire("gcrAA"));
    const $2bfa8f80c65d815a$export$ed5179c818622fb = ()=>(parcelRequire("2GPkE"));
    const $2bfa8f80c65d815a$export$acb2a88f7d552ebf = ()=>(parcelRequire("lTJgL"));
    const $2bfa8f80c65d815a$export$9901d21957972d53 = ()=>(parcelRequire("4XY9U"));
    const $2bfa8f80c65d815a$export$226b3eccf92c9ed9 = ()=>(parcelRequire("b1ue4"));
    const $2bfa8f80c65d815a$export$3486a10f30cf1ee4 = ()=>(parcelRequire("b1r3S"));
    const $2bfa8f80c65d815a$export$8c6f505e9474ce90 = ()=>(parcelRequire("8feIQ"));
    const $2bfa8f80c65d815a$export$798cf677954c9533 = ()=>(parcelRequire("iyobA"));
    const $2bfa8f80c65d815a$export$38ef0e3f791a121e = ()=>(parcelRequire("02fvb"));
    const $2bfa8f80c65d815a$export$9c64ee4d84d79ce1 = ()=>(parcelRequire("70Rnd"));
    const $2bfa8f80c65d815a$export$6ea5311eda92944f = ()=>(parcelRequire("eLNIO"));
    const $2bfa8f80c65d815a$export$84175d5f1cb4e39d = ()=>(parcelRequire("3ugFg"));
    const $2bfa8f80c65d815a$export$82924b14976e7373 = ()=>(parcelRequire("3k2Ut"));
    const $2bfa8f80c65d815a$export$ea30ec7f37fb148d = ()=>(parcelRequire("biU2J"));
    const $2bfa8f80c65d815a$export$cf48009033a0126b = ()=>(parcelRequire("978IP"));
    const $2bfa8f80c65d815a$export$d608fa5b5bfd2021 = ()=>(parcelRequire("i5gWB"));
    const $2bfa8f80c65d815a$export$65540e5f7f6e7dce = ()=>(parcelRequire("3927F"));
    const $2bfa8f80c65d815a$export$72451b88a72ad9c2 = ()=>(parcelRequire("hHs4F"));
    const $2bfa8f80c65d815a$export$d657bc098992a431 = ()=>(parcelRequire("hcpvu"));
    const $2bfa8f80c65d815a$export$312745a8a3013c00 = ()=>(parcelRequire("36BJl"));
    const $2bfa8f80c65d815a$export$e3786bf10a8abdf2 = ()=>(parcelRequire("lyZ6k"));
    const $2bfa8f80c65d815a$export$b65a7f08f2280505 = ()=>(parcelRequire("bhZGn"));
    const $2bfa8f80c65d815a$export$41779e6acd26e15f = ()=>(parcelRequire("ewe9b"));
});
parcelRegister("h81Th", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("b1CQa").then(()=>parcelRequire('fExJZ'));
});
parcelRegister("lKYWs", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("9Y5Xm").then(()=>parcelRequire('h49zj'));
});
parcelRegister("5IzoK", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("mf86l").then(()=>parcelRequire('ksdj2'));
});
parcelRegister("h7dRq", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("5pkwq").then(()=>parcelRequire('9S4eI'));
});
parcelRegister("5F5iw", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("9oJGZ").then(()=>parcelRequire('jR0Em'));
});
parcelRegister("aAuvR", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("a0eKB").then(()=>parcelRequire('cpC58'));
});
parcelRegister("20Lov", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("8fhAA").then(()=>parcelRequire('hXLvF'));
});
parcelRegister("gcrAA", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("9UzOV").then(()=>parcelRequire('3jxEi'));
});
parcelRegister("2GPkE", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("cGi0u").then(()=>parcelRequire('bem9x'));
});
parcelRegister("lTJgL", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("jtWxq").then(()=>parcelRequire('1Z04w'));
});
parcelRegister("4XY9U", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("lmm7J").then(()=>parcelRequire('ddvLU'));
});
parcelRegister("b1ue4", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("7F6Qd").then(()=>parcelRequire('iuYhr'));
});
parcelRegister("b1r3S", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("3fCSJ").then(()=>parcelRequire('kjLAT'));
});
parcelRegister("8feIQ", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("hE4OV").then(()=>parcelRequire('j9DVR'));
});
parcelRegister("iyobA", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("dvErj").then(()=>parcelRequire('7zgXj'));
});
parcelRegister("02fvb", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("bINwB").then(()=>parcelRequire('aXlfw'));
});
parcelRegister("70Rnd", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("1t72e").then(()=>parcelRequire('71H9N'));
});
parcelRegister("eLNIO", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("dMeCY").then(()=>parcelRequire('ljJMk'));
});
parcelRegister("3ugFg", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("6PfTa").then(()=>parcelRequire('9c3LE'));
});
parcelRegister("3k2Ut", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("hkeZT").then(()=>parcelRequire('h7Z1H'));
});
parcelRegister("biU2J", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("1SCfM").then(()=>parcelRequire('llnnW'));
});
parcelRegister("978IP", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("ax03h").then(()=>parcelRequire('jsirv'));
});
parcelRegister("i5gWB", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("kh61f").then(()=>parcelRequire('7s028'));
});
parcelRegister("3927F", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("ebL7h").then(()=>parcelRequire('8Tuck'));
});
parcelRegister("hHs4F", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("3JKKm").then(()=>parcelRequire('1czcz'));
});
parcelRegister("hcpvu", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("icFwq").then(()=>parcelRequire('ciBsY'));
});
parcelRegister("36BJl", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("eyM85").then(()=>parcelRequire('9Ej9o'));
});
parcelRegister("lyZ6k", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("fMuho").then(()=>parcelRequire('3IrzE'));
});
parcelRegister("bhZGn", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("9JUCG").then(()=>parcelRequire('eveoR'));
});
parcelRegister("ewe9b", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("8QK5x").then(()=>parcelRequire('k9Nyn'));
});
parcelRegister("4AXtg", function(module, exports) {
    $parcel$export(module.exports, "PeopleMenuTriggerSSR", ()=>$176dc84aa3d064ce$export$7e1e2ab520ce5d59);
    $parcel$export(module.exports, "default", ()=>$176dc84aa3d064ce$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $ousew;
    var $7ownK;
    var $ebd3R;
    var $kJpBP;
    var $fWjEu;
    var $hEofo;
    var $ckanx;
    var $3sQev;
    var $leIuY;
    function $176dc84aa3d064ce$export$7e1e2ab520ce5d59({ testId: testId, peopleText: peopleText }) {
        const remoteConfig = (0, (0, parcelRequire("fWjEu")).usePeopleAndTeamsPeopleMenuConfiguration)();
        const navLabel = remoteConfig?.navLabel || peopleText;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7ownK")).PrimaryDropdownButton), {
            testId: `${testId}-people-primary-button-ssr`
        }, navLabel ? navLabel : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("ckanx")).messages).teams));
    }
    function $176dc84aa3d064ce$var$PeopleMenuTrigger(props) {
        const { isSpotlightActive: isSpotlightActive, renotifyExperimentProps: renotifyExperimentProps } = (0, (0, parcelRequire("hEofo")).usePeopleMenuContext)();
        const { isVisible: isVisible, isHighlighted: isHighlighted, customChevronIcon: customChevronIcon, triggerProps: triggerProps, onClick: onClick, onMouseEnter: onMouseEnter, testId: testId, isSelected: isSelected, peopleText: peopleText } = props;
        const buttonProps = (0, $5uXOq.useMemo)(()=>({
                isSelected: isSelected,
                onClick: onClick,
                onMouseEnter: onMouseEnter,
                testId: testId
            }), [
            isSelected,
            onClick,
            onMouseEnter,
            testId
        ]);
        const remoteConfig = (0, (0, parcelRequire("fWjEu")).usePeopleAndTeamsPeopleMenuConfiguration)();
        const navLabel = remoteConfig?.navLabel || peopleText;
        const chevron = customChevronIcon || (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("ebd3R"))))), {
            label: "dropdown-chevron"
        });
        const renderPrimaryDropDownButton = (0, $5uXOq.useCallback)(()=>{
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7ownK")).PrimaryDropdownButton), {
                isHighlighted: isHighlighted,
                ...buttonProps,
                ...triggerProps
            }, navLabel || (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("ckanx")).messages).teams));
        }, [
            buttonProps,
            isHighlighted,
            navLabel,
            triggerProps
        ]);
        if (isVisible) {
            if (renotifyExperimentProps?.isEnrolled && isSpotlightActive !== false) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Suspense), {
                fallback: renderPrimaryDropDownButton()
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3sQev")).RenotifySpotlight), {
                "data-testid": "renotify-spotlight-trigger",
                setIsOpen: onClick,
                renderFallback: renderPrimaryDropDownButton
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("leIuY")).default), {
                testId: "renotify-menu-trigger-button",
                triggerProps: triggerProps
            }, navLabel || (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("ckanx")).messages).teams))));
            return renderPrimaryDropDownButton();
        }
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kJpBP")).default), {
            iconAfter: chevron,
            ...triggerProps,
            ...buttonProps
        }, navLabel || (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("ckanx")).messages).teams));
    }
    var $176dc84aa3d064ce$export$2e2bcd8739ae039 = $176dc84aa3d064ce$var$PeopleMenuTrigger;
});
parcelRegister("3sQev", function(module, exports) {
    $parcel$export(module.exports, "RenotifySpotlight", ()=>$2fe7c8f320c16856$export$c598a42b0405f75);
    var $5uXOq = parcelRequire("5uXOq");
    const $2fe7c8f320c16856$export$c598a42b0405f75 = (0, $5uXOq.lazy)(()=>(parcelRequire("hN5uN")));
});
parcelRegister("hN5uN", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("gyCjO").then(()=>parcelRequire('6nzR8'));
});
parcelRegister("leIuY", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5f136f891505e9fd$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $711X2;
    var $6Ingq;
    var $g2l9s;
    function $5f136f891505e9fd$var$RenotifyMenuButton(props) {
        const { testId: testId, triggerProps: triggerProps, children: children } = props;
        return $5uXOq.createElement((0, (0, parcelRequire("711X2")).PrimaryButton), {
            "data-testid": testId,
            className: "renotify-menu-button",
            iconAfter: $5uXOq.createElement((0, (0, parcelRequire("g2l9s")).RenotifySpotlightTriggerChevron), null, $5uXOq.createElement((0, ($parcel$interopDefault((0, parcelRequire("6Ingq"))))), {
                label: "dropdown-chevron"
            })),
            ...triggerProps
        }, children);
    }
    var $5f136f891505e9fd$export$2e2bcd8739ae039 = $5f136f891505e9fd$var$RenotifyMenuButton;
});
parcelRegister("g2l9s", function(module, exports) {
    $parcel$export(module.exports, "RenotifyMessageContainer", ()=>$4bd67b8a67c5aebb$export$82eb61f2818fcdcb);
    $parcel$export(module.exports, "RenotifyModalWidthFull", ()=>$4bd67b8a67c5aebb$export$1b5dc0ba5fe67cdb);
    $parcel$export(module.exports, "RenotifyModalUsersContainer", ()=>$4bd67b8a67c5aebb$export$ecd3b6bfab51e27c);
    $parcel$export(module.exports, "RenotifySpotlightTriggerChevron", ()=>$4bd67b8a67c5aebb$export$bdd40b9dcae00142);
    $parcel$export(module.exports, "RenotifySpotlightContent", ()=>$4bd67b8a67c5aebb$export$75293539a002acf6);
    var $9UCCQ;
    var $bWGt6 = parcelRequire("bWGt6");
    function $4bd67b8a67c5aebb$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $4bd67b8a67c5aebb$export$82eb61f2818fcdcb = (0, $bWGt6.default)((0, (0, parcelRequire("9UCCQ")).default), {
        target: "e11sj30a4"
    })({
        maxWidth: '300px',
        padding: "var(--ds-space-200, 16px)",
        backgroundColor: `var(--ds-background-accent-yellow-subtlest, ${(0, $829f609a65d26a98$export$1cc05bbbf340e559)})`,
        '&::before': {
            height: "var(--ds-space-0, 0px)"
        },
        '&::after': {
            height: "var(--ds-space-0, 0px)"
        }
    });
    const $4bd67b8a67c5aebb$export$1b5dc0ba5fe67cdb = (0, $bWGt6.default)("div", {
        target: "e11sj30a3"
    })({
        name: "1d3w5wq",
        styles: "width:100%"
    });
    const $4bd67b8a67c5aebb$export$ecd3b6bfab51e27c = (0, $bWGt6.default)("div", {
        target: "e11sj30a2"
    })({
        name: "cjcfh5",
        styles: "height:fit-content;max-height:174px;overflow-y:auto;margin-top:var(--ds-space-200, 16px);padding-top:var(--ds-space-100, 8px)"
    });
    const $4bd67b8a67c5aebb$export$bdd40b9dcae00142 = (0, $bWGt6.default)("span", {
        target: "e11sj30a1"
    })({
        name: "x63kpl",
        styles: "margin-left:var(--ds-space-negative-100, -8px);margin-right:var(--ds-space-negative-100, -8px);opacity:0.5"
    });
    const $4bd67b8a67c5aebb$export$75293539a002acf6 = (0, $bWGt6.default)("div", {
        target: "e11sj30a0"
    })({
        name: "kzyyo8",
        styles: "margin-top:var(--ds-space-050, 4px);margin-bottom:var(--ds-space-100, 8px)"
    });
});
parcelRegister("14DM3", function(module, exports) {
    $parcel$export(module.exports, "UsersTeamsPreFetch", ()=>$018d7b56116a683b$export$ffb64487c0de3976);
    var $5uXOq = parcelRequire("5uXOq");
    var $cb25w;
    var $eSTPq;
    var $5iwOw;
    var $gFH8O;
    var $9iwCj;
    function $018d7b56116a683b$export$50ca75733630fce1({ cloudId: cloudId, orgId: orgId, userId: userId, product: product, tenantUrl: tenantUrl, createAnalyticsEvent: createAnalyticsEvent, renotifyExperiment: renotifyExperiment }) {
        (0, $5uXOq.useEffect)(()=>{
            (0, (0, parcelRequire("9iwCj")).triggerAnalyticsForPreFetchData)(createAnalyticsEvent);
            (0, (0, parcelRequire("gFH8O")).startMeasure)('fetchingData');
        }, [
            createAnalyticsEvent
        ]);
        const { isLoading: isLoading } = (0, (0, parcelRequire("5iwOw")).default)(cloudId, userId, product, tenantUrl, undefined, orgId);
        (0, (0, parcelRequire("eSTPq")).usePendingUsers)({
            cloudId: cloudId,
            startFetching: true,
            renotifyExperiment: renotifyExperiment
        });
        (0, $5uXOq.useEffect)(()=>{
            if (!isLoading) (0, (0, parcelRequire("gFH8O")).stopMeasure)('fetchingData', (duration, startTime)=>{
                (0, (0, parcelRequire("9iwCj")).triggerAnalyticsForFetchingData)(createAnalyticsEvent, duration, startTime);
            });
        }, [
            createAnalyticsEvent,
            isLoading
        ]);
        return null;
    }
    const $018d7b56116a683b$export$ffb64487c0de3976 = (0, (0, parcelRequire("cb25w")).default)()($018d7b56116a683b$export$50ca75733630fce1);
});
parcelRegister("bPysz", function(module, exports) {
    $parcel$export(module.exports, "ProductSearchInputSkeleton", ()=>$f7d66de1ed5c4c15$export$91fb362ea940bd8b);
    var $cFUJK;
    var $2AbEM;
    var $5uXOq = parcelRequire("5uXOq");
    const $f7d66de1ed5c4c15$export$91fb362ea940bd8b = ({ theme: theme, ...rest })=>{
        if (theme) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2AbEM")).ThemeProvider), {
            partialSearchCSS: theme
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cFUJK")).default), rest));
        else return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cFUJK")).default), rest);
    };
});
parcelRegister("59y5F", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3c083ca41bc0ca78$export$2e2bcd8739ae039);
    var $jovBr;
    var $j2niS;
    var $3c083ca41bc0ca78$var$isValid = (0, (0, parcelRequire("j2niS")).default)((0, (0, parcelRequire("jovBr")).default), 1);
    var $3c083ca41bc0ca78$export$2e2bcd8739ae039 = $3c083ca41bc0ca78$var$isValid;
});
parcelRegister("j2niS", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ddc047cf9e7996a6$export$2e2bcd8739ae039);
    function $ddc047cf9e7996a6$export$2e2bcd8739ae039(fn, arity, a) {
        a = a || [];
        if (a.length >= arity) return fn.apply(null, a.slice(0, arity).reverse());
        return function() {
            var args = Array.prototype.slice.call(arguments);
            return $ddc047cf9e7996a6$export$2e2bcd8739ae039(fn, arity, a.concat(args));
        };
    }
});
parcelRegister("dQChl", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a14dd31138eb438e$export$2e2bcd8739ae039);
    var $lb7qa;
    var $j2niS;
    var $a14dd31138eb438e$var$isWithinInterval = (0, (0, parcelRequire("j2niS")).default)((0, (0, parcelRequire("lb7qa")).default), 2);
    var $a14dd31138eb438e$export$2e2bcd8739ae039 = $a14dd31138eb438e$var$isWithinInterval;
});
parcelRegister("2xkYZ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1d8ef08fb2404f13$export$2e2bcd8739ae039);
    var $gn1v9;
    var $j2niS;
    var $1d8ef08fb2404f13$var$sub = (0, (0, parcelRequire("j2niS")).default)((0, (0, parcelRequire("gn1v9")).default), 2);
    var $1d8ef08fb2404f13$export$2e2bcd8739ae039 = $1d8ef08fb2404f13$var$sub;
});
const $b276966247f2f12d$export$70df29c238ba7306 = 'mediaCtx';
const $8acc83d90e579622$export$30fa7cc5f2690a43 = 56;
const $8acc83d90e579622$export$4033a111ca79977d = 1280;
const $8acc83d90e579622$export$24ec62cee78b7042 = 1130;
const $8acc83d90e579622$export$d8bde68ac946124f = '--ds--ans--fbc';
const $8acc83d90e579622$export$73e44f54603a0964 = '--ds--ans--hbgc';
const $8acc83d90e579622$export$13f8aa8f663f4c99 = '--ds--ans--bgc';
const $8acc83d90e579622$export$d81606c1fc5119bc = '--ds--ans--c';
const $8acc83d90e579622$export$65f656ad520ea71 = '--ds--ans--bc';
const $af03419a6de12610$export$e4c79eb95c23a0da = 'atlaskit-portal-container';
const $af03419a6de12610$export$72f415121273627e = 'body > .atlaskit-portal-container';
const $af03419a6de12610$export$13f57c02915787b3 = 'atlaskit-portal';
const $edbbaf000cbe1dd7$export$ed5835cc67e87f72 = 'akPortalMount';
const $edbbaf000cbe1dd7$export$80816bd900e5bd00 = 'akPortalUnmount';
const $5e71d9a7b5ef77ee$export$390330c10ff2b9a1 = 'ArrowUp';
const $5e71d9a7b5ef77ee$export$a80636c6f41931fe = 'ArrowDown';
const $5e71d9a7b5ef77ee$export$4af703091671bc = 'Home';
const $5e71d9a7b5ef77ee$export$e2bc30913faa5db7 = 'End';
const $5e71d9a7b5ef77ee$export$10f6869ed0a7d75b = 'Tab';
const $5e71d9a7b5ef77ee$export$8152f929a25a0ff4 = 'Enter';
const $5e71d9a7b5ef77ee$export$e51a3576c045c8d5 = 'Space';
const $5e71d9a7b5ef77ee$export$2bb790b9008907b4 = 'Escape';
const $eba99f58997c09b3$export$c07234257a03d5e9 = 'cubic-bezier(0.15,1,0.3,1)';
const $eba99f58997c09b3$export$57636bb43b1ccbb0 = 'cubic-bezier(0.2,0,0,1)';
const $eba99f58997c09b3$export$929e5a82286172a6 = 'cubic-bezier(0.8,0,0,0.8)';
const $90de389b166e701f$export$42f4885608027d0c = 'non_boolean';
const $636842cf8e8f850b$export$b98e411ae80c806f = '/';
const $b2e0d12d54fddedd$export$cf090d5281b5ae06 = 10000;
const $b2e0d12d54fddedd$export$8575e30be0feb909 = 30000;
const $84558f51b42056b1$export$194c34963e6f0bc6 = 'https://atlassian-cookies--categories.us-east-1.prod.public.atl-paas.net/categories.json';
const $84558f51b42056b1$export$ab0619f627170401 = 'https://atlassian-cookies--categories.us-east-1.prod.public.atl-paas.net/categories_COOKIE.json';
const $84558f51b42056b1$export$38bed9fd9923fef3 = 'https://atlassian-cookies--categories.us-east-1.prod.public.atl-paas.net/categories_LOCAL_STORAGE.json';
const $84558f51b42056b1$export$4f73a4b5fdb7ed6c = 'https://atlassian-cookies--categories.us-east-1.prod.public.atl-paas.net/categories_SESSION_STORAGE.json';
const $08da727ccd44b71d$export$d4c5499dc806c969 = ', Loading';
const $ff8b18549b2c06bf$export$d6830277b06edd6 = 'normal';
const $ff8b18549b2c06bf$export$4f8f13a66ae77bdd = '--color';
const $ff8b18549b2c06bf$export$e9244ec13bd422b5 = '--bg-color';
const $ff8b18549b2c06bf$export$97e78d9745006c11 = '--bg-color-hover';
const $ff8b18549b2c06bf$export$291d63757828f290 = '--bg-color-active';
const $da88f8f66d8f0f0a$export$3288b14b6745c572 = 204;
const $da88f8f66d8f0f0a$export$c09e7ea0fc79f34f = 409;
const $da88f8f66d8f0f0a$export$974c37534b0191b1 = 503;
const $1cb976721581e2e6$export$dffb4ed44e20ea9a = 'ai-mate-container';
const $1cb976721581e2e6$export$64aee74ba59709e5 = 439;
const $1cb976721581e2e6$export$1c07393c5bb1bc27 = 439;
const $1cb976721581e2e6$export$aa3478deee7adbeb = 350;
const $1cb976721581e2e6$export$21e515a86cd1733b = 'Chat';
$parcel$global.rlb("fr9NE");
